/**
 * A function to create a log object for the 'subscriptionsCreateSubscription' event (evid: 100)
 *
 * Event description: This event is triggered when a new subscription creation is initiated. When the subscription is actually created event 128:107
 *
 * @param {subscriptionsCreateSubscriptionParams} params - The parameters for this event
 * @property {string} cycleDurationUnit - WEEK/YEAR/MONTH/DAY
 * @property {string} name - subscription_name
 * @property {string} source - subscription_source
 * @property {string} shippingFee - subscription_shipping_fee
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {DateTime} endDate - end_date
 * @property {string} cycleUnit - cycle_unit
 * @property {GUID} appInstanceId - BASS tenant_id
 * @property {DateTime} billingStartDate - billing_start_date
 * @property {GUID} originAppId - origin_app_id
 * @property {number} cycleDurationCount - cycle_duration_count
 * @property {string} items - json data - of items in the subscription
 * @property {string} customerType - MEMBER/CONTACT
 * @property {string} freeTrialDurationUnit - free_trial_duration_unit
 * @property {string} customerId - This is the UoU ID, it can be member_id or contact_id
 * @property {boolean} cycleAutoRenew - cycle_auto_renew
 * @property {GUID} id - subscription_id
 * @property {string} discounts - json data
 * @property {string} currency - currency
 * @property {number} freeTrialDurationCount - free_trial_duration_count
 * @property {string} metadata - json data - Every vertical and APP sends it's own metadata
 * @property {number} totalCycles - total_cycles
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {DateTime} startDate - start_date
 * @property {string} collectionMethod - OFFLINE/AUTO_CHARGE (online)
 * @property {string} policies - json data
 * @property {GUID} orderId - order_id
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsCreateSubscriptionParams>} LogObject<subscriptionsCreateSubscriptionParams>
 */
export function subscriptionsCreateSubscription(params) {
    return { evid: 100, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsCancelSubscription' event (evid: 101)
 *
 * Event description: This event is triggered when a subscription is actually canceled, Take notice that for this event, there won't always be as a result of request cancelation 128:120 event
 *
 * @param {subscriptionsCancelSubscriptionParams} params - The parameters for this event
 * @property {DateTime} gracePeriodEndDate - The date the subscription will be canceled if no payment occurred during grace period
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {string} paymentStatus - latest payment status at the time of camcelation
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} reason - reason
 * @property {DateTime} gracePeriodStartDate - The date the subscription enters grace period after failed payment
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} collectionMethod - offline/online(AUTO_CHARGE)/free...data available since 2022-11-06 09:51, before data null doesn't mean FREE
 * @property {string} initiator - BUSINESS/CUSTOMER/SYSTEM
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsCancelSubscriptionParams>} LogObject<subscriptionsCancelSubscriptionParams>
 */
export function subscriptionsCancelSubscription(params) {
    return { evid: 101, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsPauseSubscription' event (evid: 102)
 *
 * Event description: Pause subscription request. Actual pause is event 128:108
 *
 * @param {subscriptionsPauseSubscriptionParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {DateTime} autoResumeDate - If there is a specific date to stop the pause it will be in this field
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} reason - reason
 * @property {string} pauseAt - pause_at
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} pausePolicy - pause_policy
 * @property {number} pauseAtCyclesFromToday - pause_at_cycles_from_today
 * @property {DateTime} pauseAtDate - pause_at_date
 * @property {string} initiator - initiator_name
 * @property {number} autoResumeNumberOfCycles - auto_resume_date_number_of_cycles
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsPauseSubscriptionParams>} LogObject<subscriptionsPauseSubscriptionParams>
 */
export function subscriptionsPauseSubscription(params) {
    return { evid: 102, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsResumeSubscription' event (evid: 103)
 *
 * Event description: Resume subscription request, actual resume is event 128:109
 *
 * @param {subscriptionsResumeSubscriptionParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} reason - reason
 * @property {GUID} id - subscription_id
 * @property {string} resumeAt - resume_at
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {DateTime} resumeAtDate - resume_at_date
 * @property {string} initiator - initiator_name
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsResumeSubscriptionParams>} LogObject<subscriptionsResumeSubscriptionParams>
 */
export function subscriptionsResumeSubscription(params) {
    return { evid: 103, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsAutoRenewOff' event (evid: 104)
 *
 * Event description: Subscriptions - Auto renew off
 *
 * @param {subscriptionsAutoRenewOffParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} reason - reason
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} initiator - initiator_name
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsAutoRenewOffParams>} LogObject<subscriptionsAutoRenewOffParams>
 */
export function subscriptionsAutoRenewOff(params) {
    return { evid: 104, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsAutoRenewOn' event (evid: 105)
 *
 * Event description: Subscriptions - Auto renew on
 *
 * @param {subscriptionsAutoRenewOnParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} reason - reason
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} initiator - initiator_name
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsAutoRenewOnParams>} LogObject<subscriptionsAutoRenewOnParams>
 */
export function subscriptionsAutoRenewOn(params) {
    return { evid: 105, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsExtendSubscription' event (evid: 106)
 *
 * Event description: Extend subscription
 *
 * @param {subscriptionsExtendSubscriptionParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} reason - reason
 * @property {number} periodCount - period_count
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {number} cycles - cycles
 * @property {GUID} appId - app_id
 * @property {string} periodUnit - period_unit
 * @property {string} initiator - initiator_name
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsExtendSubscriptionParams>} LogObject<subscriptionsExtendSubscriptionParams>
 */
export function subscriptionsExtendSubscription(params) {
    return { evid: 106, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsSubscriptionCreatedSuccessfully' event (evid: 107)
 *
 * Event description: This event will be sent when BASS created the subscription successfully
 *
 * @param {subscriptionsSubscriptionCreatedSuccessfullyParams} params - The parameters for this event
 * @property {DateTime} nextBillingDate - next_billing_date
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {DateTime} endDate - subscription_end_date
 * @property {string} paymentOrderId - This is the first paymentOrderID for the Wix payments (this will be the POId in the first invoice)
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} subscriptionStatus - subscription_status
 * @property {GUID} id - subscription_id
 * @property {DateTime} originCreatedDate - This field is for the migration from SAPI, the idea is that this date will get the value from date_created from SAPI and not the BASS date_created
 * @property {GUID} appid - app_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {DateTime} freeTrialStartDate - free_trial_start_date
 * @property {DateTime} startDate - subscription_start_date
 * @property {DateTime} freeTrialEndDate - free_trial_end_date
 * @property {GUID} orderId - order_id
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsSubscriptionCreatedSuccessfullyParams>} LogObject<subscriptionsSubscriptionCreatedSuccessfullyParams>
 */
export function subscriptionsSubscriptionCreatedSuccessfully(params) {
    return { evid: 107, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsSubscriptionActuallyPaused' event (evid: 108)
 *
 * Event description: The actual pause of the subscription
 *
 * @param {subscriptionsSubscriptionActuallyPausedParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsSubscriptionActuallyPausedParams>} LogObject<subscriptionsSubscriptionActuallyPausedParams>
 */
export function subscriptionsSubscriptionActuallyPaused(params) {
    return { evid: 108, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsSubscriptionActuallyResumed' event (evid: 109)
 *
 * Event description: The actual resume of the subscription
 *
 * @param {subscriptionsSubscriptionActuallyResumedParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsSubscriptionActuallyResumedParams>} LogObject<subscriptionsSubscriptionActuallyResumedParams>
 */
export function subscriptionsSubscriptionActuallyResumed(params) {
    return { evid: 109, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionDeleteSubscription' event (evid: 110)
 *
 * Event description: Delete the subscription - currently this is an internal event, users or UoU can't perform this action
 *
 * @param {subscriptionDeleteSubscriptionParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionDeleteSubscriptionParams>} LogObject<subscriptionDeleteSubscriptionParams>
 */
export function subscriptionDeleteSubscription(params) {
    return { evid: 110, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentSchedulerPayInvoice' event (evid: 1100)
 *
 * Event description: recurring retry for subscription in grace period was executed, attempting to pay the previously failed invoice
 *
 * @param {paymentSchedulerPayInvoiceParams} params - The parameters for this event
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {GUID} invoiceId - invoice_guid
 * @property {GUID} appid - app_id
 * @property {GUID} originEntityId - origin_entity_id
 * @return {LogObject<paymentSchedulerPayInvoiceParams>} LogObject<paymentSchedulerPayInvoiceParams>
 */
export function paymentSchedulerPayInvoice(params) {
    return { evid: 1100, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentSchedulerTimeCapsuleAddSchedule' event (evid: 1102)
 *
 * Event description: This event is when creating a scheduled task in Time Capsule for recurring retry
 *
 * @param {paymentSchedulerTimeCapsuleAddScheduleParams} params - The parameters for this event
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} subscriptionId - subscription id
 * @property {DateTime} scheduledTime - schedule time that the time capsule task will be executed
 * @property {GUID} invoiceId - invoice_guid
 * @property {string} subjectId - time_capsule_subject_id
 * @property {GUID} appid - app_id
 * @property {GUID} attemptId - payment attempt id
 * @property {string} declineMode - Indicate if the attempt schedule was triggered by INTERNAL_GRACE_PERIOD or  BUSINESS_GRACE_PERIOD
 * @return {LogObject<paymentSchedulerTimeCapsuleAddScheduleParams>} LogObject<paymentSchedulerTimeCapsuleAddScheduleParams>
 */
export function paymentSchedulerTimeCapsuleAddSchedule(params) {
    return { evid: 1102, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentSchedulerTimeCapsuleExecuteSchedule' event (evid: 1103)
 *
 * Event description: This event is when creating a scheduled task in Time Capsule for recurring retry
 *
 * @param {paymentSchedulerTimeCapsuleExecuteScheduleParams} params - The parameters for this event
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} subscriptionId - subscription id
 * @property {DateTime} scheduledTime - schedule time that the time capsule task will be executed
 * @property {GUID} invoiceId - invoice_guid
 * @property {string} subjectId - time_capsule_subject_id
 * @property {GUID} appid - app_id
 * @return {LogObject<paymentSchedulerTimeCapsuleExecuteScheduleParams>} LogObject<paymentSchedulerTimeCapsuleExecuteScheduleParams>
 */
export function paymentSchedulerTimeCapsuleExecuteSchedule(params) {
    return { evid: 1103, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentSchedulerTimeCapsuleDeleteSchedule' event (evid: 1104)
 *
 * Event description: This event is when creating a scheduled task in Time Capsule for recurring retry
 *
 * @param {paymentSchedulerTimeCapsuleDeleteScheduleParams} params - The parameters for this event
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} subscriptionId - subscription id
 * @property {DateTime} scheduledTime - schedule time that the time capsule task will be executed
 * @property {GUID} invoiceId - invoice_guid
 * @property {string} subjectId - time_capsule_subject_id
 * @property {GUID} appid - app_id
 * @return {LogObject<paymentSchedulerTimeCapsuleDeleteScheduleParams>} LogObject<paymentSchedulerTimeCapsuleDeleteScheduleParams>
 */
export function paymentSchedulerTimeCapsuleDeleteSchedule(params) {
    return { evid: 1104, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsMarkAsPaid' event (evid: 111)
 *
 * Event description: Mark the subscription as paid - This is marking the last invoice as paid
 *
 * @param {subscriptionsMarkAsPaidParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {GUID} id - subscription_id
 * @property {GUID} appid - app_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsMarkAsPaidParams>} LogObject<subscriptionsMarkAsPaidParams>
 */
export function subscriptionsMarkAsPaid(params) {
    return { evid: 111, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsSubscriptionActivated' event (evid: 112)
 *
 * Event description: This event is when a subscription is actually activated, That means that this event is triggered when a subscription becomes in status = ACTIVE
 *
 * @param {subscriptionsSubscriptionActivatedParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {string} originAppId - origin_app_id
 * @property {string} fromStatus - status before activation, can be DRAFT or PENDIG
 * @property {string} user_agent - user_agent
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} collectionMethod - online(AUTO_CHARGE)/offline/free(NULL)
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsSubscriptionActivatedParams>} LogObject<subscriptionsSubscriptionActivatedParams>
 */
export function subscriptionsSubscriptionActivated(params) {
    return { evid: 112, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsUpdatePolicy' event (evid: 113)
 *
 * Event description: This even is when a policy is updated on the subscription - Currently there are limited (3) types of policies but it will probably grow over time
 *
 * @param {subscriptionsUpdatePolicyParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} policyName - The name of the policy
 * @property {GUID} id - subscription_id
 * @property {string} oldValue - The old value of the policy - this can be any type, in the infra we'll cast per policy name
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} newValue - The new value of the policy - this can be any type, in the infra we'll cast per policy name
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsUpdatePolicyParams>} LogObject<subscriptionsUpdatePolicyParams>
 */
export function subscriptionsUpdatePolicy(params) {
    return { evid: 113, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsUpdateSubscription' event (evid: 114)
 *
 * Event description: This is a generic update subscription event, it will consist of the field being update, old and new value
 *
 * @param {subscriptionsUpdateSubscriptionParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {GUID} id - subscription_id
 * @property {string} oldValue - The old value of the updated field
 * @property {string} fieldName - The name of the field being updated
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} newValue - The new value of the updated field
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsUpdateSubscriptionParams>} LogObject<subscriptionsUpdateSubscriptionParams>
 */
export function subscriptionsUpdateSubscription(params) {
    return { evid: 114, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsReviseSubscription' event (evid: 115)
 *
 * Event description: This event is triggered when subscription items are being revised and subscription is recalculated (for example coupon is applied to subscriptions)
 *
 * @param {subscriptionsReviseSubscriptionParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {DateTime} endDate - subscription_end_date
 * @property {string} latestPaymentData - latestPaymentData
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} items - JSON of subscription items
 * @property {string} subscriptionStatus - subscriptionstatus
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {DateTime} freeTrialStartDate - The start date of free trial if exists
 * @property {DateTime} startDate - subscription_start_date
 * @property {DateTime} freeTrialEndDate - The end date of free trial if exists
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsReviseSubscriptionParams>} LogObject<subscriptionsReviseSubscriptionParams>
 */
export function subscriptionsReviseSubscription(params) {
    return { evid: 115, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsCreateInvoice' event (evid: 116)
 *
 * Event description: Event generated when create invoice is triggered from subscriptions service, this triggers Invoice service (BASS). Take notice this is triggered in the subscription management, similar event should be generated when triggered in Invoice management
 *
 * @param {subscriptionsCreateInvoiceParams} params - The parameters for this event
 * @property {string} source - source
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {string} paymentOrderId - equivalent to payments order_snapshot_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} invoiceItems - JSON
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} invoiceId - This is invoice_id, We call it invoice_guid because invoice_id is numeric in the schema.
 * @property {GUID} customerId - customer_id
 * @property {string} invoiceType - This field will describe whether the invoice is a recurring, authorization or initial invoice
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} totals - JSON
 * @property {string} collectionMethod - collection_method
 * @property {string} invoiceStatus - invoice_status
 * @property {GUID} orderId - order_id
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @property {string} MerchantConfiguration - More indications of merchant configuration. For examples the time zone of the merchant
 * @property {string} globalDiscountAmount - This is the total discount amount for the invoice example 20$ if this field is not null, global_discount_percentege will be null
 * @property {string} globalDiscountPercentage - This is the total discount percentage for the invoice example 20% if this field is not null, global_discount_amount will be null
 * @return {LogObject<subscriptionsCreateInvoiceParams>} LogObject<subscriptionsCreateInvoiceParams>
 */
export function subscriptionsCreateInvoice(params) {
    return { evid: 116, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsPayInvoice' event (evid: 117)
 *
 * Event description: triggered when BASS subscription service want to pay a specific invoice. This is after orderPaymentId was received from Wix payments. Take notice this is triggered in the subscription management, similar event should be generated when triggered in Invoice management. this is not including retry attempts, as retry attempts are under payment scheduler artifact
 *
 * @param {subscriptionsPayInvoiceParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} invoiceId - invoice_guid
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsPayInvoiceParams>} LogObject<subscriptionsPayInvoiceParams>
 */
export function subscriptionsPayInvoice(params) {
    return { evid: 117, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsInvoicePaymentStatusResponse' event (evid: 118)
 *
 * Event description: This event is triggered when response was received from Pay invoice attempt. This event covers different scenarios of response - Success and failure. Take notice this is triggered in the subscription management, similar event should be generated when triggered in Invoice management. this is not including retry attempts, as retry attempts are under payment scheduler artifact
 *
 * @param {subscriptionsInvoicePaymentStatusResponseParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {string} paymentOrderId - The payment order from WP
 * @property {GUID} appInstanceId - app_instance_id
 * @property {string} originAppId - origin_app_id
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} invoiceId - invoice_guid
 * @property {string} user_agent - user_agent
 * @property {string} invoiceType - initial/renewal
 * @property {number} cycle - billing cycle of subscription in invoice
 * @property {string} status - can be Open, Paid, Failed, Attempt, Failed, Canceled
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} initiatorName - source of invoice payment attempt - can be from payment scheduler during recurring retries
 * @property {string} collectionMethod - online(AUTO_CHARGE)/offline/free(NULL)
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsInvoicePaymentStatusResponseParams>} LogObject<subscriptionsInvoicePaymentStatusResponseParams>
 */
export function subscriptionsInvoicePaymentStatusResponse(params) {
    return { evid: 118, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsStartCycle' event (evid: 119)
 *
 * Event description: This event is triggered after a new invoice for the cycle was created and payed and the Subscription was updated with current cycle data
 *
 * @param {subscriptionsStartCycleParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} invoiceId - invoice_guid
 * @property {string} user_agent - user_agent
 * @property {number} cycle - cycle
 * @property {string} cycleType - initial (cycle=1) / renewal (cycle>1)
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} collectionMethod - AUTO_CHARGE/OFFLINE/EXTERNAL
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsStartCycleParams>} LogObject<subscriptionsStartCycleParams>
 */
export function subscriptionsStartCycle(params) {
    return { evid: 119, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsSubscriptionCanceled' event (evid: 120)
 *
 * Event description: This event is triggered when a subscription cancelation is initiated, there are cases like payment failure, when this event is not triggered. For actual cancelation of subscription, use event 128:101
 *
 * @param {subscriptionsSubscriptionCanceledParams} params - The parameters for this event
 * @property {DateTime} gracePeriodEndDate - The date the subscription will be canceled if no payment occurred during grace period
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {string} paymentStatus - latest payment status
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} reason - reason
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} collectionMethod - offline/online/free
 * @property {string} initiator - initiator_name
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsSubscriptionCanceledParams>} LogObject<subscriptionsSubscriptionCanceledParams>
 */
export function subscriptionsSubscriptionCanceled(params) {
    return { evid: 120, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsUpdatePaymentMethod' event (evid: 121)
 *
 * Event description: This event is triggered when a payment method is changed on subscription, after update payment method flow or paynow
 *
 * @param {subscriptionsUpdatePaymentMethodParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {GUID} oldPaymentMethodId - The payment method id that was changed
 * @property {GUID} id - subscription_id
 * @property {GUID} newPaymentMethodId - The new payment method id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} initiator - UPM/PayNow/User UPM/User UCM
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsUpdatePaymentMethodParams>} LogObject<subscriptionsUpdatePaymentMethodParams>
 */
export function subscriptionsUpdatePaymentMethod(params) {
    return { evid: 121, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateCollectionMethod' event (evid: 122)
 *
 * Event description: This event is triggered when collection method is changed on subscription
 *
 * @param {updateCollectionMethodParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} newCollectionMethod - The new collection method
 * @property {string} oldCollectionMethod - The collection method that was changed
 * @property {GUID} id - subscription_id
 * @property {GUID} newPaymentMethodId - new payment method id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} initiator - User/Customer
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<updateCollectionMethodParams>} LogObject<updateCollectionMethodParams>
 */
export function updateCollectionMethod(params) {
    return { evid: 122, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsGracePeriodStarted' event (evid: 123)
 *
 * Event description: This event is triggered when subscription is entering grace period due to payment failure
 *
 * @param {subscriptionsGracePeriodStartedParams} params - The parameters for this event
 * @property {DateTime} gracePeriodEndDate - The date the subscription will be canceled if no payment occurred during grace period
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} invoiceId - invoice_guid
 * @property {DateTime} gracePeriodStartDate - The date the subscription enters grace period due to failed payment, allowing user to pay and save the subscription
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app id
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsGracePeriodStartedParams>} LogObject<subscriptionsGracePeriodStartedParams>
 */
export function subscriptionsGracePeriodStarted(params) {
    return { evid: 123, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsSubscriptionPending' event (evid: 124)
 *
 * Event description: This event is when a subscription is entering pending status, meaning it was created and initialized successfully, but start date will be in the future.
 *
 * @param {subscriptionsSubscriptionPendingParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {string} originAppId - origin_app_id
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} collectionMethod - online(AUTO_CHARGE)/offline/free(NULL)
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsSubscriptionPendingParams>} LogObject<subscriptionsSubscriptionPendingParams>
 */
export function subscriptionsSubscriptionPending(params) {
    return { evid: 124, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsTimeCapsuleAddSchedule' event (evid: 130)
 *
 * Event description: This event is when creating a schedule in Time Capsule, ex: pause subscription at specific date.
 * There can be only one schedule at any given time for subscription_id and subject_id. This is an internal event for monitoring purposes, it's used to monitor correct triggering from Time capsule
 *
 * @param {subscriptionsTimeCapsuleAddScheduleParams} params - The parameters for this event
 * @property {GUID} appInstanceId - app_instance_id
 * @property {DateTime} scheduledTime - when is the subscription scheduled in Time Capsule
 * @property {string} user_agent - user_agent
 * @property {string} subjectId - PAUSE/RESUME/etc.
 * @property {GUID} id - subscription_id
 * @property {GUID} appid - app_id
 * @property {number} cycleNumber - The number of cycles passed
 * @return {LogObject<subscriptionsTimeCapsuleAddScheduleParams>} LogObject<subscriptionsTimeCapsuleAddScheduleParams>
 */
export function subscriptionsTimeCapsuleAddSchedule(params) {
    return { evid: 130, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsTimeCapsuleAddScheduleSrc128Evid131' event (evid: 131)
 *
 * Event description: This event is when Time Capsule schedule is executed. This is an internal event for monitoring purposes, it's used to monitor correct triggering from Time capsule
 *
 * @param {subscriptionsTimeCapsuleAddScheduleSrc128Evid131Params} params - The parameters for this event
 * @property {string} subjectid - PAUSE/RESUME/etc.
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} id - subscription_id
 * @property {number} cycleNumber - Number of current recurring cycle
 * @property {GUID} appId - app_id
 * @return {LogObject<subscriptionsTimeCapsuleAddScheduleSrc128Evid131Params>} LogObject<subscriptionsTimeCapsuleAddScheduleSrc128Evid131Params>
 */
export function subscriptionsTimeCapsuleAddScheduleSrc128Evid131(params) {
    return { evid: 131, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsTimeCapsuleDeleteSchedule' event (evid: 132)
 *
 * Event description: This event is triggered when time capsule schedule is deleted. when this event is triggered it deletes ALL!! Schedules for the subscription. so if there are 3 scheduled subjectIDs for subscription, there will be 3 events for the subscription. This is an internal event for monitoring purposes, it's used to monitor correct triggering from Time capsule
 *
 * @param {subscriptionsTimeCapsuleDeleteScheduleParams} params - The parameters for this event
 * @property {string} subjectid - time_capsule_subject_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} id - subscription_id
 * @property {GUID} appId - app_id
 * @return {LogObject<subscriptionsTimeCapsuleDeleteScheduleParams>} LogObject<subscriptionsTimeCapsuleDeleteScheduleParams>
 */
export function subscriptionsTimeCapsuleDeleteSchedule(params) {
    return { evid: 132, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsChangeSubscriptionFutureUpdatesRequested' event (evid: 140)
 *
 * Event description: Request for future changes in subscription
 *
 * @param {subscriptionsChangeSubscriptionFutureUpdatesRequestedParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {string} itemsToAdd - items_to_add
 * @property {string} originAppId - origin_app_id
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} itemsToUpdate - list of items that will be updated and their updated fields and values
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} itemsToDelete - list of items that will be deleted from the subscription
 * @return {LogObject<subscriptionsChangeSubscriptionFutureUpdatesRequestedParams>} LogObject<subscriptionsChangeSubscriptionFutureUpdatesRequestedParams>
 */
export function subscriptionsChangeSubscriptionFutureUpdatesRequested(params) {
    return { evid: 140, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsChangeSubscriptionUpdatesApplied' event (evid: 141)
 *
 * Event description: Updates for subscription were applied, following an immediate or future request
 *
 * @param {subscriptionsChangeSubscriptionUpdatesAppliedParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {string} itemsToAdd - list of items that will be added to the subscription
 * @property {string} originAppId - origin_app_id
 * @property {string} items - subscription items before change applied
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} itemsToUpdate - list of items that will be updated and their updated fields and values
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} appliedAt - indicating if updates applied immediatley after request or following a future request
 * @property {string} itemsToDelete - list of items that will be deleted from the subscription
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsChangeSubscriptionUpdatesAppliedParams>} LogObject<subscriptionsChangeSubscriptionUpdatesAppliedParams>
 */
export function subscriptionsChangeSubscriptionUpdatesApplied(params) {
    return { evid: 141, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsChangeSubscriptionResetPendingUpdates' event (evid: 142)
 *
 * Event description: Future update requests for subscription were deleted
 *
 * @param {subscriptionsChangeSubscriptionResetPendingUpdatesParams} params - The parameters for this event
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {string} originAppId - origin_app_id
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @return {LogObject<subscriptionsChangeSubscriptionResetPendingUpdatesParams>} LogObject<subscriptionsChangeSubscriptionResetPendingUpdatesParams>
 */
export function subscriptionsChangeSubscriptionResetPendingUpdates(params) {
    return { evid: 142, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsUpdateBillingDate' event (evid: 143)
 *
 * Event description: This event is triggered when billing date is changed on subscription
 *
 * @param {subscriptionsUpdateBillingDateParams} params - The parameters for this event
 * @property {string} customExtraCharge - charge amount (in local currency) that uou pay due to change in payment date
 * @property {DateTime} previousBillingDate - previous time the subscription was billed
 * @property {string} prorationType - time based (we calculate how much the user will extra charge  or give credit to the uou) or custom (user decide on amount)
 * @property {string} cycleDurationUnit - subscription cycle unit DAY/WEEK/MONTH/YEAR
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {string} customCredit - credit amount (in local currency) that uou get due to change in payment date
 * @property {GUID} originAppId - origin_app_id
 * @property {number} cycleDurationCount - subscription cycle unit count, meaning how many units (YEARS/MONTHS/..) 1 billing cycle last
 * @property {DateTime} newNextBillingDate - The new next billing date after the change
 * @property {GUID} id - subscription_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {DateTime} oldNextBillingDate - The next billing date that was changed
 * @property {DateTime} paidUntil - the date the subscription is currently paid for, in terms of billing cycle duration and changes since last payment (pause will postpone this date)
 * @property {GUID} platformAppId - platform_app_id
 * @property {GUID} platformEntityId - platform_entity_id
 * @return {LogObject<subscriptionsUpdateBillingDateParams>} LogObject<subscriptionsUpdateBillingDateParams>
 */
export function subscriptionsUpdateBillingDate(params) {
    return { evid: 143, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ordersCreateOrderSrc128Evid160' event (evid: 160)
 *
 * Event description: This event is triggered when a new order creation is initiated after the subscriptions and the invoice are created.
 *
 * @param {ordersCreateOrderSrc128Evid160Params} params - The parameters for this event
 * @property {GUID} orderId - order_id
 * @property {string} paymentOrderId - equivalent to payments order_snapshot_id
 * @property {GUID} invoiceId - This is invoice_id, We call it invoice_guid because invoice_id is numeric in the schema.
 * @property {GUID} appInstanceId - BASS tenant_id
 * @property {string} orderSubscriptions - list of order subscriptions
 * @property {string} orderItems - list of order one-items
 * @property {GUID} customerId - customer_id
 * @property {boolean} isOrderUpdate - Whether the the current action on the order is update or not
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} originAppId - origin_app_id
 * @return {LogObject<ordersCreateOrderSrc128Evid160Params>} LogObject<ordersCreateOrderSrc128Evid160Params>
 */
export function ordersCreateOrderSrc128Evid160(params) {
    return { evid: 160, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ordersOrderCompletedSrc128Evid161' event (evid: 161)
 *
 * Event description: This event is triggered when an order is completed, the subscription should be activated, and the invoice should be paid.
 *
 * @param {ordersOrderCompletedSrc128Evid161Params} params - The parameters for this event
 * @property {GUID} orderId - order_id
 * @property {string} paymentOrderId - equivalent to payments order_snapshot_id
 * @property {GUID} invoiceId - This is invoice_id, We call it invoice_guid because invoice_id is numeric in the schema.
 * @property {GUID} appInstanceId - BASS tenant_id
 * @property {string} orderSubscriptions - list of order subscriptions
 * @property {string} orderItems - list of order one-items
 * @property {GUID} customerId - customer_id
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} originAppId - origin_app_id
 * @return {LogObject<ordersOrderCompletedSrc128Evid161Params>} LogObject<ordersOrderCompletedSrc128Evid161Params>
 */
export function ordersOrderCompletedSrc128Evid161(params) {
    return { evid: 161, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ordersOrderFailedSrc128Evid162' event (evid: 162)
 *
 * Event description: This event is triggered when an order fails due to a technical error or comparison error (excluding payment failure).
 *
 * @param {ordersOrderFailedSrc128Evid162Params} params - The parameters for this event
 * @property {GUID} orderId - order_id
 * @property {string} paymentOrderId - equivalent to payments order_snapshot_id
 * @property {GUID} invoiceId - This is invoice_id, We call it invoice_guid because invoice_id is numeric in the schema.
 * @property {GUID} appInstanceId - BASS tenant_id
 * @property {string} orderSubscriptions - list of order subscriptions
 * @property {string} orderItems - list of order one-items
 * @property {GUID} customerId - customer_id
 * @property {string} errorType - Technical error/Comparison error
 * @property {string} errorMessage - error_message
 * @return {LogObject<ordersOrderFailedSrc128Evid162Params>} LogObject<ordersOrderFailedSrc128Evid162Params>
 */
export function ordersOrderFailedSrc128Evid162(params) {
    return { evid: 162, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ordersCreateInvoiceSrc128Evid163' event (evid: 163)
 *
 * Event description: Event generated when create invoice is triggered from orders after ecom integration, this triggers Invoice service (BASS).
 *
 * @param {ordersCreateInvoiceSrc128Evid163Params} params - The parameters for this event
 * @property {string} source - source
 * @property {GUID} originInstanceId - origin_instance_id
 * @property {string} paymentOrderId - equivalent to payments order_snapshot_id
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {string} invoiceItems - JSON
 * @property {string} invoiceSubscriptions - list of invoice subscriptions
 * @property {GUID} invoiceId - This is invoice_id, We call it invoice_guid because invoice_id is numeric in the schema.
 * @property {GUID} customerId - customer_id
 * @property {string} invoiceType - This field will describe whether the invoice is a recurring, authorization or initial invoice
 * @property {GUID} originEntityId - origin_entity_id
 * @property {GUID} appId - app_id
 * @property {string} totals - JSON
 * @property {string} collectionMethod - collection_method
 * @property {string} invoiceStatus - invoice_status
 * @property {GUID} orderId - order_id
 * @property {string} MerchantConfiguration - More indications of merchant configuration. For examples the time zone of the merchant
 * @property {string} globalDiscountAmount - This is the total discount amount for the invoice example 20$ if this field is not null, global_discount_percentege will be null
 * @property {string} globalDiscountPercentage - This is the total discount percentage for the invoice example 20% if this field is not null, global_discount_amount will be null
 * @return {LogObject<ordersCreateInvoiceSrc128Evid163Params>} LogObject<ordersCreateInvoiceSrc128Evid163Params>
 */
export function ordersCreateInvoiceSrc128Evid163(params) {
    return { evid: 163, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bassCustomerManagementMergeMembers' event (evid: 300)
 *
 * Event description: This event is triggered when detected a merge contacts event by BASS and the merged contacts have subscriptions. This will trigger update contacts/member in the relevant list of subscriptions by BASS
 *
 * @param {bassCustomerManagementMergeMembersParams} params - The parameters for this event
 * @property {GUID} appInstanceId - app_instance_id
 * @property {string} sourceIds - A comma separated list of contact_ids that will be merged into target_contact_id
 * @property {string} targetId - The contact_id of which all source_contact_ids will be merged
 * @property {string} subscriptionIds - list of subscriptions to update
 * @property {GUID} appId - app_id
 * @return {LogObject<bassCustomerManagementMergeMembersParams>} LogObject<bassCustomerManagementMergeMembersParams>
 */
export function bassCustomerManagementMergeMembers(params) {
    return { evid: 300, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bassCustomerManagementDeleteMember' event (evid: 301)
 *
 * Event description: This event is triggered when a delete member event is detected and the member have subscriptions, this event will trigger canceling the active subscriptions of the member
 *
 * @param {bassCustomerManagementDeleteMemberParams} params - The parameters for this event
 * @property {GUID} appInstanceId - app_instance_id
 * @property {string} subscriptionIds - list of comma separated subscriptions to cancel
 * @property {GUID} memberId - member_id
 * @property {GUID} appId - app_id
 * @return {LogObject<bassCustomerManagementDeleteMemberParams>} LogObject<bassCustomerManagementDeleteMemberParams>
 */
export function bassCustomerManagementDeleteMember(params) {
    return { evid: 301, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bassCustomerManagementDeleteContact' event (evid: 302)
 *
 * Event description: This event is triggered when a delete contact event is detected and the contact have subscriptions, this event will trigger canceling the active subscriptions of the contact
 *
 * @param {bassCustomerManagementDeleteContactParams} params - The parameters for this event
 * @property {GUID} appInstanceId - app_instance_id
 * @property {string} user_agent - user_agent
 * @property {string} subscriptionIds - list of comma separated subscriptions to cancel
 * @property {GUID} contactId - contact_id
 * @property {GUID} appId - app_id
 * @return {LogObject<bassCustomerManagementDeleteContactParams>} LogObject<bassCustomerManagementDeleteContactParams>
 */
export function bassCustomerManagementDeleteContact(params) {
    return { evid: 302, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bassCustomerManagementBlockMember' event (evid: 303)
 *
 * Event description: This event is triggered when a block member event is detected and the member have subscriptions, this event will trigger canceling the active subscriptions of the member
 *
 * @param {bassCustomerManagementBlockMemberParams} params - The parameters for this event
 * @property {GUID} appInstanceId - app_instance_id
 * @property {string} subscriptionIds - list of comma separated subscriptions to cancel
 * @property {GUID} memberId - contact_id
 * @property {GUID} appId - app_id
 * @return {LogObject<bassCustomerManagementBlockMemberParams>} LogObject<bassCustomerManagementBlockMemberParams>
 */
export function bassCustomerManagementBlockMember(params) {
    return { evid: 303, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickUpmCtaEvent' event (evid: 500)
 *
 * Event description: UOU click on Update Payment Method for a single subscription
 *
 * @param {aClickUpmCtaEventParams} params - The parameters for this event
 * @property {DateTime} previousBillingDate - The previous date the subscription was charged at
 * @property {DateTime} nextBillingDate - The next date the subscription is scheduled to be charged at
 * @property {string} subscription_status - Current status of subscription
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {boolean} cycleAutoRenew - Flag indicating if the subscription will be canceled at the next cycle (at next_billing_date)
 * @property {number} cycle - Current cycle of subscription
 * @property {GUID} paymentMethodId - The current payment method before the update
 * @property {GUID} sessionId - The session of UPM flow, can be multiple sessions for the same visitor (uou)
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickUpmCtaEventParams>} LogObject<aClickUpmCtaEventParams>
 */
export function aClickUpmCtaEvent(params) {
    return { evid: 500, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickCancelUpmEvent' event (evid: 502)
 *
 * Event description: UOU cancel the update payment method widget
 *
 * @param {aClickCancelUpmEventParams} params - The parameters for this event
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {string} referral - "Cancel Button" or Exit Window (click X or click in random place in screen)
 * @property {GUID} sessionId - The session of UPM flow, can be multiple sessions for the same visitor (uou)
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickCancelUpmEventParams>} LogObject<aClickCancelUpmEventParams>
 */
export function aClickCancelUpmEvent(params) {
    return { evid: 502, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickSubmitUpmEvent' event (evid: 503)
 *
 * Event description: UOU click update in UPM checkout widget
 *
 * @param {aClickSubmitUpmEventParams} params - The parameters for this event
 * @property {GUID} sessionId - The session of UPM flow, can be multiple sessions for the same visitor (uou)
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickSubmitUpmEventParams>} LogObject<aClickSubmitUpmEventParams>
 */
export function aClickSubmitUpmEvent(params) {
    return { evid: 503, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPaymentMethodUpdatedSuccessfully' event (evid: 504)
 *
 * Event description: UOU successfully updated payment method after success toast
 *
 * @param {aPaymentMethodUpdatedSuccessfullyParams} params - The parameters for this event
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {GUID} sessionId - The session of UPM flow, can be multiple sessions for the same visitor (uou)
 * @property {GUID} newPaymentMethodId - new_payment_method_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aPaymentMethodUpdatedSuccessfullyParams>} LogObject<aPaymentMethodUpdatedSuccessfullyParams>
 */
export function aPaymentMethodUpdatedSuccessfully(params) {
    return { evid: 504, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickPayNowCtaEvent' event (evid: 506)
 *
 * Event description: UOU click on Submit Payment during grace period in order to pay and save his subscription before cancellation, the  payment method will be also updated for future payments on the subscription
 *
 * @param {aClickPayNowCtaEventParams} params - The parameters for this event
 * @property {DateTime} previousBillingDate - The previous date the subscription was charged at
 * @property {DateTime} nextBillingDate - The next date the subscription is scheduled to be charged at, in this case of grace period the value will be the failed date in the past
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to pay
 * @property {string} subscriptionStatus - subscription status
 * @property {boolean} cycleAutoRenew - Flag indicating if the subscription will be canceled at the next cycle (at next_billing_date)
 * @property {number} cycle - Current cycle of subscription
 * @property {GUID} paymentMethodId - The current payment method before the update
 * @property {GUID} sessionId - The session of my subscriptions page, can be multiple sessions for the same customer, and multiple flows in the same session
 * @property {string} endPoint - end point
 * @return {LogObject<aClickPayNowCtaEventParams>} LogObject<aClickPayNowCtaEventParams>
 */
export function aClickPayNowCtaEvent(params) {
    return { evid: 506, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickCancelPayNowEvent' event (evid: 507)
 *
 * Event description: UOU cancel the Pay Now widget
 *
 * @param {aClickCancelPayNowEventParams} params - The parameters for this event
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to pay
 * @property {string} referral - "Cancel Button" or Exit Window (click X or click in random place in screen)
 * @property {GUID} sessionId - The session of my subscriptions page, can be multiple sessions for the same customer, and multiple flows in the same session
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickCancelPayNowEventParams>} LogObject<aClickCancelPayNowEventParams>
 */
export function aClickCancelPayNowEvent(params) {
    return { evid: 507, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickSubmitPayNowEvent' event (evid: 508)
 *
 * Event description: UOU click Submit in Pay Now flow
 *
 * @param {aClickSubmitPayNowEventParams} params - The parameters for this event
 * @property {string} paymentOrderId - payments identifier for the specific payment
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {GUID} sessionId - The session of my subscriptions page, can be multiple sessions for the same customer, and multiple flows in the same session
 * @property {string} assetVersion - indication - Cairo or old
 * @property {string} endPoint - end point
 * @return {LogObject<aClickSubmitPayNowEventParams>} LogObject<aClickSubmitPayNowEventParams>
 */
export function aClickSubmitPayNowEvent(params) {
    return { evid: 508, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPayNowSuccessEvent' event (evid: 509)
 *
 * Event description: UOU successfully paid and updated payment method, and got success toast
 *
 * @param {aPayNowSuccessEventParams} params - The parameters for this event
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {GUID} sessionId - The session of UPM flow, can be multiple sessions for the same visitor (uou)
 * @property {GUID} newPaymentMethodId - new_payment_method_id
 * @property {string} endPoint - end point
 * @return {LogObject<aPayNowSuccessEventParams>} LogObject<aPayNowSuccessEventParams>
 */
export function aPayNowSuccessEvent(params) {
    return { evid: 509, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPayNowSubmitResponseEvent' event (evid: 510)
 *
 * Event description: response from payments after UOU click submit in Pay Now flow
 *
 * @param {aPayNowSubmitResponseEventParams} params - The parameters for this event
 * @property {GUID} subscriptionId - The subscription that the UOU is looking to update
 * @property {string} response - ‘Approved’ | ‘Pending’ | ‘Failed’ | ‘InProcess’ | ‘Unknown’
 * @property {GUID} sessionId - The session of my subscriptions page, can be multiple sessions for the same customer, and multiple flows in the same session
 * @property {string} endPoint - end point
 * @return {LogObject<aPayNowSubmitResponseEventParams>} LogObject<aPayNowSubmitResponseEventParams>
 */
export function aPayNowSubmitResponseEvent(params) {
    return { evid: 510, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aManageSubscriptionUpdatePaymentMethodEvent' event (evid: 610)
 *
 * Event description: User click on update payment method for online subscription from subscription overview page, under Manage Subscription menu
 *
 * @param {aManageSubscriptionUpdatePaymentMethodEventParams} params - The parameters for this event
 * @property {DateTime} nextBillingDate - next billing date
 * @property {string} subscription_status - PENDING/ACTIVE/PAUSED/ENDED/CANCELED
 * @property {GUID} subscriptionId - the subscription
 * @property {boolean} cycleAutoRenew - flag to determine if subscription will continue to next cycle at next billing date
 * @property {string} referralinfo - referral info
 * @property {string} invoiceStatus - Last payment status, can be PAID/FAILED/UNPAID, allowing users to choose if to pay for UNPAID invoice as well
 * @return {LogObject<aManageSubscriptionUpdatePaymentMethodEventParams>} LogObject<aManageSubscriptionUpdatePaymentMethodEventParams>
 */
export function aManageSubscriptionUpdatePaymentMethodEvent(params) {
    return { evid: 610, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'anUpmClickUpdateEvent' event (evid: 611)
 *
 * Event description: User update payment method for online subscription from subscription overview page > submit checkout
 *
 * @param {anUpmClickUpdateEventParams} params - The parameters for this event
 * @property {GUID} subscriptionId - the subscription
 * @property {string} referralinfo - referralinfo
 * @return {LogObject<anUpmClickUpdateEventParams>} LogObject<anUpmClickUpdateEventParams>
 */
export function anUpmClickUpdateEvent(params) {
    return { evid: 611, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aManageSubscriptionUpdatePaymentMethodCancelEvent' event (evid: 612)
 *
 * Event description: User update payment method for online subscription from subscription overview page > Cancel checkout
 *
 * @param {aManageSubscriptionUpdatePaymentMethodCancelEventParams} params - The parameters for this event
 * @property {GUID} subscriptionId - the subscription
 * @property {string} referral - "Cancel Button" or Exit Window
 * @property {string} referralinfo - referral info
 * @return {LogObject<aManageSubscriptionUpdatePaymentMethodCancelEventParams>} LogObject<aManageSubscriptionUpdatePaymentMethodCancelEventParams>
 */
export function aManageSubscriptionUpdatePaymentMethodCancelEvent(params) {
    return { evid: 612, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionSwitchToOnlinePaymentStep1PaymentTiming' event (evid: 613)
 *
 * Event description: User update payment method for offline subscription from subscription overview page, changing it to online going forward > step 1 choosing if paying the unpaid offline invoice or start paying online from the next billing cycle
 *
 * @param {manageSubscriptionSwitchToOnlinePaymentStep1PaymentTimingParams} params - The parameters for this event
 * @property {GUID} subscriptionId - subscription_id
 * @property {boolean} isPayment - Is UPM action also paying for the currently UNPAID offline invoice?
 * @property {string} referralinfo - referralinfo
 * @property {string} action - view/select payment timing/next/cancel
 * @return {LogObject<manageSubscriptionSwitchToOnlinePaymentStep1PaymentTimingParams>} LogObject<manageSubscriptionSwitchToOnlinePaymentStep1PaymentTimingParams>
 */
export function manageSubscriptionSwitchToOnlinePaymentStep1PaymentTiming(params) {
    return { evid: 613, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionSwitchToOnlinePayment' event (evid: 620)
 *
 * Event description: User update payment method for offline subscription from subscription overview page, changing it to online going forward
 *
 * @param {manageSubscriptionSwitchToOnlinePaymentParams} params - The parameters for this event
 * @property {DateTime} nextBillingDate - next billing date
 * @property {string} subscription_status - PENDING/ACTIVE/PAUSED/ENDED/CANCELED
 * @property {GUID} subscriptionId - the subscription
 * @property {boolean} cycleAutoRenew - flag to determine if subscription will continue to next cycle at next billing date
 * @property {string} referralinfo - referralinfo
 * @property {string} invoiceStatus - Last payment status, can be PAID/FAILED/UNPAID, allowing users to choose if to pay for UNPAID invoice as well
 * @return {LogObject<manageSubscriptionSwitchToOnlinePaymentParams>} LogObject<manageSubscriptionSwitchToOnlinePaymentParams>
 */
export function manageSubscriptionSwitchToOnlinePayment(params) {
    return { evid: 620, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionSwitchToOnlinePaymentUpdate' event (evid: 621)
 *
 * Event description: User update payment method for offline subscription from subscription overview page, changing it to online going forward > submit checkout
 *
 * @param {manageSubscriptionSwitchToOnlinePaymentUpdateParams} params - The parameters for this event
 * @property {GUID} subscriptionId - subscription_id
 * @property {boolean} isPayment - Is UPM action also paying for the currently UNPAID offline invoice?
 * @property {string} referralinfo - referralinfo
 * @return {LogObject<manageSubscriptionSwitchToOnlinePaymentUpdateParams>} LogObject<manageSubscriptionSwitchToOnlinePaymentUpdateParams>
 */
export function manageSubscriptionSwitchToOnlinePaymentUpdate(params) {
    return { evid: 621, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionSwitchToOnlinePaymentCancel' event (evid: 622)
 *
 * Event description: User update payment method for offline subscription from subscription overview page, changing it to online going forward > Cancel checkout
 *
 * @param {manageSubscriptionSwitchToOnlinePaymentCancelParams} params - The parameters for this event
 * @property {GUID} subscriptionId - the subscription
 * @property {string} referral - "Cancel Button" or Exit Window
 * @property {string} referralinfo - referralinfo
 * @return {LogObject<manageSubscriptionSwitchToOnlinePaymentCancelParams>} LogObject<manageSubscriptionSwitchToOnlinePaymentCancelParams>
 */
export function manageSubscriptionSwitchToOnlinePaymentCancel(params) {
    return { evid: 622, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionMarkAsPaid' event (evid: 630)
 *
 * Event description: User open modal of mark as paid, still not marking as paid
 *
 * @param {manageSubscriptionMarkAsPaidParams} params - The parameters for this event
 * @property {DateTime} nextBillingDate - The next date the subscription is scheduled to be charged at, in case of grace period the value will be the failed date in the past
 * @property {string} subscription_status - PENDING/ACTIVE/PAUSED/ENDED/CANCELED
 * @property {GUID} subscriptionId - the subscription
 * @property {string} initiatorName - Manage Subscription / GP widget
 * @property {string} collectionMethod - AUTO_CHARGE/OFFLINE
 * @property {string} invoiceStatus - Last payment status, can be FAILED/UNPAID
 * @property {string} endPoint - end point
 * @return {LogObject<manageSubscriptionMarkAsPaidParams>} LogObject<manageSubscriptionMarkAsPaidParams>
 */
export function manageSubscriptionMarkAsPaid(params) {
    return { evid: 630, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionMarkAsPaidMarkAsPaid' event (evid: 631)
 *
 * Event description: User marks as paid from mark as paid modal
 *
 * @param {manageSubscriptionMarkAsPaidMarkAsPaidParams} params - The parameters for this event
 * @property {DateTime} nextBillingDate - The next date the subscription is scheduled to be charged at, in case of grace period the value will be the failed date in the past
 * @property {string} subscription_status - PENDING/ACTIVE/PAUSED/ENDED/CANCELED
 * @property {GUID} subscriptionId - the subscription
 * @property {string} collectionMethod - AUTO_CHARGE/OFFLINE
 * @property {string} invoiceStatus - Last payment status, can be FAILED/UNPAID
 * @property {string} endPoint - end point
 * @return {LogObject<manageSubscriptionMarkAsPaidMarkAsPaidParams>} LogObject<manageSubscriptionMarkAsPaidMarkAsPaidParams>
 */
export function manageSubscriptionMarkAsPaidMarkAsPaid(params) {
    return { evid: 631, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionMarkAsPaidCancel' event (evid: 632)
 *
 * Event description: User cancel marks as paid modal
 *
 * @param {manageSubscriptionMarkAsPaidCancelParams} params - The parameters for this event
 * @property {string} initiatorName - "Cancel"/"X"
 * @property {GUID} subscriptionId - the subscription
 * @property {string} endPoint - end point
 * @return {LogObject<manageSubscriptionMarkAsPaidCancelParams>} LogObject<manageSubscriptionMarkAsPaidCancelParams>
 */
export function manageSubscriptionMarkAsPaidCancel(params) {
    return { evid: 632, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionChangePaymentDate' event (evid: 640)
 *
 * Event description: User change payment date for recurring subscription from subscription overview page
 *
 * @param {manageSubscriptionChangePaymentDateParams} params - The parameters for this event
 * @property {DateTime} previousBillingDate - previous billing date
 * @property {string} cycleDurationUnit - billing cycle duration unit (DAY/WEEK/MONTH/YEAR)
 * @property {DateTime} nextBillingDate - next billing date
 * @property {string} subscription_status - PENDING/ACTIVE/PAUSED/ENDED/CANCELED
 * @property {number} cycleDurationCount - number of cycle duration units in each billing cycle (for exmple 2 Months)
 * @property {GUID} subscriptionId - the subscription
 * @property {string} paymentDateValue - if subscription is weekly, then week day, if not then date
 * @property {boolean} cycleAutoRenew - flag to determine if subscription will continue to next cycle at next billing date
 * @property {string} invoiceStatus - Last payment status, can be PAID/FAILED/UNPAID, allowing users to choose if to pay for UNPAID invoice as well
 * @property {string} referralInfo - referral
 * @return {LogObject<manageSubscriptionChangePaymentDateParams>} LogObject<manageSubscriptionChangePaymentDateParams>
 */
export function manageSubscriptionChangePaymentDate(params) {
    return { evid: 640, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionChangePaymentDateStep1SelectDate' event (evid: 641)
 *
 * Event description: selecting payment date value, weekday for weekly subscriptions, specific date for other cycles
 *
 * @param {manageSubscriptionChangePaymentDateStep1SelectDateParams} params - The parameters for this event
 * @property {DateTime} previousBillingDate - previous billing date
 * @property {string} cycleDurationUnit - billing cycle duration unit (DAY/WEEK/MONTH/YEAR)
 * @property {DateTime} nextBillingDate - next billing date
 * @property {number} cycleDurationCount - number of cycle duration units in each billing cycle (for exmple 2 Months)
 * @property {string} prorationAmount - amount to charge following change of payment date
 * @property {GUID} subscriptionId - the subscription
 * @property {string} paymentDateValue - if subscription is weekly, then week day, if not then date
 * @property {string} subscriptionStatus - PENDING/ACTIVE/PAUSED/ENDED/CANCELED
 * @property {string} actionName - view/select value/next/learn more/cancel
 * @property {boolean} isAddCharge - select from radio buttons weather to add charge or not
 * @property {string} referralInfo - referral
 * @return {LogObject<manageSubscriptionChangePaymentDateStep1SelectDateParams>} LogObject<manageSubscriptionChangePaymentDateStep1SelectDateParams>
 */
export function manageSubscriptionChangePaymentDateStep1SelectDate(params) {
    return { evid: 641, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionChangePaymentDateStep2SelectProration' event (evid: 642)
 *
 * Event description: select proration option - user settling the charge amount following the change in payment date
 *
 * @param {manageSubscriptionChangePaymentDateStep2SelectProrationParams} params - The parameters for this event
 * @property {DateTime} previousBillingDate - previous billing date
 * @property {string} cycleDurationUnit - billing cycle duration unit (DAY/WEEK/MONTH/YEAR)
 * @property {DateTime} nextBillingDate - next billing date
 * @property {number} cycleDurationCount - number of cycle duration units in each billing cycle (for exmple 2 Months)
 * @property {string} prorationAmount - amount to charge following change of payment date
 * @property {GUID} subscriptionId - the subscription
 * @property {string} paymentDateValue - if subscription is weekly, then week day, if not then date
 * @property {string} subscriptionStatus - PENDING/ACTIVE/PAUSED/ENDED/CANCELED
 * @property {string} actionName - view/select proration type/next/back/learn more/cancel
 * @property {boolean} isAddCharge - select from radio buttons weather to add charge or not
 * @property {string} referralInfo - referral
 * @return {LogObject<manageSubscriptionChangePaymentDateStep2SelectProrationParams>} LogObject<manageSubscriptionChangePaymentDateStep2SelectProrationParams>
 */
export function manageSubscriptionChangePaymentDateStep2SelectProration(params) {
    return { evid: 642, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionChangePaymentDateStep3Summary' event (evid: 643)
 *
 * Event description: confirm the change
 *
 * @param {manageSubscriptionChangePaymentDateStep3SummaryParams} params - The parameters for this event
 * @property {DateTime} previousBillingDate - previous billing date
 * @property {string} cycleDurationUnit - billing cycle duration unit (DAY/WEEK/MONTH/YEAR)
 * @property {DateTime} nextBillingDate - next billing date
 * @property {number} cycleDurationCount - number of cycle duration units in each billing cycle (for exmple 2 Months)
 * @property {string} prorationAmount - amount to charge following change of payment date
 * @property {GUID} subscriptionId - the subscription
 * @property {string} paymentDateValue - if subscription is weekly, then week day, if not then date
 * @property {string} subscriptionStatus - PENDING/ACTIVE/PAUSED/ENDED/CANCELED
 * @property {string} actionName - view/confirm/back/learn more/cancel
 * @property {boolean} isAddCharge - select from radio buttons weather to add charge or not
 * @property {string} referralInfo - referral
 * @return {LogObject<manageSubscriptionChangePaymentDateStep3SummaryParams>} LogObject<manageSubscriptionChangePaymentDateStep3SummaryParams>
 */
export function manageSubscriptionChangePaymentDateStep3Summary(params) {
    return { evid: 643, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionOverviewViewPaymentDetails' event (evid: 650)
 *
 * Event description: User open payment details modal from the subscritption overview page
 *
 * @param {subscriptionOverviewViewPaymentDetailsParams} params - The parameters for this event
 * @property {DateTime} nextBillingDate - The next date the subscription is scheduled to be charged at, in case of grace period the value will be the failed date in the past
 * @property {string} subscription_status - PENDING/ACTIVE/PAUSED/ENDED/CANCELED
 * @property {GUID} subscriptionId - the subscription
 * @property {string} collectionMethod - AUTO_CHARGE/OFFLINE
 * @property {string} referralInfo - referral
 * @return {LogObject<subscriptionOverviewViewPaymentDetailsParams>} LogObject<subscriptionOverviewViewPaymentDetailsParams>
 */
export function subscriptionOverviewViewPaymentDetails(params) {
    return { evid: 650, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionOverviewViewPaymentDetailsActions' event (evid: 651)
 *
 * Event description: payment details modal actions
 *
 * @param {subscriptionOverviewViewPaymentDetailsActionsParams} params - The parameters for this event
 * @property {DateTime} nextBillingDate - The next date the subscription is scheduled to be charged at, in case of grace period the value will be the failed date in the past
 * @property {string} subscription_status - PENDING/ACTIVE/PAUSED/ENDED/CANCELED
 * @property {GUID} subscriptionId - the subscription
 * @property {string} actionName - view/expand next payment/hide next payment/expand last payment/hide last payment
 * @property {string} collectionMethod - AUTO_CHARGE/OFFLINE
 * @property {string} endPoint - end point
 * @return {LogObject<subscriptionOverviewViewPaymentDetailsActionsParams>} LogObject<subscriptionOverviewViewPaymentDetailsActionsParams>
 */
export function subscriptionOverviewViewPaymentDetailsActions(params) {
    return { evid: 651, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionOverviewCollectPaymentSubmitPayment' event (evid: 660)
 *
 * Event description: MOTO Pay now entry point from Grace Period decline charge message
 *
 * @param {subscriptionOverviewCollectPaymentSubmitPaymentParams} params - The parameters for this event
 * @property {string} subscription_status - PENDING/ACTIVE/PAUSED/ENDED/CANCELED
 * @property {DateTime} gracePeriodEndDate - grace_period_end_date
 * @property {GUID} subscriptionId - the subscription
 * @property {GUID} invoiceId - invoiceid
 * @property {DateTime} gracePeriodStartDate - grace_period_start_date
 * @property {string} actionName - view/submit/cancel
 * @property {string} initiatorName - Manage Subscription / GP
 * @property {string} collectionMethod - subscription collection_method - AUTO_CHARGE/OFFLINE
 * @property {string} referralInfo - referral
 * @return {LogObject<subscriptionOverviewCollectPaymentSubmitPaymentParams>} LogObject<subscriptionOverviewCollectPaymentSubmitPaymentParams>
 */
export function subscriptionOverviewCollectPaymentSubmitPayment(params) {
    return { evid: 660, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aSuccessToastEvent' event (evid: 698)
 *
 * Event description: Success toast for business manager operations, like UPM, pay now, etc.
 *
 * @param {aSuccessToastEventParams} params - The parameters for this event
 * @property {GUID} subscriptionId - the subscription
 * @property {string} initiatorName - UPM/UCM 0/UCM pay/CPD/GP Paynow
 * @property {string} referralinfo - referralinfo
 * @return {LogObject<aSuccessToastEventParams>} LogObject<aSuccessToastEventParams>
 */
export function aSuccessToastEvent(params) {
    return { evid: 698, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aToggleGracePeriodEvent' event (evid: 700)
 *
 * Event description: Enable and disable the grace period toggle switch in pricing plans settings of a site
 *
 * @param {aToggleGracePeriodEventParams} params - The parameters for this event
 * @property {boolean} enabled - is grace period enabled (true) or disabled (false) after clicking the toggle
 * @property {GUID} tenantId - bass site identifier
 * @property {string} referralinfo - referralinfo
 * @return {LogObject<aToggleGracePeriodEventParams>} LogObject<aToggleGracePeriodEventParams>
 */
export function aToggleGracePeriodEvent(params) {
    return { evid: 700, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnLearnMoreGracePeriodEvent' event (evid: 701)
 *
 * Event description: Go to grace period support article
 *
 * @param {aClickOnLearnMoreGracePeriodEventParams} params - The parameters for this event
 * @property {GUID} tenantId - bass site identifier
 * @property {string} initiatorName - setting_page or list_page_banner (subscriptions page)
 * @property {string} referralinfo - referral_info
 * @return {LogObject<aClickOnLearnMoreGracePeriodEventParams>} LogObject<aClickOnLearnMoreGracePeriodEventParams>
 */
export function aClickOnLearnMoreGracePeriodEvent(params) {
    return { evid: 701, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aChangeDaysGracePeriodEvent' event (evid: 702)
 *
 * Event description: Change grace period days, determining how long customers have to resubmit a payment after failure
 *
 * @param {aChangeDaysGracePeriodEventParams} params - The parameters for this event
 * @property {boolean} isValid - validation of number of days, should be 1-14 days (at the time of feature rollout, might change)
 * @property {GUID} tenantId - bass site identifier
 * @property {string} referralinfo - referralinfo
 * @property {number} gracePeriodDuration - grace period duration in days
 * @return {LogObject<aChangeDaysGracePeriodEventParams>} LogObject<aChangeDaysGracePeriodEventParams>
 */
export function aChangeDaysGracePeriodEvent(params) {
    return { evid: 702, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessBillingSettingsCreateBillingSettings' event (evid: 800)
 *
 * Event description: business billing settings is created for the user on the first time it is needed, including grace period settings, taxes, etc
 *
 * @param {businessBillingSettingsCreateBillingSettingsParams} params - The parameters for this event
 * @property {GUID} appInstanceId - tenant_id
 * @property {boolean} gracePeriodEnabled - is grace period enabled (true) or disabled (false)
 * @property {GUID} id - business_billing_settings_id
 * @property {string} taxes - taxes json
 * @property {string} gracePeriodModel - fixed duration/duration by cycle unit
 * @property {GUID} appId - app_id
 * @property {string} gracePeriod - grace_period json
 * @property {number} gracePeriodDuration - grace period duration in days
 * @return {LogObject<businessBillingSettingsCreateBillingSettingsParams>} LogObject<businessBillingSettingsCreateBillingSettingsParams>
 */
export function businessBillingSettingsCreateBillingSettings(params) {
    return { evid: 800, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessBillingSettingsUpdateBillingSettings' event (evid: 801)
 *
 * Event description: when user update grace period settings in the business billing settings on a site level (=tanant)
 *
 * @param {businessBillingSettingsUpdateBillingSettingsParams} params - The parameters for this event
 * @property {number} duration - grace period duration in days after update
 * @property {string} model - grace period model type - "fixed duration"/"duration by cycle unit" after update
 * @property {GUID} appInstanceId - tenant_id
 * @property {boolean} enabled - is grace period enabled (true) or disabled (false) after update
 * @property {GUID} id - business_billing_settings_id
 * @property {string} oldValue - the setting value before the change
 * @property {boolean} isAutomaticRetryEnabled - automatic retries setting flag
 * @property {GUID} appId - app_id
 * @property {string} newValue - the setting value after the change
 * @return {LogObject<businessBillingSettingsUpdateBillingSettingsParams>} LogObject<businessBillingSettingsUpdateBillingSettingsParams>
 */
export function businessBillingSettingsUpdateBillingSettings(params) {
    return { evid: 801, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aViewPricingPlansSettingsEvent' event (evid: 900)
 *
 * Event description: Buttons directing to pricing plans settings, either general settings CTA or banner that leads user to the settings page in order to enable grace period settings
 *
 * @param {aViewPricingPlansSettingsEventParams} params - The parameters for this event
 * @property {GUID} tenantId - bass site identifier
 * @property {string} initiatorName - banner/pricing_plans_settings_btn
 * @property {string} referralinfo - referralinfo
 * @return {LogObject<aViewPricingPlansSettingsEventParams>} LogObject<aViewPricingPlansSettingsEventParams>
 */
export function aViewPricingPlansSettingsEvent(params) {
    return { evid: 900, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aViewSubscriptionReports' event (evid: 901)
 *
 * Event description: Button that leads user to subscription reports
 *
 * @param {aViewSubscriptionReportsParams} params - The parameters for this event
 * @property {string} referralinfo - referralinfo
 * @property {GUID} tenantId - bass site identifier
 * @return {LogObject<aViewSubscriptionReportsParams>} LogObject<aViewSubscriptionReportsParams>
 */
export function aViewSubscriptionReports(params) {
    return { evid: 901, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pricingPlansSettingsGracePeriodAutomaticRetriesToggleSwitch' event (evid: 902)
 *
 * Event description: Enable and disable the  Automatic Retries toggle switch in pricing plans settings of a site, under grace period section
 *
 * @param {pricingPlansSettingsGracePeriodAutomaticRetriesToggleSwitchParams} params - The parameters for this event
 * @property {boolean} enabled - is grace period enabled (true) or disabled (false) after clicking the toggle
 * @property {GUID} tenantId - bass site identifier
 * @property {string} referralinfo - referralinfo
 * @return {LogObject<pricingPlansSettingsGracePeriodAutomaticRetriesToggleSwitchParams>} LogObject<pricingPlansSettingsGracePeriodAutomaticRetriesToggleSwitchParams>
 */
export function pricingPlansSettingsGracePeriodAutomaticRetriesToggleSwitch(params) {
    return { evid: 902, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsPageView' event (evid: 903)
 *
 * Event description: Enable and disable the  Automatic Retries toggle switch in pricing plans settings of a site, under grace period section
 *
 * @param {settingsPageViewParams} params - The parameters for this event
 * @property {GUID} tenantId - bass site identifier
 * @property {string} initiatorName - subscriptions page / settings menu / pricing plans settings / back
 * @property {string} referralinfo - referralinfo
 * @return {LogObject<settingsPageViewParams>} LogObject<settingsPageViewParams>
 */
export function settingsPageView(params) {
    return { evid: 903, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsPageSwitchTab' event (evid: 904)
 *
 * Event description: Enable and disable the  Automatic Retries toggle switch in pricing plans settings of a site, under grace period section
 *
 * @param {settingsPageSwitchTabParams} params - The parameters for this event
 * @property {string} tabName - General / Automations
 * @property {GUID} tenantId - bass site identifier
 * @property {string} referralinfo - referralinfo
 * @return {LogObject<settingsPageSwitchTabParams>} LogObject<settingsPageSwitchTabParams>
 */
export function settingsPageSwitchTab(params) {
    return { evid: 904, src: 128, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnViewInvoices' event (evid: 10)
 *
 * Event description: client
 *
 * @param {aClickOnViewInvoicesParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnViewInvoicesParams>} LogObject<aClickOnViewInvoicesParams>
 */
export function aClickOnViewInvoices(params) {
    return { evid: 10, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartPremiumPurchaseDispatcherException' event (evid: 100)
 *
 * Event description: R_StartPremiumPurchaseDispatcherException.
 *
 * @param {rStartPremiumPurchaseDispatcherExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartPremiumPurchaseDispatcherExceptionParams>} LogObject<rStartPremiumPurchaseDispatcherExceptionParams>
 */
export function rStartPremiumPurchaseDispatcherException(params) {
    return { evid: 100, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainAlreadyHave' event (evid: 1000)
 *
 * Event description: V_DomainAlreadyHave.
 *
 * @param {vDomainAlreadyHaveParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainAlreadyHaveParams>} LogObject<vDomainAlreadyHaveParams>
 */
export function vDomainAlreadyHave(params) {
    return { evid: 1000, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainAlreadyHaveClickConnect' event (evid: 1001)
 *
 * Event description: A_DomainAlreadyHaveClickConnect.
 *
 * @param {aDomainAlreadyHaveClickConnectParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainAlreadyHaveClickConnectParams>} LogObject<aDomainAlreadyHaveClickConnectParams>
 */
export function aDomainAlreadyHaveClickConnect(params) {
    return { evid: 1001, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainAlreadyHaveClickTransfer' event (evid: 1002)
 *
 * Event description: A_DomainAlreadyHaveClickTransfer.
 *
 * @param {aDomainAlreadyHaveClickTransferParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainAlreadyHaveClickTransferParams>} LogObject<aDomainAlreadyHaveClickTransferParams>
 */
export function aDomainAlreadyHaveClickTransfer(params) {
    return { evid: 1002, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainApiUpdateProductAndPricing' event (evid: 1003)
 *
 * Event description: triggered when server calls Billing API to update domain's Product & Pricing
 *
 * @param {domainApiUpdateProductAndPricingParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} uuid - user guid
 * @property {string} productId - product guid
 * @property {string} serviceId - service guid
 * @property {number} skuid - sku id
 * @return {LogObject<domainApiUpdateProductAndPricingParams>} LogObject<domainApiUpdateProductAndPricingParams>
 */
export function domainApiUpdateProductAndPricing(params) {
    return { evid: 1003, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainAlreadyHaveClickTransferDetailsLink' event (evid: 1004)
 *
 * Event description: A_DomainAlreadyHaveClickTransferDetailsLink.
 *
 * @param {aDomainAlreadyHaveClickTransferDetailsLinkParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainAlreadyHaveClickTransferDetailsLinkParams>} LogObject<aDomainAlreadyHaveClickTransferDetailsLinkParams>
 */
export function aDomainAlreadyHaveClickTransferDetailsLink(params) {
    return { evid: 1004, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainAvailForTransferSuccess' event (evid: 1005)
 *
 * Event description: R_DomainAvailbleForTransferSuccess.
 *
 * @param {rDomainAvailForTransferSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainAvailForTransferSuccessParams>} LogObject<rDomainAvailForTransferSuccessParams>
 */
export function rDomainAvailForTransferSuccess(params) {
    return { evid: 1005, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainAvailForTransferError' event (evid: 1006)
 *
 * Event description: R_DomainAvailbleForTransferError.
 *
 * @param {rDomainAvailForTransferErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainAvailForTransferErrorParams>} LogObject<rDomainAvailForTransferErrorParams>
 */
export function rDomainAvailForTransferError(params) {
    return { evid: 1006, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainAvailForTransferErrorException' event (evid: 1007)
 *
 * Event description: R_DomainAvailForTransferErrorException.
 *
 * @param {rDomainAvailForTransferErrorExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainAvailForTransferErrorExceptionParams>} LogObject<rDomainAvailForTransferErrorExceptionParams>
 */
export function rDomainAvailForTransferErrorException(params) {
    return { evid: 1007, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferInPurchaseStartSuccess' event (evid: 1008)
 *
 * Event description: R_DomainTransferInPurchaseStartSuccess.
 *
 * @param {rDomainTransferInPurchaseStartSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferInPurchaseStartSuccessParams>} LogObject<rDomainTransferInPurchaseStartSuccessParams>
 */
export function rDomainTransferInPurchaseStartSuccess(params) {
    return { evid: 1008, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferInPurchaseStartError' event (evid: 1009)
 *
 * Event description: R_DomainTransferInPurchaseStartError.
 *
 * @param {rDomainTransferInPurchaseStartErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferInPurchaseStartErrorParams>} LogObject<rDomainTransferInPurchaseStartErrorParams>
 */
export function rDomainTransferInPurchaseStartError(params) {
    return { evid: 1009, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferInPurchaseStartException' event (evid: 1010)
 *
 * Event description: R_DomainTransferInPurchaseStartException.
 *
 * @param {rDomainTransferInPurchaseStartExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferInPurchaseStartExceptionParams>} LogObject<rDomainTransferInPurchaseStartExceptionParams>
 */
export function rDomainTransferInPurchaseStartException(params) {
    return { evid: 1010, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainTransferInPurchaseForm' event (evid: 1011)
 *
 * Event description: V_DomainTransferInPurchaseForm.
 *
 * @param {vDomainTransferInPurchaseFormParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainTransferInPurchaseFormParams>} LogObject<vDomainTransferInPurchaseFormParams>
 */
export function vDomainTransferInPurchaseForm(params) {
    return { evid: 1011, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainTransferInStartProcessSuccessPage' event (evid: 1012)
 *
 * Event description: V_DomainTransferInStartProcessSuccessPage.
 *
 * @param {vDomainTransferInStartProcessSuccessPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainTransferInStartProcessSuccessPageParams>} LogObject<vDomainTransferInStartProcessSuccessPageParams>
 */
export function vDomainTransferInStartProcessSuccessPage(params) {
    return { evid: 1012, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainConsoleClickOnDomainTransferInStatus' event (evid: 1013)
 *
 * Event description: A_DomainConsoleClickOnDomainTransferInStatus.
 *
 * @param {aDomainConsoleClickOnDomainTransferInStatusParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainConsoleClickOnDomainTransferInStatusParams>} LogObject<aDomainConsoleClickOnDomainTransferInStatusParams>
 */
export function aDomainConsoleClickOnDomainTransferInStatus(params) {
    return { evid: 1013, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferInPurchaseSetContractSuccess' event (evid: 1014)
 *
 * Event description: R_DomainTransferInPurchaseSetContractSuccess.
 *
 * @param {rDomainTransferInPurchaseSetContractSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferInPurchaseSetContractSuccessParams>} LogObject<rDomainTransferInPurchaseSetContractSuccessParams>
 */
export function rDomainTransferInPurchaseSetContractSuccess(params) {
    return { evid: 1014, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferInPurchaseSetContractError' event (evid: 1015)
 *
 * Event description: R_DomainTransferInPurchaseSetContractError.
 *
 * @param {rDomainTransferInPurchaseSetContractErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferInPurchaseSetContractErrorParams>} LogObject<rDomainTransferInPurchaseSetContractErrorParams>
 */
export function rDomainTransferInPurchaseSetContractError(params) {
    return { evid: 1015, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferInPurchaseSetContractException' event (evid: 1016)
 *
 * Event description: R_DomainTransferInPurchaseSetContractException.
 *
 * @param {rDomainTransferInPurchaseSetContractExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferInPurchaseSetContractExceptionParams>} LogObject<rDomainTransferInPurchaseSetContractExceptionParams>
 */
export function rDomainTransferInPurchaseSetContractException(params) {
    return { evid: 1016, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferInPurchaseExecuteSuccess' event (evid: 1017)
 *
 * Event description: New implementation of Transfer-In.Effective from 2020-04-01
 *
 * @param {rDomainTransferInPurchaseExecuteSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferInPurchaseExecuteSuccessParams>} LogObject<rDomainTransferInPurchaseExecuteSuccessParams>
 */
export function rDomainTransferInPurchaseExecuteSuccess(params) {
    return { evid: 1017, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferInPurchaseExecuteError' event (evid: 1018)
 *
 * Event description: New implementation of Transfer-In.Effective from 2020-04-01
 *
 * @param {rDomainTransferInPurchaseExecuteErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferInPurchaseExecuteErrorParams>} LogObject<rDomainTransferInPurchaseExecuteErrorParams>
 */
export function rDomainTransferInPurchaseExecuteError(params) {
    return { evid: 1018, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferInPurchaseExecuteException' event (evid: 1019)
 *
 * Event description: R_DomainTransferInPurchaseExecuteException.
 *
 * @param {rDomainTransferInPurchaseExecuteExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferInPurchaseExecuteExceptionParams>} LogObject<rDomainTransferInPurchaseExecuteExceptionParams>
 */
export function rDomainTransferInPurchaseExecuteException(params) {
    return { evid: 1019, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vParkDomainNeedToClearDomainConnectionFirst' event (evid: 1020)
 *
 * Event description: V_ParkDomainNeedToClearDomainConnectionFirst.
 *
 * @param {vParkDomainNeedToClearDomainConnectionFirstParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vParkDomainNeedToClearDomainConnectionFirstParams>} LogObject<vParkDomainNeedToClearDomainConnectionFirstParams>
 */
export function vParkDomainNeedToClearDomainConnectionFirst(params) {
    return { evid: 1020, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rBrazilGetAddressByZipCode' event (evid: 1021)
 *
 * Event description: R_BrazilGetAddressByZipCode.
 *
 * @param {rBrazilGetAddressByZipCodeParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rBrazilGetAddressByZipCodeParams>} LogObject<rBrazilGetAddressByZipCodeParams>
 */
export function rBrazilGetAddressByZipCode(params) {
    return { evid: 1021, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rChangeDomainFacebookRemarketingIdSuccess' event (evid: 1025)
 *
 * Event description: R_ChangeDomainFacebookRemarketingIdSuccess.
 *
 * @param {rChangeDomainFacebookRemarketingIdSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rChangeDomainFacebookRemarketingIdSuccessParams>} LogObject<rChangeDomainFacebookRemarketingIdSuccessParams>
 */
export function rChangeDomainFacebookRemarketingIdSuccess(params) {
    return { evid: 1025, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aGoToConnectDomainFromTransfer' event (evid: 1028)
 *
 * Event description: When you try to transfer a domain that you can't buy in wix cause it's TLD is not supported, you get an error message with a CTA.
 * If you press the CTA 'connect your domain' you will be sent to the connect flow. This event is the click on this button
 *
 * @param {aGoToConnectDomainFromTransferParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - the domain the user tried to transfer
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aGoToConnectDomainFromTransferParams>} LogObject<aGoToConnectDomainFromTransferParams>
 */
export function aGoToConnectDomainFromTransfer(params) {
    return { evid: 1028, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainStartMigration' event (evid: 1029)
 *
 * Event description: domain start migration
 *
 * @param {domainStartMigrationParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} uuid - uuid
 * @return {LogObject<domainStartMigrationParams>} LogObject<domainStartMigrationParams>
 */
export function domainStartMigration(params) {
    return { evid: 1029, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumPurchaseSuccess' event (evid: 103)
 *
 * Event description: Premium plan purchase success, event_aggregator since 2017-11-21
 *
 * @param {premiumPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {GUID} '4' - uuid
 * @property {string} '33' - site_type_name
 * @property {GUID} uuid - uuid
 * @property {string} subscriptionId - package_id
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} billingCountry - billing_country
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {GUID} serviceGuid - service_guid
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} paymentCycle - cycle_id
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon_id
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} productTypeName - product_type_name
 * @property {number} invoiceId - invoice_id
 * @property {string} newPurchase - is_new_purchase
 * @property {string} externalProvider - external_provider
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {number} noOfOrderItems - no_of_order_items
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {string} productTypeId - product_type_id
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - msid
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - msid
 * @property {string} couponId - coupon_id
 * @property {number} '28' - billing_system
 * @property {number} cycleId - cycle_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<premiumPurchaseSuccessParams>} LogObject<premiumPurchaseSuccessParams>
 */
export function premiumPurchaseSuccess(params) {
    return { evid: 103, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainFinishMigration' event (evid: 1030)
 *
 * Event description: domain finish migration
 *
 * @param {domainFinishMigrationParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} uuid - uuid
 * @property {boolean} isSuccess - true/false
 * @return {LogObject<domainFinishMigrationParams>} LogObject<domainFinishMigrationParams>
 */
export function domainFinishMigration(params) {
    return { evid: 1030, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rClearTransferInFailedSuccess' event (evid: 1031)
 *
 * Event description: R_ClearTransferInFailedSuccess.
 *
 * @param {rClearTransferInFailedSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rClearTransferInFailedSuccessParams>} LogObject<rClearTransferInFailedSuccessParams>
 */
export function rClearTransferInFailedSuccess(params) {
    return { evid: 1031, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rClearTransferInFailedError' event (evid: 1032)
 *
 * Event description: R_ClearTransferInFailedError.
 *
 * @param {rClearTransferInFailedErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rClearTransferInFailedErrorParams>} LogObject<rClearTransferInFailedErrorParams>
 */
export function rClearTransferInFailedError(params) {
    return { evid: 1032, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainTransferInDeliveryError' event (evid: 1033)
 *
 * Event description: This event is triggered when the domain delivery during the Transfer-In has failed. Effective from 2020-04-01
 *
 * @param {domainTransferInDeliveryErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error description
 * @property {string} domain - Domain name
 * @property {GUID} uuid - Unique user identifier
 * @return {LogObject<domainTransferInDeliveryErrorParams>} LogObject<domainTransferInDeliveryErrorParams>
 */
export function domainTransferInDeliveryError(params) {
    return { evid: 1033, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainSetAsPrimarySuccess' event (evid: 1034)
 *
 * Event description: R_DomainSetAsPrimarySuccess.
 *
 * @param {rDomainSetAsPrimarySuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainSetAsPrimarySuccessParams>} LogObject<rDomainSetAsPrimarySuccessParams>
 */
export function rDomainSetAsPrimarySuccess(params) {
    return { evid: 1034, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainSetAsPrimaryError' event (evid: 1035)
 *
 * Event description: R_DomainSetAsPrimaryError.
 *
 * @param {rDomainSetAsPrimaryErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainSetAsPrimaryErrorParams>} LogObject<rDomainSetAsPrimaryErrorParams>
 */
export function rDomainSetAsPrimaryError(params) {
    return { evid: 1035, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainSetAsPrimaryException' event (evid: 1036)
 *
 * Event description: R_DomainSetAsPrimaryException.
 *
 * @param {rDomainSetAsPrimaryExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainSetAsPrimaryExceptionParams>} LogObject<rDomainSetAsPrimaryExceptionParams>
 */
export function rDomainSetAsPrimaryException(params) {
    return { evid: 1036, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rChangeDomainYandexMetricaIdSuccess' event (evid: 1037)
 *
 * Event description: R_ChangeDomainYandexMetricaIdSuccess.
 *
 * @param {rChangeDomainYandexMetricaIdSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rChangeDomainYandexMetricaIdSuccessParams>} LogObject<rChangeDomainYandexMetricaIdSuccessParams>
 */
export function rChangeDomainYandexMetricaIdSuccess(params) {
    return { evid: 1037, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc17Evid1042' event (evid: 1042)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc17Evid1042Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<dummyNameSrc17Evid1042Params>} LogObject<dummyNameSrc17Evid1042Params>
 */
export function dummyNameSrc17Evid1042(params) {
    return { evid: 1042, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumPurchaseError' event (evid: 105)
 *
 * Event description: R_PremiumPurchaseError
 *
 * @param {rPremiumPurchaseErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rPremiumPurchaseErrorParams>} LogObject<rPremiumPurchaseErrorParams>
 */
export function rPremiumPurchaseError(params) {
    return { evid: 105, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageAddCouponSuccess' event (evid: 106)
 *
 * Event description: Checkout  Page >  Add Coupon Success.
 *
 * @param {checkOutPageAddCouponSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {string} couponId - coupon_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<checkOutPageAddCouponSuccessParams>} LogObject<checkOutPageAddCouponSuccessParams>
 */
export function checkOutPageAddCouponSuccess(params) {
    return { evid: 106, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderPageAddCouponError' event (evid: 107)
 *
 * Event description: Checkout page > Add Coupon Error.
 *
 * @param {orderPageAddCouponErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} errorKey - error_key
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} coupon - PHONE85221, Phone87221
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} errorCode - checkout_error_code
 * @property {string} udger_ua - udger_ua
 * @property {string} actionType - action_type
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} additionalInfo - additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<orderPageAddCouponErrorParams>} LogObject<orderPageAddCouponErrorParams>
 */
export function orderPageAddCouponError(params) {
    return { evid: 107, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vPremiumPurchaseSuccess' event (evid: 109)
 *
 * Event description: V_PremiumPurchaseSuccess.
 *
 * @param {vPremiumPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vPremiumPurchaseSuccessParams>} LogObject<vPremiumPurchaseSuccessParams>
 */
export function vPremiumPurchaseSuccess(params) {
    return { evid: 109, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnUpdatePayment' event (evid: 11)
 *
 * Event description: A_ClickOnUpdatePayment
 *
 * @param {aClickOnUpdatePaymentParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} existingPaymentMethod - none/boleto/payU/creditCard/sepa
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {string} actionName - Update_payment_method/add_payment_method/renew_with_CC/Boleto/PayU
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {GUID} siteId - site_id
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} renewWith - boleto/payU/sepa/creditCard
 * @property {string} type - partners/diy
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickOnUpdatePaymentParams>} LogObject<aClickOnUpdatePaymentParams>
 */
export function aClickOnUpdatePayment(params) {
    return { evid: 11, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'new1512' event (evid: 110)
 *
 * Event description: We are migrating dealer client to call a new platformized api.
 * those events will contains comparison results of both api's - new and old.  it will make migration process safer.
 *
 * @param {new1512Params} params - The parameters for this event
 * @property {GUID} bannerIdNew - banner id returning from new dealer
 * @property {GUID} bannerIdOld - banner id returning fro old dealer
 * @property {string} realEstateId - the real estate that the request was made from
 * @property {boolean} assetIdEqual - true if assetId has the same value in both responses
 * @property {boolean} dynamicParamsEqual - true if dynamicParams has the same value in both responses
 * @property {boolean} equal - true if all other comparison fields are true
 * @property {boolean} daysLeftEqual - true if daysLeft has the same value in both responses - only if its back from new dealer
 * @property {boolean} bannerIdEqual - true if bannerId has the same value in both responses
 * @property {boolean} templateEqual - true if template has the same value in both responses
 * @property {boolean} saleTypeEqual - true if saleType has the same value in both responses - only if its back from new dealer
 * @property {boolean} lightboxTriggersEqual - true if lightboxTriggers has the same value in both responses
 * @property {GUID} msid - the metasite id in context of request
 * @return {LogObject<new1512Params>} LogObject<new1512Params>
 */
export function new1512(params) {
    return { evid: 110, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vSbsPayNow' event (evid: 1100)
 *
 * Event description: V_SbsPayNow.
 *
 * @param {vSbsPayNowParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vSbsPayNowParams>} LogObject<vSbsPayNowParams>
 */
export function vSbsPayNow(params) {
    return { evid: 1100, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsPayNowSuccess' event (evid: 1101)
 *
 * Event description: R_SbsPayNowSuccess.
 *
 * @param {rSbsPayNowSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsPayNowSuccessParams>} LogObject<rSbsPayNowSuccessParams>
 */
export function rSbsPayNowSuccess(params) {
    return { evid: 1101, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsPayNowError' event (evid: 1102)
 *
 * Event description: R_SbsPayNowError.
 *
 * @param {rSbsPayNowErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsPayNowErrorParams>} LogObject<rSbsPayNowErrorParams>
 */
export function rSbsPayNowError(params) {
    return { evid: 1102, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsPayNowFatalError' event (evid: 1103)
 *
 * Event description: R_SbsPayNowFatalError.
 *
 * @param {rSbsPayNowFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsPayNowFatalErrorParams>} LogObject<rSbsPayNowFatalErrorParams>
 */
export function rSbsPayNowFatalError(params) {
    return { evid: 1103, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsPayNowException' event (evid: 1104)
 *
 * Event description: R_SbsPayNowException.
 *
 * @param {rSbsPayNowExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsPayNowExceptionParams>} LogObject<rSbsPayNowExceptionParams>
 */
export function rSbsPayNowException(params) {
    return { evid: 1104, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsPayNowBusinessError' event (evid: 1105)
 *
 * Event description: R_SbsPayNowBusinessError.
 *
 * @param {rSbsPayNowBusinessErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsPayNowBusinessErrorParams>} LogObject<rSbsPayNowBusinessErrorParams>
 */
export function rSbsPayNowBusinessError(params) {
    return { evid: 1105, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesClick' event (evid: 1106)
 *
 * Event description: click on a CTA in Business Email page
 *
 * @param {gSuiteMyMailboxesClickParams} params - The parameters for this event
 * @property {string} nextStep - Next step type - Single Connected domain/  Multiple Connected domain /No connected domain
 * @property {number} accountTotalDomains - account_total_domains
 * @property {string} viewMode - empty_state/manage_state
 * @property {string} voucher - True/False
 * @property {boolean} hasLiveMailbox - has_live_mailbox
 * @property {number} domainsNotAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {number} siteTotalDomains - site_total_domains
 * @property {string} domain - domain name
 * @property {number} expiredMailboxAccounts - number of expired mailbox accounts
 * @property {number} domainsAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {string} clickType - 'Google Voice Get Started'
 * @property {string} pagetype - page_type
 * @property {boolean} inSale - [yes / no]
 * @property {string} isConnectedDomain - true, false
 * @property {number} emailProvider - email_provider
 * @property {number} siteConnectedDomains - site_connected_domains
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - is_account_premium
 * @property {number} activeMailboxAccounts - number of active mailbox accounts
 * @property {boolean} isPremium - is_premium
 * @property {string} pageName - current version of the page
 * @property {number} accountConnectedDomains - account_connected_domains
 * @property {string} discount - discount
 * @property {GUID} siteGuid - site_id
 * @return {LogObject<gSuiteMyMailboxesClickParams>} LogObject<gSuiteMyMailboxesClickParams>
 */
export function gSuiteMyMailboxesClick(params) {
    return { evid: 1106, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageCouponClickOnApply' event (evid: 111)
 *
 * Event description: Checkout Page > Coupon click on "Apply".
 *
 * @param {checkOutPageCouponClickOnApplyParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} coupon - coupon
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<checkOutPageCouponClickOnApplyParams>} LogObject<checkOutPageCouponClickOnApplyParams>
 */
export function checkOutPageCouponClickOnApply(params) {
    return { evid: 111, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aSbsPayNowPayButtonPressed' event (evid: 1110)
 *
 * Event description: A_SbsPayNowPayButtonPressed.
 *
 * @param {aSbsPayNowPayButtonPressedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aSbsPayNowPayButtonPressedParams>} LogObject<aSbsPayNowPayButtonPressedParams>
 */
export function aSbsPayNowPayButtonPressed(params) {
    return { evid: 1110, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageClickOnShowHideMoreSavedPMsSrc17Evid112' event (evid: 112)
 *
 * Event description: User clicked on "show more" or "hide" in the saved PM section in the checkout, in order to see more saved PMs.
 *
 * @param {checkoutPageClickOnShowHideMoreSavedPMsSrc17Evid112Params} params - The parameters for this event
 * @property {string} externalSessionId - external session id
 * @property {string} initiatorName - initiator_name
 * @property {number} numSavedPaymentMethods - Show- number of total saved payment methods in saved pm tab (for example 10)
 * Hide - number of saved PM which are shown in the tab when user clicked hide (for example 1 (out of 10))
 *
 * @property {string} subType - click on "show" or "hide"
 * @return {LogObject<checkoutPageClickOnShowHideMoreSavedPMsSrc17Evid112Params>} LogObject<checkoutPageClickOnShowHideMoreSavedPMsSrc17Evid112Params>
 */
export function checkoutPageClickOnShowHideMoreSavedPMsSrc17Evid112(params) {
    return { evid: 112, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aSbsPayNowMercadoPagoLoadjsready' event (evid: 1120)
 *
 * Event description: A_SbsPayNowMercadoPagoLoadJSReady.
 *
 * @param {aSbsPayNowMercadoPagoLoadjsreadyParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aSbsPayNowMercadoPagoLoadjsreadyParams>} LogObject<aSbsPayNowMercadoPagoLoadjsreadyParams>
 */
export function aSbsPayNowMercadoPagoLoadjsready(params) {
    return { evid: 1120, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsPayNowMercadoPagoPreApprovalSuccess' event (evid: 1121)
 *
 * Event description: R_SbsPayNowMercadoPagoPreApprovalSuccess.
 *
 * @param {rSbsPayNowMercadoPagoPreApprovalSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsPayNowMercadoPagoPreApprovalSuccessParams>} LogObject<rSbsPayNowMercadoPagoPreApprovalSuccessParams>
 */
export function rSbsPayNowMercadoPagoPreApprovalSuccess(params) {
    return { evid: 1121, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsPayNowMercadoPagoPreApprovalError' event (evid: 1122)
 *
 * Event description: R_SbsPayNowMercadoPagoPreApprovalError.
 *
 * @param {rSbsPayNowMercadoPagoPreApprovalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsPayNowMercadoPagoPreApprovalErrorParams>} LogObject<rSbsPayNowMercadoPagoPreApprovalErrorParams>
 */
export function rSbsPayNowMercadoPagoPreApprovalError(params) {
    return { evid: 1122, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsPayNowMercadoPagoPreApprovalDroppedUser' event (evid: 1123)
 *
 * Event description: R_SbsPayNowMercadoPagoPreApprovalDroppedUser.
 *
 * @param {rSbsPayNowMercadoPagoPreApprovalDroppedUserParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsPayNowMercadoPagoPreApprovalDroppedUserParams>} LogObject<rSbsPayNowMercadoPagoPreApprovalDroppedUserParams>
 */
export function rSbsPayNowMercadoPagoPreApprovalDroppedUser(params) {
    return { evid: 1123, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageCreateOrderPage' event (evid: 1124)
 *
 * Event description: server
 *
 * @param {checkOutPageCreateOrderPageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - externalSessionId
 * @property {string} initiatorProductType - initiator_product_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} products - json
 * @property {string} invoiceId - id
 * @property {string} newPurchase - false, true
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} initiator - initiator
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkOutPageCreateOrderPageParams>} LogObject<checkOutPageCreateOrderPageParams>
 */
export function checkOutPageCreateOrderPage(params) {
    return { evid: 1124, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageInitiateOrderPage' event (evid: 1125)
 *
 * Event description: This event is fired before 17:125, 17:1124. The idea is to catch initialisation errors
 *
 * @param {checkoutPageInitiateOrderPageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - externalSessionId
 * @property {string} initiatorProductType - initiator_product_type
 * @property {GUID} uuid - user guid
 * @property {string} acceptLang - accept_lng
 * @property {string} products - json
 * @property {string} newPurchase - false, true
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPageInitiateOrderPageParams>} LogObject<checkoutPageInitiateOrderPageParams>
 */
export function checkoutPageInitiateOrderPage(params) {
    return { evid: 1125, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageInitiateOrderPageError' event (evid: 1126)
 *
 * Event description: This event is fired before 17:125, 17:1124 and only if there is an error
 *
 * @param {checkoutPageInitiateOrderPageErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} errorInfo - error_info
 * @property {string} externalSessionId - externalSessionId
 * @property {string} initiatorProductType - initiator_product_type
 * @property {GUID} uuid - user guid
 * @property {string} acceptLang - accept_lng
 * @property {string} products - json
 * @property {string} newPurchase - false, true
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} errorCode - checkout_error_code
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPageInitiateOrderPageErrorParams>} LogObject<checkoutPageInitiateOrderPageErrorParams>
 */
export function checkoutPageInitiateOrderPageError(params) {
    return { evid: 1126, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickOnResetAdminPassword' event (evid: 1130)
 *
 * Event description: G-suite > click on Reset Admin Password
 *
 * @param {gSuiteClickOnResetAdminPasswordParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - /
 * @property {GUID} 	productTypeId - 	productTypeId
 * @property {GUID} 	productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickOnResetAdminPasswordParams>} LogObject<gSuiteClickOnResetAdminPasswordParams>
 */
export function gSuiteClickOnResetAdminPassword(params) {
    return { evid: 1130, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteResetAdminPasswordPopUpClick' event (evid: 1131)
 *
 * Event description: G-suite > Reset Admin Password Pop-up > click
 *
 * @param {gSuiteResetAdminPasswordPopUpClickParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} clickType - cancel, close, reset password
 * @property {string} referralAdditionalInfo - /
 * @return {LogObject<gSuiteResetAdminPasswordPopUpClickParams>} LogObject<gSuiteResetAdminPasswordPopUpClickParams>
 */
export function gSuiteResetAdminPasswordPopUpClick(params) {
    return { evid: 1131, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickRetrieveMailboxesArrow' event (evid: 1132)
 *
 * Event description: G-suite > click retrieve mailboxes arrow
 * the little down facing arrow next to the mailbox
 *
 * @param {gSuiteClickRetrieveMailboxesArrowParams} params - The parameters for this event
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} clickType - expand, collapse
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @return {LogObject<gSuiteClickRetrieveMailboxesArrowParams>} LogObject<gSuiteClickRetrieveMailboxesArrowParams>
 */
export function gSuiteClickRetrieveMailboxesArrow(params) {
    return { evid: 1132, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickSetUpMailbox' event (evid: 1133)
 *
 * Event description: After use goes to G-suite > click retrieve mailboxes arrow,
 * he clicks Set Up Mailbox.  This button available when mailbox was purchased for this domain but not set up yet.
 *
 * @param {gSuiteClickSetUpMailboxParams} params - The parameters for this event
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} seatName - seat name
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @return {LogObject<gSuiteClickSetUpMailboxParams>} LogObject<gSuiteClickSetUpMailboxParams>
 */
export function gSuiteClickSetUpMailbox(params) {
    return { evid: 1133, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickGoToMailbox' event (evid: 1134)
 *
 * Event description: After use goes to G-suite > click retrieve mailboxes arrow,
 * he clicks Go to Mailbox.
 *
 * @param {gSuiteClickGoToMailboxParams} params - The parameters for this event
 * @property {number} numSetUpSeats - num_setup_seats
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {number} totalSeats - total_seats
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {GUID} 	productTypeId - 	productTypeId
 * @property {GUID} 	productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickGoToMailboxParams>} LogObject<gSuiteClickGoToMailboxParams>
 */
export function gSuiteClickGoToMailbox(params) {
    return { evid: 1134, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickManageAtGoogle' event (evid: 1135)
 *
 * Event description: After use goes to G-suite > click retrieve mailboxes arrow,
 * he clicks Manage at Google.
 *
 * @param {gSuiteClickManageAtGoogleParams} params - The parameters for this event
 * @property {number} numSetUpSeats - number of seats that were already setup
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {number} totalSeats - total number of seats in the account
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @property {GUID} 	productTypeId - 	product_type_id
 * @property {GUID} 	productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickManageAtGoogleParams>} LogObject<gSuiteClickManageAtGoogleParams>
 */
export function gSuiteClickManageAtGoogle(params) {
    return { evid: 1135, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickManagePayments' event (evid: 1136)
 *
 * Event description: After use goes to G-suite > click retrieve mailboxes arrow,
 * he clicks Manage Payments.
 *
 * @param {gSuiteClickManagePaymentsParams} params - The parameters for this event
 * @property {number} numSetUpSeats - number of saets that were already set up in the mailbox account
 * @property {string} viewMode - empty_state / maage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {number} totalSeats - total number of seats in the mailbox account
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @property {GUID} productTypeId - product_type_id
 * @property {GUID} productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickManagePaymentsParams>} LogObject<gSuiteClickManagePaymentsParams>
 */
export function gSuiteClickManagePayments(params) {
    return { evid: 1136, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickRenewSubscription' event (evid: 1137)
 *
 * Event description: G-suite > click Renew Subscription
 *
 * @param {gSuiteClickRenewSubscriptionParams} params - The parameters for this event
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} pageView - site_level/ account_level
 * @property {string} referralAdditionalInfo - /
 * @property {GUID} 	productTypeId - 	productTypeId
 * @property {GUID} 	productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {GUID} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickRenewSubscriptionParams>} LogObject<gSuiteClickRenewSubscriptionParams>
 */
export function gSuiteClickRenewSubscription(params) {
    return { evid: 1137, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickRenewSubscriptionClick' event (evid: 1138)
 *
 * Event description: G-suite > click Renew Subscription > click inside the pop-up
 *
 * @param {gSuiteClickRenewSubscriptionClickParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} clickType - close, next
 * @property {string} referralAdditionalInfo - /
 * @return {LogObject<gSuiteClickRenewSubscriptionClickParams>} LogObject<gSuiteClickRenewSubscriptionClickParams>
 */
export function gSuiteClickRenewSubscriptionClick(params) {
    return { evid: 1138, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickSetUpMailboxes' event (evid: 1139)
 *
 * Event description: After use goes to G-suite > he clicks Set Up Mailboxes. This button exists when domain had already set up a mailbox with at least one seat.
 *
 * @param {gSuiteClickSetUpMailboxesParams} params - The parameters for this event
 * @property {number} numSetUpSeats - number of seats in the mailbox account that were already set up
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {number} totalSeats - total number of seats in the mailbox account
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @property {GUID} productTypeId - productTypeId
 * @property {GUID} productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickSetUpMailboxesParams>} LogObject<gSuiteClickSetUpMailboxesParams>
 */
export function gSuiteClickSetUpMailboxes(params) {
    return { evid: 1139, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickBuyAMailbox' event (evid: 1140)
 *
 * Event description: After use goes to G-suite > he clicks Buy a Mailbox. This button exists when user didn't yet buy a mailbox for this domain.
 *
 * @param {gSuiteClickBuyAMailboxParams} params - The parameters for this event
 * @property {string} viewMode - empty_state / manage_state
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @return {LogObject<gSuiteClickBuyAMailboxParams>} LogObject<gSuiteClickBuyAMailboxParams>
 */
export function gSuiteClickBuyAMailbox(params) {
    return { evid: 1140, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickSetUpMailboxesToolTip' event (evid: 1141)
 *
 * Event description: After use goes to G-suite > he clicks Set Up Mailboxes > Hovers or clicks the tool tip. distinguish between hover and click according to clickType field.
 *
 * @param {gSuiteClickSetUpMailboxesToolTipParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - /
 * @return {LogObject<gSuiteClickSetUpMailboxesToolTipParams>} LogObject<gSuiteClickSetUpMailboxesToolTipParams>
 */
export function gSuiteClickSetUpMailboxesToolTip(params) {
    return { evid: 1141, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickSetUpMailboxesEnterField' event (evid: 1142)
 *
 * Event description: After use goes to G-suite > he clicks Set Up Mailboxes >  clicks in any of the boxes in the screen. distinguish between boxes with fieldName field.
 *
 * @param {gSuiteClickSetUpMailboxesEnterFieldParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} fieldName - Choose admin user name, Create Password, Re-enter password, First Name, Last Name, Alternative email, Company Name,  Country, Postal Code
 * @return {LogObject<gSuiteClickSetUpMailboxesEnterFieldParams>} LogObject<gSuiteClickSetUpMailboxesEnterFieldParams>
 */
export function gSuiteClickSetUpMailboxesEnterField(params) {
    return { evid: 1142, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesPageClickDropdown' event (evid: 1145)
 *
 * Event description: G-suite > Click the three dots dropdown in my mailboxes page
 *
 * @param {gSuiteMyMailboxesPageClickDropdownParams} params - The parameters for this event
 * @property {boolean} canUpgrade - If the current package is eligible for upgrade
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain name
 * @property {string} items - MANAGE_AT_GOOGLE, UPGRADE_TO_BUSINESS_EMAIL, MANAGE_PAYMENTS
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @return {LogObject<gSuiteMyMailboxesPageClickDropdownParams>} LogObject<gSuiteMyMailboxesPageClickDropdownParams>
 */
export function gSuiteMyMailboxesPageClickDropdown(params) {
    return { evid: 1145, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesExpandLoadSuccess' event (evid: 1146)
 *
 * Event description: My mailboxes > expand load success
 *
 * @param {gSuiteMyMailboxesExpandLoadSuccessParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain name
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteMyMailboxesExpandLoadSuccessParams>} LogObject<gSuiteMyMailboxesExpandLoadSuccessParams>
 */
export function gSuiteMyMailboxesExpandLoadSuccess(params) {
    return { evid: 1146, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesExpandLoadFailure' event (evid: 1147)
 *
 * Event description: My mailboxes > expand load failure
 *
 * @param {gSuiteMyMailboxesExpandLoadFailureParams} params - The parameters for this event
 * @property {string} errorInfo - network error /data retrieve error
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain name
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteMyMailboxesExpandLoadFailureParams>} LogObject<gSuiteMyMailboxesExpandLoadFailureParams>
 */
export function gSuiteMyMailboxesExpandLoadFailure(params) {
    return { evid: 1147, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesClickLearnMore' event (evid: 1148)
 *
 * Event description: Click on learn how to set up an additional user/mailbox after the admin was already set up
 *
 * @param {gSuiteMyMailboxesClickLearnMoreParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} domain - domain name
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referraladditionalinfo
 * @return {LogObject<gSuiteMyMailboxesClickLearnMoreParams>} LogObject<gSuiteMyMailboxesClickLearnMoreParams>
 */
export function gSuiteMyMailboxesClickLearnMore(params) {
    return { evid: 1148, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesPageLoadFailure' event (evid: 1149)
 *
 * Event description: G-suite > My mailboxes > Page load failure (manage state)
 *
 * @param {gSuiteMyMailboxesPageLoadFailureParams} params - The parameters for this event
 * @property {string} errorInfo - network error /data retrieve error
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referraladditionalinfo
 * @return {LogObject<gSuiteMyMailboxesPageLoadFailureParams>} LogObject<gSuiteMyMailboxesPageLoadFailureParams>
 */
export function gSuiteMyMailboxesPageLoadFailure(params) {
    return { evid: 1149, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageRemoveCouponSuccess' event (evid: 115)
 *
 * Event description: Checkout  Page >  Remove Coupon Success.
 *
 * @param {checkOutPageRemoveCouponSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {string} couponId - coupon_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<checkOutPageRemoveCouponSuccessParams>} LogObject<checkOutPageRemoveCouponSuccessParams>
 */
export function checkOutPageRemoveCouponSuccess(params) {
    return { evid: 115, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesConnectMailboxLearnHow' event (evid: 1150)
 *
 * Event description: Click on learn how to connect a mailbox that was purchased outside of Wix
 *
 * @param {gSuiteMyMailboxesConnectMailboxLearnHowParams} params - The parameters for this event
 * @property {number} accountTotalDomains - total number of domains in the account
 * @property {string} pageView - page_view
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteMyMailboxesConnectMailboxLearnHowParams>} LogObject<gSuiteMyMailboxesConnectMailboxLearnHowParams>
 */
export function gSuiteMyMailboxesConnectMailboxLearnHow(params) {
    return { evid: 1150, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesClickDropdownSeatLevel' event (evid: 1151)
 *
 * Event description: G-suite > Click the three dots dropdown in seat level (my mailboxes page)
 *
 * @param {gSuiteMyMailboxesClickDropdownSeatLevelParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain name
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {GUID} 	productTypeId - 	productTypeId
 * @property {GUID} 	productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteMyMailboxesClickDropdownSeatLevelParams>} LogObject<gSuiteMyMailboxesClickDropdownSeatLevelParams>
 */
export function gSuiteMyMailboxesClickDropdownSeatLevel(params) {
    return { evid: 1151, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickOnRenameUser' event (evid: 1152)
 *
 * Event description: G-suite > Click 'Rename User'
 *
 * @param {gSuiteClickOnRenameUserParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {GUID} productTypeId - productTypeId
 * @property {GUID} productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickOnRenameUserParams>} LogObject<gSuiteClickOnRenameUserParams>
 */
export function gSuiteClickOnRenameUser(params) {
    return { evid: 1152, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteRenameUserPopUpClick' event (evid: 1153)
 *
 * Event description: G-suite > Rename User Pop-up > click
 *
 * @param {gSuiteRenameUserPopUpClickParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {boolean} firstNameChanged - true/false
 * @property {string} domain - domain
 * @property {string} clickType - cancel, close, rename_user
 * @property {string} pageView - site_level/account_level
 * @property {boolean} emailAddressChanged - true/false
 * @property {boolean} lastNameChanged - true/false
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteRenameUserPopUpClickParams>} LogObject<gSuiteRenameUserPopUpClickParams>
 */
export function gSuiteRenameUserPopUpClick(params) {
    return { evid: 1153, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesRenameUserLearnMore' event (evid: 1154)
 *
 * Event description: Click on learn more on the message  "Renaming your user can take up to 10 minutes" or on "This user will continue to receive emails sent to old and new address"
 *
 * @param {gSuiteMyMailboxesRenameUserLearnMoreParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - emailPackageGuid
 * @property {string} domain - domain name
 * @property {string} messageType - time_to_update/email_address
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteMyMailboxesRenameUserLearnMoreParams>} LogObject<gSuiteMyMailboxesRenameUserLearnMoreParams>
 */
export function gSuiteMyMailboxesRenameUserLearnMore(params) {
    return { evid: 1154, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteRenameUserSubmitSuccess' event (evid: 1155)
 *
 * Event description: Rename user Submit Success
 *
 * @param {gSuiteRenameUserSubmitSuccessParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteRenameUserSubmitSuccessParams>} LogObject<gSuiteRenameUserSubmitSuccessParams>
 */
export function gSuiteRenameUserSubmitSuccess(params) {
    return { evid: 1155, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteRenameUserSubmitError' event (evid: 1156)
 *
 * Event description: Rename user Submit Error
 *
 * @param {gSuiteRenameUserSubmitErrorParams} params - The parameters for this event
 * @property {string} errorInfo - error info
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @return {LogObject<gSuiteRenameUserSubmitErrorParams>} LogObject<gSuiteRenameUserSubmitErrorParams>
 */
export function gSuiteRenameUserSubmitError(params) {
    return { evid: 1156, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesRedirectionFromPurchase' event (evid: 1157)
 *
 * Event description: G-suite > My mailboxes > Redirection from Purchase
 *
 * @param {gSuiteMyMailboxesRedirectionFromPurchaseParams} params - The parameters for this event
 * @property {string} errorInfo - network error /data retrieve error
 * @property {number} retryCount - number of retries
 * @property {string} domainName - domainName
 * @property {boolean} isSuccess - whether setup form redirection worked
 * @property {string} referralAdditionalInfo - referraladditionalinfo
 * @return {LogObject<gSuiteMyMailboxesRedirectionFromPurchaseParams>} LogObject<gSuiteMyMailboxesRedirectionFromPurchaseParams>
 */
export function gSuiteMyMailboxesRedirectionFromPurchase(params) {
    return { evid: 1157, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageSubmitErrorAfterSubmittingWithoutSelectedSavedPmSrc17Evid116' event (evid: 116)
 *
 * Event description: Submit error after submitting without a selected saved PM
 *
 * @param {checkoutPageSubmitErrorAfterSubmittingWithoutSelectedSavedPmSrc17Evid116Params} params - The parameters for this event
 * @property {string} externalSessionId - external session id
 * @property {string} initiatorName - initiator_name
 * @property {GUID} billingAccountGuid - Submited Billing Account Guid
 * @property {string} errorMessage - Error message (in english, not the translated one)
 * @property {string} searchText - search_text
 * @property {string} searchedBillingAccountGuid - list of billing accounts that were  returned on search
 * @return {LogObject<checkoutPageSubmitErrorAfterSubmittingWithoutSelectedSavedPmSrc17Evid116Params>} LogObject<checkoutPageSubmitErrorAfterSubmittingWithoutSelectedSavedPmSrc17Evid116Params>
 */
export function checkoutPageSubmitErrorAfterSubmittingWithoutSelectedSavedPmSrc17Evid116(params) {
    return { evid: 116, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowUpgradePageLoad' event (evid: 1160)
 *
 * Event description: enterprise user view page after clicking upgrade button
 *
 * @param {noCheckoutFlowUpgradePageLoadParams} params - The parameters for this event
 * @property {string} viewMode - ‘upgrade’, ‘already premium’, ‘no permissions’
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {GUID} msid - msid
 * @return {LogObject<noCheckoutFlowUpgradePageLoadParams>} LogObject<noCheckoutFlowUpgradePageLoadParams>
 */
export function noCheckoutFlowUpgradePageLoad(params) {
    return { evid: 1160, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumPlanAssetVersionSrc17Evid117' event (evid: 117)
 *
 * Event description: Premium Plan- Asset Version
 *
 * @param {premiumPlanAssetVersionSrc17Evid117Params} params - The parameters for this event
 * @property {string} asset_version - V1 or V2
 * @property {string} requestId - request_id
 * @property {string} msid - msid
 * @return {LogObject<premiumPlanAssetVersionSrc17Evid117Params>} LogObject<premiumPlanAssetVersionSrc17Evid117Params>
 */
export function premiumPlanAssetVersionSrc17Evid117(params) {
    return { evid: 117, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainPurchaseStep3PrivacyContinueSrc17Evid118' event (evid: 118)
 *
 * Event description: Domain purchase - Privacy step click Continue to step 4 (checkout)
 *
 * @param {domainPurchaseStep3PrivacyContinueSrc17Evid118Params} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} udger_ua_class - udger_ua_class
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {string} acceptLang - accept_lng
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} os_name - os_name
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} screenResolution - screen_resolution
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} privacy - privacy
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {string} referral - referral
 * @property {string} providerId - provider_id
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {string} region - region
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {Url} referer - referral
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<domainPurchaseStep3PrivacyContinueSrc17Evid118Params>} LogObject<domainPurchaseStep3PrivacyContinueSrc17Evid118Params>
 */
export function domainPurchaseStep3PrivacyContinueSrc17Evid118(params) {
    return { evid: 118, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainPurchaseStep2PrivacyChangePrivacySrc17Evid119' event (evid: 119)
 *
 * Event description: Privacy page on domain purchase flow - change privacy selection
 *
 * @param {domainPurchaseStep2PrivacyChangePrivacySrc17Evid119Params} params - The parameters for this event
 * @property {GUID} packageGuid - package_id
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} udger_ua_class - udger_ua_class
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {string} acceptLang - accept_lng
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} os_name - os_name
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {string} region - region
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {Url} referer - referral
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {string} privacy - 0,1
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<domainPurchaseStep2PrivacyChangePrivacySrc17Evid119Params>} LogObject<domainPurchaseStep2PrivacyChangePrivacySrc17Evid119Params>
 */
export function domainPurchaseStep2PrivacyChangePrivacySrc17Evid119(params) {
    return { evid: 119, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rUpdatePaymentMethodError' event (evid: 12)
 *
 * Event description: R_UpdatePaymentMethodError.
 *
 * @param {rUpdatePaymentMethodErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rUpdatePaymentMethodErrorParams>} LogObject<rUpdatePaymentMethodErrorParams>
 */
export function rUpdatePaymentMethodError(params) {
    return { evid: 12, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCanceledAndRefundPlan' event (evid: 120)
 *
 * Event description: when we can't deliver the plan due to :
 * 1. site deleted
 * 2. site is already connected to a vertical plan
 *
 * @param {premiumCanceledAndRefundPlanParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} serviceGuid - sbs serviceGuid
 * @property {GUID} userGuid - user guid
 * @property {number} paymentCycle - 3,6...
 * @property {string} eventAggregator - event_aggregator
 * @property {string} reason - why
 * @property {string} user_agent - user_agent
 * @property {number} site_type - site_type
 * @property {string} premiumLng - wix lng
 * @property {GUID} packageGuid - package_id
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - premium product id
 * @property {string} productGuid - Product Guid
 * @property {GUID} siteGuid - msid
 * @return {LogObject<premiumCanceledAndRefundPlanParams>} LogObject<premiumCanceledAndRefundPlanParams>
 */
export function premiumCanceledAndRefundPlan(params) {
    return { evid: 120, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPremiumMercadoPagoLoadjsready' event (evid: 1200)
 *
 * Event description: A_PremiumMercadoPagoLoadJSReady.
 *
 * @param {aPremiumMercadoPagoLoadjsreadyParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPremiumMercadoPagoLoadjsreadyParams>} LogObject<aPremiumMercadoPagoLoadjsreadyParams>
 */
export function aPremiumMercadoPagoLoadjsready(params) {
    return { evid: 1200, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumMercadoPagoPreApprovalSuccess' event (evid: 1201)
 *
 * Event description: R_PremiumMercadoPagoPreApprovalSuccess.
 *
 * @param {rPremiumMercadoPagoPreApprovalSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPremiumMercadoPagoPreApprovalSuccessParams>} LogObject<rPremiumMercadoPagoPreApprovalSuccessParams>
 */
export function rPremiumMercadoPagoPreApprovalSuccess(params) {
    return { evid: 1201, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumMercadoPagoPreApprovalError' event (evid: 1202)
 *
 * Event description: R_PremiumMercadoPagoPreApprovalError.
 *
 * @param {rPremiumMercadoPagoPreApprovalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPremiumMercadoPagoPreApprovalErrorParams>} LogObject<rPremiumMercadoPagoPreApprovalErrorParams>
 */
export function rPremiumMercadoPagoPreApprovalError(params) {
    return { evid: 1202, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumMercadoPagoPreApprovalDroppedUser' event (evid: 1203)
 *
 * Event description: R_PremiumMercadoPagoPreApprovalDroppedUser.
 *
 * @param {rPremiumMercadoPagoPreApprovalDroppedUserParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPremiumMercadoPagoPreApprovalDroppedUserParams>} LogObject<rPremiumMercadoPagoPreApprovalDroppedUserParams>
 */
export function rPremiumMercadoPagoPreApprovalDroppedUser(params) {
    return { evid: 1203, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMissingeExceptionBiEvent' event (evid: 121)
 *
 * Event description: sometimes this event is triggered by Domains team, but it can also be triggered from TPAs and other places.
 *
 * @param {rMissingeExceptionBiEventParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMissingeExceptionBiEventParams>} LogObject<rMissingeExceptionBiEventParams>
 */
export function rMissingeExceptionBiEvent(params) {
    return { evid: 121, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainMercadoPagoLoadjsready' event (evid: 1210)
 *
 * Event description: A_DomainMercadoPagoLoadJSReady.
 *
 * @param {aDomainMercadoPagoLoadjsreadyParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainMercadoPagoLoadjsreadyParams>} LogObject<aDomainMercadoPagoLoadjsreadyParams>
 */
export function aDomainMercadoPagoLoadjsready(params) {
    return { evid: 1210, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainMercadoPagoPreApprovalSuccess' event (evid: 1211)
 *
 * Event description: R_DomainMercadoPagoPreApprovalSuccess.
 *
 * @param {rDomainMercadoPagoPreApprovalSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainMercadoPagoPreApprovalSuccessParams>} LogObject<rDomainMercadoPagoPreApprovalSuccessParams>
 */
export function rDomainMercadoPagoPreApprovalSuccess(params) {
    return { evid: 1211, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainMercadoPagoPreApprovalError' event (evid: 1212)
 *
 * Event description: R_DomainMercadoPagoPreApprovalError.
 *
 * @param {rDomainMercadoPagoPreApprovalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainMercadoPagoPreApprovalErrorParams>} LogObject<rDomainMercadoPagoPreApprovalErrorParams>
 */
export function rDomainMercadoPagoPreApprovalError(params) {
    return { evid: 1212, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainMercadoPagoPreApprovalDroppedUser' event (evid: 1213)
 *
 * Event description: R_DomainMercadoPagoPreApprovalDroppedUser.
 *
 * @param {rDomainMercadoPagoPreApprovalDroppedUserParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainMercadoPagoPreApprovalDroppedUserParams>} LogObject<rDomainMercadoPagoPreApprovalDroppedUserParams>
 */
export function rDomainMercadoPagoPreApprovalDroppedUser(params) {
    return { evid: 1213, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc17Evid1219' event (evid: 1219)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc17Evid1219Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc17Evid1219Params>} LogObject<dummyNameSrc17Evid1219Params>
 */
export function dummyNameSrc17Evid1219(params) {
    return { evid: 1219, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumDoublePurchase' event (evid: 122)
 *
 * Event description: The user is trying to upgrade a site that is already premium for the first time.
 *
 * @param {premiumDoublePurchaseParams} params - The parameters for this event
 * @property {string} product_type_id - product_type_id
 * @property {string} siteTypeName - site_type_name
 * @property {string} abTest - ab_test
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} conflictingServiceGuid - conflicting_service_guid
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {number} paymentCycle - 3,6...
 * @property {string} eventAggregator - event_aggregator
 * @property {string} reason - whyץ Failed to retrieve data from SBS - means the check failed. no blocking
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - wix lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} productTypeId - product_type_id
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - premium product id
 * @property {Url} referer - referral
 * @property {string} productGuid - Product Guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<premiumDoublePurchaseParams>} LogObject<premiumDoublePurchaseParams>
 */
export function premiumDoublePurchase(params) {
    return { evid: 122, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumViewDoublePurchasePopup' event (evid: 1220)
 *
 * Event description: view popup
 *
 * @param {premiumViewDoublePurchasePopupParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} conflictingServiceGuid - conflictingServiceGuid
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} reason - delivered /pending delivery
 * @property {string} newPurchase - true/false
 * @property {number} site_type - site_type
 * @property {string} premiumLng - wix lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} pagename - ab_test
 * @property {string} productTypeId - dynamic
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} additionalInfo - error_info
 * @property {number} productId - premium product id
 * @property {Url} referer - referral
 * @property {string} productGuid - product_guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<premiumViewDoublePurchasePopupParams>} LogObject<premiumViewDoublePurchasePopupParams>
 */
export function premiumViewDoublePurchasePopup(params) {
    return { evid: 1220, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumDoublePurchasePopupAction' event (evid: 1221)
 *
 * Event description: view popup
 *
 * @param {premiumDoublePurchasePopupActionParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} conflictingServiceGuid - conflictingServiceGuid
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} reason - delivered /pending delivery
 * @property {string} newPurchase - true/false
 * @property {number} site_type - site_type
 * @property {string} premiumLng - wix lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} pagename - ab_test
 * @property {string} productTypeId - dynamic
 * @property {string} actionName - action_name
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} additionalInfo - error_info
 * @property {number} productId - premium product id
 * @property {Url} referer - referral
 * @property {string} productGuid - productGuid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<premiumDoublePurchasePopupActionParams>} LogObject<premiumDoublePurchasePopupActionParams>
 */
export function premiumDoublePurchasePopupAction(params) {
    return { evid: 1221, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowEligibilityCartExposure' event (evid: 1222)
 *
 * Event description: Is eligible to get the Cart experience (express checkout). Used for exposure for the AB test
 *
 * @param {expressFlowEligibilityCartExposureParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {boolean} isEligible - Is eligible for cart or not
 * @property {GUID} msid - msid
 * @return {LogObject<expressFlowEligibilityCartExposureParams>} LogObject<expressFlowEligibilityCartExposureParams>
 */
export function expressFlowEligibilityCartExposure(params) {
    return { evid: 1222, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutView' event (evid: 1223)
 *
 * Event description: User viewed the Pre-Checkout of express flow
 *
 * @param {expressFlowPreCheckoutViewParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @return {LogObject<expressFlowPreCheckoutViewParams>} LogObject<expressFlowPreCheckoutViewParams>
 */
export function expressFlowPreCheckoutView(params) {
    return { evid: 1223, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutPlanProductIsViewed' event (evid: 1224)
 *
 * Event description: Plan product is shown
 *
 * @param {expressFlowPreCheckoutPlanProductIsViewedParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} productType - plan
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {string} productId - product_id
 * @property {GUID} msid - site
 * @property {string} eventAggregator - eventaggregator
 * @property {string} viewmode - view_mode
 * @return {LogObject<expressFlowPreCheckoutPlanProductIsViewedParams>} LogObject<expressFlowPreCheckoutPlanProductIsViewedParams>
 */
export function expressFlowPreCheckoutPlanProductIsViewed(params) {
    return { evid: 1224, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutDomainProductViewed' event (evid: 1225)
 *
 * Event description: Domain product is shown
 *
 * @param {expressFlowPreCheckoutDomainProductViewedParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} privacy - true, false
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {string} productId - product_id
 * @property {GUID} msid - site
 * @property {string} eventAggregator - eventaggregator
 * @property {string} viewmode - view_mode
 * @return {LogObject<expressFlowPreCheckoutDomainProductViewedParams>} LogObject<expressFlowPreCheckoutDomainProductViewedParams>
 */
export function expressFlowPreCheckoutDomainProductViewed(params) {
    return { evid: 1225, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutGeneralCtaClick' event (evid: 1226)
 *
 * Event description: Clicks on CTAs in pre checkout page
 *
 * @param {expressFlowPreCheckoutGeneralCtaClickParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} elementText - domain_privacy_learn_more
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowPreCheckoutGeneralCtaClickParams>} LogObject<expressFlowPreCheckoutGeneralCtaClickParams>
 */
export function expressFlowPreCheckoutGeneralCtaClick(params) {
    return { evid: 1226, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutProductRemoveAdd' event (evid: 1228)
 *
 * Event description: Add or Remove product from the pre-checkout page  (check / uncheck)
 *
 * @param {expressFlowPreCheckoutProductRemoveAddParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} productType - domain, plan
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} action - add, remove
 * @property {string} referraladditionalinfo - .
 * @property {string} eventAggregator - eventaggregator
 * @property {string} viewmode - view_mode
 * @return {LogObject<expressFlowPreCheckoutProductRemoveAddParams>} LogObject<expressFlowPreCheckoutProductRemoveAddParams>
 */
export function expressFlowPreCheckoutProductRemoveAdd(params) {
    return { evid: 1228, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutPlanSelectionCycleChange' event (evid: 1229)
 *
 * Event description: Change of Plan cycle
 *
 * @param {expressFlowPreCheckoutPlanSelectionCycleChangeParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {number} cycle - 3,6,7,8
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @property {string} changeSource - Where was the cycle changed from- dedicated CTA, or cycle scroll
 * @return {LogObject<expressFlowPreCheckoutPlanSelectionCycleChangeParams>} LogObject<expressFlowPreCheckoutPlanSelectionCycleChangeParams>
 */
export function expressFlowPreCheckoutPlanSelectionCycleChange(params) {
    return { evid: 1229, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rCancelPackageRequestError' event (evid: 123)
 *
 * Event description: R_CancelPackageRequestError.
 *
 * @param {rCancelPackageRequestErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rCancelPackageRequestErrorParams>} LogObject<rCancelPackageRequestErrorParams>
 */
export function rCancelPackageRequestError(params) {
    return { evid: 123, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutDomainSelectionPrivacyChange' event (evid: 1230)
 *
 * Event description: Change of domain privacy
 *
 * @param {expressFlowPreCheckoutDomainSelectionPrivacyChangeParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} action - add, remove
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowPreCheckoutDomainSelectionPrivacyChangeParams>} LogObject<expressFlowPreCheckoutDomainSelectionPrivacyChangeParams>
 */
export function expressFlowPreCheckoutDomainSelectionPrivacyChange(params) {
    return { evid: 1230, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutDomainSelectionCycleChange' event (evid: 1231)
 *
 * Event description: Change of domain cycle
 *
 * @param {expressFlowPreCheckoutDomainSelectionCycleChangeParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {number} cycle - cycle_id
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowPreCheckoutDomainSelectionCycleChangeParams>} LogObject<expressFlowPreCheckoutDomainSelectionCycleChangeParams>
 */
export function expressFlowPreCheckoutDomainSelectionCycleChange(params) {
    return { evid: 1231, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutCtaComparePlans' event (evid: 1232)
 *
 * Event description: click "Compare Plans" CTA in Pre Checkout page (redirects to Package Picker)
 *
 * @param {expressFlowPreCheckoutCtaComparePlansParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} countryCode - .
 * @property {string} flow - flow
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowPreCheckoutCtaComparePlansParams>} LogObject<expressFlowPreCheckoutCtaComparePlansParams>
 */
export function expressFlowPreCheckoutCtaComparePlans(params) {
    return { evid: 1232, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutContinueToCheckout' event (evid: 1233)
 *
 * Event description: click Continue in Pre-Checkout page
 *
 * @param {expressFlowPreCheckoutContinueToCheckoutParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {number} totalAmount - amount
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {string} currency - currency
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowPreCheckoutContinueToCheckoutParams>} LogObject<expressFlowPreCheckoutContinueToCheckoutParams>
 */
export function expressFlowPreCheckoutContinueToCheckout(params) {
    return { evid: 1233, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutClickBack' event (evid: 1234)
 *
 * Event description: click back in Pre Checkout page
 *
 * @param {expressFlowPreCheckoutClickBackParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} sourcePage - bundle_selector (budle/domain only), plan_selector (PP), cart (summary page), checkout
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @property {string} eventAggregator - eventaggregator
 * @property {string} viewmode - view_mode
 * @return {LogObject<expressFlowPreCheckoutClickBackParams>} LogObject<expressFlowPreCheckoutClickBackParams>
 */
export function expressFlowPreCheckoutClickBack(params) {
    return { evid: 1234, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowErrorPage' event (evid: 1235)
 *
 * Event description: Add or Remove product from the pre-checkout page  (check / uncheck)
 *
 * @param {expressFlowErrorPageParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} errorMsg - error_message
 * @property {string} countryCode - .
 * @property {boolean} isAccountPremium - true, false
 * @property {string} pageName - page name
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowErrorPageParams>} LogObject<expressFlowErrorPageParams>
 */
export function expressFlowErrorPage(params) {
    return { evid: 1235, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowSummaryPageClick2YearsCycleSrc17Evid1236' event (evid: 1236)
 *
 * Event description: For Cart of Premium +Domain, click on "save more with 2 years cycle" CTA
 *
 * @param {expressFlowSummaryPageClick2YearsCycleSrc17Evid1236Params} params - The parameters for this event
 * @property {string} domain - Domain
 * @return {LogObject<expressFlowSummaryPageClick2YearsCycleSrc17Evid1236Params>} LogObject<expressFlowSummaryPageClick2YearsCycleSrc17Evid1236Params>
 */
export function expressFlowSummaryPageClick2YearsCycleSrc17Evid1236(params) {
    return { evid: 1236, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rCancelPackageRequestException' event (evid: 124)
 *
 * Event description: R_CancelPackageRequestException.
 *
 * @param {rCancelPackageRequestExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rCancelPackageRequestExceptionParams>} LogObject<rCancelPackageRequestExceptionParams>
 */
export function rCancelPackageRequestException(params) {
    return { evid: 124, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainConciergeSearchEligibleForModalSrc17Evid1240' event (evid: 1240)
 *
 * Event description: Exposure for test in domain search flow of split page vs modal (July 2024)
 * trigger when a user is eligible to get the split page, based on dev logic of eligibility.
 *
 * @param {domainConciergeSearchEligibleForModalSrc17Evid1240Params} params - The parameters for this event
 * @property {string} domain - Domain searched
 * @property {boolean} isEligible - Is eligible to split screen
 * @return {LogObject<domainConciergeSearchEligibleForModalSrc17Evid1240Params>} LogObject<domainConciergeSearchEligibleForModalSrc17Evid1240Params>
 */
export function domainConciergeSearchEligibleForModalSrc17Evid1240(params) {
    return { evid: 1240, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartCartPageLoadStartSrc17Evid1241' event (evid: 1241)
 *
 * Event description: Premium Cart - Cart page - Cart page started to load
 *
 *
 * @param {premiumCartCartPageLoadStartSrc17Evid1241Params} params - The parameters for this event
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid - msid
 * @return {LogObject<premiumCartCartPageLoadStartSrc17Evid1241Params>} LogObject<premiumCartCartPageLoadStartSrc17Evid1241Params>
 */
export function premiumCartCartPageLoadStartSrc17Evid1241(params) {
    return { evid: 1241, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartLineItemClickEditSrc17Evid1244' event (evid: 1244)
 *
 * Event description: User clicked to edit a line item
 *
 * @param {premiumCartLineItemClickEditSrc17Evid1244Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} referralInfo - Where the cart was initiated from (mailbox floe etc.)
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid - msid
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycleDurationCount
 * @return {LogObject<premiumCartLineItemClickEditSrc17Evid1244Params>} LogObject<premiumCartLineItemClickEditSrc17Evid1244Params>
 */
export function premiumCartLineItemClickEditSrc17Evid1244(params) {
    return { evid: 1244, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartLineItemClickRemoveFromCartSrc17Evid1245' event (evid: 1245)
 *
 * Event description: User clicked to remove an item from cart
 *
 * @param {premiumCartLineItemClickRemoveFromCartSrc17Evid1245Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} referralInfo - Where the cart was initiated from (mailbox floe etc.)
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} recommendationTitle - Title of the recommendation
 * @property {string} msid -  msid
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @return {LogObject<premiumCartLineItemClickRemoveFromCartSrc17Evid1245Params>} LogObject<premiumCartLineItemClickRemoveFromCartSrc17Evid1245Params>
 */
export function premiumCartLineItemClickRemoveFromCartSrc17Evid1245(params) {
    return { evid: 1245, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartLineItemLineItemUpdatedSrc17Evid1246' event (evid: 1246)
 *
 * Event description: Line item was edited and saved
 *
 * @param {premiumCartLineItemLineItemUpdatedSrc17Evid1246Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} productName - Specific product in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid -  msid
 * @property {string} cycleDurationUnit - cycleDurationUnit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @return {LogObject<premiumCartLineItemLineItemUpdatedSrc17Evid1246Params>} LogObject<premiumCartLineItemLineItemUpdatedSrc17Evid1246Params>
 */
export function premiumCartLineItemLineItemUpdatedSrc17Evid1246(params) {
    return { evid: 1246, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartLineItemChangeSeatsSrc17Evid1247' event (evid: 1247)
 *
 * Event description: Seats number was changed (seats added or removed)
 *
 * @param {premiumCartLineItemChangeSeatsSrc17Evid1247Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid - msid
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @return {LogObject<premiumCartLineItemChangeSeatsSrc17Evid1247Params>} LogObject<premiumCartLineItemChangeSeatsSrc17Evid1247Params>
 */
export function premiumCartLineItemChangeSeatsSrc17Evid1247(params) {
    return { evid: 1247, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartCartPageCartPageLoadSuccessSrc17Evid1248' event (evid: 1248)
 *
 * Event description: the Cart Page started successfully loaded
 * Will be triggered everytime there is a change/addition of a line item
 *
 * @param {premiumCartCartPageCartPageLoadSuccessSrc17Evid1248Params} params - The parameters for this event
 * @property {GUID} cartId - cart id
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid - msid
 * @property {string} lineItems - list of line items
 * @return {LogObject<premiumCartCartPageCartPageLoadSuccessSrc17Evid1248Params>} LogObject<premiumCartCartPageCartPageLoadSuccessSrc17Evid1248Params>
 */
export function premiumCartCartPageCartPageLoadSuccessSrc17Evid1248(params) {
    return { evid: 1248, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartCartPageContinueToCheckoutSrc17Evid1249' event (evid: 1249)
 *
 * Event description: Clicked on continue to checkout
 *
 * @param {premiumCartCartPageContinueToCheckoutSrc17Evid1249Params} params - The parameters for this event
 * @property {GUID} cartId - cart id
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} continueType - skip/continue to checkout
 * @property {string} msid - msid
 * @property {string} LineItems - array
 * @return {LogObject<premiumCartCartPageContinueToCheckoutSrc17Evid1249Params>} LogObject<premiumCartCartPageContinueToCheckoutSrc17Evid1249Params>
 */
export function premiumCartCartPageContinueToCheckoutSrc17Evid1249(params) {
    return { evid: 1249, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumPurchasePage' event (evid: 125)
 *
 * Event description: View Premium plan purchase page. legacy premium plans. DO is 17:1124
 *
 * @param {premiumPurchasePageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {string} abTest - ab_test
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} coupon - coupon
 * @property {number} paymentCycle - cycle_id
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<premiumPurchasePageParams>} LogObject<premiumPurchasePageParams>
 */
export function premiumPurchasePage(params) {
    return { evid: 125, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartRecommendationRecommendationLoadStartSrc17Evid1250' event (evid: 1250)
 *
 * Event description: A recommendation of another product/cycle/tier was started to load
 *
 * @param {premiumCartRecommendationRecommendationLoadStartSrc17Evid1250Params} params - The parameters for this event
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} cartInitiator - The source from which the cart was created
 * @property {string} recommendationId - identifier of the recommendation
 * @property {string} lineItems - list of line items
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} recommendationTitle - Title of the recommendation
 * @property {string} msid -  msid
 * @property {string} cycleDurationUnit - cycle_duration_uni
 * @property {number} cycleDurationCount - cycle_duration_count
 * @return {LogObject<premiumCartRecommendationRecommendationLoadStartSrc17Evid1250Params>} LogObject<premiumCartRecommendationRecommendationLoadStartSrc17Evid1250Params>
 */
export function premiumCartRecommendationRecommendationLoadStartSrc17Evid1250(params) {
    return { evid: 1250, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartRecommendationRecommendationLoadSuccessSrc17Evid1251' event (evid: 1251)
 *
 * Event description: A recommendation of another product/cycle_name/tier successfully loaded
 *
 * @param {premiumCartRecommendationRecommendationLoadSuccessSrc17Evid1251Params} params - The parameters for this event
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} cartInitiator - The source from which the cart was created
 * @property {string} recommendationId - identifier of the recommendation
 * @property {string} lineItems - list of line items
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} recommendationTitle - Title of the recommendation
 * @property {string} msid -  msid
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @return {LogObject<premiumCartRecommendationRecommendationLoadSuccessSrc17Evid1251Params>} LogObject<premiumCartRecommendationRecommendationLoadSuccessSrc17Evid1251Params>
 */
export function premiumCartRecommendationRecommendationLoadSuccessSrc17Evid1251(params) {
    return { evid: 1251, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartRecommendationClickAddRecommendationToCartSrc17Evid1252' event (evid: 1252)
 *
 * Event description: A recommendation of another product/cycle_name/tier was clicked to be added to the cart
 *
 * @param {premiumCartRecommendationClickAddRecommendationToCartSrc17Evid1252Params} params - The parameters for this event
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} recommendationId - identifier of the recommendation
 * @property {string} lineItems - list of line items
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} recommendationTitle - Title of the recommendation
 * @property {string} msid -  msid
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @return {LogObject<premiumCartRecommendationClickAddRecommendationToCartSrc17Evid1252Params>} LogObject<premiumCartRecommendationClickAddRecommendationToCartSrc17Evid1252Params>
 */
export function premiumCartRecommendationClickAddRecommendationToCartSrc17Evid1252(params) {
    return { evid: 1252, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartLineItemChangeSeatsSrc17Evid1253' event (evid: 1253)
 *
 * Event description: Seats number was changed (seats added or removed)
 *
 * @param {premiumCartLineItemChangeSeatsSrc17Evid1253Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} referralInfo - Where the cart was initiated from (mailbox floe etc.)
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} productName - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} msid - msid
 * @return {LogObject<premiumCartLineItemChangeSeatsSrc17Evid1253Params>} LogObject<premiumCartLineItemChangeSeatsSrc17Evid1253Params>
 */
export function premiumCartLineItemChangeSeatsSrc17Evid1253(params) {
    return { evid: 1253, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartEditModalModalLoadedSrc17Evid1254' event (evid: 1254)
 *
 * Event description: Modal was opened, to edit one of the line items
 *
 * @param {premiumCartEditModalModalLoadedSrc17Evid1254Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid - msid
 * @return {LogObject<premiumCartEditModalModalLoadedSrc17Evid1254Params>} LogObject<premiumCartEditModalModalLoadedSrc17Evid1254Params>
 */
export function premiumCartEditModalModalLoadedSrc17Evid1254(params) {
    return { evid: 1254, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planPurchasePurchasePageViewFallbackCoupon' event (evid: 1255)
 *
 * Event description: fallback coupon (from dealer) was injected in purchase page. In this scenario, there could be 2 reasons why fallback coupon was injected
 * 1. Coupon service was down
 * 2. Client passed a parameter saying use fallback
 *
 * @param {planPurchasePurchasePageViewFallbackCouponParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} offeringGroupGuid - offering_group_guid
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {number} paymentCycle - 3,6...
 * @property {string} eventAggregator - event aggregator
 * @property {string} newPurchase - false, true
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} additionalInfo - 'no coupon available', 'client request'
 * @property {number} productId - premium product id
 * @property {Url} referer - referral
 * @property {string} offeringType - offeringtype
 * @property {string} productGuid - Product Guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {string} couponId - coupon guid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} offeringResultGuid - offering Result Guid
 * @return {LogObject<planPurchasePurchasePageViewFallbackCouponParams>} LogObject<planPurchasePurchasePageViewFallbackCouponParams>
 */
export function planPurchasePurchasePageViewFallbackCoupon(params) {
    return { evid: 1255, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartEditModalCycleDropdownClickedSrc17Evid1256' event (evid: 1256)
 *
 * Event description: Click on the cycle drop down
 *
 * @param {premiumCartEditModalCycleDropdownClickedSrc17Evid1256Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid - msid
 * @return {LogObject<premiumCartEditModalCycleDropdownClickedSrc17Evid1256Params>} LogObject<premiumCartEditModalCycleDropdownClickedSrc17Evid1256Params>
 */
export function premiumCartEditModalCycleDropdownClickedSrc17Evid1256(params) {
    return { evid: 1256, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartEditModalCycleSelectedSrc17Evid1257' event (evid: 1257)
 *
 * Event description: Click on a different cycle
 *
 * @param {premiumCartEditModalCycleSelectedSrc17Evid1257Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid - msid
 * @return {LogObject<premiumCartEditModalCycleSelectedSrc17Evid1257Params>} LogObject<premiumCartEditModalCycleSelectedSrc17Evid1257Params>
 */
export function premiumCartEditModalCycleSelectedSrc17Evid1257(params) {
    return { evid: 1257, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartEditModalProductSelectedSrc17Evid1258' event (evid: 1258)
 *
 * Event description: Click on a different product
 *
 * @param {premiumCartEditModalProductSelectedSrc17Evid1258Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid - msid
 * @return {LogObject<premiumCartEditModalProductSelectedSrc17Evid1258Params>} LogObject<premiumCartEditModalProductSelectedSrc17Evid1258Params>
 */
export function premiumCartEditModalProductSelectedSrc17Evid1258(params) {
    return { evid: 1258, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartServerCartCompletedSrc17Evid1259' event (evid: 1259)
 *
 * Event description: Cart was paid
 *
 * @param {premiumCartServerCartCompletedSrc17Evid1259Params} params - The parameters for this event
 * @property {string} cartId - Identifier of the cart
 * @property {string} lineItems - Array of all the items in cart
 * @property {string} msid -  msid
 * @return {LogObject<premiumCartServerCartCompletedSrc17Evid1259Params>} LogObject<premiumCartServerCartCompletedSrc17Evid1259Params>
 */
export function premiumCartServerCartCompletedSrc17Evid1259(params) {
    return { evid: 1259, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartServerCartCreatedSrc17Evid1260' event (evid: 1260)
 *
 * Event description: Cart was initially created
 * Should be unique per Cart
 *
 * @param {premiumCartServerCartCreatedSrc17Evid1260Params} params - The parameters for this event
 * @property {string} cartId - Identifier of the cart
 * @property {string} lineItems - Array of all the items in cart
 * @property {string} msid -  msid
 * @return {LogObject<premiumCartServerCartCreatedSrc17Evid1260Params>} LogObject<premiumCartServerCartCreatedSrc17Evid1260Params>
 */
export function premiumCartServerCartCreatedSrc17Evid1260(params) {
    return { evid: 1260, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartServerCartUpdatedSrc17Evid1261' event (evid: 1261)
 *
 * Event description: A line item in the cart was changed
 *
 * @param {premiumCartServerCartUpdatedSrc17Evid1261Params} params - The parameters for this event
 * @property {string} cartId - Identifier of the cart
 * @property {string} lineItems - Array of all the items in cart
 * @property {string} msid -  msid
 * @return {LogObject<premiumCartServerCartUpdatedSrc17Evid1261Params>} LogObject<premiumCartServerCartUpdatedSrc17Evid1261Params>
 */
export function premiumCartServerCartUpdatedSrc17Evid1261(params) {
    return { evid: 1261, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartServerCartExpiredSrc17Evid1262' event (evid: 1262)
 *
 * Event description: Cart was expired due to session's timeout
 *
 * @param {premiumCartServerCartExpiredSrc17Evid1262Params} params - The parameters for this event
 * @property {string} cartId - Identifier of the cart
 * @property {string} lineItems - Array of all the items in cart
 * @property {string} msid -  msid
 * @return {LogObject<premiumCartServerCartExpiredSrc17Evid1262Params>} LogObject<premiumCartServerCartExpiredSrc17Evid1262Params>
 */
export function premiumCartServerCartExpiredSrc17Evid1262(params) {
    return { evid: 1262, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartServerCartCanceledSrc17Evid1263' event (evid: 1263)
 *
 * Event description: Cart canceled
 *
 * @param {premiumCartServerCartCanceledSrc17Evid1263Params} params - The parameters for this event
 * @property {string} cartId - Identifier of the cart
 * @property {string} lineItems - Array of all the items in cart
 * @property {string} cancelationType - Reason of the cancelation
 * @property {string} msid -  msid
 * @return {LogObject<premiumCartServerCartCanceledSrc17Evid1263Params>} LogObject<premiumCartServerCartCanceledSrc17Evid1263Params>
 */
export function premiumCartServerCartCanceledSrc17Evid1263(params) {
    return { evid: 1263, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartServerLineItemAddedSrc17Evid1264' event (evid: 1264)
 *
 * Event description: Line Item Added
 *
 * @param {premiumCartServerLineItemAddedSrc17Evid1264Params} params - The parameters for this event
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} cycleDurationUnit - duration unit (month/year etc)
 * @property {number} cycleDurationCount - number of units
 * @property {string} msid - msid
 * @return {LogObject<premiumCartServerLineItemAddedSrc17Evid1264Params>} LogObject<premiumCartServerLineItemAddedSrc17Evid1264Params>
 */
export function premiumCartServerLineItemAddedSrc17Evid1264(params) {
    return { evid: 1264, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartServerLineItemUpdatedSrc17Evid1265' event (evid: 1265)
 *
 * Event description: Line Item Updated
 *
 * @param {premiumCartServerLineItemUpdatedSrc17Evid1265Params} params - The parameters for this event
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} cycleDurationUnit - duration unit (month/year etc)
 * @property {number} cycleDurationCount - number of units
 * @property {string} msid - msid
 * @return {LogObject<premiumCartServerLineItemUpdatedSrc17Evid1265Params>} LogObject<premiumCartServerLineItemUpdatedSrc17Evid1265Params>
 */
export function premiumCartServerLineItemUpdatedSrc17Evid1265(params) {
    return { evid: 1265, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartServerLineItemRemovedSrc17Evid1266' event (evid: 1266)
 *
 * Event description: Line Item Removed from cart
 *
 * @param {premiumCartServerLineItemRemovedSrc17Evid1266Params} params - The parameters for this event
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} cycleDurationUnit - duration unit (month/year etc)
 * @property {number} cycleDurationCount - number of units
 * @return {LogObject<premiumCartServerLineItemRemovedSrc17Evid1266Params>} LogObject<premiumCartServerLineItemRemovedSrc17Evid1266Params>
 */
export function premiumCartServerLineItemRemovedSrc17Evid1266(params) {
    return { evid: 1266, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartEditModalClickSaveSrc17Evid1267' event (evid: 1267)
 *
 * Event description: Click on save the changes to update the line item and cart
 *
 * @param {premiumCartEditModalClickSaveSrc17Evid1267Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @property {string} msid - msid
 * @property {string} productName - name
 * @return {LogObject<premiumCartEditModalClickSaveSrc17Evid1267Params>} LogObject<premiumCartEditModalClickSaveSrc17Evid1267Params>
 */
export function premiumCartEditModalClickSaveSrc17Evid1267(params) {
    return { evid: 1267, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartSuccessPagePageStartLoadSrc17Evid1268' event (evid: 1268)
 *
 * Event description: Success Page of cart started to load
 *
 * @param {premiumCartSuccessPagePageStartLoadSrc17Evid1268Params} params - The parameters for this event
 * @property {string} productTypeIds - Array of
 * @property {GUID} cartId - cartid
 * @property {string} msid - msid
 * @property {number} invoiceId - invoice id
 * @property {string} buttonclicked - CTA that was clicked
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @return {LogObject<premiumCartSuccessPagePageStartLoadSrc17Evid1268Params>} LogObject<premiumCartSuccessPagePageStartLoadSrc17Evid1268Params>
 */
export function premiumCartSuccessPagePageStartLoadSrc17Evid1268(params) {
    return { evid: 1268, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartSuccessPagePageLoadSuccessSrc17Evid1269' event (evid: 1269)
 *
 * Event description: Premium Cart - Success Page - Page Load Success
 *
 * @param {premiumCartSuccessPagePageLoadSuccessSrc17Evid1269Params} params - The parameters for this event
 * @property {string} productTypeIds - Array of
 * @property {GUID} cartId - cartid
 * @property {string} msid - msid
 * @property {number} invoiceId - invoice id
 * @property {string} buttonclicked - CTA that was clicked
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} device - mobile / desktop
 * @property {string} viewMode - storefront/ concierge
 * @return {LogObject<premiumCartSuccessPagePageLoadSuccessSrc17Evid1269Params>} LogObject<premiumCartSuccessPagePageLoadSuccessSrc17Evid1269Params>
 */
export function premiumCartSuccessPagePageLoadSuccessSrc17Evid1269(params) {
    return { evid: 1269, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartSuccessPageCtaClickSrc17Evid1270' event (evid: 1270)
 *
 * Event description: Premium Cart - Success Page - CTA Click
 *
 * @param {premiumCartSuccessPageCtaClickSrc17Evid1270Params} params - The parameters for this event
 * @property {GUID} cartId - cartid
 * @property {string} msid - msid
 * @property {number} invoiceId - invoice id
 * @property {string} buttonclicked - CTA that was clicked
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} productTypeId - product_type_id clicked
 * @property {string} device - mobile / desktop
 * @property {string} viewMode - storefront  / concierge
 * @return {LogObject<premiumCartSuccessPageCtaClickSrc17Evid1270Params>} LogObject<premiumCartSuccessPageCtaClickSrc17Evid1270Params>
 */
export function premiumCartSuccessPageCtaClickSrc17Evid1270(params) {
    return { evid: 1270, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartSuccessPageCtaClickSrc17Evid1271' event (evid: 1271)
 *
 * Event description: Premium Cart - Success Page - Error
 *
 * @param {premiumCartSuccessPageCtaClickSrc17Evid1271Params} params - The parameters for this event
 * @property {GUID} cartId - cartid
 * @property {string} msid - msid
 * @property {number} invoiceId - invoice_id
 * @return {LogObject<premiumCartSuccessPageCtaClickSrc17Evid1271Params>} LogObject<premiumCartSuccessPageCtaClickSrc17Evid1271Params>
 */
export function premiumCartSuccessPageCtaClickSrc17Evid1271(params) {
    return { evid: 1271, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartSuccessPageLoadingErrorSrc17Evid1272' event (evid: 1272)
 *
 * Event description: Premium Cart - Success Page -Loading Error
 *
 * @param {premiumCartSuccessPageLoadingErrorSrc17Evid1272Params} params - The parameters for this event
 * @property {GUID} cartId - cartid
 * @property {string} msid - msid
 * @property {number} invoiceId - invoice_id
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @return {LogObject<premiumCartSuccessPageLoadingErrorSrc17Evid1272Params>} LogObject<premiumCartSuccessPageLoadingErrorSrc17Evid1272Params>
 */
export function premiumCartSuccessPageLoadingErrorSrc17Evid1272(params) {
    return { evid: 1272, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartPurchaseSummaryPageLoadSuccessSrc17Evid1273' event (evid: 1273)
 *
 * Event description: cart purchase summary page load success
 *
 * @param {premiumCartPurchaseSummaryPageLoadSuccessSrc17Evid1273Params} params - The parameters for this event
 * @property {GUID} CartId - cart id
 * @property {string} msid - msid
 * @property {string} device - mobile / desktop
 * @property {string} 'view mode' - storefront / concierge
 * @property {string} productTypeIds - all products purchased in the invoice
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @return {LogObject<premiumCartPurchaseSummaryPageLoadSuccessSrc17Evid1273Params>} LogObject<premiumCartPurchaseSummaryPageLoadSuccessSrc17Evid1273Params>
 */
export function premiumCartPurchaseSummaryPageLoadSuccessSrc17Evid1273(params) {
    return { evid: 1273, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartBusinessTypeChatPageLoadSuccessSrc17Evid1274' event (evid: 1274)
 *
 * Event description: event is trigger when Business type chat page load success
 *
 * @param {premiumCartBusinessTypeChatPageLoadSuccessSrc17Evid1274Params} params - The parameters for this event
 * @property {string} msid - msid
 * @property {string} domain - domain
 * @property {boolean} 'is premium' - true / false
 * @property {string} 'chat session id' - chat session id
 * @property {string} 'view mode' - storefront/ concierge
 * @property {string} device - mobile / desktop
 * @property {string} 'cart id' - cart id
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @return {LogObject<premiumCartBusinessTypeChatPageLoadSuccessSrc17Evid1274Params>} LogObject<premiumCartBusinessTypeChatPageLoadSuccessSrc17Evid1274Params>
 */
export function premiumCartBusinessTypeChatPageLoadSuccessSrc17Evid1274(params) {
    return { evid: 1274, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartBusinessChatPagePageInteractionSrc17Evid1275' event (evid: 1275)
 *
 * Event description: event is trigger for every page interaction from the user (CTA click / answer)
 *
 * @param {premiumCartBusinessChatPagePageInteractionSrc17Evid1275Params} params - The parameters for this event
 * @property {string} msid - msid
 * @property {string} domain - domain
 * @property {GUID} 'chat session guid' - chat session guid
 * @property {string} device - desktop / mobile
 * @property {string} 'view mode' - storefront / concierge
 * @property {string} 'current content shows' - last chat message shown
 * @property {string} 'cta type' - main cta / chat cta / user answer
 * @property {string} 'cta name' - cta name
 * @property {string} 'user answer' - user answer
 * @property {string} 'cart id' - cart id
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @return {LogObject<premiumCartBusinessChatPagePageInteractionSrc17Evid1275Params>} LogObject<premiumCartBusinessChatPagePageInteractionSrc17Evid1275Params>
 */
export function premiumCartBusinessChatPagePageInteractionSrc17Evid1275(params) {
    return { evid: 1275, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartBusinessTypeChatContentViewSrc17Evid1276' event (evid: 1276)
 *
 * Event description: event is triggered for evey new content load
 *
 * @param {premiumCartBusinessTypeChatContentViewSrc17Evid1276Params} params - The parameters for this event
 * @property {string} msid - msid
 * @property {string} domain - domain name
 * @property {string} device - desktop / mobile
 * @property {string} 'view mode' - concierge / storefornt
 * @property {GUID} 'chat session id' - chat session id
 * @property {string} 'cart id' - cart id
 * @property {string} content - message content
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @return {LogObject<premiumCartBusinessTypeChatContentViewSrc17Evid1276Params>} LogObject<premiumCartBusinessTypeChatContentViewSrc17Evid1276Params>
 */
export function premiumCartBusinessTypeChatContentViewSrc17Evid1276(params) {
    return { evid: 1276, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartLineItemRemoveLineItemModalLoadSrc17Evid1277' event (evid: 1277)
 *
 * Event description: Modal of remove from cart was shown after click "remove"
 *
 * @param {premiumCartLineItemRemoveLineItemModalLoadSrc17Evid1277Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} referralInfo - Where the cart was initiated from (mailbox floe etc.)
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid -  msid
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @return {LogObject<premiumCartLineItemRemoveLineItemModalLoadSrc17Evid1277Params>} LogObject<premiumCartLineItemRemoveLineItemModalLoadSrc17Evid1277Params>
 */
export function premiumCartLineItemRemoveLineItemModalLoadSrc17Evid1277(params) {
    return { evid: 1277, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartLineItemRemoveLineItemModalClickRemoveSrc17Evid1278' event (evid: 1278)
 *
 * Event description: Modal of remove from cart was shown after click "remove", and user clicked "remove"
 *
 * @param {premiumCartLineItemRemoveLineItemModalClickRemoveSrc17Evid1278Params} params - The parameters for this event
 * @property {string} lineItemId - line_item_id
 * @property {string} referralInfo - Where the cart was initiated from (mailbox floe etc.)
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid -  msid
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @return {LogObject<premiumCartLineItemRemoveLineItemModalClickRemoveSrc17Evid1278Params>} LogObject<premiumCartLineItemRemoveLineItemModalClickRemoveSrc17Evid1278Params>
 */
export function premiumCartLineItemRemoveLineItemModalClickRemoveSrc17Evid1278(params) {
    return { evid: 1278, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksEmptyStateStartLoadSrc17Evid1279' event (evid: 1279)
 *
 * Event description: QB has 4 entry points. its the start page load event
 *
 * @param {quickbooksEmptyStateStartLoadSrc17Evid1279Params} params - The parameters for this event
 * @property {string} emptyStateType - what entry point is it
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @return {LogObject<quickbooksEmptyStateStartLoadSrc17Evid1279Params>} LogObject<quickbooksEmptyStateStartLoadSrc17Evid1279Params>
 */
export function quickbooksEmptyStateStartLoadSrc17Evid1279(params) {
    return { evid: 1279, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksEmptyStateLoadEndSuccessSrc17Evid1280' event (evid: 1280)
 *
 * Event description: QB has 4 entry points. its the end page load event
 *
 * @param {quickbooksEmptyStateLoadEndSuccessSrc17Evid1280Params} params - The parameters for this event
 * @property {string} emptyStateType - what entry point is it
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @return {LogObject<quickbooksEmptyStateLoadEndSuccessSrc17Evid1280Params>} LogObject<quickbooksEmptyStateLoadEndSuccessSrc17Evid1280Params>
 */
export function quickbooksEmptyStateLoadEndSuccessSrc17Evid1280(params) {
    return { evid: 1280, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksEmptyStateLoadErrorSrc17Evid1281' event (evid: 1281)
 *
 * Event description: QB has 4 entry points. its the end page load event
 *
 * @param {quickbooksEmptyStateLoadErrorSrc17Evid1281Params} params - The parameters for this event
 * @property {string} emptyStateType - what entry point is it
 * @property {string} errorMessage - -
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @return {LogObject<quickbooksEmptyStateLoadErrorSrc17Evid1281Params>} LogObject<quickbooksEmptyStateLoadErrorSrc17Evid1281Params>
 */
export function quickbooksEmptyStateLoadErrorSrc17Evid1281(params) {
    return { evid: 1281, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksPackagePickerStartLoadSrc17Evid1282' event (evid: 1282)
 *
 * Event description:  QB Package picker  start load
 *
 * @param {quickbooksPackagePickerStartLoadSrc17Evid1282Params} params - The parameters for this event
 * @property {boolean} isSale - -
 * @property {number} salePercentage - -
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @property {string} saleType - -
 * @return {LogObject<quickbooksPackagePickerStartLoadSrc17Evid1282Params>} LogObject<quickbooksPackagePickerStartLoadSrc17Evid1282Params>
 */
export function quickbooksPackagePickerStartLoadSrc17Evid1282(params) {
    return { evid: 1282, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksPackagePickerLoadEndSuccessSrc17Evid1283' event (evid: 1283)
 *
 * Event description:  QB Package picker  start load
 *
 * @param {quickbooksPackagePickerLoadEndSuccessSrc17Evid1283Params} params - The parameters for this event
 * @property {boolean} isSale - -
 * @property {number} salePercentage - -
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @return {LogObject<quickbooksPackagePickerLoadEndSuccessSrc17Evid1283Params>} LogObject<quickbooksPackagePickerLoadEndSuccessSrc17Evid1283Params>
 */
export function quickbooksPackagePickerLoadEndSuccessSrc17Evid1283(params) {
    return { evid: 1283, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksPackagePickerLoadErrorSrc17Evid1284' event (evid: 1284)
 *
 * Event description:  QB Package picker  start load
 *
 * @param {quickbooksPackagePickerLoadErrorSrc17Evid1284Params} params - The parameters for this event
 * @property {boolean} isSale - -
 * @property {number} salePercentage - -
 * @property {string} errorMessage - -
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @return {LogObject<quickbooksPackagePickerLoadErrorSrc17Evid1284Params>} LogObject<quickbooksPackagePickerLoadErrorSrc17Evid1284Params>
 */
export function quickbooksPackagePickerLoadErrorSrc17Evid1284(params) {
    return { evid: 1284, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksUserInteractionSrc17Evid1285' event (evid: 1285)
 *
 * Event description: click inside Quickbooks pages (all pages) like clicks and hover
 *
 * @param {quickbooksUserInteractionSrc17Evid1285Params} params - The parameters for this event
 * @property {string} buttonName - select, compare plans, hover , contact us, term of use,privacy etc, (hover on feature name, for example “bookkeeping automation”, “invoice and payment”…
 * @property {string} actiontype - button_click,hover, link_click..)click/hover
 * @property {boolean} isSale - -
 * @property {number} salePercentage - -
 * @property {string} msid - -
 * @property {string} country_code - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} pageName - -
 * @property {string} origin - -
 * @property {string} identifier - -
 * @property {string} modalName - -
 * @property {string} productName - quickbooks package name
 * @return {LogObject<quickbooksUserInteractionSrc17Evid1285Params>} LogObject<quickbooksUserInteractionSrc17Evid1285Params>
 */
export function quickbooksUserInteractionSrc17Evid1285(params) {
    return { evid: 1285, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksCheckoutPageStartLoadSrc17Evid1286' event (evid: 1286)
 *
 * Event description:  QB Checkout page start load
 *
 * @param {quickbooksCheckoutPageStartLoadSrc17Evid1286Params} params - The parameters for this event
 * @property {boolean} isSale - -
 * @property {number} salePercentage - -
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @property {string} saleType - -
 * @property {string} packageId - -
 * @property {string} productFamily - -
 * @property {string} packageName - -
 * @return {LogObject<quickbooksCheckoutPageStartLoadSrc17Evid1286Params>} LogObject<quickbooksCheckoutPageStartLoadSrc17Evid1286Params>
 */
export function quickbooksCheckoutPageStartLoadSrc17Evid1286(params) {
    return { evid: 1286, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksCheckoutPageEndSuccessSrc17Evid1287' event (evid: 1287)
 *
 * Event description:  QB Checkout page load end successfully
 *
 * @param {quickbooksCheckoutPageEndSuccessSrc17Evid1287Params} params - The parameters for this event
 * @property {boolean} isSale - -
 * @property {number} salePercentage - -
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @return {LogObject<quickbooksCheckoutPageEndSuccessSrc17Evid1287Params>} LogObject<quickbooksCheckoutPageEndSuccessSrc17Evid1287Params>
 */
export function quickbooksCheckoutPageEndSuccessSrc17Evid1287(params) {
    return { evid: 1287, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksCheckoutPageLoadErrorSrc17Evid1288' event (evid: 1288)
 *
 * Event description:  QB Package picker   Load Error
 *
 * @param {quickbooksCheckoutPageLoadErrorSrc17Evid1288Params} params - The parameters for this event
 * @property {boolean} isSale - -
 * @property {number} salePercentage - -
 * @property {string} errorMessage - -
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @return {LogObject<quickbooksCheckoutPageLoadErrorSrc17Evid1288Params>} LogObject<quickbooksCheckoutPageLoadErrorSrc17Evid1288Params>
 */
export function quickbooksCheckoutPageLoadErrorSrc17Evid1288(params) {
    return { evid: 1288, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksSuccessPageStartLoadSrc17Evid1289' event (evid: 1289)
 *
 * Event description: when success page is loaded
 *
 * @param {quickbooksSuccessPageStartLoadSrc17Evid1289Params} params - The parameters for this event
 * @property {string} packageType - -
 * @property {number} packagePrice - -
 * @property {number} packagePriceAfterSale - -
 * @property {string} packageId - -
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @property {string} productFamily - -
 * @property {string} saleType - -
 * @property {boolean} isSale - -
 * @property {number} salePercentage - -
 * @return {LogObject<quickbooksSuccessPageStartLoadSrc17Evid1289Params>} LogObject<quickbooksSuccessPageStartLoadSrc17Evid1289Params>
 */
export function quickbooksSuccessPageStartLoadSrc17Evid1289(params) {
    return { evid: 1289, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rCancelPackageImmediateRequestSuccess' event (evid: 129)
 *
 * Event description: User request to cancel -  in trial period (14 days), right now
 *
 * @param {rCancelPackageImmediateRequestSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {string} abTest - ab_test
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} paymentCycle - cycle_id
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {number} cancelReason - cancel_reason
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} cancelTextReason - cancel_text_reason
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rCancelPackageImmediateRequestSuccessParams>} LogObject<rCancelPackageImmediateRequestSuccessParams>
 */
export function rCancelPackageImmediateRequestSuccess(params) {
    return { evid: 129, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksSuccessPageLoadEndSuccessSrc17Evid1290' event (evid: 1290)
 *
 * Event description: when success page is loaded successfully
 *
 * @param {quickbooksSuccessPageLoadEndSuccessSrc17Evid1290Params} params - The parameters for this event
 * @property {string} packageType - -
 * @property {number} packagePrice - -
 * @property {number} packagePriceAfterSale - -
 * @property {string} packageId - -
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @return {LogObject<quickbooksSuccessPageLoadEndSuccessSrc17Evid1290Params>} LogObject<quickbooksSuccessPageLoadEndSuccessSrc17Evid1290Params>
 */
export function quickbooksSuccessPageLoadEndSuccessSrc17Evid1290(params) {
    return { evid: 1290, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksSuccessPageLoadErrorSrc17Evid1291' event (evid: 1291)
 *
 * Event description: when success page is loaded  not successfully -  error bi event
 *
 * @param {quickbooksSuccessPageLoadErrorSrc17Evid1291Params} params - The parameters for this event
 * @property {string} packageType - -
 * @property {number} packagePrice - -
 * @property {number} packagePriceAfterSale - -
 * @property {string} packageId - -
 * @property {string} errorMessage - -
 * @property {string} msid - -
 * @property {string} city - -
 * @property {string} deviceType - -
 * @property {string} browserFamily - -
 * @property {string} country_code - -
 * @return {LogObject<quickbooksSuccessPageLoadErrorSrc17Evid1291Params>} LogObject<quickbooksSuccessPageLoadErrorSrc17Evid1291Params>
 */
export function quickbooksSuccessPageLoadErrorSrc17Evid1291(params) {
    return { evid: 1291, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartCartPageCartErrorSrc17Evid1292' event (evid: 1292)
 *
 * Event description: Error on CART PAGE
 *
 * @param {premiumCartCartPageCartErrorSrc17Evid1292Params} params - The parameters for this event
 * @property {GUID} cartId - cart id
 * @property {string} errorType - error_type
 * @property {string} errorMessage - error_message
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} msid - msid
 * @property {string} lineItems - list of line items
 * @return {LogObject<premiumCartCartPageCartErrorSrc17Evid1292Params>} LogObject<premiumCartCartPageCartErrorSrc17Evid1292Params>
 */
export function premiumCartCartPageCartErrorSrc17Evid1292(params) {
    return { evid: 1292, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickbooksErrorPageSrc17Evid1293' event (evid: 1293)
 *
 * Event description: when error page occurs during Quickbooks flows
 *
 * @param {quickbooksErrorPageSrc17Evid1293Params} params - The parameters for this event
 * @property {string} pageName - -
 * @property {string} errorMessage - -
 * @property {string} reason - -
 * @return {LogObject<quickbooksErrorPageSrc17Evid1293Params>} LogObject<quickbooksErrorPageSrc17Evid1293Params>
 */
export function quickbooksErrorPageSrc17Evid1293(params) {
    return { evid: 1293, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartRecommendationRecommendationViewSrc17Evid1294' event (evid: 1294)
 *
 * Event description: A recommendation of another product//tier was visible (some
 * recommendations are below the fold, need to scroll to get)
 *
 * @param {premiumCartRecommendationRecommendationViewSrc17Evid1294Params} params - The parameters for this event
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} recommendationId - identifier of the recommendation
 * @property {string} lineItems - list of line items
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} recommendationTitle - Title of the recommendation
 * @property {string} msid -  msid
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @return {LogObject<premiumCartRecommendationRecommendationViewSrc17Evid1294Params>} LogObject<premiumCartRecommendationRecommendationViewSrc17Evid1294Params>
 */
export function premiumCartRecommendationRecommendationViewSrc17Evid1294(params) {
    return { evid: 1294, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartRecommendationToggleOnOffSrc17Evid1295' event (evid: 1295)
 *
 * Event description: User clicked toggle (for example- of domain privacy) on or off
 *
 * @param {premiumCartRecommendationToggleOnOffSrc17Evid1295Params} params - The parameters for this event
 * @property {string} productType - Premium/Mailbox etc.
 * @property {string} productTypeId - Premium/Mailbox etc.
 * @property {string} productGuid - Specific product in the line item
 * @property {string} cycleName - cycle in the line item
 * @property {string} cartId - Identifier of the cart
 * @property {boolean} isSale - Is line item in sale
 * @property {number} totalSeats - amount of seats in the line item (relevant mostly for mailbox)
 * @property {string} recommendationId - identifier of the recommendation
 * @property {string} lineItems - list of line items
 * @property {string} productName - product_name
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} recommendationTitle - Title of the recommendation
 * @property {string} toggleValue - On/Off
 * @property {string} msid -  msid
 * @property {string} cycleDurationUnit - cycle_duration_unit
 * @property {number} cycleDurationCount - cycle_duration_count
 * @return {LogObject<premiumCartRecommendationToggleOnOffSrc17Evid1295Params>} LogObject<premiumCartRecommendationToggleOnOffSrc17Evid1295Params>
 */
export function premiumCartRecommendationToggleOnOffSrc17Evid1295(params) {
    return { evid: 1295, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCartBackButtonClickSrc17Evid1296' event (evid: 1296)
 *
 * Event description: User clicked back from CO or review page
 *
 * @param {premiumCartBackButtonClickSrc17Evid1296Params} params - The parameters for this event
 * @property {GUID} cartId - cart id
 * @property {string} cartFlowType - distinguish between different cart flows (domain upsell/domain bundle/domain + mailbox)
 * @property {string} fromStep - From CO/Review page
 * @property {string} toStep - To review page/cycle selection/split page
 * @property {string} msid - msid
 * @property {string} LineItems - array
 * @return {LogObject<premiumCartBackButtonClickSrc17Evid1296Params>} LogObject<premiumCartBackButtonClickSrc17Evid1296Params>
 */
export function premiumCartBackButtonClickSrc17Evid1296(params) {
    return { evid: 1296, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rUpdatePaymentMethodSuccess' event (evid: 13)
 *
 * Event description: R_UpdatePaymentMethodSuccess.
 *
 * @param {rUpdatePaymentMethodSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rUpdatePaymentMethodSuccessParams>} LogObject<rUpdatePaymentMethodSuccessParams>
 */
export function rUpdatePaymentMethodSuccess(params) {
    return { evid: 13, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rCancelPackageRenewRequestSuccess' event (evid: 130)
 *
 * Event description: User request to cancel -  at then end of the period (auto renew off)
 *
 * @param {rCancelPackageRenewRequestSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {string} abTest - ab_test
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} paymentCycle - cycle_id
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {number} cancelReason - cancel_reason
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} cancelTextReason - cancel_text_reason
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rCancelPackageRenewRequestSuccessParams>} LogObject<rCancelPackageRenewRequestSuccessParams>
 */
export function rCancelPackageRenewRequestSuccess(params) {
    return { evid: 130, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPremiumPurchaseShowPaymentConfirmation' event (evid: 1300)
 *
 * Event description: A_PremiumPurchaseShowPaymentConfirmation.
 *
 * @param {aPremiumPurchaseShowPaymentConfirmationParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPremiumPurchaseShowPaymentConfirmationParams>} LogObject<aPremiumPurchaseShowPaymentConfirmationParams>
 */
export function aPremiumPurchaseShowPaymentConfirmation(params) {
    return { evid: 1300, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPremiumPurchaseBackFromPaymentConfirmation' event (evid: 1301)
 *
 * Event description: A_PremiumPurchaseBackFromPaymentConfirmation.
 *
 * @param {aPremiumPurchaseBackFromPaymentConfirmationParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPremiumPurchaseBackFromPaymentConfirmationParams>} LogObject<aPremiumPurchaseBackFromPaymentConfirmationParams>
 */
export function aPremiumPurchaseBackFromPaymentConfirmation(params) {
    return { evid: 1301, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPremiumPurchaseChangePaymentMethod' event (evid: 1302)
 *
 * Event description: A_PremiumPurchaseChangePaymentMethod.
 *
 * @param {aPremiumPurchaseChangePaymentMethodParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPremiumPurchaseChangePaymentMethodParams>} LogObject<aPremiumPurchaseChangePaymentMethodParams>
 */
export function aPremiumPurchaseChangePaymentMethod(params) {
    return { evid: 1302, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchDomainCheckDomainAvailabilityServer' event (evid: 1307)
 *
 * Event description: Search domain availability result - BED event.
 * The event is parallel to 17:309 (only the availability, not the suggestions)
 *
 * @param {searchDomainCheckDomainAvailabilityServerParams} params - The parameters for this event
 * @property {string} uuid - uuid
 * @property {string} searchTerm - searched domain name
 * @property {string} result - domain status
 * @property {GUID} requestId - id of the specific request to server (should be the key to events such as 97:100 , 17:1308)
 * @property {GUID} appdefid - appDefId
 * @property {string} type - available, suggestions
 * @property {GUID} msid - msid
 * @property {string} referraladditionalinfo - referral
 * @property {GUID} check_msid - check_msid
 * @property {string} premium - domain is premium true/ false
 * @property {GUID} ident_target_account_id - ident_target_account_id
 * @property {GUID} meta_site_id - meta_site_id
 * @property {GUID} meta_site_id_check - meta_site_id_check
 * @property {GUID} sess_logged_account_id - sess_logged_account_id
 * @return {LogObject<searchDomainCheckDomainAvailabilityServerParams>} LogObject<searchDomainCheckDomainAvailabilityServerParams>
 */
export function searchDomainCheckDomainAvailabilityServer(params) {
    return { evid: 1307, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainSuggestions3rdPartyResults' event (evid: 1308)
 *
 * Event description: The event contains the raw suggestions of each provider before UI filtering
 *
 * @param {domainSuggestions3rdPartyResultsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} results - list of suggestions
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} origin - suggestions provider
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {string} requestId - requestid
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<domainSuggestions3rdPartyResultsParams>} LogObject<domainSuggestions3rdPartyResultsParams>
 */
export function domainSuggestions3rdPartyResults(params) {
    return { evid: 1308, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchDomainSearchResultViewServer' event (evid: 1309)
 *
 * Event description: Search domain results view - BED event.
 * The event is parallel to 17:309, with request_id.
 *
 * @param {searchDomainSearchResultViewServerParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {number} numOfSuggestions - number of presented suggestions
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} voucher - if the user has an available voucher - true/false
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {number} numOfLabels - number of labeled suggestions
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {string} searchTerm - searched domain name
 * @property {GUID} '37' - sku_id
 * @property {string} result - array of suggested domains/available/error message
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} results - array of suggested domains/available/error message
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {string} requestId - id of the specific request to server (should be the key to events such as 97:100 , 17:1308)
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} suggestionsList - complex json of the suggestions
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<searchDomainSearchResultViewServerParams>} LogObject<searchDomainSearchResultViewServerParams>
 */
export function searchDomainSearchResultViewServer(params) {
    return { evid: 1309, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumCancelPackage' event (evid: 131)
 *
 * Event description: Premium plan canceled
 *
 * @param {premiumCancelPackageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} paymentCycle - cycle_id
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {number} cancelReason - cancel_reason
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} cancelTextReason - cancel_text_reason
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<premiumCancelPackageParams>} LogObject<premiumCancelPackageParams>
 */
export function premiumCancelPackage(params) {
    return { evid: 131, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchaseShowPaymentConfirmation' event (evid: 1310)
 *
 * Event description: A_DomainPurchaseShowPaymentConfirmation.
 *
 * @param {aDomainPurchaseShowPaymentConfirmationParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchaseShowPaymentConfirmationParams>} LogObject<aDomainPurchaseShowPaymentConfirmationParams>
 */
export function aDomainPurchaseShowPaymentConfirmation(params) {
    return { evid: 1310, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchaseBackFromPaymentConfirmation' event (evid: 1311)
 *
 * Event description: A_DomainPurchaseBackFromPaymentConfirmation.
 *
 * @param {aDomainPurchaseBackFromPaymentConfirmationParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchaseBackFromPaymentConfirmationParams>} LogObject<aDomainPurchaseBackFromPaymentConfirmationParams>
 */
export function aDomainPurchaseBackFromPaymentConfirmation(params) {
    return { evid: 1311, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchaseChangePaymentMethod' event (evid: 1312)
 *
 * Event description: A_DomainPurchaseChangePaymentMethod.
 *
 * @param {aDomainPurchaseChangePaymentMethodParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchaseChangePaymentMethodParams>} LogObject<aDomainPurchaseChangePaymentMethodParams>
 */
export function aDomainPurchaseChangePaymentMethod(params) {
    return { evid: 1312, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartPremiumPurchaseSuccess' event (evid: 132)
 *
 * Event description: R_StartPremiumPurchaseSuccess.
 *
 * @param {rStartPremiumPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartPremiumPurchaseSuccessParams>} LogObject<rStartPremiumPurchaseSuccessParams>
 */
export function rStartPremiumPurchaseSuccess(params) {
    return { evid: 132, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vSepaPremiumPurchasePendingPayment' event (evid: 1320)
 *
 * Event description: V_SepaPremiumPurchasePendingPayment
 *
 * @param {vSepaPremiumPurchasePendingPaymentParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vSepaPremiumPurchasePendingPaymentParams>} LogObject<vSepaPremiumPurchasePendingPaymentParams>
 */
export function vSepaPremiumPurchasePendingPayment(params) {
    return { evid: 1320, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sepaShowHidePurchaseSummary' event (evid: 1322)
 *
 * Event description: V_SepaPremiumShowHidePurchaseSummary
 *
 * @param {sepaShowHidePurchaseSummaryParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - show/hide
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} productGuid - product_guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - cycle_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<sepaShowHidePurchaseSummaryParams>} LogObject<sepaShowHidePurchaseSummaryParams>
 */
export function sepaShowHidePurchaseSummary(params) {
    return { evid: 1322, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutSubmitViewPurchasePendingPaymentPage' event (evid: 1323)
 *
 * Event description: pending page after checkout submit in payment methods that cant show immediate success page, because it takes more than a few seconds to approve the transaction (bank transfers, validations, etc)
 *
 * @param {checkoutSubmitViewPurchasePendingPaymentPageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} billingAccountGuid - billing_account_guid
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - id of the payment method type, equivalent to billing_account_type	from sbs (10 - Sepa, etc)
 * @property {string} acceptLang - accept_lng
 * @property {number} invoiceId - invoice_id
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - Invoice status (only in new APMs using cashier, starting from PayPal)
 * @property {Url} referer - referral
 * @property {string} initiatorName - Checkout consumer or referral to checkout. It can be the product type/class (premium, domain, logo, etc) or the payment flow type (UPM, paynow, etc)
 * @property {string} productGuid - product_guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutSubmitViewPurchasePendingPaymentPageParams>} LogObject<checkoutSubmitViewPurchasePendingPaymentPageParams>
 */
export function checkoutSubmitViewPurchasePendingPaymentPage(params) {
    return { evid: 1323, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartPremiumPurchaseError' event (evid: 133)
 *
 * Event description: R_StartPremiumPurchaseError.
 *
 * @param {rStartPremiumPurchaseErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartPremiumPurchaseErrorParams>} LogObject<rStartPremiumPurchaseErrorParams>
 */
export function rStartPremiumPurchaseError(params) {
    return { evid: 133, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sepaShowPaymentConfirmation' event (evid: 1330)
 *
 * Event description: A_ShowPaymentConfirmation
 *
 * @param {sepaShowPaymentConfirmationParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<sepaShowPaymentConfirmationParams>} LogObject<sepaShowPaymentConfirmationParams>
 */
export function sepaShowPaymentConfirmation(params) {
    return { evid: 1330, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sepaBackFromPaymentConfirmation' event (evid: 1331)
 *
 * Event description: A_BackFromPaymentConfirmation
 *
 * @param {sepaBackFromPaymentConfirmationParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<sepaBackFromPaymentConfirmationParams>} LogObject<sepaBackFromPaymentConfirmationParams>
 */
export function sepaBackFromPaymentConfirmation(params) {
    return { evid: 1331, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageUseAnotherCard' event (evid: 1332)
 *
 * Event description: A_ChangeSavedPaymentMethod
 *
 * @param {checkOutPageUseAnotherCardParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<checkOutPageUseAnotherCardParams>} LogObject<checkOutPageUseAnotherCardParams>
 */
export function checkOutPageUseAnotherCard(params) {
    return { evid: 1332, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aOrderFormSubmitPurchaseClick' event (evid: 1333)
 *
 * Event description: Click on 'submit purchase' generate
 *
 * @param {aOrderFormSubmitPurchaseClickParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aOrderFormSubmitPurchaseClickParams>} LogObject<aOrderFormSubmitPurchaseClickParams>
 */
export function aOrderFormSubmitPurchaseClick(params) {
    return { evid: 1333, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageSelectPaymentMethod' event (evid: 1334)
 *
 * Event description: selected payment method in field payment_method - change tab when you have more than one option. A_OrderFormSelectPaymentMethod
 *
 * @param {checkoutPageSelectPaymentMethodParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<checkoutPageSelectPaymentMethodParams>} LogObject<checkoutPageSelectPaymentMethodParams>
 */
export function checkoutPageSelectPaymentMethod(params) {
    return { evid: 1334, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rOrderFormSavedPaymentMethodShown' event (evid: 1335)
 *
 * Event description: User have a saved payment method
 *
 * @param {rOrderFormSavedPaymentMethodShownParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rOrderFormSavedPaymentMethodShownParams>} LogObject<rOrderFormSavedPaymentMethodShownParams>
 */
export function rOrderFormSavedPaymentMethodShown(params) {
    return { evid: 1335, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rOrderFormSavedPaymentMethodNotShown' event (evid: 1336)
 *
 * Event description: User don’t have a saved payment method
 *
 * @param {rOrderFormSavedPaymentMethodNotShownParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rOrderFormSavedPaymentMethodNotShownParams>} LogObject<rOrderFormSavedPaymentMethodNotShownParams>
 */
export function rOrderFormSavedPaymentMethodNotShown(params) {
    return { evid: 1336, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageUseMySavedCard' event (evid: 1337)
 *
 * Event description: Check Out Page > Use 'My saved card'
 *
 * @param {checkOutPageUseMySavedCardParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkOutPageUseMySavedCardParams>} LogObject<checkOutPageUseMySavedCardParams>
 */
export function checkOutPageUseMySavedCard(params) {
    return { evid: 1337, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageSwitchSavedPaymentMethod' event (evid: 1338)
 *
 * Event description: Switch between payment methods in "Saved payment methods" tab. Can be between same or different types (CC to CC, CC to Paypal, etc).
 * Not including select payment method in "Other payment methods" tab.
 *
 * @param {checkoutPageSwitchSavedPaymentMethodParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} billingAccountGuid - The billing account identifier in SBS
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - id of the payment method type, equivalent to billing_account_type from sbs (10 - Sepa, etc)
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiatorName
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPageSwitchSavedPaymentMethodParams>} LogObject<checkoutPageSwitchSavedPaymentMethodParams>
 */
export function checkoutPageSwitchSavedPaymentMethod(params) {
    return { evid: 1338, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageHover' event (evid: 1339)
 *
 * Event description: Check Out Page> Hover
 *
 * @param {checkoutPageHoverParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} fieldValue - if its PII than no. of digits
 * @property {string} fieldName - the name
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPageHoverParams>} LogObject<checkoutPageHoverParams>
 */
export function checkoutPageHover(params) {
    return { evid: 1339, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartPremiumPurchaseException' event (evid: 134)
 *
 * Event description: R_StartPremiumPurchaseException.
 *
 * @param {rStartPremiumPurchaseExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartPremiumPurchaseExceptionParams>} LogObject<rStartPremiumPurchaseExceptionParams>
 */
export function rStartPremiumPurchaseException(params) {
    return { evid: 134, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payPalContinueWithPayPal' event (evid: 1340)
 *
 * Event description: After clicking submit (=Continue to PayPal), a small window opens simultaneously to the PayPal popup, showing the option to re-open the PayPal popup in case it's hidden or minimized.
 *
 * @param {payPalContinueWithPayPalParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiatorName
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<payPalContinueWithPayPalParams>} LogObject<payPalContinueWithPayPalParams>
 */
export function payPalContinueWithPayPal(params) {
    return { evid: 1340, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payPalGoBackToCheckoutPage' event (evid: 1341)
 *
 * Event description: Going back to the checkout page from PayPal window
 *
 * @param {payPalGoBackToCheckoutPageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - The referral to go back to checkout (closing popup wit X for example)
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiatorName
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<payPalGoBackToCheckoutPageParams>} LogObject<payPalGoBackToCheckoutPageParams>
 */
export function payPalGoBackToCheckoutPage(params) {
    return { evid: 1341, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPagePaymentMethodLoadingStart' event (evid: 1342)
 *
 * Event description: Payment Method Loading - Start event for test the loading time of Payment method on the checkout
 *
 * @param {checkoutPagePaymentMethodLoadingStartParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPagePaymentMethodLoadingStartParams>} LogObject<checkoutPagePaymentMethodLoadingStartParams>
 */
export function checkoutPagePaymentMethodLoadingStart(params) {
    return { evid: 1342, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPagePaymentMethodLoadingEnd' event (evid: 1343)
 *
 * Event description: Payment Method Loading - End , event for test the loading time of Payment method on the checkout
 *
 * @param {checkoutPagePaymentMethodLoadingEndParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPagePaymentMethodLoadingEndParams>} LogObject<checkoutPagePaymentMethodLoadingEndParams>
 */
export function checkoutPagePaymentMethodLoadingEnd(params) {
    return { evid: 1343, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageUpdateSummary' event (evid: 1344)
 *
 * Event description: Checkout Page >  update summary
 *
 * @param {checkoutPageUpdateSummaryParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {boolean} success - success
 * @property {string} errorInfo - error_info
 * @property {string} taxPercent - tax_precent
 * @property {string} externalSessionId - external_session_id
 * @property {string} state - state
 * @property {GUID} uuid - uuid
 * @property {string} errorKey - error_key
 * @property {string} acceptLang - accept_lng
 * @property {number} taxRate - rate
 * @property {string} zipCode - zip_code
 * @property {string} newPurchase - is_new_purchase
 * @property {number} amount - total amount
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} actionOrigin - action_origin
 * @property {string} errorCode - checkout_error_code
 * @property {GUID} packageGuid - package_id
 * @property {string} actionType - action_type
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPageUpdateSummaryParams>} LogObject<checkoutPageUpdateSummaryParams>
 */
export function checkoutPageUpdateSummary(params) {
    return { evid: 1344, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rRecurringPaymentFailureReceivedSuccess' event (evid: 135)
 *
 * Event description: 4501 replaced it, we can kill
 *
 * @param {rRecurringPaymentFailureReceivedSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rRecurringPaymentFailureReceivedSuccessParams>} LogObject<rRecurringPaymentFailureReceivedSuccessParams>
 */
export function rRecurringPaymentFailureReceivedSuccess(params) {
    return { evid: 135, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rRecurringPaymentFailureReceivedException' event (evid: 136)
 *
 * Event description: 4501 replaced it, we can kill
 *
 * @param {rRecurringPaymentFailureReceivedExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rRecurringPaymentFailureReceivedExceptionParams>} LogObject<rRecurringPaymentFailureReceivedExceptionParams>
 */
export function rRecurringPaymentFailureReceivedException(params) {
    return { evid: 136, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vPremiumPurchasePendingPayment' event (evid: 137)
 *
 * Event description: V_PremiumPurchasePendingPayment.
 *
 * @param {vPremiumPurchasePendingPaymentParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vPremiumPurchasePendingPaymentParams>} LogObject<vPremiumPurchasePendingPaymentParams>
 */
export function vPremiumPurchasePendingPayment(params) {
    return { evid: 137, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rUpdatePaymentMethodException' event (evid: 14)
 *
 * Event description: R_UpdatePaymentMethodException.
 *
 * @param {rUpdatePaymentMethodExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rUpdatePaymentMethodExceptionParams>} LogObject<rUpdatePaymentMethodExceptionParams>
 */
export function rUpdatePaymentMethodException(params) {
    return { evid: 14, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rChangeDomainGoogleAnalyticsSuccess' event (evid: 140)
 *
 * Event description: HTML sites moved to Editor 2.2.18
 *
 * @param {rChangeDomainGoogleAnalyticsSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rChangeDomainGoogleAnalyticsSuccessParams>} LogObject<rChangeDomainGoogleAnalyticsSuccessParams>
 */
export function rChangeDomainGoogleAnalyticsSuccess(params) {
    return { evid: 140, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPremiumPayPalClicked' event (evid: 1400)
 *
 * Event description: A_PremiumPayPalClicked.
 *
 * @param {aPremiumPayPalClickedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPremiumPayPalClickedParams>} LogObject<aPremiumPayPalClickedParams>
 */
export function aPremiumPayPalClicked(params) {
    return { evid: 1400, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPremiumThumbnailImageSuccess' event (evid: 1402)
 *
 * Event description: A_PremiumThumbnailImageSuccess.
 *
 * @param {aPremiumThumbnailImageSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPremiumThumbnailImageSuccessParams>} LogObject<aPremiumThumbnailImageSuccessParams>
 */
export function aPremiumThumbnailImageSuccess(params) {
    return { evid: 1402, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPremiumGiftImageSuccess' event (evid: 1403)
 *
 * Event description: A_PremiumGiftImageSuccess.
 *
 * @param {aPremiumGiftImageSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPremiumGiftImageSuccessParams>} LogObject<aPremiumGiftImageSuccessParams>
 */
export function aPremiumGiftImageSuccess(params) {
    return { evid: 1403, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPremiumTopBannerClicked' event (evid: 1404)
 *
 * Event description: A_PremiumTopBannerClicked.
 *
 * @param {aPremiumTopBannerClickedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPremiumTopBannerClickedParams>} LogObject<aPremiumTopBannerClickedParams>
 */
export function aPremiumTopBannerClicked(params) {
    return { evid: 1404, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsViewRemoveTeammatePopUp' event (evid: 14081)
 *
 * Event description: after users clicks on remove contributor, he reaches a pop up which shows the subscriptions are related to his payment methods.
 *
 * @param {rolesAndPermissionsViewRemoveTeammatePopUpParams} params - The parameters for this event
 * @property {GUID} teammateId - the user_id of the removed team/team member (if status is pending then invite_id)
 * @property {string} roleIds - role_id of the removed user
 * @property {string} billingAccountGuid - the replaced billing account guid
 * @property {string} serviceGuid - the associated service of the PM
 * @property {string} context - account/site
 * @property {string} roleId - role_id of the removed user
 * @return {LogObject<rolesAndPermissionsViewRemoveTeammatePopUpParams>} LogObject<rolesAndPermissionsViewRemoveTeammatePopUpParams>
 */
export function rolesAndPermissionsViewRemoveTeammatePopUp(params) {
    return { evid: 14081, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccess' event (evid: 14082)
 *
 * Event description: after update of the PM was processed successfully , user reaches update success page.
 *
 * @param {rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessParams} params - The parameters for this event
 * @property {GUID} teammateId - the user_id of the removed team/team member (if status is pending then invite_id)
 * @property {string} roleIds - role_id of the removed user
 * @property {string} billingAccountGuid - the new billing account guid
 * @property {string} serviceGuid - the associated service of the PM
 * @property {string} context - account/site
 * @property {string} roleId - role_id of the removed user
 * @return {LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessParams>} LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessParams>
 */
export function rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccess(params) {
    return { evid: 14082, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessClick' event (evid: 14083)
 *
 * Event description: after update of the PM was processed successfully , user reaches update success page and selects action
 *
 * @param {rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessClickParams} params - The parameters for this event
 * @property {GUID} teammateId - the user_id of the removed team/team member (if status is pending then invite_id)
 * @property {string} roleIds - role_id of the removed user
 * @property {string} billingAccountGuid - the new billing account guid
 * @property {string} serviceGuid - the associated service of the PM
 * @property {string} context - account/site
 * @property {string} clickType - keep/remove/close
 * @property {string} roleId - role_id of the removed user
 * @return {LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessClickParams>} LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessClickParams>
 */
export function rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessClick(params) {
    return { evid: 14083, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFail' event (evid: 14084)
 *
 * Event description: after update of the PM was failed, user reaches pop up
 *
 * @param {rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailParams} params - The parameters for this event
 * @property {GUID} teammateId - the user_id of the removed team/team member (if status is pending then invite_id)
 * @property {string} roleIds - role_id of the removed user
 * @property {string} billingAccountGuid - the replaced billing account guid
 * @property {string} serviceGuid - the associated service of the PM
 * @property {string} context - account/site
 * @property {string} inviteStatus - pending/expired/accepted/leave_team
 * @property {string} roleId - role_id of the removed user
 * @return {LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailParams>} LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailParams>
 */
export function rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFail(params) {
    return { evid: 14084, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailClick' event (evid: 14085)
 *
 * Event description: after update of the PM failed, user reaches update fail page and selects action
 *
 * @param {rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailClickParams} params - The parameters for this event
 * @property {GUID} teammateId - the user_id of the removed team/team member (if status is pending then invite_id)
 * @property {string} roleIds - role_id of the removed user
 * @property {string} billingAccountGuid - the replaced billing account guid
 * @property {string} serviceGuid - the associated service of the PM
 * @property {string} context - account/site
 * @property {string} clickType - keep/try/close/back
 * @property {string} roleId - role_id of the removed user
 * @return {LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailClickParams>} LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailClickParams>
 */
export function rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailClick(params) {
    return { evid: 14085, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rChangeDomainGoogleAnalyticsError' event (evid: 141)
 *
 * Event description: HTML sites moved to Editor 2.2.18
 *
 * @param {rChangeDomainGoogleAnalyticsErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rChangeDomainGoogleAnalyticsErrorParams>} LogObject<rChangeDomainGoogleAnalyticsErrorParams>
 */
export function rChangeDomainGoogleAnalyticsError(params) {
    return { evid: 141, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rChangeDomainGoogleAnalyticsException' event (evid: 142)
 *
 * Event description: HTML sites moved to Editor 2.2.18
 *
 * @param {rChangeDomainGoogleAnalyticsExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rChangeDomainGoogleAnalyticsExceptionParams>} LogObject<rChangeDomainGoogleAnalyticsExceptionParams>
 */
export function rChangeDomainGoogleAnalyticsException(params) {
    return { evid: 142, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'new351' event (evid: 147)
 *
 * Event description: plan purchase success page - client.  In case of re-assign domain PP, event 17:329 is triggered instead of 17:147.
 *
 * @param {new351Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {string} pageType - page_type
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<new351Params>} LogObject<new351Params>
 */
export function new351(params) {
    return { evid: 147, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelFlowPopUpSuggestionOfferedSrc17Evid148' event (evid: 148)
 *
 * Event description: Indicate what was offered to the user, based on the reason
 * (should be sent based on what actually was offered)
 *
 * @param {cancelFlowPopUpSuggestionOfferedSrc17Evid148Params} params - The parameters for this event
 * @property {string} referral - where the flow was initiated from
 * @property {string} referralAdditionalInfo - the reason the user chose
 * @property {string} cancelTextReason - the reason the user chose
 * @property {string} suggestion - the suggestion the user was offered, based on the cancelation reason
 * @property {string} subscriptionId - subscriptionId
 * @property {string} ctaName - the cta that is shown
 * @return {LogObject<cancelFlowPopUpSuggestionOfferedSrc17Evid148Params>} LogObject<cancelFlowPopUpSuggestionOfferedSrc17Evid148Params>
 */
export function cancelFlowPopUpSuggestionOfferedSrc17Evid148(params) {
    return { evid: 148, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planPurchaseViewSuccessPageSrc17Evid149' event (evid: 149)
 *
 * Event description: The user saw the new success page (as of Jan 22).
 * The success page with the dealer asset
 *
 * @param {planPurchaseViewSuccessPageSrc17Evid149Params} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - true/false
 * @property {string} externalSessionId - externalSessionId
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} domainName - domain name
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {boolean} bannerSale - is the banner from dealer includes sale
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} pageType - default success page / connect domain success page
 * @property {Url} referer - referral
 * @property {string} productGuid - product_id
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} bannerProducttype - which product the user saw in the success page banner (dealer campaign)
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<planPurchaseViewSuccessPageSrc17Evid149Params>} LogObject<planPurchaseViewSuccessPageSrc17Evid149Params>
 */
export function planPurchaseViewSuccessPageSrc17Evid149(params) {
    return { evid: 149, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'successPageClickedOnDealerBanner' event (evid: 1491)
 *
 * Event description: If the user clicked the dealer campaign banner in the success page
 *
 * @param {successPageClickedOnDealerBannerParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - true/false
 * @property {string} externalSessionId - externalSessionId
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} domainName - domain name
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {boolean} bannerSale - is the banner from dealer includes sale
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} pageType - default success page / connect domain success page
 * @property {Url} referer - referral
 * @property {string} productGuid - product_id
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} bannerProducttype - which product the user saw in the success page banner (dealer campaign)
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<successPageClickedOnDealerBannerParams>} LogObject<successPageClickedOnDealerBannerParams>
 */
export function successPageClickedOnDealerBanner(params) {
    return { evid: 1491, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainClickOnAssignToADifferentSite' event (evid: 15)
 *
 * Event description: My Subscriptions >  Click on "Assign to a different site".
 *
 * @param {domainClickOnAssignToADifferentSiteParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} subscriptionId - subscriptionId
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} paymentCycle - cycle_id
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} productTypeName - productTypeName
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {string} productTypeId - productTypeId
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {GUID} siteId - site_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - partners/diy
 * @property {string} isEditorxSiteExist - Is any of the sites editor x site (true/false)
 * @property {number} '29' - initiator
 * @property {string} productGuid - productGuid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<domainClickOnAssignToADifferentSiteParams>} LogObject<domainClickOnAssignToADifferentSiteParams>
 */
export function domainClickOnAssignToADifferentSite(params) {
    return { evid: 15, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelSeoProblemSeoTool' event (evid: 150)
 *
 * Event description: A_Cancel_SeoProblem_SeoTool.
 *
 * @param {aCancelSeoProblemSeoToolParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelSeoProblemSeoToolParams>} LogObject<aCancelSeoProblemSeoToolParams>
 */
export function aCancelSeoProblemSeoTool(params) {
    return { evid: 150, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMpDomainTabLoadSuccess' event (evid: 1500)
 *
 * Event description: V_MpDomainTabLoadSuccess.
 *
 * @param {vMpDomainTabLoadSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMpDomainTabLoadSuccessParams>} LogObject<vMpDomainTabLoadSuccessParams>
 */
export function vMpDomainTabLoadSuccess(params) {
    return { evid: 1500, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMpDomainTabLoadError' event (evid: 1501)
 *
 * Event description: V_MpDomainTabLoadError.
 *
 * @param {vMpDomainTabLoadErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMpDomainTabLoadErrorParams>} LogObject<vMpDomainTabLoadErrorParams>
 */
export function vMpDomainTabLoadError(params) {
    return { evid: 1501, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMpEmailTabLoadSuccess' event (evid: 1502)
 *
 * Event description: V_MpEmailTabLoadSuccess.
 *
 * @param {vMpEmailTabLoadSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMpEmailTabLoadSuccessParams>} LogObject<vMpEmailTabLoadSuccessParams>
 */
export function vMpEmailTabLoadSuccess(params) {
    return { evid: 1502, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMpEmailTabLoadError' event (evid: 1503)
 *
 * Event description: V_MpEmailTabLoadError.
 *
 * @param {vMpEmailTabLoadErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMpEmailTabLoadErrorParams>} LogObject<vMpEmailTabLoadErrorParams>
 */
export function vMpEmailTabLoadError(params) {
    return { evid: 1503, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMpPlanTabLoadSuccess' event (evid: 1504)
 *
 * Event description: V_MpPlanTabLoadSuccess.
 *
 * @param {vMpPlanTabLoadSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMpPlanTabLoadSuccessParams>} LogObject<vMpPlanTabLoadSuccessParams>
 */
export function vMpPlanTabLoadSuccess(params) {
    return { evid: 1504, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMpPlanTabLoadError' event (evid: 1505)
 *
 * Event description: V_MpPlanTabLoadError.
 *
 * @param {vMpPlanTabLoadErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMpPlanTabLoadErrorParams>} LogObject<vMpPlanTabLoadErrorParams>
 */
export function vMpPlanTabLoadError(params) {
    return { evid: 1505, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMpBillingPaymentsTabLoadSuccess' event (evid: 1506)
 *
 * Event description: V_MpBillingPaymentsTabLoadSuccess.
 *
 * @param {vMpBillingPaymentsTabLoadSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMpBillingPaymentsTabLoadSuccessParams>} LogObject<vMpBillingPaymentsTabLoadSuccessParams>
 */
export function vMpBillingPaymentsTabLoadSuccess(params) {
    return { evid: 1506, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMpBillingPaymentsTabLoadError' event (evid: 1507)
 *
 * Event description: V_MpBillingPaymentsTabLoadError.
 *
 * @param {vMpBillingPaymentsTabLoadErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMpBillingPaymentsTabLoadErrorParams>} LogObject<vMpBillingPaymentsTabLoadErrorParams>
 */
export function vMpBillingPaymentsTabLoadError(params) {
    return { evid: 1507, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelLiveChat' event (evid: 151)
 *
 * Event description: A_Cancel_LiveChat.
 *
 * @param {aCancelLiveChatParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelLiveChatParams>} LogObject<aCancelLiveChatParams>
 */
export function aCancelLiveChat(params) {
    return { evid: 151, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aSearchDomainValid' event (evid: 1510)
 *
 * Event description: Client - A_SearchDomainValid
 *
 * @param {aSearchDomainValidParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aSearchDomainValidParams>} LogObject<aSearchDomainValidParams>
 */
export function aSearchDomainValid(params) {
    return { evid: 1510, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aSearchDomainNotValid' event (evid: 1511)
 *
 * Event description: Client - A_SearchDomainNotValid
 *
 * @param {aSearchDomainNotValidParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aSearchDomainNotValidParams>} LogObject<aSearchDomainNotValidParams>
 */
export function aSearchDomainNotValid(params) {
    return { evid: 1511, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vSearchDomainLoaded' event (evid: 1512)
 *
 * Event description: Client - V_SearchDomainLoaded (view domain search page)
 *
 * @param {vSearchDomainLoadedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - true | false
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} screenResolution - screen_resolution
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} referral - referral
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - where a user came from
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - where a user came from
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vSearchDomainLoadedParams>} LogObject<vSearchDomainLoadedParams>
 */
export function vSearchDomainLoaded(params) {
    return { evid: 1512, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchDomainClickGetItSrc17Evid1513' event (evid: 1513)
 *
 * Event description: the user clicked on get-it
 *
 * @param {searchDomainClickGetItSrc17Evid1513Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - clickType (offers - user clicked on suggestions, search - that domain was available and the user clicked on it)
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain name (not formatted)
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} clickType - click_type
 * @property {string} '10' - domain position
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} referral - referral
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain name (not formatted)
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<searchDomainClickGetItSrc17Evid1513Params>} LogObject<searchDomainClickGetItSrc17Evid1513Params>
 */
export function searchDomainClickGetItSrc17Evid1513(params) {
    return { evid: 1513, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchDomainSearchResultViewSrc17Evid1514' event (evid: 1514)
 *
 * Event description: V_DomainSearchResultView
 *
 * @param {searchDomainSearchResultViewSrc17Evid1514Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - search response time (client)
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22'
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - available domain or not
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - array of suggested domains
 * @property {string} '14'
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - searched domain (not formatted)
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<searchDomainSearchResultViewSrc17Evid1514Params>} LogObject<searchDomainSearchResultViewSrc17Evid1514Params>
 */
export function searchDomainSearchResultViewSrc17Evid1514(params) {
    return { evid: 1514, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'voucherPageGetYourDomainCta' event (evid: 1515)
 *
 * Event description: voucher page > Get Your Domain CTA
 *
 * @param {voucherPageGetYourDomainCtaParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} text - get your domain
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @return {LogObject<voucherPageGetYourDomainCtaParams>} LogObject<voucherPageGetYourDomainCtaParams>
 */
export function voucherPageGetYourDomainCta(params) {
    return { evid: 1515, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelUnableToCompleteSiteBuildYourSite' event (evid: 152)
 *
 * Event description: A_Cancel_UnableToCompleteSite_BuildYourSite.
 *
 * @param {aCancelUnableToCompleteSiteBuildYourSiteParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelUnableToCompleteSiteBuildYourSiteParams>} LogObject<aCancelUnableToCompleteSiteBuildYourSiteParams>
 */
export function aCancelUnableToCompleteSiteBuildYourSite(params) {
    return { evid: 152, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelUnableToCompleteSiteLiveChat' event (evid: 153)
 *
 * Event description: A_Cancel_UnableToCompleteSite_LiveChat.
 *
 * @param {aCancelUnableToCompleteSiteLiveChatParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelUnableToCompleteSiteLiveChatParams>} LogObject<aCancelUnableToCompleteSiteLiveChatParams>
 */
export function aCancelUnableToCompleteSiteLiveChat(params) {
    return { evid: 153, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelFlowPopUpSuggestionCtaClickSrc17Evid154' event (evid: 154)
 *
 * Event description: indicate if the users clicked on any suggestions' cta
 *
 * @param {cancelFlowPopUpSuggestionCtaClickSrc17Evid154Params} params - The parameters for this event
 * @property {string} referral - where the flow was initiated from
 * @property {string} referralAdditionalInfo - the reason the user chose
 * @property {string} cancelTextReason - the reason the user chose
 * @property {string} suggestion - the suggestion the user was offered, based on the cancelation reason
 * @property {string} subscriptionId - subscriptionId
 * @property {string} ctaName - cta_name clicked
 * @return {LogObject<cancelFlowPopUpSuggestionCtaClickSrc17Evid154Params>} LogObject<cancelFlowPopUpSuggestionCtaClickSrc17Evid154Params>
 */
export function cancelFlowPopUpSuggestionCtaClickSrc17Evid154(params) {
    return { evid: 154, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelECommerceLiveChat' event (evid: 155)
 *
 * Event description: A_Cancel_eCommerce_LiveChat.
 *
 * @param {aCancelECommerceLiveChatParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelECommerceLiveChatParams>} LogObject<aCancelECommerceLiveChatParams>
 */
export function aCancelECommerceLiveChat(params) {
    return { evid: 155, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelSwitchSiteManagePremium' event (evid: 156)
 *
 * Event description: A_Cancel_SwitchSite_ManagePremium.
 *
 * @param {aCancelSwitchSiteManagePremiumParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelSwitchSiteManagePremiumParams>} LogObject<aCancelSwitchSiteManagePremiumParams>
 */
export function aCancelSwitchSiteManagePremium(params) {
    return { evid: 156, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelSwitchSitePurchaseDomain' event (evid: 157)
 *
 * Event description: A_Cancel_SwitchSite_PurchaseDomain.
 *
 * @param {aCancelSwitchSitePurchaseDomainParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelSwitchSitePurchaseDomainParams>} LogObject<aCancelSwitchSitePurchaseDomainParams>
 */
export function aCancelSwitchSitePurchaseDomain(params) {
    return { evid: 157, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelSwitchSiteAttachDomain' event (evid: 158)
 *
 * Event description: A_Cancel_SwitchSite_AttachDomain.
 *
 * @param {aCancelSwitchSiteAttachDomainParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelSwitchSiteAttachDomainParams>} LogObject<aCancelSwitchSiteAttachDomainParams>
 */
export function aCancelSwitchSiteAttachDomain(params) {
    return { evid: 158, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelMissingFunctionalityLiveChat' event (evid: 159)
 *
 * Event description: A_Cancel_MissingFunctionality_LiveChat.
 *
 * @param {aCancelMissingFunctionalityLiveChatParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelMissingFunctionalityLiveChatParams>} LogObject<aCancelMissingFunctionalityLiveChatParams>
 */
export function aCancelMissingFunctionalityLiveChat(params) {
    return { evid: 159, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTransferOrAssignErrorNoDoc' event (evid: 16)
 *
 * Event description: R_TransferOrAssignErrorNoDoc.
 *
 * @param {rTransferOrAssignErrorNoDocParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTransferOrAssignErrorNoDocParams>} LogObject<rTransferOrAssignErrorNoDocParams>
 */
export function rTransferOrAssignErrorNoDoc(params) {
    return { evid: 16, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelMissingFunctionalityMyAccountBlog' event (evid: 160)
 *
 * Event description: A_Cancel_MissingFunctionality_MyAccountBlog.
 *
 * @param {aCancelMissingFunctionalityMyAccountBlogParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelMissingFunctionalityMyAccountBlogParams>} LogObject<aCancelMissingFunctionalityMyAccountBlogParams>
 */
export function aCancelMissingFunctionalityMyAccountBlog(params) {
    return { evid: 160, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnViewSingleInvoice' event (evid: 1600)
 *
 * Event description: client
 *
 * @param {aClickOnViewSingleInvoiceParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {string} selectionType - 'invoice_row'/ 'edit invoice toast'
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} invoiceId - invoice_id
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {GUID} sessionId - session_id
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {GUID} siteId - site_id
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnViewSingleInvoiceParams>} LogObject<aClickOnViewSingleInvoiceParams>
 */
export function aClickOnViewSingleInvoice(params) {
    return { evid: 1600, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelPlanPopupClickOnBack' event (evid: 1601)
 *
 * Event description: A_CancelPlanPopupClickOnBack
 *
 * @param {aCancelPlanPopupClickOnBackParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelPlanPopupClickOnBackParams>} LogObject<aCancelPlanPopupClickOnBackParams>
 */
export function aCancelPlanPopupClickOnBack(params) {
    return { evid: 1601, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaPopupKeepAutoRenew' event (evid: 1602)
 *
 * Event description: A_TpaPopupKeepAutoRenew.
 *
 * @param {aTpaPopupKeepAutoRenewParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaPopupKeepAutoRenewParams>} LogObject<aTpaPopupKeepAutoRenewParams>
 */
export function aTpaPopupKeepAutoRenew(params) {
    return { evid: 1602, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaPopupClickOnProviderName' event (evid: 1603)
 *
 * Event description: A_TpaPopupClickOnProviderName.
 *
 * @param {aTpaPopupClickOnProviderNameParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaPopupClickOnProviderNameParams>} LogObject<aTpaPopupClickOnProviderNameParams>
 */
export function aTpaPopupClickOnProviderName(params) {
    return { evid: 1603, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaPopupClickOnSupportLink' event (evid: 1604)
 *
 * Event description: A_TpaPopupClickOnSupportLink.
 *
 * @param {aTpaPopupClickOnSupportLinkParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaPopupClickOnSupportLinkParams>} LogObject<aTpaPopupClickOnSupportLinkParams>
 */
export function aTpaPopupClickOnSupportLink(params) {
    return { evid: 1604, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPopupKeepAutoRenew' event (evid: 1605)
 *
 * Event description: A_DomainPopupKeepAutoRenew.
 *
 * @param {aDomainPopupKeepAutoRenewParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPopupKeepAutoRenewParams>} LogObject<aDomainPopupKeepAutoRenewParams>
 */
export function aDomainPopupKeepAutoRenew(params) {
    return { evid: 1605, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMailboxPopupKeepAutoRenew' event (evid: 1606)
 *
 * Event description: A_MailboxPopupKeepAutoRenew.
 *
 * @param {aMailboxPopupKeepAutoRenewParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMailboxPopupKeepAutoRenewParams>} LogObject<aMailboxPopupKeepAutoRenewParams>
 */
export function aMailboxPopupKeepAutoRenew(params) {
    return { evid: 1606, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMailboxPopupClickOnSupportLink' event (evid: 1607)
 *
 * Event description: A_MailboxPopupClickOnSupportLink.
 *
 * @param {aMailboxPopupClickOnSupportLinkParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMailboxPopupClickOnSupportLinkParams>} LogObject<aMailboxPopupClickOnSupportLinkParams>
 */
export function aMailboxPopupClickOnSupportLink(params) {
    return { evid: 1607, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPopupClickOnSupportLink' event (evid: 1608)
 *
 * Event description: A_DomainPopupClickOnSupportLink.
 *
 * @param {aDomainPopupClickOnSupportLinkParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPopupClickOnSupportLinkParams>} LogObject<aDomainPopupClickOnSupportLinkParams>
 */
export function aDomainPopupClickOnSupportLink(params) {
    return { evid: 1608, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelPlanPopupMoveToSecondPage' event (evid: 1609)
 *
 * Event description: in the pop up - user choos "cancel now"
 *
 * @param {aCancelPlanPopupMoveToSecondPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} subscriptionId - subscriptionId
 * @return {LogObject<aCancelPlanPopupMoveToSecondPageParams>} LogObject<aCancelPlanPopupMoveToSecondPageParams>
 */
export function aCancelPlanPopupMoveToSecondPage(params) {
    return { evid: 1609, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelMissingFunctionalityMyAccountMobile' event (evid: 161)
 *
 * Event description: A_Cancel_MissingFunctionality_MyAccountMobile.
 *
 * @param {aCancelMissingFunctionalityMyAccountMobileParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelMissingFunctionalityMyAccountMobileParams>} LogObject<aCancelMissingFunctionalityMyAccountMobileParams>
 */
export function aCancelMissingFunctionalityMyAccountMobile(params) {
    return { evid: 161, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnNextPaymentDlg' event (evid: 1610)
 *
 * Event description: A_ClickOnNextPaymentDlg.
 *
 * @param {aClickOnNextPaymentDlgParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnNextPaymentDlgParams>} LogObject<aClickOnNextPaymentDlgParams>
 */
export function aClickOnNextPaymentDlg(params) {
    return { evid: 1610, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainClickOnCancel' event (evid: 1611)
 *
 * Event description: A_DomainClickOnCancel.
 *
 * @param {aDomainClickOnCancelParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainClickOnCancelParams>} LogObject<aDomainClickOnCancelParams>
 */
export function aDomainClickOnCancel(params) {
    return { evid: 1611, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMailClickOnCancelSrc17Evid1612' event (evid: 1612)
 *
 * Event description: client
 *
 * @param {aMailClickOnCancelSrc17Evid1612Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} emailSkuId - email_sku_id
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {boolean} isIncudingVoice - true if has active voice that will be cancelled
 * @property {string} isIncludingGemini - true if has active geminin that will be cancelled
 * @property {string} subscriptionsList - all subscription guids that will be cancelled (gws and add-ons)
 * @property {string} action - view of the modal or click on one of the CTAs
 * @property {GUID} GeminiProductId - gemini_product_id
 * @property {GUID} VoiceProductId - voice_product_id
 * @return {LogObject<aMailClickOnCancelSrc17Evid1612Params>} LogObject<aMailClickOnCancelSrc17Evid1612Params>
 */
export function aMailClickOnCancelSrc17Evid1612(params) {
    return { evid: 1612, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPlanClickTurnAutoRenewOff' event (evid: 1613)
 *
 * Event description: Click on "Turn Auto Renew Of" Premium Plan page
 *
 * @param {aPlanClickTurnAutoRenewOffParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPlanClickTurnAutoRenewOffParams>} LogObject<aPlanClickTurnAutoRenewOffParams>
 */
export function aPlanClickTurnAutoRenewOff(params) {
    return { evid: 1613, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPlanRenewalPopupClickOnTurnOff' event (evid: 1614)
 *
 * Event description: In "Turn Auto Renew Of"  popup - click on ""Turn Auto Renew Of"
 *
 * @param {aPlanRenewalPopupClickOnTurnOffParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPlanRenewalPopupClickOnTurnOffParams>} LogObject<aPlanRenewalPopupClickOnTurnOffParams>
 */
export function aPlanRenewalPopupClickOnTurnOff(params) {
    return { evid: 1614, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPlanRenewalPopupClickOnCancel' event (evid: 1615)
 *
 * Event description: In "Turn Auto Renew Of"  popup - click on "Cancel"
 *
 * @param {aPlanRenewalPopupClickOnCancelParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPlanRenewalPopupClickOnCancelParams>} LogObject<aPlanRenewalPopupClickOnCancelParams>
 */
export function aPlanRenewalPopupClickOnCancel(params) {
    return { evid: 1615, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelOtherHtmlmobileMyAccount' event (evid: 162)
 *
 * Event description: A_Cancel_Other_HTMLMobile_MyAccount.
 *
 * @param {aCancelOtherHtmlmobileMyAccountParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelOtherHtmlmobileMyAccountParams>} LogObject<aCancelOtherHtmlmobileMyAccountParams>
 */
export function aCancelOtherHtmlmobileMyAccount(params) {
    return { evid: 162, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editInvoiceWarningMessage' event (evid: 1622)
 *
 * Event description: edit invoice -> warning message
 *
 * @param {editInvoiceWarningMessageParams} params - The parameters for this event
 * @property {string} viewMode - Billing History Page, My Subscriptions Page, Site level - Subscription Page
 * @property {GUID} serviceGuid - service_guid
 * @property {string} externalSessionId - externalSessionId
 * @property {string} errorMessage - cant apply vat , cant apply postal code
 * @property {string} domain - domain
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} invoiceId - invoice_id
 * @property {GUID} sessionId - session_id
 * @property {string} productName - product_name
 * @property {GUID} productId - product_guid
 * @property {string} subscriptionType - Premium Plan/ Ascend ...
 * @property {number} cycleId - cycle_id
 * @property {string} product - product_name_on_screen
 * @return {LogObject<editInvoiceWarningMessageParams>} LogObject<editInvoiceWarningMessageParams>
 */
export function editInvoiceWarningMessage(params) {
    return { evid: 1622, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editInvoiceClick' event (evid: 1623)
 *
 * Event description: edit invoice click
 *
 * @param {editInvoiceClickParams} params - The parameters for this event
 * @property {string} viewMode - Billing History Page, My Subscriptions Page, Site level - Subscription Page
 * @property {GUID} serviceGuid - service_guid
 * @property {string} externalSessionId - externalSessionId
 * @property {string} futureUpdatedFields - Fields to be updated in future invoices
 * @property {string} domain - domain
 * @property {boolean} applyToAllOtherServices - true/false
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - save, cancel, close
 * @property {string} invoiceId - invoice_id
 * @property {string} fieldsUpdated - fields_updated
 * @property {string} subscriptionsEffected - subscriptions_effected
 * @property {GUID} sessionId - session_id
 * @property {string} productName - product_name
 * @property {GUID} productId - product_guid
 * @property {boolean} applyToAllOtherInvoices - true/false
 * @property {string} subscriptionType - Premium Plan/ Ascend ...
 * @property {number} cycleId - cycle_id
 * @property {string} product - product_name_on_screen
 * @return {LogObject<editInvoiceClickParams>} LogObject<editInvoiceClickParams>
 */
export function editInvoiceClick(params) {
    return { evid: 1623, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'invoiceUpdateSuccessMessage' event (evid: 1624)
 *
 * Event description: invoice update success message
 *
 * @param {invoiceUpdateSuccessMessageParams} params - The parameters for this event
 * @property {GUID} newBillingAccountGuidCurrentInvoice - new_billing_account_for_invoice
 * @property {GUID} newBillingAccountGuidForServices - new_billing_account_for_services
 * @property {string} viewMode - Billing History Page, My Subscriptions Page, Site level - Subscription Page
 * @property {GUID} serviceGuid - service_guid
 * @property {string} domain - domain
 * @property {boolean} isBulk - Is_bulk
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} invoiceId - invoice_id
 * @property {GUID} originalPaymentSourceId - old_billing_account_guid
 * @property {boolean} isUpdatedLastInvoice - true/false
 * @property {GUID} newPaymentSourceIdCurrentInvoice - new_billing_account_for_invoice
 * @property {string} fieldsUpdated - fields_updated
 * @property {string} servicesInvoicesList - services_invoices_list
 * @property {GUID} sessionId - session_id
 * @property {string} productName - product_name
 * @property {GUID} productId - product_guid
 * @property {string} subscriptionType - Premium Plan/ Ascend ...
 * @property {GUID} newPaymentSourceIdForServices - new_billing_account_for_services
 * @property {number} cycleId - cycle_id
 * @return {LogObject<invoiceUpdateSuccessMessageParams>} LogObject<invoiceUpdateSuccessMessageParams>
 */
export function invoiceUpdateSuccessMessage(params) {
    return { evid: 1624, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editInvoiceClickSaveError' event (evid: 1625)
 *
 * Event description: Invoice update error message
 *
 * @param {editInvoiceClickSaveErrorParams} params - The parameters for this event
 * @property {GUID} newBillingAccountGuidCurrentInvoice - new_billing_account_for_invoice
 * @property {GUID} newBillingAccountGuidForServices - new_billing_account_for_services
 * @property {string} viewMode - Billing History Page, My Subscriptions Page, Site level - Subscription Page
 * @property {GUID} serviceGuid - service_guid
 * @property {string} errorInfo - error
 * @property {string} externalSessionId - external_session_id
 * @property {string} domain - domain
 * @property {boolean} isBulk - Is_bulk
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} invoiceId - invoice_id
 * @property {GUID} originalPaymentSourceId - old_billing_account_guid
 * @property {boolean} isUpdatedLastInvoice - true/false
 * @property {GUID} newPaymentSourceIdCurrentInvoice - new_billing_account_for_invoice
 * @property {string} fieldsUpdated - fields_updated
 * @property {string} servicesInvoicesList - services_invoices_list
 * @property {string} invalidFields - Invalid fields
 * @property {GUID} sessionId - session_id
 * @property {string} productName - product_name
 * @property {GUID} productId - product_guid
 * @property {string} subscriptionType - Premium Plan/ Ascend ...
 * @property {GUID} newPaymentSourceIdForServices - new_billing_account_for_services
 * @property {number} cycleId - cycle_id
 * @property {string} product - I hate this field
 * @return {LogObject<editInvoiceClickSaveErrorParams>} LogObject<editInvoiceClickSaveErrorParams>
 */
export function editInvoiceClickSaveError(params) {
    return { evid: 1625, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelOtherApplyPremiumDifferentSiteManagePremium' event (evid: 163)
 *
 * Event description: A_Cancel_Other_ApplyPremiumDifferentSite_ManagePremium.
 *
 * @param {aCancelOtherApplyPremiumDifferentSiteManagePremiumParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelOtherApplyPremiumDifferentSiteManagePremiumParams>} LogObject<aCancelOtherApplyPremiumDifferentSiteManagePremiumParams>
 */
export function aCancelOtherApplyPremiumDifferentSiteManagePremium(params) {
    return { evid: 163, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ilInvoicePendingElectronicSignatureMessage' event (evid: 1630)
 *
 * Event description: A message that Israeli users receive when they click on view invoice, and the invoice is still pending an electronic signature
 *
 * @param {ilInvoicePendingElectronicSignatureMessageParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - where did the user arrive from
 * @property {string} billingInvoiceId - invoice
 * @return {LogObject<ilInvoicePendingElectronicSignatureMessageParams>} LogObject<ilInvoicePendingElectronicSignatureMessageParams>
 */
export function ilInvoicePendingElectronicSignatureMessage(params) {
    return { evid: 1630, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ilInvoicePendingElectronicSignatureMessageClickGoToBillingHistory' event (evid: 1631)
 *
 * Event description: The user clicks on go to billing history CTA from the message that his invoice is still pending an electronic signature
 *
 * @param {ilInvoicePendingElectronicSignatureMessageClickGoToBillingHistoryParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - where did the user arrive from
 * @property {string} billingInvoiceId - billingInvoiceId
 * @return {LogObject<ilInvoicePendingElectronicSignatureMessageClickGoToBillingHistoryParams>} LogObject<ilInvoicePendingElectronicSignatureMessageClickGoToBillingHistoryParams>
 */
export function ilInvoicePendingElectronicSignatureMessageClickGoToBillingHistory(params) {
    return { evid: 1631, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelOtherChangeDomainBuyDomain' event (evid: 164)
 *
 * Event description: A_Cancel_Other_ChangeDomain_BuyDomain.
 *
 * @param {aCancelOtherChangeDomainBuyDomainParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelOtherChangeDomainBuyDomainParams>} LogObject<aCancelOtherChangeDomainBuyDomainParams>
 */
export function aCancelOtherChangeDomainBuyDomain(params) {
    return { evid: 164, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelOtherChangeDomainAttachExistingDomain' event (evid: 165)
 *
 * Event description: A_Cancel_Other_ChangeDomain_AttachExistingDomain.
 *
 * @param {aCancelOtherChangeDomainAttachExistingDomainParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelOtherChangeDomainAttachExistingDomainParams>} LogObject<aCancelOtherChangeDomainAttachExistingDomainParams>
 */
export function aCancelOtherChangeDomainAttachExistingDomain(params) {
    return { evid: 165, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelDomainProblemsLiveChat' event (evid: 166)
 *
 * Event description: A_Cancel_DomainProblems_LiveChat.
 *
 * @param {aCancelDomainProblemsLiveChatParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelDomainProblemsLiveChatParams>} LogObject<aCancelDomainProblemsLiveChatParams>
 */
export function aCancelDomainProblemsLiveChat(params) {
    return { evid: 166, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelSeoProblemLiveChat' event (evid: 167)
 *
 * Event description: A_Cancel_SeoProblem_LiveChat.
 *
 * @param {aCancelSeoProblemLiveChatParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelSeoProblemLiveChatParams>} LogObject<aCancelSeoProblemLiveChatParams>
 */
export function aCancelSeoProblemLiveChat(params) {
    return { evid: 167, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTransferOrAssignException' event (evid: 17)
 *
 * Event description: R_TransferOrAssignException.
 *
 * @param {rTransferOrAssignExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTransferOrAssignExceptionParams>} LogObject<rTransferOrAssignExceptionParams>
 */
export function rTransferOrAssignException(params) {
    return { evid: 17, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rBvSelectionFromCookie' event (evid: 170)
 *
 * Event description: R_BvSelectionFromCookie.
 *
 * @param {rBvSelectionFromCookieParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rBvSelectionFromCookieParams>} LogObject<rBvSelectionFromCookieParams>
 */
export function rBvSelectionFromCookie(params) {
    return { evid: 170, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainNotificationsConnectDomain' event (evid: 1701)
 *
 * Event description: We trigger this event when we send push to Ping
 *
 * @param {domainNotificationsConnectDomainParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {GUID} uuid - uuid
 * @property {boolean} wixdomain - true | false
 * @property {boolean} isPublished - true | false
 * @property {string} templateId - templateId
 * @property {string} domainStatus - verification, propagation, connected, error
 * @property {GUID} msid - msid
 * @return {LogObject<domainNotificationsConnectDomainParams>} LogObject<domainNotificationsConnectDomainParams>
 */
export function domainNotificationsConnectDomain(params) {
    return { evid: 1701, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainNotificationsConnectDomainAbTestExposure' event (evid: 1702)
 *
 * Event description: We trigger this event when a domain pass check for a notification
 *
 * @param {domainNotificationsConnectDomainAbTestExposureParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {GUID} uuid - uuid
 * @property {string} domainStatus - verification, propagation, connected, error
 * @return {LogObject<domainNotificationsConnectDomainAbTestExposureParams>} LogObject<domainNotificationsConnectDomainAbTestExposureParams>
 */
export function domainNotificationsConnectDomainAbTestExposure(params) {
    return { evid: 1702, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelChangingPlanDowngrade' event (evid: 171)
 *
 * Event description: A_Cancel_ChangingPlan_Downgrade.
 *
 * @param {aCancelChangingPlanDowngradeParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelChangingPlanDowngradeParams>} LogObject<aCancelChangingPlanDowngradeParams>
 */
export function aCancelChangingPlanDowngrade(params) {
    return { evid: 171, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelUseadifferentWebAddress' event (evid: 172)
 *
 * Event description: A_Cancel_UseADifferentWebAddress.
 *
 * @param {aCancelUseadifferentWebAddressParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelUseadifferentWebAddressParams>} LogObject<aCancelUseadifferentWebAddressParams>
 */
export function aCancelUseadifferentWebAddress(params) {
    return { evid: 172, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCancelBannerToArena' event (evid: 173)
 *
 * Event description: A_Cancel_BannerToArena.
 *
 * @param {aCancelBannerToArenaParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCancelBannerToArenaParams>} LogObject<aCancelBannerToArenaParams>
 */
export function aCancelBannerToArena(params) {
    return { evid: 173, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnHowToBing' event (evid: 175)
 *
 * Event description: A_ClickOnHowToBing.
 *
 * @param {aClickOnHowToBingParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnHowToBingParams>} LogObject<aClickOnHowToBingParams>
 */
export function aClickOnHowToBing(params) {
    return { evid: 175, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsOrderPagePremiumPurchaseBusinessError' event (evid: 176)
 *
 * Event description: R_SbsOrderPagePremiumPurchaseBusinessError
 *
 * @param {rSbsOrderPagePremiumPurchaseBusinessErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rSbsOrderPagePremiumPurchaseBusinessErrorParams>} LogObject<rSbsOrderPagePremiumPurchaseBusinessErrorParams>
 */
export function rSbsOrderPagePremiumPurchaseBusinessError(params) {
    return { evid: 176, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsOrderPagePremiumPurchaseFatalError' event (evid: 177)
 *
 * Event description: R_SbsOrderPagePremiumPurchaseFatalError
 *
 * @param {rSbsOrderPagePremiumPurchaseFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rSbsOrderPagePremiumPurchaseFatalErrorParams>} LogObject<rSbsOrderPagePremiumPurchaseFatalErrorParams>
 */
export function rSbsOrderPagePremiumPurchaseFatalError(params) {
    return { evid: 177, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aSbsPremiumPurchaseBuyButtonPressed' event (evid: 178)
 *
 * Event description: A_SbsPremiumPurchaseBuyButtonPressed
 *
 * @param {aSbsPremiumPurchaseBuyButtonPressedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aSbsPremiumPurchaseBuyButtonPressedParams>} LogObject<aSbsPremiumPurchaseBuyButtonPressedParams>
 */
export function aSbsPremiumPurchaseBuyButtonPressed(params) {
    return { evid: 178, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartPremiumRenewSuccess' event (evid: 180)
 *
 * Event description: R_StartPremiumRenewSuccess.
 *
 * @param {rStartPremiumRenewSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartPremiumRenewSuccessParams>} LogObject<rStartPremiumRenewSuccessParams>
 */
export function rStartPremiumRenewSuccess(params) {
    return { evid: 180, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainViaApiSuccess' event (evid: 1800)
 *
 * Event description: connect domain via api - success.
 * It is triggered when we successfully create the domain zone-file and insert it to User-Domain DB (before the propagation).
 * It is triggered both in re-assign & connect flows.
 *
 * @param {connectDomainViaApiSuccessParams} params - The parameters for this event
 * @property {string} mgmtTypeName - pointing or dns
 * @property {GUID} ctxMetaSiteId - .
 * @property {string} domainName - domain_name
 * @property {GUID} identTargetAccountId - .
 * @property {boolean} connectedByEntri - is connected by entri
 * @return {LogObject<connectDomainViaApiSuccessParams>} LogObject<connectDomainViaApiSuccessParams>
 */
export function connectDomainViaApiSuccess(params) {
    return { evid: 1800, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'filtersUseTestingAfterNileMiogrationOfAssetServices' event (evid: 1801)
 *
 * Event description: Filters use - testing after nile migration of asset services.
 *
 * @param {filtersUseTestingAfterNileMiogrationOfAssetServicesParams} params - The parameters for this event
 * @property {string} artifactCallerId - artifact_caller_id
 * @property {string} functionName - functionName
 * @property {boolean} assetType - assetType
 * @property {boolean} paymentCollectionType - paymentCollectionType
 * @property {boolean} paymentSourceId - paymentSourceId
 * @property {boolean} paymentMethod - paymentMethod
 * @property {boolean} productFamilyId - productFamilyId
 * @property {boolean} domainName - domainName
 * @property {boolean} editorCompatability - editorCompatability
 * @property {boolean} serviceStatus - serviceStatus
 * @property {boolean} metaSiteFilter - metaSiteFilter
 * @property {boolean} nextRenewalDate - nextRenewalDate
 * @property {boolean} productTypeId - productTypeId
 * @property {boolean} providerName - providerName
 * @property {boolean} premiumId - premiumId
 * @property {boolean} recurringType - recurringType
 * @property {boolean} billingServiceId - billingServiceId
 * @property {boolean} billingAccountOwnerId - billingAccountOwnerId
 * @return {LogObject<filtersUseTestingAfterNileMiogrationOfAssetServicesParams>} LogObject<filtersUseTestingAfterNileMiogrationOfAssetServicesParams>
 */
export function filtersUseTestingAfterNileMiogrationOfAssetServices(params) {
    return { evid: 1801, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartPremiumRenewError' event (evid: 181)
 *
 * Event description: R_StartPremiumRenewError.
 *
 * @param {rStartPremiumRenewErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartPremiumRenewErrorParams>} LogObject<rStartPremiumRenewErrorParams>
 */
export function rStartPremiumRenewError(params) {
    return { evid: 181, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartPremiumRenewException' event (evid: 182)
 *
 * Event description: R_StartPremiumRenewException.
 *
 * @param {rStartPremiumRenewExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartPremiumRenewExceptionParams>} LogObject<rStartPremiumRenewExceptionParams>
 */
export function rStartPremiumRenewException(params) {
    return { evid: 182, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsChangePaymentMethodBusinessError' event (evid: 183)
 *
 * Event description: R_SbsChangePaymentMethodBusinessError.
 *
 * @param {rSbsChangePaymentMethodBusinessErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsChangePaymentMethodBusinessErrorParams>} LogObject<rSbsChangePaymentMethodBusinessErrorParams>
 */
export function rSbsChangePaymentMethodBusinessError(params) {
    return { evid: 183, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsChangePaymentMethodFatalError' event (evid: 184)
 *
 * Event description: R_SbsChangePaymentMethodFatalError.
 *
 * @param {rSbsChangePaymentMethodFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsChangePaymentMethodFatalErrorParams>} LogObject<rSbsChangePaymentMethodFatalErrorParams>
 */
export function rSbsChangePaymentMethodFatalError(params) {
    return { evid: 184, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageLoaded' event (evid: 185)
 *
 * Event description: Check Out > Load
 *
 * @param {checkOutPageLoadedParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} services - A list of services in case the user chooses to update via UPM
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} billingAccountGuid - if there is saved payment method
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} statusText - EditMode/ViewMode
 * @property {number} defaultCreditCardType - credit_card_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} defaultBillingCountry - billing_country
 * @property {string} resolution - resolution
 * @property {boolean} savedPaymentMethodShown - true  / false
 * @property {string} pagename - ab_test
 * @property {string} status_text - status_text
 * @property {number} billingAccountType - type from SBS
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {string} currency - currency
 * @property {string} form_type - view mode / edit mode
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiator_name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} couponId - injected coupon id
 * @property {string} allBillingAccountGuids - list of billing account guids
 * @property {string} pricing - json
 * @property {GUID} purchaseFlowIdentifier - Represents the cart_session_id if the user came from a cart flow
 *
 * @property {boolean} isSearchModalEligible - is eligble for search modal in saved PM ( only if he have enough saved payment methods -currently 5)
 * @property {string} suggestedPaymentMethods - a list of strings with the suggested payment methods that the user will see as option when entering a new payment method.
 * The order of the list represents the sequence of the payment methods as it appears for the the user (first on the list is the first one that will appear for the user
 * @return {LogObject<checkOutPageLoadedParams>} LogObject<checkOutPageLoadedParams>
 */
export function checkOutPageLoaded(params) {
    return { evid: 185, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageErrorLoading' event (evid: 186)
 *
 * Event description: Check Out > Enter Field
 *
 * @param {checkOutPageErrorLoadingParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} errorInfo - error_info
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {string} errorKey - error_key
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} errorCode - checkout_error_code
 * @property {GUID} packageGuid - package_id
 * @property {string} actionType - submit, changeCountry, invalidStateOrZip, removingCoupon, applyingCoupon, changePaymentSource, changeVatId
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiator_name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkOutPageErrorLoadingParams>} LogObject<checkOutPageErrorLoadingParams>
 */
export function checkOutPageErrorLoading(params) {
    return { evid: 186, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageEnterField' event (evid: 187)
 *
 * Event description: Check Out > Enter Field
 *
 * @param {checkOutPageEnterFieldParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} fieldValue - if its PII than no. of digits
 * @property {string} fieldName - the name
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkOutPageEnterFieldParams>} LogObject<checkOutPageEnterFieldParams>
 */
export function checkOutPageEnterField(params) {
    return { evid: 187, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageLeaveField' event (evid: 188)
 *
 * Event description: Check Out Page> Leave Field
 *
 * @param {checkOutPageLeaveFieldParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {boolean} isValid - TRUE / FALSE
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} fieldValue - if its PII than no. of digits
 * @property {string} fieldName - the name
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {boolean} isEmpty - TRUE / FALSE
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkOutPageLeaveFieldParams>} LogObject<checkOutPageLeaveFieldParams>
 */
export function checkOutPageLeaveField(params) {
    return { evid: 188, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageViewTooltip' event (evid: 189)
 *
 * Event description: Check Out Page> view tooltip
 *
 * @param {checkOutPageViewTooltipParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {string} tooltipName - tooltip_name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<checkOutPageViewTooltipParams>} LogObject<checkOutPageViewTooltipParams>
 */
export function checkOutPageViewTooltip(params) {
    return { evid: 189, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aSbsPremiumPurchaseBuyButtonPressedRegDotRu' event (evid: 190)
 *
 * Event description: A_SbsPremiumPurchaseBuyButtonPressedRegDotRu.
 *
 * @param {aSbsPremiumPurchaseBuyButtonPressedRegDotRuParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aSbsPremiumPurchaseBuyButtonPressedRegDotRuParams>} LogObject<aSbsPremiumPurchaseBuyButtonPressedRegDotRuParams>
 */
export function aSbsPremiumPurchaseBuyButtonPressedRegDotRu(params) {
    return { evid: 190, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainsManuallyDeletingDomainsSrc17Evid1900' event (evid: 1900)
 *
 * Event description: We want to delete many domains bound to users but not connected to the user's site. This event saves the latest data of the deleted domains.
 *
 * @param {domainsManuallyDeletingDomainsSrc17Evid1900Params} params - The parameters for this event
 * @property {string} domainName
 * @property {string} userId
 * @property {string} connectivityStatus
 * @property {number} managementType
 * @property {string} msid
 * @property {DateTime} createdAt
 * @return {LogObject<domainsManuallyDeletingDomainsSrc17Evid1900Params>} LogObject<domainsManuallyDeletingDomainsSrc17Evid1900Params>
 */
export function domainsManuallyDeletingDomainsSrc17Evid1900(params) {
    return { evid: 1900, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainsDeleteDomainsSrc17Evid1901' event (evid: 1901)
 *
 * Event description: fhfh
 *
 * @param {domainsDeleteDomainsSrc17Evid1901Params} params - The parameters for this event
 * @property {string} domain - -
 * @property {string} userGuid - -
 * @property {number} managementType - -
 * @property {string} siteId - -
 * @property {boolean} isRedirectsTo - -
 * @property {string} immigratorId - -
 * @property {string} createDomainDate - -
 * @property {boolean} silentConnect - -
 * @return {LogObject<domainsDeleteDomainsSrc17Evid1901Params>} LogObject<domainsDeleteDomainsSrc17Evid1901Params>
 */
export function domainsDeleteDomainsSrc17Evid1901(params) {
    return { evid: 1901, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickedOnSubmitPurchaseRegDotRu' event (evid: 191)
 *
 * Event description: A_ClickedOnSubmitPurchaseRegDotRu.
 *
 * @param {aClickedOnSubmitPurchaseRegDotRuParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickedOnSubmitPurchaseRegDotRuParams>} LogObject<aClickedOnSubmitPurchaseRegDotRuParams>
 */
export function aClickedOnSubmitPurchaseRegDotRu(params) {
    return { evid: 191, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rNonSufficientFundsRegDotRu' event (evid: 192)
 *
 * Event description: R_NonSufficientFundsRegDotRu.
 *
 * @param {rNonSufficientFundsRegDotRuParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rNonSufficientFundsRegDotRuParams>} LogObject<rNonSufficientFundsRegDotRuParams>
 */
export function rNonSufficientFundsRegDotRu(params) {
    return { evid: 192, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnAddMoreFundsRegDotRu' event (evid: 193)
 *
 * Event description: A_ClickOnAddMoreFundsRegDotRu.
 *
 * @param {aClickOnAddMoreFundsRegDotRuParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnAddMoreFundsRegDotRuParams>} LogObject<aClickOnAddMoreFundsRegDotRuParams>
 */
export function aClickOnAddMoreFundsRegDotRu(params) {
    return { evid: 193, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutvalidationErrorInpreview' event (evid: 194)
 *
 * Event description: Checkout Page >  validation error in preview
 *
 * @param {checkOutvalidationErrorInpreviewParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} errorInfo - error_info
 * @property {string} taxPercent - tax_precent
 * @property {string} externalSessionId - external_session_id
 * @property {string} state - state
 * @property {GUID} uuid - uuid
 * @property {string} errorKey - error_key
 * @property {string} acceptLang - accept_lng
 * @property {number} taxRate - rate
 * @property {string} zipCode - zip_code
 * @property {string} newPurchase - is_new_purchase
 * @property {number} amount - total amount
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} errorCode - checkout_error_code
 * @property {GUID} packageGuid - package_id
 * @property {string} actionType - action_type
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkOutvalidationErrorInpreviewParams>} LogObject<checkOutvalidationErrorInpreviewParams>
 */
export function checkOutvalidationErrorInpreview(params) {
    return { evid: 194, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelFlowPopUpClickCancelFinalSrc17Evid195' event (evid: 195)
 *
 * Event description: The user clicked to finally cancel
 *
 * @param {cancelFlowPopUpClickCancelFinalSrc17Evid195Params} params - The parameters for this event
 * @property {string} referral - where the flow was initiated from
 * @property {string} referralAdditionalInfo - the reason the user chose
 * @property {string} cancelTextReason - the reason the user chose
 * @property {string} suggestion - the suggestion the user was offered, based on the cancelation reason
 * @property {string} subscriptionId - subscriptionId
 * @property {string} tellUsMore - the text in tell us more
 * @return {LogObject<cancelFlowPopUpClickCancelFinalSrc17Evid195Params>} LogObject<cancelFlowPopUpClickCancelFinalSrc17Evid195Params>
 */
export function cancelFlowPopUpClickCancelFinalSrc17Evid195(params) {
    return { evid: 195, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageEditDetails' event (evid: 196)
 *
 * Event description: Clicking 'edit details' in the checkout page (pay now & UPM flows)
 *
 * @param {checkoutPageEditDetailsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} taxPercent - tax_precent
 * @property {string} externalSessionId - external_session_id
 * @property {string} state - state
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {number} taxRate - rate
 * @property {string} zipCode - zip_code
 * @property {string} newPurchase - is_new_purchase
 * @property {number} amount - total amount
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPageEditDetailsParams>} LogObject<checkoutPageEditDetailsParams>
 */
export function checkoutPageEditDetails(params) {
    return { evid: 196, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsDomainConnectionProblems' event (evid: 197)
 *
 * Event description: Triggers if users have at least 1 domain in the following status:  DNS_DOMAIN_CONNECTION_STATUS_ERROR, POINTING_DOMAIN_CONNECTION_STATUS_ERROR, DNS_RECORDS_POINTING_OUTSIDE_OF_WIX, DOMAIN_STILL_PROPAGATING, DOMAIN_STILL_VERIFYING
 *
 * @param {myDomainsDomainConnectionProblemsParams} params - The parameters for this event
 * @property {string} status_text - first negative domain status that we detected
 * @property {string} referralAdditionalInfo - where users come from
 * @property {GUID} msid - msid (null for account level)
 * @property {string} domainsQuantity - domains quantity on the page
 * @return {LogObject<myDomainsDomainConnectionProblemsParams>} LogObject<myDomainsDomainConnectionProblemsParams>
 */
export function myDomainsDomainConnectionProblems(params) {
    return { evid: 197, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageDomainsBottomBanner' event (evid: 198)
 *
 * Event description: Get help for connect domain banner in my domains in case the list have a at least 1 domain in the following status:  DNS_DOMAIN_CONNECTION_STATUS_ERROR, POINTING_DOMAIN_CONNECTION_STATUS_ERROR, DNS_RECORDS_POINTING_OUTSIDE_OF_WIX, DOMAIN_STILL_PROPAGATING, DOMAIN_STILL_VERIFYING
 *
 * @param {manageDomainsBottomBannerParams} params - The parameters for this event
 * @property {string} clickType - view | click
 * @property {string} popup_type - wix_arena_banner
 * @property {string} status_text - first negative domain status that we detected
 * @property {string} referralAdditionalInfo - where users come from
 * @property {GUID} msid - msid (null for account level)
 * @property {string} domainsQuantity - domains quantity on the page
 * @return {LogObject<manageDomainsBottomBannerParams>} LogObject<manageDomainsBottomBannerParams>
 */
export function manageDomainsBottomBanner(params) {
    return { evid: 198, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickConnectMicrosoft' event (evid: 199)
 *
 * Event description: A_ClickConnectMicrosoft.
 *
 * @param {aClickConnectMicrosoftParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickConnectMicrosoftParams>} LogObject<aClickConnectMicrosoftParams>
 */
export function aClickConnectMicrosoft(params) {
    return { evid: 199, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnUnAssign' event (evid: 20)
 *
 * Event description: A_ClickOnUnAssign
 *
 * @param {aClickOnUnAssignParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} productTypeName - product_type_name
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {GUID} siteid - site_id
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {string} productTypeId - product_type_id
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - partners/diy
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - to_msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - cycle_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickOnUnAssignParams>} LogObject<aClickOnUnAssignParams>
 */
export function aClickOnUnAssign(params) {
    return { evid: 20, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSearchDomainAvailable' event (evid: 200)
 *
 * Event description: Server event - Search Domain Available
 *
 * @param {rSearchDomainAvailableParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} appDefId - app_def_id
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSearchDomainAvailableParams>} LogObject<rSearchDomainAvailableParams>
 */
export function rSearchDomainAvailable(params) {
    return { evid: 200, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainAddStep2RegistrarSelected' event (evid: 2000)
 *
 * Event description: A_DomainAddStep2RegistrarSelected.
 *
 * @param {aDomainAddStep2RegistrarSelectedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainAddStep2RegistrarSelectedParams>} LogObject<aDomainAddStep2RegistrarSelectedParams>
 */
export function aDomainAddStep2RegistrarSelected(params) {
    return { evid: 2000, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSearchDomainNotAvailable' event (evid: 201)
 *
 * Event description: Server event - Search Domain Not Available
 *
 * @param {rSearchDomainNotAvailableParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} reason - reason
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} appDefId - app_def_id
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSearchDomainNotAvailableParams>} LogObject<rSearchDomainNotAvailableParams>
 */
export function rSearchDomainNotAvailable(params) {
    return { evid: 201, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSearchDomainError' event (evid: 202)
 *
 * Event description: R_SearchDomainError server
 *
 * @param {rSearchDomainErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSearchDomainErrorParams>} LogObject<rSearchDomainErrorParams>
 */
export function rSearchDomainError(params) {
    return { evid: 202, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSearchDomainException' event (evid: 203)
 *
 * Event description: R_SearchDomainException.
 *
 * @param {rSearchDomainExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSearchDomainExceptionParams>} LogObject<rSearchDomainExceptionParams>
 */
export function rSearchDomainException(params) {
    return { evid: 203, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchasePage' event (evid: 204)
 *
 * Event description: V_DomainPurchasePage.
 *
 * @param {vDomainPurchasePageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchasePageParams>} LogObject<vDomainPurchasePageParams>
 */
export function vDomainPurchasePage(params) {
    return { evid: 204, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchaseSuccess' event (evid: 205)
 *
 * Event description: Client - V_DomainPurchaseSuccess (server is sending it for Payu).
 *
 * @param {vDomainPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} email - email
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} paymentMethod - payment_type
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} coupon - PHONE85221, Phone87221
 * @property {string} siteStatus - site_staus
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {string} parameters - parameters
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {string} emailSale - email_sale
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} pageType - new_success_page, null/current_page
 * @return {LogObject<vDomainPurchaseSuccessParams>} LogObject<vDomainPurchaseSuccessParams>
 */
export function vDomainPurchaseSuccess(params) {
    return { evid: 205, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainAuthCodeRequestSuccess' event (evid: 206)
 *
 * Event description: Triggered in Transfer Away flow
 *
 * @param {rDomainAuthCodeRequestSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainAuthCodeRequestSuccessParams>} LogObject<rDomainAuthCodeRequestSuccessParams>
 */
export function rDomainAuthCodeRequestSuccess(params) {
    return { evid: 206, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainAuthCodeRequestError' event (evid: 207)
 *
 * Event description: Triggered in Transfer Away flow.
 *
 * @param {rDomainAuthCodeRequestErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainAuthCodeRequestErrorParams>} LogObject<rDomainAuthCodeRequestErrorParams>
 */
export function rDomainAuthCodeRequestError(params) {
    return { evid: 207, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainAuthCodeRequestException' event (evid: 208)
 *
 * Event description: R_DomainAuthCodeRequestException.
 *
 * @param {rDomainAuthCodeRequestExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainAuthCodeRequestExceptionParams>} LogObject<rDomainAuthCodeRequestExceptionParams>
 */
export function rDomainAuthCodeRequestException(params) {
    return { evid: 208, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vManageDomains' event (evid: 209)
 *
 * Event description: client
 *
 * @param {vManageDomainsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} responseSpeed - download page time in milliseconds
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} totalUnassignedDomains - the number of unassigned domains in the page
 * @property {string} '23' - additional_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} totalInactiveDomains - the number of inactive domains in the page
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} domains - 5 random domains from myDomains
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} totalDomains - the number of domains on the page, if 0 - then empty state
 * @property {boolean} emptyState - true | false
 * @property {boolean} isPublished - sitelevel - true | false, account level - NULL
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - where users came from
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {boolean} isPremiumSite - true, false
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {boolean} isVoucher - true, false
 * @property {string} region - region
 * @property {string} totalConnectedDomains - the number of active domains in the page that are connected
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - where users came from
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} reseller - reseller guid if applicable
 * @property {string} pageType - default, reseller
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {boolean} isPremium - has a premium on the current site
 * @property {string} totalAssignedDomains - the number of assigned domains in the page
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid for site level, null for account
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vManageDomainsParams>} LogObject<vManageDomainsParams>
 */
export function vManageDomains(params) {
    return { evid: 209, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainIcannClickConfirmEmailSuccess' event (evid: 2100)
 *
 * Event description: R_DomainIcannClickConfirmEmailSuccess.
 *
 * @param {rDomainIcannClickConfirmEmailSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainIcannClickConfirmEmailSuccessParams>} LogObject<rDomainIcannClickConfirmEmailSuccessParams>
 */
export function rDomainIcannClickConfirmEmailSuccess(params) {
    return { evid: 2100, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainIcannClickConfirmEmailError' event (evid: 2101)
 *
 * Event description: R_DomainIcannClickConfirmEmailError.
 *
 * @param {rDomainIcannClickConfirmEmailErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainIcannClickConfirmEmailErrorParams>} LogObject<rDomainIcannClickConfirmEmailErrorParams>
 */
export function rDomainIcannClickConfirmEmailError(params) {
    return { evid: 2101, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainIcannClickConfirmEmailException' event (evid: 2102)
 *
 * Event description: R_DomainIcannClickConfirmEmailException.
 *
 * @param {rDomainIcannClickConfirmEmailExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainIcannClickConfirmEmailExceptionParams>} LogObject<rDomainIcannClickConfirmEmailExceptionParams>
 */
export function rDomainIcannClickConfirmEmailException(params) {
    return { evid: 2102, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainIcannClickReactiveEmailSuccess' event (evid: 2103)
 *
 * Event description: R_DomainIcannClickReactiveEmailSuccess.
 *
 * @param {rDomainIcannClickReactiveEmailSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainIcannClickReactiveEmailSuccessParams>} LogObject<rDomainIcannClickReactiveEmailSuccessParams>
 */
export function rDomainIcannClickReactiveEmailSuccess(params) {
    return { evid: 2103, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainIcannClickReactiveEmailError' event (evid: 2104)
 *
 * Event description: R_DomainIcannClickReactiveEmailError.
 *
 * @param {rDomainIcannClickReactiveEmailErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainIcannClickReactiveEmailErrorParams>} LogObject<rDomainIcannClickReactiveEmailErrorParams>
 */
export function rDomainIcannClickReactiveEmailError(params) {
    return { evid: 2104, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainIcannClickReactiveEmailException' event (evid: 2105)
 *
 * Event description: R_DomainIcannClickReactiveEmailException.
 *
 * @param {rDomainIcannClickReactiveEmailExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainIcannClickReactiveEmailExceptionParams>} LogObject<rDomainIcannClickReactiveEmailExceptionParams>
 */
export function rDomainIcannClickReactiveEmailException(params) {
    return { evid: 2105, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainIcannClickSendConfirmPopUp' event (evid: 2107)
 *
 * Event description: A_DomainIcannClickSendConfirmPopUp.
 *
 * @param {aDomainIcannClickSendConfirmPopUpParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainIcannClickSendConfirmPopUpParams>} LogObject<aDomainIcannClickSendConfirmPopUpParams>
 */
export function aDomainIcannClickSendConfirmPopUp(params) {
    return { evid: 2107, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainIcannClickUpdateConfirmPopUp' event (evid: 2108)
 *
 * Event description: A_DomainIcannClickUpdateConfirmPopUp.
 *
 * @param {aDomainIcannClickUpdateConfirmPopUpParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainIcannClickUpdateConfirmPopUpParams>} LogObject<aDomainIcannClickUpdateConfirmPopUpParams>
 */
export function aDomainIcannClickUpdateConfirmPopUp(params) {
    return { evid: 2108, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainIcannClickSupportConfirmPopUp' event (evid: 2109)
 *
 * Event description: A_DomainIcannClickSupportConfirmPopUp.
 *
 * @param {aDomainIcannClickSupportConfirmPopUpParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainIcannClickSupportConfirmPopUpParams>} LogObject<aDomainIcannClickSupportConfirmPopUpParams>
 */
export function aDomainIcannClickSupportConfirmPopUp(params) {
    return { evid: 2109, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPurchaseSuccess' event (evid: 211)
 *
 * Event description: Domain purchase success
 *
 * @param {rDomainPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainPurchaseSuccessParams>} LogObject<rDomainPurchaseSuccessParams>
 */
export function rDomainPurchaseSuccess(params) {
    return { evid: 211, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coreServicesCreationOfDomainRecord' event (evid: 2110)
 *
 * Event description: Create domain (connect. register) in DB.
 * Triggered when domain is first appear in MyDomains page --> on linkage with user, whether by Connect, Purchase & Transfer
 *
 * @param {coreServicesCreationOfDomainRecordParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {string} method - DNS, POINTING, WIX
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {DateTime} dateCreated - date
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - if connect by API --> not mandatory
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<coreServicesCreationOfDomainRecordParams>} LogObject<coreServicesCreationOfDomainRecordParams>
 */
export function coreServicesCreationOfDomainRecord(params) {
    return { evid: 2110, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainIcannClickSendReactivePopUp' event (evid: 2111)
 *
 * Event description: A_DomainIcannClickSendReactivePopUp.
 *
 * @param {aDomainIcannClickSendReactivePopUpParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainIcannClickSendReactivePopUpParams>} LogObject<aDomainIcannClickSendReactivePopUpParams>
 */
export function aDomainIcannClickSendReactivePopUp(params) {
    return { evid: 2111, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainIcannClickUpdateDeactivePopUp' event (evid: 2112)
 *
 * Event description: A_DomainIcannClickUpdateDeactivePopUp.
 *
 * @param {aDomainIcannClickUpdateDeactivePopUpParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainIcannClickUpdateDeactivePopUpParams>} LogObject<aDomainIcannClickUpdateDeactivePopUpParams>
 */
export function aDomainIcannClickUpdateDeactivePopUp(params) {
    return { evid: 2112, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainIcannClickSupportReactivePopUp' event (evid: 2113)
 *
 * Event description: A_DomainIcannClickSupportReactivePopUp.
 *
 * @param {aDomainIcannClickSupportReactivePopUpParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainIcannClickSupportReactivePopUpParams>} LogObject<aDomainIcannClickSupportReactivePopUpParams>
 */
export function aDomainIcannClickSupportReactivePopUp(params) {
    return { evid: 2113, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainIcannResedingVerificationMailSuccess' event (evid: 2114)
 *
 * Event description: R_DomainIcannResedingVerificationMailSuccess.
 *
 * @param {rDomainIcannResedingVerificationMailSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainIcannResedingVerificationMailSuccessParams>} LogObject<rDomainIcannResedingVerificationMailSuccessParams>
 */
export function rDomainIcannResedingVerificationMailSuccess(params) {
    return { evid: 2114, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainIcannResedingVerificationMailError' event (evid: 2115)
 *
 * Event description: R_DomainIcannResedingVerificationMailError.
 *
 * @param {rDomainIcannResedingVerificationMailErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainIcannResedingVerificationMailErrorParams>} LogObject<rDomainIcannResedingVerificationMailErrorParams>
 */
export function rDomainIcannResedingVerificationMailError(params) {
    return { evid: 2115, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainIcannResedingVerificationMailException' event (evid: 2116)
 *
 * Event description: R_DomainIcannResedingVerificationMailException.
 *
 * @param {rDomainIcannResedingVerificationMailExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainIcannResedingVerificationMailExceptionParams>} LogObject<rDomainIcannResedingVerificationMailExceptionParams>
 */
export function rDomainIcannResedingVerificationMailException(params) {
    return { evid: 2116, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainIcannVerificationTaskStatusChanged' event (evid: 2117)
 *
 * Event description: R_DomainIcannVerificationTaskStatusChanged.
 *
 * @param {rDomainIcannVerificationTaskStatusChangedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {string} newStatus - new_status
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} domainName - domain_name
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} contactId - contact_id
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {string} errorinfo - error_info
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainIcannVerificationTaskStatusChangedParams>} LogObject<rDomainIcannVerificationTaskStatusChangedParams>
 */
export function rDomainIcannVerificationTaskStatusChanged(params) {
    return { evid: 2117, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainFixMetatSiteSuccess' event (evid: 2118)
 *
 * Event description: R_DomainFixMetatSiteSuccess.
 *
 * @param {rDomainFixMetatSiteSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainFixMetatSiteSuccessParams>} LogObject<rDomainFixMetatSiteSuccessParams>
 */
export function rDomainFixMetatSiteSuccess(params) {
    return { evid: 2118, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainFixMetatSiteException' event (evid: 2120)
 *
 * Event description: R_DomainFixMetatSiteException.
 *
 * @param {rDomainFixMetatSiteExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainFixMetatSiteExceptionParams>} LogObject<rDomainFixMetatSiteExceptionParams>
 */
export function rDomainFixMetatSiteException(params) {
    return { evid: 2120, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coreServicesAssignDomainToTheSite' event (evid: 2121)
 *
 * Event description: Assign domain to the site Success
 *
 * @param {coreServicesAssignDomainToTheSiteParams} params - The parameters for this event
 * @property {string} assignmentType - primary , redirect
 * @property {string} domain - domain name
 * @property {GUID} uuid - user id
 * @property {string} user_agent - user_agent
 * @property {string} appDefId - array, who request the service / initiator
 * @property {string} domainStatus - domain check status
 * @property {GUID} domainGuid - guid from user_domain_info table
 * @property {GUID} msid - to which site the initiator assign domain
 * @return {LogObject<coreServicesAssignDomainToTheSiteParams>} LogObject<coreServicesAssignDomainToTheSiteParams>
 */
export function coreServicesAssignDomainToTheSite(params) {
    return { evid: 2121, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coreServicesUnassignDomainFromTheSite' event (evid: 2122)
 *
 * Event description: Unassign domain from the site Success
 *
 * @param {coreServicesUnassignDomainFromTheSiteParams} params - The parameters for this event
 * @property {string} assignmentType - assignment_type
 * @property {string} domain - domain name
 * @property {GUID} uuid - user id
 * @property {string} user_agent - user_agent
 * @property {string} appDefId - array, who request the service / initiator
 * @property {string} domainStatus - domain check status
 * @property {GUID} domainGuid - guid from user_domain_info table
 * @property {GUID} msid - from which site the initiator assign domain
 * @return {LogObject<coreServicesUnassignDomainFromTheSiteParams>} LogObject<coreServicesUnassignDomainFromTheSiteParams>
 */
export function coreServicesUnassignDomainFromTheSite(params) {
    return { evid: 2122, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coreServicesAssignDomainToTheSiteError' event (evid: 2123)
 *
 * Event description: Errors, encountered during "Assign domain to the site" action  (FAILURE)
 *
 * @param {coreServicesAssignDomainToTheSiteErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error info
 * @property {string} assignmentType - assignment_type
 * @property {string} domain - domain name
 * @property {GUID} uuid - user id
 * @property {string} user_agent - user_agent
 * @property {string} appDefId - array, who request the service / initiator
 * @property {string} domainStatus - domain check status
 * @property {GUID} domainGuid - guid from user_domain_info table
 * @property {GUID} msid - to which site the initiator assign domain
 * @return {LogObject<coreServicesAssignDomainToTheSiteErrorParams>} LogObject<coreServicesAssignDomainToTheSiteErrorParams>
 */
export function coreServicesAssignDomainToTheSiteError(params) {
    return { evid: 2123, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coreServicesUnassignDomainFromTheSiteError' event (evid: 2124)
 *
 * Event description: Errors, encountered during "Unassign domain from the site" action  (FAILURE)
 *
 * @param {coreServicesUnassignDomainFromTheSiteErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error info
 * @property {string} assignmentType - assignment_type
 * @property {string} domain - domain name
 * @property {GUID} uuid - user id
 * @property {string} user_agent - user_agent
 * @property {string} appDefId - array, who request the service / initiator
 * @property {string} domainStatus - domain check status
 * @property {GUID} domainGuid - guid from user_domain_info table
 * @property {GUID} msid - from which site the initiator assign domain
 * @return {LogObject<coreServicesUnassignDomainFromTheSiteErrorParams>} LogObject<coreServicesUnassignDomainFromTheSiteErrorParams>
 */
export function coreServicesUnassignDomainFromTheSiteError(params) {
    return { evid: 2124, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc17Evid2125' event (evid: 2125)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc17Evid2125Params} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} user_agent - user_agent
 * @return {LogObject<dummyNameSrc17Evid2125Params>} LogObject<dummyNameSrc17Evid2125Params>
 */
export function dummyNameSrc17Evid2125(params) {
    return { evid: 2125, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coreServicesAssignmentTrySrc17Evid2126' event (evid: 2126)
 *
 * Event description: There was a try to assign / unassign the domain.
 *
 * @param {coreServicesAssignmentTrySrc17Evid2126Params} params - The parameters for this event
 * @property {string} assignmentType - primary , redirect
 * @property {string} domain - domain name
 * @property {GUID} uuid - user id
 * @property {string} user_agent - user_agent
 * @property {string} appDefId - array, who request the service / initiator
 * @property {string} domainStatus - domain check status
 * @property {GUID} domainGuid - guid from user_domain_info table
 * @property {GUID} msid - to which site the initiator assign domain
 * @property {string} actiontype - assign, unassign
 * @return {LogObject<coreServicesAssignmentTrySrc17Evid2126Params>} LogObject<coreServicesAssignmentTrySrc17Evid2126Params>
 */
export function coreServicesAssignmentTrySrc17Evid2126(params) {
    return { evid: 2126, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPurchaseException' event (evid: 213)
 *
 * Event description: R_DomainPurchaseException.
 *
 * @param {rDomainPurchaseExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainPurchaseExceptionParams>} LogObject<rDomainPurchaseExceptionParams>
 */
export function rDomainPurchaseException(params) {
    return { evid: 213, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rUnAssignSuccess' event (evid: 22)
 *
 * Event description: UnAssign premium plan
 *
 * @param {rUnAssignSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} paymentCycle - cycle_id
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {GUID} fromMsid - from_msid
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} referral - referral
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rUnAssignSuccessParams>} LogObject<rUnAssignSuccessParams>
 */
export function rUnAssignSuccess(params) {
    return { evid: 22, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aVoucherClaimForGoogleSuccess' event (evid: 2210)
 *
 * Event description: A_VoucherClaimForGoogleSuccess.
 *
 * @param {aVoucherClaimForGoogleSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aVoucherClaimForGoogleSuccessParams>} LogObject<aVoucherClaimForGoogleSuccessParams>
 */
export function aVoucherClaimForGoogleSuccess(params) {
    return { evid: 2210, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aVoucherClaimForGoogleException' event (evid: 2212)
 *
 * Event description: A_VoucherClaimForGoogleException.
 *
 * @param {aVoucherClaimForGoogleExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aVoucherClaimForGoogleExceptionParams>} LogObject<aVoucherClaimForGoogleExceptionParams>
 */
export function aVoucherClaimForGoogleException(params) {
    return { evid: 2212, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aVoucherClaimForFacebookException' event (evid: 2215)
 *
 * Event description: A_VoucherClaimForFacebookException.
 *
 * @param {aVoucherClaimForFacebookExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aVoucherClaimForFacebookExceptionParams>} LogObject<aVoucherClaimForFacebookExceptionParams>
 */
export function aVoucherClaimForFacebookException(params) {
    return { evid: 2215, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aVoucherClaimForYandexSuccess' event (evid: 2216)
 *
 * Event description: A_VoucherClaimForYandexSuccess.
 *
 * @param {aVoucherClaimForYandexSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aVoucherClaimForYandexSuccessParams>} LogObject<aVoucherClaimForYandexSuccessParams>
 */
export function aVoucherClaimForYandexSuccess(params) {
    return { evid: 2216, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aVoucherClaimForYandexException' event (evid: 2218)
 *
 * Event description: A_VoucherClaimForYandexException.
 *
 * @param {aVoucherClaimForYandexExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aVoucherClaimForYandexExceptionParams>} LogObject<aVoucherClaimForYandexExceptionParams>
 */
export function aVoucherClaimForYandexException(params) {
    return { evid: 2218, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainChangeAutoRenewSuccess' event (evid: 223)
 *
 * Event description: R_DomainChangeAutoRenewSuccess.
 *
 * @param {rDomainChangeAutoRenewSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainChangeAutoRenewSuccessParams>} LogObject<rDomainChangeAutoRenewSuccessParams>
 */
export function rDomainChangeAutoRenewSuccess(params) {
    return { evid: 223, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerNewDeal' event (evid: 2233)
 *
 * Event description: all views. server - 2018-12-24 open to 100%
 *
 * @param {packagePickerNewDealParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} flowType - upgrade / change_plan
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} domainName - suggested_domain
 * @property {string} offerColor - color of post reg color
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {string} offeringName - offering_name
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} intentName - Vertical name or account_level
 * @property {GUID} packageGuid - package_id
 * @property {string} saleCouponUsed - 50% fallback' / 'coupon from coupon service'
 * @property {string} pagename - CMS
 * @property {string} ppType - website / business
 * @property {string} intentGuid - Vertical guid
 * @property {string} offeringGuid - offering_guid
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {Url} referer - referer
 * @property {string} offeringType - Seasonal / Personal / Default
 * @property {string} salePrecent - '50% fallback' / 'coupon from coupon service'
 * @property {string} domainFirstServiceGuid - service_guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - MSID
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<packagePickerNewDealParams>} LogObject<packagePickerNewDealParams>
 */
export function packagePickerNewDeal(params) {
    return { evid: 2233, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bundlePurchaseSuccessPageClickSrc17Evid2234' event (evid: 2234)
 *
 * Event description: CTAs click on bundle plan purchase success page
 *
 * @param {bundlePurchaseSuccessPageClickSrc17Evid2234Params} params - The parameters for this event
 * @property {string} voucher - true/false
 * @property {string} domain - domain
 * @property {number} paymentMethod - payment_method
 * @property {string} clickType - buy_mailbox , show_summary, go_to_dashboard
 * @property {string} eventAggregator - event_aggregator
 * @property {number} cycle - cycle_id
 * @property {string} flow - express_checkout
 * @property {string} pageType - default success page / connect domain success page
 * @property {string} productGuid - Product Guid
 * @property {GUID} msid - msid
 * @property {string} product - bundle_domain_plan
 * @property {string} abTesting - abTesting1
 * @return {LogObject<bundlePurchaseSuccessPageClickSrc17Evid2234Params>} LogObject<bundlePurchaseSuccessPageClickSrc17Evid2234Params>
 */
export function bundlePurchaseSuccessPageClickSrc17Evid2234(params) {
    return { evid: 2234, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerStartLoadSrc17Evid2235' event (evid: 2235)
 *
 * Event description: Server event for pp start load (before 2233)
 *
 * @param {packagePickerStartLoadSrc17Evid2235Params} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} flowType - upgrade / change_plan
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} domainName - suggested_domain
 * @property {string} offerColor - color of post reg color
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {string} offeringName - offering_name
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} intentName - Vertical name or account_level
 * @property {GUID} packageGuid - package_id
 * @property {string} saleCouponUsed - 50% fallback' / 'coupon from coupon service'
 * @property {string} pagename - CMS
 * @property {string} ppType - website / business
 * @property {string} intentGuid - Vertical guid
 * @property {string} offeringGuid - offering_guid
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {Url} referer - referer
 * @property {string} offeringType - Seasonal / Personal / Default
 * @property {string} salePrecent - '50% fallback' / 'coupon from coupon service'
 * @property {string} domainFirstServiceGuid - service_guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - MSID
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<packagePickerStartLoadSrc17Evid2235Params>} LogObject<packagePickerStartLoadSrc17Evid2235Params>
 */
export function packagePickerStartLoadSrc17Evid2235(params) {
    return { evid: 2235, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainChangeAutoRenewError' event (evid: 224)
 *
 * Event description: R_DomainChangeAutoRenewError.
 *
 * @param {rDomainChangeAutoRenewErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainChangeAutoRenewErrorParams>} LogObject<rDomainChangeAutoRenewErrorParams>
 */
export function rDomainChangeAutoRenewError(params) {
    return { evid: 224, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainChangeAutoRenewException' event (evid: 225)
 *
 * Event description: R_DomainChangeAutoRenewException.
 *
 * @param {rDomainChangeAutoRenewExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainChangeAutoRenewExceptionParams>} LogObject<rDomainChangeAutoRenewExceptionParams>
 */
export function rDomainChangeAutoRenewException(params) {
    return { evid: 225, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainRenewStartSuccess' event (evid: 226)
 *
 * Event description: R_DomainRenewStartSuccess.
 *
 * @param {rDomainRenewStartSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainRenewStartSuccessParams>} LogObject<rDomainRenewStartSuccessParams>
 */
export function rDomainRenewStartSuccess(params) {
    return { evid: 226, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainRenewStartError' event (evid: 227)
 *
 * Event description: R_DomainRenewStartError.
 *
 * @param {rDomainRenewStartErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainRenewStartErrorParams>} LogObject<rDomainRenewStartErrorParams>
 */
export function rDomainRenewStartError(params) {
    return { evid: 227, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPurchaseSetContractSuccess' event (evid: 229)
 *
 * Event description: R_DomainPurchaseSetContractSuccess.
 *
 * @param {rDomainPurchaseSetContractSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainPurchaseSetContractSuccessParams>} LogObject<rDomainPurchaseSetContractSuccessParams>
 */
export function rDomainPurchaseSetContractSuccess(params) {
    return { evid: 229, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPurchaseSetContractError' event (evid: 230)
 *
 * Event description: reasons: DOMAIN_ALREADY_TAKEN, INVALID_REGISTRANT_PHONE_FORMAT, DOMAIN_RENEW_NOT_ALLOWED_MORE_THEN_ONCE_IN_24_HOURS_PERIOD
 *
 * @param {rDomainPurchaseSetContractErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainPurchaseSetContractErrorParams>} LogObject<rDomainPurchaseSetContractErrorParams>
 */
export function rDomainPurchaseSetContractError(params) {
    return { evid: 230, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPackagePickerSaleSuccess' event (evid: 2300)
 *
 * Event description: Desktop site selector. Upgrade in account level. Increasing in sale times.
 *
 * @param {rPackagePickerSaleSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} pageName - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPackagePickerSaleSuccessParams>} LogObject<rPackagePickerSaleSuccessParams>
 */
export function rPackagePickerSaleSuccess(params) {
    return { evid: 2300, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPackagePickerSiteSelectorSuccess' event (evid: 2303)
 *
 * Event description: Mobile site selector - package_picker_site_selector_static. Increasing in sale times. Related to upgrade in account level - since 11.6.2019 merged with 2300 (different device type)
 *
 * @param {rPackagePickerSiteSelectorSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPackagePickerSiteSelectorSuccessParams>} LogObject<rPackagePickerSiteSelectorSuccessParams>
 */
export function rPackagePickerSiteSelectorSuccess(params) {
    return { evid: 2303, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPurchaseSetContractException' event (evid: 231)
 *
 * Event description: R_DomainPurchaseSetContractException.
 *
 * @param {rDomainPurchaseSetContractExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainPurchaseSetContractExceptionParams>} LogObject<rDomainPurchaseSetContractExceptionParams>
 */
export function rDomainPurchaseSetContractException(params) {
    return { evid: 231, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPurchaseStartSuccess' event (evid: 232)
 *
 * Event description: R_DomainPurchaseStartSuccess
 *
 * @param {rDomainPurchaseStartSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainPurchaseStartSuccessParams>} LogObject<rDomainPurchaseStartSuccessParams>
 */
export function rDomainPurchaseStartSuccess(params) {
    return { evid: 232, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageBillingServerException' event (evid: 2324)
 *
 * Event description: from billing server
 *
 * @param {checkoutPageBillingServerExceptionParams} params - The parameters for this event
 * @property {string} orderSessionMetadata - order_session_metadata
 * @property {string} paymentSourceId - billing_account_guid
 * @property {number} invoiceId - invoiceId
 * @property {string} errorCode - errorCode
 * @property {string} errorDescription - error_description
 * @property {string} currency - currency
 * @property {string} rootCauseExceptionMessage - root_cause_exception_message
 * @property {string} transactionName - submitOrder / updateOrderSummary / getCec
 * @return {LogObject<checkoutPageBillingServerExceptionParams>} LogObject<checkoutPageBillingServerExceptionParams>
 */
export function checkoutPageBillingServerException(params) {
    return { evid: 2324, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPurchaseStartError' event (evid: 233)
 *
 * Event description: R_DomainPurchaseStartError.
 *
 * @param {rDomainPurchaseStartErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainPurchaseStartErrorParams>} LogObject<rDomainPurchaseStartErrorParams>
 */
export function rDomainPurchaseStartError(params) {
    return { evid: 233, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPurchaseStartException' event (evid: 234)
 *
 * Event description: R_DomainPurchaseStartException.
 *
 * @param {rDomainPurchaseStartExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainPurchaseStartExceptionParams>} LogObject<rDomainPurchaseStartExceptionParams>
 */
export function rDomainPurchaseStartException(params) {
    return { evid: 234, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchasePageNext1' event (evid: 235)
 *
 * Event description: A_DomainPurchasePageNext1.
 *
 * @param {aDomainPurchasePageNext1Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchasePageNext1Params>} LogObject<aDomainPurchasePageNext1Params>
 */
export function aDomainPurchasePageNext1(params) {
    return { evid: 235, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchaseContractSelectionChange' event (evid: 236)
 *
 * Event description: Client - A_DomainPurchaseContractSelectionChange
 *
 * @param {aDomainPurchaseContractSelectionChangeParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {string} selectionType - selection_type
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} privacy - privacy
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchaseContractSelectionChangeParams>} LogObject<aDomainPurchaseContractSelectionChangeParams>
 */
export function aDomainPurchaseContractSelectionChange(params) {
    return { evid: 236, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchasePendingPayment' event (evid: 237)
 *
 * Event description: V_DomainPurchasePendingPayment.
 *
 * @param {vDomainPurchasePendingPaymentParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchasePendingPaymentParams>} LogObject<vDomainPurchasePendingPaymentParams>
 */
export function vDomainPurchasePendingPayment(params) {
    return { evid: 237, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainModifyPrivateRegistrationSuccess' event (evid: 238)
 *
 * Event description: R_DomainModifyPrivateRegistrationSuccess.
 *
 * @param {rDomainModifyPrivateRegistrationSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainModifyPrivateRegistrationSuccessParams>} LogObject<rDomainModifyPrivateRegistrationSuccessParams>
 */
export function rDomainModifyPrivateRegistrationSuccess(params) {
    return { evid: 238, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainModifyPrivateRegistrationError' event (evid: 239)
 *
 * Event description: R_DomainModifyPrivateRegistrationError.
 *
 * @param {rDomainModifyPrivateRegistrationErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainModifyPrivateRegistrationErrorParams>} LogObject<rDomainModifyPrivateRegistrationErrorParams>
 */
export function rDomainModifyPrivateRegistrationError(params) {
    return { evid: 239, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnAssign' event (evid: 24)
 *
 * Event description: A_ClickOnAssign.
 *
 * @param {aClickOnAssignParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnAssignParams>} LogObject<aClickOnAssignParams>
 */
export function aClickOnAssign(params) {
    return { evid: 24, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainModifyPrivateRegistrationException' event (evid: 240)
 *
 * Event description: R_DomainModifyPrivateRegistrationException.
 *
 * @param {rDomainModifyPrivateRegistrationExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainModifyPrivateRegistrationExceptionParams>} LogObject<rDomainModifyPrivateRegistrationExceptionParams>
 */
export function rDomainModifyPrivateRegistrationException(params) {
    return { evid: 240, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchasePrivacyStepNext' event (evid: 241)
 *
 * Event description: Client - A_DomainPurchasePrivacyStepNext
 *
 * @param {aDomainPurchasePrivacyStepNextParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} responseSpeed - response_speed
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} privacy - privacy
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchasePrivacyStepNextParams>} LogObject<aDomainPurchasePrivacyStepNextParams>
 */
export function aDomainPurchasePrivacyStepNext(params) {
    return { evid: 241, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchaseSrvTermNext' event (evid: 242)
 *
 * Event description: Client - A_DomainPurchaseSrvTermNext
 *
 * @param {aDomainPurchaseSrvTermNextParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} responseSpeed - response_speed
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchaseSrvTermNextParams>} LogObject<aDomainPurchaseSrvTermNextParams>
 */
export function aDomainPurchaseSrvTermNext(params) {
    return { evid: 242, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainUpdatePaymentMethodSuccess' event (evid: 244)
 *
 * Event description: R_DomainUpdatePaymentMethodSuccess.
 *
 * @param {rDomainUpdatePaymentMethodSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainUpdatePaymentMethodSuccessParams>} LogObject<rDomainUpdatePaymentMethodSuccessParams>
 */
export function rDomainUpdatePaymentMethodSuccess(params) {
    return { evid: 244, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainUpdatePaymentMethodError' event (evid: 245)
 *
 * Event description: R_DomainUpdatePaymentMethodError.
 *
 * @param {rDomainUpdatePaymentMethodErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainUpdatePaymentMethodErrorParams>} LogObject<rDomainUpdatePaymentMethodErrorParams>
 */
export function rDomainUpdatePaymentMethodError(params) {
    return { evid: 245, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainUpdatePaymentMethodException' event (evid: 246)
 *
 * Event description: R_DomainUpdatePaymentMethodException.
 *
 * @param {rDomainUpdatePaymentMethodExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainUpdatePaymentMethodExceptionParams>} LogObject<rDomainUpdatePaymentMethodExceptionParams>
 */
export function rDomainUpdatePaymentMethodException(params) {
    return { evid: 246, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aConnectDomainRegistrar' event (evid: 248)
 *
 * Event description: A_ConnectDomain_Registrar.
 *
 * @param {aConnectDomainRegistrarParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aConnectDomainRegistrarParams>} LogObject<aConnectDomainRegistrarParams>
 */
export function aConnectDomainRegistrar(params) {
    return { evid: 248, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rAssignSuccess' event (evid: 25)
 *
 * Event description: Assign an existing premium to another site in your account. site_id the UnAssignd site.
 *
 * @param {rAssignSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} toMsid - to_msid
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} paymentCycle - cycle_id
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {GUID} fromMsid - from_msid
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} referral - referral
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rAssignSuccessParams>} LogObject<rAssignSuccessParams>
 */
export function rAssignSuccess(params) {
    return { evid: 25, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aConnectDomainTroubleShooter2' event (evid: 250)
 *
 * Event description: A_ConnectDomainTroubleShooter2.
 *
 * @param {aConnectDomainTroubleShooter2Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aConnectDomainTroubleShooter2Params>} LogObject<aConnectDomainTroubleShooter2Params>
 */
export function aConnectDomainTroubleShooter2(params) {
    return { evid: 250, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dealerPackagePicker' event (evid: 2500)
 *
 * Event description: Dealer Package Picker - can be when the user requests to upgrade. or when someone is calling the Dealer.
 *
 * @param {dealerPackagePickerParams} params - The parameters for this event
 * @property {string} mobilePackagePickerId - mobile_package_picker_id (cms)
 * @property {GUID} uuid - user guid
 * @property {string} verticalGuid - vertical guid from delaer
 * @property {string} packagePickerId - package_picker_id (cms)
 * @property {string} offeringName - offering name from dealer
 * @property {boolean} changePlan - is it from the "change plan" flow
 * @property {string} requestedAppId - from the app - app definition id  (specific)
 * @property {string} offeringGuid - offering_guid from dealer
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} appEngageOverride - app_engage_override (goes with requestedAppId)
 * @property {string} offeringType - sale type
 * @property {GUID} siteGuid - msid
 * @property {string} offeringResultGuid - offering_result_guid  from dealer
 * @return {LogObject<dealerPackagePickerParams>} LogObject<dealerPackagePickerParams>
 */
export function dealerPackagePicker(params) {
    return { evid: 2500, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dealerAppIntent' event (evid: 2501)
 *
 * Event description: Dealer AppIntent
 *
 * @param {dealerAppIntentParams} params - The parameters for this event
 * @property {GUID} uuid - user guid
 * @property {string} appDefinitionId - app_defintion_id
 * @property {string} appIntent - from profile
 * @property {string} appEngage - level of intent
 * @return {LogObject<dealerAppIntentParams>} LogObject<dealerAppIntentParams>
 */
export function dealerAppIntent(params) {
    return { evid: 2501, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnDomainTransferBetweenWixAccounts' event (evid: 254)
 *
 * Event description: A_ClickOnDomainTransferBetweenWixAccounts.
 *
 * @param {aClickOnDomainTransferBetweenWixAccountsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnDomainTransferBetweenWixAccountsParams>} LogObject<aClickOnDomainTransferBetweenWixAccountsParams>
 */
export function aClickOnDomainTransferBetweenWixAccounts(params) {
    return { evid: 254, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferBetweenWixAccountsSuccess' event (evid: 255)
 *
 * Event description: Domain Transfer Between Wix Accounts Success
 *
 * @param {rDomainTransferBetweenWixAccountsSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} targetUserId - target_uuid
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferBetweenWixAccountsSuccessParams>} LogObject<rDomainTransferBetweenWixAccountsSuccessParams>
 */
export function rDomainTransferBetweenWixAccountsSuccess(params) {
    return { evid: 255, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferBetweenWixAccountsError' event (evid: 256)
 *
 * Event description: R_DomainTransferBetweenWixAccountsError
 *
 * @param {rDomainTransferBetweenWixAccountsErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} targetUserId - target_uuid
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferBetweenWixAccountsErrorParams>} LogObject<rDomainTransferBetweenWixAccountsErrorParams>
 */
export function rDomainTransferBetweenWixAccountsError(params) {
    return { evid: 256, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferBetweenWixAccountsException' event (evid: 257)
 *
 * Event description: R_DomainTransferBetweenWixAccountsException.
 *
 * @param {rDomainTransferBetweenWixAccountsExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainTransferBetweenWixAccountsExceptionParams>} LogObject<rDomainTransferBetweenWixAccountsExceptionParams>
 */
export function rDomainTransferBetweenWixAccountsException(params) {
    return { evid: 257, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsOrderPageDomainPurchaseFatalError' event (evid: 259)
 *
 * Event description: R_SbsOrderPageDomainPurchaseFatalError.
 *
 * @param {rSbsOrderPageDomainPurchaseFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsOrderPageDomainPurchaseFatalErrorParams>} LogObject<rSbsOrderPageDomainPurchaseFatalErrorParams>
 */
export function rSbsOrderPageDomainPurchaseFatalError(params) {
    return { evid: 259, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnBuyNowFromDomainlp' event (evid: 260)
 *
 * Event description: A_ClickOnBuyNowFromDomainLP.
 *
 * @param {aClickOnBuyNowFromDomainlpParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnBuyNowFromDomainlpParams>} LogObject<aClickOnBuyNowFromDomainlpParams>
 */
export function aClickOnBuyNowFromDomainlp(params) {
    return { evid: 260, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'contributorDeniedAccesses' event (evid: 2600)
 *
 * Event description: when a contributor is trying to reach a page that only owners can see (for plan and tpa pp, look in page_name)
 *
 * @param {contributorDeniedAccessesParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} pageName - the denied page
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<contributorDeniedAccessesParams>} LogObject<contributorDeniedAccessesParams>
 */
export function contributorDeniedAccesses(params) {
    return { evid: 2600, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainFlowlp' event (evid: 261)
 *
 * Event description: V_DomainFlowLP.
 *
 * @param {vDomainFlowlpParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainFlowlpParams>} LogObject<vDomainFlowlpParams>
 */
export function vDomainFlowlp(params) {
    return { evid: 261, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainDirectLoginError' event (evid: 263)
 *
 * Event description: R_DomainDirectLoginError.
 *
 * @param {rDomainDirectLoginErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainDirectLoginErrorParams>} LogObject<rDomainDirectLoginErrorParams>
 */
export function rDomainDirectLoginError(params) {
    return { evid: 263, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vAddDomainStep1' event (evid: 27)
 *
 * Event description: V_AddDomainStep1.
 *
 * @param {vAddDomainStep1Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vAddDomainStep1Params>} LogObject<vAddDomainStep1Params>
 */
export function vAddDomainStep1(params) {
    return { evid: 27, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainDirectSuccessPage' event (evid: 274)
 *
 * Event description: V_DomainDirectSuccessPage.
 *
 * @param {vDomainDirectSuccessPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainDirectSuccessPageParams>} LogObject<vDomainDirectSuccessPageParams>
 */
export function vDomainDirectSuccessPage(params) {
    return { evid: 274, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainDirectPageLoadSuccess' event (evid: 275)
 *
 * Event description: V_DomainDirectPageLoadSuccess.
 *
 * @param {vDomainDirectPageLoadSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainDirectPageLoadSuccessParams>} LogObject<vDomainDirectPageLoadSuccessParams>
 */
export function vDomainDirectPageLoadSuccess(params) {
    return { evid: 275, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainDirectPageLoadError' event (evid: 276)
 *
 * Event description: V_DomainDirectPageLoadError.
 *
 * @param {vDomainDirectPageLoadErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainDirectPageLoadErrorParams>} LogObject<vDomainDirectPageLoadErrorParams>
 */
export function vDomainDirectPageLoadError(params) {
    return { evid: 276, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainDirectPageLoadException' event (evid: 277)
 *
 * Event description: V_DomainDirectPageLoadException.
 *
 * @param {vDomainDirectPageLoadExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainDirectPageLoadExceptionParams>} LogObject<vDomainDirectPageLoadExceptionParams>
 */
export function vDomainDirectPageLoadException(params) {
    return { evid: 277, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOndnsnext' event (evid: 28)
 *
 * Event description: connect domain popup > click on - connect another domain
 *
 * @param {aClickOndnsnextParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOndnsnextParams>} LogObject<aClickOndnsnextParams>
 */
export function aClickOndnsnext(params) {
    return { evid: 28, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainDirectSearchDomainError' event (evid: 280)
 *
 * Event description: R_DomainDirectSearchDomainError.
 *
 * @param {rDomainDirectSearchDomainErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainDirectSearchDomainErrorParams>} LogObject<rDomainDirectSearchDomainErrorParams>
 */
export function rDomainDirectSearchDomainError(params) {
    return { evid: 280, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainDirectSearchDomainException' event (evid: 281)
 *
 * Event description: R_DomainDirectSearchDomainException.
 *
 * @param {rDomainDirectSearchDomainExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainDirectSearchDomainExceptionParams>} LogObject<rDomainDirectSearchDomainExceptionParams>
 */
export function rDomainDirectSearchDomainException(params) {
    return { evid: 281, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vUpgradeBeforeConnect' event (evid: 283)
 *
 * Event description: Triggers when free users click on Connect Domain button
 *
 * @param {vUpgradeBeforeConnectParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} split_referral - referral of the modal (where it was opened from)- funnel/concierge/setupwidget
 *
 * @property {string} version - old or new modal
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} voucher - true, false
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} totalUnassignedDomains - num of domains
 * @property {string} '23' - additional_info
 * @property {string} voucherSupportedTlds - .
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {GUID} siteOwnerId - .
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} domainPermissions - .
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} totalInactiveDomains - num of domains
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} domains - list of domains
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} totalDomains - num of domains
 * @property {boolean} emptyState - true / false
 * @property {boolean} isPublished - true, false
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} locale - .
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - Where user came from
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {boolean} isPremiumPlansOnSale - .
 * @property {boolean} hasSites - If the user has sites in the account of not
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {boolean} isPremiumSite - true, false
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {string} isConcierge - true, false
 * @property {GUID} '2' - billing_session_id
 * @property {boolean} isVoucher - If the modal was at it's voucher version or not
 * @property {string} region - region
 * @property {string} totalConnectedDomains - num of domains
 * @property {string} hasValidVouchers - .
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - Where user came from
 * @property {boolean} isAccountPremium - User has at least one valid premium
 * @property {string} cruncher_pod - cruncher_pod
 * @property {string} place - empty_state | connectdomain_topbanner
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {boolean} isPremium - true, false
 * @property {string} totalAssignedDomains - num of domains
 * @property {string} sites - .
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} hosting - .
 * @property {number} limit - .
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {string} action - view | select_plan | close | transfer_your_domain | learn_more
 * @property {boolean} isSale - if the modal was on its sale version or not
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vUpgradeBeforeConnectParams>} LogObject<vUpgradeBeforeConnectParams>
 */
export function vUpgradeBeforeConnect(params) {
    return { evid: 283, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickAttachDomainToSite' event (evid: 284)
 *
 * Event description: A_ClickAttachDomainToSite.
 *
 * @param {aClickAttachDomainToSiteParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - additional_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickAttachDomainToSiteParams>} LogObject<aClickAttachDomainToSiteParams>
 */
export function aClickAttachDomainToSite(params) {
    return { evid: 284, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aSearchNewDomain' event (evid: 285)
 *
 * Event description: A_SearchNewDomain
 *
 * @param {aSearchNewDomainParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} name - name
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} totalUnassignedDomains - total_unassigned_domains
 * @property {string} '23' - additional_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} totalInactiveDomains - total_inactive_domains
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} totalDomains - total_domains
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {string} totalConnectedDomains - total_connected_domains
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - is_account_premium
 * @property {string} cruncher_pod - cruncher_pod
 * @property {string} reseller - reseller uuid
 * @property {string} pageType - default, reseller
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {boolean} isPremium - is_premium
 * @property {string} totalAssignedDomains - total_assigned_domains
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aSearchNewDomainParams>} LogObject<aSearchNewDomainParams>
 */
export function aSearchNewDomain(params) {
    return { evid: 285, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickConnectDomainNextButton' event (evid: 286)
 *
 * Event description: A_ClickConnectDomainNextButton.
 *
 * @param {aClickConnectDomainNextButtonParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} voucher - true/false
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - additional_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} pagetype - page_type
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral additiona linfo
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral additiona linfo
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickConnectDomainNextButtonParams>} LogObject<aClickConnectDomainNextButtonParams>
 */
export function aClickConnectDomainNextButton(params) {
    return { evid: 286, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickConnectDomainPreviousButton' event (evid: 287)
 *
 * Event description: A_ClickConnectDomainPreviousButton.
 *
 * @param {aClickConnectDomainPreviousButtonParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - additional_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickConnectDomainPreviousButtonParams>} LogObject<aClickConnectDomainPreviousButtonParams>
 */
export function aClickConnectDomainPreviousButton(params) {
    return { evid: 287, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vConnectDomainConfirmationFailurePage' event (evid: 289)
 *
 * Event description: V_ConnectDomainConfirmationFailurePage.
 *
 * @param {vConnectDomainConfirmationFailurePageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - additional_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vConnectDomainConfirmationFailurePageParams>} LogObject<vConnectDomainConfirmationFailurePageParams>
 */
export function vConnectDomainConfirmationFailurePage(params) {
    return { evid: 289, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnPointingNext' event (evid: 29)
 *
 * Event description: A_ClickOnPointingNext.
 *
 * @param {aClickOnPointingNextParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnPointingNextParams>} LogObject<aClickOnPointingNextParams>
 */
export function aClickOnPointingNext(params) {
    return { evid: 29, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vUpgradeBeforeDomainPurchase' event (evid: 290)
 *
 * Event description: Premium Upgrade Pop-Up appears when a user without premium clicks on 'Get it' CTA on the domain search
 *
 * @param {vUpgradeBeforeDomainPurchaseParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} intent - connect or get
 * @property {string} version - indicating if was opened as a modal or new tab
 * @property {string} splitReferral - referral of the split page (where it was opened from)- concierge/funnel/storefront
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel/accountLevel/ focusWidget  / express-checkout
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} voucher - true / false
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} voucherSupportedTlds - .
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {GUID} siteOwnerId - .
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} domainPermissions - .
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - clicked domain name
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} locale - .
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - where a user came from to the page
 * @property {string} browser_family - browser_family
 * @property {boolean} isModal - true, false (is viewed via modal)
 * @property {string} bot_name - bot_name
 * @property {string} '31' - clicked domain name
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {boolean} isPremiumPlansOnSale - .
 * @property {boolean} hasSites - If the user has sites in the account
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {boolean} isPremiumSite - true, false
 * @property {number} '20' - cancel_reason
 * @property {string} actionName - view / upgrade_now / buy_domain / bundle_domain_plan / click_collapse
 * @property {number} '27' - email_provider
 * @property {string} isConcierge - true,false
 * @property {GUID} '2' - billing_session_id
 * @property {boolean} isVoucher - if the modal was at it's voucher version or not
 * @property {string} region - region
 * @property {string} hasValidVouchers - .
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - where a user came from to the page
 * @property {boolean} isAccountPremium - true, false
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {boolean} isPremium - true, false
 * @property {string} sites - .
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} hosting - null / dashboard
 * @property {number} limit - .
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {boolean} isSale - if the modal was at it's sale version or not
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} domains - list
 * @property {boolean} emptystate - emptystate
 * @property {number} totalassigneddomains - totalassigneddomains
 * @property {number} totalconnecteddomains - totalconnecteddomains
 * @property {number} totaldomains - totaldomains
 * @property {number} totalinactivedomains - totalinactivedomains
 * @property {number} totalunassigneddomains - totalunassigneddomains
 * @return {LogObject<vUpgradeBeforeDomainPurchaseParams>} LogObject<vUpgradeBeforeDomainPurchaseParams>
 */
export function vUpgradeBeforeDomainPurchase(params) {
    return { evid: 290, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aSbsDomainPurchaseBuyButtonPressedYandex' event (evid: 292)
 *
 * Event description: A_SbsDomainPurchaseBuyButtonPressedYandex.
 *
 * @param {aSbsDomainPurchaseBuyButtonPressedYandexParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aSbsDomainPurchaseBuyButtonPressedYandexParams>} LogObject<aSbsDomainPurchaseBuyButtonPressedYandexParams>
 */
export function aSbsDomainPurchaseBuyButtonPressedYandex(params) {
    return { evid: 292, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainChangeContactsSuccess' event (evid: 293)
 *
 * Event description: R_DomainChangeContactsSuccess.
 *
 * @param {rDomainChangeContactsSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} fieldsUpdated - fields_updated
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {boolean} emailChanged - email_changed
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainChangeContactsSuccessParams>} LogObject<rDomainChangeContactsSuccessParams>
 */
export function rDomainChangeContactsSuccess(params) {
    return { evid: 293, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainChangeContactsError' event (evid: 294)
 *
 * Event description: R_DomainChangeContactsError.
 *
 * @param {rDomainChangeContactsErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainChangeContactsErrorParams>} LogObject<rDomainChangeContactsErrorParams>
 */
export function rDomainChangeContactsError(params) {
    return { evid: 294, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainChangeContactsException' event (evid: 295)
 *
 * Event description: R_DomainChangeContactsException.
 *
 * @param {rDomainChangeContactsExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainChangeContactsExceptionParams>} LogObject<rDomainChangeContactsExceptionParams>
 */
export function rDomainChangeContactsException(params) {
    return { evid: 295, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainManageTab' event (evid: 297)
 *
 * Event description: client
 *
 * @param {vDomainManageTabParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - additional_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainManageTabParams>} LogObject<vDomainManageTabParams>
 */
export function vDomainManageTab(params) {
    return { evid: 297, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainManageBuyMailBox' event (evid: 298)
 *
 * Event description: A_DomainManageBuyMailBox.
 *
 * @param {aDomainManageBuyMailBoxParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - additional_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainManageBuyMailBoxParams>} LogObject<aDomainManageBuyMailBoxParams>
 */
export function aDomainManageBuyMailBox(params) {
    return { evid: 298, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vOwnerRestrictedAreaError' event (evid: 299)
 *
 * Event description: V_OwnerRestrictedAreaError.
 *
 * @param {vOwnerRestrictedAreaErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vOwnerRestrictedAreaErrorParams>} LogObject<vOwnerRestrictedAreaErrorParams>
 */
export function vOwnerRestrictedAreaError(params) {
    return { evid: 299, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vVoucher' event (evid: 3)
 *
 * Event description: V_Voucher
 *
 * @param {vVoucherParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} pageView - page_view
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {string} extraInfo - uuid
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vVoucherParams>} LogObject<vVoucherParams>
 */
export function vVoucher(params) {
    return { evid: 3, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickHereDomainsPage' event (evid: 30)
 *
 * Event description: since 1.6.22 - domain purchase was blocked due to fraud suspicious according to the new domains fraud detection logic
 *
 * @param {aClickHereDomainsPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickHereDomainsPageParams>} LogObject<aClickHereDomainsPageParams>
 */
export function aClickHereDomainsPage(params) {
    return { evid: 30, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPlimusProcessPayment' event (evid: 300)
 *
 * Event description: A_Plimus_ProcessPayment.
 *
 * @param {aPlimusProcessPaymentParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPlimusProcessPaymentParams>} LogObject<aPlimusProcessPaymentParams>
 */
export function aPlimusProcessPayment(params) {
    return { evid: 300, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rWixPpSiteHasVerticalPackagePicker' event (evid: 3000)
 *
 * Event description: R_Wix_PP_SiteHasVerticalPackagePicker.
 *
 * @param {rWixPpSiteHasVerticalPackagePickerParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rWixPpSiteHasVerticalPackagePickerParams>} LogObject<rWixPpSiteHasVerticalPackagePickerParams>
 */
export function rWixPpSiteHasVerticalPackagePicker(params) {
    return { evid: 3000, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPlimusChangeCurrency' event (evid: 301)
 *
 * Event description: A_Plimus_ChangeCurrency.
 *
 * @param {aPlimusChangeCurrencyParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPlimusChangeCurrencyParams>} LogObject<aPlimusChangeCurrencyParams>
 */
export function aPlimusChangeCurrency(params) {
    return { evid: 301, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPlimusRecalcCoupon' event (evid: 302)
 *
 * Event description: A_Plimus_RecalcCoupon.
 *
 * @param {aPlimusRecalcCouponParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPlimusRecalcCouponParams>} LogObject<aPlimusRecalcCouponParams>
 */
export function aPlimusRecalcCoupon(params) {
    return { evid: 302, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPlimusRegister' event (evid: 303)
 *
 * Event description: A_Plimus_Register.
 *
 * @param {aPlimusRegisterParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPlimusRegisterParams>} LogObject<aPlimusRegisterParams>
 */
export function aPlimusRegister(params) {
    return { evid: 303, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPlimusRestart' event (evid: 304)
 *
 * Event description: A_Plimus_Restart.
 *
 * @param {aPlimusRestartParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPlimusRestartParams>} LogObject<aPlimusRestartParams>
 */
export function aPlimusRestart(params) {
    return { evid: 304, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPlimusChangeLanguage' event (evid: 305)
 *
 * Event description: A_Plimus_ChangeLanguage.
 *
 * @param {aPlimusChangeLanguageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPlimusChangeLanguageParams>} LogObject<aPlimusChangeLanguageParams>
 */
export function aPlimusChangeLanguage(params) {
    return { evid: 305, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPlimusBuynowVisit' event (evid: 306)
 *
 * Event description: A_Plimus_BuynowVisit.
 *
 * @param {aPlimusBuynowVisitParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPlimusBuynowVisitParams>} LogObject<aPlimusBuynowVisitParams>
 */
export function aPlimusBuynowVisit(params) {
    return { evid: 306, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'event307PleaseGiveMeAName' event (evid: 307)
 *
 * Event description: V_DomainPurchaseSuccessGetMailbox.
 *
 * @param {event307PleaseGiveMeANameParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<event307PleaseGiveMeANameParams>} LogObject<event307PleaseGiveMeANameParams>
 */
export function event307PleaseGiveMeAName(params) {
    return { evid: 307, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickTransferAwayFromWix' event (evid: 308)
 *
 * Event description: Click Transfer away from Wix.
 *
 * @param {clickTransferAwayFromWixParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - eligible / not eligible
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<clickTransferAwayFromWixParams>} LogObject<clickTransferAwayFromWixParams>
 */
export function clickTransferAwayFromWix(params) {
    return { evid: 308, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchDomainSearchResultView' event (evid: 309)
 *
 * Event description: Search domain results view.
 *
 * @param {searchDomainSearchResultViewParams} params - The parameters for this event
 * @property {number} responseSpeed - response time between click on search button and search result view
 * @property {number} numOfSuggestions - number of suggestions appeared
 * @property {string} viewMode - concierge , purchase, focusWidget
 * @property {string} voucher - true | false
 * @property {string} conciergeStatus - search results error (only from concierge)
 * @property {string} voucherSupportedTlds - .
 * @property {string} assignmentStatus - .
 * @property {GUID} siteOwnerId - .
 * @property {boolean} preTyped - was domain pre-filled or typed by user
 * @property {string} domainPermissions - .
 * @property {number} numOfLabels - number of labeled suggestions appeared
 * @property {string} domain - .
 * @property {GUID} uuid - uuid
 * @property {string} searchTerm - searched domain
 * @property {string} result - array of suggested domains/available/error message
 * @property {string} domains - .
 * @property {string} suggestions - .
 * @property {string} locale - .
 * @property {string} transferInState - .
 * @property {boolean} isModal - true, false (is viewed via modal)
 * @property {boolean} isPremiumPlansOnSale - true, false
 * @property {boolean} isUnsupported - true, false
 * @property {boolean} isPremiumSite - true / false
 * @property {string} connectionStatus - domain connection status
 * @property {boolean} isVoucher - true / false
 * @property {string} hasValidVouchers - .
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {boolean} isAccountPremium - true / false
 * @property {string} requestId - request_id
 * @property {boolean} isAvailable - true, false
 * @property {boolean} isTaken - true, false
 * @property {boolean} isPremium - true / false
 * @property {string} sites - .
 * @property {string} suggestionsList - complex results
 * @property {string} type - suggestions/available/error/pending_transfer_completion
 * @property {string} hosting - null / dashboard
 * @property {string} unassignedDomains - .
 * @property {number} limit - .
 * @property {GUID} msid - msid
 * @property {boolean} isSale - true / false
 * @property {GUID} sourceMsid - msid which the domain is assigned to
 * @property {string} intent - get/connect
 * @property {boolean} IsBundleEligible - true,false
 * @property {string} PageSource - Marketing gate source
 * @property {string} funnelDomainFlow - get domain/connect/domain
 * for new funnel flow
 * @property {number} NumFiltersActive - amount of filters active in view
 * @property {string} ActiveFilters - string of all active filters
 * @property {boolean} IsPremiumDomain - true, false
 * @return {LogObject<searchDomainSearchResultViewParams>} LogObject<searchDomainSearchResultViewParams>
 */
export function searchDomainSearchResultView(params) {
    return { evid: 309, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickHereStep1' event (evid: 31)
 *
 * Event description: A_ClickHereStep1.
 *
 * @param {aClickHereStep1Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickHereStep1Params>} LogObject<aClickHereStep1Params>
 */
export function aClickHereStep1(params) {
    return { evid: 31, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchDomainClickGetIt' event (evid: 310)
 *
 * Event description: Click on "Get it" button in the domain search
 *
 * @param {searchDomainClickGetItParams} params - The parameters for this event
 * @property {number} responseSpeed - response time between search result view and click get it
 * @property {string} viewMode - purchase , concierge, focusWidget
 * @property {string} voucher - true | false
 * @property {string} domain - clicked domain
 * @property {GUID} uuid - uuid
 * @property {string} searchTerm - searched domain
 * @property {string} locale - .
 * @property {boolean} isModal - true, false (is viewed via modal)
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} hasValidVouchers - .
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {boolean} isAccountPremium - true, false
 * @property {number} position - 0 - search/1+ - suggestions
 * @property {boolean} isPremium - true, false
 * @property {string} type - search/suggestions/secondary
 * @property {string} hosting - null / dashboard
 * @property {GUID} msid - msid
 * @property {boolean} isSale - true, false
 * @property {string} intent - get/connect
 * @property {string} second_domain_name - domain name in bundle offering
 * @property {boolean} IsPremiumDomain - true,false
 * @return {LogObject<searchDomainClickGetItParams>} LogObject<searchDomainClickGetItParams>
 */
export function searchDomainClickGetIt(params) {
    return { evid: 310, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumPurchaseDataSuccess' event (evid: 3100)
 *
 * Event description: R_PremiumPurchaseDataSuccess.
 *
 * @param {rPremiumPurchaseDataSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPremiumPurchaseDataSuccessParams>} LogObject<rPremiumPurchaseDataSuccessParams>
 */
export function rPremiumPurchaseDataSuccess(params) {
    return { evid: 3100, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumPurchaseDataError' event (evid: 3101)
 *
 * Event description: R_PremiumPurchaseDataError.
 *
 * @param {rPremiumPurchaseDataErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPremiumPurchaseDataErrorParams>} LogObject<rPremiumPurchaseDataErrorParams>
 */
export function rPremiumPurchaseDataError(params) {
    return { evid: 3101, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumPurchaseDataException' event (evid: 3102)
 *
 * Event description: R_PremiumPurchaseDataException.
 *
 * @param {rPremiumPurchaseDataExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPremiumPurchaseDataExceptionParams>} LogObject<rPremiumPurchaseDataExceptionParams>
 */
export function rPremiumPurchaseDataException(params) {
    return { evid: 3102, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumOrderPageSubmitSuccess' event (evid: 3103)
 *
 * Event description: R_PremiumOrderPageSubmitSuccess.
 *
 * @param {rPremiumOrderPageSubmitSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - eventAggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - abTesting
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - abTesting
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - abTesting
 * @return {LogObject<rPremiumOrderPageSubmitSuccessParams>} LogObject<rPremiumOrderPageSubmitSuccessParams>
 */
export function rPremiumOrderPageSubmitSuccess(params) {
    return { evid: 3103, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumOrderPageSubmitPending' event (evid: 3104)
 *
 * Event description: R_PremiumOrderPageSubmitPending.
 *
 * @param {rPremiumOrderPageSubmitPendingParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - paymentMethod
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} ppType - pp_type
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - paymentMethod
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rPremiumOrderPageSubmitPendingParams>} LogObject<rPremiumOrderPageSubmitPendingParams>
 */
export function rPremiumOrderPageSubmitPending(params) {
    return { evid: 3104, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vPremiumErrorPage' event (evid: 3105)
 *
 * Event description: User is blacklist or blocked in SBS
 *
 * @param {vPremiumErrorPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vPremiumErrorPageParams>} LogObject<vPremiumErrorPageParams>
 */
export function vPremiumErrorPage(params) {
    return { evid: 3105, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainRenewSuccessExtend' event (evid: 311)
 *
 * Event description: Domain extend success (from 2018-08-23)
 *
 * @param {domainRenewSuccessExtendParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<domainRenewSuccessExtendParams>} LogObject<domainRenewSuccessExtendParams>
 */
export function domainRenewSuccessExtend(params) {
    return { evid: 311, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPrivacyChanged' event (evid: 312)
 *
 * Event description: Triggered when a user turns privacy on\off at Edit Contact Info page
 *
 * @param {rDomainPrivacyChangedParams} params - The parameters for this event
 * @property {string} domain - Domain name
 * @property {GUID} uuid - User guid
 * @property {boolean} isEnabled - Status of privacy protection
 * @return {LogObject<rDomainPrivacyChangedParams>} LogObject<rDomainPrivacyChangedParams>
 */
export function rDomainPrivacyChanged(params) {
    return { evid: 312, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPrivacyChangeError' event (evid: 313)
 *
 * Event description: Triggered when an error occurred during Privacy Change action on Edit Contact Info page
 *
 * @param {rDomainPrivacyChangeErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error info
 * @property {string} domain - Domain name
 * @property {GUID} uuid - User guid
 * @property {boolean} isEnabled - Intention of privacy protection change
 * @return {LogObject<rDomainPrivacyChangeErrorParams>} LogObject<rDomainPrivacyChangeErrorParams>
 */
export function rDomainPrivacyChangeError(params) {
    return { evid: 313, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'entriFlowDomainIsEligibleSrc17Evid314' event (evid: 314)
 *
 * Event description: Serverless event. user is enabled to Entri flow (triggered on eligibility check = TRUE). Connect Domain
 *
 * @param {entriFlowDomainIsEligibleSrc17Evid314Params} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - original referral additional info
 * @property {GUID} msid - msid
 * @property {string} viewMode - serverless
 * @property {boolean} isEligible - true, false
 * @property {string} provider - provider name
 * @return {LogObject<entriFlowDomainIsEligibleSrc17Evid314Params>} LogObject<entriFlowDomainIsEligibleSrc17Evid314Params>
 */
export function entriFlowDomainIsEligibleSrc17Evid314(params) {
    return { evid: 314, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'featureManagerFeatureChangedStatus' event (evid: 31415)
 *
 * Event description: Feature Manager - Feature Changed Status.
 *
 * @param {featureManagerFeatureChangedStatusParams} params - The parameters for this event
 * @property {string} scope - scope
 * @property {string} featureEvent - enabled/disabled/canceled/updated
 * @property {GUID} userId - user_id
 * @property {string} uniqueName - Feature Name
 * @return {LogObject<featureManagerFeatureChangedStatusParams>} LogObject<featureManagerFeatureChangedStatusParams>
 */
export function featureManagerFeatureChangedStatus(params) {
    return { evid: 31415, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'resellerManagementRedirectUrlView' event (evid: 315)
 *
 * Event description: reseller redirect url shown
 *
 * @param {resellerManagementRedirectUrlViewParams} params - The parameters for this event
 * @property {GUID} reseller_uuid - reseller uuid
 * @property {string} referralAdditionalInfo - referral additional info (origin CTA)
 * @property {string} reseller - reseller name
 * @property {string} subscriptionType - plan, ascend
 * @property {GUID} msid - site msid
 * @return {LogObject<resellerManagementRedirectUrlViewParams>} LogObject<resellerManagementRedirectUrlViewParams>
 */
export function resellerManagementRedirectUrlView(params) {
    return { evid: 315, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'resellerManagementRedirectUrlClick' event (evid: 316)
 *
 * Event description: reseller redirect url click
 *
 * @param {resellerManagementRedirectUrlClickParams} params - The parameters for this event
 * @property {GUID} reseller_uuid - reseller uuid
 * @property {string} clickType - upgrade, learn_more
 * @property {string} referralAdditionalInfo - referral additional info (origin CTA)
 * @property {string} reseller - reseller name
 * @property {string} subscriptionType - plan, ascend
 * @property {GUID} msid - site msid
 * @return {LogObject<resellerManagementRedirectUrlClickParams>} LogObject<resellerManagementRedirectUrlClickParams>
 */
export function resellerManagementRedirectUrlClick(params) {
    return { evid: 316, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'resellerRedirectRedirectEvent' event (evid: 317)
 *
 * Event description: redirect event upon upgrade click
 *
 * @param {resellerRedirectRedirectEventParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} redirectUrl - redirect URL
 * @property {string} packagePickerType - package_picker_type
 * @property {string} flowType - upgrade / change_plan
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} productTypeId - product type guid
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} reseller - reseller name
 * @property {Url} referer - referer
 * @property {string} subscriptionType - plan, ascend
 * @property {GUID} msid - msid
 * @property {GUID} resellerUuid - reseller uuid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<resellerRedirectRedirectEventParams>} LogObject<resellerRedirectRedirectEventParams>
 */
export function resellerRedirectRedirectEvent(params) {
    return { evid: 317, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sbsToProvisionedPremiumsMigration' event (evid: 318)
 *
 * Event description: Migration of SBS premiums to Provisioned premiums (old premiums are cancelled and new premiums are created via packages API)
 *
 * @param {sbsToProvisionedPremiumsMigrationParams} params - The parameters for this event
 * @property {string} oldProductGuId - old product id via SBS
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - new subscription_id via packages API (provisioned)
 * @property {GUID} oldSubscriptionId - old subscription_id via SBS
 * @property {string} productId - new product id via packages API (provisioned)
 * @property {GUID} msid - msid
 * @property {number} cycleId - cycle (stayed the same as old)
 * @return {LogObject<sbsToProvisionedPremiumsMigrationParams>} LogObject<sbsToProvisionedPremiumsMigrationParams>
 */
export function sbsToProvisionedPremiumsMigration(params) {
    return { evid: 318, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfNoCheckoutFlowToastShown' event (evid: 319)
 *
 * Event description: No-Checkout Flow toast shown
 *
 * @param {copyOfNoCheckoutFlowToastShownParams} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {string} name - toast name
 * @property {string} productTypeName - product_type_name - not sent!!
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product id
 * @property {string} type - 'error', 'warning', 'success'
 * @property {GUID} msid - msid
 * @return {LogObject<copyOfNoCheckoutFlowToastShownParams>} LogObject<copyOfNoCheckoutFlowToastShownParams>
 */
export function copyOfNoCheckoutFlowToastShown(params) {
    return { evid: 319, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'nPurPagePaymentPageLoaded' event (evid: 320)
 *
 * Event description: client - like 942
 *
 * @param {nPurPagePaymentPageLoadedParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - the same as eventAggregator
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<nPurPagePaymentPageLoadedParams>} LogObject<nPurPagePaymentPageLoadedParams>
 */
export function nPurPagePaymentPageLoaded(params) {
    return { evid: 320, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPurchasePageChangeProduct' event (evid: 3201)
 *
 * Event description: Boleto: When choosing Monthly plan, user clicks on 'ok' and the the product is changed to Yearly plan
 *
 * @param {aPurchasePageChangeProductParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPurchasePageChangeProductParams>} LogObject<aPurchasePageChangeProductParams>
 */
export function aPurchasePageChangeProduct(params) {
    return { evid: 3201, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vPurchasePagePaymentSlipView' event (evid: 3202)
 *
 * Event description: Wix payment slip opened
 *
 * @param {vPurchasePagePaymentSlipViewParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {string} productGuid - product_guid
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} flowType - flow_type
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {string} productId - product_guid
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<vPurchasePagePaymentSlipViewParams>} LogObject<vPurchasePagePaymentSlipViewParams>
 */
export function vPurchasePagePaymentSlipView(params) {
    return { evid: 3202, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPurchasePagePaymentSlipClose' event (evid: 3203)
 *
 * Event description: Boleto > A_PurchasePagePaymentSlipClose.
 *
 * @param {aPurchasePagePaymentSlipCloseParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPurchasePagePaymentSlipCloseParams>} LogObject<aPurchasePagePaymentSlipCloseParams>
 */
export function aPurchasePagePaymentSlipClose(params) {
    return { evid: 3203, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPurchasePageShowCvvSrc17Evid3208' event (evid: 3208)
 *
 * Event description: A_PurchasePageShowCvv
 *
 * @param {aPurchasePageShowCvvSrc17Evid3208Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPurchasePageShowCvvSrc17Evid3208Params>} LogObject<aPurchasePageShowCvvSrc17Evid3208Params>
 */
export function aPurchasePageShowCvvSrc17Evid3208(params) {
    return { evid: 3208, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'nPurPageClickOnBuyNow' event (evid: 321)
 *
 * Event description: client - like 178
 *
 * @param {nPurPageClickOnBuyNowParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} billingAccountGuid - billing_account_guid
 * @property {string} externalSessionId - the same as eventAggregator
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} totalAmount - total_amount_submit
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiator_name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<nPurPageClickOnBuyNowParams>} LogObject<nPurPageClickOnBuyNowParams>
 */
export function nPurPageClickOnBuyNow(params) {
    return { evid: 321, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPurchasePageShowCvv' event (evid: 3210)
 *
 * Event description: A_PurchasePageShowCvv.
 *
 * @param {aPurchasePageShowCvvParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPurchasePageShowCvvParams>} LogObject<aPurchasePageShowCvvParams>
 */
export function aPurchasePageShowCvv(params) {
    return { evid: 3210, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'nPurPageValidationError' event (evid: 322)
 *
 * Event description: client - like 105
 *
 * @param {nPurPageValidationErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {boolean} invoiceDetailsSeenByUser - ind if invoice details seen by user
 * @property {string} packagePickerType - package_picker_type
 * @property {string} errorInfo - error
 * @property {string} externalSessionId - the same as eventAggregator
 * @property {GUID} uuid - uuid
 * @property {string} errorKey - error_key
 * @property {number} paymentMethod - paymentMethod
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} errorInfoCashierIFrame - cashier I-Frame error
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} errorCode - checkout_error_code
 * @property {GUID} packageGuid - package_id
 * @property {string} actionType - submit, changeCountry, invalidStateOrZip, removingCoupon, applyingCoupon, changePaymentSource, changeVatId
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiator_name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} billingAccountGuid - Billing account guid of submited BA
 * @property {string} searchedBillingAccountGuid - list of billing accounts that were returned on search
 *
 * @property {string} searchText - searchText
 * @property {boolean} isSubmitWithSaved - Is submit with saved PM
 * @return {LogObject<nPurPageValidationErrorParams>} LogObject<nPurPageValidationErrorParams>
 */
export function nPurPageValidationError(params) {
    return { evid: 322, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'nPurPageBusinessError' event (evid: 323)
 *
 * Event description: client - like 176
 *
 * @param {nPurPageBusinessErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} errorInfo - error
 * @property {string} externalSessionId - the same as eventAggregator
 * @property {GUID} uuid - uuid
 * @property {string} errorKey - error_key
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} errorCode - checkout_error_code
 * @property {GUID} packageGuid - package_id
 * @property {string} actionType - submit, changeCountry, invalidStateOrZip, removingCoupon, applyingCoupon, changePaymentSource, changeVatId
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiator_name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<nPurPageBusinessErrorParams>} LogObject<nPurPageBusinessErrorParams>
 */
export function nPurPageBusinessError(params) {
    return { evid: 323, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'nPurPageFatalError' event (evid: 324)
 *
 * Event description: client - like 177 (only after the user click on "buy")
 *
 * @param {nPurPageFatalErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} errorInfo - error
 * @property {string} externalSessionId - the same as eventAggregator
 * @property {GUID} uuid - uuid
 * @property {string} errorKey - error_key
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} errorCode - checkout_error_code
 * @property {GUID} packageGuid - package_id
 * @property {string} actionType - submit, changeCountry, invalidStateOrZip, removingCoupon, applyingCoupon, changePaymentSource, changeVatId
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiator_name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<nPurPageFatalErrorParams>} LogObject<nPurPageFatalErrorParams>
 */
export function nPurPageFatalError(params) {
    return { evid: 324, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainEditContactInfoPrivacyShowMoreSrc17Evid325' event (evid: 325)
 *
 * Event description: on domain Edit Contact Info page , when user clicks "Show more" on the Privacy section
 *
 * @param {domainEditContactInfoPrivacyShowMoreSrc17Evid325Params} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} privacyType - privacy | privacy_and_dnssec
 * @property {string} action - show_more
 * @return {LogObject<domainEditContactInfoPrivacyShowMoreSrc17Evid325Params>} LogObject<domainEditContactInfoPrivacyShowMoreSrc17Evid325Params>
 */
export function domainEditContactInfoPrivacyShowMoreSrc17Evid325(params) {
    return { evid: 325, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPagePmLoadingError' event (evid: 326)
 *
 * Event description: Checkout Page > PM Loading Error
 *
 * @param {checkoutPagePmLoadingErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {string} paymentMethodType - the name
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPagePmLoadingErrorParams>} LogObject<checkoutPagePmLoadingErrorParams>
 */
export function checkoutPagePmLoadingError(params) {
    return { evid: 326, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'conciergeDomainConnectionStatusCta' event (evid: 327)
 *
 * Event description: click on CTA when Domain Status is shown in concierge,
 *
 * @param {conciergeDomainConnectionStatusCtaParams} params - The parameters for this event
 * @property {string} voucher - true, false
 * @property {string} uuid - uuid
 * @property {string} domainStatus - in_verification, in_propagation, other, expired_grace, expired_redemption
 * @property {boolean} isPremiumSite - true, false
 * @property {string} type - check_domain_status, view_instructions, extend, learn_how__to_get_your_domain_back
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - referal
 * @return {LogObject<conciergeDomainConnectionStatusCtaParams>} LogObject<conciergeDomainConnectionStatusCtaParams>
 */
export function conciergeDomainConnectionStatusCta(params) {
    return { evid: 327, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planPurchaseViewSuccessPageAssignDomainCta' event (evid: 328)
 *
 * Event description: CTAs on Premium purchases > view success page
 *
 * @param {planPurchaseViewSuccessPageAssignDomainCtaParams} params - The parameters for this event
 * @property {string} voucher - true, false, null
 * @property {string} externalSessionId - session id
 * @property {string} domain - domain
 * @property {string} uuid - uuid
 * @property {string} pageView - success_page_assign_domain
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} productGuid - product guid
 * @property {GUID} msid - msid
 * @property {string} couponId - coupon
 * @property {string} action - assign_your_domain, get_voucher, connect_domain, go_to_side_dashboard
 * @property {string} abTesting - ab test value (success_page_assign_domain)
 * @return {LogObject<planPurchaseViewSuccessPageAssignDomainCtaParams>} LogObject<planPurchaseViewSuccessPageAssignDomainCtaParams>
 */
export function planPurchaseViewSuccessPageAssignDomainCta(params) {
    return { evid: 328, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planPurchaseViewSuccessPageAssignDomain' event (evid: 329)
 *
 * Event description: plan purchase success page - assign domain intent
 *
 * @param {planPurchaseViewSuccessPageAssignDomainParams} params - The parameters for this event
 * @property {string} abTest - success_page_assign_domain
 * @property {string} externalSessionId - session_id
 * @property {string} domain - domain (if applicable)
 * @property {number} cycleid - cycle_id
 * @property {GUID} siteid - site_id
 * @property {string} referralAdditionalInfo - referral
 * @property {number} productId - product_id
 * @property {GUID} packageId - package_id
 * @property {string} productGuid - product guid
 * @property {GUID} couponId - coupon_id
 * @return {LogObject<planPurchaseViewSuccessPageAssignDomainParams>} LogObject<planPurchaseViewSuccessPageAssignDomainParams>
 */
export function planPurchaseViewSuccessPageAssignDomain(params) {
    return { evid: 329, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnUpgradeLinkDomainsPage' event (evid: 33)
 *
 * Event description: A_ClickOnUpgradeLinkDomainsPage.
 *
 * @param {aClickOnUpgradeLinkDomainsPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnUpgradeLinkDomainsPageParams>} LogObject<aClickOnUpgradeLinkDomainsPageParams>
 */
export function aClickOnUpgradeLinkDomainsPage(params) {
    return { evid: 33, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainProtocolCreateADomainRecord' event (evid: 330)
 *
 * Event description: This event triggers when a user try to connect domain throw DCP. If attempt is successful we create a record in user_domain_info (with mgmt_type = pointing )
 *
 * @param {connectDomainProtocolCreateADomainRecordParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {GUID} uuid - uuid
 * @property {string} registrar - registrar name
 * @return {LogObject<connectDomainProtocolCreateADomainRecordParams>} LogObject<connectDomainProtocolCreateADomainRecordParams>
 */
export function connectDomainProtocolCreateADomainRecord(params) {
    return { evid: 330, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vUpdatePaymentPage' event (evid: 3300)
 *
 * Event description: V_UpdatePaymentPage.
 *
 * @param {vUpdatePaymentPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vUpdatePaymentPageParams>} LogObject<vUpdatePaymentPageParams>
 */
export function vUpdatePaymentPage(params) {
    return { evid: 3300, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aUpdatePaymentPageReady' event (evid: 3301)
 *
 * Event description: Frog -  A_UpdatePaymentPageReady
 *
 * @param {aUpdatePaymentPageReadyParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aUpdatePaymentPageReadyParams>} LogObject<aUpdatePaymentPageReadyParams>
 */
export function aUpdatePaymentPageReady(params) {
    return { evid: 3301, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aUpdatePaymentSubmit' event (evid: 3302)
 *
 * Event description: Frog
 *
 * @param {aUpdatePaymentSubmitParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} cancelTextReason - cancel_text_reason
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aUpdatePaymentSubmitParams>} LogObject<aUpdatePaymentSubmitParams>
 */
export function aUpdatePaymentSubmit(params) {
    return { evid: 3302, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rUpdatePaymentSuccess' event (evid: 3303)
 *
 * Event description: Frog
 *
 * @param {rUpdatePaymentSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {string} services - List of updated services in case of UPM
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {GUID} billingAccountGuid - billing_account_guid
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - externalsessionid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} updateType - same_site/same_PM/all/only
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} billingAccountType - billing_account_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator name from checkout
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} cancelTextReason - cancel_text_reason
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @property {string} invoiceId - invoice_ids of succesfull invoices
 * @return {LogObject<rUpdatePaymentSuccessParams>} LogObject<rUpdatePaymentSuccessParams>
 */
export function rUpdatePaymentSuccess(params) {
    return { evid: 3303, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rUpdatePaymentBusinessError' event (evid: 3304)
 *
 * Event description: Frog
 *
 * @param {rUpdatePaymentBusinessErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rUpdatePaymentBusinessErrorParams>} LogObject<rUpdatePaymentBusinessErrorParams>
 */
export function rUpdatePaymentBusinessError(params) {
    return { evid: 3304, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rUpdatePaymentValidationError' event (evid: 3305)
 *
 * Event description: Frog
 *
 * @param {rUpdatePaymentValidationErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rUpdatePaymentValidationErrorParams>} LogObject<rUpdatePaymentValidationErrorParams>
 */
export function rUpdatePaymentValidationError(params) {
    return { evid: 3305, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rUpdatePaymentFatalError' event (evid: 3306)
 *
 * Event description: Frog
 *
 * @param {rUpdatePaymentFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rUpdatePaymentFatalErrorParams>} LogObject<rUpdatePaymentFatalErrorParams>
 */
export function rUpdatePaymentFatalError(params) {
    return { evid: 3306, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updatePmSelectUpdateTypePopupView1st' event (evid: 3307)
 *
 * Event description: first page, when you have more than one active subscription
 *
 * @param {updatePmSelectUpdateTypePopupView1stParams} params - The parameters for this event
 * @property {string} viewMode - view_mode as of 11:28
 * @property {string} availableUpdateTypes - available options: same_site/same_PM/all/only
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} subscriptionType - subscriptionType
 * @property {GUID} msid - msid
 * @return {LogObject<updatePmSelectUpdateTypePopupView1stParams>} LogObject<updatePmSelectUpdateTypePopupView1stParams>
 */
export function updatePmSelectUpdateTypePopupView1st(params) {
    return { evid: 3307, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updatePmSelectUpdateTypePopupClick' event (evid: 3308)
 *
 * Event description: first page, action click
 *
 * @param {updatePmSelectUpdateTypePopupClickParams} params - The parameters for this event
 * @property {string} services - Services the user chooses to update
 * @property {string} viewMode - view_mode as of 11:28
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - cancel/next/back
 * @property {string} subscriptionType - subscriptionType
 * @property {string} update_type - Update type the user choose ( from 17:3307)
 * @return {LogObject<updatePmSelectUpdateTypePopupClickParams>} LogObject<updatePmSelectUpdateTypePopupClickParams>
 */
export function updatePmSelectUpdateTypePopupClick(params) {
    return { evid: 3308, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updatePmViewReviewSubscriptionsPopup2nd' event (evid: 3309)
 *
 * Event description: second page, review the subscriptions you about to update
 *
 * @param {updatePmViewReviewSubscriptionsPopup2ndParams} params - The parameters for this event
 * @property {string} services - Update type the user choose ( from 17:3307)
 * @property {string} viewMode - view_mode as of 11:28
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} subscriptionType - subscriptionType
 * @property {string} update_type - Update type the user choose ( from 17:3307)
 * @return {LogObject<updatePmViewReviewSubscriptionsPopup2ndParams>} LogObject<updatePmViewReviewSubscriptionsPopup2ndParams>
 */
export function updatePmViewReviewSubscriptionsPopup2nd(params) {
    return { evid: 3309, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainProtocolError' event (evid: 331)
 *
 * Event description: It will trigger if we didn't detect registrar
 *
 * @param {connectDomainProtocolErrorParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {GUID} uuid - uuid
 * @property {string} registrar - registrar name
 * @return {LogObject<connectDomainProtocolErrorParams>} LogObject<connectDomainProtocolErrorParams>
 */
export function connectDomainProtocolError(params) {
    return { evid: 331, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aUpdatePaymentApplySameCard' event (evid: 3312)
 *
 * Event description: Frog
 *
 * @param {aUpdatePaymentApplySameCardParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscriptionType
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aUpdatePaymentApplySameCardParams>} LogObject<aUpdatePaymentApplySameCardParams>
 */
export function aUpdatePaymentApplySameCard(params) {
    return { evid: 3312, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updatePmUpdateTypePopupSelectUpdateType' event (evid: 3319)
 *
 * Event description: first page, action click
 *
 * @param {updatePmUpdateTypePopupSelectUpdateTypeParams} params - The parameters for this event
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} updateType - available options: same_site/same_PM/all/only
 * @property {string} subscriptionType - subscriptionType
 * @return {LogObject<updatePmUpdateTypePopupSelectUpdateTypeParams>} LogObject<updatePmUpdateTypePopupSelectUpdateTypeParams>
 */
export function updatePmUpdateTypePopupSelectUpdateType(params) {
    return { evid: 3319, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowUpgradePageView' event (evid: 332)
 *
 * Event description: No-Checkout Flow > Upgrade page > View/click
 *
 * @param {noCheckoutFlowUpgradePageViewParams} params - The parameters for this event
 * @property {string} viewMode - site_level, account_level
 * @property {string} state - 'upgrade', 'soft limit reached'
 * @property {string} clickType - activate plan, go to site dashboard, contact account manager, cancel, close ,kb, url, product:{product_name},cycle:{cycle}
 * @property {string} productTypeName - product_type_name - not sent!!
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product id
 * @property {number} limit - limit of subscriptions by the contract
 * @property {GUID} msid - msid
 * @property {string} action - view, click
 * @property {boolean} isRecurring - distinguish between recurring flow (channels) and life time (Enterprise)
 * @property {number} limit_usage - number of activated subscriptions
 * @property {string} offering - offering type
 * @return {LogObject<noCheckoutFlowUpgradePageViewParams>} LogObject<noCheckoutFlowUpgradePageViewParams>
 */
export function noCheckoutFlowUpgradePageView(params) {
    return { evid: 332, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updatePmReviewSubscriptionsPopupClick' event (evid: 3320)
 *
 * Event description: second page, review the subscriptions you about to update, click
 *
 * @param {updatePmReviewSubscriptionsPopupClickParams} params - The parameters for this event
 * @property {string} services - Update type the user choose ( from 17:3307)
 * @property {string} viewMode - view_mode as of 11:28
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - cancel /next /back
 * @property {string} subscriptionType - subscriptionType
 * @property {string} update_type - Update type the user choose ( from 17:3307)
 * @return {LogObject<updatePmReviewSubscriptionsPopupClickParams>} LogObject<updatePmReviewSubscriptionsPopupClickParams>
 */
export function updatePmReviewSubscriptionsPopupClick(params) {
    return { evid: 3320, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowSuccessPageView' event (evid: 333)
 *
 * Event description: No-Checkout Flow > Success page > View
 *
 * @param {noCheckoutFlowSuccessPageViewParams} params - The parameters for this event
 * @property {string} viewMode - site_level, account_level
 * @property {string} externalSessionId - externalsessionid
 * @property {string} state - 'success', 'already premium'
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - activate plan, go to site dashboard, contact account manager, cancel, close
 * @property {string} productTypeName - product_type_name
 * @property {GUID} productInstanceId - product_instance_id
 * @property {string} cycleName - cycle name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product_id
 * @property {GUID} msid - msid
 * @property {string} action - view, click
 * @property {number} cycleId - cycle_id
 * @property {boolean} isRecurring - distinguish between recurring flow (channels) and life time (Enterprise)
 * @property {number} limit - limit of subscriptions by the contract
 * @property {number} limit_usage - number of activated subscriptions
 * @property {string} offering - offering type
 * @return {LogObject<noCheckoutFlowSuccessPageViewParams>} LogObject<noCheckoutFlowSuccessPageViewParams>
 */
export function noCheckoutFlowSuccessPageView(params) {
    return { evid: 333, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageAdditionalServices' event (evid: 3330)
 *
 * Event description: Indicates if the user has additional services on the same credit card
 *
 * @param {checkoutPageAdditionalServicesParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} cycle_name - Monthly/Yearly/Etc.
 * @property {string} services - services attached to current payment source
 * @property {string} packagePickerType - package_picker_type
 * @property {string} assetType - PLAN/DOMAIN/MAILBOX/ETC.
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {number} invoiceId - The invoice which is in declined charges
 * @property {string} productType - catalog product type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} serviceId - service_guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} invoiceStatus - currency, total, tax
 * @return {LogObject<checkoutPageAdditionalServicesParams>} LogObject<checkoutPageAdditionalServicesParams>
 */
export function checkoutPageAdditionalServices(params) {
    return { evid: 3330, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowSuccessModal' event (evid: 3331)
 *
 * Event description: after updating payment method in pay now, success modal appears with suggestion to update additional services on the same payment method
 *
 * @param {upmAfterPayNowSuccessModalParams} params - The parameters for this event
 * @property {string} services - other services that are relevant for UPM on the same PM
 * @property {GUID} billingAccountGuid - New credit card guid
 * @property {string} externalSessionId - Checkout SessionID
 * @property {GUID} assetId - old credit card guid
 * @property {GUID} subscriptionId - subscription_id
 * @property {number} assetIdType - Old Billing account type
 * @property {number} declinedServiceCount - Number of services on the same PM that are in decline status
 * @property {number} billingAccountType - New billingAccountType (PM)
 * @property {string} declinedServices - all the declined services that are on the same pm and relavent for pay now
 * @return {LogObject<upmAfterPayNowSuccessModalParams>} LogObject<upmAfterPayNowSuccessModalParams>
 */
export function upmAfterPayNowSuccessModal(params) {
    return { evid: 3331, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowClickOnReview' event (evid: 3332)
 *
 * Event description: Users clicks on review additional services to update
 *
 * @param {upmAfterPayNowClickOnReviewParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - 'Success modal' / 'Subscription page'
 * @property {string} externalSessionId - External Session_id from Checkout
 * @return {LogObject<upmAfterPayNowClickOnReviewParams>} LogObject<upmAfterPayNowClickOnReviewParams>
 */
export function upmAfterPayNowClickOnReview(params) {
    return { evid: 3332, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowCloseSuccessModal' event (evid: 3333)
 *
 * Event description: User closes the success modal
 *
 * @param {upmAfterPayNowCloseSuccessModalParams} params - The parameters for this event
 * @property {string} clickType - 'No thanks' / 'Close through X'
 * @property {string} externalSessionId - external_session_id from checkout
 * @return {LogObject<upmAfterPayNowCloseSuccessModalParams>} LogObject<upmAfterPayNowCloseSuccessModalParams>
 */
export function upmAfterPayNowCloseSuccessModal(params) {
    return { evid: 3333, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowAdditionalServicesModal' event (evid: 3334)
 *
 * Event description: modal with all the services that are attached to the old card that was updated
 *
 * @param {upmAfterPayNowAdditionalServicesModalParams} params - The parameters for this event
 * @property {string} services - string with all the objects in the list that are active (not declined), including the service that was paid through this session.
 * @property {GUID} billingAccountGuid - New billing account guid (PM)
 * @property {string} externalSessionId - external session id from checkout
 * @property {GUID} assetId - Old Billing account guid (PM)
 * @property {string} declinedServices - string with all the objects in the list that are in declined status
 * @return {LogObject<upmAfterPayNowAdditionalServicesModalParams>} LogObject<upmAfterPayNowAdditionalServicesModalParams>
 */
export function upmAfterPayNowAdditionalServicesModal(params) {
    return { evid: 3334, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowAdditionalServicesModalClick' event (evid: 3335)
 *
 * Event description: click on additional services modal (update or cancel)
 *
 * @param {upmAfterPayNowAdditionalServicesModalClickParams} params - The parameters for this event
 * @property {string} services - string with all the objects in the list (that are checked), including the original service that was paid through this session. excluding those in declined status
 * @property {string} externalSessionId - external_session_id from checkout
 * @property {string} clickType - 1='update' / 2='cancel' / 3='close through x'
 * @property {string} declinedServices - string with all the objects in the list that are in declined status (and are checked)
 * @return {LogObject<upmAfterPayNowAdditionalServicesModalClickParams>} LogObject<upmAfterPayNowAdditionalServicesModalClickParams>
 */
export function upmAfterPayNowAdditionalServicesModalClick(params) {
    return { evid: 3335, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowAdditionalUpmSuccess' event (evid: 3336)
 *
 * Event description: after updating payment method in pay now, declined services on the same old payment method were updated successfully (and paid) to the new payment method
 *
 * @param {upmAfterPayNowAdditionalUpmSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - New credit card guid
 * @property {boolean} isMobile - check if user arrived from mobile
 * @property {string} errorInfo - error message
 * @property {string} externalSessionId - Checkout Session
 * @property {GUID} assetId - old credit card guid
 * @property {string} is3ds - according to the result from shouldVerifyPaymentSource
 * @property {string} declinedServicesPaid - list of all the objects in the list that were in declined status and charged successfully
 * @property {number} assetIdType - Old billing account type
 * @property {string} declinedServicesFailed - list of all the objects in the list that were in declined status and failed to be charged
 * @property {number} numOfServicesUpdated - number of additional services that were paid or updated
 * @property {number} numOfDeclinedServicesPaid - number of additional declined services that were paid
 * @property {number} billingAccountType - New billing account Type
 * @property {string} initiatorName - initiator name
 * @return {LogObject<upmAfterPayNowAdditionalUpmSuccessParams>} LogObject<upmAfterPayNowAdditionalUpmSuccessParams>
 */
export function upmAfterPayNowAdditionalUpmSuccess(params) {
    return { evid: 3336, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainResultPageClickShowMoreSrc17Evid334' event (evid: 334)
 *
 * Event description: Domain Result Page View > click on Show More Results
 *
 * @param {domainResultPageClickShowMoreSrc17Evid334Params} params - The parameters for this event
 * @property {string} SearchTerm - domain search term
 * @return {LogObject<domainResultPageClickShowMoreSrc17Evid334Params>} LogObject<domainResultPageClickShowMoreSrc17Evid334Params>
 */
export function domainResultPageClickShowMoreSrc17Evid334(params) {
    return { evid: 334, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainSearchFilterResultsSrc17Evid335' event (evid: 335)
 *
 * Event description: Filter values clicked/ view
 *
 * @param {domainSearchFilterResultsSrc17Evid335Params} params - The parameters for this event
 * @property {string} ViewMode - view mode
 * @property {string} SearchTerm - domain search term
 * @property {string} TLDSuggestions - Tld Clicked or All (if no choice was made)
 * @property {string} MaxCharacterLength - Number of max character length chosen/ NULL if no choice was made
 * @property {string} ClearAll - Click on clear all filters
 * @property {string} Action - View filter bar / Click
 * @return {LogObject<domainSearchFilterResultsSrc17Evid335Params>} LogObject<domainSearchFilterResultsSrc17Evid335Params>
 */
export function domainSearchFilterResultsSrc17Evid335(params) {
    return { evid: 335, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowDomainPurchasePremiumUpgradePopUp' event (evid: 336)
 *
 * Event description: No-Checkout Flow > Domain purchase > Premium Upgrade pop-up
 *
 * @param {noCheckoutFlowDomainPurchasePremiumUpgradePopUpParams} params - The parameters for this event
 * @property {string} viewMode - ‘accountLevel’, ‘siteLevel’
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {GUID} msid - msid
 * @property {string} action - view’, ‘upgrade’, ‘cancel’, ‘close’, ‘get domain’
 * @return {LogObject<noCheckoutFlowDomainPurchasePremiumUpgradePopUpParams>} LogObject<noCheckoutFlowDomainPurchasePremiumUpgradePopUpParams>
 */
export function noCheckoutFlowDomainPurchasePremiumUpgradePopUp(params) {
    return { evid: 336, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowDomainConnectPremiumUpgradePopUp' event (evid: 337)
 *
 * Event description: No-Checkout Flow > Domain Connect > Premium Upgrade pop-up
 *
 * @param {noCheckoutFlowDomainConnectPremiumUpgradePopUpParams} params - The parameters for this event
 * @property {string} viewMode - ‘accountLevel’, ‘siteLevel’
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {GUID} msid - msid
 * @property {string} action - ‘view’, ‘upgrade’, ‘cancel’, ‘close’
 * @return {LogObject<noCheckoutFlowDomainConnectPremiumUpgradePopUpParams>} LogObject<noCheckoutFlowDomainConnectPremiumUpgradePopUpParams>
 */
export function noCheckoutFlowDomainConnectPremiumUpgradePopUp(params) {
    return { evid: 337, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowNoPermissions' event (evid: 338)
 *
 * Event description: logged user has no permissions to upgrade message page, or there is a generic error or page not found
 *
 * @param {noCheckoutFlowNoPermissionsParams} params - The parameters for this event
 * @property {string} viewMode - site_level, account_level
 * @property {string} errorInfo - error info if error page
 * @property {string} clickType - 'manage your website'
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product_id
 * @property {string} pageName - unauthorized, generic error, not found
 * @property {GUID} msid - msid
 * @property {string} action - view, click
 * @return {LogObject<noCheckoutFlowNoPermissionsParams>} LogObject<noCheckoutFlowNoPermissionsParams>
 */
export function noCheckoutFlowNoPermissions(params) {
    return { evid: 338, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowReachedLimitPage' event (evid: 339)
 *
 * Event description: No-Checkout Flow > Reached limit page
 *
 * @param {noCheckoutFlowReachedLimitPageParams} params - The parameters for this event
 * @property {string} viewMode - site_level, account_level
 * @property {string} clickType - 'go to site dashboard', cancel, contact account manager, close
 * @property {string} productTypeName - product_type_name - not being sent!
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product name
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} productId - product guid
 * @property {number} limit - hard limit
 * @property {GUID} msid - msid
 * @property {string} action - view, click
 * @return {LogObject<noCheckoutFlowReachedLimitPageParams>} LogObject<noCheckoutFlowReachedLimitPageParams>
 */
export function noCheckoutFlowReachedLimitPage(params) {
    return { evid: 339, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rAddDomainStep2ContinueSuccess' event (evid: 34)
 *
 * Event description: R_AddDomainStep2ContinueSuccess.
 *
 * @param {rAddDomainStep2ContinueSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rAddDomainStep2ContinueSuccessParams>} LogObject<rAddDomainStep2ContinueSuccessParams>
 */
export function rAddDomainStep2ContinueSuccess(params) {
    return { evid: 34, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainRolesAndPermissionsAccessDeniedPageView' event (evid: 340)
 *
 * Event description: It triggers if user sees access denied page
 *
 * @param {domainRolesAndPermissionsAccessDeniedPageViewParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} domain - domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral
 * @property {string} place - place
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<domainRolesAndPermissionsAccessDeniedPageViewParams>} LogObject<domainRolesAndPermissionsAccessDeniedPageViewParams>
 */
export function domainRolesAndPermissionsAccessDeniedPageView(params) {
    return { evid: 340, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowErrorPageView' event (evid: 341)
 *
 * Event description: generic error page view
 *
 * @param {noCheckoutFlowErrorPageViewParams} params - The parameters for this event
 * @property {string} errorInfo - error info
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product_id
 * @property {GUID} msid - msid
 * @return {LogObject<noCheckoutFlowErrorPageViewParams>} LogObject<noCheckoutFlowErrorPageViewParams>
 */
export function noCheckoutFlowErrorPageView(params) {
    return { evid: 341, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowNotFoundPageView' event (evid: 342)
 *
 * Event description: not found page view or click
 *
 * @param {noCheckoutFlowNotFoundPageViewParams} params - The parameters for this event
 * @property {string} viewMode - site_level, account_level
 * @property {string} clickType - click_type
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product_id
 * @property {GUID} msid - msid
 * @property {string} action - view, click
 * @return {LogObject<noCheckoutFlowNotFoundPageViewParams>} LogObject<noCheckoutFlowNotFoundPageViewParams>
 */
export function noCheckoutFlowNotFoundPageView(params) {
    return { evid: 342, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'provisionedSubscriptionsWithDiscountCode' event (evid: 343)
 *
 * Event description: Subscriptions created with provisioning API and have a discount code
 *
 * @param {provisionedSubscriptionsWithDiscountCodeParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscription id
 * @property {string} discountCode - dsicount code for sale tag
 * @property {string} productTypeId - product type id
 * @property {GUID} reseller - reseller uuid
 * @property {string} productId - product id
 * @property {GUID} msid - msid
 * @return {LogObject<provisionedSubscriptionsWithDiscountCodeParams>} LogObject<provisionedSubscriptionsWithDiscountCodeParams>
 */
export function provisionedSubscriptionsWithDiscountCode(params) {
    return { evid: 343, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'registrarsAsResellersCannotTransferPageView' event (evid: 344)
 *
 * Event description: user viewed a page "Your domain cannot be transferred to Wix" after clicking transfer on My domains page
 *
 * @param {registrarsAsResellersCannotTransferPageViewParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {GUID} reseller - reseller guid
 * @return {LogObject<registrarsAsResellersCannotTransferPageViewParams>} LogObject<registrarsAsResellersCannotTransferPageViewParams>
 */
export function registrarsAsResellersCannotTransferPageView(params) {
    return { evid: 344, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageSuccess' event (evid: 345)
 *
 * Event description: checkout success event - all flows
 *
 * @param {checkoutPageSuccessParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} billingAccountGuid - billing_account_guid (Sent only in case of using Saved), to know also regarding not saved - use 74:1018
 * @property {string} externalSessionId - the same as eventAggregator
 * @property {string} couponCode - coupon_code
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} authentication_status - authentication_status json
 * @property {string} invoiceId - invoice_id
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} totalAmount - total_amount (in cents)
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} cycle - CycleId (code) from pricing json
 * @property {string} pagename - ab_test
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} currency - currency
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiator_name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} pricing - json with other data..
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPageSuccessParams>} LogObject<checkoutPageSuccessParams>
 */
export function checkoutPageSuccess(params) {
    return { evid: 345, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'migrationFromSubscriptionToPackageEvent' event (evid: 346)
 *
 * Event description: Subscriptions created with provisioning API and have a discount code
 *
 * @param {migrationFromSubscriptionToPackageEventParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscription guid
 * @property {GUID} productInstanceId - productInstanceId
 * @property {GUID} siteId - metasite guid
 * @property {GUID} packageId - package id
 * @property {GUID} msid - msid
 * @return {LogObject<migrationFromSubscriptionToPackageEventParams>} LogObject<migrationFromSubscriptionToPackageEventParams>
 */
export function migrationFromSubscriptionToPackageEvent(params) {
    return { evid: 346, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'resellerRedirectFromDomainsPage' event (evid: 347)
 *
 * Event description: user was redirected to reseller after clicking purchase or connect on domains page/concierge
 *
 * @param {resellerRedirectFromDomainsPageParams} params - The parameters for this event
 * @property {Url} url - redirect url
 * @property {string} clickType - 'buy', 'connect'
 * @property {GUID} reseller - reseller guid
 * @return {LogObject<resellerRedirectFromDomainsPageParams>} LogObject<resellerRedirectFromDomainsPageParams>
 */
export function resellerRedirectFromDomainsPage(params) {
    return { evid: 347, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageSubmitResult' event (evid: 348)
 *
 * Event description: Server event :
 * The result of submit (success/Error), error type if there was one an deliverables (service, invoice - also in case of error).
 * Intended to replace client events after submit :
 * 17:322 (validation error)
 * 17:323 (Business error)
 * 17:324 (Fatal error)
 * 17:345  (success)
 *
 * @param {checkoutPageSubmitResultParams} params - The parameters for this event
 * @property {string} services - services
 * @property {boolean} success - True in cases of success, false in case of error
 * @property {GUID} billingAccountGuid - billing_account_guid of submit
 * @property {string} errorInfo - error_info
 * @property {string} externalSessionId - external_session_id of checkout
 * @property {GUID} uuid - uuid
 * @property {string} errorKey - errorKey
 * @property {string} invoiceId - invoice_id
 * @property {string} errorType - error type (Business/Validation/Fatal)
 * @property {string} errorCode - checkout_error_code
 * @property {string} actionType - action type for submit (regular/3ds), as in 17:323
 * @property {boolean} isSavedBillingAccount - is submit was with saved_billing_account_guid
 * @property {string} currency - currency
 * @property {string} initiatorName - initator_name of the consumer who triggered the checkout
 * @return {LogObject<checkoutPageSubmitResultParams>} LogObject<checkoutPageSubmitResultParams>
 */
export function checkoutPageSubmitResult(params) {
    return { evid: 348, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainPurchaseShowErrorPage' event (evid: 349)
 *
 * Event description: We show it if users try to purchase an unavailable domain
 *
 * @param {domainPurchaseShowErrorPageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} viewMode - mobile | desktop
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - voucher
 * @property {string} errorInfo - error  code
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} registrar - registrar
 * @property {GUID} packageGuid - package_id
 * @property {string} flow - purchase | extend | transfer-in
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} action - learn_more
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<domainPurchaseShowErrorPageParams>} LogObject<domainPurchaseShowErrorPageParams>
 */
export function domainPurchaseShowErrorPage(params) {
    return { evid: 349, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rAddDomainStep2ContinueError' event (evid: 35)
 *
 * Event description: R_AddDomainStep2ContinueError.
 *
 * @param {rAddDomainStep2ContinueErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rAddDomainStep2ContinueErrorParams>} LogObject<rAddDomainStep2ContinueErrorParams>
 */
export function rAddDomainStep2ContinueError(params) {
    return { evid: 35, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchaseStep1' event (evid: 350)
 *
 * Event description: Client - V_DomainPurchaseStep1
 *
 * @param {vDomainPurchaseStep1Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} screenResolution - screen_resolution
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} providerId - provider_id
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchaseStep1Params>} LogObject<vDomainPurchaseStep1Params>
 */
export function vDomainPurchaseStep1(params) {
    return { evid: 350, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aVoucherClaimForBingSuccess' event (evid: 3500)
 *
 * Event description: A_VoucherClaimForBingSuccess.
 *
 * @param {aVoucherClaimForBingSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aVoucherClaimForBingSuccessParams>} LogObject<aVoucherClaimForBingSuccessParams>
 */
export function aVoucherClaimForBingSuccess(params) {
    return { evid: 3500, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aVoucherClaimForBingException' event (evid: 3503)
 *
 * Event description: A_VoucherClaimForBingException.
 *
 * @param {aVoucherClaimForBingExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aVoucherClaimForBingExceptionParams>} LogObject<aVoucherClaimForBingExceptionParams>
 */
export function aVoucherClaimForBingException(params) {
    return { evid: 3503, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchaseStep2' event (evid: 351)
 *
 * Event description: Client - V_DomainPurchaseStep2
 *
 * @param {vDomainPurchaseStep2Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} screenResolution - screen_resolution
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} providerId - provider_id
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {string} parameters - parameters
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchaseStep2Params>} LogObject<vDomainPurchaseStep2Params>
 */
export function vDomainPurchaseStep2(params) {
    return { evid: 351, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchaseContactInfoNextSuccess' event (evid: 352)
 *
 * Event description: Client - A_DomainPurchaseContactInfoNextSuccess
 *
 * @param {aDomainPurchaseContactInfoNextSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} responseSpeed - response_speed
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {string} parameters - parameters
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchaseContactInfoNextSuccessParams>} LogObject<aDomainPurchaseContactInfoNextSuccessParams>
 */
export function aDomainPurchaseContactInfoNextSuccess(params) {
    return { evid: 352, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchaseContactInfoNextError' event (evid: 353)
 *
 * Event description: Client - A_DomainPurchaseContactInfoNextError
 *
 * @param {aDomainPurchaseContactInfoNextErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} responseSpeed - response_speed
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {string} parameters - parameters
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchaseContactInfoNextErrorParams>} LogObject<aDomainPurchaseContactInfoNextErrorParams>
 */
export function aDomainPurchaseContactInfoNextError(params) {
    return { evid: 353, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchaseStep3' event (evid: 355)
 *
 * Event description: Client - V_DomainPurchaseStep3
 *
 * @param {vDomainPurchaseStep3Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} screenResolution - screen_resolution
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} privacy - privacy
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} providerId - provider_id
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchaseStep3Params>} LogObject<vDomainPurchaseStep3Params>
 */
export function vDomainPurchaseStep3(params) {
    return { evid: 355, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchasePublicStepNext' event (evid: 356)
 *
 * Event description: A_DomainPurchasePublicStepNext.
 *
 * @param {aDomainPurchasePublicStepNextParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchasePublicStepNextParams>} LogObject<aDomainPurchasePublicStepNextParams>
 */
export function aDomainPurchasePublicStepNext(params) {
    return { evid: 356, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchaseStep4' event (evid: 357)
 *
 * Event description: Client - V_DomainPurchaseStep4
 *
 * @param {vDomainPurchaseStep4Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} screenResolution - screen_resolution
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} providerId - provider_id
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {string} parameters - parameters
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchaseStep4Params>} LogObject<vDomainPurchaseStep4Params>
 */
export function vDomainPurchaseStep4(params) {
    return { evid: 357, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchase1Site1Domain' event (evid: 358)
 *
 * Event description: V_DomainPurchase1Site1Domain.
 *
 * @param {vDomainPurchase1Site1DomainParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchase1Site1DomainParams>} LogObject<vDomainPurchase1Site1DomainParams>
 */
export function vDomainPurchase1Site1Domain(params) {
    return { evid: 358, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchase1Unpublished1Domain' event (evid: 359)
 *
 * Event description: V_DomainPurchase1Unpublished1Domain.
 *
 * @param {vDomainPurchase1Unpublished1DomainParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchase1Unpublished1DomainParams>} LogObject<vDomainPurchase1Unpublished1DomainParams>
 */
export function vDomainPurchase1Unpublished1Domain(params) {
    return { evid: 359, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rAddDomainStep2ContinueException' event (evid: 36)
 *
 * Event description: R_AddDomainStep2ContinueException.
 *
 * @param {rAddDomainStep2ContinueExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rAddDomainStep2ContinueExceptionParams>} LogObject<rAddDomainStep2ContinueExceptionParams>
 */
export function rAddDomainStep2ContinueException(params) {
    return { evid: 36, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchase1FreeSite1Domain' event (evid: 360)
 *
 * Event description: V_DomainPurchase1FreeSite1Domain.
 *
 * @param {vDomainPurchase1FreeSite1DomainParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchase1FreeSite1DomainParams>} LogObject<vDomainPurchase1FreeSite1DomainParams>
 */
export function vDomainPurchase1FreeSite1Domain(params) {
    return { evid: 360, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchaseNoSite1Domain' event (evid: 361)
 *
 * Event description: V_DomainPurchaseNoSite1Domain.
 *
 * @param {vDomainPurchaseNoSite1DomainParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchaseNoSite1DomainParams>} LogObject<vDomainPurchaseNoSite1DomainParams>
 */
export function vDomainPurchaseNoSite1Domain(params) {
    return { evid: 361, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchaseSeveralSitesSeveralDomains' event (evid: 362)
 *
 * Event description: V_DomainPurchaseSeveralSitesSeveralDomains.
 *
 * @param {vDomainPurchaseSeveralSitesSeveralDomainsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchaseSeveralSitesSeveralDomainsParams>} LogObject<vDomainPurchaseSeveralSitesSeveralDomainsParams>
 */
export function vDomainPurchaseSeveralSitesSeveralDomains(params) {
    return { evid: 362, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchaseClickConnectBothDomains' event (evid: 363)
 *
 * Event description: A_DomainPurchaseClickConnectBothDomains.
 *
 * @param {aDomainPurchaseClickConnectBothDomainsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchaseClickConnectBothDomainsParams>} LogObject<aDomainPurchaseClickConnectBothDomainsParams>
 */
export function aDomainPurchaseClickConnectBothDomains(params) {
    return { evid: 363, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchaseClickConnectOnlyOne' event (evid: 364)
 *
 * Event description: A_DomainPurchaseClickConnectOnlyOne.
 *
 * @param {aDomainPurchaseClickConnectOnlyOneParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchaseClickConnectOnlyOneParams>} LogObject<aDomainPurchaseClickConnectOnlyOneParams>
 */
export function aDomainPurchaseClickConnectOnlyOne(params) {
    return { evid: 364, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchaseSrvTermChange' event (evid: 365)
 *
 * Event description: Client - A_DomainPurchaseSrvTermChange
 *
 * @param {aDomainPurchaseSrvTermChangeParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchaseSrvTermChangeParams>} LogObject<aDomainPurchaseSrvTermChangeParams>
 */
export function aDomainPurchaseSrvTermChange(params) {
    return { evid: 365, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainPurchaseClickPurchaseSummary' event (evid: 366)
 *
 * Event description: A_DomainPurchaseClickPurchaseSummary.
 *
 * @param {aDomainPurchaseClickPurchaseSummaryParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainPurchaseClickPurchaseSummaryParams>} LogObject<aDomainPurchaseClickPurchaseSummaryParams>
 */
export function aDomainPurchaseClickPurchaseSummary(params) {
    return { evid: 366, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchaseTpaCartInView' event (evid: 367)
 *
 * Event description: V_DomainPurchaseTpaCartInView.
 *
 * @param {vDomainPurchaseTpaCartInViewParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchaseTpaCartInViewParams>} LogObject<vDomainPurchaseTpaCartInViewParams>
 */
export function vDomainPurchaseTpaCartInView(params) {
    return { evid: 367, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainPurchaseStep1PeriodCanTUseVoucherLearnMore' event (evid: 369)
 *
 * Event description: Client
 *
 * @param {domainPurchaseStep1PeriodCanTUseVoucherLearnMoreParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} viewMode - mobile / desktop
 * @property {string} packagePickerType - package_picker_type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {GUID} packageGuid - package_id
 * @property {string} flow - purchase | transfer-in | extend
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {number} domainSkuId - domain_sku_id
 * @property {GUID} msid - msid
 * @property {string} userType - premium / free
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<domainPurchaseStep1PeriodCanTUseVoucherLearnMoreParams>} LogObject<domainPurchaseStep1PeriodCanTUseVoucherLearnMoreParams>
 */
export function domainPurchaseStep1PeriodCanTUseVoucherLearnMore(params) {
    return { evid: 369, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchaseOrderFormLoadSuccess' event (evid: 370)
 *
 * Event description: Client - V_DomainPurchaseOrderFormLoadSuccess
 *
 * @param {vDomainPurchaseOrderFormLoadSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {string} parameters - parameters
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchaseOrderFormLoadSuccessParams>} LogObject<vDomainPurchaseOrderFormLoadSuccessParams>
 */
export function vDomainPurchaseOrderFormLoadSuccess(params) {
    return { evid: 370, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rClaimRefundSuccess' event (evid: 3700)
 *
 * Event description: R_ClaimRefundSuccess.
 *
 * @param {rClaimRefundSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rClaimRefundSuccessParams>} LogObject<rClaimRefundSuccessParams>
 */
export function rClaimRefundSuccess(params) {
    return { evid: 3700, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rClaimRefundError' event (evid: 3701)
 *
 * Event description: R_ClaimRefundError.
 *
 * @param {rClaimRefundErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rClaimRefundErrorParams>} LogObject<rClaimRefundErrorParams>
 */
export function rClaimRefundError(params) {
    return { evid: 3701, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rClaimRefundException' event (evid: 3702)
 *
 * Event description: R_ClaimRefundException.
 *
 * @param {rClaimRefundExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rClaimRefundExceptionParams>} LogObject<rClaimRefundExceptionParams>
 */
export function rClaimRefundException(params) {
    return { evid: 3702, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPurchasePageBoletoSlipOpen' event (evid: 3703)
 *
 * Event description: User clicks on 'print' (to open the bank payment slip)
 *
 * @param {aPurchasePageBoletoSlipOpenParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPurchasePageBoletoSlipOpenParams>} LogObject<aPurchasePageBoletoSlipOpenParams>
 */
export function aPurchasePageBoletoSlipOpen(params) {
    return { evid: 3703, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPurchasePageBoletoBankRedirection' event (evid: 3704)
 *
 * Event description: Go to bank from wix payment slip - click 'login to bank'
 *
 * @param {aPurchasePageBoletoBankRedirectionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {string} bankName - bank_name
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPurchasePageBoletoBankRedirectionParams>} LogObject<aPurchasePageBoletoBankRedirectionParams>
 */
export function aPurchasePageBoletoBankRedirection(params) {
    return { evid: 3704, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageBoletoSlipActions' event (evid: 3705)
 *
 * Event description: pay your boleto - actions
 *
 * @param {checkoutPageBoletoSlipActionsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - sendmail / print / copycode / view summery / dashboard
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiator_name
 * @property {string} productGuid - Product Guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPageBoletoSlipActionsParams>} LogObject<checkoutPageBoletoSlipActionsParams>
 */
export function checkoutPageBoletoSlipActions(params) {
    return { evid: 3705, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainPurchaseOrderFormLoadFatal' event (evid: 372)
 *
 * Event description: V_DomainPurchaseOrderFormLoadFatal.
 *
 * @param {vDomainPurchaseOrderFormLoadFatalParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainPurchaseOrderFormLoadFatalParams>} LogObject<vDomainPurchaseOrderFormLoadFatalParams>
 */
export function vDomainPurchaseOrderFormLoadFatal(params) {
    return { evid: 372, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPurchaseOrderFormSubmitSuccess' event (evid: 373)
 *
 * Event description: R_DomainPurchaseOrderFormSubmitSuccess.
 *
 * @param {rDomainPurchaseOrderFormSubmitSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainPurchaseOrderFormSubmitSuccessParams>} LogObject<rDomainPurchaseOrderFormSubmitSuccessParams>
 */
export function rDomainPurchaseOrderFormSubmitSuccess(params) {
    return { evid: 373, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPurchaseOrderFormSubmitError' event (evid: 374)
 *
 * Event description: Client - R_DomainPurchaseOrderFormSubmitError. we need to move the business error in desktop to evid 390
 *
 * @param {rDomainPurchaseOrderFormSubmitErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {string} parameters - parameters
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainPurchaseOrderFormSubmitErrorParams>} LogObject<rDomainPurchaseOrderFormSubmitErrorParams>
 */
export function rDomainPurchaseOrderFormSubmitError(params) {
    return { evid: 374, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainPurchaseOrderFormSubmitFatal' event (evid: 375)
 *
 * Event description: Client - R_DomainPurchaseOrderFormSubmitFatal
 *
 * @param {rDomainPurchaseOrderFormSubmitFatalParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} referral - referral
 * @property {string} registrar - registrar
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} flow - flow
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {string} userType - type
 * @property {string} parameters - parameters
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainPurchaseOrderFormSubmitFatalParams>} LogObject<rDomainPurchaseOrderFormSubmitFatalParams>
 */
export function rDomainPurchaseOrderFormSubmitFatal(params) {
    return { evid: 375, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMsPurchaseStartSuccess' event (evid: 377)
 *
 * Event description: Start Purchase Load success
 *
 * @param {vMsPurchaseStartSuccessParams} params - The parameters for this event
 * @property {string} isNewPurchase - True, False
 * @property {string} domainName - Domain related to the mailbox
 * @property {string} additionalInfo - referral_additional_info
 * @return {LogObject<vMsPurchaseStartSuccessParams>} LogObject<vMsPurchaseStartSuccessParams>
 */
export function vMsPurchaseStartSuccess(params) {
    return { evid: 377, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMsnClickContinueSuccess' event (evid: 378)
 *
 * Event description: Click on Continue with no errors
 *
 * @param {vMsnClickContinueSuccessParams} params - The parameters for this event
 * @property {number} quantity - Quantity
 * @property {string} domainName - Domain related to the mailbox
 * @property {string} additionalInfo - ms_purchase_admin_details or ms_purchase_mailbox_plan
 * @return {LogObject<vMsnClickContinueSuccessParams>} LogObject<vMsnClickContinueSuccessParams>
 */
export function vMsnClickContinueSuccess(params) {
    return { evid: 378, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMsnPurchase1stStepValidationError' event (evid: 379)
 *
 * Event description: If 0 is chosen
 *
 * @param {aMsnPurchase1stStepValidationErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error with fields
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<aMsnPurchase1stStepValidationErrorParams>} LogObject<aMsnPurchase1stStepValidationErrorParams>
 */
export function aMsnPurchase1stStepValidationError(params) {
    return { evid: 379, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aChangeEmailProvider' event (evid: 38)
 *
 * Event description: A_ChangeEmailProvider.
 *
 * @param {aChangeEmailProviderParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aChangeEmailProviderParams>} LogObject<aChangeEmailProviderParams>
 */
export function aChangeEmailProvider(params) {
    return { evid: 38, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMsnPaymentDetailsLoad' event (evid: 380)
 *
 * Event description: When user see the Payment Step
 *
 * @param {vMsnPaymentDetailsLoadParams} params - The parameters for this event
 * @property {string} additionalInfo - From 2nd Step Or Direct (repurchase)
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<vMsnPaymentDetailsLoadParams>} LogObject<vMsnPaymentDetailsLoadParams>
 */
export function vMsnPaymentDetailsLoad(params) {
    return { evid: 380, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dayfulPackagePickerViewCycleSelection2ndStep' event (evid: 3805)
 *
 * Event description: Dayful Plan PP - select product (and move to 2nd step)
 *
 * @param {dayfulPackagePickerViewCycleSelection2ndStepParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} pp_type - pp_type
 * @property {string} intent - intent
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} productid - extra_info
 * @property {string} eventAggregator - event_aggregator
 * @property {string} productTypeName - Dayful
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - 3/6
 * @property {string} pagename - ab_test
 * @property {string} ppType - pp_type
 * @property {string} productTypeId - productTypeId
 * @property {string} offeringGuid - offering_guid
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {Url} referer - referral
 * @property {string} offeringType - Seasonal / Personal / Default
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} pricing - json
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<dayfulPackagePickerViewCycleSelection2ndStepParams>} LogObject<dayfulPackagePickerViewCycleSelection2ndStepParams>
 */
export function dayfulPackagePickerViewCycleSelection2ndStep(params) {
    return { evid: 3805, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMsnPurchaseAdminInfoValidationClientError' event (evid: 381)
 *
 * Event description: When Clicking Continue and there are client validation errors on form
 *
 * @param {aMsnPurchaseAdminInfoValidationClientErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error with fields
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<aMsnPurchaseAdminInfoValidationClientErrorParams>} LogObject<aMsnPurchaseAdminInfoValidationClientErrorParams>
 */
export function aMsnPurchaseAdminInfoValidationClientError(params) {
    return { evid: 381, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aNotVerticalClick' event (evid: 3810)
 *
 * Event description: when you get a vertical PP you can change to default by clicking "Not a store owner? Check out Wix Premium Plans for more options."
 *
 * @param {aNotVerticalClickParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aNotVerticalClickParams>} LogObject<aNotVerticalClickParams>
 */
export function aNotVerticalClick(params) {
    return { evid: 3810, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vAutoRefundServiceViewer' event (evid: 3811)
 *
 * Event description: V_AutoRefundServiceViewer.
 *
 * @param {vAutoRefundServiceViewerParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vAutoRefundServiceViewerParams>} LogObject<vAutoRefundServiceViewerParams>
 */
export function vAutoRefundServiceViewer(params) {
    return { evid: 3811, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundWidgetPageLoad' event (evid: 3812)
 *
 * Event description: Refund Widget Loaded - one event per service
 *
 * @param {refundWidgetPageLoadParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} productType - plan,mailbox,domain
 * @property {GUID} sbsSId - Sbs Service Guid
 * @property {string} type - in_trial after_trial,no_services
 * @property {string} referralId - Source
 * @property {string} serviceState - pending request / no request
 * @return {LogObject<refundWidgetPageLoadParams>} LogObject<refundWidgetPageLoadParams>
 */
export function refundWidgetPageLoad(params) {
    return { evid: 3812, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundWidgetClickNextFirstStep' event (evid: 3813)
 *
 * Event description: Refund Widget View Not refundable page
 *
 * @param {refundWidgetClickNextFirstStepParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {boolean} selected - Is the service selected?
 * @property {string} productType - plan,mailbox,domain
 * @property {GUID} sbsSId - Sbs Service Guid
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetClickNextFirstStepParams>} LogObject<refundWidgetClickNextFirstStepParams>
 */
export function refundWidgetClickNextFirstStep(params) {
    return { evid: 3813, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundWidgetClickNextSecondStep' event (evid: 3814)
 *
 * Event description: Refund Widget Click Next Second Step
 *
 * @param {refundWidgetClickNextSecondStepParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} clickType - back / my account / request form url
 * @property {string} reason - Cancel free text
 * @property {string} productType - plan,mailbox,domain
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetClickNextSecondStepParams>} LogObject<refundWidgetClickNextSecondStepParams>
 */
export function refundWidgetClickNextSecondStep(params) {
    return { evid: 3814, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundWidgetSummaryView' event (evid: 3815)
 *
 * Event description: Refund Widget Summary View
 *
 * @param {refundWidgetSummaryViewParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} productType - plan,mailbox,domain
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetSummaryViewParams>} LogObject<refundWidgetSummaryViewParams>
 */
export function refundWidgetSummaryView(params) {
    return { evid: 3815, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundWidgetClickSubmit' event (evid: 3816)
 *
 * Event description: Refund Widget Click Submit
 *
 * @param {refundWidgetClickSubmitParams} params - The parameters for this event
 * @property {string} referralId - Source
 * @property {GUID} userGuid - user guid
 * @return {LogObject<refundWidgetClickSubmitParams>} LogObject<refundWidgetClickSubmitParams>
 */
export function refundWidgetClickSubmit(params) {
    return { evid: 3816, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundWidgetError' event (evid: 3817)
 *
 * Event description: Refund Widget error
 *
 * @param {refundWidgetErrorParams} params - The parameters for this event
 * @property {string} step - error step
 * @property {string} errorMsg - Error Message
 * @property {GUID} userGuid - user guid
 * @property {string} productType - plan,mailbox,domain
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetErrorParams>} LogObject<refundWidgetErrorParams>
 */
export function refundWidgetError(params) {
    return { evid: 3817, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundWidgetSuccessPage' event (evid: 3818)
 *
 * Event description: Refund Widget Success page
 *
 * @param {refundWidgetSuccessPageParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} productType - plan,mailbox,domain
 * @property {GUID} sbsSId - Sbs package_id
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetSuccessPageParams>} LogObject<refundWidgetSuccessPageParams>
 */
export function refundWidgetSuccessPage(params) {
    return { evid: 3818, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundWidgetApproved' event (evid: 3819)
 *
 * Event description: refund request wad approved by the support 16.8
 *
 * @param {refundWidgetApprovedParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service from sbs
 * @property {GUID} userGuid - user guid
 * @property {number} invoiceId - invocie id
 * @property {string} refundServiceType - premium,tpa...
 * @property {GUID} refundRequestId - refundRequestId
 * @property {string} caller - caller name
 * @return {LogObject<refundWidgetApprovedParams>} LogObject<refundWidgetApprovedParams>
 */
export function refundWidgetApproved(params) {
    return { evid: 3819, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMsnClickOnSubmitPurchase' event (evid: 382)
 *
 * Event description: When clicking submit and no validations errors.
 *
 * @param {vMsnClickOnSubmitPurchaseParams} params - The parameters for this event
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<vMsnClickOnSubmitPurchaseParams>} LogObject<vMsnClickOnSubmitPurchaseParams>
 */
export function vMsnClickOnSubmitPurchase(params) {
    return { evid: 382, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mailboxFailureToEndResellerRelationship' event (evid: 3820)
 *
 * Event description: Mailbox > Failure to end reseller relationship.
 *
 * @param {mailboxFailureToEndResellerRelationshipParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<mailboxFailureToEndResellerRelationshipParams>} LogObject<mailboxFailureToEndResellerRelationshipParams>
 */
export function mailboxFailureToEndResellerRelationship(params) {
    return { evid: 3820, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundWidgetViewRequestForm' event (evid: 3821)
 *
 * Event description: Refund Widget  -  View request form
 *
 * @param {refundWidgetViewRequestFormParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} productType - plan,mailbox,domain
 * @property {GUID} sbsSId - Sbs Service Guid
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetViewRequestFormParams>} LogObject<refundWidgetViewRequestFormParams>
 */
export function refundWidgetViewRequestForm(params) {
    return { evid: 3821, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundWidgetEmptyStateClick' event (evid: 3822)
 *
 * Event description: Refund Widget > empty state >  click
 *
 * @param {refundWidgetEmptyStateClickParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} clickType - where is my pending request /how to get refund /where is my money/my account
 * @property {string} productType - plan,mailbox,domain
 * @property {GUID} sbsSId - Sbs Service Guid
 * @property {string} type - in_trial after_trial,no_services
 * @property {string} referralId - Source
 * @property {string} serviceState - pending request / no request
 * @return {LogObject<refundWidgetEmptyStateClickParams>} LogObject<refundWidgetEmptyStateClickParams>
 */
export function refundWidgetEmptyStateClick(params) {
    return { evid: 3822, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMsnPurchasePaymentValidationError' event (evid: 383)
 *
 * Event description: When Clicking Continue and there are validation errors
 *
 * @param {aMsnPurchasePaymentValidationErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error with fields
 * @property {string} domainName - Domain related to the mailbox
 * @property {string} additionalInfo - additional info
 * @return {LogObject<aMsnPurchasePaymentValidationErrorParams>} LogObject<aMsnPurchasePaymentValidationErrorParams>
 */
export function aMsnPurchasePaymentValidationError(params) {
    return { evid: 383, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMsnPurchaseSuccess' event (evid: 384)
 *
 * Event description: When success page is loaded
 *
 * @param {vMsnPurchaseSuccessParams} params - The parameters for this event
 * @property {GUID} userPackageGuid - Package Guid
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<vMsnPurchaseSuccessParams>} LogObject<vMsnPurchaseSuccessParams>
 */
export function vMsnPurchaseSuccess(params) {
    return { evid: 384, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMsnClickActivate' event (evid: 385)
 *
 * Event description: When Clicking activate from text
 *
 * @param {aMsnClickActivateParams} params - The parameters for this event
 * @property {GUID} userPackageGuid - Package Guid
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<aMsnClickActivateParams>} LogObject<aMsnClickActivateParams>
 */
export function aMsnClickActivate(params) {
    return { evid: 385, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rNoActiveBillingAccountEmailSuccess' event (evid: 3850)
 *
 * Event description: Notification that the users can't be charged. need to update billing account
 *
 * @param {rNoActiveBillingAccountEmailSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rNoActiveBillingAccountEmailSuccessParams>} LogObject<rNoActiveBillingAccountEmailSuccessParams>
 */
export function rNoActiveBillingAccountEmailSuccess(params) {
    return { evid: 3850, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rNoActiveBillingAccountEmailException' event (evid: 3851)
 *
 * Event description: R_NoActiveBillingAccountEmailException.
 *
 * @param {rNoActiveBillingAccountEmailExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rNoActiveBillingAccountEmailExceptionParams>} LogObject<rNoActiveBillingAccountEmailExceptionParams>
 */
export function rNoActiveBillingAccountEmailException(params) {
    return { evid: 3851, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMsnActivateLoad' event (evid: 386)
 *
 * Event description: V_MsnActivateLoad.
 *
 * @param {vMsnActivateLoadParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMsnActivateLoadParams>} LogObject<vMsnActivateLoadParams>
 */
export function vMsnActivateLoad(params) {
    return { evid: 386, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rManualRecurringReminderEmailSuccess' event (evid: 3860)
 *
 * Event description: R_ManualRecurringReminderEmailSuccess.
 *
 * @param {rManualRecurringReminderEmailSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rManualRecurringReminderEmailSuccessParams>} LogObject<rManualRecurringReminderEmailSuccessParams>
 */
export function rManualRecurringReminderEmailSuccess(params) {
    return { evid: 3860, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rManualRecurringReminderEmailException' event (evid: 3861)
 *
 * Event description: R_ManualRecurringReminderEmailException.
 *
 * @param {rManualRecurringReminderEmailExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rManualRecurringReminderEmailExceptionParams>} LogObject<rManualRecurringReminderEmailExceptionParams>
 */
export function rManualRecurringReminderEmailException(params) {
    return { evid: 3861, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMsnClickSubmitActivate' event (evid: 387)
 *
 * Event description: A_MsnClickSubmitActivate.
 *
 * @param {aMsnClickSubmitActivateParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMsnClickSubmitActivateParams>} LogObject<aMsnClickSubmitActivateParams>
 */
export function aMsnClickSubmitActivate(params) {
    return { evid: 387, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMsnActivateValidationError' event (evid: 388)
 *
 * Event description: A_MsnActivateValidationError.
 *
 * @param {aMsnActivateValidationErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMsnActivateValidationErrorParams>} LogObject<aMsnActivateValidationErrorParams>
 */
export function aMsnActivateValidationError(params) {
    return { evid: 388, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMsnPurchaseAdminInfoValidationServerError' event (evid: 389)
 *
 * Event description: When Clicking Continue and there are server validation errors on the combination of state, postal, city
 *
 * @param {aMsnPurchaseAdminInfoValidationServerErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error with fields
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<aMsnPurchaseAdminInfoValidationServerErrorParams>} LogObject<aMsnPurchaseAdminInfoValidationServerErrorParams>
 */
export function aMsnPurchaseAdminInfoValidationServerError(params) {
    return { evid: 389, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickNoEmailRadio' event (evid: 39)
 *
 * Event description: A_ClickNoEmailRadio.
 *
 * @param {aClickNoEmailRadioParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickNoEmailRadioParams>} LogObject<aClickNoEmailRadioParams>
 */
export function aClickNoEmailRadio(params) {
    return { evid: 39, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainPurchaseOrderPageBusinessError' event (evid: 390)
 *
 * Event description: Client
 *
 * @param {domainPurchaseOrderPageBusinessErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} viewMode - mobile / desktop
 * @property {string} packagePickerType - package_picker_type
 * @property {string} errorInfo - error_info
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} referral - referral
 * @property {string} registrar - WEB | TUCOWS | WIX-TUCOWS
 * @property {GUID} packageGuid - package_id
 * @property {string} flow - domain_purchase | extend | transfer_in
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {number} domainSkuId - domain_sku_id
 * @property {GUID} msid - msid
 * @property {string} userType - free (no premium at all) | premium (at least one premium)
 * @property {string} parameters - saved_card| no_saved_card
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<domainPurchaseOrderPageBusinessErrorParams>} LogObject<domainPurchaseOrderPageBusinessErrorParams>
 */
export function domainPurchaseOrderPageBusinessError(params) {
    return { evid: 390, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMailPurchaseFatalError' event (evid: 3900)
 *
 * Event description: V_MailPurchaseFatalError.
 *
 * @param {vMailPurchaseFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMailPurchaseFatalErrorParams>} LogObject<vMailPurchaseFatalErrorParams>
 */
export function vMailPurchaseFatalError(params) {
    return { evid: 3900, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vTpapurchaseFatalError' event (evid: 3901)
 *
 * Event description: V_TPAPurchaseFatalError.
 *
 * @param {vTpapurchaseFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vTpapurchaseFatalErrorParams>} LogObject<vTpapurchaseFatalErrorParams>
 */
export function vTpapurchaseFatalError(params) {
    return { evid: 3901, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyName' event (evid: 3902)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params) {
    return { evid: 3902, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerStickyHeaderInMobile' event (evid: 3903)
 *
 * Event description: Mobile PP: The user scrolled down so the title is sticky
 *
 * @param {packagePickerStickyHeaderInMobileParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} ppType - website / business
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - The product ID the user select when clicking the button
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<packagePickerStickyHeaderInMobileParams>} LogObject<packagePickerStickyHeaderInMobileParams>
 */
export function packagePickerStickyHeaderInMobile(params) {
    return { evid: 3903, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerSelectAPlanWithRadioButtonsMobile' event (evid: 3904)
 *
 * Event description: package picker >  select a plan with radio buttons (mobile).
 *
 * @param {packagePickerSelectAPlanWithRadioButtonsMobileParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} ppType - website / business
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - The product ID the user select when clicking the button
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<packagePickerSelectAPlanWithRadioButtonsMobileParams>} LogObject<packagePickerSelectAPlanWithRadioButtonsMobileParams>
 */
export function packagePickerSelectAPlanWithRadioButtonsMobile(params) {
    return { evid: 3904, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPackagePickerEventAddInfoAction' event (evid: 3905)
 *
 * Event description: Plan PP - select product (and move to 2nd step)
 *
 * @param {aPackagePickerEventAddInfoActionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - offering type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} clickType - click_type
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} ppType - pp_type
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @property {string} cartFlow - cartFlow
 * @return {LogObject<aPackagePickerEventAddInfoActionParams>} LogObject<aPackagePickerEventAddInfoActionParams>
 */
export function aPackagePickerEventAddInfoAction(params) {
    return { evid: 3905, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPackagePickerEventSelectCycle' event (evid: 3906)
 *
 * Event description: Plan PP - select cycle (and move to PurcahsePage)
 *
 * @param {aPackagePickerEventSelectCycleParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - offering type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @property {string} cartFlow - cartFlow
 * @return {LogObject<aPackagePickerEventSelectCycleParams>} LogObject<aPackagePickerEventSelectCycleParams>
 */
export function aPackagePickerEventSelectCycle(params) {
    return { evid: 3906, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onePagePpChange' event (evid: 3907)
 *
 * Event description: Client event
 * In the one page Package Picker click on "change"
 *
 * @param {onePagePpChangeParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} fromStep - change_product_from_cycle...
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - productId
 * @property {Url} referer - referral
 * @property {string} productGuid - Product Guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - MSID
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<onePagePpChangeParams>} LogObject<onePagePpChangeParams>
 */
export function onePagePpChange(params) {
    return { evid: 3907, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onePagePpShowFeatures' event (evid: 3908)
 *
 * Event description: Client event
 * In the one page Package Picker, in the Purchase page step -  click on "show features"
 *
 * @param {onePagePpShowFeaturesParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - productId
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - MSID
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<onePagePpShowFeaturesParams>} LogObject<onePagePpShowFeaturesParams>
 */
export function onePagePpShowFeatures(params) {
    return { evid: 3908, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onePagePpSelectProduct' event (evid: 3909)
 *
 * Event description: Client event
 * In the one page Package Picker, in the first step -  select a product (to see his features)
 *
 * @param {onePagePpSelectProductParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle ID
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - productId
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - MSID
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<onePagePpSelectProductParams>} LogObject<onePagePpSelectProductParams>
 */
export function onePagePpSelectProduct(params) {
    return { evid: 3909, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainPurchaseStep4PaymentBuyNow' event (evid: 391)
 *
 * Event description: Client
 *
 * @param {domainPurchaseStep4PaymentBuyNowParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {number} responseSpeed - time in ms from load step4 to click on continue button
 * @property {string} viewMode - mobile / desktop
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - voucher
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} referral - referral
 * @property {string} registrar - WEB | TUCOWS | WIX-TUCOWS
 * @property {GUID} packageGuid - package_id
 * @property {string} flow - domain_purchase | extend | transfer_in
 * @property {string} pagename - ab_test
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {number} domainSkuId - domain_sku_id
 * @property {GUID} msid - msid
 * @property {string} userType - free (no premium at all) | premium (at least one premium)
 * @property {string} parameters - saved_card| no_saved_card
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<domainPurchaseStep4PaymentBuyNowParams>} LogObject<domainPurchaseStep4PaymentBuyNowParams>
 */
export function domainPurchaseStep4PaymentBuyNow(params) {
    return { evid: 391, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onePagePpHoverOnFeatures' event (evid: 3910)
 *
 * Event description: Client event
 * In the one page Package Picker, Hover  Hover  (more than 5 sec)
 *
 * @param {onePagePpHoverOnFeaturesParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} fromStep - in which step you are (select_plan,select_cycle_purchase_page)
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} featureKey - tool tip key
 * @property {number} productId - productId
 * @property {Url} referer - referral
 * @property {string} productGuid - Product Guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<onePagePpHoverOnFeaturesParams>} LogObject<onePagePpHoverOnFeaturesParams>
 */
export function onePagePpHoverOnFeatures(params) {
    return { evid: 3910, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onePagePpClickOnUpsellBannner' event (evid: 3911)
 *
 * Event description: Client event
 * In the one page Package Picker, Click on “save more over time” offer
 *
 * @param {onePagePpClickOnUpsellBannnerParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} fromStep - in which step you are (select_plan,select_cycle)
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - productId
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - MSID
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<onePagePpClickOnUpsellBannnerParams>} LogObject<onePagePpClickOnUpsellBannnerParams>
 */
export function onePagePpClickOnUpsellBannner(params) {
    return { evid: 3911, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newDealClickChangePpType' event (evid: 3912)
 *
 * Event description: when a user clicks on the PP tab
 *
 * @param {newDealClickChangePpTypeParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - top_switch / bottom_switch
 * @property {string} products - json
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} ppType - website / business
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} currency - currency
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} pricing - pricing json
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<newDealClickChangePpTypeParams>} LogObject<newDealClickChangePpTypeParams>
 */
export function newDealClickChangePpType(params) {
    return { evid: 3912, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newDealHoverChangePpType' event (evid: 3913)
 *
 * Event description: when a user clicks on the PP tab
 *
 * @param {newDealHoverChangePpTypeParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} ppType - website / business
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<newDealHoverChangePpTypeParams>} LogObject<newDealHoverChangePpTypeParams>
 */
export function newDealHoverChangePpType(params) {
    return { evid: 3913, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerRequestACallLoad' event (evid: 3914)
 *
 * Event description: PP -  Click 'Request a call' button to enterprise PP
 *
 * @param {packagePickerRequestACallLoadParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - click_type
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} ppType - pp_type
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<packagePickerRequestACallLoadParams>} LogObject<packagePickerRequestACallLoadParams>
 */
export function packagePickerRequestACallLoad(params) {
    return { evid: 3914, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerRequestACallCta' event (evid: 3915)
 *
 * Event description: PackagePicker >  'Request a call' CTA
 *
 * @param {packagePickerRequestACallCtaParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - offering type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - close/submit
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<packagePickerRequestACallCtaParams>} LogObject<packagePickerRequestACallCtaParams>
 */
export function packagePickerRequestACallCta(params) {
    return { evid: 3915, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newDeal2ndStepViewTooltip' event (evid: 3916)
 *
 * Event description: when view tooltip
 *
 * @param {newDeal2ndStepViewTooltipParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - packagePickerType
 * @property {string} tooltipName - tooltipName
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} ppType - website / business
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<newDeal2ndStepViewTooltipParams>} LogObject<newDeal2ndStepViewTooltipParams>
 */
export function newDeal2ndStepViewTooltip(params) {
    return { evid: 3916, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerClickOnQuestion' event (evid: 3917)
 *
 * Event description: The user clicks on show/ hide Frequently Asked
 * Questions.
 *
 * @param {packagePickerClickOnQuestionParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - show/ hide
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - pageview
 * @property {string} ppType - website / business
 * @property {string} questionType - question title. e.g "How do I get my free domain?"
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - pageview
 * @return {LogObject<packagePickerClickOnQuestionParams>} LogObject<packagePickerClickOnQuestionParams>
 */
export function packagePickerClickOnQuestion(params) {
    return { evid: 3917, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerShowFeature' event (evid: 3918)
 *
 * Event description: The user clicks on show features / hide features on the business PP tab.
 *
 * @param {packagePickerShowFeatureParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} showFeatureType - feature type
 * @property {string} clickType - show/ hide
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - pageview
 * @property {string} ppType - website / business
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - pageview
 * @return {LogObject<packagePickerShowFeatureParams>} LogObject<packagePickerShowFeatureParams>
 */
export function packagePickerShowFeature(params) {
    return { evid: 3918, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerShowAllFeatures' event (evid: 3919)
 *
 * Event description: package picker  > Show  All  features.
 *
 * @param {packagePickerShowAllFeaturesParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - show/ hide
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - pageview
 * @property {string} ppType - website / business
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - pageview
 * @return {LogObject<packagePickerShowAllFeaturesParams>} LogObject<packagePickerShowAllFeaturesParams>
 */
export function packagePickerShowAllFeatures(params) {
    return { evid: 3919, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainPurchaseSuccessPageClick' event (evid: 392)
 *
 * Event description: Client
 *
 * @param {domainPurchaseSuccessPageClickParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} viewMode - mobile / desktop
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - domain voucher
 * @property {string} email - 1 | 0 (email promo view)
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} paymentMethod - credit_card | sepa  | boleto
 * @property {string} acceptLang - accept_lng
 * @property {string} coupon - Currently, this field is used to understand if the user encounter free mailbox voucher banner
 * @property {string} siteStatus - published | etc
 * @property {string} clickType - view invoice | edit site | buy_mailbox
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} referral - referral
 * @property {string} registrar - WEB | TUCOWS | WIX-TUCOWS
 * @property {GUID} packageGuid - package_id
 * @property {string} flow - domain_purchase | extend | transfer_in
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {number} domainSkuId - domain_sku_id
 * @property {GUID} msid - msid
 * @property {string} userType - premium | free
 * @property {string} parameters - 1Site1Domain | 1Unpublished1Domain | 1FreeSite1Domain | NoSite1Domain | SeveralSitesSeveralDomains | ClickConnectBothDomains | ClickConnectOnlyOne
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} emailSale - 1 | 0
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} pageType - null / current_page / new_success_page
 * @return {LogObject<domainPurchaseSuccessPageClickParams>} LogObject<domainPurchaseSuccessPageClickParams>
 */
export function domainPurchaseSuccessPageClick(params) {
    return { evid: 392, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerTooltipLinkClick' event (evid: 3920)
 *
 * Event description: Client event
 * In the Package Picker, click on the link provided in the feature tooltip
 *
 * @param {packagePickerTooltipLinkClickParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} fromStep - in which step you are (select_plan,select_cycle_purchase_page)
 * @property {string} packagePickerType - package_picker_type
 * @property {string} url - link
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} featureKey - tool tip key
 * @property {number} productId - productId
 * @property {Url} referer - referral
 * @property {string} productGuid - Product Guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<packagePickerTooltipLinkClickParams>} LogObject<packagePickerTooltipLinkClickParams>
 */
export function packagePickerTooltipLinkClick(params) {
    return { evid: 3920, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerCycleSelection2ndStepGoToCheckout' event (evid: 3921)
 *
 * Event description: Plan PP - select cycle and click to move to purchase page
 *
 * @param {packagePickerCycleSelection2ndStepGoToCheckoutParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - newPurchase
 * @property {number} cycle - cycle
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} additionalInfo - additionalInfo
 * @property {number} productId - productId
 * @property {GUID} siteGuid - siteGuid
 * @property {string} abTesting - abTesting
 * @return {LogObject<packagePickerCycleSelection2ndStepGoToCheckoutParams>} LogObject<packagePickerCycleSelection2ndStepGoToCheckoutParams>
 */
export function packagePickerCycleSelection2ndStepGoToCheckout(params) {
    return { evid: 3921, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerComparePlanFeatures' event (evid: 3922)
 *
 * Event description: The user clicks on Compare Plan Features button to see the entire grid (full plans comparison below the cards)
 *
 * @param {packagePickerComparePlanFeaturesParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} showFeatureType - feature type
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - pageview
 * @property {string} ppType - pp_type
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - pageview
 * @return {LogObject<packagePickerComparePlanFeaturesParams>} LogObject<packagePickerComparePlanFeaturesParams>
 */
export function packagePickerComparePlanFeatures(params) {
    return { evid: 3922, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerClickOnCtaInAnonymous' event (evid: 3923)
 *
 * Event description: User click on a CTA in anonymous package picker
 *
 * @param {packagePickerClickOnCtaInAnonymousParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} targetUrl - target url of the click
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} ctaName - the name of the CTA clicked
 * @property {GUID} packageGuid - package_id
 * @property {number} foldNumber - number of the fold the cta was clicked on
 * @property {string} pagename - ab_test
 * @property {Url} pageURL - url of the page where the click happened
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abtesting - abtesting
 * @property {string} eventAggregator - event_aggregator
 * @property {string} segment - segment
 * @return {LogObject<packagePickerClickOnCtaInAnonymousParams>} LogObject<packagePickerClickOnCtaInAnonymousParams>
 */
export function packagePickerClickOnCtaInAnonymous(params) {
    return { evid: 3923, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerClickBack' event (evid: 3924)
 *
 * Event description: PP -  Click back (currently in express checkout)
 *
 * @param {packagePickerClickBackParams} params - The parameters for this event
 * @property {string} siteTypeName - .
 * @property {string} packagePickerType - packagePickerType
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - .
 * @property {string} clickType - click_type
 * @property {string} deviceType - .
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - .
 * @property {GUID} packageGuid - package_id
 * @property {string} countryCode - .
 * @property {string} pagename - .
 * @property {string} ppType - pp_type
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - .
 * @property {string} intentDomainName - domain
 * @property {GUID} msid - msid
 * @property {number} referralType - .
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - .
 * @property {string} abTesting - .
 * @return {LogObject<packagePickerClickBackParams>} LogObject<packagePickerClickBackParams>
 */
export function packagePickerClickBack(params) {
    return { evid: 3924, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerCycleSelection2ndStepClickContinueToCheckoutSrc17Evid3925' event (evid: 3925)
 *
 * Event description: package picker > cycle selection (2nd step) > Click continue to checkout
 *
 * @param {packagePickerCycleSelection2ndStepClickContinueToCheckoutSrc17Evid3925Params} params - The parameters for this event
 * @property {number} cycleid - Cycle chosen
 * @property {string} packagePickerType - package_picker_type
 * @property {string} productGuid - productGuid
 * @property {string} siteId - siteId
 * @property {boolean} IsCartFlow - is_cart_flow
 * @property {string} cartFlow - cartFlow
 * @property {string} eventAggregator - session identifier
 * @return {LogObject<packagePickerCycleSelection2ndStepClickContinueToCheckoutSrc17Evid3925Params>} LogObject<packagePickerCycleSelection2ndStepClickContinueToCheckoutSrc17Evid3925Params>
 */
export function packagePickerCycleSelection2ndStepClickContinueToCheckoutSrc17Evid3925(params) {
    return { evid: 3925, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerCycleSelectionRevShareEligibilitySrc17Evid3926' event (evid: 3926)
 *
 * Event description: On load of cycle selection step in PP (Studio only a first), was the site/user/account eligible to see Rev share
 *
 * @param {packagePickerCycleSelectionRevShareEligibilitySrc17Evid3926Params} params - The parameters for this event
 * @property {string} msid - msid
 * @property {boolean} isEligible - is eligible to get rev share
 * @property {string} failReason - why didn't get rev share (permissions/not site creator etc)
 * @property {string} eventAggregator - eventAggregator
 * @return {LogObject<packagePickerCycleSelectionRevShareEligibilitySrc17Evid3926Params>} LogObject<packagePickerCycleSelectionRevShareEligibilitySrc17Evid3926Params>
 */
export function packagePickerCycleSelectionRevShareEligibilitySrc17Evid3926(params) {
    return { evid: 3926, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerCycleSelectionRevShareLoadedSrc17Evid3927' event (evid: 3927)
 *
 * Event description: On load of cycle selection step in PP (Studio only a first), user got the Rev share info
 *
 * @param {packagePickerCycleSelectionRevShareLoadedSrc17Evid3927Params} params - The parameters for this event
 * @property {string} msid - msid
 * @property {string} eventAggregator - eventAggregator
 * @return {LogObject<packagePickerCycleSelectionRevShareLoadedSrc17Evid3927Params>} LogObject<packagePickerCycleSelectionRevShareLoadedSrc17Evid3927Params>
 */
export function packagePickerCycleSelectionRevShareLoadedSrc17Evid3927(params) {
    return { evid: 3927, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domaingptOnSbumit' event (evid: 393)
 *
 * Event description: user interaction with the AI (on click)
 *
 * @param {domaingptOnSbumitParams} params - The parameters for this event
 * @property {string} viewMode - concierge , purchase
 * @property {number} numberOfMessages - number of messages with AI so far
 * @property {GUID} uuid - user guid
 * @property {string} clickType - submit, find something better, refine based on my favorites
 * @property {string} error - error
 * @property {string} userInput - free text inserted by the user
 * @property {string} likedDomains - all domains user liked
 * @property {GUID} msid - msid
 * @return {LogObject<domaingptOnSbumitParams>} LogObject<domaingptOnSbumitParams>
 */
export function domaingptOnSbumit(params) {
    return { evid: 393, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domaingptOnReceivedCompletion' event (evid: 394)
 *
 * Event description: result returned from AI (suggestions)
 *
 * @param {domaingptOnReceivedCompletionParams} params - The parameters for this event
 * @property {string} viewMode - concierge , purchase
 * @property {number} numberOfMessages - number of messages with AI so far
 * @property {string} usage - token's parameter
 * @property {GUID} uuid - user guid
 * @property {string} result - array of suggested domains
 * @property {string} error - error
 * @property {string} userInput - free text inserted by the user
 * @property {GUID} msid - msid
 * @return {LogObject<domaingptOnReceivedCompletionParams>} LogObject<domaingptOnReceivedCompletionParams>
 */
export function domaingptOnReceivedCompletion(params) {
    return { evid: 394, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domaingptActionsOnResult' event (evid: 395)
 *
 * Event description: actions done by the user on AI results - get it (=purchase), LIKE, UNLIKE
 *
 * @param {domaingptActionsOnResultParams} params - The parameters for this event
 * @property {string} viewMode - concierge , purchase
 * @property {string} domain - domain
 * @property {GUID} uuid - user guid
 * @property {string} clickType - getIt, like, unlike, reset, selectTLD
 * @property {string} error - error
 * @property {GUID} msid - msid
 * @return {LogObject<domaingptActionsOnResultParams>} LogObject<domaingptActionsOnResultParams>
 */
export function domaingptActionsOnResult(params) {
    return { evid: 395, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domaingptVisitExit' event (evid: 396)
 *
 * Event description: trigger when banner "go to GPT" is clicked or when "leave GPT" are clicked
 *
 * @param {domaingptVisitExitParams} params - The parameters for this event
 * @property {string} viewMode - concierge
 * @property {GUID} uuid - user guid
 * @property {string} clickType - enter , leave
 * @property {string} error - error
 * @property {GUID} msid - msid
 * @return {LogObject<domaingptVisitExitParams>} LogObject<domaingptVisitExitParams>
 */
export function domaingptVisitExit(params) {
    return { evid: 396, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domaingptError' event (evid: 397)
 *
 * Event description: error appears
 *
 * @param {domaingptErrorParams} params - The parameters for this event
 * @property {string} viewMode - concierge
 * @property {GUID} uuid - user guid
 * @property {string} errorMsg - Error Message
 * @property {GUID} msid - msid
 * @return {LogObject<domaingptErrorParams>} LogObject<domaingptErrorParams>
 */
export function domaingptError(params) {
    return { evid: 397, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainsSearchView' event (evid: 398)
 *
 * Event description: User viewed the Domain Search page
 * (in desktop accountLevel , in mobile - both accountLevel & siteLevel)
 *
 * @param {domainsSearchViewParams} params - The parameters for this event
 * @property {string} viewMode - mobile, accountLevel
 * @property {string} uuid - uuid
 * @property {string} referralAdditionalInfo - domain_connect_domain , buy_a_domain , connect_domain_you_already_own , domains-item
 * @property {GUID} msid - site
 * @return {LogObject<domainsSearchViewParams>} LogObject<domainsSearchViewParams>
 */
export function domainsSearchView(params) {
    return { evid: 398, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteTosSectionShown' event (evid: 399)
 *
 * Event description: User was shown a TOS section in business email page
 *
 * @param {gSuiteTosSectionShownParams} params - The parameters for this event
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @property {string} productGuid - product id
 * @property {GUID} msid - msid
 * @return {LogObject<gSuiteTosSectionShownParams>} LogObject<gSuiteTosSectionShownParams>
 */
export function gSuiteTosSectionShown(params) {
    return { evid: 399, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnCancel' event (evid: 4)
 *
 * Event description: click on "cancel plan", pop up open
 *
 * @param {aClickOnCancelParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {GUID} siteid - site_id
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - cycle_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} subscriptionId - subscriptionId
 * @return {LogObject<aClickOnCancelParams>} LogObject<aClickOnCancelParams>
 */
export function aClickOnCancel(params) {
    return { evid: 4, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDomainSummaryPage' event (evid: 40)
 *
 * Event description: Users open/see domain summary tab
 *
 * @param {vDomainSummaryPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vDomainSummaryPageParams>} LogObject<vDomainSummaryPageParams>
 */
export function vDomainSummaryPage(params) {
    return { evid: 40, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMail' event (evid: 400)
 *
 * Event description: G-suite > My mailboxes > Page load success.
 *
 * @param {vMailParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} VoiceCtaType - voice cta type
 * @property {boolean} IsVoiceSetUp - is_voice_set_up
 * @property {boolean} IsVoiceTos - is_voice_tos
 * @property {string} VoiceEligibility - Purchase, Entry point, etc.
 * @property {string} VoiceBanner - Pending, set up, renew, TOS, payment problem mailbox, payment problem voice
 *
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {string} nextStep - Next step type - Single Connected domain/  Multiple Connected domain /No connected domain
 * @property {number} accountTotalDomains - account_total_domains
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - empty_state/manage_state
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} voucher - True/False
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {boolean} hasLiveMailbox - has_live_mailbox
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {number} domainsNotAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {number} siteTotalDomains - site_total_domains
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain name
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {number} expiredMailboxAccounts - number of expired mailbox accounts
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} domainsAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} pagetype - page_type
 * @property {string} device_type - device_type
 * @property {boolean} inSale - [yes / no]
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} isConnectedDomain - true, false
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} emailProvider - email_provider
 * @property {number} '36' - email_sku_id
 * @property {number} siteConnectedDomains - site_connected_domains
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain name
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} pageView - site_level/account_level
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - is_account_premium
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} activeMailboxAccounts - number of active mailbox accounts
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - current version of the page
 * @property {boolean} isPremium - is_premium
 * @property {string} pageName - current version of the page
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} accountConnectedDomains - account_connected_domains
 * @property {number} '29' - initiator
 * @property {string} discount - discount
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} BannerType - The type of banner when it appears
 *
 * @property {string} Recommended - What addons are offered
 * @property {string} ActiveVoices - Numbers of active google voice subscriptions
 * @property {string} ActiveGeminis - Number of active Gemini subscriptions
 *
 * @property {string} TotalMailboxAccounts - Total Business Email subscriptions user have (as shown on the page)
 *
 * @property {string} isAddonPopup - Did the user see any popup in the add-ons section.
 * @return {LogObject<vMailParams>} LogObject<vMailParams>
 */
export function vMail(params) {
    return { evid: 400, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fraudBusterBlockEvent' event (evid: 4001)
 *
 * Event description: Fraud buster blocking transactions
 *
 * @param {fraudBusterBlockEventParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - Blocked billing account
 * @property {GUID} uuid - user_guid
 * @property {string} reason - Excessive Declines/Multiple Billing Cards...
 * @property {number} invoiceId - Blocked invoice
 * @property {string} user_agent - user_agent
 * @property {number} fraudScore - Fraud Score
 * @return {LogObject<fraudBusterBlockEventParams>} LogObject<fraudBusterBlockEventParams>
 */
export function fraudBusterBlockEvent(params) {
    return { evid: 4001, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addToBlacklist' event (evid: 4002)
 *
 * Event description: a user was added to the Blacklist
 *
 * @param {addToBlacklistParams} params - The parameters for this event
 * @property {string} reporter - whoever reported the user
 * @property {GUID} uuid - user_guid
 * @property {string} user_agent - user_agent
 * @return {LogObject<addToBlacklistParams>} LogObject<addToBlacklistParams>
 */
export function addToBlacklist(params) {
    return { evid: 4002, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'removeFromBlacklist' event (evid: 4003)
 *
 * Event description: When we remove a user from Blacklist
 *
 * @param {removeFromBlacklistParams} params - The parameters for this event
 * @property {GUID} uuid - user_guid
 * @property {string} user_agent - user_agent
 * @return {LogObject<removeFromBlacklistParams>} LogObject<removeFromBlacklistParams>
 */
export function removeFromBlacklist(params) {
    return { evid: 4003, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blockUserSuccess' event (evid: 4004)
 *
 * Event description: When we ask user server to block a user and it succeeds
 *
 * @param {blockUserSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - user_guid
 * @property {string} user_agent - user_agent
 * @return {LogObject<blockUserSuccessParams>} LogObject<blockUserSuccessParams>
 */
export function blockUserSuccess(params) {
    return { evid: 4004, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blockUserFailed' event (evid: 4005)
 *
 * Event description: When we ask user server to block a user and it fails
 *
 * @param {blockUserFailedParams} params - The parameters for this event
 * @property {GUID} uuid - user_guid
 * @property {string} user_agent - user_agent
 * @return {LogObject<blockUserFailedParams>} LogObject<blockUserFailedParams>
 */
export function blockUserFailed(params) {
    return { evid: 4005, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'phishingSiteForFreeUserHandled' event (evid: 4006)
 *
 * Event description: This event will fire when fraud buster handles phishing event for free user.
 *
 * @param {phishingSiteForFreeUserHandledParams} params - The parameters for this event
 * @property {GUID} uuid - user_guid
 * @property {string} user_agent - user_agent
 * @property {GUID} siteId - site_id
 * @property {GUID} metaSiteId - msid
 * @return {LogObject<phishingSiteForFreeUserHandledParams>} LogObject<phishingSiteForFreeUserHandledParams>
 */
export function phishingSiteForFreeUserHandled(params) {
    return { evid: 4006, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'phishingSiteForPremiumUserHandled' event (evid: 4007)
 *
 * Event description: This event will fire when fraud buster handles phishing event for premium user.
 *
 * @param {phishingSiteForPremiumUserHandledParams} params - The parameters for this event
 * @property {GUID} uuid - user_guid
 * @property {string} user_agent - user_agent
 * @property {GUID} siteId - site_id
 * @property {GUID} metaSiteId - msid
 * @return {LogObject<phishingSiteForPremiumUserHandledParams>} LogObject<phishingSiteForPremiumUserHandledParams>
 */
export function phishingSiteForPremiumUserHandled(params) {
    return { evid: 4007, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'phishingSiteHandlingFailed' event (evid: 4008)
 *
 * Event description: This event will fire when fraud buster failed during handling the phishing site.
 *
 * @param {phishingSiteHandlingFailedParams} params - The parameters for this event
 * @property {GUID} uuid - user_guid
 * @property {string} reason - reason
 * @property {string} user_agent - user_agent
 * @property {GUID} siteId - site_id
 * @property {GUID} metaSiteId - msid
 * @return {LogObject<phishingSiteHandlingFailedParams>} LogObject<phishingSiteHandlingFailedParams>
 */
export function phishingSiteHandlingFailed(params) {
    return { evid: 4008, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainTestEvidForFed' event (evid: 4009)
 *
 * Event description: domain which holds many actions such as view, hover, clicks. for test purposes
 *
 * @param {domainTestEvidForFedParams} params - The parameters for this event
 * @property {number} responseSpeed - response_speed
 * @property {number} numOfSuggestions - number of suggestions appeared
 * @property {string} viewMode - concierge , purchase
 * @property {string} voucher - true | false
 * @property {string} conciergeStatus - search results error (only from concierge)
 * @property {number} numOfLabels - number of labeled suggestions appeared
 * @property {string} domain - domain
 * @property {string} searchTerm - searched domain
 * @property {string} result - array of suggested domains/available/error message
 * @property {string} connectionStatus - domain connection status
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} requestId - request
 * @property {string} suggestionsList - complex results
 * @property {string} type - suggestions/available/error/pending_transfer_completion
 * @property {GUID} msid - msid
 * @return {LogObject<domainTestEvidForFedParams>} LogObject<domainTestEvidForFedParams>
 */
export function domainTestEvidForFed(params) {
    return { evid: 4009, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vPayments' event (evid: 401)
 *
 * Event description: View_popup_after_cancellation
 *
 * @param {vPaymentsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} popupType - popup_type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vPaymentsParams>} LogObject<vPaymentsParams>
 */
export function vPayments(params) {
    return { evid: 401, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'requestForServicesTerminationByWixSrc17Evid4010' event (evid: 4010)
 *
 * Event description: This event will fire when a request for service termination is created by wix employees.
 * Currently the limit for request is 15 services and we want to monitor it.
 *
 * @param {requestForServicesTerminationByWixSrc17Evid4010Params} params - The parameters for this event
 * @property {boolean} isLimitExceeded - is_limit_exceeded
 * @property {string} source - source of request
 * @property {number} countServices - number of services to exclude
 * @property {string} user_agent - user_agent
 * @property {string} servicesList - list of services to terminate
 * @return {LogObject<requestForServicesTerminationByWixSrc17Evid4010Params>} LogObject<requestForServicesTerminationByWixSrc17Evid4010Params>
 */
export function requestForServicesTerminationByWixSrc17Evid4010(params) {
    return { evid: 4010, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMailClickOnCancel' event (evid: 402)
 *
 * Event description: A_Mail_ClickOnCancel
 *
 * @param {aMailClickOnCancelParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} clickType - click_type
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} popupType - popup_type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMailClickOnCancelParams>} LogObject<aMailClickOnCancelParams>
 */
export function aMailClickOnCancel(params) {
    return { evid: 402, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailCancelRenewRequestSuccess' event (evid: 404)
 *
 * Event description: reused - R_Mail_CancelRenewRequestSuccess
 *
 * @param {rMailCancelRenewRequestSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - serviceGuid
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - voucherGuid
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - serviceGuid
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailCancelRenewRequestSuccessParams>} LogObject<rMailCancelRenewRequestSuccessParams>
 */
export function rMailCancelRenewRequestSuccess(params) {
    return { evid: 404, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteEmptyStateError' event (evid: 4040)
 *
 * Event description: G-suite > empty state error
 *
 * @param {gSuiteEmptyStateErrorParams} params - The parameters for this event
 * @property {string} errorInfo - error_info
 * @property {string} viewMode - view_mode
 * @property {string} domainName - domain_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {GUID} siteGuid - msid
 * @return {LogObject<gSuiteEmptyStateErrorParams>} LogObject<gSuiteEmptyStateErrorParams>
 */
export function gSuiteEmptyStateError(params) {
    return { evid: 4040, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPackageRenew' event (evid: 409)
 *
 * Event description: A_Package_Renew
 *
 * @param {aPackageRenewParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPackageRenewParams>} LogObject<aPackageRenewParams>
 */
export function aPackageRenew(params) {
    return { evid: 409, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myMailboxesClickOnAction' event (evid: 4100)
 *
 * Event description: My Mailboxes - click on the action connect a domain /  get a Mailbox
 *
 * @param {myMailboxesClickOnActionParams} params - The parameters for this event
 * @property {number} accountTotalDomains - No of domains in the account
 * @property {string} viewMode - empty_state / manage_state
 * @property {string} voucher - true/false
 * @property {boolean} hasLiveMailbox - live mailbox in another site
 * @property {number} siteTotalDomains - No of domains in the site
 * @property {string} clickType - connect a domain /  get a Mailbox
 * @property {boolean} inSale - [yes / no]
 * @property {number} emailProvider - 1 OR 2
 * @property {number} siteConnectedDomains - No of domains connected to the site
 * @property {string} referralAdditionalInfo - make sure it's account or site
 * @property {boolean} isAccountPremium - free_account/premium_account
 * @property {boolean} isPremium - free_site/premium_site
 * @property {number} accountConnectedDomains - No of domains connected to the account
 * @property {string} discount - discount
 * @property {GUID} siteGuid - msid
 * @return {LogObject<myMailboxesClickOnActionParams>} LogObject<myMailboxesClickOnActionParams>
 */
export function myMailboxesClickOnAction(params) {
    return { evid: 4100, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myMailboxesBlockPage' event (evid: 4101)
 *
 * Event description: My Mailboxes > Block Page
 *
 * @param {myMailboxesBlockPageParams} params - The parameters for this event
 * @property {number} accountTotalDomains - /
 * @property {string} viewMode - /
 * @property {string} voucher - /
 * @property {string} errorInfo - restricted geo
 * @property {boolean} hasLiveMailbox - /
 * @property {number} siteTotalDomains - /
 * @property {string} domain - domain
 * @property {boolean} inSale - true, false
 * @property {string} emailProvider - /
 * @property {number} siteConnectedDomains - /
 * @property {number} '27' - /
 * @property {boolean} emailProvided - /
 * @property {string} referralAdditionalInfo - mydomains__domaininfotab
 * @property {boolean} isAccountPremium - true, false
 * @property {number} accountConnectedDomains - /
 * @property {number} discount - /
 * @property {GUID} siteGuid - /
 * @return {LogObject<myMailboxesBlockPageParams>} LogObject<myMailboxesBlockPageParams>
 */
export function myMailboxesBlockPage(params) {
    return { evid: 4101, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myMailboxesBlockPageClickLearnMore' event (evid: 4102)
 *
 * Event description: My Mailboxes > Block Page > click learn more
 *
 * @param {myMailboxesBlockPageClickLearnMoreParams} params - The parameters for this event
 * @property {number} accountTotalDomains - /
 * @property {string} viewMode - /
 * @property {string} voucher - /
 * @property {boolean} hasLiveMailbox - /
 * @property {number} siteTotalDomains - /
 * @property {string} domain - domain
 * @property {boolean} inSale - in sale
 * @property {number} siteConnectedDomains - /
 * @property {number} emailprovider - /
 * @property {boolean} discounts - /
 * @property {boolean} isAccountPremium - is account premium
 * @property {number} accountConnectedDomains - /
 * @property {string} errorinfo - /
 * @property {number} discount - /
 * @property {GUID} siteGuid - /
 * @property {string} referraladditionalinfo - /
 * @return {LogObject<myMailboxesBlockPageClickLearnMoreParams>} LogObject<myMailboxesBlockPageClickLearnMoreParams>
 */
export function myMailboxesBlockPageClickLearnMore(params) {
    return { evid: 4102, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseRestrictedDomain' event (evid: 4103)
 *
 * Event description: My Mailboxes > Block Page
 *
 * @param {gSuitePurchaseRestrictedDomainParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - /
 * @property {string} errorInfo - /
 * @property {number} emailSkuId - /
 * @property {string} flowType - flow_type
 * @property {string} errorInfoShown - domain tld restricted, domain subdomain restricted, domain char restricted
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - /
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} emailskuid - /
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - mydomains__domaininfotab
 * @property {Url} referer - referral
 * @property {boolean} domainSubdomainRestricted - false, true
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {boolean} domainCharRestricted - false, true
 * @property {number} cycleId - /
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {boolean} domainTldRestricted - false, true
 * @return {LogObject<gSuitePurchaseRestrictedDomainParams>} LogObject<gSuitePurchaseRestrictedDomainParams>
 */
export function gSuitePurchaseRestrictedDomain(params) {
    return { evid: 4103, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseRestrictedDomainClickBuyADomain' event (evid: 4104)
 *
 * Event description: Block Page >  buy a domain / go to domains. There are two events in restricted domains page. one is click buy a domain, and another one click go to domains. We can differentiatewith error_info field.
 *
 * @param {gSuitePurchaseRestrictedDomainClickBuyADomainParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - /
 * @property {string} errorInfo - BRAND, TLD , SUBDOMAIN
 * @property {number} emailSkuId - /
 * @property {string} flowType - Flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - /
 * @property {string} newPurchase - is_new_purchase
 * @property {number} cycleid - /
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} emailskuid - /
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - /
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuitePurchaseRestrictedDomainClickBuyADomainParams>} LogObject<gSuitePurchaseRestrictedDomainClickBuyADomainParams>
 */
export function gSuitePurchaseRestrictedDomainClickBuyADomain(params) {
    return { evid: 4104, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseSubmitPurchaseBlock' event (evid: 4106)
 *
 * Event description: G-suite purchase > submit purchase block.
 *
 * @param {gSuitePurchaseSubmitPurchaseBlockParams} params - The parameters for this event
 * @property {string} errorInfo - already purchased by wix/already purchased by other reseller/ Non Eligible for repurchase
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {GUID} userGuid - uuid
 * @return {LogObject<gSuitePurchaseSubmitPurchaseBlockParams>} LogObject<gSuitePurchaseSubmitPurchaseBlockParams>
 */
export function gSuitePurchaseSubmitPurchaseBlock(params) {
    return { evid: 4106, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseSubmitBlockMessageView' event (evid: 4107)
 *
 * Event description: G-suite purchase > submit block message view.
 *
 * @param {gSuitePurchaseSubmitBlockMessageViewParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - voucher
 * @property {string} errorInfo - error_info
 * @property {string} flowType - flow_type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuitePurchaseSubmitBlockMessageViewParams>} LogObject<gSuitePurchaseSubmitBlockMessageViewParams>
 */
export function gSuitePurchaseSubmitBlockMessageView(params) {
    return { evid: 4107, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myMailboxesPendingStateView' event (evid: 4108)
 *
 * Event description: My mailboxes - pending state view
 *
 * @param {myMailboxesPendingStateViewParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} actionName - setup_mailbox
 * @property {string} referraladditionalinfo - referral_additional_info
 * @return {LogObject<myMailboxesPendingStateViewParams>} LogObject<myMailboxesPendingStateViewParams>
 */
export function myMailboxesPendingStateView(params) {
    return { evid: 4108, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myMailboxesPendingStateResolvedView' event (evid: 4109)
 *
 * Event description: My mailboxes - pending state resolved  view
 *
 * @param {myMailboxesPendingStateResolvedViewParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} actionName - setup_mailbox
 * @property {string} referraladditionalinfo - referral_additional_info
 * @return {LogObject<myMailboxesPendingStateResolvedViewParams>} LogObject<myMailboxesPendingStateResolvedViewParams>
 */
export function myMailboxesPendingStateResolvedView(params) {
    return { evid: 4109, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteSelectADomainPageLoadSuccess' event (evid: 4112)
 *
 * Event description: G-suite > select a domain > Page load success
 *
 * @param {gSuiteSelectADomainPageLoadSuccessParams} params - The parameters for this event
 * @property {number} accountTotalDomains - account_total_domains
 * @property {string} viewMode - empty_state/manage_state
 * @property {string} voucher - voucher
 * @property {boolean} hasLiveMailbox - has_live_mailbox
 * @property {number} domainsNotAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {number} siteTotalDomains - site_total_domains
 * @property {string} domain - domain name
 * @property {number} expiredMailboxAccounts - expired_mailbox_accounts
 * @property {number} domainsAvailableForPurchase - domains_available_for_purchase
 * @property {string} pagetype - page_type
 * @property {boolean} inSale - in_sale
 * @property {number} emailProvider - email_provider
 * @property {number} siteConnectedDomains - site_connected_domains
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} activeMailboxAccounts - number of active mailbox accounts
 * @property {boolean} isPremium - is_premium
 * @property {string} pageName - current version of the page
 * @property {number} accountConnectedDomains - account_connected_domains
 * @property {GUID} siteGuid - site_id
 * @return {LogObject<gSuiteSelectADomainPageLoadSuccessParams>} LogObject<gSuiteSelectADomainPageLoadSuccessParams>
 */
export function gSuiteSelectADomainPageLoadSuccess(params) {
    return { evid: 4112, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteSelectADomainClickOnAction' event (evid: 4113)
 *
 * Event description: G-suite > select a domain > click on action
 *
 * @param {gSuiteSelectADomainClickOnActionParams} params - The parameters for this event
 * @property {number} accountTotalDomains - account total domains
 * @property {string} viewMode - empty_state/manage_state
 * @property {string} voucher - True/False
 * @property {boolean} hasLiveMailbox - has live mailbox
 * @property {number} domainsNotAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {number} siteTotalDomains - site total domains
 * @property {string} domain - domain
 * @property {number} expiredMailboxAccounts - number of expired mailbox accounts
 * @property {number} domainsAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {string} clickType - Search bar => search Available Domain=> available _domain Desabled  Domain=> desabled_domain Restricted  Domain=> restricted _domain Select=> select  Cancel/X  =>  cancel
 * @property {string} pagetype - page_type
 * @property {boolean} inSale - [yes / no]
 * @property {number} emailProvider - email provider
 * @property {number} siteConnectedDomains - site connected domains
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - is account premium
 * @property {number} activeMailboxAccounts - active_mailbox_accounts
 * @property {boolean} isPremium - is premium
 * @property {string} pageName - current version of the page
 * @property {number} accountConnectedDomains - account connected domains
 * @property {string} discount - discount
 * @property {GUID} siteGuid - site id
 * @return {LogObject<gSuiteSelectADomainClickOnActionParams>} LogObject<gSuiteSelectADomainClickOnActionParams>
 */
export function gSuiteSelectADomainClickOnAction(params) {
    return { evid: 4113, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDomainRenew' event (evid: 414)
 *
 * Event description: A_Domain_Renew.
 *
 * @param {aDomainRenewParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainRenewParams>} LogObject<aDomainRenewParams>
 */
export function aDomainRenew(params) {
    return { evid: 414, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMailPackagePicker' event (evid: 415)
 *
 * Event description: G-suite purchase > step1 (qty) load.
 *
 * @param {vMailPackagePickerParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} DeviceFlowType - If this desktop or mobile flow
 * @property {string} ProductName - ProductName
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {number} quantity - quantity
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - If the user had a PP or not
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {number} definedEmails - defined_emails
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {string} siteSegment - site_segment
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {boolean} IsCartFlow - is_cart_flow
 * @property {string} SaleType - sale_type
 * @return {LogObject<vMailPackagePickerParams>} LogObject<vMailPackagePickerParams>
 */
export function vMailPackagePicker(params) {
    return { evid: 415, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planMigrationSuccess' event (evid: 4200)
 *
 * Event description: plan was migrated successfully
 *
 * @param {planMigrationSuccessParams} params - The parameters for this event
 * @property {GUID} subscriptionId - subscription_id
 * @return {LogObject<planMigrationSuccessParams>} LogObject<planMigrationSuccessParams>
 */
export function planMigrationSuccess(params) {
    return { evid: 4200, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountMigrationSuccess' event (evid: 4201)
 *
 * Event description: account was migrated successfully
 *
 * @param {accountMigrationSuccessParams} params - The parameters for this event
 * @property {string} initiatingPackageId - initiatingPackageId
 * @property {string} initiatingFlow - initiatingFlow
 * @return {LogObject<accountMigrationSuccessParams>} LogObject<accountMigrationSuccessParams>
 */
export function accountMigrationSuccess(params) {
    return { evid: 4201, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountRevertSuccess' event (evid: 4202)
 *
 * Event description: account was reverted successfully
 *
 * @param {accountRevertSuccessParams} params - The parameters for this event
 * @return {LogObject<accountRevertSuccessParams>} LogObject<accountRevertSuccessParams>
 */
export function accountRevertSuccess(params) {
    return { evid: 4202, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'planRevertSuccess' event (evid: 4203)
 *
 * Event description: plan was reverted successfully
 *
 * @param {planRevertSuccessParams} params - The parameters for this event
 * @property {GUID} subscriptionId - subscription_id
 * @return {LogObject<planRevertSuccessParams>} LogObject<planRevertSuccessParams>
 */
export function planRevertSuccess(params) {
    return { evid: 4203, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMailPurchaseSuccess' event (evid: 426)
 *
 * Event description: G-suite purchase > view success page.
 *
 * @param {vMailPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} Device_Flow_Type - device_flow_type
 * @property {boolean} IsSetup_button - is_setup_button
 * @property {string} ProductName - ProductName
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {number} quantity - quantity
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow_type
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {number} definedEmails - defined_emails
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMailPurchaseSuccessParams>} LogObject<vMailPurchaseSuccessParams>
 */
export function vMailPurchaseSuccess(params) {
    return { evid: 426, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMailPurchasePendingPayment' event (evid: 427)
 *
 * Event description: GoogleBrazil
 *
 * @param {vMailPurchasePendingPaymentParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMailPurchasePendingPaymentParams>} LogObject<vMailPurchasePendingPaymentParams>
 */
export function vMailPurchasePendingPayment(params) {
    return { evid: 427, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailPurchaseSuccess' event (evid: 428)
 *
 * Event description: G-suite purchase > Mail Purchase Success.
 *
 * @param {rMailPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} DeviceFlowType - device_flow_type
 * @property {string} ProductName - ProductName
 * @property {string} ProductID - product_id
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {number} quantity - quantity
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - Quantity purchased
 * @property {string} errorInfo - Quantity purchased
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {number} totalSeats - total_seats
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {string} dealCode - deal_code
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {string} couponId - coupon_id
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - google_sku
 * @property {boolean} IsCartFlow - is_cart_flow
 * @property {string} SaleType - sale_type
 * @return {LogObject<rMailPurchaseSuccessParams>} LogObject<rMailPurchaseSuccessParams>
 */
export function rMailPurchaseSuccess(params) {
    return { evid: 428, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailPurchaseError' event (evid: 429)
 *
 * Event description: G-suite purchase > order page > validation error.
 *
 * @param {rMailPurchaseErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {number} quantity - quantity
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {number} definedEmails - defined_emails
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailPurchaseErrorParams>} LogObject<rMailPurchaseErrorParams>
 */
export function rMailPurchaseError(params) {
    return { evid: 429, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPurchaseMailException' event (evid: 430)
 *
 * Event description: R_PurchaseMailException.
 *
 * @param {rPurchaseMailExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPurchaseMailExceptionParams>} LogObject<rPurchaseMailExceptionParams>
 */
export function rPurchaseMailException(params) {
    return { evid: 430, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickHereSummaryPage' event (evid: 44)
 *
 * Event description: A_clickHereSummaryPage.
 *
 * @param {aClickHereSummaryPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickHereSummaryPageParams>} LogObject<aClickHereSummaryPageParams>
 */
export function aClickHereSummaryPage(params) {
    return { evid: 44, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMailSetPassword' event (evid: 446)
 *
 * Event description: triggered when domain is successfully delivered, for purchase / transfer / renewal.
 * Initiator: (1) purchase , (2) transfer, (3) renewal
 *
 * @param {aMailSetPasswordParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} isNewPurchase - false, true
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {string} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {number} cycleid - cycle_id
 * @return {LogObject<aMailSetPasswordParams>} LogObject<aMailSetPasswordParams>
 */
export function aMailSetPassword(params) {
    return { evid: 446, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickChangeSite' event (evid: 45)
 *
 * Event description: Domain - when the domain is disconnected, click on "Connect"
 *
 * @param {aClickChangeSiteParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickChangeSiteParams>} LogObject<aClickChangeSiteParams>
 */
export function aClickChangeSite(params) {
    return { evid: 45, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'emailWasTriggeredBySbs' event (evid: 4501)
 *
 * Event description: SBS or Premium triggered an Email
 *
 * @param {emailWasTriggeredBySbsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} services - sbs service_guid can be more than one
 * @property {string} invoices - invoices
 * @property {string} emailType - Recurring_charge...
 * @property {string} domain - domain
 * @property {string} experimentValue - true/false
 * @property {GUID} userGuid - user
 * @property {number} paymentCycle - cycle_id
 * @property {string} templateName - Email name (User premium invoices email)
 * @property {number} invoiceId - invoice
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} sentto - target_user_id
 * @property {GUID} packageGuid - package_id
 * @property {number} productId - product_id
 * @property {string} emailLng - template lng
 * @property {string} mailGuid - Server-side identifier of the API-call
 * @property {GUID} siteGuid - site_id
 * @property {string} packages - premium packages  can be more than one
 * @property {number} skuid - SKU id
 * @return {LogObject<emailWasTriggeredBySbsParams>} LogObject<emailWasTriggeredBySbsParams>
 */
export function emailWasTriggeredBySbs(params) {
    return { evid: 4501, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleMailSwitchExecuteSuccess' event (evid: 4502)
 *
 * Event description: Google Mail Switch Execute Success.
 *
 * @param {googleMailSwitchExecuteSuccessParams} params - The parameters for this event
 * @property {number} quantity - number of seats
 * @property {number} emailSkuId - email sku id
 * @property {GUID} emailPackageGuid - email package guid
 * @property {string} flowType - upgrade / migration
 * @property {string} domain - domain name
 * @property {string} subscriptionId - email package guid
 * @property {GUID} userGuid - uuid
 * @property {number} cycleId - cycle id
 * @return {LogObject<googleMailSwitchExecuteSuccessParams>} LogObject<googleMailSwitchExecuteSuccessParams>
 */
export function googleMailSwitchExecuteSuccess(params) {
    return { evid: 4502, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleMailAutoTransitionExecuteSuccess' event (evid: 4503)
 *
 * Event description: Google Mail Auto Transition Execute Success
 *
 * @param {googleMailAutoTransitionExecuteSuccessParams} params - The parameters for this event
 * @property {number} quantity - number of seats
 * @property {number} emailSkuId - email sku id
 * @property {GUID} emailPackageGuid - email package guid
 * @property {string} domain - domain name
 * @property {string} subscriptionId - email package guid
 * @property {GUID} userGuid - uuid
 * @property {number} cycleId - cycle id
 * @return {LogObject<googleMailAutoTransitionExecuteSuccessParams>} LogObject<googleMailAutoTransitionExecuteSuccessParams>
 */
export function googleMailAutoTransitionExecuteSuccess(params) {
    return { evid: 4503, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleMailMigrationOnWixExecuteSuccess' event (evid: 4504)
 *
 * Event description: Google Mail Migration on Wix Execute Success
 *
 * @param {googleMailMigrationOnWixExecuteSuccessParams} params - The parameters for this event
 * @property {number} quantity - number of seats
 * @property {number} emailSkuId - email sku id
 * @property {GUID} emailPackageGuid - email package guid
 * @property {string} domain - domain name
 * @property {string} subscriptionId - email package guid
 * @property {GUID} userGuid - uuid
 * @property {string} migrationType - gsuite / priceinc
 * @property {number} cycleId - cycle id
 * @property {string} OldEmailSkuId - old_email_sku_id
 * @return {LogObject<googleMailMigrationOnWixExecuteSuccessParams>} LogObject<googleMailMigrationOnWixExecuteSuccessParams>
 */
export function googleMailMigrationOnWixExecuteSuccess(params) {
    return { evid: 4504, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleMailTransitionMigrationEmailReceived' event (evid: 4505)
 *
 * Event description: Google Mail Transition migration email received
 *
 * @param {googleMailTransitionMigrationEmailReceivedParams} params - The parameters for this event
 * @property {number} quantity - number of seats
 * @property {number} emailSkuId - email_sku_id
 * @property {GUID} emailPackageGuid - email package guid
 * @property {string} domain - domain name
 * @property {string} subscriptionId - email package guid
 * @property {GUID} userGuid - uuid
 * @property {number} cycleId - cycle id
 * @return {LogObject<googleMailTransitionMigrationEmailReceivedParams>} LogObject<googleMailTransitionMigrationEmailReceivedParams>
 */
export function googleMailTransitionMigrationEmailReceived(params) {
    return { evid: 4505, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumPlanMigrationInitiated' event (evid: 4506)
 *
 * Event description: The event is fired once a service is starting migration. Success means the migration initiated successfully, but not necessarily migrated successfully
 *
 * @param {premiumPlanMigrationInitiatedParams} params - The parameters for this event
 * @property {GUID} service_id - service id
 * @property {string} uuid - uuid
 * @property {string} segmentName - segmentName
 * @property {GUID} toProduct - new product
 * @property {GUID} fromProduct - previous product
 * @property {string} failReason - if is_successful = false, whats the reason
 * @property {boolean} isSuccessful - migration initiated successfully or failed due to eligibility
 * @property {GUID} msid - msid
 * @property {GUID} serviceId - service id
 * @return {LogObject<premiumPlanMigrationInitiatedParams>} LogObject<premiumPlanMigrationInitiatedParams>
 */
export function premiumPlanMigrationInitiated(params) {
    return { evid: 4506, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumPlanMigrationInitiatedMigrationSuccess' event (evid: 4507)
 *
 * Event description: plan was migrated successfully
 *
 * @param {premiumPlanMigrationInitiatedMigrationSuccessParams} params - The parameters for this event
 * @property {GUID} uuid - userGuid
 * @property {GUID} serviceGuid - service_guid
 * @property {string} externalSessionId - external_session_id
 * @property {string} productTypeShortId - id
 * @property {GUID} subscriptionId - subscription_id - premium
 * @property {GUID} userGuid - userGuid
 * @property {string} productTypeName - product_type_name
 * @property {string} externalProvider - external_provider
 * @property {string} productTypeId - product_type_id
 * @property {GUID} previousProductGuid - prev product
 * @property {string} productGuid - productGuid
 * @property {string} productShortId - product_id
 * @property {number} cycleId - cycle_id
 * @return {LogObject<premiumPlanMigrationInitiatedMigrationSuccessParams>} LogObject<premiumPlanMigrationInitiatedMigrationSuccessParams>
 */
export function premiumPlanMigrationInitiatedMigrationSuccess(params) {
    return { evid: 4507, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleMailMigrationEligibilityCheckSrc17Evid4508' event (evid: 4508)
 *
 * Event description: Google Mail Migration eligibility check
 *
 * @param {googleMailMigrationEligibilityCheckSrc17Evid4508Params} params - The parameters for this event
 * @property {number} quantity - number of seats
 * @property {number} emailSkuId - email sku id
 * @property {GUID} emailPackageGuid - email package guid
 * @property {string} domain - domain name
 * @property {string} subscriptionId - email package guid
 * @property {GUID} userGuid - uuid
 * @property {string} migrationType - gsuite / priceinc
 * @property {number} cycleId - cycle id
 * @property {string} OldEmailSkuId - old_email_sku_id
 * @property {boolean} IsEligible - is_eligible
 * @property {boolean} IsEnabled - Is it in the population that is being subjected to migration, or is it from outside the population
 * @return {LogObject<googleMailMigrationEligibilityCheckSrc17Evid4508Params>} LogObject<googleMailMigrationEligibilityCheckSrc17Evid4508Params>
 */
export function googleMailMigrationEligibilityCheckSrc17Evid4508(params) {
    return { evid: 4508, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rChangeSiteSuccess' event (evid: 46)
 *
 * Event description: Assign an existing domain to another site in your account. the site must be premium. or Disconnect a domain (site_id will be null).
 *
 * @param {rChangeSiteSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} toMsid - to_msid
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} domainName - domain
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {GUID} fromMsid - from_msid
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - the site the domain is connecting / changing to
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - the site the domain is connecting / changing to
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rChangeSiteSuccessParams>} LogObject<rChangeSiteSuccessParams>
 */
export function rChangeSiteSuccess(params) {
    return { evid: 46, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailPurchaseStartSuccess' event (evid: 460)
 *
 * Event description: G-suite purchase > start.
 *
 * @param {rMailPurchaseStartSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} DeviceFlowType - device_flow_type
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - What flow did the user had
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} emailskuid - 4, 5
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailPurchaseStartSuccessParams>} LogObject<rMailPurchaseStartSuccessParams>
 */
export function rMailPurchaseStartSuccess(params) {
    return { evid: 460, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'alertWasTriggeredBySbs' event (evid: 4601)
 *
 * Event description: help us when we have a complex expuser event
 *
 * @param {alertWasTriggeredBySbsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} experimentValue - True/False
 * @property {GUID} userGuid - uuid
 * @property {number} paymentCycle - cycle_id
 * @property {string} newPurchase - is_new_purchase
 * @property {string} user_agent - user_agent
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} additionalData - what triggered the alert
 * @property {string} pagename - ab_test
 * @property {string} alertType - Alert name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - product_id
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<alertWasTriggeredBySbsParams>} LogObject<alertWasTriggeredBySbsParams>
 */
export function alertWasTriggeredBySbs(params) {
    return { evid: 4601, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailPurchaseStartError' event (evid: 461)
 *
 * Event description: R_MailPurchaseStartError.
 *
 * @param {rMailPurchaseStartErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailPurchaseStartErrorParams>} LogObject<rMailPurchaseStartErrorParams>
 */
export function rMailPurchaseStartError(params) {
    return { evid: 461, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailPurchaseStartException' event (evid: 462)
 *
 * Event description: R_MailPurchaseStartException.
 *
 * @param {rMailPurchaseStartExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailPurchaseStartExceptionParams>} LogObject<rMailPurchaseStartExceptionParams>
 */
export function rMailPurchaseStartException(params) {
    return { evid: 462, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailPackagePickerSuccess' event (evid: 463)
 *
 * Event description: G-suite purchase > step3 (payment).
 *
 * @param {rMailPackagePickerSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} DeviceFlowType - device_flow_type
 * @property {string} ProductName - ProductName
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {number} quantity - quantity
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow_type
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailPackagePickerSuccessParams>} LogObject<rMailPackagePickerSuccessParams>
 */
export function rMailPackagePickerSuccess(params) {
    return { evid: 463, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailPackagePickerError' event (evid: 464)
 *
 * Event description: R_MailPackagePickerError.
 *
 * @param {rMailPackagePickerErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailPackagePickerErrorParams>} LogObject<rMailPackagePickerErrorParams>
 */
export function rMailPackagePickerError(params) {
    return { evid: 464, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailPackagePickerException' event (evid: 465)
 *
 * Event description: R_MailPackagePickerException.
 *
 * @param {rMailPackagePickerExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailPackagePickerExceptionParams>} LogObject<rMailPackagePickerExceptionParams>
 */
export function rMailPackagePickerException(params) {
    return { evid: 465, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMailDomainSuccessClick' event (evid: 469)
 *
 * Event description: A_Mail_DomainSuccessClick.
 *
 * @param {aMailDomainSuccessClickParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMailDomainSuccessClickParams>} LogObject<aMailDomainSuccessClickParams>
 */
export function aMailDomainSuccessClick(params) {
    return { evid: 469, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rChangeSiteException' event (evid: 47)
 *
 * Event description: R_ChangeSiteException.
 *
 * @param {rChangeSiteExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rChangeSiteExceptionParams>} LogObject<rChangeSiteExceptionParams>
 */
export function rChangeSiteException(params) {
    return { evid: 47, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelMailbox' event (evid: 470)
 *
 * Event description: Cancel mailbox.
 *
 * @param {cancelMailboxParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<cancelMailboxParams>} LogObject<cancelMailboxParams>
 */
export function cancelMailbox(params) {
    return { evid: 470, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'detachPremiumServicesRequest' event (evid: 4700)
 *
 * Event description: when we get a request to detach premium services from a site.  Probably because a user request to delete the site or by the risk dept.
 *
 * @param {detachPremiumServicesRequestParams} params - The parameters for this event
 * @property {GUID} uuid - user guid
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid
 * @return {LogObject<detachPremiumServicesRequestParams>} LogObject<detachPremiumServicesRequestParams>
 */
export function detachPremiumServicesRequest(params) {
    return { evid: 4700, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelMailboxAutoRenewOn' event (evid: 471)
 *
 * Event description: Cancel mailbox > auto renew on.
 *
 * @param {cancelMailboxAutoRenewOnParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<cancelMailboxAutoRenewOnParams>} LogObject<cancelMailboxAutoRenewOnParams>
 */
export function cancelMailboxAutoRenewOn(params) {
    return { evid: 471, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelFlowPriceGetCoupon' event (evid: 472)
 *
 * Event description: .
 *
 * @param {cancelFlowPriceGetCouponParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - packageGuid
 * @property {GUID} packageGuid - packageGuid
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - packageGuid
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<cancelFlowPriceGetCouponParams>} LogObject<cancelFlowPriceGetCouponParams>
 */
export function cancelFlowPriceGetCoupon(params) {
    return { evid: 472, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMailClickOnReduce' event (evid: 473)
 *
 * Event description: A_MailClickOnReduce.
 *
 * @param {aMailClickOnReduceParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {number} quantity - Total number of users
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} emailSkuId - email_sku_id
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {number} numInactiveUsers - Number of current inactive users
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} cycleName - cycle
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMailClickOnReduceParams>} LogObject<aMailClickOnReduceParams>
 */
export function aMailClickOnReduce(params) {
    return { evid: 473, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMailClickOnConfirmReduce' event (evid: 474)
 *
 * Event description: A_MailClickOnConfirmReduce.
 *
 * @param {aMailClickOnConfirmReduceParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referraladditionalinfo
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMailClickOnConfirmReduceParams>} LogObject<aMailClickOnConfirmReduceParams>
 */
export function aMailClickOnConfirmReduce(params) {
    return { evid: 474, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMailReduceSuccess' event (evid: 475)
 *
 * Event description: V_MailReduceSuccess.
 *
 * @param {vMailReduceSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - packageId
 * @property {GUID} packageId - packageId
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {number} quantity - New number of seats
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - packageId
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {string} referraladditionalinfo - referral_additional_info
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMailReduceSuccessParams>} LogObject<vMailReduceSuccessParams>
 */
export function vMailReduceSuccess(params) {
    return { evid: 475, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteEditUserSuccess' event (evid: 476)
 *
 * Event description: User edit successfully name/last name/email address
 *
 * @param {gSuiteEditUserSuccessParams} params - The parameters for this event
 * @property {string} googleUserId - google user Id
 * @property {GUID} emailPackageGuid - email package guid
 * @property {boolean} firstNameChanged - true/false
 * @property {string} domain - domain name
 * @property {GUID} userGuid - uuid
 * @property {boolean} emailAddressChanged - true/false
 * @property {boolean} lastNameChanged - true/false
 * @return {LogObject<gSuiteEditUserSuccessParams>} LogObject<gSuiteEditUserSuccessParams>
 */
export function gSuiteEditUserSuccess(params) {
    return { evid: 476, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vBillingAndPayment' event (evid: 477)
 *
 * Event description: V_BillingAndPayment.
 *
 * @param {vBillingAndPaymentParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vBillingAndPaymentParams>} LogObject<vBillingAndPaymentParams>
 */
export function vBillingAndPayment(params) {
    return { evid: 477, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabViewBillingHistoryTab' event (evid: 4770)
 *
 * Event description: The user view the Billing History tab
 *
 * @param {billingHistoryTabViewBillingHistoryTabParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} userGuid - user guid
 * @property {string} pageView - empty_state/populated_state
 * @property {number} countInvoices - number of invoices
 * @return {LogObject<billingHistoryTabViewBillingHistoryTabParams>} LogObject<billingHistoryTabViewBillingHistoryTabParams>
 */
export function billingHistoryTabViewBillingHistoryTab(params) {
    return { evid: 4770, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabViewSingleInvoice' event (evid: 4771)
 *
 * Event description: The user opened an invoice
 *
 * @param {billingHistoryTabViewSingleInvoiceParams} params - The parameters for this event
 * @property {string} searchTerm - The term when clicking on the invoice. can be null.
 * @property {string} selectionType - 'view_link' / 'invoice_row'/ 'edit invoice toast'
 * @property {GUID} userGuid - user guid
 * @property {string} invoiceId - invoice number
 * @property {GUID} sessionId - session_id
 * @return {LogObject<billingHistoryTabViewSingleInvoiceParams>} LogObject<billingHistoryTabViewSingleInvoiceParams>
 */
export function billingHistoryTabViewSingleInvoice(params) {
    return { evid: 4771, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabFilterSelection' event (evid: 4772)
 *
 * Event description: user changed the filters
 *
 * @param {billingHistoryTabFilterSelectionParams} params - The parameters for this event
 * @property {string} filterValue - 'month' / 'all' / 'paid'
 * @property {string} filterType - 'time ' /  'status' / 'site'  / 'Payment Method'
 * @property {string} selectionType - 'add' / 'remove'
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabFilterSelectionParams>} LogObject<billingHistoryTabFilterSelectionParams>
 */
export function billingHistoryTabFilterSelection(params) {
    return { evid: 4772, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabAdvancedFilterLink' event (evid: 4773)
 *
 * Event description: open or closed the Advanced filter link
 *
 * @param {billingHistoryTabAdvancedFilterLinkParams} params - The parameters for this event
 * @property {string} selectionType - 'open' / 'close'
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabAdvancedFilterLinkParams>} LogObject<billingHistoryTabAdvancedFilterLinkParams>
 */
export function billingHistoryTabAdvancedFilterLink(params) {
    return { evid: 4773, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabSearchTermWhenNoResult' event (evid: 4774)
 *
 * Event description: The user opened an invoice
 *
 * @param {billingHistoryTabSearchTermWhenNoResultParams} params - The parameters for this event
 * @property {string} searchTerm - The term when no results
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabSearchTermWhenNoResultParams>} LogObject<billingHistoryTabSearchTermWhenNoResultParams>
 */
export function billingHistoryTabSearchTermWhenNoResult(params) {
    return { evid: 4774, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabClickAboutThisCharge' event (evid: 4775)
 *
 * Event description: The user clicked on - "About This Charge"
 *
 * @param {billingHistoryTabClickAboutThisChargeParams} params - The parameters for this event
 * @property {string} invoiceId - invoice number
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabClickAboutThisChargeParams>} LogObject<billingHistoryTabClickAboutThisChargeParams>
 */
export function billingHistoryTabClickAboutThisCharge(params) {
    return { evid: 4775, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabViewAboutThisChargePopup' event (evid: 4776)
 *
 * Event description: view About This Charge Popup
 *
 * @param {billingHistoryTabViewAboutThisChargePopupParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} invoiceId - invoice number
 * @property {string} popupType - 'invoice' / 'select service'
 * @return {LogObject<billingHistoryTabViewAboutThisChargePopupParams>} LogObject<billingHistoryTabViewAboutThisChargePopupParams>
 */
export function billingHistoryTabViewAboutThisChargePopup(params) {
    return { evid: 4776, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabAboutThisChargePopupAction' event (evid: 4777)
 *
 * Event description: choose action in "About This Charge" Popup
 *
 * @param {billingHistoryTabAboutThisChargePopupActionParams} params - The parameters for this event
 * @property {string} selectionType - 'close' / 'got_it / 'select service XXX'
 * @property {GUID} userGuid - user guid
 * @property {string} invoiceId - invoice number
 * @property {string} popupType - 'invoice' / 'select service'
 * @return {LogObject<billingHistoryTabAboutThisChargePopupActionParams>} LogObject<billingHistoryTabAboutThisChargePopupActionParams>
 */
export function billingHistoryTabAboutThisChargePopupAction(params) {
    return { evid: 4777, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabClickOnNfEInvoice' event (evid: 4778)
 *
 * Event description: BillingHistoryTab > click on NF-e Invoice
 *
 * @param {billingHistoryTabClickOnNfEInvoiceParams} params - The parameters for this event
 * @property {string} invoiceId - invoice number
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabClickOnNfEInvoiceParams>} LogObject<billingHistoryTabClickOnNfEInvoiceParams>
 */
export function billingHistoryTabClickOnNfEInvoice(params) {
    return { evid: 4778, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabDownloadCsv' event (evid: 4779)
 *
 * Event description: The user clicked on download CSV
 *
 * @param {billingHistoryTabDownloadCsvParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabDownloadCsvParams>} LogObject<billingHistoryTabDownloadCsvParams>
 */
export function billingHistoryTabDownloadCsv(params) {
    return { evid: 4779, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailUpdatePaymentMethodSuccess' event (evid: 478)
 *
 * Event description: R_MailUpdatePaymentMethodSuccess.
 *
 * @param {rMailUpdatePaymentMethodSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailUpdatePaymentMethodSuccessParams>} LogObject<rMailUpdatePaymentMethodSuccessParams>
 */
export function rMailUpdatePaymentMethodSuccess(params) {
    return { evid: 478, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnEditInvoiceDetails' event (evid: 4780)
 *
 * Event description: click on edit invoice details
 *
 * @param {clickOnEditInvoiceDetailsParams} params - The parameters for this event
 * @property {string} viewMode - Billing History Page, My Subscriptions Page, Site level - Subscription Page
 * @property {string} billingCountry - billing_country
 * @property {GUID} serviceGuid - service_guid
 * @property {string} domain - domain
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} invoiceId - invoice_id
 * @property {number} numberOfSubscriptions - number_of_subscriptions
 * @property {GUID} sessionId - session_id
 * @property {string} productName - product_name
 * @property {GUID} productId - product_guid
 * @property {string} subscriptionType - Premium Plan/ Ascend ...
 * @property {number} cycleId - cycle_id
 * @return {LogObject<clickOnEditInvoiceDetailsParams>} LogObject<clickOnEditInvoiceDetailsParams>
 */
export function clickOnEditInvoiceDetails(params) {
    return { evid: 4780, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabDropdownClick' event (evid: 4781)
 *
 * Event description: The user clicked on the Dropdown menu
 *
 * @param {billingHistoryTabDropdownClickParams} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {string} domain - domain
 * @property {string} searchTerm - The term when clicking on the invoice. can be null.
 * @property {string} selectionType - 'view_link' / 'invoice_row'/ 'edit invoice toast'
 * @property {GUID} userGuid - user guid
 * @property {string} invoiceId - invoice number
 * @property {string} productName - productname
 * @property {string} subscriptionType - subscriptiontype
 * @property {string} type - click_type
 * @return {LogObject<billingHistoryTabDropdownClickParams>} LogObject<billingHistoryTabDropdownClickParams>
 */
export function billingHistoryTabDropdownClick(params) {
    return { evid: 4781, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabUnknownChargeView' event (evid: 4782)
 *
 * Event description: The user clicked 'Read more' on 'Can't find the charge you're looking for'
 *
 * @param {billingHistoryTabUnknownChargeViewParams} params - The parameters for this event
 * @property {string} pageView - empty_state/populated_state
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabUnknownChargeViewParams>} LogObject<billingHistoryTabUnknownChargeViewParams>
 */
export function billingHistoryTabUnknownChargeView(params) {
    return { evid: 4782, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'unknownChargeModalClickLogInToADifferentAccount' event (evid: 4783)
 *
 * Event description: The user clicked 'Log in to a different account' in the unknown charge modal
 *
 * @param {unknownChargeModalClickLogInToADifferentAccountParams} params - The parameters for this event
 * @property {string} pageView - empty_state/populated_state
 * @property {GUID} userGuid - user guid
 * @return {LogObject<unknownChargeModalClickLogInToADifferentAccountParams>} LogObject<unknownChargeModalClickLogInToADifferentAccountParams>
 */
export function unknownChargeModalClickLogInToADifferentAccount(params) {
    return { evid: 4783, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'unknownChargeModalClickUseEmailLocator' event (evid: 4784)
 *
 * Event description: The user clicked the footer (If you don’t remember your account details, you can try to find your login email using our email locator) in the unknown charge modal
 *
 * @param {unknownChargeModalClickUseEmailLocatorParams} params - The parameters for this event
 * @property {string} pageView - empty_state/populated_state
 * @property {GUID} userGuid - user guid
 * @return {LogObject<unknownChargeModalClickUseEmailLocatorParams>} LogObject<unknownChargeModalClickUseEmailLocatorParams>
 */
export function unknownChargeModalClickUseEmailLocator(params) {
    return { evid: 4784, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorLoad' event (evid: 4785)
 *
 * Event description: a user/anonymous views the charge locator
 *
 * @param {chargeLocatorLoadParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - referral additional info
 * @return {LogObject<chargeLocatorLoadParams>} LogObject<chargeLocatorLoadParams>
 */
export function chargeLocatorLoad(params) {
    return { evid: 4785, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorClickSearch' event (evid: 4786)
 *
 * Event description: a user/anonymous clicks search to find a charge in the charge locator
 *
 * @param {chargeLocatorClickSearchParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice number
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorClickSearchParams>} LogObject<chargeLocatorClickSearchParams>
 */
export function chargeLocatorClickSearch(params) {
    return { evid: 4786, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorFaqClick' event (evid: 4787)
 *
 * Event description: a user/anonymous opened one of the FAQs in the charge locator
 *
 * @param {chargeLocatorFaqClickParams} params - The parameters for this event
 * @property {string} content - the question string
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorFaqClickParams>} LogObject<chargeLocatorFaqClickParams>
 */
export function chargeLocatorFaqClick(params) {
    return { evid: 4787, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorChargeDetailsView' event (evid: 4788)
 *
 * Event description: a user/anonymous views charge details
 *
 * @param {chargeLocatorChargeDetailsViewParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice number
 * @property {number} paymentMethod - payment method
 * @property {GUID} subscriptionId - subscription id
 * @property {string} productTypeName - Premium Plan/Domain/Mailbox
 * @property {string} amount - transaction amount
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {DateTime} transactionDate - transaction date
 * @property {number} cycleId - cycle id
 * @return {LogObject<chargeLocatorChargeDetailsViewParams>} LogObject<chargeLocatorChargeDetailsViewParams>
 */
export function chargeLocatorChargeDetailsView(params) {
    return { evid: 4788, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorChargeNotFoundView' event (evid: 4789)
 *
 * Event description: a user/anonymous sees a disclaimer that the requested charge was not found
 *
 * @param {chargeLocatorChargeNotFoundViewParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice number
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorChargeNotFoundViewParams>} LogObject<chargeLocatorChargeNotFoundViewParams>
 */
export function chargeLocatorChargeNotFoundView(params) {
    return { evid: 4789, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailUpdatePaymentMethodError' event (evid: 479)
 *
 * Event description: R_MailUpdatePaymentMethodError.
 *
 * @param {rMailUpdatePaymentMethodErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailUpdatePaymentMethodErrorParams>} LogObject<rMailUpdatePaymentMethodErrorParams>
 */
export function rMailUpdatePaymentMethodError(params) {
    return { evid: 479, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorChargeNotFoundClickContactCustomerCare' event (evid: 4790)
 *
 * Event description: a user/anonymous clicked contact customer care after he saw that the requested charge was not found
 *
 * @param {chargeLocatorChargeNotFoundClickContactCustomerCareParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice number
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorChargeNotFoundClickContactCustomerCareParams>} LogObject<chargeLocatorChargeNotFoundClickContactCustomerCareParams>
 */
export function chargeLocatorChargeNotFoundClickContactCustomerCare(params) {
    return { evid: 4790, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorChargeDetailsClickSearchAgain' event (evid: 4791)
 *
 * Event description: a user/anonymous clicks search again after he viewed a result of a previous search
 *
 * @param {chargeLocatorChargeDetailsClickSearchAgainParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorChargeDetailsClickSearchAgainParams>} LogObject<chargeLocatorChargeDetailsClickSearchAgainParams>
 */
export function chargeLocatorChargeDetailsClickSearchAgain(params) {
    return { evid: 4791, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorConsolidatedInvoiceView' event (evid: 4792)
 *
 * Event description: a user/anonymous views a result of a consolidated invoice
 *
 * @param {chargeLocatorConsolidatedInvoiceViewParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorConsolidatedInvoiceViewParams>} LogObject<chargeLocatorConsolidatedInvoiceViewParams>
 */
export function chargeLocatorConsolidatedInvoiceView(params) {
    return { evid: 4792, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorError' event (evid: 4793)
 *
 * Event description: charge locator error toast
 *
 * @param {chargeLocatorErrorParams} params - The parameters for this event
 * @property {string} errorInfo - error message translation key
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @return {LogObject<chargeLocatorErrorParams>} LogObject<chargeLocatorErrorParams>
 */
export function chargeLocatorError(params) {
    return { evid: 4793, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorBlockPageError' event (evid: 4794)
 *
 * Event description: Charge locator block page error (when we recognized an action which is not legit)
 *
 * @param {chargeLocatorBlockPageErrorParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice number
 * @return {LogObject<chargeLocatorBlockPageErrorParams>} LogObject<chargeLocatorBlockPageErrorParams>
 */
export function chargeLocatorBlockPageError(params) {
    return { evid: 4794, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorFaqClickContactCustomerCare' event (evid: 4795)
 *
 * Event description: a user/anonymous clicks contact customer care from one of the FAQs
 *
 * @param {chargeLocatorFaqClickContactCustomerCareParams} params - The parameters for this event
 * @return {LogObject<chargeLocatorFaqClickContactCustomerCareParams>} LogObject<chargeLocatorFaqClickContactCustomerCareParams>
 */
export function chargeLocatorFaqClickContactCustomerCare(params) {
    return { evid: 4795, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorFaqCancelSubscription' event (evid: 4796)
 *
 * Event description: link to premium subscriptions page from the FAQ of the charge locator
 *
 * @param {chargeLocatorFaqCancelSubscriptionParams} params - The parameters for this event
 * @return {LogObject<chargeLocatorFaqCancelSubscriptionParams>} LogObject<chargeLocatorFaqCancelSubscriptionParams>
 */
export function chargeLocatorFaqCancelSubscription(params) {
    return { evid: 4796, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabHoverOnDownloadCsvPdf' event (evid: 4797)
 *
 * Event description: Hover on download csv/pdf
 *
 * @param {billingHistoryTabHoverOnDownloadCsvPdfParams} params - The parameters for this event
 * @property {string} externalSessionId - externalSessionId
 * @property {GUID} userGuid - user guid
 * @property {string} buttonName - export csv/download pdf
 * @property {boolean} isEnabled - is download Enabled
 * @property {number} countInvoices - count_invoices
 * @return {LogObject<billingHistoryTabHoverOnDownloadCsvPdfParams>} LogObject<billingHistoryTabHoverOnDownloadCsvPdfParams>
 */
export function billingHistoryTabHoverOnDownloadCsvPdf(params) {
    return { evid: 4797, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabDownloadPdf' event (evid: 4798)
 *
 * Event description: BillingHistoryTab > download invoices Modal view (CSV/PDF)
 *
 * @param {billingHistoryTabDownloadPdfParams} params - The parameters for this event
 * @property {string} name - domain_name_filter
 * @property {string} modalType - csv/pdf
 * @property {string} externalSessionId - externalSessionId
 * @property {string} paymentMethod - payment_method_type_filter
 * @property {number} year - year_filter
 * @property {string} freeText - free_text_filter
 * @property {string} siteName - site_name_filter
 * @property {number} daysAgo - days_ago_filter
 * @property {string} status - status_filter
 * @property {number} countInvoices - number of invoices
 * @property {string} jsonData - jsonData
 * @property {string} metaSiteId - msid_filter
 * @return {LogObject<billingHistoryTabDownloadPdfParams>} LogObject<billingHistoryTabDownloadPdfParams>
 */
export function billingHistoryTabDownloadPdf(params) {
    return { evid: 4798, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabDownloadPdfModalResult' event (evid: 4799)
 *
 * Event description: BillingHistoryTab > download CSV/PDF Modal result
 * click on send download link\ Closed window\ Cancel (2 different modals, filtered by modal type
 *
 * @param {billingHistoryTabDownloadPdfModalResultParams} params - The parameters for this event
 * @property {string} name - domain_name_filter
 * @property {string} modalType - csv/pdf
 * @property {string} externalSessionId - externalSessionId
 * @property {string} filterType - date,paid,site,no filter etc
 * @property {string} paymentMethod - payment_method_type_filter
 * @property {number} year - year_filter
 * @property {string} clickType - closed window/ cancel/ download
 * @property {string} freeText - free_text_filter
 * @property {string} siteName - site_name_filter
 * @property {number} daysAgo - days_ago_filter
 * @property {string} status - status_filter
 * @property {number} countInvoices - number of invoices
 * @property {string} jsonData - json_data
 * @property {string} metaSiteId - msid_filter
 * @return {LogObject<billingHistoryTabDownloadPdfModalResultParams>} LogObject<billingHistoryTabDownloadPdfModalResultParams>
 */
export function billingHistoryTabDownloadPdfModalResult(params) {
    return { evid: 4799, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rChangeSiteError' event (evid: 48)
 *
 * Event description: R_ChangeSiteError.
 *
 * @param {rChangeSiteErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rChangeSiteErrorParams>} LogObject<rChangeSiteErrorParams>
 */
export function rChangeSiteError(params) {
    return { evid: 48, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailUpdatePaymentMethodException' event (evid: 480)
 *
 * Event description: R_MailUpdatePaymentMethodException.
 *
 * @param {rMailUpdatePaymentMethodExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailUpdatePaymentMethodExceptionParams>} LogObject<rMailUpdatePaymentMethodExceptionParams>
 */
export function rMailUpdatePaymentMethodException(params) {
    return { evid: 480, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteStep1Continue' event (evid: 4800)
 *
 * Event description: Client
 *
 * @param {gSuiteStep1ContinueParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} fromStep - step1_qty / step2_cycle /  step3 _pay
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - quantity - selected qty
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - ‘Migration’
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - Next / skip this step / header
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} definedEmails - defined_emails - Number of defined emails
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - Seats names and source
 * @property {string} recommendedPlan - starter/standard/plus
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} siteSegment - The version of the seats selection (store or other)
 * @property {string} modalPlan - The plan which the user clicked the disclaimer
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} toStep - step1_qty / step2_cycle /  step3 _pay
 * @property {string} DeviceFlowType - device_flow_type
 * @property {string} ProductName - ProductName
 * @property {boolean} IsCartFlow - is_cart_flow
 * @property {string} SaleType - sale_type
 * @return {LogObject<gSuiteStep1ContinueParams>} LogObject<gSuiteStep1ContinueParams>
 */
export function gSuiteStep1Continue(params) {
    return { evid: 4800, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseStep2CycleLoad' event (evid: 4801)
 *
 * Event description: Client
 *
 * @param {gSuitePurchaseStep2CycleLoadParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - selected qty
 * @property {number} emailSkuId - product SKU
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} definedEmails - Number of defined emails
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} DeviceFlowType - device_flow_type
 * @property {string} SuggestedTiers - suggested_tiers - null / starter / all
 * @property {string} ProductName - ProductName
 * @property {string} ProductId - productid
 * @property {boolean} IsCartFlow - is_cart_flow
 * @property {string} SaleType - sale_type
 * @return {LogObject<gSuitePurchaseStep2CycleLoadParams>} LogObject<gSuitePurchaseStep2CycleLoadParams>
 */
export function gSuitePurchaseStep2CycleLoad(params) {
    return { evid: 4801, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseStep2CycleSelectCycle' event (evid: 4802)
 *
 * Event description: Client
 *
 * @param {gSuitePurchaseStep2CycleSelectCycleParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - quantity
 * @property {number} emailSkuId - product SKU
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} definedEmails - Number of defined emails
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - 3 or 6
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} DeviceFlowType - device_flow_type
 * @property {string} SuggestedTiers - SuggestedTiers
 * @property {string} ProductName - ProductName
 * @property {string} ProductId - productid
 * @property {boolean} IsCartFlow - is_cart_flow
 * @property {string} SaleType - sale_type
 * @return {LogObject<gSuitePurchaseStep2CycleSelectCycleParams>} LogObject<gSuitePurchaseStep2CycleSelectCycleParams>
 */
export function gSuitePurchaseStep2CycleSelectCycle(params) {
    return { evid: 4802, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseStep3PaymentLoad' event (evid: 4803)
 *
 * Event description: Client
 *
 * @param {gSuitePurchaseStep3PaymentLoadParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - quantity
 * @property {number} emailSkuId - Email_sku_id
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} definedEmails - Number of defined emails
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - 3 or 6
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} DeviceFlowType - device_flow_type
 * @return {LogObject<gSuitePurchaseStep3PaymentLoadParams>} LogObject<gSuitePurchaseStep3PaymentLoadParams>
 */
export function gSuitePurchaseStep3PaymentLoad(params) {
    return { evid: 4803, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseSuccessPageClick' event (evid: 4806)
 *
 * Event description: Client
 *
 * @param {gSuitePurchaseSuccessPageClickParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - quantity
 * @property {number} emailSkuId - Email_sku_id
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - view invoice...
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} definedEmails - Number of defined emails
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - 3 or 6
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} DeviceFlowType - device_flow_type
 * @property {boolean} IsSetup_button - is_setup_button
 * @property {string} ProductName - ProductName
 * @property {number} Product_id - Product_id
 * @return {LogObject<gSuitePurchaseSuccessPageClickParams>} LogObject<gSuitePurchaseSuccessPageClickParams>
 */
export function gSuitePurchaseSuccessPageClick(params) {
    return { evid: 4806, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteStep1ChangeQuantity' event (evid: 4807)
 *
 * Event description: Client. change from drop list - is for add qty
 *
 * @param {gSuiteStep1ChangeQuantityParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - quantity - selected qty
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - add from ticker / add from button /  reduce from ticker / change text / change from drop list
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} DeviceFlowType - If this desktop or mobile flow
 * @property {string} ProductName - ProductName
 * @property {number} PreviousQuantity - previous_quantity
 * @property {boolean} IsCartFlow - is_cart_flow
 * @property {string} SaleType - sale_type
 * @return {LogObject<gSuiteStep1ChangeQuantityParams>} LogObject<gSuiteStep1ChangeQuantityParams>
 */
export function gSuiteStep1ChangeQuantity(params) {
    return { evid: 4807, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteStep1ViewToolTip' event (evid: 4808)
 *
 * Event description: Client
 *
 * @param {gSuiteStep1ViewToolTipParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - quantity - selected qty
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuiteStep1ViewToolTipParams>} LogObject<gSuiteStep1ViewToolTipParams>
 */
export function gSuiteStep1ViewToolTip(params) {
    return { evid: 4808, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteBack' event (evid: 4809)
 *
 * Event description: Client
 *
 * @param {gSuiteBackParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} fromStep - step2_cycle /  step3 _payment
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - quantity - selected qty
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - back button / header
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} definedEmails - Number of defined emails
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} toStep - step2_cycle /  step3 _payment
 * @property {string} DeviceFlowType - device_flow_type
 * @return {LogObject<gSuiteBackParams>} LogObject<gSuiteBackParams>
 */
export function gSuiteBack(params) {
    return { evid: 4809, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailUpdateAutoRenewSuccess' event (evid: 481)
 *
 * Event description: R_MailUpdateAutoRenewSuccess.
 *
 * @param {rMailUpdateAutoRenewSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailUpdateAutoRenewSuccessParams>} LogObject<rMailUpdateAutoRenewSuccessParams>
 */
export function rMailUpdateAutoRenewSuccess(params) {
    return { evid: 481, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteViewDetails' event (evid: 4810)
 *
 * Event description: Client - view details of the charge additional seats
 *
 * @param {gSuiteViewDetailsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - quantity - selected qty
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - view/close
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuiteViewDetailsParams>} LogObject<gSuiteViewDetailsParams>
 */
export function gSuiteViewDetails(params) {
    return { evid: 4810, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteHoverOnMailboxVoucher' event (evid: 4811)
 *
 * Event description: User hovers on the present icon on mailboxes tab
 *
 * @param {gSuiteHoverOnMailboxVoucherParams} params - The parameters for this event
 * @property {number} accountTotalDomains - number of account total domains
 * @property {string} viewMode - manage_state/empty_state
 * @property {string} voucher - true
 * @property {boolean} hasLiveMailbox - true/false
 * @property {number} siteTotalDomains - number of site total domains
 * @property {boolean} inSale - [yes / no]
 * @property {number} emailProvider - number
 * @property {number} siteConnectedDomains - number of site connected domains
 * @property {string} referralAdditionalInfo - account-manager
 * @property {boolean} isAccountPremium - true/false
 * @property {boolean} isPremium - true/false
 * @property {number} accountConnectedDomains - number
 * @property {string} discount - value
 * @property {GUID} siteGuid - guid
 * @return {LogObject<gSuiteHoverOnMailboxVoucherParams>} LogObject<gSuiteHoverOnMailboxVoucherParams>
 */
export function gSuiteHoverOnMailboxVoucher(params) {
    return { evid: 4811, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteClickOnClaimVoucher' event (evid: 4812)
 *
 * Event description: User clicks on claim G-suite voucher from the pop-up
 *
 * @param {gSuiteClickOnClaimVoucherParams} params - The parameters for this event
 * @property {number} accountTotalDomains - number of account total domains
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} voucher - true/false
 * @property {boolean} hasLiveMailbox - true/false
 * @property {number} siteTotalDomains - number of site total domains
 * @property {boolean} inSale - [yes / no]
 * @property {number} emailProvider - number
 * @property {number} siteConnectedDomains - number of site connected domains
 * @property {string} referralAdditionalInfo - account-manager
 * @property {boolean} isAccountPremium - true/false
 * @property {boolean} isPremium - true/false
 * @property {number} accountConnectedDomains - number
 * @property {string} discount - value
 * @property {GUID} siteGuid - guid
 * @return {LogObject<gSuiteClickOnClaimVoucherParams>} LogObject<gSuiteClickOnClaimVoucherParams>
 */
export function gSuiteClickOnClaimVoucher(params) {
    return { evid: 4812, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'logPlansPageLoaded' event (evid: 4813)
 *
 * Event description: Client
 *
 * @param {logPlansPageLoadedParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} suggestionName - Hat type (‘recommended for you’/’most popular’)
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - selected qty
 * @property {number} emailSkuId - Product SKU (yearly is pre selected)
 * @property {string} flowType - ‘Migration’ / 'Purchase'
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} definedEmails - Number of defined emails
 * @property {string} pagename - ab_test
 * @property {number} salePercent - sale percent 10 or 50
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} recommendedPlan - The recommended plan by Google (starter/standard/plus)
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} DeviceFlowType - device_flow_type
 * @property {string} SuggestedTiers - suggested_tiers
 * @property {string} ProductName - product_name
 * @property {boolean} IsCartFlow - is_cart_flow
 * @property {string} SaleType - sale_type
 * @return {LogObject<logPlansPageLoadedParams>} LogObject<logPlansPageLoadedParams>
 */
export function logPlansPageLoaded(params) {
    return { evid: 4813, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickAssignToADifferentSitePopup' event (evid: 4815)
 *
 * Event description: Click assign/back/cancel/x/Learn more in the assign plan to a different site popup
 *
 * @param {mySubscriptionsClickAssignToADifferentSitePopupParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} clickType - assign/back/cancel/close/learnMore
 * @property {string} productTypeName - productTypeName
 * @property {GUID} fromMsid - fromMsid
 * @property {GUID} siteid - siteid
 * @property {string} productTypeId - productTypeId
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - productId
 * @property {string} subscriptionType - subscriptionType
 * @property {string} type - partners/diy
 * @property {GUID} packageId - packageId
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - msid
 * @property {number} cycleId - cycleId
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickAssignToADifferentSitePopupParams>} LogObject<mySubscriptionsClickAssignToADifferentSitePopupParams>
 */
export function mySubscriptionsClickAssignToADifferentSitePopup(params) {
    return { evid: 4815, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsAssignToAnEditorXSitePopupView' event (evid: 4816)
 *
 * Event description: Viewing the second step of the assign to a different site popup, after choosing an editor X site
 *
 * @param {mySubscriptionsAssignToAnEditorXSitePopupViewParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} productTypeName - productTypeName
 * @property {GUID} fromMsid - from msid
 * @property {GUID} siteid - siteid
 * @property {string} productTypeId - productTypeId
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - productId
 * @property {string} subscriptionType - subscriptionType
 * @property {string} type - partners/diy
 * @property {GUID} packageId - packageId
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - to msid
 * @property {number} cycleId - cycleId
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsAssignToAnEditorXSitePopupViewParams>} LogObject<mySubscriptionsAssignToAnEditorXSitePopupViewParams>
 */
export function mySubscriptionsAssignToAnEditorXSitePopupView(params) {
    return { evid: 4816, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsAssignToAnEditorXSitePopupClick' event (evid: 4817)
 *
 * Event description: Clicking any of the options in the assign to a different site popup, after choosing an editor X site
 *
 * @param {mySubscriptionsAssignToAnEditorXSitePopupClickParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} clickType - close/back/cancel/compare_plans
 * @property {string} productTypeName - productTypeName
 * @property {GUID} fromMsid - from msid
 * @property {GUID} siteid - siteid
 * @property {string} productTypeId - productTypeId
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - productId
 * @property {string} subscriptionType - subscriptionType
 * @property {string} type - partners/diy
 * @property {GUID} packageId - packageId
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - to msid
 * @property {number} cycleId - cycleId
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsAssignToAnEditorXSitePopupClickParams>} LogObject<mySubscriptionsAssignToAnEditorXSitePopupClickParams>
 */
export function mySubscriptionsAssignToAnEditorXSitePopupClick(params) {
    return { evid: 4817, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickDeactivatePlan' event (evid: 4818)
 *
 * Event description: My Subscriptions > Click on Deactivate Plan from dropdown button
 *
 * @param {mySubscriptionsClickDeactivatePlanParams} params - The parameters for this event
 * @property {string} viewMode - accountLevel, siteLevel
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} type - partners/diy
 * @property {GUID} msid - msid
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickDeactivatePlanParams>} LogObject<mySubscriptionsClickDeactivatePlanParams>
 */
export function mySubscriptionsClickDeactivatePlan(params) {
    return { evid: 4818, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsDeactivatePlanPopUpClick' event (evid: 4819)
 *
 * Event description: Click in Deactivate plan pop-up
 *
 * @param {mySubscriptionsDeactivatePlanPopUpClickParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - ‘deactivate’, ‘close’, ‘cancel’
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} type - partners/diy
 * @property {GUID} msid - msid
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsDeactivatePlanPopUpClickParams>} LogObject<mySubscriptionsDeactivatePlanPopUpClickParams>
 */
export function mySubscriptionsDeactivatePlanPopUpClick(params) {
    return { evid: 4819, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailUpdateAutoRenewError' event (evid: 482)
 *
 * Event description: R_MailUpdateAutoRenewError.
 *
 * @param {rMailUpdateAutoRenewErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailUpdateAutoRenewErrorParams>} LogObject<rMailUpdateAutoRenewErrorParams>
 */
export function rMailUpdateAutoRenewError(params) {
    return { evid: 482, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickUnassignPopup' event (evid: 4820)
 *
 * Event description: Click unassign/cancel/x/Learn more in the unassign popup
 *
 * @param {mySubscriptionsClickUnassignPopupParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} clickType - unassign/cancel/close/learnMore
 * @property {string} productTypeName - productTypeName
 * @property {GUID} fromMsid - fromMsid
 * @property {GUID} siteid - siteid
 * @property {string} productTypeId - productTypeId
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - productId
 * @property {string} subscriptionType - subscriptionType
 * @property {string} type - partners/diy
 * @property {GUID} packageId - packageId
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - msid
 * @property {number} cycleId - cycleId
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickUnassignPopupParams>} LogObject<mySubscriptionsClickUnassignPopupParams>
 */
export function mySubscriptionsClickUnassignPopup(params) {
    return { evid: 4820, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsErrorPage' event (evid: 4821)
 *
 * Event description: User got error page
 *
 * @param {mySubscriptionsErrorPageParams} params - The parameters for this event
 * @property {string} services - list of sbs
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} userSitesCount - number of sites in the account
 * @property {string} pageView - error
 * @property {string} status_text - 'UPM after pay now - success' / 'UPM after pay now - review'
 * @property {string} siteId - site_id
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsErrorPageParams>} LogObject<mySubscriptionsErrorPageParams>
 */
export function mySubscriptionsErrorPage(params) {
    return { evid: 4821, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickOnManageAtResellerCta' event (evid: 4822)
 *
 * Event description: My Subscriptions  > user clicked on "Manage At Reseller"
 *
 * @param {mySubscriptionsClickOnManageAtResellerCtaParams} params - The parameters for this event
 * @property {string} viewMode - site_level/account_level
 * @property {string} domain - domain
 * @property {string} actionName - manage at reseller
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} reseller - reseller guid if applicable
 * @property {string} type - partners/diy
 * @property {GUID} msid - msid
 * @return {LogObject<mySubscriptionsClickOnManageAtResellerCtaParams>} LogObject<mySubscriptionsClickOnManageAtResellerCtaParams>
 */
export function mySubscriptionsClickOnManageAtResellerCta(params) {
    return { evid: 4822, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsHoverOnInfoSign' event (evid: 4823)
 *
 * Event description: This event should be triggered when user hovers on info sign for 1 second or more and sees a flying box.
 *
 * @param {mySubscriptionsHoverOnInfoSignParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} text - text
 * @property {string} reseller - reseller guid if applicable
 * @property {string} type - partners/diy
 * @property {GUID} msid - msid
 * @property {string} action - view
 * @return {LogObject<mySubscriptionsHoverOnInfoSignParams>} LogObject<mySubscriptionsHoverOnInfoSignParams>
 */
export function mySubscriptionsHoverOnInfoSign(params) {
    return { evid: 4823, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsCardWidgetView' event (evid: 4824)
 *
 * Event description: The card was shown to the user
 *
 * @param {mySubscriptionsCardWidgetViewParams} params - The parameters for this event
 * @property {string} number - number shown on the card
 * @property {string} services - list of sbs
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} pageView - no_subscriptions /unable_to_retrieve/active_subscriptions
 * @property {string} cardName - upcoming_renewals/unassigned_subscriptions/payment_problems
 * @property {GUID} msid - site_id
 * @property {boolean} failedToLoad - true if a card failed to load
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsCardWidgetViewParams>} LogObject<mySubscriptionsCardWidgetViewParams>
 */
export function mySubscriptionsCardWidgetView(params) {
    return { evid: 4824, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsCardWidgetClick' event (evid: 4825)
 *
 * Event description: User clicked inside a card
 *
 * @param {mySubscriptionsCardWidgetClickParams} params - The parameters for this event
 * @property {string} number - number shown on the card
 * @property {string} services - list of sbs
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} clickName - filter/clear/refresh/current_month/next_week/next_30_days/next_90_days
 * @property {string} pageView - no_subscriptions /unable_to_retrieve/active_subscriptions
 * @property {string} cardName - upcoming_renewals/unassigned_subscriptions/payment_problems
 * @property {GUID} msid - site_id
 * @property {boolean} failedToLoad - true if a card failed to load
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsCardWidgetClickParams>} LogObject<mySubscriptionsCardWidgetClickParams>
 */
export function mySubscriptionsCardWidgetClick(params) {
    return { evid: 4825, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsUseSearchBar' event (evid: 4827)
 *
 * Event description: user filters the page using search bar
 *
 * @param {mySubscriptionsUseSearchBarParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} filter - json filter name: filter value
 * @property {boolean} hasResult - 0/1 TRUE/FALSE
 * @property {string} type - partners/diy
 * @return {LogObject<mySubscriptionsUseSearchBarParams>} LogObject<mySubscriptionsUseSearchBarParams>
 */
export function mySubscriptionsUseSearchBar(params) {
    return { evid: 4827, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailUpdateAutoRenewException' event (evid: 483)
 *
 * Event description: R_MailUpdateAutoRenewException.
 *
 * @param {rMailUpdateAutoRenewExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailUpdateAutoRenewExceptionParams>} LogObject<rMailUpdateAutoRenewExceptionParams>
 */
export function rMailUpdateAutoRenewException(params) {
    return { evid: 483, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumPackageUpdateAutoRenewSuccess' event (evid: 484)
 *
 * Event description: changing to auto-renew-on
 *
 * @param {rPremiumPackageUpdateAutoRenewSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} paymentCycle - cycle_id
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPremiumPackageUpdateAutoRenewSuccessParams>} LogObject<rPremiumPackageUpdateAutoRenewSuccessParams>
 */
export function rPremiumPackageUpdateAutoRenewSuccess(params) {
    return { evid: 484, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumPackageUpdateAutoRenewError' event (evid: 485)
 *
 * Event description: R_PremiumPackageUpdateAutoRenewError.
 *
 * @param {rPremiumPackageUpdateAutoRenewErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPremiumPackageUpdateAutoRenewErrorParams>} LogObject<rPremiumPackageUpdateAutoRenewErrorParams>
 */
export function rPremiumPackageUpdateAutoRenewError(params) {
    return { evid: 485, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rPremiumPackageUpdateAutoRenewException' event (evid: 486)
 *
 * Event description: R_PremiumPackageUpdateAutoRenewException.
 *
 * @param {rPremiumPackageUpdateAutoRenewExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rPremiumPackageUpdateAutoRenewExceptionParams>} LogObject<rPremiumPackageUpdateAutoRenewExceptionParams>
 */
export function rPremiumPackageUpdateAutoRenewException(params) {
    return { evid: 486, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsViewMySubscriptionsTab' event (evid: 4870)
 *
 * Event description: The user view My Subscriptions tab
 *
 * @param {mySubscriptionsViewMySubscriptionsTabParams} params - The parameters for this event
 * @property {string} services - list of sbs
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} userSitesCount - number of sites in the account
 * @property {string} pageView - no_subscriptions /unable_to_retrieve/active_subscriptions
 * @property {string} status_text - 'UPM after pay now - success' / 'UPM after pay now - review'
 * @property {string} siteId - site_id
 * @property {string} type - partners/diy
 * @property {string} assetVersion - Indication- Cairo or old
 * @return {LogObject<mySubscriptionsViewMySubscriptionsTabParams>} LogObject<mySubscriptionsViewMySubscriptionsTabParams>
 */
export function mySubscriptionsViewMySubscriptionsTab(params) {
    return { evid: 4870, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsReclaimDomainClickContactSupport' event (evid: 4871)
 *
 * Event description: My Subscriptions  >  reclaim domain - click "Contact Support"
 *
 * @param {mySubscriptionsReclaimDomainClickContactSupportParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} domain - domain
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsReclaimDomainClickContactSupportParams>} LogObject<mySubscriptionsReclaimDomainClickContactSupportParams>
 */
export function mySubscriptionsReclaimDomainClickContactSupport(params) {
    return { evid: 4871, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickGoToSiteDashboard' event (evid: 4872)
 *
 * Event description: My Subscriptions  >  click "go to site dashboard"
 *
 * @param {mySubscriptionsClickGoToSiteDashboardParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickGoToSiteDashboardParams>} LogObject<mySubscriptionsClickGoToSiteDashboardParams>
 */
export function mySubscriptionsClickGoToSiteDashboard(params) {
    return { evid: 4872, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickAppSetting' event (evid: 4873)
 *
 * Event description: My Subscriptions  >  click "App Setting"
 *
 * @param {mySubscriptionsClickAppSettingParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickAppSettingParams>} LogObject<mySubscriptionsClickAppSettingParams>
 */
export function mySubscriptionsClickAppSetting(params) {
    return { evid: 4873, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsUseFilter' event (evid: 4874)
 *
 * Event description: My Subscriptions  >  use filter
 *
 * @param {mySubscriptionsUseFilterParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} preDefinedFilters - list of all pre-defined filters applied
 * @property {string} filter - json filter name: filter value
 * @property {string} search_term - searched term by the user
 * @property {boolean} hasResult - 0/1 TRUE/FALSE
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsUseFilterParams>} LogObject<mySubscriptionsUseFilterParams>
 */
export function mySubscriptionsUseFilter(params) {
    return { evid: 4874, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsDownloadCsv' event (evid: 4875)
 *
 * Event description: Download CSV
 *
 * @param {mySubscriptionsDownloadCsvParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsDownloadCsvParams>} LogObject<mySubscriptionsDownloadCsvParams>
 */
export function mySubscriptionsDownloadCsv(params) {
    return { evid: 4875, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickViewPlanFeatures' event (evid: 4876)
 *
 * Event description: My Subscriptions  > ”View_plan_features”
 *
 * @param {mySubscriptionsClickViewPlanFeaturesParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} assetVersion - indication - Cairo or old
 * @property {string} type - type
 * @return {LogObject<mySubscriptionsClickViewPlanFeaturesParams>} LogObject<mySubscriptionsClickViewPlanFeaturesParams>
 */
export function mySubscriptionsClickViewPlanFeatures(params) {
    return { evid: 4876, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickBanner' event (evid: 4878)
 *
 * Event description: My Subscriptions  > Click fall-back banner in case the dealer banner doesn't load (what's next banner)
 *
 * @param {mySubscriptionsClickBannerParams} params - The parameters for this event
 * @property {string} bannerName - banner name
 * @property {GUID} msid - msid
 * @return {LogObject<mySubscriptionsClickBannerParams>} LogObject<mySubscriptionsClickBannerParams>
 */
export function mySubscriptionsClickBanner(params) {
    return { evid: 4878, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickViewPaymentDetails' event (evid: 4879)
 *
 * Event description: My Subscriptions  > ”View_payment_details”
 *
 * @param {mySubscriptionsClickViewPaymentDetailsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} subscriptionType - Plan/Domain/Mailbox
 * @property {string} type - partners/diy
 * @property {GUID} msid - number
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickViewPaymentDetailsParams>} LogObject<mySubscriptionsClickViewPaymentDetailsParams>
 */
export function mySubscriptionsClickViewPaymentDetails(params) {
    return { evid: 4879, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickDropdown' event (evid: 4880)
 *
 * Event description: My Subscriptions  >  Click Dropdown
 *
 * @param {mySubscriptionsClickDropdownParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {boolean} canUpgrade - If the current mailbox package is eligible for upgrade
 * @property {string} domain - domain
 * @property {GUID} subscriptionId - Premium_guid
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} availableValue - availableValue
 * @property {boolean} isDeclinedCharge - true/false
 * @property {string} subscriptionType - Plan/Domain/Mailbox
 * @property {string} type - partners/diy
 * @property {GUID} packageId - Premium_guid
 * @property {GUID} msid - number
 * @property {string} renewalStatus - renewal_status
 * @property {boolean} canReduce - If the current mailbox package is eligible for reduce seats
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickDropdownParams>} LogObject<mySubscriptionsClickDropdownParams>
 */
export function mySubscriptionsClickDropdown(params) {
    return { evid: 4880, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickChangeBillingCycle' event (evid: 4881)
 *
 * Event description: Click on "change billing cycle" from my subscriptions page (dropdown)
 *
 * @param {mySubscriptionsClickChangeBillingCycleParams} params - The parameters for this event
 * @property {string} viewMode - site_level/account_level
 * @property {number} pendingBillingCycle - numeric/null
 * @property {GUID} subscriptionId - premium package id
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} subscriptionType - subscription type
 * @property {string} type - partners/diy
 * @property {GUID} packageId - Premium package Id
 * @property {GUID} msid - msid
 * @property {string} renewalStatus - on / off
 * @property {number} cycleId - cycle id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickChangeBillingCycleParams>} LogObject<mySubscriptionsClickChangeBillingCycleParams>
 */
export function mySubscriptionsClickChangeBillingCycle(params) {
    return { evid: 4881, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsChangeBillingCycleView' event (evid: 4882)
 *
 * Event description: Change Billing cycle Modal loads
 *
 * @param {mySubscriptionsChangeBillingCycleViewParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - premium package id
 * @property {string} productTypeName - hard coded 'Premium Plan'
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} type - partners/diy
 * @property {string} offeringType - Personal / Default / Seasonal
 * @property {GUID} packageId - package_id
 * @property {string} productGuid - product guid
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - current cycle id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsChangeBillingCycleViewParams>} LogObject<mySubscriptionsChangeBillingCycleViewParams>
 */
export function mySubscriptionsChangeBillingCycleView(params) {
    return { evid: 4882, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsChangeBillingCycleModalSelectCycle' event (evid: 4883)
 *
 * Event description: Select a new billing cycle in the change billing cycle modal
 *
 * @param {mySubscriptionsChangeBillingCycleModalSelectCycleParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - premium package id
 * @property {string} productTypeName - hard coded 'Premium Plan'
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} selectedCycle - the new cycle that was chosenull
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} warningMessages - price only / lost features / null
 * @property {Url} referer - referral
 * @property {string} type - partners/diy
 * @property {string} offeringType - Personal / Seasonal / Default
 * @property {GUID} packageId - package_id
 * @property {string} productGuid - product guid
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - current cycle id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsChangeBillingCycleModalSelectCycleParams>} LogObject<mySubscriptionsChangeBillingCycleModalSelectCycleParams>
 */
export function mySubscriptionsChangeBillingCycleModalSelectCycle(params) {
    return { evid: 4883, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsChangeBillingCycleModalClick' event (evid: 4884)
 *
 * Event description: Click 'close' / 'keep my current cycle'/'continue'
 *
 * @param {mySubscriptionsChangeBillingCycleModalClickParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - click_type
 * @property {string} productTypeName - hard coded 'Premium Plan'
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} selectedCycle - the new cycle that was chosenull
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} type - partners/diy
 * @property {string} offeringType - offering_type
 * @property {GUID} packageId - package_id
 * @property {string} productGuid - product guid
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - current cycle id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsChangeBillingCycleModalClickParams>} LogObject<mySubscriptionsChangeBillingCycleModalClickParams>
 */
export function mySubscriptionsChangeBillingCycleModalClick(params) {
    return { evid: 4884, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsChangeBillingCycleSummaryView' event (evid: 4885)
 *
 * Event description: Change billing cycle summary loads (only when downgrading)
 *
 * @param {mySubscriptionsChangeBillingCycleSummaryViewParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - premium package id
 * @property {string} productTypeName - hard coded 'Premium Plan'
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} selectedCycle - The new cycle that was selected
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} type - partners/diy
 * @property {string} offeringType - Personal / Default / Seasonal
 * @property {GUID} packageId - package_id
 * @property {string} productGuid - product id
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - current cycle id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsChangeBillingCycleSummaryViewParams>} LogObject<mySubscriptionsChangeBillingCycleSummaryViewParams>
 */
export function mySubscriptionsChangeBillingCycleSummaryView(params) {
    return { evid: 4885, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsChangeBillingCycleSummaryClick' event (evid: 4886)
 *
 * Event description: Click  'close' /back'/ 'Keep my current cycle' / 'confirm'
 *
 * @param {mySubscriptionsChangeBillingCycleSummaryClickParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - premium package id
 * @property {string} clickType - close / back / Keep my current cycle / confirm
 * @property {string} productTypeName - hard coded 'Premium Plan'
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} selectedCycle - the new cycle that was chosen or null
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} type - partners/diy
 * @property {string} offeringType - Personal / Seasonal / Default
 * @property {GUID} packageId - package_id
 * @property {string} productGuid - product guid
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - current cycle id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsChangeBillingCycleSummaryClickParams>} LogObject<mySubscriptionsChangeBillingCycleSummaryClickParams>
 */
export function mySubscriptionsChangeBillingCycleSummaryClick(params) {
    return { evid: 4886, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickChangeBackToCurrentCycle' event (evid: 4887)
 *
 * Event description: Click 'Change back to current cycle' from the subscriptions page
 *
 * @param {mySubscriptionsClickChangeBackToCurrentCycleParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} viewMode - site_level / account_level
 * @property {string} packagePickerType - package_picker_type
 * @property {number} pendingBillingCycle - pending billing cycle
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - premium package id
 * @property {string} productTypeName - hard coded 'Premium Plan'
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - premium package id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {Url} referer - referral
 * @property {string} subscriptionType - subscription type
 * @property {string} type - partners/diy
 * @property {GUID} packageId - premium package id
 * @property {string} productGuid - product id
 * @property {GUID} msid - msid
 * @property {string} renewalStatus - renewal status
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - current cycle id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickChangeBackToCurrentCycleParams>} LogObject<mySubscriptionsClickChangeBackToCurrentCycleParams>
 */
export function mySubscriptionsClickChangeBackToCurrentCycle(params) {
    return { evid: 4887, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsChangeBillingCycleViewCreatePendingBillingCycleToast' event (evid: 4888)
 *
 * Event description: Toast indicating that a pending billing cycle was created successfully. (The change will take place at the end of period)
 *
 * @param {mySubscriptionsChangeBillingCycleViewCreatePendingBillingCycleToastParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} pendingBillingCycle - pending cycle id
 * @property {GUID} subscriptionId - premium package id
 * @property {string} productTypeName - hard coded 'Premium Plan')
 * @property {string} referralAdditionalInfo - Referral Additional Info
 * @property {string} subscriptionType - subscription type
 * @property {string} type - partners/diy
 * @property {GUID} packageId - premium package id
 * @property {GUID} msid - msid
 * @property {string} renewalStatus - renewal status
 * @property {number} cycleId - current cycle id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsChangeBillingCycleViewCreatePendingBillingCycleToastParams>} LogObject<mySubscriptionsChangeBillingCycleViewCreatePendingBillingCycleToastParams>
 */
export function mySubscriptionsChangeBillingCycleViewCreatePendingBillingCycleToast(params) {
    return { evid: 4888, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsChangeBillingCycleViewCancelPendingBillingCycleToast' event (evid: 4889)
 *
 * Event description: Cancel pending billing cycle success. Changed back to original cycle
 *
 * @param {mySubscriptionsChangeBillingCycleViewCancelPendingBillingCycleToastParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} pendingBillingCycle - pending cycle id
 * @property {GUID} subscriptionId - premium package id
 * @property {string} productTypeName - hard coded 'Premium Plan'
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} subscriptionType - subscription_type
 * @property {string} type - partners/diy
 * @property {GUID} packageId - premium package id
 * @property {string} productGuid - product guid
 * @property {GUID} msid - msid
 * @property {string} renewalStatus - renewal_status
 * @property {number} cycleId - current cycle Id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsChangeBillingCycleViewCancelPendingBillingCycleToastParams>} LogObject<mySubscriptionsChangeBillingCycleViewCancelPendingBillingCycleToastParams>
 */
export function mySubscriptionsChangeBillingCycleViewCancelPendingBillingCycleToast(params) {
    return { evid: 4889, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsChangeBillingCycleLoadError' event (evid: 4890)
 *
 * Event description: Change billing cycle modal load error
 *
 * @param {mySubscriptionsChangeBillingCycleLoadErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} errorInfo - network error / permission error / other
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - premium package id
 * @property {string} productTypeName - hard coded 'Premium Plan'
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} selectedCycle - the new cycle that was chosen/null
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} errorLocation - according to the location of the error
 * @property {Url} referer - referral
 * @property {string} type - partners/diy
 * @property {string} offeringType - offering type
 * @property {GUID} packageId - package_id
 * @property {string} productGuid - product Guid
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - current cycle id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsChangeBillingCycleLoadErrorParams>} LogObject<mySubscriptionsChangeBillingCycleLoadErrorParams>
 */
export function mySubscriptionsChangeBillingCycleLoadError(params) {
    return { evid: 4890, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsChangeBackToCurrentCycleActions' event (evid: 4891)
 *
 * Event description: Click 'back/cancel/confirm/close' in the Cancel pending changes flow
 *
 * @param {mySubscriptionsChangeBackToCurrentCycleActionsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} viewMode - site_level / account_level
 * @property {string} packagePickerType - package_picker_type
 * @property {number} pendingBillingCycle - pending billing cycle
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - premium package id
 * @property {string} clickType - back/cancel/confirm/close
 * @property {string} productTypeName - hard coded 'Premium Plan'
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} selectedCycle - selected cycle
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} type - partners/diy
 * @property {string} offeringType - offering type
 * @property {GUID} packageId - package_id
 * @property {string} productGuid - product id
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - current cycle id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsChangeBackToCurrentCycleActionsParams>} LogObject<mySubscriptionsChangeBackToCurrentCycleActionsParams>
 */
export function mySubscriptionsChangeBackToCurrentCycleActions(params) {
    return { evid: 4891, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickOnManageSpendingLimit' event (evid: 4892)
 *
 * Event description: My Subscriptions > Click  on Manage Spending Limit
 *
 * @param {mySubscriptionsClickOnManageSpendingLimitParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} app_def_id - app_def_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isDeclinedCharge - true/false
 * @property {string} subscriptionType - Plan/Domain/Mailbox
 * @property {string} type - partners/diy
 * @property {GUID} packageId - Premium_guid
 * @property {GUID} msid - number
 * @property {string} renewalStatus - renewal_status
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickOnManageSpendingLimitParams>} LogObject<mySubscriptionsClickOnManageSpendingLimitParams>
 */
export function mySubscriptionsClickOnManageSpendingLimit(params) {
    return { evid: 4892, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsSpendingLimitChangeSaved' event (evid: 4893)
 *
 * Event description: My Subscriptions > Spending Limit change Saved for custom charge subscriptions
 *
 * @param {mySubscriptionsSpendingLimitChangeSavedParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} chargeLimit - new charge limit
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} app_def_id - app_def_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isDeclinedCharge - true/false
 * @property {string} subscriptionType - Plan/Domain/Mailbox
 * @property {string} oldChargeLimit - old_charge_limit
 * @property {string} type - partners/diy
 * @property {GUID} packageId - Premium_guid
 * @property {GUID} msid - number
 * @property {string} renewalStatus - renewal_status
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsSpendingLimitChangeSavedParams>} LogObject<mySubscriptionsSpendingLimitChangeSavedParams>
 */
export function mySubscriptionsSpendingLimitChangeSaved(params) {
    return { evid: 4893, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickCanSitePopup' event (evid: 49)
 *
 * Event description: A_ClickCanSitePopup.
 *
 * @param {aClickCanSitePopupParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickCanSitePopupParams>} LogObject<aClickCanSitePopupParams>
 */
export function aClickCanSitePopup(params) {
    return { evid: 49, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailBoxChangePasswordSuccess' event (evid: 490)
 *
 * Event description: R_MailBox_ChangePasswordSuccess.
 *
 * @param {rMailBoxChangePasswordSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailBoxChangePasswordSuccessParams>} LogObject<rMailBoxChangePasswordSuccessParams>
 */
export function rMailBoxChangePasswordSuccess(params) {
    return { evid: 490, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'alertSent' event (evid: 4900)
 *
 * Event description: alert sent
 *
 * @param {alertSentParams} params - The parameters for this event
 * @property {GUID} serviceGuid - sbs
 * @property {string} assetType - subscriptionType
 * @property {GUID} uuid - uuid
 * @property {GUID} userGuid - uuid
 * @property {number} invoiceId - invoiceId
 * @property {string} user_agent - user_agent
 * @property {string} alertType - DECLINE_CHARGES
 * @property {GUID} siteId - msid
 * @return {LogObject<alertSentParams>} LogObject<alertSentParams>
 */
export function alertSent(params) {
    return { evid: 4900, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'alertResolved' event (evid: 4901)
 *
 * Event description: alert resolved
 *
 * @param {alertResolvedParams} params - The parameters for this event
 * @property {GUID} serviceGuid - sbs
 * @property {GUID} uuid - uuid
 * @property {GUID} userGuid - uuid
 * @property {number} reasonid - CREATE(0),
 *     RECURRING_SUCCESS(1),
 *     STATUS_CHANGE(2),
 *     SWITCH_CONTRACT(3),
 *     CHARGE_FAILURE(4),
 *     CC_EXPIRED(5),
 *     OFFLINE_PAYMENT(6),
 *     CHARGE_BACK(7),
 *     SERVICE_NEAR_RENEWAL(8),
 *     SERIVCE_AUTO_RENEW_CHANGE(9),
 *     SERVICE_QUANTITY_CHANGE(10),
 *     NO_ACTIVE_BILLING_ACCOUNT(11),
 *     MANUAL_RECURRING_REMINDER(12),
 *     AFTER_SWITCH_CONTRACT(13),
 *     TRANSFER_SERVICE(14),
 *     SERVICE_BILLING_ACCOUNT_CHANGE(15),
 *     END_OF_PERIOD_CHANGE(16),
 *     NEXT_RENEWAL_DATE_CHANGE(17),
 *     INVOICE_UPDATE(18),
 *     SERVICE_PENDING_CHANGE(19);
 * @property {number} invoiceId - invoiceId
 * @property {string} user_agent - user_agent
 * @property {string} alertType - DECLINE_CHARGES
 * @return {LogObject<alertResolvedParams>} LogObject<alertResolvedParams>
 */
export function alertResolved(params) {
    return { evid: 4901, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailBoxChangePasswordFailure' event (evid: 491)
 *
 * Event description: R_MailBox_ChangePasswordFailure.
 *
 * @param {rMailBoxChangePasswordFailureParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailBoxChangePasswordFailureParams>} LogObject<rMailBoxChangePasswordFailureParams>
 */
export function rMailBoxChangePasswordFailure(params) {
    return { evid: 491, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailBoxChangePasswordException' event (evid: 492)
 *
 * Event description: R_MailBox_ChangePasswordException.
 *
 * @param {rMailBoxChangePasswordExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailBoxChangePasswordExceptionParams>} LogObject<rMailBoxChangePasswordExceptionParams>
 */
export function rMailBoxChangePasswordException(params) {
    return { evid: 492, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailBoxDeleteSuccess' event (evid: 493)
 *
 * Event description: R_MailBox_DeleteSuccess.
 *
 * @param {rMailBoxDeleteSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailBoxDeleteSuccessParams>} LogObject<rMailBoxDeleteSuccessParams>
 */
export function rMailBoxDeleteSuccess(params) {
    return { evid: 493, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailBoxDeleteFailure' event (evid: 494)
 *
 * Event description: R_MailBox_DeleteFailure.
 *
 * @param {rMailBoxDeleteFailureParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailBoxDeleteFailureParams>} LogObject<rMailBoxDeleteFailureParams>
 */
export function rMailBoxDeleteFailure(params) {
    return { evid: 494, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMailBoxDeleteException' event (evid: 495)
 *
 * Event description: R_MailBox_DeleteException.
 *
 * @param {rMailBoxDeleteExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMailBoxDeleteExceptionParams>} LogObject<rMailBoxDeleteExceptionParams>
 */
export function rMailBoxDeleteException(params) {
    return { evid: 495, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsOrderPageEmailPurchaseBusinessError' event (evid: 496)
 *
 * Event description: G-suite purchase > order page > business error.
 *
 * @param {rSbsOrderPageEmailPurchaseBusinessErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {number} quantity - quantity
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {number} definedEmails - defined_emails
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsOrderPageEmailPurchaseBusinessErrorParams>} LogObject<rSbsOrderPageEmailPurchaseBusinessErrorParams>
 */
export function rSbsOrderPageEmailPurchaseBusinessError(params) {
    return { evid: 496, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsOrderPageEmailPurchaseFatalError' event (evid: 497)
 *
 * Event description: G-suite purchase > order page > fatal error.
 *
 * @param {rSbsOrderPageEmailPurchaseFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - voucher
 * @property {number} quantity - quantity
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow_type
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {number} definedEmails - defined_emails
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsOrderPageEmailPurchaseFatalErrorParams>} LogObject<rSbsOrderPageEmailPurchaseFatalErrorParams>
 */
export function rSbsOrderPageEmailPurchaseFatalError(params) {
    return { evid: 497, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsViewPaymentMethodsTab' event (evid: 4970)
 *
 * Event description: The user view Payment Methods tab
 *
 * @param {paymentMethodsViewPaymentMethodsTabParams} params - The parameters for this event
 * @property {string} viewMode - i.e. team/contributors
 * @property {GUID} billingAccountGuid - list of billing account guids
 * @property {string} pageView - no_payment_methods /active_payment_methods
 * @property {string} allBillingAccountGuids - list of billing account guids
 * @return {LogObject<paymentMethodsViewPaymentMethodsTabParams>} LogObject<paymentMethodsViewPaymentMethodsTabParams>
 */
export function paymentMethodsViewPaymentMethodsTab(params) {
    return { evid: 4970, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodView' event (evid: 4971)
 *
 * Event description: The user clicked on add payment method, and a pop-up was opened. For team page - second step after viewing the teammates with billing permissions
 *
 * @param {paymentMethodsAddPaymentMethodViewParams} params - The parameters for this event
 * @property {string} viewMode - team/regular
 * @return {LogObject<paymentMethodsAddPaymentMethodViewParams>} LogObject<paymentMethodsAddPaymentMethodViewParams>
 */
export function paymentMethodsAddPaymentMethodView(params) {
    return { evid: 4971, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewInvoiceFromActiveSubscriptions' event (evid: 4972)
 *
 * Event description: The user clicked save in the add payment method pop-up
 *
 * @param {viewInvoiceFromActiveSubscriptionsParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {number} invoiceId - Invoice Id
 * @property {string} origin - active_subscriptions/update_payment_method
 * @return {LogObject<viewInvoiceFromActiveSubscriptionsParams>} LogObject<viewInvoiceFromActiveSubscriptionsParams>
 */
export function viewInvoiceFromActiveSubscriptions(params) {
    return { evid: 4972, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodCancel' event (evid: 4973)
 *
 * Event description: The user closed the add payment method pop-up
 *
 * @param {paymentMethodsAddPaymentMethodCancelParams} params - The parameters for this event
 * @property {string} clickType - cancel/close
 * @return {LogObject<paymentMethodsAddPaymentMethodCancelParams>} LogObject<paymentMethodsAddPaymentMethodCancelParams>
 */
export function paymentMethodsAddPaymentMethodCancel(params) {
    return { evid: 4973, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodSuccess' event (evid: 4974)
 *
 * Event description: Add payment method success
 *
 * @param {paymentMethodsAddPaymentMethodSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsAddPaymentMethodSuccessParams>} LogObject<paymentMethodsAddPaymentMethodSuccessParams>
 */
export function paymentMethodsAddPaymentMethodSuccess(params) {
    return { evid: 4974, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsRemovePaymentMethodView' event (evid: 4975)
 *
 * Event description: The user clicked on delete payment method and viewed the pop-up
 *
 * @param {paymentMethodsRemovePaymentMethodViewParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsRemovePaymentMethodViewParams>} LogObject<paymentMethodsRemovePaymentMethodViewParams>
 */
export function paymentMethodsRemovePaymentMethodView(params) {
    return { evid: 4975, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsClickOnActions' event (evid: 4976)
 *
 * Event description: The user clicked on "actions" button from one of the payment methods
 *
 * @param {paymentMethodsClickOnActionsParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} availableValue - e.g update payment method/remove payment method
 * @return {LogObject<paymentMethodsClickOnActionsParams>} LogObject<paymentMethodsClickOnActionsParams>
 */
export function paymentMethodsClickOnActions(params) {
    return { evid: 4976, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsRemovePaymentMethodCancel' event (evid: 4977)
 *
 * Event description: The user clicked cancel in the remove payment method pop-up
 *
 * @param {paymentMethodsRemovePaymentMethodCancelParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} clickType - cancel/close
 * @return {LogObject<paymentMethodsRemovePaymentMethodCancelParams>} LogObject<paymentMethodsRemovePaymentMethodCancelParams>
 */
export function paymentMethodsRemovePaymentMethodCancel(params) {
    return { evid: 4977, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsRemovePaymentMethodSuccess' event (evid: 4978)
 *
 * Event description: Remove payment method success
 *
 * @param {paymentMethodsRemovePaymentMethodSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsRemovePaymentMethodSuccessParams>} LogObject<paymentMethodsRemovePaymentMethodSuccessParams>
 */
export function paymentMethodsRemovePaymentMethodSuccess(params) {
    return { evid: 4978, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsViewActiveSubscriptions' event (evid: 4979)
 *
 * Event description: View the active subscriptions that are attached to the payment method (after clicking "x active subscriptions" button)
 *
 * @param {paymentMethodsViewActiveSubscriptionsParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsViewActiveSubscriptionsParams>} LogObject<paymentMethodsViewActiveSubscriptionsParams>
 */
export function paymentMethodsViewActiveSubscriptions(params) {
    return { evid: 4979, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteEditUserFailure' event (evid: 498)
 *
 * Event description: G-suite edit user failed
 *
 * @param {gSuiteEditUserFailureParams} params - The parameters for this event
 * @property {string} errorInfo - error_info
 * @property {string} domain - domain name
 * @property {GUID} userGuid - uuid
 * @return {LogObject<gSuiteEditUserFailureParams>} LogObject<gSuiteEditUserFailureParams>
 */
export function gSuiteEditUserFailure(params) {
    return { evid: 498, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsClickManageSubscriptions' event (evid: 4980)
 *
 * Event description: Click Manage Subscriptions > Move from the payment method tab to the account level subscriptions tab
 *
 * @param {paymentMethodsClickManageSubscriptionsParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsClickManageSubscriptionsParams>} LogObject<paymentMethodsClickManageSubscriptionsParams>
 */
export function paymentMethodsClickManageSubscriptions(params) {
    return { evid: 4980, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsUpdatePaymentMethodView' event (evid: 4981)
 *
 * Event description: The user clicked on update payment method and view the update payment method pop-up
 *
 * @param {paymentMethodsUpdatePaymentMethodViewParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} services - List of eligible services to update which are under the same payment method
 * @return {LogObject<paymentMethodsUpdatePaymentMethodViewParams>} LogObject<paymentMethodsUpdatePaymentMethodViewParams>
 */
export function paymentMethodsUpdatePaymentMethodView(params) {
    return { evid: 4981, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsUpdatePaymentMethodNext' event (evid: 4982)
 *
 * Event description: The user clicked next in the update payment method pop-up
 *
 * @param {paymentMethodsUpdatePaymentMethodNextParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsUpdatePaymentMethodNextParams>} LogObject<paymentMethodsUpdatePaymentMethodNextParams>
 */
export function paymentMethodsUpdatePaymentMethodNext(params) {
    return { evid: 4982, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsUpdatePaymentMethodCancel' event (evid: 4984)
 *
 * Event description: The user clicked on cancel in the update payment method pop-up
 *
 * @param {paymentMethodsUpdatePaymentMethodCancelParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} clickType - cancel/close
 * @return {LogObject<paymentMethodsUpdatePaymentMethodCancelParams>} LogObject<paymentMethodsUpdatePaymentMethodCancelParams>
 */
export function paymentMethodsUpdatePaymentMethodCancel(params) {
    return { evid: 4984, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsUpdatePaymentMethodSuccess' event (evid: 4985)
 *
 * Event description: Update payment method success
 *
 * @param {paymentMethodsUpdatePaymentMethodSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsUpdatePaymentMethodSuccessParams>} LogObject<paymentMethodsUpdatePaymentMethodSuccessParams>
 */
export function paymentMethodsUpdatePaymentMethodSuccess(params) {
    return { evid: 4985, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsViewPaymentMethodsError' event (evid: 4986)
 *
 * Event description: Payment Methods tab did not load successfully
 *
 * @param {paymentMethodsViewPaymentMethodsErrorParams} params - The parameters for this event
 * @property {string} errorInfo - The error info
 * @return {LogObject<paymentMethodsViewPaymentMethodsErrorParams>} LogObject<paymentMethodsViewPaymentMethodsErrorParams>
 */
export function paymentMethodsViewPaymentMethodsError(params) {
    return { evid: 4986, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodsError' event (evid: 4987)
 *
 * Event description: Update payment method failed
 *
 * @param {paymentMethodsAddPaymentMethodsErrorParams} params - The parameters for this event
 * @return {LogObject<paymentMethodsAddPaymentMethodsErrorParams>} LogObject<paymentMethodsAddPaymentMethodsErrorParams>
 */
export function paymentMethodsAddPaymentMethodsError(params) {
    return { evid: 4987, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsRemovePaymentMethodError' event (evid: 4988)
 *
 * Event description: Remove payment method failed
 *
 * @param {paymentMethodsRemovePaymentMethodErrorParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsRemovePaymentMethodErrorParams>} LogObject<paymentMethodsRemovePaymentMethodErrorParams>
 */
export function paymentMethodsRemovePaymentMethodError(params) {
    return { evid: 4988, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsUpdatePaymentMethodError' event (evid: 4989)
 *
 * Event description: Update payment method failed
 *
 * @param {paymentMethodsUpdatePaymentMethodErrorParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsUpdatePaymentMethodErrorParams>} LogObject<paymentMethodsUpdatePaymentMethodErrorParams>
 */
export function paymentMethodsUpdatePaymentMethodError(params) {
    return { evid: 4989, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteAddSeats' event (evid: 499)
 *
 * Event description: G-suite > add seats
 *
 * @param {gSuiteAddSeatsParams} params - The parameters for this event
 * @property {number} numSetUpSeats - num_setup_seats
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {number} totalSeats - total_seats
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {GUID} product_type_id - product_type_id
 * @property {GUID} productId - 	product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteAddSeatsParams>} LogObject<gSuiteAddSeatsParams>
 */
export function gSuiteAddSeats(params) {
    return { evid: 499, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsViewTeammatesWithBillingPermissions' event (evid: 4990)
 *
 * Event description: The user clicked on 'teammates with billing permissions' add the modal opened.
 *
 * @param {paymentMethodsViewTeammatesWithBillingPermissionsParams} params - The parameters for this event
 * @property {string} pageView - no_payment_methods /active_payment_methods
 * @return {LogObject<paymentMethodsViewTeammatesWithBillingPermissionsParams>} LogObject<paymentMethodsViewTeammatesWithBillingPermissionsParams>
 */
export function paymentMethodsViewTeammatesWithBillingPermissions(params) {
    return { evid: 4990, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodViewTeammates' event (evid: 4991)
 *
 * Event description: The account owner clicked on add payment method and the list of teammates with billing permissions is shown
 *
 * @param {paymentMethodsAddPaymentMethodViewTeammatesParams} params - The parameters for this event
 * @property {string} pageView - no_payment_methods /active_payment_methods
 * @return {LogObject<paymentMethodsAddPaymentMethodViewTeammatesParams>} LogObject<paymentMethodsAddPaymentMethodViewTeammatesParams>
 */
export function paymentMethodsAddPaymentMethodViewTeammates(params) {
    return { evid: 4991, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodConfirmAuthorization' event (evid: 4992)
 *
 * Event description: The account owner checked the box of giving other team members permission to use the payment method
 *
 * @param {paymentMethodsAddPaymentMethodConfirmAuthorizationParams} params - The parameters for this event
 * @property {string} pageView - no_payment_methods /active_payment_methods
 * @return {LogObject<paymentMethodsAddPaymentMethodConfirmAuthorizationParams>} LogObject<paymentMethodsAddPaymentMethodConfirmAuthorizationParams>
 */
export function paymentMethodsAddPaymentMethodConfirmAuthorization(params) {
    return { evid: 4992, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsView' event (evid: 4993)
 *
 * Event description: View manage permissions page for specific payment method
 *
 * @param {paymentMethodsManagePermissionsViewParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} pageView - no permissions / x permissions
 * @property {string} referralAdditionalInfo - actions / card permissions (what was the entry point to view the modal)
 * @return {LogObject<paymentMethodsManagePermissionsViewParams>} LogObject<paymentMethodsManagePermissionsViewParams>
 */
export function paymentMethodsManagePermissionsView(params) {
    return { evid: 4993, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsStep1' event (evid: 4994)
 *
 * Event description: Site selector loaded after clicking add permissions
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsStep1Params} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsStep1Params>} LogObject<paymentMethodsManagePermissionsAddPermissionsStep1Params>
 */
export function paymentMethodsManagePermissionsAddPermissionsStep1(params) {
    return { evid: 4994, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsStep2' event (evid: 4995)
 *
 * Event description: Click the site selector page while adding permissions
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsStep2Params} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {GUID} selectedMsid - Selected MSID
 * @property {string} clickType - cancel/next/close
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsStep2Params>} LogObject<paymentMethodsManagePermissionsAddPermissionsStep2Params>
 */
export function paymentMethodsManagePermissionsAddPermissionsStep2(params) {
    return { evid: 4995, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsStep3' event (evid: 4996)
 *
 * Event description: Click the user selector page while giving permissions
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsStep3Params} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} clickType - cancel/next/close
 * @property {string} selectedUuids - list of selected uuids (separated by comas)
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsStep3Params>} LogObject<paymentMethodsManagePermissionsAddPermissionsStep3Params>
 */
export function paymentMethodsManagePermissionsAddPermissionsStep3(params) {
    return { evid: 4996, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsStep4' event (evid: 4997)
 *
 * Event description: add permissions final step
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsStep4Params} params - The parameters for this event
 * @property {string} clickType - back/cancel/confirm/close
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsStep4Params>} LogObject<paymentMethodsManagePermissionsAddPermissionsStep4Params>
 */
export function paymentMethodsManagePermissionsAddPermissionsStep4(params) {
    return { evid: 4997, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsSuccess' event (evid: 4998)
 *
 * Event description: add permissions success
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {GUID} selectedMsid - Selected MSID
 * @property {string} selectedUuids - list of UUIDs
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsSuccessParams>} LogObject<paymentMethodsManagePermissionsAddPermissionsSuccessParams>
 */
export function paymentMethodsManagePermissionsAddPermissionsSuccess(params) {
    return { evid: 4998, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsError' event (evid: 4999)
 *
 * Event description: add permissions failure
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsErrorParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} errorInfo - error info
 * @property {GUID} selectedMsid - Selected MSID
 * @property {string} selectedUuids - list of UUIDs
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsErrorParams>} LogObject<paymentMethodsManagePermissionsAddPermissionsErrorParams>
 */
export function paymentMethodsManagePermissionsAddPermissionsError(params) {
    return { evid: 4999, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsViewCardPermissions' event (evid: 49991)
 *
 * Event description: View card permissions
 *
 * @param {paymentMethodsViewCardPermissionsParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsViewCardPermissionsParams>} LogObject<paymentMethodsViewCardPermissionsParams>
 */
export function paymentMethodsViewCardPermissions(params) {
    return { evid: 49991, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsRemovePermissionView' event (evid: 49992)
 *
 * Event description: User Clicked remove permission cta
 *
 * @param {paymentMethodsManagePermissionsRemovePermissionViewParams} params - The parameters for this event
 * @property {GUID} selectedUser - uuid of selected user
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsManagePermissionsRemovePermissionViewParams>} LogObject<paymentMethodsManagePermissionsRemovePermissionViewParams>
 */
export function paymentMethodsManagePermissionsRemovePermissionView(params) {
    return { evid: 49992, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsRemovePermissionClick' event (evid: 49993)
 *
 * Event description: Remove permission click
 *
 * @param {paymentMethodsManagePermissionsRemovePermissionClickParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {GUID} selectedUser - uuid of selected user
 * @property {string} selectedMsids - list of msids
 * @property {string} clickType - cancel/remove/close
 * @return {LogObject<paymentMethodsManagePermissionsRemovePermissionClickParams>} LogObject<paymentMethodsManagePermissionsRemovePermissionClickParams>
 */
export function paymentMethodsManagePermissionsRemovePermissionClick(params) {
    return { evid: 49993, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsRemovePermissionSuccess' event (evid: 49994)
 *
 * Event description: Remove permission success
 *
 * @param {paymentMethodsManagePermissionsRemovePermissionSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {GUID} selectedUser - uuid of selected user
 * @property {string} selectedMsids - list of msids
 * @return {LogObject<paymentMethodsManagePermissionsRemovePermissionSuccessParams>} LogObject<paymentMethodsManagePermissionsRemovePermissionSuccessParams>
 */
export function paymentMethodsManagePermissionsRemovePermissionSuccess(params) {
    return { evid: 49994, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsRemovePermissionError' event (evid: 49995)
 *
 * Event description: Remove permission failure
 *
 * @param {paymentMethodsManagePermissionsRemovePermissionErrorParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} errorInfo - error info
 * @property {GUID} selectedUser - uuid of selected user
 * @property {string} selectedMsids - list of msids
 * @return {LogObject<paymentMethodsManagePermissionsRemovePermissionErrorParams>} LogObject<paymentMethodsManagePermissionsRemovePermissionErrorParams>
 */
export function paymentMethodsManagePermissionsRemovePermissionError(params) {
    return { evid: 49995, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsLearnMore' event (evid: 49996)
 *
 * Event description: Click learn more on manage permissions page
 *
 * @param {paymentMethodsManagePermissionsLearnMoreParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} pageView - no permissions / x permissions
 * @property {string} referralAdditionalInfo - Referral Additional Info
 * @return {LogObject<paymentMethodsManagePermissionsLearnMoreParams>} LogObject<paymentMethodsManagePermissionsLearnMoreParams>
 */
export function paymentMethodsManagePermissionsLearnMore(params) {
    return { evid: 49996, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainNoSitesModal' event (evid: 49997)
 *
 * Event description: Triggers when free users with no sites click on Connect Purchse Domain button in the empty state
 *
 * @param {domainNoSitesModalParams} params - The parameters for this event
 * @property {string} viewMode - Account | Site level
 * @property {string} flowType - Connect | Purchase
 * @property {boolean} hasSites - If the user has sites in the accuont
 * @property {string} referralAdditionalInfo - Where user came from
 * @property {string} action - view | create_your_site| close | get_domain_without_site | learn_more | hover_info | tooltip_click | expand_footer
 * @return {LogObject<domainNoSitesModalParams>} LogObject<domainNoSitesModalParams>
 */
export function domainNoSitesModal(params) {
    return { evid: 49997, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainsConciergeClickOnSuggestedTld' event (evid: 49998)
 *
 * Event description: User clicked on suggested TLD
 *
 * @param {domainsConciergeClickOnSuggestedTldParams} params - The parameters for this event
 * @property {string} voucher - true , false
 * @property {string} suggestedTlds - array of suggested TLDs and notes (voucher included etc)
 * @property {string} viewmode - .
 * @property {string} locale - .
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} hasValidVouchers - .
 * @property {string} referralAdditionalInfo - domain_connect_domain , buy_a_domain , connect_domain_you_already_own , domains-item
 * @property {boolean} isAccountPremium - is_account_premium
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {string} tld - The TLD that was selected
 * @property {boolean} isSale - is_sale
 * @return {LogObject<domainsConciergeClickOnSuggestedTldParams>} LogObject<domainsConciergeClickOnSuggestedTldParams>
 */
export function domainsConciergeClickOnSuggestedTld(params) {
    return { evid: 49998, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfDomainsConciergeHoverOverSuggestedTld' event (evid: 49999)
 *
 * Event description: User hovered on suggested TLD
 *
 * @param {copyOfDomainsConciergeHoverOverSuggestedTldParams} params - The parameters for this event
 * @property {string} voucher - true , false
 * @property {string} suggestedTlds - array of suggested TLDs and notes (voucher included etc)
 * @property {string} text - The hover content test
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} referralAdditionalInfo - domain_connect_domain , buy_a_domain , connect_domain_you_already_own , domains-item
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {string} tld - The TLD that was selected
 * @property {boolean} isSale - true. false
 * @return {LogObject<copyOfDomainsConciergeHoverOverSuggestedTldParams>} LogObject<copyOfDomainsConciergeHoverOverSuggestedTldParams>
 */
export function copyOfDomainsConciergeHoverOverSuggestedTld(params) {
    return { evid: 49999, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnCancelNextPopup1' event (evid: 5)
 *
 * Event description: A_ClickOnCancelNextPopup1
 *
 * @param {aClickOnCancelNextPopup1Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn. In the new flow since Nov 24  it changed to be "tell_us_more" field
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} subscriptionId - subscriptionId
 * @return {LogObject<aClickOnCancelNextPopup1Params>} LogObject<aClickOnCancelNextPopup1Params>
 */
export function aClickOnCancelNextPopup1(params) {
    return { evid: 5, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnRemoveConnection' event (evid: 50)
 *
 * Event description: A_ClickOnRemoveConnection.
 *
 * @param {aClickOnRemoveConnectionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnRemoveConnectionParams>} LogObject<aClickOnRemoveConnectionParams>
 */
export function aClickOnRemoveConnection(params) {
    return { evid: 50, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnHowTouslocalDirectory' event (evid: 500)
 *
 * Event description: A_ClickOnHowToUSLocalDirectory.
 *
 * @param {aClickOnHowTouslocalDirectoryParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnHowTouslocalDirectoryParams>} LogObject<aClickOnHowTouslocalDirectoryParams>
 */
export function aClickOnHowTouslocalDirectory(params) {
    return { evid: 500, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteUpgradeClick' event (evid: 50011)
 *
 * Event description: Upgrade Click - currently only for migratoin flow
 *
 * @param {gSuiteUpgradeClickParams} params - The parameters for this event
 * @property {number} quantity - quantity
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} flowType - Migration
 * @property {string} positionName - Context-menu Marketing-banner section-helper
 * @property {string} domain - domain name
 * @property {string} clickType - upgrade
 * @property {string} viewmode - view mode
 * @property {string} newPurchase - is_new_purchase
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} recommendedPlan - Recommended Plan
 * @property {string} referrer - referrer
 * @property {string} type - type
 * @property {GUID} msid - msid
 * @property {GUID} productTypeId - product_type_id
 * @property {string} productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteUpgradeClickParams>} LogObject<gSuiteUpgradeClickParams>
 */
export function gSuiteUpgradeClick(params) {
    return { evid: 50011, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMigrationLearnMoreClick' event (evid: 50012)
 *
 * Event description: G-suite > Migration Learn More Click
 *
 * @param {gSuiteMigrationLearnMoreClickParams} params - The parameters for this event
 * @property {number} quantity - quantity
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow_type
 * @property {string} positionName - position_name
 * @property {string} domain - domain
 * @property {string} clickType - click_type
 * @property {string} newPurchase - is_new_purchase
 * @property {string} pageView - page_view
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} recommendedPlan - recommended_plan
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<gSuiteMigrationLearnMoreClickParams>} LogObject<gSuiteMigrationLearnMoreClickParams>
 */
export function gSuiteMigrationLearnMoreClick(params) {
    return { evid: 50012, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMigrationUpgradeBanner' event (evid: 50013)
 *
 * Event description: G-suite > Migration Upgrade Banner
 *
 * @param {gSuiteMigrationUpgradeBannerParams} params - The parameters for this event
 * @property {number} quantity - quantity
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} flowType - Migration
 * @property {string} positionName - Context-menu Marketing-banner section-helper
 * @property {string} domain - domain name
 * @property {string} clickType - upgrade
 * @property {string} viewmode - view mode
 * @property {string} newPurchase - is_new_purchase
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} recommendedPlan - Recommended Plan
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<gSuiteMigrationUpgradeBannerParams>} LogObject<gSuiteMigrationUpgradeBannerParams>
 */
export function gSuiteMigrationUpgradeBanner(params) {
    return { evid: 50013, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleMailDeleteUsersModalLoad' event (evid: 50014)
 *
 * Event description: Google Mail Delete users modal load
 *
 * @param {googleMailDeleteUsersModalLoadParams} params - The parameters for this event
 * @property {string} viewMode - site_level/account_level
 * @property {number} quantity - Total number of users
 * @property {number} emailSkuId - email_sku_id
 * @property {string} domain - domain
 * @property {number} numInactiveUsers - Number of current inactive users
 * @property {string} cycleName - cyclecycle_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} subscriptionType - subscription_type
 * @property {GUID} packageId - package_id
 * @property {GUID} msid - msid
 * @return {LogObject<googleMailDeleteUsersModalLoadParams>} LogObject<googleMailDeleteUsersModalLoadParams>
 */
export function googleMailDeleteUsersModalLoad(params) {
    return { evid: 50014, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleMailDeleteUsersModalClick' event (evid: 50015)
 *
 * Event description: Google Mail Delete users modal clock
 *
 * @param {googleMailDeleteUsersModalClickParams} params - The parameters for this event
 * @property {string} viewMode - site_level/account_level
 * @property {number} quantity - Total number of users
 * @property {number} emailSkuId - email_sku_id
 * @property {string} domain - domain
 * @property {string} clickType - Learn more / renew with active only / submit / renew active only
 * @property {number} numInactiveUsers - Number of current inactive users
 * @property {string} cycleName - cyclecycle_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} subscriptionType - subscription_type
 * @property {GUID} packageId - package_id
 * @property {GUID} msid - msid
 * @return {LogObject<googleMailDeleteUsersModalClickParams>} LogObject<googleMailDeleteUsersModalClickParams>
 */
export function googleMailDeleteUsersModalClick(params) {
    return { evid: 50015, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePpLoaded' event (evid: 50016)
 *
 * Event description: When the GWS package picker load on the client
 *
 * @param {gSuitePpLoadedParams} params - The parameters for this event
 * @property {string} viewMode - site_level/account_level
 * @property {number} quantity - quantity
 * @property {number} emailSkuId - emailSkuId
 * @property {string} domain - domain
 * @property {string} planType - starter/standard/plus
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {GUID} packageId - packageId
 * @property {GUID} msid - msid
 * @return {LogObject<gSuitePpLoadedParams>} LogObject<gSuitePpLoadedParams>
 */
export function gSuitePpLoaded(params) {
    return { evid: 50016, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuite2ndUpgradeUpgradeButtonAppearing' event (evid: 50017)
 *
 * Event description: Upgrade button appearing on Business Email Page - a per domain event
 *
 * @param {gSuite2ndUpgradeUpgradeButtonAppearingParams} params - The parameters for this event
 * @property {number} quantity - quantity
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} flowType - Migration
 * @property {string} positionName - Context-menu Marketing-banner section-helper
 * @property {string} domain - domain name
 * @property {string} viewmode - view mode
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} recommendedPlan - Recommended Plan
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<gSuite2ndUpgradeUpgradeButtonAppearingParams>} LogObject<gSuite2ndUpgradeUpgradeButtonAppearingParams>
 */
export function gSuite2ndUpgradeUpgradeButtonAppearing(params) {
    return { evid: 50017, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuite2ndUpgradeHighestPlanError' event (evid: 50018)
 *
 * Event description: G-suite > 2nd upgrade > Highest plan error
 *
 * @param {gSuite2ndUpgradeHighestPlanErrorParams} params - The parameters for this event
 * @property {number} quantity - quantity
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} flowType - Migration
 * @property {string} positionName - Context-menu Marketing-banner section-helper
 * @property {string} domain - domain name
 * @property {string} viewmode - view mode
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} recommendedPlan - Recommended Plan
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<gSuite2ndUpgradeHighestPlanErrorParams>} LogObject<gSuite2ndUpgradeHighestPlanErrorParams>
 */
export function gSuite2ndUpgradeHighestPlanError(params) {
    return { evid: 50018, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesGoogleVoicePageCtaClick' event (evid: 50019)
 *
 * Event description: Click on the CTA of the Google voice page
 *
 * @param {gSuiteMyMailboxesGoogleVoicePageCtaClickParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} siteGuid - msid
 * @return {LogObject<gSuiteMyMailboxesGoogleVoicePageCtaClickParams>} LogObject<gSuiteMyMailboxesGoogleVoicePageCtaClickParams>
 */
export function gSuiteMyMailboxesGoogleVoicePageCtaClick(params) {
    return { evid: 50019, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'semiPrivacyEnabled' event (evid: 5004)
 *
 * Event description: Semi privacy enabled - migration finished successfully
 *
 * @param {semiPrivacyEnabledParams} params - The parameters for this event
 * @property {GUID} uuid - domain owner
 * @property {string} domainName - domain
 * @property {string} user_agent - user_agent
 * @return {LogObject<semiPrivacyEnabledParams>} LogObject<semiPrivacyEnabledParams>
 */
export function semiPrivacyEnabled(params) {
    return { evid: 5004, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'emailReceivedWixDomain' event (evid: 5005)
 *
 * Event description: WIX received email  from anonymous user to xxx@wix-domains.com
 *
 * @param {emailReceivedWixDomainParams} params - The parameters for this event
 * @property {GUID} uuid - uuid of site owner
 * not the sender
 * @property {GUID} userGuid - uuid of site owner
 * @property {string} domainName - domain
 * @property {string} user_agent - user_agent
 * @property {boolean} whiteListed - is the email exists in the wishlist table
 * @property {string} sendVia - domain part of the sender's email address
 * @return {LogObject<emailReceivedWixDomainParams>} LogObject<emailReceivedWixDomainParams>
 */
export function emailReceivedWixDomain(params) {
    return { evid: 5005, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'autoReplyDomainEmail' event (evid: 5006)
 *
 * Event description: auto reply email has been sent to the anonymous sender
 *
 * @param {autoReplyDomainEmailParams} params - The parameters for this event
 * @property {GUID} uuid - uuid of site owner
 * not the sender
 * @property {GUID} userGuid - uuid of site owner
 * @property {string} domainName - domain
 * @property {string} user_agent - user_agent
 * @return {LogObject<autoReplyDomainEmailParams>} LogObject<autoReplyDomainEmailParams>
 */
export function autoReplyDomainEmail(params) {
    return { evid: 5006, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'whiteListedDomainEmailSent' event (evid: 5007)
 *
 * Event description: triggered when the sender email exist in the white listed table and the email has been delivered
 *
 * @param {whiteListedDomainEmailSentParams} params - The parameters for this event
 * @property {GUID} uuid - uuid of site owner
 * not the sender
 * @property {GUID} userGuid - uuid of site owner
 * @property {string} domainName - domain
 * @property {string} user_agent - user_agent
 * @property {string} sendVia - domain part of the sender's email address
 * @property {string} title - email title field
 * @return {LogObject<whiteListedDomainEmailSentParams>} LogObject<whiteListedDomainEmailSentParams>
 */
export function whiteListedDomainEmailSent(params) {
    return { evid: 5007, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainFormOpen' event (evid: 5008)
 *
 * Event description: open the wix-form in order to contact the wix's domain owner
 *
 * @param {domainFormOpenParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} user_agent - user_agent
 * @return {LogObject<domainFormOpenParams>} LogObject<domainFormOpenParams>
 */
export function domainFormOpen(params) {
    return { evid: 5008, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainFormSubmit' event (evid: 5009)
 *
 * Event description: Click on the domain form submit button
 *
 * @param {domainFormSubmitParams} params - The parameters for this event
 * @property {GUID} uuid - sender
 * @property {GUID} userGuid - uuid of site owner
 * @property {string} domainName - domain
 * @property {string} user_agent - user_agent
 * @return {LogObject<domainFormSubmitParams>} LogObject<domainFormSubmitParams>
 */
export function domainFormSubmit(params) {
    return { evid: 5009, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartPremiumUpgradeDirectUrlSuccess' event (evid: 501)
 *
 * Event description: R_StartPremiumUpgradeDirectUrlSuccess.
 *
 * @param {rStartPremiumUpgradeDirectUrlSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartPremiumUpgradeDirectUrlSuccessParams>} LogObject<rStartPremiumUpgradeDirectUrlSuccessParams>
 */
export function rStartPremiumUpgradeDirectUrlSuccess(params) {
    return { evid: 501, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainFormError' event (evid: 5010)
 *
 * Event description: Error message been sent after clicking on the submit button
 *
 * @param {domainFormErrorParams} params - The parameters for this event
 * @property {string} errorMessage - error_message
 * @property {GUID} uuid - sender
 * @property {GUID} userGuid - uuid of site owner
 * @property {string} domainName - domain
 * @property {string} user_agent - user_agent
 * @return {LogObject<domainFormErrorParams>} LogObject<domainFormErrorParams>
 */
export function domainFormError(params) {
    return { evid: 5010, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc17Evid501000' event (evid: 501000)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc17Evid501000Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc17Evid501000Params>} LogObject<dummyNameSrc17Evid501000Params>
 */
export function dummyNameSrc17Evid501000(params) {
    return { evid: 501000, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainPrivacySemiPrivacyTucowsVerificationEmailSent' event (evid: 5011)
 *
 * Event description: Semi privacy/Sendgrid email sent (In case we got an email from openSRS and send our own cheetah/oracle version instead. Used within verification/suspended emails)
 *
 * @param {domainPrivacySemiPrivacyTucowsVerificationEmailSentParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} domainName - domain
 * @property {string} user_agent - user_agent
 * @property {string} emailTemplate - Cheetah / Oracle Template Name
 * @return {LogObject<domainPrivacySemiPrivacyTucowsVerificationEmailSentParams>} LogObject<domainPrivacySemiPrivacyTucowsVerificationEmailSentParams>
 */
export function domainPrivacySemiPrivacyTucowsVerificationEmailSent(params) {
    return { evid: 5011, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc17Evid501100' event (evid: 501100)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc17Evid501100Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc17Evid501100Params>} LogObject<dummyNameSrc17Evid501100Params>
 */
export function dummyNameSrc17Evid501100(params) {
    return { evid: 501100, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc17Evid501200' event (evid: 501200)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc17Evid501200Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc17Evid501200Params>} LogObject<dummyNameSrc17Evid501200Params>
 */
export function dummyNameSrc17Evid501200(params) {
    return { evid: 501200, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc17Evid501300' event (evid: 501300)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc17Evid501300Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc17Evid501300Params>} LogObject<dummyNameSrc17Evid501300Params>
 */
export function dummyNameSrc17Evid501300(params) {
    return { evid: 501300, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryTabCsvFileIsReadyToDownload' event (evid: 5014)
 *
 * Event description: BillingHistoryTab > CSV file is ready to download after 17:4799 when user clicked on export csv there is a loader and then a green toast of "ready file".. this event will be fired when the file is ready
 *
 * @param {billingHistoryTabCsvFileIsReadyToDownloadParams} params - The parameters for this event
 * @property {string} name - domain_name_filter
 * @property {string} externalSessionId - externalSessionId
 * @property {string} paymentMethod - payment_method_type_filter
 * @property {number} year - year_filter
 * @property {string} clickType - closed window/ cancel/ download
 * @property {string} freeText - free_text_filter
 * @property {string} siteName - site_name_filter
 * @property {string} clickName - closed window/ cancel/ download
 * @property {number} daysAgo - days_ago_filter
 * @property {string} status - status_filter
 * @property {number} countInvoices - number of invoices
 * @property {string} jsonData - json_data
 * @property {string} metaSiteId - msid_filter
 * @property {string} modalType - modal_type
 * @return {LogObject<billingHistoryTabCsvFileIsReadyToDownloadParams>} LogObject<billingHistoryTabCsvFileIsReadyToDownloadParams>
 */
export function billingHistoryTabCsvFileIsReadyToDownload(params) {
    return { evid: 5014, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc17Evid501400' event (evid: 501400)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc17Evid501400Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc17Evid501400Params>} LogObject<dummyNameSrc17Evid501400Params>
 */
export function dummyNameSrc17Evid501400(params) {
    return { evid: 501400, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc17Evid501600' event (evid: 501600)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc17Evid501600Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc17Evid501600Params>} LogObject<dummyNameSrc17Evid501600Params>
 */
export function dummyNameSrc17Evid501600(params) {
    return { evid: 501600, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartPremiumUpgradeDirectUrlError' event (evid: 502)
 *
 * Event description: R_StartPremiumUpgradeDirectUrlError.
 *
 * @param {rStartPremiumUpgradeDirectUrlErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartPremiumUpgradeDirectUrlErrorParams>} LogObject<rStartPremiumUpgradeDirectUrlErrorParams>
 */
export function rStartPremiumUpgradeDirectUrlError(params) {
    return { evid: 502, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartPremiumUpgradeDirectUrlException' event (evid: 503)
 *
 * Event description: R_StartPremiumUpgradeDirectUrlException.
 *
 * @param {rStartPremiumUpgradeDirectUrlExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartPremiumUpgradeDirectUrlExceptionParams>} LogObject<rStartPremiumUpgradeDirectUrlExceptionParams>
 */
export function rStartPremiumUpgradeDirectUrlException(params) {
    return { evid: 503, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPpclickOnMonthlyPlansLink' event (evid: 504)
 *
 * Event description: A_PPClickOnMonthlyPlansLink.
 *
 * @param {aPpclickOnMonthlyPlansLinkParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPpclickOnMonthlyPlansLinkParams>} LogObject<aPpclickOnMonthlyPlansLinkParams>
 */
export function aPpclickOnMonthlyPlansLink(params) {
    return { evid: 504, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnFreeSiteUpgrade' event (evid: 505)
 *
 * Event description: A_ClickOnFreeSiteUpgrade.
 *
 * @param {aClickOnFreeSiteUpgradeParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnFreeSiteUpgradeParams>} LogObject<aClickOnFreeSiteUpgradeParams>
 */
export function aClickOnFreeSiteUpgrade(params) {
    return { evid: 505, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchDomainResultPageErrorSrc17Evid506' event (evid: 506)
 *
 * Event description: errors on domain result page
 *
 * @param {searchDomainResultPageErrorSrc17Evid506Params} params - The parameters for this event
 * @property {string} ViewMode - view mode
 * @property {string} SearchTerm - domain search term
 * @property {string} TriggerType - search/Filters/Own it/view More Results
 * @property {string} ErrorType - Empty search field/ network issue/service unavailable/ No results/ Pricing unavailable/ Rate limit
 * @return {LogObject<searchDomainResultPageErrorSrc17Evid506Params>} LogObject<searchDomainResultPageErrorSrc17Evid506Params>
 */
export function searchDomainResultPageErrorSrc17Evid506(params) {
    return { evid: 506, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainRegistrarRenewalSuccess' event (evid: 507)
 *
 * Event description: SBS sends to domains request if a payment was successful then domains  ask Registrar to prolong subscription. This event triggers if a prolong was successful.
 *
 * @param {domainRegistrarRenewalSuccessParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {GUID} uuid - user id
 * @property {string} serviceId - service id
 * @return {LogObject<domainRegistrarRenewalSuccessParams>} LogObject<domainRegistrarRenewalSuccessParams>
 */
export function domainRegistrarRenewalSuccess(params) {
    return { evid: 507, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainRegistrarRenewalError' event (evid: 508)
 *
 * Event description: SBS sends to domains request if a payment was successful then domains  ask Registrar to prolong subscription. This event triggers if a prolong fails.
 *
 * @param {domainRegistrarRenewalErrorParams} params - The parameters for this event
 * @property {string} errorInfo - error info
 * @property {string} domain - domain name
 * @property {GUID} uuid - user id
 * @return {LogObject<domainRegistrarRenewalErrorParams>} LogObject<domainRegistrarRenewalErrorParams>
 */
export function domainRegistrarRenewalError(params) {
    return { evid: 508, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsFedMonitoring' event (evid: 509)
 *
 * Event description: event for FED monitoring
 *
 * @param {myDomainsFedMonitoringParams} params - The parameters for this event
 * @property {string} tabId - tab_id
 * @property {Url} parentUrl - parent url
 * @property {Url} fullUrl - full url
 * @property {string} errorName - error name
 * @property {string} additionalInfo - error_info
 * @return {LogObject<myDomainsFedMonitoringParams>} LogObject<myDomainsFedMonitoringParams>
 */
export function myDomainsFedMonitoring(params) {
    return { evid: 509, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickManagemx' event (evid: 51)
 *
 * Event description: A_ClickManageMX.
 *
 * @param {aClickManagemxParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickManagemxParams>} LogObject<aClickManagemxParams>
 */
export function aClickManagemx(params) {
    return { evid: 51, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixDomainDeletionSuccess' event (evid: 510)
 *
 * Event description: if a user cancels his domain in first 5 days after registration we will remove his domain from Registrar, in other case we park it.
 *
 * @param {wixDomainDeletionSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} status_text - deleted | parked | cleaned (can't park, removed from DB)
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} appdefid - application calling the API
 * @property {GUID} _event_hash - event_hash
 * @property {string} owner - backoffice | refund_widget | ...
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} agentUuid - uuid performs the action (caller of the API)
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<wixDomainDeletionSuccessParams>} LogObject<wixDomainDeletionSuccessParams>
 */
export function wixDomainDeletionSuccess(params) {
    return { evid: 510, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'registrarIcannVerificationOfContactInformation' event (evid: 5101)
 *
 * Event description: Domain Contact Verification. It will trigger when we receive notifications from Tucows about status change.
 *
 * @param {registrarIcannVerificationOfContactInformationParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {GUID} uuid - uuid
 * @property {string} externalStatus - tucows status (external)
 * @property {string} statusText - contact verification status (main)
 * @return {LogObject<registrarIcannVerificationOfContactInformationParams>} LogObject<registrarIcannVerificationOfContactInformationParams>
 */
export function registrarIcannVerificationOfContactInformation(params) {
    return { evid: 5101, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainTransferInSuccess' event (evid: 511)
 *
 * Event description: Effective from 2018-08-23
 *
 * @param {domainTransferInSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {GUID} siteid - site_id
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} skuId - domain_sku_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - cycle_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<domainTransferInSuccessParams>} LogObject<domainTransferInSuccessParams>
 */
export function domainTransferInSuccess(params) {
    return { evid: 511, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainTransferOutSuccess' event (evid: 512)
 *
 * Event description: We check the owner of the domain after 2 weeks a user requested Authorization code for this domain.
 *
 * @param {rDomainTransferOutSuccessParams} params - The parameters for this event
 * @property {boolean} success - true | false
 * @property {string} domain - domain name
 * @property {GUID} uuid - user id
 * @return {LogObject<rDomainTransferOutSuccessParams>} LogObject<rDomainTransferOutSuccessParams>
 */
export function rDomainTransferOutSuccess(params) {
    return { evid: 512, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsActions' event (evid: 513)
 *
 * Event description: Any actions with domains on My Domains Page.
 *
 * @param {myDomainsActionsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} totalUnassignedDomains - the number of unassigned domains in the page
 * @property {string} location - dropdown | details | name | button | domain_statuses | etc
 * @property {string} tab - assigned | unassigned | inactive
 * @property {string} domain - domain name
 * @property {string} totalInactiveDomains - the number of inactive domains in the page
 * @property {string} label - live | offline
 * @property {string} domains - list of domains
 * @property {string} elementText - the text on the element - buy a mailbox | assign to a different site | open_dropdown
 * @property {string} totalDomains - the number of domains on the page, if 0 - then empty state
 * @property {boolean} emptyState - true,false
 * @property {boolean} isPublished - is site published or not
 * @property {string} redeemStatus - can_redeem, redeem_in_process, redeem_failed
 * @property {string} registrar - wix | non-wix
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} status - status path
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} totalConnectedDomains - the number of active domains in the page that are connected
 * @property {string} referralAdditionalInfo - where users came form
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {string} reseller - reseller guid (if applicable)
 * @property {boolean} hasApi - whether domain has Redeem API - true, false
 * @property {boolean} isPremium - has a premium on the current site
 * @property {string} totalAssignedDomains - the number of assigned domains in the page
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid | NULL if domain unassigned
 * @return {LogObject<myDomainsActionsParams>} LogObject<myDomainsActionsParams>
 */
export function myDomainsActions(params) {
    return { evid: 513, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsAssignFlowStep1' event (evid: 514)
 *
 * Event description: First screens in assign flow: one free site, one free site with unassigned premium, one premium site, premium and free sites
 *
 * @param {myDomainsAssignFlowStep1Params} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {GUID} fromMsid - msid | NULL means that domain was unassigned
 * @property {string} registrar - wix | non-wix
 * @property {DateTime} datetimeSent - Precise event timestamp from client side. Technical field to avoid wrong event order, when event in funnel are captured almost instantly.
 * @property {string} domainStatus - status of the domain from messages
 * @property {number} siteType - 0 - free | 1 - premium (for actions next, assign, assign_an_existing_plan,  upgrade_to_premium)
 * @property {string} referralAdditionalInfo - where users came form
 * @property {boolean} isPremium - Does a user have an unassigned premium package
 * @property {string} domainLevel - primary | secondary
 * @property {string} totalSites - Number of sites
 * @property {string} totalFreeSites - Number of free sites
 * @property {string} action - view | close | cancel | next | assign| assign_an_existing_plan | upgrade_to_premium
 * @property {string} totalPremiumSites - Number of premium sites
 * @return {LogObject<myDomainsAssignFlowStep1Params>} LogObject<myDomainsAssignFlowStep1Params>
 */
export function myDomainsAssignFlowStep1(params) {
    return { evid: 514, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsAssignFlowStep2' event (evid: 515)
 *
 * Event description: Second screens in assign flow:
 * 1. one free site with unassigned premium > Assign Existing Plan
 * 2. one premium site > Confirmation wo domain | Choose what to do with domain
 * 3. premium and free sites >  free > Assign Premium Plan
 * 4. premium and free sites >  premium > Confirmation wo domain | Choose what to do with domain
 *
 * @param {myDomainsAssignFlowStep2Params} params - The parameters for this event
 * @property {DateTime} dateTimeSent - Precise event timestamp from client side. Technical field to avoid wrong event order, when event in funnel are captured almost instantly.
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {GUID} toMsid - to which site user assigns a domain
 * @property {string} label - live | offline
 * @property {GUID} fromMsid - msid | NULL means that domain was unassigned
 * @property {string} registrar - wix | non-wix
 * @property {string} domainStatus - status of the domain from messages
 * @property {number} siteType - 0 - free | 1 - premium
 * @property {string} premium - Is the premium plan is assigned to a site. unassigned | assigned
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} type - assign_premium_plan | has_domain | no_domains
 * @property {string} domainLevel - primary | secondary
 * @property {string} action - view | close | cancel | next | assign | back
 * @return {LogObject<myDomainsAssignFlowStep2Params>} LogObject<myDomainsAssignFlowStep2Params>
 */
export function myDomainsAssignFlowStep2(params) {
    return { evid: 515, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsAssignFlowStep3' event (evid: 516)
 *
 * Event description: Third screens in assign flow:
 * 1. one free site with unassigned premium > Assign Existing Plan > Confirmation
 * 2. one premium site > Confirmation wo domain | Choose what to do with domain > Success
 * 3. 4. premium and free sites >  premium > Confirmation wo domain | Choose what to do with domain > Success
 * 4. premium and free sites >  free > Assign Premium Plan > Confirmation wo domain | Choose what to do with domain | unassigned_plan
 *
 * @param {myDomainsAssignFlowStep3Params} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {GUID} toMsid - to which site user assigns a domain
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {GUID} fromMsid - msid | NULL means that domain was unassigned
 * @property {string} registrar - wix | non-wix
 * @property {DateTime} datetimeSent - Precise event timestamp from client side. Technical field to avoid wrong event order, when event in funnel are captured almost instantly.
 * @property {string} domainStatus - status of the domain from messages
 * @property {number} siteType - free | premium
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} type - has_domain | no_domains | unassigned_plan | success
 * @property {string} domainLevel - primary | secondary
 * @property {string} action - view | close | back | cancel | assign |  view_your_site | go_to_editor | skip_for_now
 * @return {LogObject<myDomainsAssignFlowStep3Params>} LogObject<myDomainsAssignFlowStep3Params>
 */
export function myDomainsAssignFlowStep3(params) {
    return { evid: 516, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsAssignFlowStep4' event (evid: 517)
 *
 * Event description: Forth screens in assign flow:
 * 1. one free site with unassigned premium > Assign Existing Plan > Confirmation > Success
 * 4. premium and free sites >  free > Assign Premium Plan > Confirmation wo domain | Choose what to do with domain | unassigned_plan > Success
 *
 * @param {myDomainsAssignFlowStep4Params} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {GUID} toMsid - to which site user assigns a domain
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {GUID} fromMsid - msid | NULL means that domain was unassigned
 * @property {string} registrar - wix | non-wix
 * @property {DateTime} datetimeSent - Precise event timestamp from client side. Technical field to avoid wrong event order, when event in funnel are captured almost instantly.
 * @property {string} domainStatus - status of the domain from messages
 * @property {number} siteType - free | premium
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} type - has_domain | no_domains | unassigned_plan | success
 * @property {string} domainLevel - primary | secondary
 * @property {string} action - view | close | back | cancel | assign |  view_your_site | go_to_editor | skip_for_now
 * @return {LogObject<myDomainsAssignFlowStep4Params>} LogObject<myDomainsAssignFlowStep4Params>
 */
export function myDomainsAssignFlowStep4(params) {
    return { evid: 517, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsUnassignFlow' event (evid: 518)
 *
 * Event description: Unassign domain from the site
 *
 * @param {myDomainsUnassignFlowParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {GUID} fromMsid - msid | NULL means that domain was unassigned
 * @property {string} registrar - wix | non-wix
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {string} action - view | close | unassign
 * @return {LogObject<myDomainsUnassignFlowParams>} LogObject<myDomainsUnassignFlowParams>
 */
export function myDomainsUnassignFlow(params) {
    return { evid: 518, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsTransferAwayFromWixFlow' event (evid: 519)
 *
 * Event description: Transfer domain away from Wix. User requests AUTH code.
 *
 * @param {myDomainsTransferAwayFromWixFlowParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} step - 1 | 2
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} type - icann-lock | eligible_for_transfer
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid | NULL means that domain was unassigned
 * @property {string} action - view | close | cancel | transfer_domain | keep_domain_at_wix | still_want_to_transfer | learn_more | got_it
 * @property {string} clickText - ipsTag the user chose
 * @return {LogObject<myDomainsTransferAwayFromWixFlowParams>} LogObject<myDomainsTransferAwayFromWixFlowParams>
 */
export function myDomainsTransferAwayFromWixFlow(params) {
    return { evid: 519, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickCanmx' event (evid: 52)
 *
 * Event description: A_ClickCanMX.
 *
 * @param {aClickCanmxParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickCanmxParams>} LogObject<aClickCanmxParams>
 */
export function aClickCanmx(params) {
    return { evid: 52, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsSetAsPrimary' event (evid: 520)
 *
 * Event description: Set secondary domain as primary
 *
 * @param {myDomainsSetAsPrimaryParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} action - view | close | set_as_primary
 * @return {LogObject<myDomainsSetAsPrimaryParams>} LogObject<myDomainsSetAsPrimaryParams>
 */
export function myDomainsSetAsPrimary(params) {
    return { evid: 520, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsConnectExternalMailbox' event (evid: 521)
 *
 * Event description: Connect External Mailbox
 *
 * @param {myDomainsConnectExternalMailboxParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} emailProvider - GoDaddy | GSuite | Other
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} value - comma separated user values
 * @property {string} action - view | close | connect_mailbox | click_on_dns_records | add_another | change_email_provider
 * @return {LogObject<myDomainsConnectExternalMailboxParams>} LogObject<myDomainsConnectExternalMailboxParams>
 */
export function myDomainsConnectExternalMailbox(params) {
    return { evid: 521, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectExternalBusinessEmailActions' event (evid: 5210)
 *
 * Event description: Different actions in the connect domain wizard
 *
 * @param {connectExternalBusinessEmailActionsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} emailProvider - GoDaddy | GSuite | Other
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} value - comma separated user values
 * @property {string} action - step 1 view / step 1 continue / step 2 view / step 2 continue / step 3 view / step 3 continue/ step 4 view / step 3 done/ step 4 done
 * @return {LogObject<connectExternalBusinessEmailActionsParams>} LogObject<connectExternalBusinessEmailActionsParams>
 */
export function connectExternalBusinessEmailActions(params) {
    return { evid: 5210, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectExternalBusinessEmailEditTxtActions' event (evid: 5211)
 *
 * Event description: The user edits TXT record via the connect EBE wizard
 *
 * @param {connectExternalBusinessEmailEditTxtActionsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} recordType - TXT
 * @property {string} errorMessage - Response from server in case of exceptions during “Save” action. Should be null, otherwise indicates that server responded with error
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} emailProvider - GoDaddy | GSuite | Other
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} value - comma separated user values
 * @property {string} action - add_record/ remove / edit / cancel / save
 * @property {string} record - JSON with attributes and their values for different record types domain
 * @return {LogObject<connectExternalBusinessEmailEditTxtActionsParams>} LogObject<connectExternalBusinessEmailEditTxtActionsParams>
 */
export function connectExternalBusinessEmailEditTxtActions(params) {
    return { evid: 5211, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectExternalBusinessEmailError' event (evid: 5212)
 *
 * Event description: Error in connect EBE flow
 *
 * @param {connectExternalBusinessEmailErrorParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} recordType - TXT
 * @property {string} errorMessage - Response from server in case of exceptions during “Save” action. Should be null, otherwise indicates that server responded with error
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} emailProvider - GoDaddy | GSuite | Other
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} value - comma separated user values
 * @property {string} record - JSON with attributes and their values for different record types domain
 * @return {LogObject<connectExternalBusinessEmailErrorParams>} LogObject<connectExternalBusinessEmailErrorParams>
 */
export function connectExternalBusinessEmailError(params) {
    return { evid: 5212, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsContactFormActions' event (evid: 522)
 *
 * Event description: My Domains  Contact Form Actions
 *
 * @param {myDomainsContactFormActionsParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {string} fieldsUpdated - list of updated fields
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} type - update | create
 * @property {string} action - view | cancel | back | submit
 * @property {boolean} emailChanged - Email was changed or not
 * @return {LogObject<myDomainsContactFormActionsParams>} LogObject<myDomainsContactFormActionsParams>
 */
export function myDomainsContactFormActions(params) {
    return { evid: 522, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsContactFormValidationErrorsOnSubmit' event (evid: 523)
 *
 * Event description: Contact Form Validation Errors on Submit
 *
 * @param {myDomainsContactFormValidationErrorsOnSubmitParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {string} invalidFields - comma separated empty invalid fields
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} type - update | create
 * @property {string} emptyFields - comma separated empty fields
 * @return {LogObject<myDomainsContactFormValidationErrorsOnSubmitParams>} LogObject<myDomainsContactFormValidationErrorsOnSubmitParams>
 */
export function myDomainsContactFormValidationErrorsOnSubmit(params) {
    return { evid: 523, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsNetworkCallError' event (evid: 524)
 *
 * Event description: Triggers if the session expires. Event is deprecated from 15/08/2019! From 18.02.20 - event for investigation. From 20.11.20 - network investigation.
 *
 * @param {myDomainsNetworkCallErrorParams} params - The parameters for this event
 * @property {string} sessionId - screenRecorderSessionId
 * @property {string} type - getUserDetailsCallFailure | initialCallsFailure
 * @property {string} value - error_info
 * @return {LogObject<myDomainsNetworkCallErrorParams>} LogObject<myDomainsNetworkCallErrorParams>
 */
export function myDomainsNetworkCallError(params) {
    return { evid: 524, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsEditDnsPopUp' event (evid: 525)
 *
 * Event description: Pop-ups interactions on Manage DNS page
 *
 * @param {myDomainsEditDnsPopUpParams} params - The parameters for this event
 * @property {string} recordType - aname| cname | txt | spf | srv | mx
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} type - dns_modal_edit_warning | dns_modal_save_confirmation | dns_modal_remove_confirmation
 * @property {string} action - open | cancel | ok | close | learn_more
 * @return {LogObject<myDomainsEditDnsPopUpParams>} LogObject<myDomainsEditDnsPopUpParams>
 */
export function myDomainsEditDnsPopUp(params) {
    return { evid: 525, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsEditDnsPageClicks' event (evid: 526)
 *
 * Event description: Clicks on Manage DNS page
 *
 * @param {myDomainsEditDnsPageClicksParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} action - back | edit_mx_settings | here | buy_a_new_one | learn_more_about_dns_records
 * @return {LogObject<myDomainsEditDnsPageClicksParams>} LogObject<myDomainsEditDnsPageClicksParams>
 */
export function myDomainsEditDnsPageClicks(params) {
    return { evid: 526, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsDomainVoucherInteractions' event (evid: 527)
 *
 * Event description: This event is triggered when user hovers on "Gift box" button for 1 second of more, clicks the icon or hits "Claim Voucher"
 *
 * @param {myDomainsDomainVoucherInteractionsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} totalUnassignedDomains - the number of unassigned domains in the page
 * @property {string} totalInactiveDomains - the number of inactive domains in the page
 * @property {string} totalDomains - The number of domains on the page, if 0 - then empty state
 * @property {string} totalConnectedDomains - the number of active domains in the page that are connected
 * @property {string} referralAdditionalInfo - where users came from
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {boolean} isPremium - has a premium on the current site or account level (check on the site level)
 * @property {string} totalAssignedDomains - the number of assigned domains in the page
 * @property {string} action - view(triggers on hover) | click
 * @return {LogObject<myDomainsDomainVoucherInteractionsParams>} LogObject<myDomainsDomainVoucherInteractionsParams>
 */
export function myDomainsDomainVoucherInteractions(params) {
    return { evid: 527, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsHoverOnBuyMailbox' event (evid: 528)
 *
 * Event description: This event should be triggered when user hovers on “Buy a Mailbox” button for 1 second or more. From 17.03.20 we removed this event
 *
 * @param {myDomainsHoverOnBuyMailboxParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} totalUnassignedDomains - the number of unassigned domains in the page
 * @property {string} tab - assigned|unassigned|inactive
 * @property {string} totalInactiveDomains - the number of inactive domains in the page
 * @property {string} label - live|offline
 * @property {string} totalDomains - The number of domains on the page, if 0 - then empty state
 * @property {boolean} isPublished - true | false (is site published or not)
 * @property {string} registrar - wix | non-wix
 * @property {string} domainStatus - Domain status info. Replace “NULL” value to connected domain.
 * @property {string} totalConnectedDomains - the number of active domains in the page that are connected
 * @property {string} referralAdditionalInfo - where users came from
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {boolean} isPremium - has a premium on the current site or account level (check on the site level)
 * @property {string} totalAssignedDomains - the number of assigned domains in the page
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @return {LogObject<myDomainsHoverOnBuyMailboxParams>} LogObject<myDomainsHoverOnBuyMailboxParams>
 */
export function myDomainsHoverOnBuyMailbox(params) {
    return { evid: 528, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsRemoveYourDomainFromWix' event (evid: 529)
 *
 * Event description: Remove Your Domain\Subdomain pop-up on new My Domains page
 *
 * @param {myDomainsRemoveYourDomainFromWixParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain
 * @property {string} label - live|offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} domainStatus - Domain status info. Replace “NULL” value to connected domain
 * @property {string} referralAdditionalInfo - where users came from
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} action - view | close | cancel | remove_domain | keep_domain_at_wix | keep_subdomain_at_wix
 * @return {LogObject<myDomainsRemoveYourDomainFromWixParams>} LogObject<myDomainsRemoveYourDomainFromWixParams>
 */
export function myDomainsRemoveYourDomainFromWix(params) {
    return { evid: 529, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMxupdateSuccess' event (evid: 53)
 *
 * Event description: R_MXUpdateSuccess.
 *
 * @param {rMxupdateSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {string} emailProvider - email provider name
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMxupdateSuccessParams>} LogObject<rMxupdateSuccessParams>
 */
export function rMxupdateSuccess(params) {
    return { evid: 53, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsEditDnsActions' event (evid: 530)
 *
 * Event description: Edit DNS actions on Manage DNS page
 *
 * @param {myDomainsEditDnsActionsParams} params - The parameters for this event
 * @property {string} validationMessage - ok | error (exact error text)
 * @property {string} recordType - aname| cname | txt | spf | srv | mx
 * @property {string} errorMessage - Response from server in case of exceptions during “Save” action. Should be null, otherwise indicates that server responded with error
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} action - edit | cancel | remove | add_record | save (fact of adding a new record)
 * @property {string} record - JSON with attributes and their values for different record types
 * @return {LogObject<myDomainsEditDnsActionsParams>} LogObject<myDomainsEditDnsActionsParams>
 */
export function myDomainsEditDnsActions(params) {
    return { evid: 530, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transferInIntroPage' event (evid: 531)
 *
 * Event description: Event for Intro page in new Transfer In flow
 *
 * @param {transferInIntroPageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - true | false
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - where users came from
 * @property {Url} referer - referral
 * @property {string} userType - free | premium
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInIntroPageParams>} LogObject<transferInIntroPageParams>
 */
export function transferInIntroPage(params) {
    return { evid: 531, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transferInDomainPage' event (evid: 532)
 *
 * Event description: Event is generated when the user opens "Domain" page in Transfer In flow
 *
 * @param {transferInDomainPageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} errorInfo - Error message, should be 'ok' for successes
 * @property {string} domain - Domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} registrar - Chosen registrar for a domain
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - where users come from
 * @property {Url} referer - referral
 * @property {string} userType - free | premium
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} action - view | continue
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInDomainPageParams>} LogObject<transferInDomainPageParams>
 */
export function transferInDomainPage(params) {
    return { evid: 532, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transferInPopUpInteractions' event (evid: 533)
 *
 * Event description: This event is generated on different modals in new Transfer In flow
 *
 * @param {transferInPopUpInteractionsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} domain - Domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} registrar - Chosen registrar for the  domain
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} type - domain_is_unavailable, cannot_transfer_domain, cannot_transfer_domain_without_sites
 * @property {string} popupType - domain_is_unavailable, cannot_transfer_domain, cannot_transfer_domain_without_sites
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInPopUpInteractionsParams>} LogObject<transferInPopUpInteractionsParams>
 */
export function transferInPopUpInteractions(params) {
    return { evid: 533, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transferInClickEvents' event (evid: 534)
 *
 * Event description: Event is generated when a user interacts with different checkboxes and links on "Prepare" page of the new Transfer In flow
 *
 * @param {transferInClickEventsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} domain - Domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} registrar - Chosen registrar for the domain
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} type - log_in, logged_in, unlocked_it, still_locked
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} action - log_in, logged_in, unlocked_it, still_locked
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInClickEventsParams>} LogObject<transferInClickEventsParams>
 */
export function transferInClickEvents(params) {
    return { evid: 534, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transferInPreparePage' event (evid: 535)
 *
 * Event description: This event is generated when a user opens or interacts with buttons on "Prepare" page in the new Transfer In flow
 *
 * @param {transferInPreparePageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} domain - Domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} registrar - Chosen registrar of the domain
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} action - view | continue
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInPreparePageParams>} LogObject<transferInPreparePageParams>
 */
export function transferInPreparePage(params) {
    return { evid: 535, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsPrivacyToggleActions' event (evid: 536)
 *
 * Event description: This event is triggered by changing the privacy on the Edit Contact Info page.
 *
 * @param {myDomainsPrivacyToggleActionsParams} params - The parameters for this event
 * @property {string} location - privacy_form | toast
 * @property {string} domain - Domain name
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} action - turn_on | turn_off | keep_privacy | close | open_turnoff_modal
 * @property {string} privacyType - privacy, privacy and DNSSEC
 * @return {LogObject<myDomainsPrivacyToggleActionsParams>} LogObject<myDomainsPrivacyToggleActionsParams>
 */
export function myDomainsPrivacyToggleActions(params) {
    return { evid: 536, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsRedemptionPopUp' event (evid: 537)
 *
 * Event description: Pop-ups interactions on redemption pop-up
 *
 * @param {myDomainsRedemptionPopUpParams} params - The parameters for this event
 * @property {DateTime} expirationDate - date of domain expiration
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {GUID} msid - msid
 * @property {string} action - view | redeemDomain
 * @return {LogObject<myDomainsRedemptionPopUpParams>} LogObject<myDomainsRedemptionPopUpParams>
 */
export function myDomainsRedemptionPopUp(params) {
    return { evid: 537, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainsConciergeView' event (evid: 538)
 *
 * Event description: User viewed the Concierge page
 *
 * @param {domainsConciergeViewParams} params - The parameters for this event
 * @property {number} accountNumOfPropagatedDomains - account level
 * @property {string} viewMode - .
 * @property {string} voucher - true , false
 * @property {number} siteNumOfPropagatedDomains - site level
 * @property {string} locale - .
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} hasValidVouchers - .
 * @property {string} referralAdditionalInfo - domain_connect_domain , buy_a_domain , connect_domain_you_already_own , domains-item
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {boolean} isSale - true, false
 * @return {LogObject<domainsConciergeViewParams>} LogObject<domainsConciergeViewParams>
 */
export function domainsConciergeView(params) {
    return { evid: 538, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'conciergeViewReadMoreClick' event (evid: 539)
 *
 * Event description: some actions inside the concierge
 *
 * @param {conciergeViewReadMoreClickParams} params - The parameters for this event
 * @property {string} viewMode - .
 * @property {string} voucher - true , false
 * @property {string} locale - .
 * @property {boolean} isPremiumSite - .
 * @property {string} actionName - learn more, contact support, hover (com.br hover)
 * @property {string} hasValidVouchers - .
 * @property {string} referralAdditionalInfo - .
 * @property {GUID} msid - site
 * @property {string} domain - The domain that was searched by the user
 * @return {LogObject<conciergeViewReadMoreClickParams>} LogObject<conciergeViewReadMoreClickParams>
 */
export function conciergeViewReadMoreClick(params) {
    return { evid: 539, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMxupdateException' event (evid: 54)
 *
 * Event description: R_MXUpdateException.
 *
 * @param {rMxupdateExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMxupdateExceptionParams>} LogObject<rMxupdateExceptionParams>
 */
export function rMxupdateException(params) {
    return { evid: 54, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'conciergeViewIOwnClick' event (evid: 540)
 *
 * Event description: User clicked on "i own this domain"
 *
 * @param {conciergeViewIOwnClickParams} params - The parameters for this event
 * @property {string} viewMode - cocnierge, focusWidget, focusWidgetModal
 * @property {string} voucher - true , false
 * @property {string} voucherSupportedTlds - .
 * @property {GUID} siteOwnerId - .
 * @property {string} domainPermissions - .
 * @property {string} domain - domain name
 * @property {string} locale - .
 * @property {boolean} isModal - true, false (is viewed via modal)
 * @property {boolean} isEligibleForTransfer - true, false
 * @property {boolean} isPremiumPlansOnSale - .
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} hasValidVouchers - .
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - true, false
 * @property {string} sites - .
 * @property {string} hosting - .
 * @property {number} limit - .
 * @property {GUID} msid - site
 * @property {boolean} isSale - true, false
 * @property {string} referraladditionalinfo - referral
 * @return {LogObject<conciergeViewIOwnClickParams>} LogObject<conciergeViewIOwnClickParams>
 */
export function conciergeViewIOwnClick(params) {
    return { evid: 540, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumShowcaseClickToOnCtaToStartThePurchaseFlow' event (evid: 541)
 *
 * Event description: User clicked the CTA in the premium showcase to start the purchase flow.
 *
 * @param {premiumShowcaseClickToOnCtaToStartThePurchaseFlowParams} params - The parameters for this event
 * @property {string} offerType - product name (dynamic and not dynamic)
 * @return {LogObject<premiumShowcaseClickToOnCtaToStartThePurchaseFlowParams>} LogObject<premiumShowcaseClickToOnCtaToStartThePurchaseFlowParams>
 */
export function premiumShowcaseClickToOnCtaToStartThePurchaseFlow(params) {
    return { evid: 541, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumShowcaseClickedOnCarouselSlider' event (evid: 542)
 *
 * Event description: Premium Showcase -> clicked on Carousel Slider.
 *
 * @param {premiumShowcaseClickedOnCarouselSliderParams} params - The parameters for this event
 * @property {string} offerType - product name (dynamic and not dynamic)
 * @return {LogObject<premiumShowcaseClickedOnCarouselSliderParams>} LogObject<premiumShowcaseClickedOnCarouselSliderParams>
 */
export function premiumShowcaseClickedOnCarouselSlider(params) {
    return { evid: 542, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumShowcaseShowcaseLoaded' event (evid: 543)
 *
 * Event description: The user was exposed to premium showcase
 *
 * @param {premiumShowcaseShowcaseLoadedParams} params - The parameters for this event
 * @property {string} offerType - product name (dynamic and not dynamic)
 * @return {LogObject<premiumShowcaseShowcaseLoadedParams>} LogObject<premiumShowcaseShowcaseLoadedParams>
 */
export function premiumShowcaseShowcaseLoaded(params) {
    return { evid: 543, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'conciergeLittleHelper' event (evid: 544)
 *
 * Event description: Concierge Little Helper.
 *
 * @param {conciergeLittleHelperParams} params - The parameters for this event
 * @property {string} entryPoint - real entry point
 * @property {string} referringUrl - url where the user came from
 * @property {boolean} isVoucher - if the user has a domain voucher in the account
 * @property {string} referralAdditionalInfo - original referral additional info
 * @property {boolean} isAccountPremium - is the account premium
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - msid
 * @return {LogObject<conciergeLittleHelperParams>} LogObject<conciergeLittleHelperParams>
 */
export function conciergeLittleHelper(params) {
    return { evid: 544, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsTransferInDomainPopUp' event (evid: 545)
 *
 * Event description: User had an interaction with the transfer domain pop up in my domains
 *
 * @param {myDomainsTransferInDomainPopUpParams} params - The parameters for this event
 * @property {string} viewMode - account / site level
 * @property {string} domain - domain name
 * @property {boolean} isHover - is the view was from hover or from initial pop-up
 * @property {GUID} msid - site guid
 * @property {string} action - transfer / close / view
 * @return {LogObject<myDomainsTransferInDomainPopUpParams>} LogObject<myDomainsTransferInDomainPopUpParams>
 */
export function myDomainsTransferInDomainPopUp(params) {
    return { evid: 545, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainsConciergeClickBack' event (evid: 546)
 *
 * Event description: user clicked back button in concierge page
 *
 * @param {domainsConciergeClickBackParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - referral
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @return {LogObject<domainsConciergeClickBackParams>} LogObject<domainsConciergeClickBackParams>
 */
export function domainsConciergeClickBack(params) {
    return { evid: 546, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchDomainTransferInPopUp' event (evid: 547)
 *
 * Event description: In search domain, when user clicks on "I own this domain" and domain is eligible for transfer & site is premium
 *
 * @param {searchDomainTransferInPopUpParams} params - The parameters for this event
 * @property {string} viewMode - concierge, focusWidget
 * @property {string} voucher - true, false
 * @property {boolean} isConnectedDomainModal - true, false
 * @property {string} domain - domain
 * @property {string} locale - .
 * @property {string} registrar - registrar
 * @property {boolean} isVoucherModal - true, false
 * @property {boolean} isModal - true, false (is viewed via modal)
 * @property {boolean} isPremiumSite - true, false
 * @property {string} actionName - start_domain_transfer /connect_cta/no_thanks
 * @property {boolean} isVoucher - true, false
 * @property {string} hasValidVouchers - .
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - true, false
 * @property {GUID} msid - msid
 * @property {boolean} isSale - true, false
 * @property {string} referraladditionalinfo - referral
 * @return {LogObject<searchDomainTransferInPopUpParams>} LogObject<searchDomainTransferInPopUpParams>
 */
export function searchDomainTransferInPopUp(params) {
    return { evid: 547, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transferInDomainPageClickConnectDomaind' event (evid: 548)
 *
 * Event description: User clicked "Connecting your domain" in Transfer In Domains Page
 *
 * @param {transferInDomainPageClickConnectDomaindParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - true , false
 * @property {string} domain - domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} registrar - registrar
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - site
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} action - action
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInDomainPageClickConnectDomaindParams>} LogObject<transferInDomainPageClickConnectDomaindParams>
 */
export function transferInDomainPageClickConnectDomaind(params) {
    return { evid: 548, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'showDomainStatusMessageUi' event (evid: 549)
 *
 * Event description: User viewed the Domain Status message in UI (such as: "domain taken in wix" , "can connect", etc.)
 *
 * @param {showDomainStatusMessageUiParams} params - The parameters for this event
 * @property {string} voucher - true , false
 * @property {string} domain - domain
 * @property {string} uuid - uuid
 * @property {string} clickType - null , clicked_next, clicked_prev, clicked _link
 * @property {boolean} isPremiumSite - true, false
 * @property {string} isConcierge - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} uiStatus - ui domain status (can connect, domain is taken in WIX, etc.)
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {boolean} isSale - true. false
 * @property {string} referraladditionalinfo - user is referred from
 * @return {LogObject<showDomainStatusMessageUiParams>} LogObject<showDomainStatusMessageUiParams>
 */
export function showDomainStatusMessageUi(params) {
    return { evid: 549, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rMxupdateError' event (evid: 55)
 *
 * Event description: R_MXUpdateError.
 *
 * @param {rMxupdateErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {string} emailProvider - email provider name
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rMxupdateErrorParams>} LogObject<rMxupdateErrorParams>
 */
export function rMxupdateError(params) {
    return { evid: 55, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingView' event (evid: 550)
 *
 * Event description: Connect Domain Onboarding View  [Q.A: Don't see referral_additional_info. Maybe because there isn't in the test zone] [ event is fired for every search. don't need this as event 553 is there for this reason]
 *
 * @param {connectDomainOnboardingViewParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {GUID} userGuid - uuid
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingViewParams>} LogObject<connectDomainOnboardingViewParams>
 */
export function connectDomainOnboardingView(params) {
    return { evid: 550, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingClickNext' event (evid: 551)
 *
 * Event description: ConnectDomain > Onboarding Click Next
 *
 * @param {connectDomainOnboardingClickNextParams} params - The parameters for this event
 * @property {string} method - pointing/dns (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} rawInput - the raw value (domain name) that user entered in the search bar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @return {LogObject<connectDomainOnboardingClickNextParams>} LogObject<connectDomainOnboardingClickNextParams>
 */
export function connectDomainOnboardingClickNext(params) {
    return { evid: 551, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingClickBack' event (evid: 552)
 *
 * Event description: ConnectDomain > Onboarding Click Back
 *
 * @param {connectDomainOnboardingClickBackParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingClickBackParams>} LogObject<connectDomainOnboardingClickBackParams>
 */
export function connectDomainOnboardingClickBack(params) {
    return { evid: 552, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingSearchResult' event (evid: 553)
 *
 * Event description: ConnectDomain > Onboarding Search Result (All types)
 *
 * @param {connectDomainOnboardingSearchResultParams} params - The parameters for this event
 * @property {string} method - pointing/dns (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {string} result - The result (can be an error or not)
 * @property {boolean} wixdomain - true | false
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @return {LogObject<connectDomainOnboardingSearchResultParams>} LogObject<connectDomainOnboardingSearchResultParams>
 */
export function connectDomainOnboardingSearchResult(params) {
    return { evid: 553, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingClickChangeConnectMethod' event (evid: 554)
 *
 * Event description: ConnectDomain > Onboarding Click Change Connect Method
 *
 * @param {connectDomainOnboardingClickChangeConnectMethodParams} params - The parameters for this event
 * @property {string} method - pointing/dns (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingClickChangeConnectMethodParams>} LogObject<connectDomainOnboardingClickChangeConnectMethodParams>
 */
export function connectDomainOnboardingClickChangeConnectMethod(params) {
    return { evid: 554, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainChangeConnectMethodPopUpConfirm' event (evid: 555)
 *
 * Event description: ConnectDomain > Change Connect Method PopUp Confirm
 *
 * @param {connectDomainChangeConnectMethodPopUpConfirmParams} params - The parameters for this event
 * @property {string} method - pointing (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainChangeConnectMethodPopUpConfirmParams>} LogObject<connectDomainChangeConnectMethodPopUpConfirmParams>
 */
export function connectDomainChangeConnectMethodPopUpConfirm(params) {
    return { evid: 555, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainWhoisInfo' event (evid: 5550)
 *
 * Event description: ConnectDomain > WHOIS Info  (triggered by connect domain start, connect domain verifying or my domains if pixel failed)
 *
 * @param {connectDomainWhoisInfoParams} params - The parameters for this event
 * @property {number} responseSpeed - How fast do we received WHOIS answer (ms)
 * @property {string} step - [connect domain start or verifying / my domains]. When Null it's in the flow, when not null it's in the manage domains page
 * @property {string} infoType - DNSSEC Input ['%' / unsigned]
 * @property {string} provider - provider name
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {DateTime} expiresAt - Expiration Date Input
 * @property {number} resultNumber - HTTP status code
 * @property {GUID} userGuid - uuid
 * @property {string} errorReason - error message (can be null)
 * @property {boolean} isSuccess - true/false (true if data got back correctly)
 * @property {string} user_agent - user_agent
 * @property {string} registrar - Registrar Input
 * @property {string} recordLabel - NS Input (Array?) (can be 2 or 3 records)
 * @property {string} registrarDisplayName - registrar which is sent to client
 * @property {string} resultCode - not_supported_tld, domain_not_registered, whois_record, etc
 * @property {GUID} msid - msid, can be null
 * @property {boolean} usedCache - True if we used cached results, false if not cached.
 * @return {LogObject<connectDomainWhoisInfoParams>} LogObject<connectDomainWhoisInfoParams>
 */
export function connectDomainWhoisInfo(params) {
    return { evid: 5550, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'whoisInfoSearch' event (evid: 5551)
 *
 * Event description: WHOIS Info search
 *
 * @param {whoisInfoSearchParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} user_agent - user_agent
 * @property {string} registrar - old registrar name (alias)
 * @property {string} id - new registrar name (alias)
 * @property {string} tld - tld of domain
 * @return {LogObject<whoisInfoSearchParams>} LogObject<whoisInfoSearchParams>
 */
export function whoisInfoSearch(params) {
    return { evid: 5551, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainChangeConnectMethodPopUpCancel' event (evid: 556)
 *
 * Event description: ConnectDomain > Change Connect Method PopUp cancel or X
 *
 * @param {connectDomainChangeConnectMethodPopUpCancelParams} params - The parameters for this event
 * @property {string} method - pointing (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainChangeConnectMethodPopUpCancelParams>} LogObject<connectDomainChangeConnectMethodPopUpCancelParams>
 */
export function connectDomainChangeConnectMethodPopUpCancel(params) {
    return { evid: 556, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyConfirmationPageView' event (evid: 557)
 *
 * Event description: ConnectDomain > Confirmation Page View Pop-Up.
 * From 08.08.2018 we have added field registrar (earlier we had only GoDaddy).
 *
 * @param {connectDomainGoDaddyConfirmationPageViewParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - Name of the registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyConfirmationPageViewParams>} LogObject<connectDomainGoDaddyConfirmationPageViewParams>
 */
export function connectDomainGoDaddyConfirmationPageView(params) {
    return { evid: 557, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyConfirmationPageClickYes' event (evid: 558)
 *
 * Event description: Confirmation Page View Pop-Up > User clicked 'Yes, it's from "Registrar Name" '.
 * From 08.08.2018 we have added field registrar (earlier we had only GoDaddy).
 *
 * @param {connectDomainGoDaddyConfirmationPageClickYesParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - Name of the Registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyConfirmationPageClickYesParams>} LogObject<connectDomainGoDaddyConfirmationPageClickYesParams>
 */
export function connectDomainGoDaddyConfirmationPageClickYes(params) {
    return { evid: 558, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyConfirmationPageClickBack' event (evid: 559)
 *
 * Event description: Confirmation Page View Pop-Up > User clicked "Back" in the left bottom of the screen.  From 08.08.2018 we have added field registrar (earlier we had only GoDaddy).
 *
 * @param {connectDomainGoDaddyConfirmationPageClickBackParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - Name of the Registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyConfirmationPageClickBackParams>} LogObject<connectDomainGoDaddyConfirmationPageClickBackParams>
 */
export function connectDomainGoDaddyConfirmationPageClickBack(params) {
    return { evid: 559, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vManagedns' event (evid: 56)
 *
 * Event description: V_ManageDNS.
 *
 * @param {vManagednsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vManagednsParams>} LogObject<vManagednsParams>
 */
export function vManagedns(params) {
    return { evid: 56, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyConfirmationPageClickNoAndUseGenericGuide' event (evid: 560)
 *
 * Event description: Confirmation Page View Pop-Up > User clicked 'No" ' From 08.08.2018 we have added field registrar (earlier we had only GoDaddy).
 *
 * @param {connectDomainGoDaddyConfirmationPageClickNoAndUseGenericGuideParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - Name of the Registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyConfirmationPageClickNoAndUseGenericGuideParams>} LogObject<connectDomainGoDaddyConfirmationPageClickNoAndUseGenericGuideParams>
 */
export function connectDomainGoDaddyConfirmationPageClickNoAndUseGenericGuide(params) {
    return { evid: 560, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainTutorialView' event (evid: 561)
 *
 * Event description: ConnectDomain > Tutorial View
 *
 * @param {connectDomainTutorialViewParams} params - The parameters for this event
 * @property {number} responseSpeed - How long is user waiting to see the tutorial page? (from 30 sec loader)
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} screenResolution - screen resolution
 * @property {string} subdomain - subdomain
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @return {LogObject<connectDomainTutorialViewParams>} LogObject<connectDomainTutorialViewParams>
 */
export function connectDomainTutorialView(params) {
    return { evid: 561, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainTutorialClickSwitchType' event (evid: 562)
 *
 * Event description: ConnectDomain > Tutorial Click Switch Type
 *
 * @param {connectDomainTutorialClickSwitchTypeParams} params - The parameters for this event
 * @property {string} method - dns
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text ]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - [Video tutorial / Textual tutorial] (the method you chose to change to)
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainTutorialClickSwitchTypeParams>} LogObject<connectDomainTutorialClickSwitchTypeParams>
 */
export function connectDomainTutorialClickSwitchType(params) {
    return { evid: 562, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainTutorialBack' event (evid: 563)
 *
 * Event description: ConnectDomain > Tutorial Back
 *
 * @param {connectDomainTutorialBackParams} params - The parameters for this event
 * @property {string} method - pointing/dns (the method you chose to change to)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} screenResolution - screen resolution
 * @property {string} subdomain - subdomain
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {string} place - top | bottom
 * @property {GUID} msid - msid, can be null
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @return {LogObject<connectDomainTutorialBackParams>} LogObject<connectDomainTutorialBackParams>
 */
export function connectDomainTutorialBack(params) {
    return { evid: 563, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainClickGoToGoDaddy' event (evid: 564)
 *
 * Event description: ConnectDomain > Click go to GoDaddy
 *
 * @param {connectDomainClickGoToGoDaddyParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainClickGoToGoDaddyParams>} LogObject<connectDomainClickGoToGoDaddyParams>
 */
export function connectDomainClickGoToGoDaddy(params) {
    return { evid: 564, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainClickVerifyConnection' event (evid: 565)
 *
 * Event description: ConnectDomain > Click Verify Connection
 *
 * @param {connectDomainClickVerifyConnectionParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @return {LogObject<connectDomainClickVerifyConnectionParams>} LogObject<connectDomainClickVerifyConnectionParams>
 */
export function connectDomainClickVerifyConnection(params) {
    return { evid: 565, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainVerifyConnectionResultPageView' event (evid: 566)
 *
 * Event description: ConnectDomain > Verify  Connection Result
 *
 * @param {connectDomainVerifyConnectionResultPageViewParams} params - The parameters for this event
 * @property {number} responseSpeed - How long is user waiting to see the connection result page? (from click_verify)
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic] ((the tutorial that lead to this page)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {string} result - final result
 * @property {boolean} wixdomain - true | false
 * @property {GUID} userGuid - uuid
 * @property {string} mailbox - Has mailbox - true / false
 * @property {string} coupon - Currently, this field is used to understand if the user encounter free mailbox voucher banner
 * @property {boolean} isPublished - true | false
 * @property {string} subdomain - subdomain
 * @property {string} registrar - domain registrar
 * @property {string} expectedResult - the expected result originally
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} emailSale - 1 | 0
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @property {string} flowname - flow name (manual, entri)
 * @property {boolean} SawMailboxCTA - saw_mailbox_cta
 * @return {LogObject<connectDomainVerifyConnectionResultPageViewParams>} LogObject<connectDomainVerifyConnectionResultPageViewParams>
 */
export function connectDomainVerifyConnectionResultPageView(params) {
    return { evid: 566, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainResultPageMailboxModalSrc17Evid5660' event (evid: 5660)
 *
 * Event description: ConnectDomain > Result Page > Mailbox Modal
 * The event was sent in an attempt to present the upsell of the mailbox
 *
 * @param {connectDomainResultPageMailboxModalSrc17Evid5660Params} params - The parameters for this event
 * @property {number} responseSpeed - How long is user waiting to see the connection result page? (from click_verify)
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic] ((the tutorial that lead to this page)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {string} result - final result
 * @property {boolean} wixdomain - true | false
 * @property {GUID} userGuid - uuid
 * @property {string} coupon - Currently, this field is used to understand if the user encounter free mailbox voucher banner
 * @property {boolean} isPublished - true | false
 * @property {string} subdomain - subdomain
 * @property {string} registrar - domain registrar
 * @property {string} expectedResult - the expected result originally
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} emailSale - 1 | 0
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @property {string} flowname - flow name (manual, entri)
 * @property {boolean} SawMailboxCTA - saw_mailbox_cta
 * @return {LogObject<connectDomainResultPageMailboxModalSrc17Evid5660Params>} LogObject<connectDomainResultPageMailboxModalSrc17Evid5660Params>
 */
export function connectDomainResultPageMailboxModalSrc17Evid5660(params) {
    return { evid: 5660, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainResultPageClick' event (evid: 567)
 *
 * Event description: ConnectDomain > Result page click [Go to my Domains / Learn more / Back / Go to Editor / Buy a Mailbox / Change Connection to NS]
 *
 * @param {connectDomainResultPageClickParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic] (the tutorial that lead to this page)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {string} result - page name
 * @property {GUID} userGuid - uuid
 * @property {string} mailbox - saw mailbox promo - true / false
 * @property {boolean} isPublished - true | false
 * @property {string} clickType - string from button (buy a mailbox..)
 * @property {string} subdomain - subdomain
 * @property {string} registrar - registrar
 * @property {string} expectedResult - .
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} emailSale - 1 | 0
 * @property {string} tld - tld
 * @property {string} flowname - flow name (entri, manual)
 * @return {LogObject<connectDomainResultPageClickParams>} LogObject<connectDomainResultPageClickParams>
 */
export function connectDomainResultPageClick(params) {
    return { evid: 567, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyVideoClick' event (evid: 568)
 *
 * Event description: ConnectDomain > GoDaddy Video Click Play
 *
 * @param {connectDomainGoDaddyVideoClickParams} params - The parameters for this event
 * @property {string} method - dns
 * @property {number} step - [0,1,2,3,4,5]
 * @property {string} tutorialType - GoDaddy Video
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - [start/ play / next step / replay]
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyVideoClickParams>} LogObject<connectDomainGoDaddyVideoClickParams>
 */
export function connectDomainGoDaddyVideoClick(params) {
    return { evid: 568, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainCopyData' event (evid: 569)
 *
 * Event description: ConnectDomain > Copy Data
 *
 * @param {connectDomainCopyDataParams} params - The parameters for this event
 * @property {string} method - pointing/dns
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - [DNS / A Record / CNAME Record]
 * @property {boolean} isSuccess - deprecated
 * @property {string} subdomain - subdomain
 * @property {string} recordLabel - the specific record being copied
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainCopyDataParams>} LogObject<connectDomainCopyDataParams>
 */
export function connectDomainCopyData(params) {
    return { evid: 569, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingClickGetDomainFromWix' event (evid: 570)
 *
 * Event description: ConnectDomain > Onboarding Click Get Domain From Wix A_onboardingClickPurchaseDomainLink
 *
 * @param {connectDomainOnboardingClickGetDomainFromWixParams} params - The parameters for this event
 * @property {string} method - pointing/dns (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingClickGetDomainFromWixParams>} LogObject<connectDomainOnboardingClickGetDomainFromWixParams>
 */
export function connectDomainOnboardingClickGetDomainFromWix(params) {
    return { evid: 570, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingClickLearnMore' event (evid: 571)
 *
 * Event description: ConnectDomain > Onboarding Click Learn More
 *
 * @param {connectDomainOnboardingClickLearnMoreParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingClickLearnMoreParams>} LogObject<connectDomainOnboardingClickLearnMoreParams>
 */
export function connectDomainOnboardingClickLearnMore(params) {
    return { evid: 571, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyConfirmationPageClickImNotSureAndItSPopUp' event (evid: 572)
 *
 * Event description: ConnectDomain > GoDaddy Confirmation Page Click I'm Not Sure  / Click Ok in the POP UP / Click close the POP UP.
 *
 * @param {connectDomainGoDaddyConfirmationPageClickImNotSureAndItSPopUpParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - [open , ok , close]
 * @property {string} subdomain - subdomain
 * @property {string} registrar - Name of the Registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyConfirmationPageClickImNotSureAndItSPopUpParams>} LogObject<connectDomainGoDaddyConfirmationPageClickImNotSureAndItSPopUpParams>
 */
export function connectDomainGoDaddyConfirmationPageClickImNotSureAndItSPopUp(params) {
    return { evid: 572, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainSiteSelectorView' event (evid: 573)
 *
 * Event description: Entering the connect domain flow from account level when you have more than one premium site
 *
 * @param {connectDomainSiteSelectorViewParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid , can be null
 * @return {LogObject<connectDomainSiteSelectorViewParams>} LogObject<connectDomainSiteSelectorViewParams>
 */
export function connectDomainSiteSelectorView(params) {
    return { evid: 573, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfConnectDomainSiteSelectorClick' event (evid: 574)
 *
 * Event description: Entering the connect domain flow from account level when you have more than one premium site
 *
 * @param {copyOfConnectDomainSiteSelectorClickParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - [choose_site / unchoose_site / next / back / learn_more]
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid , can be null
 * @return {LogObject<copyOfConnectDomainSiteSelectorClickParams>} LogObject<copyOfConnectDomainSiteSelectorClickParams>
 */
export function copyOfConnectDomainSiteSelectorClick(params) {
    return { evid: 574, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainChangeDomainSubHierarchyFlow' event (evid: 575)
 *
 * Event description: A user changes a flow from domain to a subdomain (or vice versa)
 *
 * @param {connectDomainChangeDomainSubHierarchyFlowParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain. User changed flow to ...
 * @property {string} domain - can be null if user didn't enter a domain/subdomain name
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - connect a subdomain/connect a domain
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainChangeDomainSubHierarchyFlowParams>} LogObject<connectDomainChangeDomainSubHierarchyFlowParams>
 */
export function connectDomainChangeDomainSubHierarchyFlow(params) {
    return { evid: 575, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingLearnMoreAboutSubdomain' event (evid: 576)
 *
 * Event description: A user clicks on Learn More button (connect subdomain page)
 *
 * @param {connectDomainOnboardingLearnMoreAboutSubdomainParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - can be null if user didn't enter a domain/subdomain name
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingLearnMoreAboutSubdomainParams>} LogObject<connectDomainOnboardingLearnMoreAboutSubdomainParams>
 */
export function connectDomainOnboardingLearnMoreAboutSubdomain(params) {
    return { evid: 576, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainPopUpInteractions' event (evid: 577)
 *
 * Event description: A user interacts(cancel/confirm) with Pop-up banners.
 *
 * @param {connectDomainPopUpInteractionsParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - can be null if user didn't enter a domain/subdomain name
 * @property {string} result - connection status
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - cancel/confirm
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainPopUpInteractionsParams>} LogObject<connectDomainPopUpInteractionsParams>
 */
export function connectDomainPopUpInteractions(params) {
    return { evid: 577, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainSupportArticleClick' event (evid: 578)
 *
 * Event description: A user interacts with links to support articles.
 *
 * @param {connectDomainSupportArticleClickParams} params - The parameters for this event
 * @property {string} method - dns/pointing
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - can be null if user didn't enter a domain/subdomain name
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain part
 * @property {string} registrar - registrar
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} articleId - article Id
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainSupportArticleClickParams>} LogObject<connectDomainSupportArticleClickParams>
 */
export function connectDomainSupportArticleClick(params) {
    return { evid: 578, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainWixAnswersLoader' event (evid: 579)
 *
 * Event description: It tells us if the Wix Answers page was successfully loaded. (LOADING_SUCCEED, SHOULD_NOT_LOAD, LOADING_FAILED
 * )
 *
 * @param {connectDomainWixAnswersLoaderParams} params - The parameters for this event
 * @property {string} method - dns/pointing
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - can be null if user didn't enter a domain/subdomain name
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain part
 * @property {string} registrar - registrar
 * @property {string} status - LOADING_SUCCEED, SHOULD_NOT_LOAD, LOADING_FAILED
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainWixAnswersLoaderParams>} LogObject<connectDomainWixAnswersLoaderParams>
 */
export function connectDomainWixAnswersLoader(params) {
    return { evid: 579, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainAvailability' event (evid: 58)
 *
 * Event description: This event will show availability of the domain for Dealer Pop-Up in Editor (Save/Publish site).
 *
 * @param {domainAvailabilityParams} params - The parameters for this event
 * @property {string} domain - generated domain name
 * @property {GUID} uuid - uuid
 * @property {string} statusText - string true or false (dublication for status)
 * @property {string} user_agent - user_agent
 * @property {boolean} status - availability of the domain (true/false)
 * @property {GUID} msid - msid
 * @property {string} siteUrl - site url
 * @return {LogObject<domainAvailabilityParams>} LogObject<domainAvailabilityParams>
 */
export function domainAvailability(params) {
    return { evid: 58, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainFatalErrorPageView' event (evid: 580)
 *
 * Event description: Users see Fatal Error Page 'Looks something went wrong'.
 *
 * @param {connectDomainFatalErrorPageViewParams} params - The parameters for this event
 * @property {string} errorInfo - Javascript code for Devs
 * @property {GUID} userGuid - uuid
 * @property {string} screenResolution - screen resolution
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @property {string} previousStep - /search-domain, /confirm-domain, etc
 * @return {LogObject<connectDomainFatalErrorPageViewParams>} LogObject<connectDomainFatalErrorPageViewParams>
 */
export function connectDomainFatalErrorPageView(params) {
    return { evid: 580, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainUnassignedDomains' event (evid: 582)
 *
 * Event description: If a user has unassigned successfully connected domains we will show to him the list of them
 *
 * @param {connectDomainUnassignedDomainsParams} params - The parameters for this event
 * @property {string} voucher - true, false
 * @property {string} domain - domain names comma separated
 * @property {string} viewmode - .
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - true, false
 * @property {string} action - view | show | hide | choose_domain
 * @property {boolean} isSale - true, false
 * @return {LogObject<connectDomainUnassignedDomainsParams>} LogObject<connectDomainUnassignedDomainsParams>
 */
export function connectDomainUnassignedDomains(params) {
    return { evid: 582, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'supportChatInDomainFunnels' event (evid: 583)
 *
 * Event description: Support Chat appears in different funnels in domain flow, tool tip appears after chat in 5 seconds
 *
 * @param {supportChatInDomainFunnelsParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} place - connect_domain | domain_search | transfer_in
 * @property {string} type - chat | tooltip
 * @property {string} action - view | open | close | started_chat
 * @return {LogObject<supportChatInDomainFunnelsParams>} LogObject<supportChatInDomainFunnelsParams>
 */
export function supportChatInDomainFunnels(params) {
    return { evid: 583, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingBreadcrumbsClick' event (evid: 584)
 *
 * Event description: It fires when a user clicks on breadcrumbs.
 *
 * @param {connectDomainOnboardingBreadcrumbsClickParams} params - The parameters for this event
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {string} text - breadcrumbs text
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} place - onboarding | tutorial | etc
 * @property {GUID} msid - msid
 * @return {LogObject<connectDomainOnboardingBreadcrumbsClickParams>} LogObject<connectDomainOnboardingBreadcrumbsClickParams>
 */
export function connectDomainOnboardingBreadcrumbsClick(params) {
    return { evid: 584, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomainEmptyStateClickReadMor' event (evid: 585)
 *
 * Event description: Click Read More in the Connect Domain Empty State
 *
 * @param {connectDomainEmptyStateClickReadMorParams} params - The parameters for this event
 * @property {string} viewMode - accountLevel, siteLevel
 * @property {string} voucher - true, false
 * @property {string} totalUnassignedDomains - number of domains
 * @property {string} totalInactiveDomains - number of domains
 * @property {GUID} userGuid - uuid
 * @property {string} domains - list of all domains
 * @property {string} totalDomains - number of domains
 * @property {boolean} emptyState - true, false
 * @property {boolean} isPublished - true, false
 * @property {string} clickType - which article the user clicked
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} totalConnectedDomains - number of domains
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - true, false
 * @property {string} totalAssignedDomains - number of domains
 * @property {GUID} msid - msid, can be null
 * @property {boolean} isSale - true, false
 * @return {LogObject<connectDomainEmptyStateClickReadMorParams>} LogObject<connectDomainEmptyStateClickReadMorParams>
 */
export function connectDomainEmptyStateClickReadMor(params) {
    return { evid: 585, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sslManagerDomainListChanged' event (evid: 5851)
 *
 * Event description: Confirms that SSL manager successfully received domain to provide certificates for or to remove the certificate to
 *
 * @param {sslManagerDomainListChangedParams} params - The parameters for this event
 * @property {string} rootDomain - root domain, as recognized by SSL manager
 * @property {string} domain - Name of domain added or removed.
 * @property {GUID} uuid - uuid
 * @property {string} removalOrigin - system which initiated removal of domain
 * @property {boolean} requireWww - true means that SSL manager must include www. subdomain to certificates
 * @property {string} changeType - Added or Removed
 * @property {string} removalReason - why we removing it
 * @property {string} additionalInfo - Migrated from old SSL manager?
 * @property {GUID} msid - the site the domain is connected to at that time
 * @return {LogObject<sslManagerDomainListChangedParams>} LogObject<sslManagerDomainListChangedParams>
 */
export function sslManagerDomainListChanged(params) {
    return { evid: 5851, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sslManagerCertificateProvisionSuccess' event (evid: 5852)
 *
 * Event description: SSL Manager received new certificate from certificate authority, or already has one
 *
 * @param {sslManagerCertificateProvisionSuccessParams} params - The parameters for this event
 * @property {string} rootDomain - root domain, as recognized by SSL manager
 * @property {DateTime} notValidAfter - not_valid_after
 * @property {string} domain - domain added to SSL manager
 * @property {GUID} uuid - uuid
 * @property {DateTime} notValidBefore - notValidBefore
 * @property {boolean} alreadyHasCertificate - certificate already exists
 * @property {number} retryCount - retryCount
 * @property {string} additionalData
 * @property {string} stageType - INITIAL_CALL / RENEWAL
 * @property {GUID} msid - the site the domain is connected to at that time
 * @property {string} certificateIssuer - issuer of this certificate
 * @property {string} certificateSerialNumber - certificate_serial_number
 * @return {LogObject<sslManagerCertificateProvisionSuccessParams>} LogObject<sslManagerCertificateProvisionSuccessParams>
 */
export function sslManagerCertificateProvisionSuccess(params) {
    return { evid: 5852, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sslManagerCertificateProvisionFailure' event (evid: 5853)
 *
 * Event description: SSL Manager were not able to create certificate for given domain.
 *
 * @param {sslManagerCertificateProvisionFailureParams} params - The parameters for this event
 * @property {string} rootDomain - root domain, as recognized by SSL manager
 * @property {string} domain - domain added to SSL manager
 * @property {GUID} uuid - uuid
 * @property {number} retryCount - current retry count
 * @property {string} reason - what happened, why we were not able to get certificate.
 * @property {string} additionalErrorInfo - additional error info
 * @property {string} additionalInfo - migrated or not from old ssl manager
 * @property {string} stageType - INITIAL_CALL / RENEWAL
 * @property {GUID} msid - the site the domain is connected to at that time
 * @property {boolean} retryAgain - will we retry again
 * @return {LogObject<sslManagerCertificateProvisionFailureParams>} LogObject<sslManagerCertificateProvisionFailureParams>
 */
export function sslManagerCertificateProvisionFailure(params) {
    return { evid: 5853, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sslManagerCertificateProvisionFailureExtended' event (evid: 5857)
 *
 * Event description: SSL Manager were not able to create certificate for given domain. It will be triggered after every failed SSL with Provider name
 *
 * @param {sslManagerCertificateProvisionFailureExtendedParams} params - The parameters for this event
 * @property {string} rootDomain - root domain, as recognized by SSL manager
 * @property {string} domain - domain added to SSL manager
 * @property {GUID} uuid - uuid
 * @property {number} retryCount - current retry count
 * @property {string} reason - what happened, why we were not able to get certificate.
 * @property {string} additionalErrorInfo - additional error info
 * @property {string} additionalInfo - migrated or not from old ssl manager
 * @property {string} stageType - INITIAL_CALL / RENEWAL
 * @property {GUID} msid - the site the domain is connected to at that time
 * @property {string} certificateIssuer - issuer of this certificate
 * @property {boolean} retryAgain - will we retry again
 * @return {LogObject<sslManagerCertificateProvisionFailureExtendedParams>} LogObject<sslManagerCertificateProvisionFailureExtendedParams>
 */
export function sslManagerCertificateProvisionFailureExtended(params) {
    return { evid: 5857, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sslManagerRequestForSslCreation' event (evid: 5858)
 *
 * Event description: Event is triggered when we ask the SSL provider to create certificate (both in initial & renewal)
 *
 * @param {sslManagerRequestForSslCreationParams} params - The parameters for this event
 * @property {string} domain - domain added to SSL manager
 * @property {GUID} uuid - uuid
 * @property {string} certificateIssuer - issuer of this certificate
 * @return {LogObject<sslManagerRequestForSslCreationParams>} LogObject<sslManagerRequestForSslCreationParams>
 */
export function sslManagerRequestForSslCreation(params) {
    return { evid: 5858, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainConnectPopupDomainIsAssignedToAnotherWixAccount' event (evid: 586)
 *
 * Event description: Domain popup in concierge - domain is assigned to another wix account
 *
 * @param {domainConnectPopupDomainIsAssignedToAnotherWixAccountParams} params - The parameters for this event
 * @property {GUID} userGuid - uuid
 * @property {string} domain - domain, can be null
 * @property {string} uuid - uuid
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} action - view, close, learn_more
 * @return {LogObject<domainConnectPopupDomainIsAssignedToAnotherWixAccountParams>} LogObject<domainConnectPopupDomainIsAssignedToAnotherWixAccountParams>
 */
export function domainConnectPopupDomainIsAssignedToAnotherWixAccount(params) {
    return { evid: 586, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsHoverOnInfoSign' event (evid: 587)
 *
 * Event description: This event should be triggered when user hovers on info sign and sees a flying box.
 *
 * @param {myDomainsHoverOnInfoSignParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} text - transfer to wix, extend
 * @property {GUID} msid - msid
 * @property {string} action - view
 * @return {LogObject<myDomainsHoverOnInfoSignParams>} LogObject<myDomainsHoverOnInfoSignParams>
 */
export function myDomainsHoverOnInfoSign(params) {
    return { evid: 587, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'conciergeReAssignDomainModal' event (evid: 588)
 *
 * Event description: re-assign domain modal between sites
 *
 * @param {conciergeReAssignDomainModalParams} params - The parameters for this event
 * @property {string} viewMode - concierge , purchase
 * @property {string} voucher - true | false
 * @property {GUID} targetMsid - targeted msid
 * @property {string} uuid - uuid
 * @property {string} search_term - domain searched
 * @property {boolean} isPremiumSite - true / false
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {boolean} isAccountPremium - true / false
 * @property {boolean} isPremium - true / false
 * @property {boolean} isSiteEqualTargetedSite - true / false
 * @property {GUID} msid - msid
 * @return {LogObject<conciergeReAssignDomainModalParams>} LogObject<conciergeReAssignDomainModalParams>
 */
export function conciergeReAssignDomainModal(params) {
    return { evid: 588, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'entriEligibilityLittleHelper' event (evid: 589)
 *
 * Event description: little helper to indicate that the domain is eligible to be connected via Entri (for test purposes)
 *
 * @param {entriEligibilityLittleHelperParams} params - The parameters for this event
 * @property {string} entryPoint - i_own_this_domain, transfer_modal_click_connect
 * @property {string} domain - domain
 * @property {boolean} isEligible - is eligible to entri
 * @property {string} referralAdditionalInfo - original referral additional info
 * @property {GUID} msid - msid
 * @return {LogObject<entriEligibilityLittleHelperParams>} LogObject<entriEligibilityLittleHelperParams>
 */
export function entriEligibilityLittleHelper(params) {
    return { evid: 589, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'whoisPageView' event (evid: 590)
 *
 * Event description: Users saw WHOIS page
 *
 * @param {whoisPageViewParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @return {LogObject<whoisPageViewParams>} LogObject<whoisPageViewParams>
 */
export function whoisPageView(params) {
    return { evid: 590, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'conciergeWatchVideoCta' event (evid: 591)
 *
 * Event description: user click on "watch video" in concierge (best domain search tutorial)
 *
 * @param {conciergeWatchVideoCtaParams} params - The parameters for this event
 * @property {string} voucher - voucher
 * @property {string} uuid - uuid
 * @property {boolean} isPremiumSite - true, false
 * @property {number} totalPlayTime - time watch in seconds
 * @property {GUID} msid - site
 * @property {string} action - view, play, pause, close
 * @property {string} referraladditionalinfo - refereal
 * @return {LogObject<conciergeWatchVideoCtaParams>} LogObject<conciergeWatchVideoCtaParams>
 */
export function conciergeWatchVideoCta(params) {
    return { evid: 591, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'whoisClickSubmit' event (evid: 592)
 *
 * Event description: User clicked on submit button
 *
 * @param {whoisClickSubmitParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @return {LogObject<whoisClickSubmitParams>} LogObject<whoisClickSubmitParams>
 */
export function whoisClickSubmit(params) {
    return { evid: 592, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'whoisClickSubmitResult' event (evid: 593)
 *
 * Event description: Result after Submit click
 *
 * @param {whoisClickSubmitResultParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {string} result - success/failure
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {string} resultCode - server results
 * @return {LogObject<whoisClickSubmitResultParams>} LogObject<whoisClickSubmitResultParams>
 */
export function whoisClickSubmitResult(params) {
    return { evid: 593, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainsConciergeVideoPopupActionsBestDomainSearch' event (evid: 594)
 *
 * Event description: Best domain search video actions (in Concierge)
 *
 * @param {domainsConciergeVideoPopupActionsBestDomainSearchParams} params - The parameters for this event
 * @property {string} voucher - true , false
 * @property {string} uuid - uuid
 * @property {number} fractionWatched - time watched / video duration
 * @property {string} referralAdditionalInfo - concierge
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {string} action - view, play, pause, close_popup
 * @return {LogObject<domainsConciergeVideoPopupActionsBestDomainSearchParams>} LogObject<domainsConciergeVideoPopupActionsBestDomainSearchParams>
 */
export function domainsConciergeVideoPopupActionsBestDomainSearch(params) {
    return { evid: 594, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainsCtas' event (evid: 595)
 *
 * Event description: clicks & views in Domains pages
 *
 * @param {domainsCtasParams} params - The parameters for this event
 * @property {string} viewMode - account level, site level
 * @property {string} voucher - true, false
 * @property {string} conciergeStatus - search results error (only from concierge)
 * @property {string} domain - domain
 * @property {string} uuid - uuid
 * @property {string} clickType - click type
 * @property {string} status - domain status
 * @property {boolean} isPremiumSite - true, false
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - site
 * @return {LogObject<domainsCtasParams>} LogObject<domainsCtasParams>
 */
export function domainsCtas(params) {
    return { evid: 595, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'conciergeFonzyResellerView' event (evid: 596)
 *
 * Event description: User viewed Fonzy page (Concierge for resellers)
 *
 * @param {conciergeFonzyResellerViewParams} params - The parameters for this event
 * @property {number} accountNumOfPropagatedDomains - account level
 * @property {string} voucher - true , false
 * @property {number} siteNumOfPropagatedDomains - site level
 * @property {string} intent - connect domain
 * @property {string} referralAdditionalInfo - domain_connect_domain , buy_a_domain , connect_domain_you_already_own , domains-item
 * @property {string} pageType - reseller
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @return {LogObject<conciergeFonzyResellerViewParams>} LogObject<conciergeFonzyResellerViewParams>
 */
export function conciergeFonzyResellerView(params) {
    return { evid: 596, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'conciergeFonzyResellerAction' event (evid: 597)
 *
 * Event description: actions in Fonzy page (Concierge for resellers)
 *
 * @param {conciergeFonzyResellerActionParams} params - The parameters for this event
 * @property {string} conciergeStatus - concierge status
 * @property {string} errorInfo - error (if applicable)
 * @property {string} domain - domain
 * @property {string} availabilityStatus - status of domain
 * @property {string} connectionStatus - domain connection status
 * @property {string} pageType - reseller
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {string} action - lets_go
 * @return {LogObject<conciergeFonzyResellerActionParams>} LogObject<conciergeFonzyResellerActionParams>
 */
export function conciergeFonzyResellerAction(params) {
    return { evid: 597, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'conciergeFonzyResellerModal' event (evid: 598)
 *
 * Event description: modal & actions in Fonzy page (Concierge for resellers)
 *
 * @param {conciergeFonzyResellerModalParams} params - The parameters for this event
 * @property {string} modalType - modal type
 * @property {string} domain - domain
 * @property {string} pageType - reseller
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {string} action - action type
 * @return {LogObject<conciergeFonzyResellerModalParams>} LogObject<conciergeFonzyResellerModalParams>
 */
export function conciergeFonzyResellerModal(params) {
    return { evid: 598, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageToggleOnOffInvoiceDetails' event (evid: 599)
 *
 * Event description: client  event for new button - toggle on/off of invoice details (part of B version of new lean checkout)
 *
 * @param {checkoutPageToggleOnOffInvoiceDetailsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - the same as eventAggregator
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - initiator_name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {string} toggleStatus - Toggle on or off
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPageToggleOnOffInvoiceDetailsParams>} LogObject<checkoutPageToggleOnOffInvoiceDetailsParams>
 */
export function checkoutPageToggleOnOffInvoiceDetails(params) {
    return { evid: 599, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aNoCanPopup1' event (evid: 6)
 *
 * Event description: in the pop up, user choose X or back or keep my plan - only in old flow
 *
 * @param {aNoCanPopup1Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aNoCanPopup1Params>} LogObject<aNoCanPopup1Params>
 */
export function aNoCanPopup1(params) {
    return { evid: 6, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainSuggestionsApi' event (evid: 60)
 *
 * Event description: Companies send to domain service different parameters (sitename, facebook, twitter, other data) and as result, service will return to them domain recommendations.
 *
 * @param {domainSuggestionsApiParams} params - The parameters for this event
 * @property {string} requestCaller - company name that used our service
 * @property {string} domainSuggestions - suggested domains separated by comma|json
 * @property {GUID} uuid - uuid
 * @property {string} user_agent - user_agent
 * @property {GUID} msid - msid, can be null
 * @property {string} parameters - input parameters in json format
 * @return {LogObject<domainSuggestionsApiParams>} LogObject<domainSuggestionsApiParams>
 */
export function domainSuggestionsApi(params) {
    return { evid: 60, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnPackagePickerView' event (evid: 600)
 *
 * Event description: Google Subscription Add-on > Package picker > view
 *
 * @param {googleSubscriptionAddOnPackagePickerViewParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} isNewPurchase - is new purchase or upgarde/change or existing add-on
 * @property {boolean} IsSaleBanner - Does a sale banner appear?
 * @property {boolean} IsGeminiEarlyAccessPopup - Is gemini early access pop-up view
 * @property {string} PopupType - Pop up type
 *
 * @property {string} SaleType - sale_type
 * @return {LogObject<googleSubscriptionAddOnPackagePickerViewParams>} LogObject<googleSubscriptionAddOnPackagePickerViewParams>
 */
export function googleSubscriptionAddOnPackagePickerView(params) {
    return { evid: 600, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnPackagePickerLoadSrc17Evid6001' event (evid: 6001)
 *
 * Event description: Google Subscription Add-on > Package picker > Start Load
 *
 * @param {googleSubscriptionAddOnPackagePickerLoadSrc17Evid6001Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} isNewPurchase - is new purchase or upgarde/change or existing add-on
 * @property {boolean} IsSaleBanner - Does a sale banner appear?
 * @property {boolean} IsGeminiEarlyAccessPopup - Is gemini early access pop-up view
 * @property {string} PopupType - Pop up type
 *
 * @property {string} SaleType - sale_type
 * @return {LogObject<googleSubscriptionAddOnPackagePickerLoadSrc17Evid6001Params>} LogObject<googleSubscriptionAddOnPackagePickerLoadSrc17Evid6001Params>
 */
export function googleSubscriptionAddOnPackagePickerLoadSrc17Evid6001(params) {
    return { evid: 6001, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnAddOnModalViewSrc17Evid6002' event (evid: 6002)
 *
 * Event description: Google Subscription Add-on > Add-on modal view
 *
 * @param {googleSubscriptionAddOnAddOnModalViewSrc17Evid6002Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} Action - View or click on one of the CTAs
 * @property {string} ViewMode - Site level or account level
 * @property {string} ModalType - the type of the modal: renew, set up, accept TOS, ect.
 * @property {GUID} SubscriptionId - subscription_id
 * @property {GUID} GwsSubscriptionId - gws_subscription_id
 * @return {LogObject<googleSubscriptionAddOnAddOnModalViewSrc17Evid6002Params>} LogObject<googleSubscriptionAddOnAddOnModalViewSrc17Evid6002Params>
 */
export function googleSubscriptionAddOnAddOnModalViewSrc17Evid6002(params) {
    return { evid: 6002, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartTpaPurchaseSuccess' event (evid: 601)
 *
 * Event description: R_StartTpaPurchaseSuccess
 *
 * @param {rStartTpaPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartTpaPurchaseSuccessParams>} LogObject<rStartTpaPurchaseSuccessParams>
 */
export function rStartTpaPurchaseSuccess(params) {
    return { evid: 601, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartTpaPurchaseError' event (evid: 602)
 *
 * Event description: don't move me to store. I will die with wix-war. purchase page is not loading (server)
 *
 * @param {rStartTpaPurchaseErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartTpaPurchaseErrorParams>} LogObject<rStartTpaPurchaseErrorParams>
 */
export function rStartTpaPurchaseError(params) {
    return { evid: 602, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartTpaPurchaseException' event (evid: 603)
 *
 * Event description: don't move me to store. I will die with wix-war. purchase page is not loading (server)
 *
 * @param {rStartTpaPurchaseExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartTpaPurchaseExceptionParams>} LogObject<rStartTpaPurchaseExceptionParams>
 */
export function rStartTpaPurchaseException(params) {
    return { evid: 603, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTpaPurchasePage' event (evid: 604)
 *
 * Event description: R_TpaPurchasePage - it think it's error. need to check
 *
 * @param {premiumTpaPurchasePageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<premiumTpaPurchasePageParams>} LogObject<premiumTpaPurchasePageParams>
 */
export function premiumTpaPurchasePage(params) {
    return { evid: 604, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaPurchaseError' event (evid: 605)
 *
 * Event description: R_TpaPurchaseError
 *
 * @param {rTpaPurchaseErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaPurchaseErrorParams>} LogObject<rTpaPurchaseErrorParams>
 */
export function rTpaPurchaseError(params) {
    return { evid: 605, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaPurchaseException' event (evid: 606)
 *
 * Event description: R_TpaPurchaseException
 *
 * @param {rTpaPurchaseExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaPurchaseExceptionParams>} LogObject<rTpaPurchaseExceptionParams>
 */
export function rTpaPurchaseException(params) {
    return { evid: 606, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTpaPurchaseSuccess' event (evid: 607)
 *
 * Event description: R_TpaPurchaseSuccess id_in_app & tpa_sku_guid data since 22.2.2018
 *
 * @param {premiumTpaPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - id_in_app
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<premiumTpaPurchaseSuccessParams>} LogObject<premiumTpaPurchaseSuccessParams>
 */
export function premiumTpaPurchaseSuccess(params) {
    return { evid: 607, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vTpaPurchaseSuccess' event (evid: 609)
 *
 * Event description: V_TpaPurchaseSuccess
 *
 * @param {vTpaPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vTpaPurchaseSuccessParams>} LogObject<vTpaPurchaseSuccessParams>
 */
export function vTpaPurchaseSuccess(params) {
    return { evid: 609, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'new9000' event (evid: 61)
 *
 * Event description: Domain status which users see on My Domain Page. It fires after event 40 and when we receive information from back/front end.
 *
 * @param {new9000Params} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} registrar - name of the domain registrar
 * @property {string} status - Domain status info. 'null' also means that a domain is managed by WIX (connected, not assigned, etc) or we don't have any message there (like a connected domain successfully connected)
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {string} domainLevel - level of the domain (primary / secondary). It also returns value if a domain not assigned to a site on the account level.
 * @property {GUID} msid - msid,  if a user looks on the domain from the account level msid will be null
 * @return {LogObject<new9000Params>} LogObject<new9000Params>
 */
export function new9000(params) {
    return { evid: 61, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaCancelPackageExecutionSuccess' event (evid: 611)
 *
 * Event description: R_TpaCancelPackageExecutionSuccess
 *
 * @param {rTpaCancelPackageExecutionSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaCancelPackageExecutionSuccessParams>} LogObject<rTpaCancelPackageExecutionSuccessParams>
 */
export function rTpaCancelPackageExecutionSuccess(params) {
    return { evid: 611, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rCancelTpaPackageRequestException' event (evid: 612)
 *
 * Event description: R_CancelTpaPackageRequestException
 *
 * @param {rCancelTpaPackageRequestExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rCancelTpaPackageRequestExceptionParams>} LogObject<rCancelTpaPackageRequestExceptionParams>
 */
export function rCancelTpaPackageRequestException(params) {
    return { evid: 612, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rCancelTpaPackageRequestError' event (evid: 613)
 *
 * Event description: R_CancelTpaPackageRequestError
 *
 * @param {rCancelTpaPackageRequestErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rCancelTpaPackageRequestErrorParams>} LogObject<rCancelTpaPackageRequestErrorParams>
 */
export function rCancelTpaPackageRequestError(params) {
    return { evid: 613, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaPackageUpdateAutoRenewSuccess' event (evid: 614)
 *
 * Event description: R_TpaPackageUpdateAutoRenewSuccess
 *
 * @param {rTpaPackageUpdateAutoRenewSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaPackageUpdateAutoRenewSuccessParams>} LogObject<rTpaPackageUpdateAutoRenewSuccessParams>
 */
export function rTpaPackageUpdateAutoRenewSuccess(params) {
    return { evid: 614, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaPackageUpdateAutoRenewError' event (evid: 615)
 *
 * Event description: R_TpaPackageUpdateAutoRenewError
 *
 * @param {rTpaPackageUpdateAutoRenewErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaPackageUpdateAutoRenewErrorParams>} LogObject<rTpaPackageUpdateAutoRenewErrorParams>
 */
export function rTpaPackageUpdateAutoRenewError(params) {
    return { evid: 615, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaPackageUpdateAutoRenewException' event (evid: 616)
 *
 * Event description: R_TpaPackageUpdateAutoRenewException
 *
 * @param {rTpaPackageUpdateAutoRenewExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaPackageUpdateAutoRenewExceptionParams>} LogObject<rTpaPackageUpdateAutoRenewExceptionParams>
 */
export function rTpaPackageUpdateAutoRenewException(params) {
    return { evid: 616, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaUpdatePaymentMethodSuccess' event (evid: 617)
 *
 * Event description: R_TpaUpdatePaymentMethodSuccess
 *
 * @param {rTpaUpdatePaymentMethodSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaUpdatePaymentMethodSuccessParams>} LogObject<rTpaUpdatePaymentMethodSuccessParams>
 */
export function rTpaUpdatePaymentMethodSuccess(params) {
    return { evid: 617, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaUpdatePaymentMethodError' event (evid: 618)
 *
 * Event description: R_TpaUpdatePaymentMethodError
 *
 * @param {rTpaUpdatePaymentMethodErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaUpdatePaymentMethodErrorParams>} LogObject<rTpaUpdatePaymentMethodErrorParams>
 */
export function rTpaUpdatePaymentMethodError(params) {
    return { evid: 618, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaUpdatePaymentMethodException' event (evid: 619)
 *
 * Event description: R_TpaUpdatePaymentMethodException
 *
 * @param {rTpaUpdatePaymentMethodExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaUpdatePaymentMethodExceptionParams>} LogObject<rTpaUpdatePaymentMethodExceptionParams>
 */
export function rTpaUpdatePaymentMethodException(params) {
    return { evid: 619, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'new9001' event (evid: 62)
 *
 * Event description: 1. When a user clicks on "Edit DNS" we will show him the Warning pop-up.
 * 2. When a user change/edit or delete A +/or CNAME records and click "Save DNS" we will show Confirm pop-up.
 *
 * @param {new9001Params} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {GUID} uuid - user id
 * @property {string} clickType - open| cancel | confirm | learn more
 * @property {string} popup_type - editing your dns records | save dns record changes
 * @property {string} status - domain status
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null if a user look on domain from account level
 * @return {LogObject<new9001Params>} LogObject<new9001Params>
 */
export function new9001(params) {
    return { evid: 62, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaClickOnCancel' event (evid: 620)
 *
 * Event description: A_TpaClickOnCancel
 *
 * @param {aTpaClickOnCancelParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {GUID} tpaSkuId - tpa_sku_guid
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaClickOnCancelParams>} LogObject<aTpaClickOnCancelParams>
 */
export function aTpaClickOnCancel(params) {
    return { evid: 620, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'msDeliveryChangeStatus' event (evid: 6200)
 *
 * Event description: Microsoft 365 change Delivery Status
 *
 * @param {msDeliveryChangeStatusParams} params - The parameters for this event
 * @property {string} newDeliveryStatus - Current Delivery Status
 * @property {GUID} uuid - uuid
 * @property {GUID} userGuid - uuid
 * @property {string} domainName - Domain Related to the Account
 * @property {GUID} packageGuid - PackageGuid
 * @return {LogObject<msDeliveryChangeStatusParams>} LogObject<msDeliveryChangeStatusParams>
 */
export function msDeliveryChangeStatus(params) {
    return { evid: 6200, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'msDeliveryException' event (evid: 6201)
 *
 * Event description: fatal error
 *
 * @param {msDeliveryExceptionParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {GUID} sessionId - session id
 * @property {string} message - message
 * @return {LogObject<msDeliveryExceptionParams>} LogObject<msDeliveryExceptionParams>
 */
export function msDeliveryException(params) {
    return { evid: 6201, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'msDeliveryFailure' event (evid: 6202)
 *
 * Event description: Microsoft 365 change Delivery Status
 *
 * @param {msDeliveryFailureParams} params - The parameters for this event
 * @property {string} currentDeliveryStatus - Current Delivery Status
 * @property {GUID} uuid - uuid
 * @property {GUID} userGuid - uuid
 * @property {string} domainName - Domain Related to the Account
 * @property {GUID} packageGuid - PackageGuid
 * @return {LogObject<msDeliveryFailureParams>} LogObject<msDeliveryFailureParams>
 */
export function msDeliveryFailure(params) {
    return { evid: 6202, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaCancelPackageImmediateRequestSuccess' event (evid: 621)
 *
 * Event description: R_TpaCancelPackageImmediateRequestSuccess
 *
 * @param {rTpaCancelPackageImmediateRequestSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {GUID} appstoreId - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} paymentCycle - 3, 6
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {number} cancelReason - 110, 90
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaCancelPackageImmediateRequestSuccessParams>} LogObject<rTpaCancelPackageImmediateRequestSuccessParams>
 */
export function rTpaCancelPackageImmediateRequestSuccess(params) {
    return { evid: 621, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vTpapurchaseFatalErrorSrc17Evid6210' event (evid: 6210)
 *
 * Event description: V_TPAPurchaseFatalError.
 *
 * @param {vTpapurchaseFatalErrorSrc17Evid6210Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vTpapurchaseFatalErrorSrc17Evid6210Params>} LogObject<vTpapurchaseFatalErrorSrc17Evid6210Params>
 */
export function vTpapurchaseFatalErrorSrc17Evid6210(params) {
    return { evid: 6210, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTpaCancel' event (evid: 622)
 *
 * Event description: R_TpaCancelPackageRenewRequestSuccess
 *
 * @param {premiumTpaCancelParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<premiumTpaCancelParams>} LogObject<premiumTpaCancelParams>
 */
export function premiumTpaCancel(params) {
    return { evid: 622, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'msCancelPackage' event (evid: 6220)
 *
 * Event description: Microsoft 365 Cancel Package
 *
 * @param {msCancelPackageParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {GUID} userGuid - uuid
 * @property {string} domainName - Domain Related to the Account
 * @property {GUID} packageGuid - PackageGuid
 * @property {number} cancellationCode - cancellation Code
 * @return {LogObject<msCancelPackageParams>} LogObject<msCancelPackageParams>
 */
export function msCancelPackage(params) {
    return { evid: 6220, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsOrderPageTpaPurchaseBusinessError' event (evid: 623)
 *
 * Event description: R_SbsOrderPageTpaPurchaseBusinessError
 *
 * @param {rSbsOrderPageTpaPurchaseBusinessErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsOrderPageTpaPurchaseBusinessErrorParams>} LogObject<rSbsOrderPageTpaPurchaseBusinessErrorParams>
 */
export function rSbsOrderPageTpaPurchaseBusinessError(params) {
    return { evid: 623, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsOrderPageTpaPurchaseFatalError' event (evid: 624)
 *
 * Event description: R_SbsOrderPageTpaPurchaseFatalError
 *
 * @param {rSbsOrderPageTpaPurchaseFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsOrderPageTpaPurchaseFatalErrorParams>} LogObject<rSbsOrderPageTpaPurchaseFatalErrorParams>
 */
export function rSbsOrderPageTpaPurchaseFatalError(params) {
    return { evid: 624, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aSbsTpaPurchaseBuyButtonPressed' event (evid: 625)
 *
 * Event description: A_SbsTpaPurchaseBuyButtonPressed
 *
 * @param {aSbsTpaPurchaseBuyButtonPressedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aSbsTpaPurchaseBuyButtonPressedParams>} LogObject<aSbsTpaPurchaseBuyButtonPressedParams>
 */
export function aSbsTpaPurchaseBuyButtonPressed(params) {
    return { evid: 625, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redemptionApiResult' event (evid: 626)
 *
 * Event description: Store the redeem action of domain - success, pending, failed
 *
 * @param {redemptionApiResultParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} uuid - user guid
 * @property {boolean} hasApi - true, false
 * @property {string} type - success, pending, redeem_failure_reason
 * @return {LogObject<redemptionApiResultParams>} LogObject<redemptionApiResultParams>
 */
export function redemptionApiResult(params) {
    return { evid: 626, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaCartPurchaseSetContractSuccess' event (evid: 627)
 *
 * Event description: R_TpaCartPurchaseSetContractSuccess
 *
 * @param {rTpaCartPurchaseSetContractSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaCartPurchaseSetContractSuccessParams>} LogObject<rTpaCartPurchaseSetContractSuccessParams>
 */
export function rTpaCartPurchaseSetContractSuccess(params) {
    return { evid: 627, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaCartPurchaseSetContractError' event (evid: 628)
 *
 * Event description: R_TpaCartPurchaseSetContractError
 *
 * @param {rTpaCartPurchaseSetContractErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaCartPurchaseSetContractErrorParams>} LogObject<rTpaCartPurchaseSetContractErrorParams>
 */
export function rTpaCartPurchaseSetContractError(params) {
    return { evid: 628, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaCartPurchaseSetContractException' event (evid: 629)
 *
 * Event description: R_TpaCartPurchaseSetContractException
 *
 * @param {rTpaCartPurchaseSetContractExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaCartPurchaseSetContractExceptionParams>} LogObject<rTpaCartPurchaseSetContractExceptionParams>
 */
export function rTpaCartPurchaseSetContractException(params) {
    return { evid: 629, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaCartStartSuccess' event (evid: 630)
 *
 * Event description: R_TpaCartStartSuccess
 *
 * @param {rTpaCartStartSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaCartStartSuccessParams>} LogObject<rTpaCartStartSuccessParams>
 */
export function rTpaCartStartSuccess(params) {
    return { evid: 630, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'msMailboxPickerLoad' event (evid: 6300)
 *
 * Event description: Microsoft 365 Mailbox Picker Load
 *
 * @param {msMailboxPickerLoadParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} referral_additional_info - referral_additional_info
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} domainName - Domain Related to the Account
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} is_new_purchase - is_new_purchase
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<msMailboxPickerLoadParams>} LogObject<msMailboxPickerLoadParams>
 */
export function msMailboxPickerLoad(params) {
    return { evid: 6300, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'msMailboxPaymentPageLoad' event (evid: 6301)
 *
 * Event description: Microsoft 365 Mailbox Payment Page Load
 *
 * @param {msMailboxPaymentPageLoadParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {number} email_sku_id - 1=Monthly 2= Yearly
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} domainName - Domain Related to the Account
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {number} cycle_id - Yearly 6 Monthly 3
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<msMailboxPaymentPageLoadParams>} LogObject<msMailboxPaymentPageLoadParams>
 */
export function msMailboxPaymentPageLoad(params) {
    return { evid: 6301, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaCartStartError' event (evid: 631)
 *
 * Event description: R_TpaCartStartError
 *
 * @param {rTpaCartStartErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaCartStartErrorParams>} LogObject<rTpaCartStartErrorParams>
 */
export function rTpaCartStartError(params) {
    return { evid: 631, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaCartStartException' event (evid: 632)
 *
 * Event description: R_TpaCartStartException
 *
 * @param {rTpaCartStartExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaCartStartExceptionParams>} LogObject<rTpaCartStartExceptionParams>
 */
export function rTpaCartStartException(params) {
    return { evid: 632, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaCartPurchaseSuccessDataError' event (evid: 633)
 *
 * Event description: R_TpaCartPurchaseSuccessDataError
 *
 * @param {rTpaCartPurchaseSuccessDataErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaCartPurchaseSuccessDataErrorParams>} LogObject<rTpaCartPurchaseSuccessDataErrorParams>
 */
export function rTpaCartPurchaseSuccessDataError(params) {
    return { evid: 633, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaCartPurchaseSuccessDataException' event (evid: 634)
 *
 * Event description: R_TpaCartPurchaseSuccessDataException
 *
 * @param {rTpaCartPurchaseSuccessDataExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaCartPurchaseSuccessDataExceptionParams>} LogObject<rTpaCartPurchaseSuccessDataExceptionParams>
 */
export function rTpaCartPurchaseSuccessDataException(params) {
    return { evid: 634, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rTpaCartPurchaseSuccessDataSuccess' event (evid: 635)
 *
 * Event description: R_TpaCartPurchaseSuccessDataSuccess
 *
 * @param {rTpaCartPurchaseSuccessDataSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rTpaCartPurchaseSuccessDataSuccessParams>} LogObject<rTpaCartPurchaseSuccessDataSuccessParams>
 */
export function rTpaCartPurchaseSuccessDataSuccess(params) {
    return { evid: 635, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redeemDomainSuccessPageView' event (evid: 636)
 *
 * Event description: Redeem page after trying to redeem your domain
 *
 * @param {redeemDomainSuccessPageViewParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} uuid - user guid
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - redeem_success
 * @return {LogObject<redeemDomainSuccessPageViewParams>} LogObject<redeemDomainSuccessPageViewParams>
 */
export function redeemDomainSuccessPageView(params) {
    return { evid: 636, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsToastShown' event (evid: 637)
 *
 * Event description: MyDomains > toast shown (Success, payment success, failed, etc.)
 *
 * @param {myDomainsToastShownParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} uuid - user guid
 * @property {string} type - domain_redeem_payment_success
 * @return {LogObject<myDomainsToastShownParams>} LogObject<myDomainsToastShownParams>
 */
export function myDomainsToastShown(params) {
    return { evid: 637, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redeemDomainPageView' event (evid: 638)
 *
 * Event description: Redeem page after trying to redeem your domain
 *
 * @param {redeemDomainPageViewParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} uuid - user guid
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - domain_already_active, redeem_in_process, redeem_temporary_fail, redeem_failed
 * @return {LogObject<redeemDomainPageViewParams>} LogObject<redeemDomainPageViewParams>
 */
export function redeemDomainPageView(params) {
    return { evid: 638, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redeemDomainPageCta' event (evid: 639)
 *
 * Event description: CTA click in Redeem page after trying to redeem your domain
 *
 * @param {redeemDomainPageCtaParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} uuid - user guid
 * @property {string} clickType - go_to_my_domains, contact_customer_care
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - domain_already_active, redeem_in_process, redeem_temporary_fail, redeem_failed
 * @return {LogObject<redeemDomainPageCtaParams>} LogObject<redeemDomainPageCtaParams>
 */
export function redeemDomainPageCta(params) {
    return { evid: 639, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyNsRecords' event (evid: 64)
 *
 * Event description: Copy NS records from tutorial widget
 *
 * @param {copyNsRecordsParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {boolean} isSuccess - success for Copy NS records
 * @property {string} place - domain_level
 * @return {LogObject<copyNsRecordsParams>} LogObject<copyNsRecordsParams>
 */
export function copyNsRecords(params) {
    return { evid: 64, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainsPixelCheck' event (evid: 640)
 *
 * Event description: We check if a user can access his domain through the Internet.
 *
 * @param {domainsPixelCheckParams} params - The parameters for this event
 * @property {boolean} success - true/false
 * @property {string} domain - domain name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} details - ONE_OR_BOTH_NOT_RESOLVING |ALL_RESOLVING
 * @property {string} place - connect_domain_flow/domain_management
 * @property {GUID} msid - msid of the site that we check
 * @return {LogObject<domainsPixelCheckParams>} LogObject<domainsPixelCheckParams>
 */
export function domainsPixelCheck(params) {
    return { evid: 640, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageDomainsRedemptionPopUp' event (evid: 641)
 *
 * Event description: Redemption Pop-up for Unpaid .com.br, .mx, .me domains in the Last 4-3 Days Prior to Expiry. We don't send this event if a user clicks on 'close' icon (technical restriction).
 *
 * @param {manageDomainsRedemptionPopUpParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {string} popup_type - redemption_pop_up
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {GUID} msid - msid
 * @property {string} action - view/close/cancel/learn_how
 * @return {LogObject<manageDomainsRedemptionPopUpParams>} LogObject<manageDomainsRedemptionPopUpParams>
 */
export function manageDomainsRedemptionPopUp(params) {
    return { evid: 641, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redeemDomainSuccessPageCta' event (evid: 642)
 *
 * Event description: CTA click in Redeem page after trying to redeem your domain
 *
 * @param {redeemDomainSuccessPageCtaParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} uuid - user guid
 * @property {string} clickType - go_to_my_domains
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - redeem_success
 * @return {LogObject<redeemDomainSuccessPageCtaParams>} LogObject<redeemDomainSuccessPageCtaParams>
 */
export function redeemDomainSuccessPageCta(params) {
    return { evid: 642, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redeemDomainSuccessPageViewNew' event (evid: 643)
 *
 * Event description: Redeem page after trying to redeem your domain (new)
 *
 * @param {redeemDomainSuccessPageViewNewParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} packagePickerType - package_picker_type
 * @property {string} domain - domain name
 * @property {GUID} uuid - user guid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - redeem_success
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<redeemDomainSuccessPageViewNewParams>} LogObject<redeemDomainSuccessPageViewNewParams>
 */
export function redeemDomainSuccessPageViewNew(params) {
    return { evid: 643, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redeemDomainSuccessPageCtaNew' event (evid: 644)
 *
 * Event description: CTA click in Redeem page after trying to redeem your domain (new)
 *
 * @param {redeemDomainSuccessPageCtaNewParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {GUID} uuid - user guid
 * @property {string} clickType - go_to_my_domains
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - redeem_success
 * @return {LogObject<redeemDomainSuccessPageCtaNewParams>} LogObject<redeemDomainSuccessPageCtaNewParams>
 */
export function redeemDomainSuccessPageCtaNew(params) {
    return { evid: 644, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'redeemDomainSuccessPageViewNew1' event (evid: 645)
 *
 * Event description: Redeem page after trying to redeem your domain (new1)
 *
 * @param {redeemDomainSuccessPageViewNew1Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - redeem_success
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<redeemDomainSuccessPageViewNew1Params>} LogObject<redeemDomainSuccessPageViewNew1Params>
 */
export function redeemDomainSuccessPageViewNew1(params) {
    return { evid: 645, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bundlePurchaseViewSuccessPage' event (evid: 646)
 *
 * Event description: Bundle Plan purchase success page - client  (when plan is purchased alone, evid 17:147 is triggered)
 *
 * @param {bundlePurchaseViewSuccessPageParams} params - The parameters for this event
 * @property {string} siteTypeName - .
 * @property {string} packagePickerType - .
 * @property {string} voucher - true/false
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - .
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - .
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} flow - express_checkout
 * @property {string} pagename - .
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - product_id
 * @property {string} pageType - default success page / connect domain success page
 * @property {Url} referer - referral
 * @property {string} productGuid - Product Guid
 * @property {GUID} msid - msid
 * @property {number} referralType - .
 * @property {GUID} siteGuid - site_id
 * @property {string} product - bundle_domain_plan
 * @property {GUID} purchaseFlowIdentifier - .
 * @property {string} abTesting - .
 * @return {LogObject<bundlePurchaseViewSuccessPageParams>} LogObject<bundlePurchaseViewSuccessPageParams>
 */
export function bundlePurchaseViewSuccessPage(params) {
    return { evid: 646, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bundlePurchaseSuccessPageClick' event (evid: 647)
 *
 * Event description: CTAs click on bundle plan purchase success page
 *
 * @param {bundlePurchaseSuccessPageClickParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - true/false
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - buy_mailbox , show_summary, go_to_dashboard
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} flow - express_checkout
 * @property {string} pagename - abTesting1
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - product_id
 * @property {string} pageType - default success page / connect domain success page
 * @property {Url} referer - referral
 * @property {string} productGuid - Product Guid
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} product - bundle_domain_plan
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting1
 * @return {LogObject<bundlePurchaseSuccessPageClickParams>} LogObject<bundlePurchaseSuccessPageClickParams>
 */
export function bundlePurchaseSuccessPageClick(params) {
    return { evid: 647, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnPackagePickerHover' event (evid: 648)
 *
 * Event description: Google Subscription Add-on > Package picker > hover
 *
 * @param {googleSubscriptionAddOnPackagePickerHoverParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} isNewPurchase - is new purchase or upgarde/change ot existing add-on
 * @property {string} feature - on which feature user hovered
 * @return {LogObject<googleSubscriptionAddOnPackagePickerHoverParams>} LogObject<googleSubscriptionAddOnPackagePickerHoverParams>
 */
export function googleSubscriptionAddOnPackagePickerHover(params) {
    return { evid: 648, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnPurchaseSuccessPage' event (evid: 649)
 *
 * Event description: Google Subscription Add-on > Purchase success page
 *
 * @param {googleSubscriptionAddOnPurchaseSuccessPageParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} isNewPurchase - is new purchase or upgarde/change ot existing add-on
 * @property {string} action - view or click on Set Up at Google, Learn how to set up, Show summary, Google Voice
 * @property {GUID} SubscriptionGuid - subscription_guid
 * @property {boolean} is_sale - is_sale
 * @return {LogObject<googleSubscriptionAddOnPurchaseSuccessPageParams>} LogObject<googleSubscriptionAddOnPurchaseSuccessPageParams>
 */
export function googleSubscriptionAddOnPurchaseSuccessPage(params) {
    return { evid: 649, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnPurchaseSuccessPageCopySrc17Evid6491' event (evid: 6491)
 *
 * Event description: Google Subscription Add-on > Add-on Purchase Success
 *
 * @param {googleSubscriptionAddOnPurchaseSuccessPageCopySrc17Evid6491Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} isNewPurchase - is new purchase or upgarde/change ot existing add-on
 * @return {LogObject<googleSubscriptionAddOnPurchaseSuccessPageCopySrc17Evid6491Params>} LogObject<googleSubscriptionAddOnPurchaseSuccessPageCopySrc17Evid6491Params>
 */
export function googleSubscriptionAddOnPurchaseSuccessPageCopySrc17Evid6491(params) {
    return { evid: 6491, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'new402' event (evid: 65)
 *
 * Event description: Get current NS records from New API (Check Task results).
 *
 * @param {new402Params} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} aName - A Name
 * @property {string} wixNs - true/false/null(not resolving, propagation)
 * @property {string} cName - C Name
 * @property {string} nsRecords - NS records
 * @property {string} referralAdditionalInfo - referral additional info
 * @return {LogObject<new402Params>} LogObject<new402Params>
 */
export function new402(params) {
    return { evid: 65, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vOfferTpaCart' event (evid: 650)
 *
 * Event description: V_OfferTpaCart.
 *
 * @param {vOfferTpaCartParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vOfferTpaCartParams>} LogObject<vOfferTpaCartParams>
 */
export function vOfferTpaCart(params) {
    return { evid: 650, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'messageSubmitted' event (evid: 6500)
 *
 * Event description: The Message was submitted
 *
 * @param {messageSubmittedParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} uuid - uuid
 * @property {string} notificationGuid - notificationGuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} newPurchase - is_new_purchase
 * @property {string} user_agent - user_agent
 * @property {string} to - user phone number
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} via - "sms" or "email"
 * @property {string} pagename - ab_test
 * @property {string} messageId - key from translation json
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} externalData - external service id
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} initiator - initiator
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<messageSubmittedParams>} LogObject<messageSubmittedParams>
 */
export function messageSubmitted(params) {
    return { evid: 6500, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'messageSent' event (evid: 6501)
 *
 * Event description: The Message was sent
 *
 * @param {messageSentParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} uuid - uuid
 * @property {string} notificationGuid - notificationGuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} newPurchase - is_new_purchase
 * @property {string} user_agent - user_agent
 * @property {string} to - user phone number
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} via - "sms" or "email"
 * @property {string} pagename - ab_test
 * @property {string} messageId - key from translation json
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} externalData - external service id
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} initiator - initiator
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<messageSentParams>} LogObject<messageSentParams>
 */
export function messageSent(params) {
    return { evid: 6501, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'messageSkipped' event (evid: 6502)
 *
 * Event description: The Message was skipped
 *
 * @param {messageSkippedParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} uuid - uuid
 * @property {string} notificationGuid - notificationGuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} reason - "OPTED_OUT" or "NOT_RELEVANT" or "RECENTLY_SENT"
 * @property {string} newPurchase - is_new_purchase
 * @property {string} user_agent - user_agent
 * @property {string} to - user phone number
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} via - "sms" or "email"
 * @property {string} pagename - ab_test
 * @property {string} messageId - key from translation json
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} externalData - external service id
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} initiator - initiator
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<messageSkippedParams>} LogObject<messageSkippedParams>
 */
export function messageSkipped(params) {
    return { evid: 6502, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'messageFailed' event (evid: 6503)
 *
 * Event description: The Message failed
 *
 * @param {messageFailedParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} uuid - uuid
 * @property {string} notificationGuid - notificationGuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} reason - reason
 * @property {string} newPurchase - is_new_purchase
 * @property {string} user_agent - user_agent
 * @property {string} to - user phone number
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} via - "sms" or "email"
 * @property {string} pagename - ab_test
 * @property {string} messageId - key from translation json
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} externalData - external service id
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} initiator - initiator
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<messageFailedParams>} LogObject<messageFailedParams>
 */
export function messageFailed(params) {
    return { evid: 6503, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'messageDelivered' event (evid: 6504)
 *
 * Event description: The Message delivered
 *
 * @param {messageDeliveredParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} errorMessage - why
 * @property {GUID} uuid - uuid
 * @property {string} notificationGuid - notificationGuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} newPurchase - is_new_purchase
 * @property {string} user_agent - user_agent
 * @property {string} to - user phone number
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} via - "sms" or "email"
 * @property {string} pagename - ab_test
 * @property {string} messageId - key from translation json
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} externalData - external service id
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} initiator - initiator
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<messageDeliveredParams>} LogObject<messageDeliveredParams>
 */
export function messageDelivered(params) {
    return { evid: 6504, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'messageOptInOut' event (evid: 6505)
 *
 * Event description: The Message OptInOut
 *
 * @param {messageOptInOutParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} commandType - "OptIn", "OptOut", "Help","Unknown"
 * @property {GUID} userGuid - uuid
 * @property {string} command - raw text that the user replied us in sms
 * @property {string} newPurchase - is_new_purchase
 * @property {string} user_agent - user_agent
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} origin - "Api" or "User"
 * @property {string} via - "sms" or "email"
 * @property {string} pagename - ab_test
 * @property {string} from - user phone number
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} externalData - external service id
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} initiator - initiator
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<messageOptInOutParams>} LogObject<messageOptInOutParams>
 */
export function messageOptInOut(params) {
    return { evid: 6505, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'messageValidationFailed' event (evid: 6506)
 *
 * Event description: Message validation failed
 * This BI Event will be logged when there was a validation error in sms request parameters.
 * For instance it will occur when the phone number is invalid or country code
 *
 * @param {messageValidationFailedParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} reason - "OPTED_OUT" or "NOT_RELEVANT" or "RECENTLY_SENT"
 * @property {string} newPurchase - is_new_purchase
 * @property {string} user_agent - user_agent
 * @property {string} to - user phone number
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} countryCode - send to country
 * @property {string} via - "sms" or "email"
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} externalData - external service id
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} initiator - initiator
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<messageValidationFailedParams>} LogObject<messageValidationFailedParams>
 */
export function messageValidationFailed(params) {
    return { evid: 6506, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vTpaCartPurchasePage' event (evid: 651)
 *
 * Event description: V_TpaCartPurchasePage.
 *
 * @param {vTpaCartPurchasePageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vTpaCartPurchasePageParams>} LogObject<vTpaCartPurchasePageParams>
 */
export function vTpaCartPurchasePage(params) {
    return { evid: 651, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vTpaCartBillingPage' event (evid: 652)
 *
 * Event description: V_TpaCartBillingPage.
 *
 * @param {vTpaCartBillingPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vTpaCartBillingPageParams>} LogObject<vTpaCartBillingPageParams>
 */
export function vTpaCartBillingPage(params) {
    return { evid: 652, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vTpaCartSuccessPage' event (evid: 653)
 *
 * Event description: V_TpaCartSuccessPage.
 *
 * @param {vTpaCartSuccessPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vTpaCartSuccessPageParams>} LogObject<vTpaCartSuccessPageParams>
 */
export function vTpaCartSuccessPage(params) {
    return { evid: 653, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aUseYourCreditNow' event (evid: 654)
 *
 * Event description: A_UseYourCreditNow.
 *
 * @param {aUseYourCreditNowParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aUseYourCreditNowParams>} LogObject<aUseYourCreditNowParams>
 */
export function aUseYourCreditNow(params) {
    return { evid: 654, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aUseYourCreditLater' event (evid: 655)
 *
 * Event description: A_UseYourCreditLater.
 *
 * @param {aUseYourCreditLaterParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aUseYourCreditLaterParams>} LogObject<aUseYourCreditLaterParams>
 */
export function aUseYourCreditLater(params) {
    return { evid: 655, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aRemovedAppFromCart' event (evid: 656)
 *
 * Event description: A_RemovedAppFromCart.
 *
 * @param {aRemovedAppFromCartParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aRemovedAppFromCartParams>} LogObject<aRemovedAppFromCartParams>
 */
export function aRemovedAppFromCart(params) {
    return { evid: 656, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaCartPurchasePageCheckout' event (evid: 657)
 *
 * Event description: A_TpaCartPurchasePageCheckout.
 *
 * @param {aTpaCartPurchasePageCheckoutParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaCartPurchasePageCheckoutParams>} LogObject<aTpaCartPurchasePageCheckoutParams>
 */
export function aTpaCartPurchasePageCheckout(params) {
    return { evid: 657, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaCartBillingPageSubmitPurchase' event (evid: 658)
 *
 * Event description: A_TpaCartBillingPageSubmitPurchase.
 *
 * @param {aTpaCartBillingPageSubmitPurchaseParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaCartBillingPageSubmitPurchaseParams>} LogObject<aTpaCartBillingPageSubmitPurchaseParams>
 */
export function aTpaCartBillingPageSubmitPurchase(params) {
    return { evid: 658, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaCartBillingPageGoBack' event (evid: 659)
 *
 * Event description: A_TpaCartBillingPageGoBack.
 *
 * @param {aTpaCartBillingPageGoBackParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaCartBillingPageGoBackParams>} LogObject<aTpaCartBillingPageGoBackParams>
 */
export function aTpaCartBillingPageGoBack(params) {
    return { evid: 659, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainManagementGetNsWithCheckTaskError' event (evid: 66)
 *
 * Event description: Get current NS records from New API - Error.
 *
 * @param {domainManagementGetNsWithCheckTaskErrorParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} type - type of the error
 * @return {LogObject<domainManagementGetNsWithCheckTaskErrorParams>} LogObject<domainManagementGetNsWithCheckTaskErrorParams>
 */
export function domainManagementGetNsWithCheckTaskError(params) {
    return { evid: 66, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaCartSuccessPageLearnToUseMyApps' event (evid: 660)
 *
 * Event description: A_TpaCartSuccessPageLearnToUseMyApps.
 *
 * @param {aTpaCartSuccessPageLearnToUseMyAppsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaCartSuccessPageLearnToUseMyAppsParams>} LogObject<aTpaCartSuccessPageLearnToUseMyAppsParams>
 */
export function aTpaCartSuccessPageLearnToUseMyApps(params) {
    return { evid: 660, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaCartSuccessPageBuyMailBox' event (evid: 661)
 *
 * Event description: A_TpaCartSuccessPageBuyMailBox.
 *
 * @param {aTpaCartSuccessPageBuyMailBoxParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaCartSuccessPageBuyMailBoxParams>} LogObject<aTpaCartSuccessPageBuyMailBoxParams>
 */
export function aTpaCartSuccessPageBuyMailBox(params) {
    return { evid: 661, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaCartSuccessPageExpendPurchaseSummary' event (evid: 662)
 *
 * Event description: A_TpaCartSuccessPageExpendPurchaseSummary.
 *
 * @param {aTpaCartSuccessPageExpendPurchaseSummaryParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaCartSuccessPageExpendPurchaseSummaryParams>} LogObject<aTpaCartSuccessPageExpendPurchaseSummaryParams>
 */
export function aTpaCartSuccessPageExpendPurchaseSummary(params) {
    return { evid: 662, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaCartSuccessPageBackToMySite' event (evid: 663)
 *
 * Event description: A_TpaCartSuccessPageBackToMySite.
 *
 * @param {aTpaCartSuccessPageBackToMySiteParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaCartSuccessPageBackToMySiteParams>} LogObject<aTpaCartSuccessPageBackToMySiteParams>
 */
export function aTpaCartSuccessPageBackToMySite(params) {
    return { evid: 663, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaCartSuccessPageBrowseMoreApps' event (evid: 664)
 *
 * Event description: A_TpaCartSuccessPageBrowseMoreApps.
 *
 * @param {aTpaCartSuccessPageBrowseMoreAppsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaCartSuccessPageBrowseMoreAppsParams>} LogObject<aTpaCartSuccessPageBrowseMoreAppsParams>
 */
export function aTpaCartSuccessPageBrowseMoreApps(params) {
    return { evid: 664, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTpaCartSuccessPageOpenApp' event (evid: 665)
 *
 * Event description: A_TpaCartSuccessPageOpenApp.
 *
 * @param {aTpaCartSuccessPageOpenAppParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaCartSuccessPageOpenAppParams>} LogObject<aTpaCartSuccessPageOpenAppParams>
 */
export function aTpaCartSuccessPageOpenApp(params) {
    return { evid: 665, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'abtestEvent' event (evid: 666)
 *
 * Event description: abtest event.
 *
 * @param {abtestEventParams} params - The parameters for this event
 * @property {DateTime} date - date time of the log entry
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} metaSiteId - meta site id
 * @property {string} conduction_type - type
 * @property {GUID} conduction_guid - conduction_guid
 * @property {number} testGroupId - test_group
 * @property {string} city - city
 * @property {string} device_id - device_id
 * @property {string} ip - ip
 * @property {string} lng - lng
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} udger_ua_class - udger_ua_class
 * @property {string} role - roles
 * @property {Url} url - url
 * @property {string} reg_color - reg_color
 * @property {boolean} is_validation_excluded - is_validation_excluded
 * @property {string} geo - geo
 * @property {GUID} uuid - unique user identificator
 * @property {string} host - host
 * @property {string} isp_name - isp
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {boolean} studio_rollout_account - true, false
 * @property {GUID} visitor_id - visitor_id
 * @property {number} area_code - area_code
 * @property {string} os_name - os_name
 * @property {string} brand_id - brand_id
 * @property {string} udger_ua_family - udger_ua_family
 * @property {GUID} gsi - gsi
 * @property {boolean} is_owner - is_owner
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} nv_invalid_reason - nv_invalid_reason
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {GUID} cuid - unique client/computer id
 * @property {string} udger_os_name - udger_os_name
 * @property {boolean} is_internal - is_internal
 * @property {string} country_code - country_code
 * @property {GUID} logged_account_id - logged_account_id
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} experimentId - experiment
 * @property {string} udger_ua - udger_ua
 * @property {string} nv_destination - nv_destination
 * @property {string} browser_family - browser_family
 * @property {string} ip_hash - ip_hash
 * @property {string} bot_name - bot_name
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} bsi - bsi
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {string} bi_project_id - bi_project_id
 * @property {string} postal_code - postal_code
 * @property {GUID} impersonating_user_id - impersonating_user_id
 * @property {string} productName - product_name
 * @property {string} region - region
 * @property {GUID} logged_user_id - logged_user_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} browser_version - browser_version
 * @property {GUID} target_account_id - target_account_id
 * @property {string} extra_fields - extra_fields
 * @property {GUID} msid - meta site id
 * @property {string} browser_name - browser_name
 * @property {GUID} logged_session_uuid - logged_session_uuid
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} label_id - The computation of label_id is experimentId * 1000 + testGroupId
 * @property {string} country_name - country_name
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<abtestEventParams>} LogObject<abtestEventParams>
 */
export function abtestEvent(params) {
    return { evid: 666, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'voucherClaimSuccess' event (evid: 6661)
 *
 * Event description: voucher > claim success
 *
 * @param {voucherClaimSuccessParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service_guid
 * @property {GUID} uuid - uuid
 * @property {string} voucherType - google/bing/yandex ...
 * @property {string} voucherGuid - promotion_table_guid
 * @return {LogObject<voucherClaimSuccessParams>} LogObject<voucherClaimSuccessParams>
 */
export function voucherClaimSuccess(params) {
    return { evid: 6661, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'voucherClaimError' event (evid: 6662)
 *
 * Event description: Exception or Error
 *
 * @param {voucherClaimErrorParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service_guid
 * @property {string} errorInfo - error
 * @property {GUID} uuid - uuid
 * @property {string} voucherType - google/bing/yandex ...
 * @property {string} voucherGuid - promotion_table_guid
 * @return {LogObject<voucherClaimErrorParams>} LogObject<voucherClaimErrorParams>
 */
export function voucherClaimError(params) {
    return { evid: 6662, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'voucherVoucherAllocated' event (evid: 6665)
 *
 * Event description: voucher Allocated
 *
 * @param {voucherVoucherAllocatedParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service_guid
 * @property {string} validSkus - validSkus
 * @property {GUID} userGuid - uuid
 * @property {string} invoiceId - invoice
 * @property {string} voucherType - voucher_type
 * @property {string} voucherGuid - voucher_guid
 * @return {LogObject<voucherVoucherAllocatedParams>} LogObject<voucherVoucherAllocatedParams>
 */
export function voucherVoucherAllocated(params) {
    return { evid: 6665, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'voucherAbuse' event (evid: 6666)
 *
 * Event description: When a user use an injected voucher more than once
 *
 * @param {voucherAbuseParams} params - The parameters for this event
 * @property {GUID} serviceGuid - sbs service
 * @property {GUID} uuid - uuid
 * @property {string} productType - domain / premium...
 * @return {LogObject<voucherAbuseParams>} LogObject<voucherAbuseParams>
 */
export function voucherAbuse(params) {
    return { evid: 6666, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'voucherAllocationDecline' event (evid: 6667)
 *
 * Event description: When a user purchase a plan and get maxmind99 - domain voucher is not given
 *
 * @param {voucherAllocationDeclineParams} params - The parameters for this event
 * @property {string} isNewPurchase - new purchase or not
 * @property {GUID} serviceGuid - sbs service
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - premium subscription id
 * @property {string} productType - domain / premium...
 * @property {string} user_agent - user_agent
 * @property {string} productTypeId - product type id
 * @property {string} productId - premium product id
 * @return {LogObject<voucherAllocationDeclineParams>} LogObject<voucherAllocationDeclineParams>
 */
export function voucherAllocationDecline(params) {
    return { evid: 6667, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aAddedAppToCart' event (evid: 667)
 *
 * Event description: A_AddedAppToCart.
 *
 * @param {aAddedAppToCartParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aAddedAppToCartParams>} LogObject<aAddedAppToCartParams>
 */
export function aAddedAppToCart(params) {
    return { evid: 667, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnCancellationModal' event (evid: 668)
 *
 * Event description: Google Subscription Add-on > Cancellation modal
 *
 * @param {googleSubscriptionAddOnCancellationModalParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} action - view or click on one of the CTAs (CTA name)
 * @return {LogObject<googleSubscriptionAddOnCancellationModalParams>} LogObject<googleSubscriptionAddOnCancellationModalParams>
 */
export function googleSubscriptionAddOnCancellationModal(params) {
    return { evid: 668, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestCreated' event (evid: 669)
 *
 * Event description: Pay Link request created
 *
 * @param {payLinkPaymentRequestCreatedParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {DateTime} payByDate - pay_by_date, client can pay by date, exparation date
 * @property {string} cycleName - cycle_name
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkPaymentRequestCreatedParams>} LogObject<payLinkPaymentRequestCreatedParams>
 */
export function payLinkPaymentRequestCreated(params) {
    return { evid: 669, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDnsupdateSuccess' event (evid: 67)
 *
 * Event description: DNS Update Success
 * (it won't be triggered for Create Zone With Records anymore)
 *
 * @param {rDnsupdateSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDnsupdateSuccessParams>} LogObject<rDnsupdateSuccessParams>
 */
export function rDnsupdateSuccess(params) {
    return { evid: 67, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDnslookup' event (evid: 670)
 *
 * Event description: This event is generated during Connect Domain flow after a user clicks "Next" in "Connect Domain" page
 *
 * @param {rDnslookupParams} params - The parameters for this event
 * @property {string} domain - Domain name
 * @property {GUID} uuid - User guid
 * @property {string} user_agent - user_agent
 * @property {string} record - JSON field with all available DNS records
 * @return {LogObject<rDnslookupParams>} LogObject<rDnslookupParams>
 */
export function rDnslookup(params) {
    return { evid: 670, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkCreatePaymentRequestTooltip' event (evid: 671)
 *
 * Event description: View/click inside the create a payment request tooltip.
 *
 * @param {payLinkCreatePaymentRequestTooltipParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {string} clickType - null (for view), ‘close’, ‘create a payment request’
 * @property {DateTime} payByDate - client can pay by date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - is_coupon_used - true if coupon was injected
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkCreatePaymentRequestTooltipParams>} LogObject<payLinkCreatePaymentRequestTooltipParams>
 */
export function payLinkCreatePaymentRequestTooltip(params) {
    return { evid: 671, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkSendRequestConfirmationModalViewClick' event (evid: 672)
 *
 * Event description: View/click inside the create a payment request Send Request confirmation modal.
 *
 * @param {payLinkSendRequestConfirmationModalViewClickParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {string} clickType - null (for view), ‘send request’, ‘close’, ‘x’
 * @property {DateTime} payByDate - pay_by_date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - true if coupon was injected
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkSendRequestConfirmationModalViewClickParams>} LogObject<payLinkSendRequestConfirmationModalViewClickParams>
 */
export function payLinkSendRequestConfirmationModalViewClick(params) {
    return { evid: 672, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestSendSuccessPageView' event (evid: 673)
 *
 * Event description: View Payment request send success page
 *
 * @param {payLinkPaymentRequestSendSuccessPageViewParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {DateTime} payByDate - pay_by_date, client can pay by date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - true if coupon was injected
 * @property {string} productId - product_guid
 * @property {string} pageType - whatever
 * @property {GUID} msid - msid
 * @property {GUID} requestCreatorAccountId - request_creator_account_id
 * @property {string} productname - product_name
 * @return {LogObject<payLinkPaymentRequestSendSuccessPageViewParams>} LogObject<payLinkPaymentRequestSendSuccessPageViewParams>
 */
export function payLinkPaymentRequestSendSuccessPageView(params) {
    return { evid: 673, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestSentSuccessPageClick' event (evid: 674)
 *
 * Event description: Click inside Payment request send success page
 *
 * @param {payLinkPaymentRequestSentSuccessPageClickParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {string} clickType - 'copy link', 'refreshing this page'
 * @property {DateTime} payByDate - pay_by_date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - is_coupon_used
 * @property {string} productId - product_guid
 * @property {string} pageType - page type
 * @property {GUID} msid - msid
 * @property {GUID} requestCreatorAccountId - request_creator_account_id
 * @property {string} productname - product_name
 * @return {LogObject<payLinkPaymentRequestSentSuccessPageClickParams>} LogObject<payLinkPaymentRequestSentSuccessPageClickParams>
 */
export function payLinkPaymentRequestSentSuccessPageClick(params) {
    return { evid: 674, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestErrorModal' event (evid: 675)
 *
 * Event description: User got an error message after trying to send a pay link payment request
 *
 * @param {payLinkPaymentRequestErrorModalParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {string} clickType - null (if no click), ‘Refresh the page’, ‘Send Request’, close, ‘x’
 * @property {string} errorType - ‘technical issue’, ‘network issue’, ‘server issue’, etc.
 * @property {DateTime} payByDate - pay_by_date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - is_coupon_used
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkPaymentRequestErrorModalParams>} LogObject<payLinkPaymentRequestErrorModalParams>
 */
export function payLinkPaymentRequestErrorModal(params) {
    return { evid: 675, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestCompletedSuccessPageView' event (evid: 676)
 *
 * Event description: Payment request completed success page view
 *
 * @param {payLinkPaymentRequestCompletedSuccessPageViewParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {GUID} subscriptionId - subscription_id
 * @property {DateTime} payByDate - pay_by_date, client can pay by date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - true if coupon was injected
 * @property {string} productName - product name
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @property {GUID} requestCreatorAccountId - partner who created the pay link request -account id
 * @return {LogObject<payLinkPaymentRequestCompletedSuccessPageViewParams>} LogObject<payLinkPaymentRequestCompletedSuccessPageViewParams>
 */
export function payLinkPaymentRequestCompletedSuccessPageView(params) {
    return { evid: 676, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestCompletedSuccessPageClick' event (evid: 677)
 *
 * Event description: click on Payment request completed success page
 *
 * @param {payLinkPaymentRequestCompletedSuccessPageClickParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - 'Premium Subscriptions'
 * @property {DateTime} payByDate - pay_by_date, client can pay by date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - true if coupon was injected
 * @property {string} productName - product_name
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @property {GUID} requestCreatorAccountId - partner who created the request
 * @return {LogObject<payLinkPaymentRequestCompletedSuccessPageClickParams>} LogObject<payLinkPaymentRequestCompletedSuccessPageClickParams>
 */
export function payLinkPaymentRequestCompletedSuccessPageClick(params) {
    return { evid: 677, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestClientSideErrorPage' event (evid: 678)
 *
 * Event description: client side Payment request client side error page
 *
 * @param {payLinkPaymentRequestClientSideErrorPageParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {string} clickType - 'refresh'
 * @property {string} errorType - 'email don't have permissions', 'request expired', 'already premium', 'site deleted', 'load error', 'service not available',
 * @property {DateTime} payByDate - pay_by_date, client can pay by date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - true if coupon was injected
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkPaymentRequestClientSideErrorPageParams>} LogObject<payLinkPaymentRequestClientSideErrorPageParams>
 */
export function payLinkPaymentRequestClientSideErrorPage(params) {
    return { evid: 678, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestTokenCreated' event (evid: 679)
 *
 * Event description: Pay Link request token created
 *
 * @param {payLinkPaymentRequestTokenCreatedParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {DateTime} payByDate - pay_by_date, client can pay by date, exparation date
 * @property {string} cycleName - cycle_name
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkPaymentRequestTokenCreatedParams>} LogObject<payLinkPaymentRequestTokenCreatedParams>
 */
export function payLinkPaymentRequestTokenCreated(params) {
    return { evid: 679, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDnsupdateError' event (evid: 68)
 *
 * Event description: DNS Update Error
 *
 * @param {rDnsupdateErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDnsupdateErrorParams>} LogObject<rDnsupdateErrorParams>
 */
export function rDnsupdateError(params) {
    return { evid: 68, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'voucherClickOnHowToClaim' event (evid: 680)
 *
 * Event description: Click on "how do I claim my vouchers"
 *
 * @param {voucherClickOnHowToClaimParams} params - The parameters for this event
 * @property {string} voucherType - domain/google/bing/local_listing_US/local_listing_CA/Yandex
 * @return {LogObject<voucherClickOnHowToClaimParams>} LogObject<voucherClickOnHowToClaimParams>
 */
export function voucherClickOnHowToClaim(params) {
    return { evid: 680, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'voucherClickOnClaimVoucher' event (evid: 681)
 *
 * Event description: click on 'get your domain/list your business/claim voucher'
 *
 * @param {voucherClickOnClaimVoucherParams} params - The parameters for this event
 * @property {string} reseller - reseller guid if applicable
 * @property {string} pageType - default, reseller
 * @property {string} voucherType - domain/google/bing/local_listing_US/local_listing_CA/Yandex
 * @return {LogObject<voucherClickOnClaimVoucherParams>} LogObject<voucherClickOnClaimVoucherParams>
 */
export function voucherClickOnClaimVoucher(params) {
    return { evid: 681, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'voucherClickDropDown' event (evid: 682)
 *
 * Event description: Click on the drop-down to see more vouchers (the page opens with one visible voucher from each voucher type, you have to click the drop-down arrow to see the rest)
 *
 * @param {voucherClickDropDownParams} params - The parameters for this event
 * @property {string} clickType - open/close
 * @property {string} voucherType - domain/google/bing/local_listing_US/local_listing_CA/Yandex
 * @return {LogObject<voucherClickDropDownParams>} LogObject<voucherClickDropDownParams>
 */
export function voucherClickDropDown(params) {
    return { evid: 682, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestOrderPageSessionInitiated' event (evid: 683)
 *
 * Event description: Payment request order page session initiated - user that is making the payment
 *
 * @param {payLinkPaymentRequestOrderPageSessionInitiatedParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {GUID} paymentRequestTokenId - payment_request_token_id
 * @property {DateTime} payByDate - pay_by_date, client can pay by date, exparation date
 * @property {string} cycleName - cycle_name
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkPaymentRequestOrderPageSessionInitiatedParams>} LogObject<payLinkPaymentRequestOrderPageSessionInitiatedParams>
 */
export function payLinkPaymentRequestOrderPageSessionInitiated(params) {
    return { evid: 683, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestPaid' event (evid: 684)
 *
 * Event description: Payment request status changed to paid
 *
 * @param {payLinkPaymentRequestPaidParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {DateTime} payByDate - pay_by_date, client can pay by date, exparation date
 * @property {string} cycleName - cycle_name
 * @property {string} productId - product_guid
 * @property {GUID} recipientAccountId - recepient_account_id
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkPaymentRequestPaidParams>} LogObject<payLinkPaymentRequestPaidParams>
 */
export function payLinkPaymentRequestPaid(params) {
    return { evid: 684, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'entriIntroModal' event (evid: 685)
 *
 * Event description: little helper to indicate that the domain is eligible to be connected via Entri (for test purposes)
 *
 * @param {entriIntroModalParams} params - The parameters for this event
 * @property {string} action_name - view, continue, go_to_our_manual_setup, learn_more, close
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - original referral additional info
 * @property {GUID} msid - msid
 * @return {LogObject<entriIntroModalParams>} LogObject<entriIntroModalParams>
 */
export function entriIntroModal(params) {
    return { evid: 685, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'entriFlowResult' event (evid: 686)
 *
 * Event description: The onEntriClose callback is triggered, and this is the result
 *
 * @param {entriFlowResultParams} params - The parameters for this event
 * @property {string} provider - provider detected
 * @property {string} domain - domain
 * @property {string} errorMsg - error message if existed
 * @property {boolean} isSuccess - true, false
 * @property {string} setupType - entri setup type
 * @property {string} lastStep - last step the user experienced
 * @property {string} referralAdditionalInfo - original referral additional info
 * @property {GUID} msid - msid
 * @return {LogObject<entriFlowResultParams>} LogObject<entriFlowResultParams>
 */
export function entriFlowResult(params) {
    return { evid: 686, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'entriFlowLeaveFunnel' event (evid: 687)
 *
 * Event description: when user clicks "go to our manual setup" or close the modal
 *
 * @param {entriFlowLeaveFunnelParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} lastStep - the step the user clicks and left the flow
 * @property {string} referralAdditionalInfo - original referral additional info
 * @property {GUID} msid - msid
 * @property {string} action_type - close, go_to_our_manual_flow
 * @return {LogObject<entriFlowLeaveFunnelParams>} LogObject<entriFlowLeaveFunnelParams>
 */
export function entriFlowLeaveFunnel(params) {
    return { evid: 687, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'entriStepView' event (evid: 688)
 *
 * Event description: This event is triggered each time a different screen is shown within the Entri configuration process
 *
 * @param {entriStepViewParams} params - The parameters for this event
 * @property {string} provider - provider, if known
 * @property {string} domain - domain
 * @property {string} stepName - Entri step
 * @property {GUID} msid - msid, if known
 * @property {string} errorMsg - error message
 * @return {LogObject<entriStepViewParams>} LogObject<entriStepViewParams>
 */
export function entriStepView(params) {
    return { evid: 688, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessEmailAndAddOnsErrorPage' event (evid: 689)
 *
 * Event description: Business Email and add-ons > error page
 *
 * @param {businessEmailAndAddOnsErrorPageParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} viewMode - site level or account level
 * @property {string} additionalErrorInfo - adidtional details about error if available
 * @property {string} errorType - type of the error
 * @property {string} action - view or click on CTA
 * @return {LogObject<businessEmailAndAddOnsErrorPageParams>} LogObject<businessEmailAndAddOnsErrorPageParams>
 */
export function businessEmailAndAddOnsErrorPage(params) {
    return { evid: 689, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDnsupdateException' event (evid: 69)
 *
 * Event description: R_DNSUpdateException.
 *
 * @param {rDnsupdateExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDnsupdateExceptionParams>} LogObject<rDnsupdateExceptionParams>
 */
export function rDnsupdateException(params) {
    return { evid: 69, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnPackagePickerClick' event (evid: 690)
 *
 * Event description: Google Subscription Add-on > Package picker > click
 *
 * @param {googleSubscriptionAddOnPackagePickerClickParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} isNewPurchase - is new purchase or upgarde/change ot existing add-on
 * @property {string} clickType - 'Continue to Checkout', Back, Premier, Standard, Starter, etc.
 * @property {string} QuestionKey - Question Key
 * @property {string} PopUpType - pop_up_type
 * @property {string} Page - page
 * @return {LogObject<googleSubscriptionAddOnPackagePickerClickParams>} LogObject<googleSubscriptionAddOnPackagePickerClickParams>
 */
export function googleSubscriptionAddOnPackagePickerClick(params) {
    return { evid: 690, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnPackagePickerError' event (evid: 691)
 *
 * Event description: Google Subscription Add-on > Package picker error
 *
 * @param {googleSubscriptionAddOnPackagePickerErrorParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} isNewPurchase - is new purchase or upgarde/change ot existing add-on
 * @property {string} additionalErrorInfo - additional error info if availabble
 * @property {string} errorType - error type
 * @property {string} action - view or click on CTA
 * @return {LogObject<googleSubscriptionAddOnPackagePickerErrorParams>} LogObject<googleSubscriptionAddOnPackagePickerErrorParams>
 */
export function googleSubscriptionAddOnPackagePickerError(params) {
    return { evid: 691, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainDeliverySuccessSrc17Evid692' event (evid: 692)
 *
 * Event description: triggered when domain is successfully delivered, for purchase / transfer / renewal.
 * Initiator: (1) purchase , (2) transfer,  (3) renewal
 *
 * @param {domainDeliverySuccessSrc17Evid692Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {GUID} '6' - service_guid
 * @property {GUID} '4' - uuid
 * @property {string} '11' - false, true
 * @property {number} '9' - 3,6,7,8
 * @property {string} '31' - domain
 * @property {GUID} '38' - service_guid
 * @property {number} '29' - 1=purchase, 2=transfer, 3=renewal
 * @property {string} '14' - purchase, transfer, renewal
 * @property {string} referraladditionalinfo - purchase, transfer, renewal
 * @property {GUID} packageid - service_guid
 * @property {string} domain - domain
 * @property {string} isnewpurchase - purchase or renewal
 * @return {LogObject<domainDeliverySuccessSrc17Evid692Params>} LogObject<domainDeliverySuccessSrc17Evid692Params>
 */
export function domainDeliverySuccessSrc17Evid692(params) {
    return { evid: 692, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createDnsZoneSuccessSrc17Evid693' event (evid: 693)
 *
 * Event description: Will be triggered on Create Zone with Records
 *
 * @param {createDnsZoneSuccessSrc17Evid693Params} params - The parameters for this event
 * @property {string} domain - Domain name
 * @property {GUID} uuid - User guid
 * @property {string} user_agent - user_agent
 * @return {LogObject<createDnsZoneSuccessSrc17Evid693Params>} LogObject<createDnsZoneSuccessSrc17Evid693Params>
 */
export function createDnsZoneSuccessSrc17Evid693(params) {
    return { evid: 693, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessEmailAndAddOnsPageCtaClick' event (evid: 694)
 *
 * Event description:  Business Email and add-ons page > CTA click
 *
 * @param {businessEmailAndAddOnsPageCtaClickParams} params - The parameters for this event
 * @property {string} nextStep - Next step type - Single Connected domain/  Multiple Connected domain /No connected domain
 * @property {number} accountTotalDomains - account_total_domains
 * @property {string} viewMode - empty_state/manage_state
 * @property {string} voucher - True/False
 * @property {boolean} hasLiveMailbox - has_live_mailbox
 * @property {number} cycleId - cycle_id
 * @property {number} domainsNotAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {number} siteTotalDomains - site_total_domains
 * @property {string} domain - domain name
 * @property {GUID} skuId - sku_id
 * @property {Url} referral - referral
 * @property {number} expiredMailboxAccounts - number of expired mailbox accounts
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {number} domainsAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {string} pagetype - page_type
 * @property {boolean} inSale - [yes / no]
 * @property {string} isConnectedDomain - true, false
 * @property {number} emailProvider - email_provider
 * @property {number} siteConnectedDomains - site_connected_domains
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - is_account_premium
 * @property {number} activeMailboxAccounts - number of active mailbox accounts
 * @property {boolean} isPremium - is_premium
 * @property {GUID} msid - site_id
 * @property {number} accountConnectedDomains - account_connected_domains
 * @property {GUID} siteGuid - site_id
 * @property {string} clickType - name of the CTA
 * @property {string} recommended - google voice, gemini
 * @property {string} active_voices - Numbers of active google voice subscriptions
 * @property {string} active_geminis - Numbers of active Gemini subscriptions
 * @property {string} totalMailboxAccounts - number of total mailbox accounts including suspended and cancelled (all that are being displayed on the page)
 * @property {GUID} ProductId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 *
 * @property {string} productName - add-on product name if available
 *
 * @property {string} productTypeName - add-on product type name
 *
 * @property {string} UserEmail - user email address
 * @property {string} UserEmailId - User email address id
 * @property {string} ClickTypeInfo - More information about the click type if available. from where etc
 * @property {GUID} subscription_guid - premium subscription guid of the add-on
 * @return {LogObject<businessEmailAndAddOnsPageCtaClickParams>} LogObject<businessEmailAndAddOnsPageCtaClickParams>
 */
export function businessEmailAndAddOnsPageCtaClick(params) {
    return { evid: 694, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessEmailAndAddOnsPageHoverSrc17Evid6944' event (evid: 6944)
 *
 * Event description:  Business Email and add-ons page > Hover
 *
 * @param {businessEmailAndAddOnsPageHoverSrc17Evid6944Params} params - The parameters for this event
 * @property {string} nextStep - Next step type - Single Connected domain/  Multiple Connected domain /No connected domain
 * @property {number} accountTotalDomains - account_total_domains
 * @property {string} viewMode - empty_state/manage_state
 * @property {string} voucher - True/False
 * @property {boolean} hasLiveMailbox - has_live_mailbox
 * @property {number} cycleId - cycle_id
 * @property {number} domainsNotAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {number} siteTotalDomains - site_total_domains
 * @property {string} domain - domain name
 * @property {GUID} skuId - sku_id
 * @property {Url} referral - referral
 * @property {number} expiredMailboxAccounts - number of expired mailbox accounts
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {number} domainsAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {string} pagetype - page_type
 * @property {boolean} inSale - [yes / no]
 * @property {string} isConnectedDomain - true, false
 * @property {number} emailProvider - email_provider
 * @property {number} siteConnectedDomains - site_connected_domains
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - is_account_premium
 * @property {number} activeMailboxAccounts - number of active mailbox accounts
 * @property {boolean} isPremium - is_premium
 * @property {GUID} msid - site_id
 * @property {number} accountConnectedDomains - account_connected_domains
 * @property {GUID} siteGuid - site_id
 * @property {string} HoverType - name of the Hover
 * @property {string} recommended - google voice, gemini
 * @property {string} active_voices - Numbers of active google voice subscriptions
 * @property {string} active_geminis - Numbers of active Gemini subscriptions
 * @property {string} totalMailboxAccounts - number of total mailbox accounts including suspended and cancelled (all that are being displayed on the page)
 * @return {LogObject<businessEmailAndAddOnsPageHoverSrc17Evid6944Params>} LogObject<businessEmailAndAddOnsPageHoverSrc17Evid6944Params>
 */
export function businessEmailAndAddOnsPageHoverSrc17Evid6944(params) {
    return { evid: 6944, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessEmailAndAddOnsPageToast' event (evid: 695)
 *
 * Event description:  Business Email and add-ons page > toast
 *
 * @param {businessEmailAndAddOnsPageToastParams} params - The parameters for this event
 * @property {string} nextStep - Next step type - Single Connected domain/  Multiple Connected domain /No connected domain
 * @property {number} accountTotalDomains - account_total_domains
 * @property {string} viewMode - empty_state/manage_state
 * @property {string} voucher - True/False
 * @property {boolean} hasLiveMailbox - has_live_mailbox
 * @property {number} cycleId - cycle_id
 * @property {number} domainsNotAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {number} siteTotalDomains - site_total_domains
 * @property {string} domain - domain name
 * @property {GUID} skuId - sku_id
 * @property {Url} referral - referral
 * @property {number} expiredMailboxAccounts - number of expired mailbox accounts
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {number} domainsAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {string} pagetype - page_type
 * @property {boolean} inSale - [yes / no]
 * @property {string} isConnectedDomain - true, false
 * @property {number} emailProvider - email_provider
 * @property {number} siteConnectedDomains - site_connected_domains
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - is_account_premium
 * @property {number} activeMailboxAccounts - number of active mailbox accounts
 * @property {boolean} isPremium - is_premium
 * @property {GUID} msid - site_id
 * @property {number} accountConnectedDomains - account_connected_domains
 * @property {GUID} siteGuid - site_id
 * @property {string} clickType - name of the CTA
 * @property {string} recommended - google voice, gemini
 * @property {string} active_voices - Numbers of active google voice subscriptions
 * @property {string} active_geminis - Numbers of active Gemini subscriptions
 * @property {string} totalMailboxAccounts - number of total mailbox accounts including suspended and cancelled (all that are being displayed on the page)
 * @property {string} toastName - the name of the toast shown
 * @property {string} action - view of the toast or click on the toast (and type of clikc, close or some CTA)
 * @property {string} subscription_guid - premium subscription id of the add-on
 * @return {LogObject<businessEmailAndAddOnsPageToastParams>} LogObject<businessEmailAndAddOnsPageToastParams>
 */
export function businessEmailAndAddOnsPageToast(params) {
    return { evid: 695, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createDnsZoneFailureSrc17Evid696' event (evid: 696)
 *
 * Event description: fired when Create Dns Zone Failure
 *
 * @param {createDnsZoneFailureSrc17Evid696Params} params - The parameters for this event
 * @property {string} user_agent - user agent
 * @property {GUID} uuid - uuid
 * @property {string} domain - domain
 * @property {string} errorInfo - error desc
 * @return {LogObject<createDnsZoneFailureSrc17Evid696Params>} LogObject<createDnsZoneFailureSrc17Evid696Params>
 */
export function createDnsZoneFailureSrc17Evid696(params) {
    return { evid: 696, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteDnsZoneSuccessSrc17Evid697' event (evid: 697)
 *
 * Event description: fired when Delete Dns Zone Success
 *
 * @param {deleteDnsZoneSuccessSrc17Evid697Params} params - The parameters for this event
 * @property {string} user_agent - user agent
 * @property {GUID} uuid - uuid
 * @property {string} domain - domain
 * @return {LogObject<deleteDnsZoneSuccessSrc17Evid697Params>} LogObject<deleteDnsZoneSuccessSrc17Evid697Params>
 */
export function deleteDnsZoneSuccessSrc17Evid697(params) {
    return { evid: 697, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteDnsZoneFailureSrc17Evid698' event (evid: 698)
 *
 * Event description: fired when Delete Dns Zone Failure
 *
 * @param {deleteDnsZoneFailureSrc17Evid698Params} params - The parameters for this event
 * @property {string} user_agent - user agent
 * @property {GUID} uuid - uuid
 * @property {string} domain - domain
 * @property {string} errorInfo - error desc
 * @return {LogObject<deleteDnsZoneFailureSrc17Evid698Params>} LogObject<deleteDnsZoneFailureSrc17Evid698Params>
 */
export function deleteDnsZoneFailureSrc17Evid698(params) {
    return { evid: 698, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchDomainSearchValidationSrc17Evid699' event (evid: 699)
 *
 * Event description: spelling validation indiaction
 *
 * @param {searchDomainSearchValidationSrc17Evid699Params} params - The parameters for this event
 * @property {string} ViewMode - view mode
 * @property {string} SearchTerm - domain search term
 * @property {string} Langauge - language of search term
 * @property {string} ValidationType - Empty Field/ Less than 3 characters / more than 63 characters/ invalid characters / unsupported language/ invalid tld/restricted tld/ sub domains
 * @return {LogObject<searchDomainSearchValidationSrc17Evid699Params>} LogObject<searchDomainSearchValidationSrc17Evid699Params>
 */
export function searchDomainSearchValidationSrc17Evid699(params) {
    return { evid: 699, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnPurchaseSuccessPageCopySrc17Evid6991' event (evid: 6991)
 *
 * Event description: Business Email and add-ons  > Subscription created on Google
 *
 * @param {googleSubscriptionAddOnPurchaseSuccessPageCopySrc17Evid6991Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} isNewPurchase - repurchase or not
 * @property {string} googleSubscriptionId - google subscription_id
 * @property {string} googleCustomerId - google customer_id
 * @property {string} premiumSubscriptionId - premium subscription id
 * @return {LogObject<googleSubscriptionAddOnPurchaseSuccessPageCopySrc17Evid6991Params>} LogObject<googleSubscriptionAddOnPurchaseSuccessPageCopySrc17Evid6991Params>
 */
export function googleSubscriptionAddOnPurchaseSuccessPageCopySrc17Evid6991(params) {
    return { evid: 6991, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'businessEmailAndAddOnsSubscriptionCancelledOnGoogleSrc17Evid6992' event (evid: 6992)
 *
 * Event description: Business Email and add-ons  > Subscription cancelled on Google
 *
 * @param {businessEmailAndAddOnsSubscriptionCancelledOnGoogleSrc17Evid6992Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} googleSubscriptionId - google subscription_id
 *
 * @property {string} googleCustomerId - google customer_id
 *
 * @return {LogObject<businessEmailAndAddOnsSubscriptionCancelledOnGoogleSrc17Evid6992Params>} LogObject<businessEmailAndAddOnsSubscriptionCancelledOnGoogleSrc17Evid6992Params>
 */
export function businessEmailAndAddOnsSubscriptionCancelledOnGoogleSrc17Evid6992(params) {
    return { evid: 6992, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rErrorCancel' event (evid: 7)
 *
 * Event description: R_ErrorCancel.
 *
 * @param {rErrorCancelParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rErrorCancelParams>} LogObject<rErrorCancelParams>
 */
export function rErrorCancel(params) {
    return { evid: 7, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainCheckConnSuccess' event (evid: 70)
 *
 * Event description: R_DomainCheckConnSuccess.
 *
 * @param {rDomainCheckConnSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainCheckConnSuccessParams>} LogObject<rDomainCheckConnSuccessParams>
 */
export function rDomainCheckConnSuccess(params) {
    return { evid: 70, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aMailSummaryPage' event (evid: 700)
 *
 * Event description: A_MailSummaryPage.
 *
 * @param {aMailSummaryPageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMailSummaryPageParams>} LogObject<aMailSummaryPageParams>
 */
export function aMailSummaryPage(params) {
    return { evid: 700, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCardTypeDropDownMenuClick' event (evid: 7000)
 *
 * Event description: A_CardTypeDropDownMenuClick.
 *
 * @param {aCardTypeDropDownMenuClickParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCardTypeDropDownMenuClickParams>} LogObject<aCardTypeDropDownMenuClickParams>
 */
export function aCardTypeDropDownMenuClick(params) {
    return { evid: 7000, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aCardTypeDropDownMenuUnionPayCardSelected' event (evid: 7001)
 *
 * Event description: only union pay
 *
 * @param {aCardTypeDropDownMenuUnionPayCardSelectedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aCardTypeDropDownMenuUnionPayCardSelectedParams>} LogObject<aCardTypeDropDownMenuUnionPayCardSelectedParams>
 */
export function aCardTypeDropDownMenuUnionPayCardSelected(params) {
    return { evid: 7001, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleAppAccountSetupSuccess' event (evid: 702)
 *
 * Event description: Google Mail Account Setup Success.
 *
 * @param {rGoogleAppAccountSetupSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleAppAccountSetupSuccessParams>} LogObject<rGoogleAppAccountSetupSuccessParams>
 */
export function rGoogleAppAccountSetupSuccess(params) {
    return { evid: 702, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleAppAccountSetupError' event (evid: 703)
 *
 * Event description: Google Mail Setup Error.
 *
 * @param {rGoogleAppAccountSetupErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {number} quantity - quantity
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {GUID} clientId - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - Full error message
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {string} errorStatus - error_status
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleAppAccountSetupErrorParams>} LogObject<rGoogleAppAccountSetupErrorParams>
 */
export function rGoogleAppAccountSetupError(params) {
    return { evid: 703, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleAppAccountSetupException' event (evid: 704)
 *
 * Event description: R_GoogleAppAccountSetupException.
 *
 * @param {rGoogleAppAccountSetupExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleAppAccountSetupExceptionParams>} LogObject<rGoogleAppAccountSetupExceptionParams>
 */
export function rGoogleAppAccountSetupException(params) {
    return { evid: 704, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleDnsManagementServiceInitiated' event (evid: 705)
 *
 * Event description: R_GoogleDnsManagementServiceInitiated.
 *
 * @param {rGoogleDnsManagementServiceInitiatedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleDnsManagementServiceInitiatedParams>} LogObject<rGoogleDnsManagementServiceInitiatedParams>
 */
export function rGoogleDnsManagementServiceInitiated(params) {
    return { evid: 705, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleDnsManagementServiceError' event (evid: 706)
 *
 * Event description: R_GoogleDnsManagementServiceError.
 *
 * @param {rGoogleDnsManagementServiceErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleDnsManagementServiceErrorParams>} LogObject<rGoogleDnsManagementServiceErrorParams>
 */
export function rGoogleDnsManagementServiceError(params) {
    return { evid: 706, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleDnsManagementServiceSuccess' event (evid: 707)
 *
 * Event description: R_GoogleDnsManagementServiceSuccess.
 *
 * @param {rGoogleDnsManagementServiceSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleDnsManagementServiceSuccessParams>} LogObject<rGoogleDnsManagementServiceSuccessParams>
 */
export function rGoogleDnsManagementServiceSuccess(params) {
    return { evid: 707, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vMailBoxAlreadyTaken' event (evid: 708)
 *
 * Event description: V_MailBoxAlreadyTaken.
 *
 * @param {vMailBoxAlreadyTakenParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMailBoxAlreadyTakenParams>} LogObject<vMailBoxAlreadyTakenParams>
 */
export function vMailBoxAlreadyTaken(params) {
    return { evid: 708, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickGoogleMailBoxCustomerAgreement' event (evid: 709)
 *
 * Event description: A_ClickGoogleMailBoxCustomerAgreement.
 *
 * @param {aClickGoogleMailBoxCustomerAgreementParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickGoogleMailBoxCustomerAgreementParams>} LogObject<aClickGoogleMailBoxCustomerAgreementParams>
 */
export function aClickGoogleMailBoxCustomerAgreement(params) {
    return { evid: 709, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainCheckConnError' event (evid: 71)
 *
 * Event description: R_DomainCheckConnError.
 *
 * @param {rDomainCheckConnErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainCheckConnErrorParams>} LogObject<rDomainCheckConnErrorParams>
 */
export function rDomainCheckConnError(params) {
    return { evid: 71, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailBrazilPaymentPurchaseStartSuccess' event (evid: 710)
 *
 * Event description: R_GoogleMailBrazilPaymentPurchaseStartSuccess.
 *
 * @param {rGoogleMailBrazilPaymentPurchaseStartSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailBrazilPaymentPurchaseStartSuccessParams>} LogObject<rGoogleMailBrazilPaymentPurchaseStartSuccessParams>
 */
export function rGoogleMailBrazilPaymentPurchaseStartSuccess(params) {
    return { evid: 710, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'featureCreated' event (evid: 7100)
 *
 * Event description: Feature created.
 *
 * @param {featureCreatedParams} params - The parameters for this event
 * @property {GUID} subscriptionId - subscriptionId
 * @property {GUID} featureId - featureId
 * @property {string} featureUniqueName - feature_unique_name
 * @property {string} productTypeId - productTypeId
 * @property {GUID} metaSiteId - metaSiteId
 * @return {LogObject<featureCreatedParams>} LogObject<featureCreatedParams>
 */
export function featureCreated(params) {
    return { evid: 7100, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'featureRemoved' event (evid: 7101)
 *
 * Event description: Feature Created
 *
 * @param {featureRemovedParams} params - The parameters for this event
 * @property {GUID} subscriptionId - subscriptionId
 * @property {GUID} featureId - featureId
 * @property {string} transferredToAccount - transferredtoaccount
 * @property {string} reason - reason
 * @property {string} featureUniqueName - feature_unique_name
 * @property {string} productTypeId - product_type_id
 * @property {GUID} metaSiteId - metaSiteId
 * @return {LogObject<featureRemovedParams>} LogObject<featureRemovedParams>
 */
export function featureRemoved(params) {
    return { evid: 7101, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumAsAServicePurchaseValidationError' event (evid: 7105)
 *
 * Event description: Purchase validation Error - client
 *
 * @param {premiumAsAServicePurchaseValidationErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} vendorUserGuid - id from vendor
 * @property {string} packagePickerType - package_picker_type
 * @property {string} vendorGuid - appdefid not the guid is SBS
 * @property {string} errorInfo - error_info
 * @property {GUID} uuid - uuid / wix user guid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<premiumAsAServicePurchaseValidationErrorParams>} LogObject<premiumAsAServicePurchaseValidationErrorParams>
 */
export function premiumAsAServicePurchaseValidationError(params) {
    return { evid: 7105, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailBrazilPaymentPurchaseStartError' event (evid: 711)
 *
 * Event description: R_GoogleMailBrazilPaymentPurchaseStartError.
 *
 * @param {rGoogleMailBrazilPaymentPurchaseStartErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailBrazilPaymentPurchaseStartErrorParams>} LogObject<rGoogleMailBrazilPaymentPurchaseStartErrorParams>
 */
export function rGoogleMailBrazilPaymentPurchaseStartError(params) {
    return { evid: 711, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailBrazilPaymentPurchaseStartException' event (evid: 712)
 *
 * Event description: R_GoogleMailBrazilPaymentPurchaseStartException.
 *
 * @param {rGoogleMailBrazilPaymentPurchaseStartExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailBrazilPaymentPurchaseStartExceptionParams>} LogObject<rGoogleMailBrazilPaymentPurchaseStartExceptionParams>
 */
export function rGoogleMailBrazilPaymentPurchaseStartException(params) {
    return { evid: 712, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumAsAServicePurchasePageView' event (evid: 7125)
 *
 * Event description: View vendor purchase page - server
 *
 * @param {premiumAsAServicePurchasePageViewParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} vendorUserGuid - id from vendor
 * @property {string} packagePickerType - package_picker_type
 * @property {string} vendorGuid - appdefid not the guid is SBS
 * @property {string} productsList - Array of all SBS product guids
 * @property {GUID} uuid - uuid / wix user guid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - 3,6...
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<premiumAsAServicePurchasePageViewParams>} LogObject<premiumAsAServicePurchasePageViewParams>
 */
export function premiumAsAServicePurchasePageView(params) {
    return { evid: 7125, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vGoogleMailBrazilPackagePicker' event (evid: 713)
 *
 * Event description: V_GoogleMailBrazilPackagePicker.
 *
 * @param {vGoogleMailBrazilPackagePickerParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vGoogleMailBrazilPackagePickerParams>} LogObject<vGoogleMailBrazilPackagePickerParams>
 */
export function vGoogleMailBrazilPackagePicker(params) {
    return { evid: 713, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleEmailBrazilInsertCustomerSuccess' event (evid: 714)
 *
 * Event description: R_GoogleEmailBrazilInsertCustomerSuccess.
 *
 * @param {rGoogleEmailBrazilInsertCustomerSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleEmailBrazilInsertCustomerSuccessParams>} LogObject<rGoogleEmailBrazilInsertCustomerSuccessParams>
 */
export function rGoogleEmailBrazilInsertCustomerSuccess(params) {
    return { evid: 714, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleEmailBrazilInsertCustomerError' event (evid: 715)
 *
 * Event description: R_GoogleEmailBrazilInsertCustomerError.
 *
 * @param {rGoogleEmailBrazilInsertCustomerErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleEmailBrazilInsertCustomerErrorParams>} LogObject<rGoogleEmailBrazilInsertCustomerErrorParams>
 */
export function rGoogleEmailBrazilInsertCustomerError(params) {
    return { evid: 715, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleEmailBrazilInsertCustomerException' event (evid: 716)
 *
 * Event description: R_GoogleEmailBrazilInsertCustomerException.
 *
 * @param {rGoogleEmailBrazilInsertCustomerExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleEmailBrazilInsertCustomerExceptionParams>} LogObject<rGoogleEmailBrazilInsertCustomerExceptionParams>
 */
export function rGoogleEmailBrazilInsertCustomerException(params) {
    return { evid: 716, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleEmailBrazilMailPurchaseSuccess' event (evid: 717)
 *
 * Event description: R_GoogleEmailBrazil_MailPurchaseSuccess.
 *
 * @param {rGoogleEmailBrazilMailPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleEmailBrazilMailPurchaseSuccessParams>} LogObject<rGoogleEmailBrazilMailPurchaseSuccessParams>
 */
export function rGoogleEmailBrazilMailPurchaseSuccess(params) {
    return { evid: 717, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumAsAServicePurchaseBusinessError' event (evid: 7176)
 *
 * Event description: Purchase Business Error - client
 * R_SbsOrderPagePremiumPurchaseBusinessError
 *
 * @param {premiumAsAServicePurchaseBusinessErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} vendorUserGuid - id from vendor
 * @property {string} packagePickerType - package_picker_type
 * @property {string} vendorGuid - appdefid not the guid is SBS
 * @property {string} errorInfo - error_info
 * @property {GUID} uuid - uuid / wix user guid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<premiumAsAServicePurchaseBusinessErrorParams>} LogObject<premiumAsAServicePurchaseBusinessErrorParams>
 */
export function premiumAsAServicePurchaseBusinessError(params) {
    return { evid: 7176, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumAsAServicePurchaseFatalError' event (evid: 7177)
 *
 * Event description: Purchase Fatal Error - client
 * R_SbsOrderPagePremiumPurchaseFatalError
 *
 * @param {premiumAsAServicePurchaseFatalErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} vendorUserGuid - id from vendor
 * @property {string} packagePickerType - package_picker_type
 * @property {string} vendorGuid - appdefid not the guid is SBS
 * @property {string} errorInfo - error_info
 * @property {GUID} uuid - uuid / wix user guid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<premiumAsAServicePurchaseFatalErrorParams>} LogObject<premiumAsAServicePurchaseFatalErrorParams>
 */
export function premiumAsAServicePurchaseFatalError(params) {
    return { evid: 7177, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumAsAServiceClickOnBuyNow' event (evid: 7178)
 *
 * Event description: click on buy now - client
 *
 * @param {premiumAsAServiceClickOnBuyNowParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} vendorUserGuid - id from vendor
 * @property {string} packagePickerType - package_picker_type
 * @property {string} vendorGuid - appdefid not the guid is SBS
 * @property {GUID} uuid - uuid / wix user guid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<premiumAsAServiceClickOnBuyNowParams>} LogObject<premiumAsAServiceClickOnBuyNowParams>
 */
export function premiumAsAServiceClickOnBuyNow(params) {
    return { evid: 7178, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleEmailBrazilMailPurchaseError' event (evid: 718)
 *
 * Event description: R_GoogleEmailBrazil_MailPurchaseError.
 *
 * @param {rGoogleEmailBrazilMailPurchaseErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleEmailBrazilMailPurchaseErrorParams>} LogObject<rGoogleEmailBrazilMailPurchaseErrorParams>
 */
export function rGoogleEmailBrazilMailPurchaseError(params) {
    return { evid: 718, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleEmailBrazilMailPurchaseException' event (evid: 719)
 *
 * Event description: R_GoogleEmailBrazil_MailPurchaseException.
 *
 * @param {rGoogleEmailBrazilMailPurchaseExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleEmailBrazilMailPurchaseExceptionParams>} LogObject<rGoogleEmailBrazilMailPurchaseExceptionParams>
 */
export function rGoogleEmailBrazilMailPurchaseException(params) {
    return { evid: 719, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainCheckConnException' event (evid: 72)
 *
 * Event description: R_DomainCheckConnException.
 *
 * @param {rDomainCheckConnExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainCheckConnExceptionParams>} LogObject<rDomainCheckConnExceptionParams>
 */
export function rDomainCheckConnException(params) {
    return { evid: 72, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vGoogleEmailBrazilPurchaseSuccess' event (evid: 720)
 *
 * Event description: V_GoogleEmailBrazilPurchaseSuccess.
 *
 * @param {vGoogleEmailBrazilPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vGoogleEmailBrazilPurchaseSuccessParams>} LogObject<vGoogleEmailBrazilPurchaseSuccessParams>
 */
export function vGoogleEmailBrazilPurchaseSuccess(params) {
    return { evid: 720, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleEmailBrazilSubmitPackagePickerSuccess' event (evid: 721)
 *
 * Event description: R_GoogleEmailBrazil_SubmitPackagePickerSuccess.
 *
 * @param {rGoogleEmailBrazilSubmitPackagePickerSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleEmailBrazilSubmitPackagePickerSuccessParams>} LogObject<rGoogleEmailBrazilSubmitPackagePickerSuccessParams>
 */
export function rGoogleEmailBrazilSubmitPackagePickerSuccess(params) {
    return { evid: 721, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleEmailBrazilSubmitPackagePickerError' event (evid: 722)
 *
 * Event description: R_GoogleEmailBrazil_SubmitPackagePickerError.
 *
 * @param {rGoogleEmailBrazilSubmitPackagePickerErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleEmailBrazilSubmitPackagePickerErrorParams>} LogObject<rGoogleEmailBrazilSubmitPackagePickerErrorParams>
 */
export function rGoogleEmailBrazilSubmitPackagePickerError(params) {
    return { evid: 722, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleEmailBrazilSubmitPackagePickerException' event (evid: 723)
 *
 * Event description: R_GoogleEmailBrazil_SubmitPackagePickerException.
 *
 * @param {rGoogleEmailBrazilSubmitPackagePickerExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleEmailBrazilSubmitPackagePickerExceptionParams>} LogObject<rGoogleEmailBrazilSubmitPackagePickerExceptionParams>
 */
export function rGoogleEmailBrazilSubmitPackagePickerException(params) {
    return { evid: 723, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aOpenMicrosoftActivateDlg' event (evid: 724)
 *
 * Event description: A_OpenMicrosoftActivateDlg.
 *
 * @param {aOpenMicrosoftActivateDlgParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aOpenMicrosoftActivateDlgParams>} LogObject<aOpenMicrosoftActivateDlgParams>
 */
export function aOpenMicrosoftActivateDlg(params) {
    return { evid: 724, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelFlowPopUpCancelModalOpenedSrc17Evid725' event (evid: 725)
 *
 * Event description: The cancelation modal was opened
 *
 *
 * @param {cancelFlowPopUpCancelModalOpenedSrc17Evid725Params} params - The parameters for this event
 * @property {string} referral - where the flow was initiated from
 * @property {string} subscriptionId - -
 * @return {LogObject<cancelFlowPopUpCancelModalOpenedSrc17Evid725Params>} LogObject<cancelFlowPopUpCancelModalOpenedSrc17Evid725Params>
 */
export function cancelFlowPopUpCancelModalOpenedSrc17Evid725(params) {
    return { evid: 725, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainStorefrontSplitScreenExposureSrc17Evid726' event (evid: 726)
 *
 * Event description: Event is trigger on domain storefront flow for users who eligible for split screen page (after log-in and get domain click)
 *
 * relevant for storefront split page test
 *
 * @param {domainStorefrontSplitScreenExposureSrc17Evid726Params} params - The parameters for this event
 * @property {boolean} is_split_page_view - 1=yeas, 0=no
 * @property {string} domain - domain name
 * @property {string} viewMode - storefront, concierge, focus widget (currently only relevant for storefront)
 * @return {LogObject<domainStorefrontSplitScreenExposureSrc17Evid726Params>} LogObject<domainStorefrontSplitScreenExposureSrc17Evid726Params>
 */
export function domainStorefrontSplitScreenExposureSrc17Evid726(params) {
    return { evid: 726, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelFlowPopUpReasonSelectedSrc17Evid727' event (evid: 727)
 *
 * Event description: Indicate what the user chose a reason for cancelation
 *
 * @param {cancelFlowPopUpReasonSelectedSrc17Evid727Params} params - The parameters for this event
 * @property {string} cancelTextReason - the reason the user chose
 * @property {string} subscriptionId - subscriptionId
 * @return {LogObject<cancelFlowPopUpReasonSelectedSrc17Evid727Params>} LogObject<cancelFlowPopUpReasonSelectedSrc17Evid727Params>
 */
export function cancelFlowPopUpReasonSelectedSrc17Evid727(params) {
    return { evid: 727, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerCheckoutLoadFailedSrc17Evid728' event (evid: 728)
 *
 * Event description: Checkout failed to load
 *
 * @param {packagePickerCheckoutLoadFailedSrc17Evid728Params} params - The parameters for this event
 * @property {number} cycleid - Cycle chosen
 * @property {string} packagePickerType - package_picker_type
 * @property {string} productGuid - productGuid
 * @property {string} siteId - siteId
 * @property {string} failReason - fail_reason
 * @property {boolean} IsCartFlow - is_cart_flow
 * @property {string} cartFlow - cartFlow
 * @property {string} eventAggregator - event_aggregator
 * @return {LogObject<packagePickerCheckoutLoadFailedSrc17Evid728Params>} LogObject<packagePickerCheckoutLoadFailedSrc17Evid728Params>
 */
export function packagePickerCheckoutLoadFailedSrc17Evid728(params) {
    return { evid: 728, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionEligibilityErrorSrc17Evid729' event (evid: 729)
 *
 * Event description: Google Subscription Eligibility Error
 *
 * @param {googleSubscriptionEligibilityErrorSrc17Evid729Params} params - The parameters for this event
 * @property {string} msid - msid
 * @property {string} reasons - Failure reasons
 * @property {string} domain - domain
 * @property {string} productTypeId - productTypeId
 * @property {string} productGuid - product_guid
 * @return {LogObject<googleSubscriptionEligibilityErrorSrc17Evid729Params>} LogObject<googleSubscriptionEligibilityErrorSrc17Evid729Params>
 */
export function googleSubscriptionEligibilityErrorSrc17Evid729(params) {
    return { evid: 729, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDeleteDomainSuccess' event (evid: 73)
 *
 * Event description: R_DeleteDomainSuccess.
 *
 * @param {rDeleteDomainSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDeleteDomainSuccessParams>} LogObject<rDeleteDomainSuccessParams>
 */
export function rDeleteDomainSuccess(params) {
    return { evid: 73, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailBoxRepurchaseExecuteSuccess' event (evid: 730)
 *
 * Event description: When a users repurchase a mailbox and we create a new account with a token from google
 *
 * @param {rGoogleMailBoxRepurchaseExecuteSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} subscriptionId - package_id
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {number} quantity - quantity
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailBoxRepurchaseExecuteSuccessParams>} LogObject<rGoogleMailBoxRepurchaseExecuteSuccessParams>
 */
export function rGoogleMailBoxRepurchaseExecuteSuccess(params) {
    return { evid: 730, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailBoxRepurchaseDeliverySuccess' event (evid: 731)
 *
 * Event description: R_GoogleMailBoxRepurchaseDeliverySuccess.
 *
 * @param {rGoogleMailBoxRepurchaseDeliverySuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailBoxRepurchaseDeliverySuccessParams>} LogObject<rGoogleMailBoxRepurchaseDeliverySuccessParams>
 */
export function rGoogleMailBoxRepurchaseDeliverySuccess(params) {
    return { evid: 731, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aGoogleMailBoxRepurchaseClickRepurchase' event (evid: 732)
 *
 * Event description: A_GoogleMailBoxRepurchaseClickRepurchase.
 *
 * @param {aGoogleMailBoxRepurchaseClickRepurchaseParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aGoogleMailBoxRepurchaseClickRepurchaseParams>} LogObject<aGoogleMailBoxRepurchaseClickRepurchaseParams>
 */
export function aGoogleMailBoxRepurchaseClickRepurchase(params) {
    return { evid: 732, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aRegruConnectDomainSuccess' event (evid: 733)
 *
 * Event description: A_RegruConnectDomainSuccess.
 *
 * @param {aRegruConnectDomainSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aRegruConnectDomainSuccessParams>} LogObject<aRegruConnectDomainSuccessParams>
 */
export function aRegruConnectDomainSuccess(params) {
    return { evid: 733, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aRegruConnectDomainError' event (evid: 734)
 *
 * Event description: A_RegruConnectDomainError.
 *
 * @param {aRegruConnectDomainErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aRegruConnectDomainErrorParams>} LogObject<aRegruConnectDomainErrorParams>
 */
export function aRegruConnectDomainError(params) {
    return { evid: 734, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aRegruConnectDomainException' event (evid: 735)
 *
 * Event description: A_RegruConnectDomainException.
 *
 * @param {aRegruConnectDomainExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aRegruConnectDomainExceptionParams>} LogObject<aRegruConnectDomainExceptionParams>
 */
export function aRegruConnectDomainException(params) {
    return { evid: 735, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailChangePasswordSuccess' event (evid: 736)
 *
 * Event description: Google Mail Change Password Success.
 *
 * @param {rGoogleMailChangePasswordSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailChangePasswordSuccessParams>} LogObject<rGoogleMailChangePasswordSuccessParams>
 */
export function rGoogleMailChangePasswordSuccess(params) {
    return { evid: 736, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailChangePasswordError' event (evid: 737)
 *
 * Event description: Google Mail Change Password Error.
 *
 * @param {rGoogleMailChangePasswordErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailChangePasswordErrorParams>} LogObject<rGoogleMailChangePasswordErrorParams>
 */
export function rGoogleMailChangePasswordError(params) {
    return { evid: 737, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailChangePasswordException' event (evid: 738)
 *
 * Event description: will be deprecated when new flow is 100%
 *
 * @param {rGoogleMailChangePasswordExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailChangePasswordExceptionParams>} LogObject<rGoogleMailChangePasswordExceptionParams>
 */
export function rGoogleMailChangePasswordException(params) {
    return { evid: 738, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailChangePasswordLoginCheckSuccess' event (evid: 739)
 *
 * Event description: R_GoogleMailChangePasswordLoginCheckSuccess.
 *
 * @param {rGoogleMailChangePasswordLoginCheckSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailChangePasswordLoginCheckSuccessParams>} LogObject<rGoogleMailChangePasswordLoginCheckSuccessParams>
 */
export function rGoogleMailChangePasswordLoginCheckSuccess(params) {
    return { evid: 739, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDeleteDomainException' event (evid: 74)
 *
 * Event description: R_DeleteDomainException.
 *
 * @param {rDeleteDomainExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDeleteDomainExceptionParams>} LogObject<rDeleteDomainExceptionParams>
 */
export function rDeleteDomainException(params) {
    return { evid: 74, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailChangePasswordLoginCheckError' event (evid: 740)
 *
 * Event description: R_GoogleMailChangePasswordLoginCheckError.
 *
 * @param {rGoogleMailChangePasswordLoginCheckErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailChangePasswordLoginCheckErrorParams>} LogObject<rGoogleMailChangePasswordLoginCheckErrorParams>
 */
export function rGoogleMailChangePasswordLoginCheckError(params) {
    return { evid: 740, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailChangePasswordLoginCheckException' event (evid: 741)
 *
 * Event description: R_GoogleMailChangePasswordLoginCheckException.
 *
 * @param {rGoogleMailChangePasswordLoginCheckExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailChangePasswordLoginCheckExceptionParams>} LogObject<rGoogleMailChangePasswordLoginCheckExceptionParams>
 */
export function rGoogleMailChangePasswordLoginCheckException(params) {
    return { evid: 741, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailActiveCountSuccess' event (evid: 742)
 *
 * Event description: R_GoogleMailActiveCountSuccess.
 *
 * @param {rGoogleMailActiveCountSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailActiveCountSuccessParams>} LogObject<rGoogleMailActiveCountSuccessParams>
 */
export function rGoogleMailActiveCountSuccess(params) {
    return { evid: 742, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailActiveCountError' event (evid: 743)
 *
 * Event description: R_GoogleMailActiveCountError.
 *
 * @param {rGoogleMailActiveCountErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailActiveCountErrorParams>} LogObject<rGoogleMailActiveCountErrorParams>
 */
export function rGoogleMailActiveCountError(params) {
    return { evid: 743, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailActiveCountException' event (evid: 744)
 *
 * Event description: R_GoogleMailActiveCountException.
 *
 * @param {rGoogleMailActiveCountExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailActiveCountExceptionParams>} LogObject<rGoogleMailActiveCountExceptionParams>
 */
export function rGoogleMailActiveCountException(params) {
    return { evid: 744, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleMailUpdateNumberOfSeatsSuccess' event (evid: 745)
 *
 * Event description: Google Mail Update Number Of Seats Success.
 *
 * @param {googleMailUpdateNumberOfSeatsSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {number} quantity - quantity
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} emailSkuId - email_sku_id
 * @property {number} '9' - cycle_id
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {number} totalSeats - total_seats
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - cycle_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<googleMailUpdateNumberOfSeatsSuccessParams>} LogObject<googleMailUpdateNumberOfSeatsSuccessParams>
 */
export function googleMailUpdateNumberOfSeatsSuccess(params) {
    return { evid: 745, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleMailUpdateNumberOfSeatsError' event (evid: 746)
 *
 * Event description: Google Mail Update Number Of Seats Error.
 *
 * @param {googleMailUpdateNumberOfSeatsErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} emailSkuId - email_sku_id
 * @property {number} '9' - cycle_id
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<googleMailUpdateNumberOfSeatsErrorParams>} LogObject<googleMailUpdateNumberOfSeatsErrorParams>
 */
export function googleMailUpdateNumberOfSeatsError(params) {
    return { evid: 746, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailUpdateNumberOfSeatsException' event (evid: 747)
 *
 * Event description: R_GoogleMailUpdateNumberOfSeatsException.
 *
 * @param {rGoogleMailUpdateNumberOfSeatsExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailUpdateNumberOfSeatsExceptionParams>} LogObject<rGoogleMailUpdateNumberOfSeatsExceptionParams>
 */
export function rGoogleMailUpdateNumberOfSeatsException(params) {
    return { evid: 747, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseErrorSrc17Evid748' event (evid: 748)
 *
 * Event description: G-suite >  Purchase error
 *
 * @param {gSuitePurchaseErrorSrc17Evid748Params} params - The parameters for this event
 * @property {string} errorInfo - error_info
 * @property {string} viewMode - view_mode
 * @property {string} domainName - domain_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {GUID} siteGuid - msid
 * @property {string} ErrorType - error_type
 * @property {string} Action - action
 * @property {string} ClickType - click_type
 * @return {LogObject<gSuitePurchaseErrorSrc17Evid748Params>} LogObject<gSuitePurchaseErrorSrc17Evid748Params>
 */
export function gSuitePurchaseErrorSrc17Evid748(params) {
    return { evid: 748, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelFlowPopUpClickOnCancelNowSrc17Evid749' event (evid: 749)
 *
 * Event description: User clicked on cancel now on the premium cancelation flow
 *
 * @param {cancelFlowPopUpClickOnCancelNowSrc17Evid749Params} params - The parameters for this event
 * @property {string} subscriptionId - subscriptionId
 * @return {LogObject<cancelFlowPopUpClickOnCancelNowSrc17Evid749Params>} LogObject<cancelFlowPopUpClickOnCancelNowSrc17Evid749Params>
 */
export function cancelFlowPopUpClickOnCancelNowSrc17Evid749(params) {
    return { evid: 749, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDeleteDomainError' event (evid: 75)
 *
 * Event description: R_DeleteDomainError.
 *
 * @param {rDeleteDomainErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDeleteDomainErrorParams>} LogObject<rDeleteDomainErrorParams>
 */
export function rDeleteDomainError(params) {
    return { evid: 75, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartDigitalGoodsPurchaseSuccess' event (evid: 750)
 *
 * Event description: R_StartDigitalGoodsPurchaseSuccess
 *
 * @param {rStartDigitalGoodsPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} vendorName - ab_test
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {GUID} skuId - sku_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartDigitalGoodsPurchaseSuccessParams>} LogObject<rStartDigitalGoodsPurchaseSuccessParams>
 */
export function rStartDigitalGoodsPurchaseSuccess(params) {
    return { evid: 750, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changePlanSuccess' event (evid: 7501)
 *
 * Event description: After clicking “confirm plan change” the server returns success (failure doesn't have an event) or change billing cycle (downgrade) completed successfully
 *
 * @param {changePlanSuccessParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} flowType - change_plan/change_billing_cycle
 * @property {string} newProductGuId - newProductGuId
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - subscription_id
 * @property {number} currentCycleId - current billing cycle
 * @property {GUID} userGuid - uuid
 * @property {number} paymentCycle - cycle_id
 * @property {string} changeType - change_billing_cycle /Extend/Grace_period
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {string} user_agent - user_agent
 * @property {number} newInvoiceId - new Invoice id
 * @property {number} site_type - site_type
 * @property {number} newProductId - new product id
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} currentProductGuid - current_product_guid
 * @property {string} pagename - ab_test
 * @property {string} productTypeId - product_type_id
 * @property {number} currentProductId - current Product Id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} newCycleId - new cycle id
 * @property {number} productId - product_id
 * @property {Url} referer - referral
 * @property {GUID} siteId - site_id
 * @property {GUID} packageId - package_id
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<changePlanSuccessParams>} LogObject<changePlanSuccessParams>
 */
export function changePlanSuccess(params) {
    return { evid: 7501, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changePlanDetails' event (evid: 7502)
 *
 * Event description: After choosing the product and clicking on “select” the server returns an answer - server
 *
 * @param {changePlanDetailsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} newProductGuId - new_product_guid
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - subscriptionId
 * @property {number} currentCycleId - current billing cycle
 * @property {GUID} userGuid - uuid
 * @property {string} changeType - Extend//Grace_period
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {number} newProductId - new product id
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} currentProductGuid - current_product_guid
 * @property {string} pagename - ab_test
 * @property {string} productTypeId - product_type_id
 * @property {number} currentProductId - current Product Id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} refundCapabilityType - refundable or NOT_ENOUGH_BALANCE...
 * @property {number} newCycleId - new cycle id
 * @property {Url} referer - referral
 * @property {GUID} siteId - site_id
 * @property {GUID} packageId - package_id
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<changePlanDetailsParams>} LogObject<changePlanDetailsParams>
 */
export function changePlanDetails(params) {
    return { evid: 7502, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changePlanViewCurrentPlan' event (evid: 7503)
 *
 * Event description: open toast and view current plan details - client
 *
 * @param {changePlanViewCurrentPlanParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} changePlanType - product_full_match/ product_partial_match/ product_not_match
 * @property {string} flowType - change plan/ upgrade
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {number} currentCycleId - current billing cycle
 * @property {GUID} userGuid - uuid
 * @property {string} changeType - Extend//Grace_period
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {number} newProductId - new product id
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {number} currentProductId - current Product Id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} refundCapabilityType - refundable or NOT_ENOUGH_BALANCE...
 * @property {number} newCycleId - new cycle id
 * @property {Url} referer - referral
 * @property {GUID} siteId - site_id
 * @property {GUID} packageId - package_id
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<changePlanViewCurrentPlanParams>} LogObject<changePlanViewCurrentPlanParams>
 */
export function changePlanViewCurrentPlan(params) {
    return { evid: 7503, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartDigitalGoodsPurchaseError' event (evid: 751)
 *
 * Event description: don't move me to store. I will die with wix-war. purchase page is not loading (server) R_StartDigitalGoodsPurchaseError
 *
 * @param {rStartDigitalGoodsPurchaseErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartDigitalGoodsPurchaseErrorParams>} LogObject<rStartDigitalGoodsPurchaseErrorParams>
 */
export function rStartDigitalGoodsPurchaseError(params) {
    return { evid: 751, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartDigitalGoodsPurchaseException' event (evid: 752)
 *
 * Event description: don't move me to store. I will die with wix-war. purchase page is not loading (server) R_StartDigitalGoodsPurchaseException
 *
 * @param {rStartDigitalGoodsPurchaseExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartDigitalGoodsPurchaseExceptionParams>} LogObject<rStartDigitalGoodsPurchaseExceptionParams>
 */
export function rStartDigitalGoodsPurchaseException(params) {
    return { evid: 752, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDigitalGoodsPurchaseError' event (evid: 753)
 *
 * Event description: R_DigitalGoodsPurchaseError
 *
 * @param {rDigitalGoodsPurchaseErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} vendorName - ab_test
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {GUID} skuId - sku_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} event_platform - event_platform
 * @return {LogObject<rDigitalGoodsPurchaseErrorParams>} LogObject<rDigitalGoodsPurchaseErrorParams>
 */
export function rDigitalGoodsPurchaseError(params) {
    return { evid: 753, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsOrderPageDigitalGoodsPurchaseBusinessError' event (evid: 754)
 *
 * Event description: R_SbsOrderPageDigitalGoodsPurchaseBusinessError
 *
 * @param {rSbsOrderPageDigitalGoodsPurchaseBusinessErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} vendorName - ab_test
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {GUID} skuId - sku_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsOrderPageDigitalGoodsPurchaseBusinessErrorParams>} LogObject<rSbsOrderPageDigitalGoodsPurchaseBusinessErrorParams>
 */
export function rSbsOrderPageDigitalGoodsPurchaseBusinessError(params) {
    return { evid: 754, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSbsOrderPageDigitalGoodsPurchaseFatalError' event (evid: 755)
 *
 * Event description: R_SbsOrderPageDigitalGoodsPurchaseFatalError
 *
 * @param {rSbsOrderPageDigitalGoodsPurchaseFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} vendorName - ab_test
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {GUID} skuId - sku_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSbsOrderPageDigitalGoodsPurchaseFatalErrorParams>} LogObject<rSbsOrderPageDigitalGoodsPurchaseFatalErrorParams>
 */
export function rSbsOrderPageDigitalGoodsPurchaseFatalError(params) {
    return { evid: 755, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDigitalGoodsPurchaseSuccess' event (evid: 756)
 *
 * Event description: R_DigitalGoodsPurchaseSuccess
 *
 * @param {rDigitalGoodsPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDigitalGoodsPurchaseSuccessParams>} LogObject<rDigitalGoodsPurchaseSuccessParams>
 */
export function rDigitalGoodsPurchaseSuccess(params) {
    return { evid: 756, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDigitalGoodsPurchaseException' event (evid: 757)
 *
 * Event description: don't move me to store. I will die with wix-war. purchase page is not loading (server)  R_DigitalGoodsPurchaseException
 *
 * @param {rDigitalGoodsPurchaseExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDigitalGoodsPurchaseExceptionParams>} LogObject<rDigitalGoodsPurchaseExceptionParams>
 */
export function rDigitalGoodsPurchaseException(params) {
    return { evid: 757, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aDigitalGoodsPurchaseBuyButtonPressed' event (evid: 758)
 *
 * Event description: click on "buy now" digital goods. for now - only WixLogo (client)   A_DigitalGoodsPurchaseBuyButtonPressed
 *
 * @param {aDigitalGoodsPurchaseBuyButtonPressedParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - paymentMethod
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {string} vendorName - ab_test
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - url
 * @property {GUID} skuId - sku - product defination
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<aDigitalGoodsPurchaseBuyButtonPressedParams>} LogObject<aDigitalGoodsPurchaseBuyButtonPressedParams>
 */
export function aDigitalGoodsPurchaseBuyButtonPressed(params) {
    return { evid: 758, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vDigitalGoodsPurchaseSuccess' event (evid: 759)
 *
 * Event description: V_DigitalGoodsPurchaseSuccess
 *
 * @param {vDigitalGoodsPurchaseSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} event_platform - event_platform
 * @return {LogObject<vDigitalGoodsPurchaseSuccessParams>} LogObject<vDigitalGoodsPurchaseSuccessParams>
 */
export function vDigitalGoodsPurchaseSuccess(params) {
    return { evid: 759, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnHowTofb' event (evid: 76)
 *
 * Event description: A_ClickOnHowToFB.
 *
 * @param {aClickOnHowTofbParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnHowTofbParams>} LogObject<aClickOnHowTofbParams>
 */
export function aClickOnHowTofb(params) {
    return { evid: 76, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDigitalGoodsCancelPackageImmediateRequestSuccess' event (evid: 761)
 *
 * Event description: R_DigitalGoodsCancelPackageImmediateRequestSuccess
 *
 * @param {rDigitalGoodsCancelPackageImmediateRequestSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDigitalGoodsCancelPackageImmediateRequestSuccessParams>} LogObject<rDigitalGoodsCancelPackageImmediateRequestSuccessParams>
 */
export function rDigitalGoodsCancelPackageImmediateRequestSuccess(params) {
    return { evid: 761, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleMailBoxUnsuspendExecuteSuccess' event (evid: 762)
 *
 * Event description: When a users repurchase a mailbox and we reactivate the old account (without a token from google)
 *
 * @param {rGoogleMailBoxUnsuspendExecuteSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {number} quantity - quantity
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} emailSkuId - 4, 5
 * @property {number} '9' - 3, 6
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - 3, 6
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleMailBoxUnsuspendExecuteSuccessParams>} LogObject<rGoogleMailBoxUnsuspendExecuteSuccessParams>
 */
export function rGoogleMailBoxUnsuspendExecuteSuccess(params) {
    return { evid: 762, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleAppDomainVerifySuccess' event (evid: 763)
 *
 * Event description: R_GoogleAppDomainVerifySuccess.
 *
 * @param {rGoogleAppDomainVerifySuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {GUID} serviceGuid - service_guid
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleAppDomainVerifySuccessParams>} LogObject<rGoogleAppDomainVerifySuccessParams>
 */
export function rGoogleAppDomainVerifySuccess(params) {
    return { evid: 763, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rGoogleAppDomainVerifyFailure' event (evid: 764)
 *
 * Event description: R_GoogleAppDomainVerifyFailure.
 *
 * @param {rGoogleAppDomainVerifyFailureParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {GUID} serviceGuid - service_guid
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rGoogleAppDomainVerifyFailureParams>} LogObject<rGoogleAppDomainVerifyFailureParams>
 */
export function rGoogleAppDomainVerifyFailure(params) {
    return { evid: 764, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumFunnelInIntroIntentPageViewSrc17Evid765' event (evid: 765)
 *
 * Event description: On the new Premium funnel  flow on intro- view of the page where user chooses to but a new domain or connect existing
 *
 * @param {premiumFunnelInIntroIntentPageViewSrc17Evid765Params} params - The parameters for this event
 * @return {LogObject<premiumFunnelInIntroIntentPageViewSrc17Evid765Params>} LogObject<premiumFunnelInIntroIntentPageViewSrc17Evid765Params>
 */
export function premiumFunnelInIntroIntentPageViewSrc17Evid765(params) {
    return { evid: 765, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumFunnelInIntroIntentPageSelectIntentSrc17Evid766' event (evid: 766)
 *
 * Event description: On the new Premium funnel  flow on intro- click on the page where user chooses to but a new domain or connect existing
 *
 * @param {premiumFunnelInIntroIntentPageSelectIntentSrc17Evid766Params} params - The parameters for this event
 * @property {string} intent - get_domain/connect_domain
 * @return {LogObject<premiumFunnelInIntroIntentPageSelectIntentSrc17Evid766Params>} LogObject<premiumFunnelInIntroIntentPageSelectIntentSrc17Evid766Params>
 */
export function premiumFunnelInIntroIntentPageSelectIntentSrc17Evid766(params) {
    return { evid: 766, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumFunnelInIntroDomainSearchPageViewSrc17Evid767' event (evid: 767)
 *
 * Event description: On the new Premium funnel  flow on intro- user viewed the screen of search domain
 *
 * @param {premiumFunnelInIntroDomainSearchPageViewSrc17Evid767Params} params - The parameters for this event
 * @property {string} intent - get_domain/connect_domain
 * @return {LogObject<premiumFunnelInIntroDomainSearchPageViewSrc17Evid767Params>} LogObject<premiumFunnelInIntroDomainSearchPageViewSrc17Evid767Params>
 */
export function premiumFunnelInIntroDomainSearchPageViewSrc17Evid767(params) {
    return { evid: 767, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumFunnelInIntroDomainSearchPageSwitchIntentSrc17Evid768' event (evid: 768)
 *
 * Event description: On the new Premium funnel  flow on intro- user chose to switch intent from "get" to "connect" or vice versa
 *
 * @param {premiumFunnelInIntroDomainSearchPageSwitchIntentSrc17Evid768Params} params - The parameters for this event
 * @property {string} intent - get_domain/connect_domain
 * @property {string} switchToIntent - the cta the user clicked (get_domain/connect_domain)
 * @return {LogObject<premiumFunnelInIntroDomainSearchPageSwitchIntentSrc17Evid768Params>} LogObject<premiumFunnelInIntroDomainSearchPageSwitchIntentSrc17Evid768Params>
 */
export function premiumFunnelInIntroDomainSearchPageSwitchIntentSrc17Evid768(params) {
    return { evid: 768, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumFunnelInIntroDomainSearchPageClickConnectSrc17Evid769' event (evid: 769)
 *
 * Event description: On the new Premium funnel  flow on intro- user clicked on connect domain (in connect domain intent, in search domain
 *
 * @param {premiumFunnelInIntroDomainSearchPageClickConnectSrc17Evid769Params} params - The parameters for this event
 * @property {string} intent - get_domain/connect_domain
 * @property {string} domain - domain
 * @return {LogObject<premiumFunnelInIntroDomainSearchPageClickConnectSrc17Evid769Params>} LogObject<premiumFunnelInIntroDomainSearchPageClickConnectSrc17Evid769Params>
 */
export function premiumFunnelInIntroDomainSearchPageClickConnectSrc17Evid769(params) {
    return { evid: 769, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnHowTons' event (evid: 77)
 *
 * Event description: A_ClickOnHowToNS.
 *
 * @param {aClickOnHowTonsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnHowTonsParams>} LogObject<aClickOnHowTonsParams>
 */
export function aClickOnHowTons(params) {
    return { evid: 77, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainsVerificationStatusSrc17Evid770' event (evid: 770)
 *
 * Event description: This BI event is triggered when the status of domain verification changes. It starts as 'Waiting for Verification' or 'No Verification Needed' and progresses to 'Verification Success.'
 *
 *
 * @param {domainsVerificationStatusSrc17Evid770Params} params - The parameters for this event
 * @property {string} domain - The domain name
 * @property {string} verificationStatus - Waiting for Verification/No Verification Needed /Verification Success
 * @return {LogObject<domainsVerificationStatusSrc17Evid770Params>} LogObject<domainsVerificationStatusSrc17Evid770Params>
 */
export function domainsVerificationStatusSrc17Evid770(params) {
    return { evid: 770, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsManagerAssign' event (evid: 771)
 *
 * Event description: subscription was assigned successfully to a different site in the user account
 *
 * @param {subscriptionsManagerAssignParams} params - The parameters for this event
 * @property {GUID} uuid - userGuid
 * @property {GUID} toMsid - to msid
 * @property {GUID} subscriptionId - subscription_id - premium
 * @property {GUID} userGuid - userGuid
 * @property {string} productTypeName - product_type_name
 * @property {string} reason - type
 * @property {GUID} fromMsid - from site (can be null)
 * @property {string} externalProvider - external_provider
 * @property {string} productTypeId - product_type_id
 * @property {string} productGuid - product_id
 * @property {number} cycleId - cycle_id
 * @return {LogObject<subscriptionsManagerAssignParams>} LogObject<subscriptionsManagerAssignParams>
 */
export function subscriptionsManagerAssign(params) {
    return { evid: 771, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsManagerUnAssign' event (evid: 772)
 *
 * Event description: subscription was un-assigned successfully from a site
 *
 * @param {subscriptionsManagerUnAssignParams} params - The parameters for this event
 * @property {GUID} uuid - userGuid
 * @property {GUID} subscriptionId - subscription_id - premium
 * @property {GUID} userGuid - userGuid
 * @property {string} productTypeName - product_type_name
 * @property {string} reason - type
 * @property {GUID} fromMsid - from site
 * @property {string} externalProvider - external_provider
 * @property {string} productTypeId - productTypeId
 * @property {string} productGuid - productGuid
 * @property {string} productShortId - product_id
 * @property {number} cycleId - cycle_id
 * @return {LogObject<subscriptionsManagerUnAssignParams>} LogObject<subscriptionsManagerUnAssignParams>
 */
export function subscriptionsManagerUnAssign(params) {
    return { evid: 772, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsManagerAutoRenewOff' event (evid: 773)
 *
 * Event description: user requested to cancel the subscription (subscription is now set to auto-renew-off)
 *
 * @param {subscriptionsManagerAutoRenewOffParams} params - The parameters for this event
 * @property {GUID} uuid - userGuid
 * @property {GUID} subscriptionId - subscription_id - premium
 * @property {GUID} userGuid - userGuid
 * @property {number} cancelReason - reason
 * @property {string} productTypeName - product_type_name
 * @property {string} externalProvider - external_provider
 * @property {string} productTypeId - productTypeId
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - msid
 * @property {number} cycleId - cycle_id
 * @return {LogObject<subscriptionsManagerAutoRenewOffParams>} LogObject<subscriptionsManagerAutoRenewOffParams>
 */
export function subscriptionsManagerAutoRenewOff(params) {
    return { evid: 773, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsManagerAutoRenewOn' event (evid: 774)
 *
 * Event description: user requested to keep his plan. he changed the status from  auto-renew-off to auto-renew-on
 *
 * @param {subscriptionsManagerAutoRenewOnParams} params - The parameters for this event
 * @property {GUID} uuid - userGuid
 * @property {GUID} subscriptionId - subscription_id - premium
 * @property {GUID} userGuid - userGuid
 * @property {string} productTypeName - product_type_name
 * @property {string} externalProvider - external_provider
 * @property {string} productTypeId - productTypeId
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - msid
 * @property {number} cycleId - cycle_id
 * @return {LogObject<subscriptionsManagerAutoRenewOnParams>} LogObject<subscriptionsManagerAutoRenewOnParams>
 */
export function subscriptionsManagerAutoRenewOn(params) {
    return { evid: 774, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsManagerCanceled' event (evid: 775)
 *
 * Event description: subscription was cancelled (immediate, in-trial, passive churn on Monday..)
 *
 * @param {subscriptionsManagerCanceledParams} params - The parameters for this event
 * @property {GUID} uuid - userGuid
 * @property {string} productTypeShortId - id
 * @property {GUID} subscriptionId - subscription_id - premium
 * @property {GUID} userGuid - userGuid
 * @property {number} cancelReason - reason
 * @property {boolean} cancelInTrial - cancel_in_trial (14days)
 * @property {string} productTypeName - product_type_name
 * @property {string} externalProvider - external_provider
 * @property {string} productTypeId - productTypeId
 * @property {string} productGuid - productGuid
 * @property {string} productShortId - product_id
 * @property {GUID} msid - msid
 * @property {number} cycleId - cycle_id
 * @return {LogObject<subscriptionsManagerCanceledParams>} LogObject<subscriptionsManagerCanceledParams>
 */
export function subscriptionsManagerCanceled(params) {
    return { evid: 775, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsManagerSubscriptionCreated' event (evid: 776)
 *
 * Event description: subscription was created in subscription manager DB
 *
 * @param {subscriptionsManagerSubscriptionCreatedParams} params - The parameters for this event
 * @property {GUID} uuid - userGuid
 * @property {GUID} serviceGuid - service_guid
 * @property {string} externalSessionId - external_session_id
 * @property {string} productTypeShortId - id
 * @property {GUID} subscriptionId - subscription_id - premium
 * @property {GUID} userGuid - userGuid
 * @property {string} productTypeName - product_type_name
 * @property {string} newPurchase - true / false
 * @property {string} externalProvider - external_provider
 * @property {string} productTypeId - product_type_id
 * @property {string} productGuid - productGuid
 * @property {string} productShortId - product_id
 * @property {number} cycleId - cycle_id
 * @return {LogObject<subscriptionsManagerSubscriptionCreatedParams>} LogObject<subscriptionsManagerSubscriptionCreatedParams>
 */
export function subscriptionsManagerSubscriptionCreated(params) {
    return { evid: 776, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsManagerSubscriptionDeliverySuccess' event (evid: 777)
 *
 * Event description: subscription delivery success
 *
 * @param {subscriptionsManagerSubscriptionDeliverySuccessParams} params - The parameters for this event
 * @property {GUID} uuid - userGuid
 * @property {string} billingCountry - billing_country
 * @property {GUID} serviceGuid - serviceGuid
 * @property {string} externalSessionId - externalSessionId
 * @property {number} paymentMethod - payment_method
 * @property {GUID} subscriptionId - subscription_id - premium
 * @property {GUID} userGuid - userGuid
 * @property {string} productTypeName - product_type_name
 * @property {string} newPurchase - true / false
 * @property {string} externalProvider - external_provider
 * @property {string} productTypeId - productTypeId
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - msid
 * @property {string} couponId - coupon_id
 * @property {number} cycleId - cycle_id
 * @return {LogObject<subscriptionsManagerSubscriptionDeliverySuccessParams>} LogObject<subscriptionsManagerSubscriptionDeliverySuccessParams>
 */
export function subscriptionsManagerSubscriptionDeliverySuccess(params) {
    return { evid: 777, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsCancelSubscriptionLoaded' event (evid: 7770)
 *
 * Event description: My Subscriptions >  cancel popup > loaded
 *
 * @param {mySubscriptionsCancelSubscriptionLoadedParams} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} productTypeName - product_type_name
 * @property {boolean} isInTrial - true /false
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} type - partners/diy
 * @property {string} productGuid - product_guid
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @property {number} cycleId - cycle_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsCancelSubscriptionLoadedParams>} LogObject<mySubscriptionsCancelSubscriptionLoadedParams>
 */
export function mySubscriptionsCancelSubscriptionLoaded(params) {
    return { evid: 7770, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickCancel' event (evid: 7773)
 *
 * Event description: My Subscriptions >  click "Cancel"
 * dynamic (like 4)
 *
 * @param {mySubscriptionsClickCancelParams} params - The parameters for this event
 * @property {string} viewMode - accountLevel / siteLevel
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} productTypeName - product_type_name
 * @property {boolean} isInTrial - is_in_trial
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} type - partners/diy
 * @property {string} productGuid - product_guid
 * @property {GUID} msid - msid
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @property {number} cycleId - cycle_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickCancelParams>} LogObject<mySubscriptionsClickCancelParams>
 */
export function mySubscriptionsClickCancel(params) {
    return { evid: 7773, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsCancelPopupClick' event (evid: 7774)
 *
 * Event description: My Subscriptions >  cancel popup > click
 *
 * @param {mySubscriptionsCancelPopupClickParams} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - keep / cancel / close X
 * @property {string} productTypeName - product_type_name
 * @property {boolean} isinTrial - true /false
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} choice - Keep, auto-renew-off, Cancel now
 * @property {string} type - partners/diy
 * @property {string} productGuid - product_guid
 * @property {GUID} msid - msid
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @property {number} cycleId - cycle_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsCancelPopupClickParams>} LogObject<mySubscriptionsCancelPopupClickParams>
 */
export function mySubscriptionsCancelPopupClick(params) {
    return { evid: 7774, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsCancelPopup2ndStepClick' event (evid: 7775)
 *
 * Event description: My Subscriptions >  cancel popup  2nd step > click
 *
 * @param {mySubscriptionsCancelPopup2ndStepClickParams} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - Keep, auto-renew-off,Cancel now
 * @property {string} productTypeName - product_type_name
 * @property {boolean} isInTrial - is_in_trial
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} type - partners/diy
 * @property {string} productGuid - product_guid
 * @property {GUID} msid - msid
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @property {number} cycleId - cycle_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsCancelPopup2ndStepClickParams>} LogObject<mySubscriptionsCancelPopup2ndStepClickParams>
 */
export function mySubscriptionsCancelPopup2ndStepClick(params) {
    return { evid: 7775, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsManagerSubscriptionDowngradeSuccess' event (evid: 778)
 *
 * Event description: subscription downgrade success (like 17:7501 from legacy)
 *
 * @param {subscriptionsManagerSubscriptionDowngradeSuccessParams} params - The parameters for this event
 * @property {number} oldCycleId - old_cycle_id
 * @property {string} billingCountry - billing_country
 * @property {GUID} serviceGuid - serviceGuid
 * @property {string} externalSessionId - externalSessionId
 * @property {string} oldProductGuId - old_product_guid
 * @property {string} flowType - flow_type
 * @property {string} newProductGuId - new_product_guid
 * @property {GUID} subscriptionId - subscription_id - premium
 * @property {GUID} userGuid - userGuid
 * @property {string} changeType - Extend/Grace_period
 * @property {string} productTypeName - product_type_name
 * @property {string} externalProvider - external_provider
 * @property {number} newInvoiceId - newInvoiceId
 * @property {string} productTypeId - product_type_id
 * @property {number} newCycleId - new_cycle_id
 * @property {GUID} msid - msid
 * @property {string} couponId - coupon_id
 * @return {LogObject<subscriptionsManagerSubscriptionDowngradeSuccessParams>} LogObject<subscriptionsManagerSubscriptionDowngradeSuccessParams>
 */
export function subscriptionsManagerSubscriptionDowngradeSuccess(params) {
    return { evid: 778, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsDnsErrorByApi' event (evid: 779)
 *
 * Event description: Triggered when the new API for DNS service fails, and fallback to old service takes place. Can be in create, edit or delete DNS
 *
 * @param {myDomainsDnsErrorByApiParams} params - The parameters for this event
 * @property {string} validationMessage - ok | error (exact error text)
 * @property {string} recordType - aname| cname | txt | spf | srv | mx
 * @property {string} errorMessage - Response from server in case of exceptions during “Save” action. Should be null, otherwise indicates that server responded with error
 * @property {string} domain - domain
 * @property {string} uuid - uuid
 * @property {string} mgmtType - 0,1 = connect  , 2 = purchase
 * @property {string} flowName - flow from where the API was called
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} record - JSON with attributes and their values for different record types
 * @return {LogObject<myDomainsDnsErrorByApiParams>} LogObject<myDomainsDnsErrorByApiParams>
 */
export function myDomainsDnsErrorByApi(params) {
    return { evid: 779, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnHowToGoogle' event (evid: 78)
 *
 * Event description: A_ClickOnHowToGoogle.
 *
 * @param {aClickOnHowToGoogleParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnHowToGoogleParams>} LogObject<aClickOnHowToGoogleParams>
 */
export function aClickOnHowToGoogle(params) {
    return { evid: 78, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020IntroPageView' event (evid: 780)
 *
 * Event description: Intro Page View
 *
 * @param {connectDomain2020IntroPageViewParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} tld - top level domain name
 * @property {number} loadingDuration - time to load the page in ms
 * @return {LogObject<connectDomain2020IntroPageViewParams>} LogObject<connectDomain2020IntroPageViewParams>
 */
export function connectDomain2020IntroPageView(params) {
    return { evid: 780, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020IntroPageInteractions' event (evid: 781)
 *
 * Event description: ConnectDomain [2020] > Intro Page Interactions.
 *
 * @param {connectDomain2020IntroPageInteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} action - next/back_bottom/back_top
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020IntroPageInteractionsParams>} LogObject<connectDomain2020IntroPageInteractionsParams>
 */
export function connectDomain2020IntroPageInteractions(params) {
    return { evid: 781, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step1ViewLogInToYourDomainProvider' event (evid: 782)
 *
 * Event description: Step 1 View (Log in to your domain Provider)
 *
 * @param {connectDomain2020Step1ViewLogInToYourDomainProviderParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step1ViewLogInToYourDomainProviderParams>} LogObject<connectDomain2020Step1ViewLogInToYourDomainProviderParams>
 */
export function connectDomain2020Step1ViewLogInToYourDomainProvider(params) {
    return { evid: 782, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step1Interactions' event (evid: 783)
 *
 * Event description: Step 1  Interactions (Log in to your domain Provider)
 *
 * @param {connectDomain2020Step1InteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where users come from
 * @property {GUID} msid - msid
 * @property {string} action - next/hint
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step1InteractionsParams>} LogObject<connectDomain2020Step1InteractionsParams>
 */
export function connectDomain2020Step1Interactions(params) {
    return { evid: 783, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step2ViewFindYourDomainSettingsPage' event (evid: 784)
 *
 * Event description: ConnectDomain [2020] > Step 2 View (Find your domain settings page).
 *
 * @param {connectDomain2020Step2ViewFindYourDomainSettingsPageParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} tld - top-level domain name
 * @return {LogObject<connectDomain2020Step2ViewFindYourDomainSettingsPageParams>} LogObject<connectDomain2020Step2ViewFindYourDomainSettingsPageParams>
 */
export function connectDomain2020Step2ViewFindYourDomainSettingsPage(params) {
    return { evid: 784, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step2Interactions' event (evid: 785)
 *
 * Event description: Step 2  Interactions (Find your domain settings page)
 *
 * @param {connectDomain2020Step2InteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} action - next/hint
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step2InteractionsParams>} LogObject<connectDomain2020Step2InteractionsParams>
 */
export function connectDomain2020Step2Interactions(params) {
    return { evid: 785, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step3ViewFindYourRecords' event (evid: 786)
 *
 * Event description: Step 3 View (Find your records (nameservers/pointing))
 *
 * @param {connectDomain2020Step3ViewFindYourRecordsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step3ViewFindYourRecordsParams>} LogObject<connectDomain2020Step3ViewFindYourRecordsParams>
 */
export function connectDomain2020Step3ViewFindYourRecords(params) {
    return { evid: 786, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step3Interactions' event (evid: 787)
 *
 * Event description: Step 3  Interactions (Find your records)
 *
 * @param {connectDomain2020Step3InteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} action - next/hint/hover
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step3InteractionsParams>} LogObject<connectDomain2020Step3InteractionsParams>
 */
export function connectDomain2020Step3Interactions(params) {
    return { evid: 787, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step4ViewReplaceYourRecords' event (evid: 788)
 *
 * Event description: Step 4 View (Replace your records (nameservers/pointing))
 *
 * @param {connectDomain2020Step4ViewReplaceYourRecordsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step4ViewReplaceYourRecordsParams>} LogObject<connectDomain2020Step4ViewReplaceYourRecordsParams>
 */
export function connectDomain2020Step4ViewReplaceYourRecords(params) {
    return { evid: 788, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step4Interactions' event (evid: 789)
 *
 * Event description: Step 4  Interactions (Replace your records)
 *
 * @param {connectDomain2020Step4InteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} action - next/hint/copy/hover
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step4InteractionsParams>} LogObject<connectDomain2020Step4InteractionsParams>
 */
export function connectDomain2020Step4Interactions(params) {
    return { evid: 789, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnLangSelection' event (evid: 79)
 *
 * Event description: A_ClickOnLangSelection.
 *
 * @param {aClickOnLangSelectionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnLangSelectionParams>} LogObject<aClickOnLangSelectionParams>
 */
export function aClickOnLangSelection(params) {
    return { evid: 79, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020SwitchConnectionMethod' event (evid: 790)
 *
 * Event description: Switch Connection Method (to pointing/nameservers)
 *
 * @param {connectDomain2020SwitchConnectionMethodParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {string} place - 'tutorial' | 'onboarding'
 * @property {string} type - pointing / nameservers
 * @property {GUID} msid - msid
 * @property {string} action - view/close/continue/switch
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020SwitchConnectionMethodParams>} LogObject<connectDomain2020SwitchConnectionMethodParams>
 */
export function connectDomain2020SwitchConnectionMethod(params) {
    return { evid: 790, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changePlanPopupOpened' event (evid: 7900)
 *
 * Event description: change plan popup opened - data from server with event_aggregator
 *
 * @param {changePlanPopupOpenedParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {number} newCycle - new cycle id
 * @property {string} paymentStatus - CHARGE_FAILURE
 * @property {GUID} uuid - user Guid
 * @property {string} acceptLang - accept_lng
 * @property {string} changeType - Extend/Grace_period
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - newPurchase
 * @property {number} site_type - site_type
 * @property {number} newProductId - new product id
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - user package guid
 * @property {number} cycle - current billing cycle
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - current Product Id
 * @property {Url} referer - referral
 * @property {GUID} packageId - user package guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<changePlanPopupOpenedParams>} LogObject<changePlanPopupOpenedParams>
 */
export function changePlanPopupOpened(params) {
    return { evid: 7900, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickConfirmPlanChange' event (evid: 7901)
 *
 * Event description: user is clicking on “confirm plan change” in the popup
 *
 * @param {clickConfirmPlanChangeParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {number} newCycle - new cycle id
 * @property {string} paymentStatus - payment_status
 * @property {GUID} uuid - user Guid
 * @property {string} acceptLang - accept_lng
 * @property {string} changeType - Extend/Grace_period
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - newPurchase
 * @property {number} site_type - site_type
 * @property {number} newProductId - new product id
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - user package guid
 * @property {number} cycle - current billing cycle
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - current Product Id
 * @property {Url} referer - referral
 * @property {GUID} packageId - user package guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<clickConfirmPlanChangeParams>} LogObject<clickConfirmPlanChangeParams>
 */
export function clickConfirmPlanChange(params) {
    return { evid: 7901, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickCancelChangePlan' event (evid: 7902)
 *
 * Event description: user is clicking on “cancel ”  or X in the popup
 *
 * @param {clickCancelChangePlanParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {number} newCycle - new cycle id
 * @property {string} paymentStatus - payment_status
 * @property {GUID} uuid - user Guid
 * @property {string} acceptLang - accept_lng
 * @property {string} changeType - Extend/Grace_period
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - newPurchase
 * @property {number} site_type - site_type
 * @property {number} newProductId - new product id
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - user package guid
 * @property {number} cycle - current billing cycle
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - current Product Id
 * @property {Url} referer - referral
 * @property {GUID} packageId - user package guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<clickCancelChangePlanParams>} LogObject<clickCancelChangePlanParams>
 */
export function clickCancelChangePlan(params) {
    return { evid: 7902, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickPremiumChangePlan' event (evid: 7903)
 *
 * Event description: change plan > click on change plan.
 *
 * @param {clickPremiumChangePlanParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {GUID} siteid - site_id
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - cycle_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<clickPremiumChangePlanParams>} LogObject<clickPremiumChangePlanParams>
 */
export function clickPremiumChangePlan(params) {
    return { evid: 7903, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewOtherPackagePickerOffers' event (evid: 7904)
 *
 * Event description: user is opening the list to view other PP options
 *
 * @param {viewOtherPackagePickerOffersParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {number} newCycle - new cycle id
 * @property {GUID} uuid - user Guid
 * @property {string} acceptLang - accept_lng
 * @property {string} changeType - Extend/Grace_period
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - newPurchase
 * @property {number} site_type - site_type
 * @property {number} newProductId - new product id
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - user package guid
 * @property {number} cycle - current billing cycle
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - current Product Id
 * @property {Url} referer - referral
 * @property {GUID} packageId - user package guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<viewOtherPackagePickerOffersParams>} LogObject<viewOtherPackagePickerOffersParams>
 */
export function viewOtherPackagePickerOffers(params) {
    return { evid: 7904, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectDomain2020TutorialInteractions' event (evid: 791)
 *
 * Event description: Interactions with tutorial (clicks on tabs, click on back)
 *
 * @param {connectDomain2020TutorialInteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} step - active step [ 1 | 2 | 3 | 4 ]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - duration_to_action
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} action - [step_1 | step_2 | step_3 | step_4 ]
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020TutorialInteractionsParams>} LogObject<connectDomain2020TutorialInteractionsParams>
 */
export function connectDomain2020TutorialInteractions(params) {
    return { evid: 791, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cancelFlowPopUpClickCancelFinalCancelSucceededSrc17Evid792' event (evid: 792)
 *
 * Event description: cancel flow > pop up > click cancel (final) > cancel succeeded
 *
 *
 *
 *
 *
 *
 * @param {cancelFlowPopUpClickCancelFinalCancelSucceededSrc17Evid792Params} params - The parameters for this event
 * @property {string} referral - referral
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<cancelFlowPopUpClickCancelFinalCancelSucceededSrc17Evid792Params>} LogObject<cancelFlowPopUpClickCancelFinalCancelSucceededSrc17Evid792Params>
 */
export function cancelFlowPopUpClickCancelFinalCancelSucceededSrc17Evid792(params) {
    return { evid: 792, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsDomainInfoView' event (evid: 793)
 *
 * Event description: Triggered when users see domain info
 *
 * @param {myDomainsDomainInfoViewParams} params - The parameters for this event
 * @property {string} method - pointing/dns
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - true | false
 * @property {string} totalUnassignedDomains - totalUnassignedDomains
 * @property {string} domain - domain name
 * @property {string} totalInactiveDomains - totalInactiveDomains
 * @property {string} totalDomains - the number of domains on the page, if 0 - then empty state
 * @property {boolean} isPublished - sitelevel - true | false, account level - NULL
 * @property {string} registrar - wix/non-wix
 * @property {string} domainStatus - domain status
 * @property {string} totalConnectedDomains - totalConnectedDomains
 * @property {string} referralAdditionalInfo - where users came from
 * @property {DateTime} end - when do we promise connection result
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {boolean} isPremium - has a premium on the current site
 * @property {string} totalAssignedDomains - totalAssignedDomains
 * @property {string} domainLevel - primary/secondary
 * @property {DateTime} start - last connect domain attempt
 * @property {GUID} msid - msid | NULL if domain unassigned
 * @return {LogObject<myDomainsDomainInfoViewParams>} LogObject<myDomainsDomainInfoViewParams>
 */
export function myDomainsDomainInfoView(params) {
    return { evid: 793, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsCongratulationMessageView' event (evid: 794)
 *
 * Event description: Users see congratulation message about successful domain connection.
 *
 * @param {myDomainsCongratulationMessageViewParams} params - The parameters for this event
 * @property {string} method - pointing/dns
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - true | false
 * @property {string} domain - domain name
 * @property {string} elementText - view_site | go_to_site_editor | assign_domain_to_a_site
 * @property {string} totalDomains - the number of domains on the page, if 0 - then empty state
 * @property {boolean} isPublished - sitelevel - true | false, account level - NULL
 * @property {string} registrar - wix/non-wix
 * @property {string} flow - connect_domain | purchase |transfer-in | extend
 * @property {string} referralAdditionalInfo - where users came from
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {boolean} isPremium - has a premium on the current site
 * @property {string} type - unassigned | unpublished | published
 * @property {string} domainLevel - primary/secondary
 * @property {GUID} msid - msid | NULL if domain unassigned
 * @property {string} action - view | click
 * @return {LogObject<myDomainsCongratulationMessageViewParams>} LogObject<myDomainsCongratulationMessageViewParams>
 */
export function myDomainsCongratulationMessageView(params) {
    return { evid: 794, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumAsAServicePurchasePageLoaded' event (evid: 7942)
 *
 * Event description: Purchase page loaded - client
 *
 * @param {premiumAsAServicePurchasePageLoadedParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} vendorUserGuid - id from vendor
 * @property {string} packagePickerType - package_picker_type
 * @property {string} vendorGuid - appdefid not the guid is SBS
 * @property {GUID} uuid - uuid / wix user guid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<premiumAsAServicePurchasePageLoadedParams>} LogObject<premiumAsAServicePurchasePageLoadedParams>
 */
export function premiumAsAServicePurchasePageLoaded(params) {
    return { evid: 7942, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'restoreDomainapi' event (evid: 795)
 *
 * Event description: Triggered when restore domain by API. Might be triggered by Wix user such as immigrator / BatOffice
 *
 * @param {restoreDomainapiParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {GUID} uuid - owner of domain
 * @property {boolean} isSuccess - is delete success
 * @property {GUID} appDefId - application calling the action
 * @property {GUID} agentUuid - uuid performs the action (caller of the API)
 * @return {LogObject<restoreDomainapiParams>} LogObject<restoreDomainapiParams>
 */
export function restoreDomainapi(params) {
    return { evid: 795, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainNttFtIsTrue' event (evid: 796)
 *
 * Event description: when user is experiencing the NTT features (by Petri FT = True)
 *
 * @param {domainNttFtIsTrueParams} params - The parameters for this event
 * @property {DateTime} '5' - date
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<domainNttFtIsTrueParams>} LogObject<domainNttFtIsTrueParams>
 */
export function domainNttFtIsTrue(params) {
    return { evid: 796, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainsServerAppRequestFailure' event (evid: 797)
 *
 * Event description: Triggers in case server fails with 500 error (instead of app)
 *
 * @param {domainsServerAppRequestFailureParams} params - The parameters for this event
 * @property {string} errorInfo - error info
 * @property {string} referralAdditionalInfo - where did users come from
 * @property {string} app - my-domains | get-domain | etc
 * @property {string} requestId - request id
 * @return {LogObject<domainsServerAppRequestFailureParams>} LogObject<domainsServerAppRequestFailureParams>
 */
export function domainsServerAppRequestFailure(params) {
    return { evid: 797, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsStartAppLoad' event (evid: 798)
 *
 * Event description: This events will fire when we start to download MyDomains app. We need it to see cases when the MyDomains page didn't load. In the future we will need to add here EmptyState too. For now we can't do it on old Empty state.
 *
 * @param {myDomainsStartAppLoadParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} referralAdditionalInfo - where users came from
 * @property {GUID} msid - msid for site level, null for account
 * @return {LogObject<myDomainsStartAppLoadParams>} LogObject<myDomainsStartAppLoadParams>
 */
export function myDomainsStartAppLoad(params) {
    return { evid: 798, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'emptyStateInteractions' event (evid: 799)
 *
 * Event description: Interactions (clicks) on Empty state
 *
 * @param {emptyStateInteractionsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} name - 'buy_a_domain' | 'connect_domain_you_already_own' | 'learn_more' | 'transfer_in'
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} totalUnassignedDomains - number of domains
 * @property {string} totalInactiveDomains - number of domains
 * @property {string} totalDomains - number of domains
 * @property {boolean} emptyState - true, false
 * @property {boolean} isPublished - sitelevel - true | false, account level - NULL
 * @property {boolean} hasSites - If the user has sites in the account
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} totalConnectedDomains - number of domains
 * @property {string} referralAdditionalInfo - where users came from
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {GUID} reseller - reseller guid
 * @property {string} pageType - default, reseller
 * @property {boolean} isPremium - has a premium on the current site
 * @property {string} totalAssignedDomains - number of domains
 * @property {GUID} msid - msid for site level, null for account
 * @property {boolean} isSale - true, false
 * @return {LogObject<emptyStateInteractionsParams>} LogObject<emptyStateInteractionsParams>
 */
export function emptyStateInteractions(params) {
    return { evid: 799, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnUpgrade' event (evid: 8)
 *
 * Event description: left banner in billing page
 *
 * @param {aClickOnUpgradeParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnUpgradeParams>} LogObject<aClickOnUpgradeParams>
 */
export function aClickOnUpgrade(params) {
    return { evid: 8, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnTooltipDomain' event (evid: 80)
 *
 * Event description: A_ClickOnTooltipDomain.
 *
 * @param {aClickOnTooltipDomainParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnTooltipDomainParams>} LogObject<aClickOnTooltipDomainParams>
 */
export function aClickOnTooltipDomain(params) {
    return { evid: 80, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnTooltipAdsfree' event (evid: 81)
 *
 * Event description: A_ClickOnTooltipAdsfree.
 *
 * @param {aClickOnTooltipAdsfreeParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnTooltipAdsfreeParams>} LogObject<aClickOnTooltipAdsfreeParams>
 */
export function aClickOnTooltipAdsfree(params) {
    return { evid: 81, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeLocatorResult' event (evid: 8100)
 *
 * Event description: Charge locator result.
 *
 * @param {chargeLocatorResultParams} params - The parameters for this event
 * @property {string} status - notFound / foundWithValidData / foundWithInvalidData
 * @property {string} invoiceNumber - invoice number
 * @return {LogObject<chargeLocatorResultParams>} LogObject<chargeLocatorResultParams>
 */
export function chargeLocatorResult(params) {
    return { evid: 8100, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myDomainsComBrHoverSrc17Evid817' event (evid: 817)
 *
 * Event description: when user put his mouse on the hover that explains on the rules of Brazilian regulations (com.br)
 *
 * @param {myDomainsComBrHoverSrc17Evid817Params} params - The parameters for this event
 * @property {string} viewMode - .
 * @property {string} voucher - true , false
 * @property {string} locale - .
 * @property {boolean} isPremiumSite - .
 * @property {string} actionName - learn more, contact support, hover (com.br hover)
 * @property {string} hasValidVouchers - .
 * @property {string} referralAdditionalInfo - .
 * @property {GUID} msid - site
 * @property {string} domain - The domain that was searched by the user
 * @return {LogObject<myDomainsComBrHoverSrc17Evid817Params>} LogObject<myDomainsComBrHoverSrc17Evid817Params>
 */
export function myDomainsComBrHoverSrc17Evid817(params) {
    return { evid: 817, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumClientMonitoringSrc17Evid818' event (evid: 818)
 *
 * Event description: Premium client monitoring
 *
 * @param {premiumClientMonitoringSrc17Evid818Params} params - The parameters for this event
 * @property {string} referer_host - referer host
 * @property {number} duration - total duration of the request
 * @property {boolean} has_been_active - if the user was active before the resource was fetched (Chrome feature)
 * @property {boolean} is_cached - is_cached
 * @property {number} encoded_body_size - response size (without headers)
 * @property {string} path - resource path
 * @property {number} headers_size - response header size
 * @property {boolean} is_blocking - is_blocking
 * @property {number} stall_queue_time - time that the request was delayed by the browser
 * @property {string} last_referer_host - last_referer_host
 * @property {number} user_interactions_count - user_interactions_count
 * @property {number} response_start - response_start
 * @property {string} last_referer_path_name - last_referer_path_name
 * @property {number} transferSize - transfer_size
 * @property {number} request_start - request_start
 * @property {string} initiator_type - the type of the resource initiator (img, css, xhr, fetch...)
 * @property {string} host_name - resource hostName
 * @property {number} download_time - time to fetch all bytes from the server
 * @property {number} dns_time - time to initiate DNS connection
 * @property {string} pixel_session_id - session id of the running script (per instance)
 * @property {string} navigation_id - navigation_id
 * @property {string} referer_path_name - referer path
 * @property {number} dcl - dom content loaded time
 * @property {number} version_num - script version
 * @property {number} connection_time - time to connect to the server (HTTP)
 * @property {number} response_status_code - response_status_code
 * @property {number} load_time - dom load time
 * @property {string} referer - referer
 * @property {number} server_response_time - time that took the server to retrieve the first byte
 * @property {number} event_start_time - time of the resource event
 * @property {number} dom_complete - dom complete time
 * @property {string} protocol - protocol
 * @property {string} tag - tag
 * @return {LogObject<premiumClientMonitoringSrc17Evid818Params>} LogObject<premiumClientMonitoringSrc17Evid818Params>
 */
export function premiumClientMonitoringSrc17Evid818(params) {
    return { evid: 818, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseDomainSelectionPageViewSrc17Evid819' event (evid: 819)
 *
 * Event description: G-suite purchase > Domain selection page View
 *
 * @param {gSuitePurchaseDomainSelectionPageViewSrc17Evid819Params} params - The parameters for this event
 * @property {DateTime} date_created - date_created
 * @property {string} DeviceFlowType - If this desktop or mobile flow
 * @property {string} city - city
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} error_info - why the user get this page: domains not in account / not in url
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} flowType - If the user had a PP or not
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domains - domains
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {string} siteSegment - site_segment
 * @property {number} NumberOfDomains - number_of_domains
 * @property {boolean} IsDomainSelection - is_domain_selection
 * @property {string} Action - get domain / get business email / select domain+get domain
 * @return {LogObject<gSuitePurchaseDomainSelectionPageViewSrc17Evid819Params>} LogObject<gSuitePurchaseDomainSelectionPageViewSrc17Evid819Params>
 */
export function gSuitePurchaseDomainSelectionPageViewSrc17Evid819(params) {
    return { evid: 819, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePage' event (evid: 820)
 *
 * Event description: User entered the partner package page
 *
 * @param {partnerPackagePageViewPartnerPackagePageParams} params - The parameters for this event
 * @property {string} viewMode - empty_state / no_assigned_sites / sites_assigned
 * @property {number} assignedSites - number of sites assigned
 * @property {GUID} subscriptionId - partner package id
 * @property {number} totalLicenses - number of total licenses purchased
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageParams>} LogObject<partnerPackagePageViewPartnerPackagePageParams>
 */
export function partnerPackagePageViewPartnerPackagePage(params) {
    return { evid: 820, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSubmitForm' event (evid: 821)
 *
 * Event description: user clicked "submit" after entering the "contact us" page
 *
 * @param {partnerPackagePageViewPartnerPackagePageSubmitFormParams} params - The parameters for this event
 * @property {GUID} subscriptionId - partner package id
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSubmitFormParams>} LogObject<partnerPackagePageViewPartnerPackagePageSubmitFormParams>
 */
export function partnerPackagePageViewPartnerPackagePageSubmitForm(params) {
    return { evid: 821, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseDomainSelectionPageClickSrc17Evid822' event (evid: 822)
 *
 * Event description: G-suite purchase > Domain selection page click
 *
 * @param {gSuitePurchaseDomainSelectionPageClickSrc17Evid822Params} params - The parameters for this event
 * @property {DateTime} date_created - date_created
 * @property {string} DeviceFlowType - If this desktop or mobile flow
 * @property {string} city - city
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} error_info - why the user get this page: domains not in account / not in url
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} flowType - If the user had a PP or not
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domains - domains
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {string} siteSegment - site_segment
 * @property {number} NumberOfDomains - number_of_domains
 * @property {boolean} IsDomainSelection - is_domain_selection
 * @property {string} Action - get domain / get business email / select domain+get domain
 * @property {string} NextStep - next_step
 * @return {LogObject<gSuitePurchaseDomainSelectionPageClickSrc17Evid822Params>} LogObject<gSuitePurchaseDomainSelectionPageClickSrc17Evid822Params>
 */
export function gSuitePurchaseDomainSelectionPageClickSrc17Evid822(params) {
    return { evid: 822, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnPackagePickerHoverCopySrc17Evid823' event (evid: 823)
 *
 * Event description: Google Subscription Add-on > Package picker > hover
 *
 * @param {googleSubscriptionAddOnPackagePickerHoverCopySrc17Evid823Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} isNewPurchase - is new purchase or upgarde/change ot existing add-on
 * @property {string} feature - on which feature user hovered
 * @property {string} PopUpType - pop_up_type
 * @property {boolean} IsSale - is_sale
 * @return {LogObject<googleSubscriptionAddOnPackagePickerHoverCopySrc17Evid823Params>} LogObject<googleSubscriptionAddOnPackagePickerHoverCopySrc17Evid823Params>
 */
export function googleSubscriptionAddOnPackagePickerHoverCopySrc17Evid823(params) {
    return { evid: 823, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageClick' event (evid: 824)
 *
 * Event description: User clicked on one of the buttons in the partner package page
 *
 * @param {partnerPackagePageViewPartnerPackagePageClickParams} params - The parameters for this event
 * @property {number} assignedSites - number of sites assigned
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - Assign Plans(top) / Assign Plans(Congrats) / Assign Plans(package) / close / actions/ tier benefits / assign more plans
 * @property {string} viewmode - empty_state / no_assigned_sites / sites_assigned
 * @property {number} totalLicenses - number of total licenses purchased
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageClickParams>} LogObject<partnerPackagePageViewPartnerPackagePageClickParams>
 */
export function partnerPackagePageViewPartnerPackagePageClick(params) {
    return { evid: 824, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageViewAssignPlansClick' event (evid: 825)
 *
 * Event description: User chose plans to assign and clicked assign or closed the window
 *
 * @param {partnerPackagePageViewPartnerPackagePageViewAssignPlansClickParams} params - The parameters for this event
 * @property {GUID} subscriptionId - partner package id
 * @property {number} numOfSubscriptionsAssigned - number of assigned subscriptions
 * @property {string} clickType - cancel / close / assign
 * @property {string} productTypeName - product type name
 * @property {string} assignedSitesIds - ids of the assigned sites
 * @property {string} productTypeId - product type id
 * @property {string} assignedClientsIds - ids of the assigned clients
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageViewAssignPlansClickParams>} LogObject<partnerPackagePageViewPartnerPackagePageViewAssignPlansClickParams>
 */
export function partnerPackagePageViewPartnerPackagePageViewAssignPlansClick(params) {
    return { evid: 825, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSiteActionMenu' event (evid: 826)
 *
 * Event description: User clicked the site action button and chose one of the options
 *
 * @param {partnerPackagePageViewPartnerPackagePageSiteActionMenuParams} params - The parameters for this event
 * @property {GUID} clientId - client id of the chosen site
 * @property {GUID} licenseId - assigned license id of the chosen site
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - connect/view_features/unassign_plan/unassign_client/assign_client
 * @property {string} productTypeName - product name_on_screen
 * @property {string} productTypeId - product_guid
 * @property {GUID} msid - the chosen site guid
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuParams>} LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuParams>
 */
export function partnerPackagePageViewPartnerPackagePageSiteActionMenu(params) {
    return { evid: 826, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignPlan' event (evid: 827)
 *
 * Event description: User clicked on unassign license from a site and reached the unassign page
 *
 * @param {partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignPlanParams} params - The parameters for this event
 * @property {GUID} clientId - client id of the chosen site
 * @property {GUID} licenseId - assigned license id of the chosen site
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - cancel/unassign/close
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @property {GUID} msid - the chosen site guid
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignPlanParams>} LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignPlanParams>
 */
export function partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignPlan(params) {
    return { evid: 827, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSiteActionMenuAssignClient' event (evid: 828)
 *
 * Event description: User entered the assign client for a specific site and clicked on one of the options
 *
 * @param {partnerPackagePageViewPartnerPackagePageSiteActionMenuAssignClientParams} params - The parameters for this event
 * @property {GUID} clientId - client id of the chosen site
 * @property {GUID} licenseId - assigned license id of the chosen site
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - cancel/back/close/create_assign /add_new_contact
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @property {GUID} msid - the chosen site guid
 * @property {GUID} siteGuid - the chosen site guid
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuAssignClientParams>} LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuAssignClientParams>
 */
export function partnerPackagePageViewPartnerPackagePageSiteActionMenuAssignClient(params) {
    return { evid: 828, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSiteActionMenuNewContact' event (evid: 829)
 *
 * Event description: User entered the add new contact page and clicked on one of the options
 *
 * @param {partnerPackagePageViewPartnerPackagePageSiteActionMenuNewContactParams} params - The parameters for this event
 * @property {GUID} clientId - client id of the chosen site
 * @property {GUID} licenseId - assigned license id of the chosen site
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - cancel/back/close/create_assign
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @property {GUID} msid - the chosen site guid
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuNewContactParams>} LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuNewContactParams>
 */
export function partnerPackagePageViewPartnerPackagePageSiteActionMenuNewContact(params) {
    return { evid: 829, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnTooltipGoogle' event (evid: 83)
 *
 * Event description: A_ClickOnTooltipGoogle.
 *
 * @param {aClickOnTooltipGoogleParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnTooltipGoogleParams>} LogObject<aClickOnTooltipGoogleParams>
 */
export function aClickOnTooltipGoogle(params) {
    return { evid: 83, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignClient' event (evid: 830)
 *
 * Event description: User chose to unassign a client from a specific site and clicked on one of the options in the unassign client page
 *
 * @param {partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignClientParams} params - The parameters for this event
 * @property {GUID} clientId - client id of the chosen site
 * @property {GUID} licenseId - assigned license id of the chosen site
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - cancel/close/unassign
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @property {GUID} msid - the chosen site guid
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignClientParams>} LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignClientParams>
 */
export function partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignClient(params) {
    return { evid: 830, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageActionMenu' event (evid: 831)
 *
 * Event description: User clicked on one of the actions from the actions menu
 *
 * @param {partnerPackagePageViewPartnerPackagePageActionMenuParams} params - The parameters for this event
 * @property {number} assignedSites - number of sites assigned
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - manage / tier_benefits
 * @property {string} viewmode - empty_state / no_assigned_sites / sites_assigned
 * @property {number} totalLicenses - number of total licenses purchased
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageActionMenuParams>} LogObject<partnerPackagePageViewPartnerPackagePageActionMenuParams>
 */
export function partnerPackagePageViewPartnerPackagePageActionMenu(params) {
    return { evid: 831, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageContactUsFullUseClick' event (evid: 832)
 *
 * Event description: User clicked on "contact us" after assigning all his licenses
 *
 * @param {partnerPackagePageViewPartnerPackagePageContactUsFullUseClickParams} params - The parameters for this event
 * @property {number} assignedSites - number of sites assigned
 * @property {GUID} subscriptionId - partner package id
 * @property {string} viewmode - empty_state / no_assigned_sites / sites_assigned
 * @property {number} totalLicenses - number of total licenses purchased
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageContactUsFullUseClickParams>} LogObject<partnerPackagePageViewPartnerPackagePageContactUsFullUseClickParams>
 */
export function partnerPackagePageViewPartnerPackagePageContactUsFullUseClick(params) {
    return { evid: 832, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageViewAssignPlansAssignOverPremiumClick' event (evid: 833)
 *
 * Event description: user assign a partner package plan to a site with an existing premium
 *
 * @param {partnerPackagePageViewPartnerPackagePageViewAssignPlansAssignOverPremiumClickParams} params - The parameters for this event
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - back / cancel / assign / close
 * @property {string} assignedSitesIds - ids of the assigned sites
 * @property {string} assignedClientsIds - ids of the assigned clients
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageViewAssignPlansAssignOverPremiumClickParams>} LogObject<partnerPackagePageViewPartnerPackagePageViewAssignPlansAssignOverPremiumClickParams>
 */
export function partnerPackagePageViewPartnerPackagePageViewAssignPlansAssignOverPremiumClick(params) {
    return { evid: 833, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnPackagePickerViewCopySrc17Evid834' event (evid: 834)
 *
 * Event description: Google Subscription Add-on > Checkout page > view
 *
 * @param {googleSubscriptionAddOnPackagePickerViewCopySrc17Evid834Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} isNewPurchase - is new purchase or upgarde/change or existing add-on
 * @property {boolean} IsSaleBanner - Does a sale banner appear?
 * @property {boolean} IsGeminiEarlyAccessPopup - Is gemini early access pop-up view
 * @property {string} PopupType - Pop up type
 *
 * @property {string} SaleType - sale_type
 * @return {LogObject<googleSubscriptionAddOnPackagePickerViewCopySrc17Evid834Params>} LogObject<googleSubscriptionAddOnPackagePickerViewCopySrc17Evid834Params>
 */
export function googleSubscriptionAddOnPackagePickerViewCopySrc17Evid834(params) {
    return { evid: 834, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnCancellationModalSrc17Evid835' event (evid: 835)
 *
 * Event description: Google Subscription Add-on > Cancellation modal
 *
 * @param {googleSubscriptionAddOnCancellationModalSrc17Evid835Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} action - view or click on one of the CTAs (CTA name)
 * @property {string} click_type - click_type
 * @return {LogObject<googleSubscriptionAddOnCancellationModalSrc17Evid835Params>} LogObject<googleSubscriptionAddOnCancellationModalSrc17Evid835Params>
 */
export function googleSubscriptionAddOnCancellationModalSrc17Evid835(params) {
    return { evid: 835, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainSearchPremiumUpgradePopUpCtaClickSrc17Evid837' event (evid: 837)
 *
 * Event description: Domain Search - Premium Upgrade Pop-Up - CTA Click
 *
 * @param {domainSearchPremiumUpgradePopUpCtaClickSrc17Evid837Params} params - The parameters for this event
 * @property {string} 'View mode' - split page / mobile / domain only removal
 * @property {string} 'CTA Click' - upgrade / back / any other CTA available
 * @property {string} domain - domain name
 * @property {string} referral_additional_info - origin funnel of the page - concierge/ storefront etc
 * @return {LogObject<domainSearchPremiumUpgradePopUpCtaClickSrc17Evid837Params>} LogObject<domainSearchPremiumUpgradePopUpCtaClickSrc17Evid837Params>
 */
export function domainSearchPremiumUpgradePopUpCtaClickSrc17Evid837(params) {
    return { evid: 837, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleSubscriptionAddOnAddOnPurchaseSuccessCopySrc17Evid838' event (evid: 838)
 *
 * Event description: Google Subscription Add-on > Add-on Purchase Success
 *
 * @param {googleSubscriptionAddOnAddOnPurchaseSuccessCopySrc17Evid838Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} productId - add-on product guid if available
 * @property {GUID} productTypeId - add-on product type guid
 * @property {string} productName - add-on product name if available
 * @property {string} productTypeName - add-on product type name
 * @property {number} cycleId - add-on cycle id (3 monthly, 6 yeary etc)
 * @property {string} cycleName - add-on cycle name (Monthly, Yearly)
 * @property {number} quantity - add-on number of seats
 * @property {string} googleSku - add-on google sku if available
 * @property {GUID} emailPackageGuid - GWS subscription id
 * @property {GUID} gwsProductId - GWS product guid
 * @property {string} gwsProductName - GWS product name
 * @property {number} gwsQuantity - GWS number of seats
 * @property {number} gwsCycleId - GWS cycle id
 * @property {string} gwsCycleName - GWS cycle name
 * @property {string} domain - domain name
 * @property {string} isNewPurchase - is new purchase or upgarde/change ot existing add-on
 * @property {boolean} IsSale - Is_sale
 * @property {string} subscriptionGuid - subscription_guid
 * @return {LogObject<googleSubscriptionAddOnAddOnPurchaseSuccessCopySrc17Evid838Params>} LogObject<googleSubscriptionAddOnAddOnPurchaseSuccessCopySrc17Evid838Params>
 */
export function googleSubscriptionAddOnAddOnPurchaseSuccessCopySrc17Evid838(params) {
    return { evid: 838, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnTooltipStorage' event (evid: 84)
 *
 * Event description: A_ClickOnTooltipStorage.
 *
 * @param {aClickOnTooltipStorageParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnTooltipStorageParams>} LogObject<aClickOnTooltipStorageParams>
 */
export function aClickOnTooltipStorage(params) {
    return { evid: 84, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dayfulPackagePickerLoad' event (evid: 840)
 *
 * Event description: Dayful Plan PP page is loaded
 *
 * @param {dayfulPackagePickerLoadParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} changePlanType - change_plan_type
 * @property {string} intent - intent
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} productid - not relevant
 * @property {string} eventAggregator - event_aggregator
 * @property {string} productTypeName - From DO
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} currentProductGuid - currentProductGuid
 * @property {number} cycle - 3/6
 * @property {string} pagename - ab_test
 * @property {string} ppType - pp_type
 * @property {string} productTypeId - productTypeId
 * @property {string} offeringGuid - offering_guid
 * @property {number} currentProductId - current_product_id
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} currency - currency
 * @property {Url} referer - referral
 * @property {string} offeringType - Seasonal / Personal / Default
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} pricing - json
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<dayfulPackagePickerLoadParams>} LogObject<dayfulPackagePickerLoadParams>
 */
export function dayfulPackagePickerLoad(params) {
    return { evid: 840, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dayfulUserEnteredRestrictedPage' event (evid: 841)
 *
 * Event description: The event is fired every time a Dayful user enters (view) a page he shouldn't be able entering to
 *
 * @param {dayfulUserEnteredRestrictedPageParams} params - The parameters for this event
 * @property {string} referringUrl - url the user came from
 * @property {string} referralAdditionalInfo - entry point
 * @property {GUID} msid - dayful site id
 * @return {LogObject<dayfulUserEnteredRestrictedPageParams>} LogObject<dayfulUserEnteredRestrictedPageParams>
 */
export function dayfulUserEnteredRestrictedPage(params) {
    return { evid: 841, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainBundleEligibilitySrc17Evid844' event (evid: 844)
 *
 * Event description: check for each concierge search or premium success page if the user is eligible for bundle or not
 *
 * @param {domainBundleEligibilitySrc17Evid844Params} params - The parameters for this event
 * @property {string} domain - main domain name
 * @property {string} secondDomainName - available domain name in bundle
 * @property {string} flowType - Concierge Search / Plan Success Page
 * @property {boolean} isBundleExist - True / False
 * @return {LogObject<domainBundleEligibilitySrc17Evid844Params>} LogObject<domainBundleEligibilitySrc17Evid844Params>
 */
export function domainBundleEligibilitySrc17Evid844(params) {
    return { evid: 844, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnTooltipbandwidth' event (evid: 85)
 *
 * Event description: A_ClickOnTooltipbandwidth.
 *
 * @param {aClickOnTooltipbandwidthParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnTooltipbandwidthParams>} LogObject<aClickOnTooltipbandwidthParams>
 */
export function aClickOnTooltipbandwidth(params) {
    return { evid: 85, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteAcceptScreenLoad' event (evid: 850)
 *
 * Event description: transfer site accept screen load (1st screen)
 *
 * @param {premiumTransferSiteAcceptScreenLoadParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteAcceptScreenLoadParams>} LogObject<premiumTransferSiteAcceptScreenLoadParams>
 */
export function premiumTransferSiteAcceptScreenLoad(params) {
    return { evid: 850, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteAcceptScreen' event (evid: 8501)
 *
 * Event description: Transfer Site accept screen (1st screen)
 *
 * @param {premiumTransferSiteAcceptScreenParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {GUID} uuid - uuid
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {string} acceptLang - accept_lng
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} newUserGuid - uuid
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<premiumTransferSiteAcceptScreenParams>} LogObject<premiumTransferSiteAcceptScreenParams>
 */
export function premiumTransferSiteAcceptScreen(params) {
    return { evid: 8501, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteBillingInfo' event (evid: 8502)
 *
 * Event description: Transfer Site billing info  (2nd screen)
 *
 * @param {premiumTransferSiteBillingInfoParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {GUID} uuid - uuid
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {string} acceptLang - accept_lng
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} newUserGuid - uuid
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<premiumTransferSiteBillingInfoParams>} LogObject<premiumTransferSiteBillingInfoParams>
 */
export function premiumTransferSiteBillingInfo(params) {
    return { evid: 8502, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkoutPageClickOnLink' event (evid: 8504)
 *
 * Event description: Checkout Page > Click on Link
 *
 * @param {checkoutPageClickOnLinkParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {string} tooltipName - link_name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - should be account or site level
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPageClickOnLinkParams>} LogObject<checkoutPageClickOnLinkParams>
 */
export function checkoutPageClickOnLink(params) {
    return { evid: 8504, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteHover' event (evid: 8505)
 *
 * Event description: Client
 *
 * @param {gSuiteHoverParams} params - The parameters for this event
 * @property {string} siteTypeName - siteTypeName
 * @property {string} selected_value - The plan type id (starter/standard/plus)
 * @property {string} fromStep - step1_qty / step2_cycle /  step3 _pay
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - quantity - selected qty
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - Mailbox/BusinessEmail/Migration
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - Next / skip this step / header
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} definedEmails - defined_emails - Number of defined emails
 * @property {string} pagename - ab_test
 * @property {string} selectedValue - The plan type id (starter/standard/plus)
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - Seats names and source
 * @property {Url} referer - referral
 * @property {boolean} isDisabled - true/false
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site Guid
 * @property {string} siteSegment - The version of the seats selection (store or other)
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} toStep - step1_qty / step2_cycle /  step3 _pay
 * @return {LogObject<gSuiteHoverParams>} LogObject<gSuiteHoverParams>
 */
export function gSuiteHover(params) {
    return { evid: 8505, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteScroll' event (evid: 8506)
 *
 * Event description: Client
 *
 * @param {gSuiteScrollParams} params - The parameters for this event
 * @property {string} siteTypeName - siteTypeName
 * @property {string} fromStep - step1_qty / step2_cycle /  step3 _pay
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - voucher
 * @property {number} quantity - quantity - selected qty
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - Next / skip this step / header
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} definedEmails - defined_emails - Number of defined emails
 * @property {string} pagename - ab_test
 * @property {string} selected_value - ‘Starter’/‘Standard’/’Plus’
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - Seats names and source
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site Guid
 * @property {string} siteSegment - The version of the seats selection (store or other)
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} toStep - to_step
 * @return {LogObject<gSuiteScrollParams>} LogObject<gSuiteScrollParams>
 */
export function gSuiteScroll(params) {
    return { evid: 8506, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteFaqClick' event (evid: 8507)
 *
 * Event description: Client
 *
 * @param {gSuiteFaqClickParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - voucher
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - open/close
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} questionType - question title. e.g "How do I get my free domain?"
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} DeviceFlowType - device_flow_type
 * @return {LogObject<gSuiteFaqClickParams>} LogObject<gSuiteFaqClickParams>
 */
export function gSuiteFaqClick(params) {
    return { evid: 8507, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteStarterFewerFeatureModal' event (evid: 8508)
 *
 * Event description: Client
 *
 * @param {gSuiteStarterFewerFeatureModalParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - voucher
 * @property {string} modalType - lose features / more features
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - open/close
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} recommendedPlan - The plan that is recommended by Google (starter/standard/plus)
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} modalPlan - The plan which the user clicked the disclaimer
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuiteStarterFewerFeatureModalParams>} LogObject<gSuiteStarterFewerFeatureModalParams>
 */
export function gSuiteStarterFewerFeatureModal(params) {
    return { evid: 8508, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuiteLoseFeaturesDisclaimer' event (evid: 8509)
 *
 * Event description: Client
 *
 * @param {gSuiteLoseFeaturesDisclaimerParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - open/close
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} questionType - question title. e.g "How do I get my free domain?"
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} recommendedPlan - The plan that is recommended by Google (starter/standard/plus)
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} modalPlan - The plan which the user clicked the disclaimer
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuiteLoseFeaturesDisclaimerParams>} LogObject<gSuiteLoseFeaturesDisclaimerParams>
 */
export function gSuiteLoseFeaturesDisclaimer(params) {
    return { evid: 8509, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteAcceptScreenClickNext' event (evid: 851)
 *
 * Event description: Premium > Transfer Site accept screen click next (1st screen)
 *
 * @param {premiumTransferSiteAcceptScreenClickNextParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react transfer
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteAcceptScreenClickNextParams>} LogObject<premiumTransferSiteAcceptScreenClickNextParams>
 */
export function premiumTransferSiteAcceptScreenClickNext(params) {
    return { evid: 851, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseStep15ProductLearnMoreClick' event (evid: 8510)
 *
 * Event description: G-suite purchase, step1.5 (product) Learn More click
 *
 * @param {gSuitePurchaseStep15ProductLearnMoreClickParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - voucher
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - open/close
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuitePurchaseStep15ProductLearnMoreClickParams>} LogObject<gSuitePurchaseStep15ProductLearnMoreClickParams>
 */
export function gSuitePurchaseStep15ProductLearnMoreClick(params) {
    return { evid: 8510, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePpSelectButtonClick' event (evid: 8511)
 *
 * Event description: Client G-suite > PP select button click
 *
 * @param {gSuitePpSelectButtonClickParams} params - The parameters for this event
 * @property {string} siteTypeName - siteTypeName
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - quantity - selected qty
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - Mailbox/BusinessEmail/Migration
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} selectedValue - click type
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - Seats names and source
 * @property {string} recommendedPlan - recommended plan
 * @property {Url} referer - referral
 * @property {boolean} isDisabled - true/false
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site Guid
 * @property {string} siteSegment - The version of the seats selection (store or other)
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} DeviceFlowType - device_flow_type
 * @property {string} ProductName - ProductName
 * @property {string} SuggestedTiers - starter / all/ null
 * @property {string} ProductId - productid
 * @return {LogObject<gSuitePpSelectButtonClickParams>} LogObject<gSuitePpSelectButtonClickParams>
 */
export function gSuitePpSelectButtonClick(params) {
    return { evid: 8511, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchasePackagePickerLoadingError' event (evid: 8513)
 *
 * Event description: Error in loading the mailbox Package Picker
 *
 * @param {gSuitePurchasePackagePickerLoadingErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - True/False
 * @property {number} quantity - quantity
 * @property {string} errorInfo - error_info
 * @property {string} errorMessage - error
 * @property {number} emailSkuId - email_sku_id
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {string} errorClassName - error type
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuitePurchasePackagePickerLoadingErrorParams>} LogObject<gSuitePurchasePackagePickerLoadingErrorParams>
 */
export function gSuitePurchasePackagePickerLoadingError(params) {
    return { evid: 8513, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchase2ndUpgradeEligibilityForUpgradeCheckNew' event (evid: 8514)
 *
 * Event description: G-suite purchase > 2nd upgrade > eligibility for upgrade check
 *
 * @param {gSuitePurchase2ndUpgradeEligibilityForUpgradeCheckNewParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {number} quantity - quantity
 * @property {boolean} canUpgrade - can upgrade or not
 * @property {string} errorInfo - error_info
 * @property {number} emailSkuId - email_sku_id
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} userGuid - uuid
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} eligible - is eligible for upgrade
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuitePurchase2ndUpgradeEligibilityForUpgradeCheckNewParams>} LogObject<gSuitePurchase2ndUpgradeEligibilityForUpgradeCheckNewParams>
 */
export function gSuitePurchase2ndUpgradeEligibilityForUpgradeCheckNew(params) {
    return { evid: 8514, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gSuitePurchase2ndUpgradeEligibilityForUpgradeCheck' event (evid: 8515)
 *
 * Event description: G-suite purchase > 2nd upgrade > eligibility for upgrade check
 *
 * @param {gSuitePurchase2ndUpgradeEligibilityForUpgradeCheckParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {number} quantity - quantity
 * @property {boolean} canUpgrade - can upgrade or not
 * @property {string} errorInfo - error_info
 * @property {number} emailSkuId - email_sku_id
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuitePurchase2ndUpgradeEligibilityForUpgradeCheckParams>} LogObject<gSuitePurchase2ndUpgradeEligibilityForUpgradeCheckParams>
 */
export function gSuitePurchase2ndUpgradeEligibilityForUpgradeCheck(params) {
    return { evid: 8515, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleMailPriceIncreaseEmailReceived' event (evid: 8516)
 *
 * Event description: When the backend process checks if the email was received based on the kafka list we created it either send a notification to the user or triggers this event
 *
 * @param {googleMailPriceIncreaseEmailReceivedParams} params - The parameters for this event
 * @property {number} quantity - number of seats
 * @property {number} emailSkuId - email_sku_id
 * @property {GUID} emailPackageGuid - email package guid
 * @property {string} domain - domain name
 * @property {GUID} uuid - uuid
 * @property {string} subscriptionId - email package guid
 * @property {GUID} userGuid - uuid
 * @property {string} user_agent - user_agent
 * @property {number} cycleId - cycle id
 * @return {LogObject<googleMailPriceIncreaseEmailReceivedParams>} LogObject<googleMailPriceIncreaseEmailReceivedParams>
 */
export function googleMailPriceIncreaseEmailReceived(params) {
    return { evid: 8516, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'purchasePageTimeoutForCouponFromDealer' event (evid: 8517)
 *
 * Event description: This event is fired when we get timeout from dealer after requesting coupon
 * https://jira.wixpress.com/browse/PREM2-12949
 *
 * @param {purchasePageTimeoutForCouponFromDealerParams} params - The parameters for this event
 * @property {string} siteTypeName - -
 * @property {string} packagePickerType - -
 * @property {string} externalSessionId - -
 * @property {GUID} uuid - -
 * @property {string} acceptLang - -
 * @property {string} eventAggregator - event aggregator
 * @property {string} newPurchase - false, true
 * @property {number} site_type - site_type
 * @property {string} premiumLng - -
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - -
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - premium product id
 * @property {Url} referer - referral
 * @property {number} referralType - -
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - -
 * @return {LogObject<purchasePageTimeoutForCouponFromDealerParams>} LogObject<purchasePageTimeoutForCouponFromDealerParams>
 */
export function purchasePageTimeoutForCouponFromDealer(params) {
    return { evid: 8517, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'timeoutFromDealerForCouponInPurchasePage' event (evid: 8518)
 *
 * Event description: This event is fired when we get timeout from dealer after requesting coupon
 * https://jira.wixpress.com/browse/PREM2-12949
 *
 * @param {timeoutFromDealerForCouponInPurchasePageParams} params - The parameters for this event
 * @property {string} siteTypeName - -
 * @property {string} packagePickerType - -
 * @property {GUID} uuid - -
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - premium product id
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - -
 * @return {LogObject<timeoutFromDealerForCouponInPurchasePageParams>} LogObject<timeoutFromDealerForCouponInPurchasePageParams>
 */
export function timeoutFromDealerForCouponInPurchasePage(params) {
    return { evid: 8518, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bundlePurchaseViewSuccessPageSrc17Evid8519' event (evid: 8519)
 *
 * Event description: Bundle Plan purchase success page - client  (when plan is purchased alone, evid 17:147 is triggered)
 *
 * @param {bundlePurchaseViewSuccessPageSrc17Evid8519Params} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - true/false
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} flow - express_checkout
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - product_id
 * @property {string} pageType - default success page / connect domain success page
 * @property {Url} referer - referral
 * @property {string} productGuid - Product Guid
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} product - bundle_domain_plan
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<bundlePurchaseViewSuccessPageSrc17Evid8519Params>} LogObject<bundlePurchaseViewSuccessPageSrc17Evid8519Params>
 */
export function bundlePurchaseViewSuccessPageSrc17Evid8519(params) {
    return { evid: 8519, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteAcceptScreenClickViewSite' event (evid: 852)
 *
 * Event description: transfer site accept screen click view_site (1st screen)
 *
 * @param {premiumTransferSiteAcceptScreenClickViewSiteParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteAcceptScreenClickViewSiteParams>} LogObject<premiumTransferSiteAcceptScreenClickViewSiteParams>
 */
export function premiumTransferSiteAcceptScreenClickViewSite(params) {
    return { evid: 852, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteBillingInfoLoad' event (evid: 853)
 *
 * Event description: transfer site  billing info load (2nd screen)
 *
 * @param {premiumTransferSiteBillingInfoLoadParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteBillingInfoLoadParams>} LogObject<premiumTransferSiteBillingInfoLoadParams>
 */
export function premiumTransferSiteBillingInfoLoad(params) {
    return { evid: 853, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteBillingInfoClickNext' event (evid: 854)
 *
 * Event description: transfer site billing info click next (in case there is one more step) (2nd screen)
 *
 * @param {premiumTransferSiteBillingInfoClickNextParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteBillingInfoClickNextParams>} LogObject<premiumTransferSiteBillingInfoClickNextParams>
 */
export function premiumTransferSiteBillingInfoClickNext(params) {
    return { evid: 854, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteBillingInfoUserError' event (evid: 855)
 *
 * Event description: transfer site billing info user error (in case there is an error) (2nd screen)
 *
 * @param {premiumTransferSiteBillingInfoUserErrorParams} params - The parameters for this event
 * @property {string} errorInfo - error
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteBillingInfoUserErrorParams>} LogObject<premiumTransferSiteBillingInfoUserErrorParams>
 */
export function premiumTransferSiteBillingInfoUserError(params) {
    return { evid: 855, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteDomainInfoLoad' event (evid: 856)
 *
 * Event description: transfer site domain info load  (3rd screen)
 *
 * @param {premiumTransferSiteDomainInfoLoadParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteDomainInfoLoadParams>} LogObject<premiumTransferSiteDomainInfoLoadParams>
 */
export function premiumTransferSiteDomainInfoLoad(params) {
    return { evid: 856, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteDomainInfoUserError' event (evid: 857)
 *
 * Event description: transfer site domain info user error (in case there is an error) (3rd screen)
 *
 * @param {premiumTransferSiteDomainInfoUserErrorParams} params - The parameters for this event
 * @property {string} errorInfo - error
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteDomainInfoUserErrorParams>} LogObject<premiumTransferSiteDomainInfoUserErrorParams>
 */
export function premiumTransferSiteDomainInfoUserError(params) {
    return { evid: 857, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteClickSubmit' event (evid: 858)
 *
 * Event description: transfer site click submit (2nd or 3rd screen)
 *
 * @param {premiumTransferSiteClickSubmitParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react transfer
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteClickSubmitParams>} LogObject<premiumTransferSiteClickSubmitParams>
 */
export function premiumTransferSiteClickSubmit(params) {
    return { evid: 858, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSitePending' event (evid: 859)
 *
 * Event description: transfer site pending
 *
 * @param {premiumTransferSitePendingParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} newSiteGuid - new site
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSitePendingParams>} LogObject<premiumTransferSitePendingParams>
 */
export function premiumTransferSitePending(params) {
    return { evid: 859, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnTooltipCombo' event (evid: 86)
 *
 * Event description: A_ClickOnTooltipCombo.
 *
 * @param {aClickOnTooltipComboParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnTooltipComboParams>} LogObject<aClickOnTooltipComboParams>
 */
export function aClickOnTooltipCombo(params) {
    return { evid: 86, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsSitePickerView' event (evid: 866)
 *
 * Event description: User viewed the site picker modal
 *
 * @param {b2BSubscriptionsSitePickerViewParams} params - The parameters for this event
 * @property {string} viewMode - available,no_sites,all_sites_premium, all_sites_assigned
 * @property {string} msids - array of msids
 * @property {GUID} selectedClient - selectedclient
 * @return {LogObject<b2BSubscriptionsSitePickerViewParams>} LogObject<b2BSubscriptionsSitePickerViewParams>
 */
export function b2BSubscriptionsSitePickerView(params) {
    return { evid: 866, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsSitePickerViewClick' event (evid: 867)
 *
 * Event description: User viewed the site picker modal
 *
 * @param {b2BSubscriptionsSitePickerViewClickParams} params - The parameters for this event
 * @property {string} viewMode - available,no_sites,all_sites_premium, all_sites_assigned
 * @property {string} msids - array of msids
 * @property {GUID} selectedMsid - the selected msid
 * @property {string} clickType - cancel,select,close
 * @property {GUID} selectedClient - the client assigned to the msid
 * @return {LogObject<b2BSubscriptionsSitePickerViewClickParams>} LogObject<b2BSubscriptionsSitePickerViewClickParams>
 */
export function b2BSubscriptionsSitePickerViewClick(params) {
    return { evid: 867, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsAddPremiumPpStep1View' event (evid: 868)
 *
 * Event description: User viewed the premium PP modal
 *
 * @param {b2BSubscriptionsAddPremiumPpStep1ViewParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {GUID} selectedMsid - adding premium plan for this site
 * @return {LogObject<b2BSubscriptionsAddPremiumPpStep1ViewParams>} LogObject<b2BSubscriptionsAddPremiumPpStep1ViewParams>
 */
export function b2BSubscriptionsAddPremiumPpStep1View(params) {
    return { evid: 868, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsAddPremiumPpStep1Click' event (evid: 869)
 *
 * Event description: User viewed the premium PP modal and closed / continued the flow
 *
 * @param {b2BSubscriptionsAddPremiumPpStep1ClickParams} params - The parameters for this event
 * @property {GUID} selectedMsid - selected site to add premium to
 * @property {GUID} subscriptionId - guid of the premium plan
 * @property {string} clickType - close,back,cancel,next
 * @property {number} cycle - selected cycle
 * @property {string} productGuid - premium type guid
 * @property {GUID} msid - msid
 * @return {LogObject<b2BSubscriptionsAddPremiumPpStep1ClickParams>} LogObject<b2BSubscriptionsAddPremiumPpStep1ClickParams>
 */
export function b2BSubscriptionsAddPremiumPpStep1Click(params) {
    return { evid: 869, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnTooltipUnlimited' event (evid: 87)
 *
 * Event description: A_ClickOnTooltipUnlimited.
 *
 * @param {aClickOnTooltipUnlimitedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnTooltipUnlimitedParams>} LogObject<aClickOnTooltipUnlimitedParams>
 */
export function aClickOnTooltipUnlimited(params) {
    return { evid: 87, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsAddPremiumPpStep1Select' event (evid: 870)
 *
 * Event description: User viewed the premium PP modal and selected one of the options (not necessary chose them as a final option)
 *
 * @param {b2BSubscriptionsAddPremiumPpStep1SelectParams} params - The parameters for this event
 * @property {GUID} selectedMsid - selected site to add premium to
 * @property {number} cycle - selected cycle
 * @property {string} productGuid - premium type guid
 * @property {GUID} msid - msid
 * @return {LogObject<b2BSubscriptionsAddPremiumPpStep1SelectParams>} LogObject<b2BSubscriptionsAddPremiumPpStep1SelectParams>
 */
export function b2BSubscriptionsAddPremiumPpStep1Select(params) {
    return { evid: 870, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingHistoryInvoiceCreated' event (evid: 8700)
 *
 * Event description: when an invoice is created
 *
 * @param {billingHistoryInvoiceCreatedParams} params - The parameters for this event
 * @property {string} invoiceDocumentId - string
 * @property {GUID} userGuid - uuid
 * @property {string} invoiceId - invoice
 * @property {string} user_agent - user_agent
 * @property {string} invoiceDocGuid - invoice_doc_guid
 * @return {LogObject<billingHistoryInvoiceCreatedParams>} LogObject<billingHistoryInvoiceCreatedParams>
 */
export function billingHistoryInvoiceCreated(params) {
    return { evid: 8700, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsAddPremiumPpStep2View' event (evid: 871)
 *
 * Event description: User viewed the premium PP step2
 *
 * @param {b2BSubscriptionsAddPremiumPpStep2ViewParams} params - The parameters for this event
 * @property {GUID} selectedMsid - selected site to add premium to
 * @property {GUID} subscriptionId - guid of the premium plan
 * @property {number} cycle - selected cycle
 * @property {string} productGuid - premium type guid
 * @property {GUID} msid - msid
 * @return {LogObject<b2BSubscriptionsAddPremiumPpStep2ViewParams>} LogObject<b2BSubscriptionsAddPremiumPpStep2ViewParams>
 */
export function b2BSubscriptionsAddPremiumPpStep2View(params) {
    return { evid: 871, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsAddPremiumPpStep2Click' event (evid: 872)
 *
 * Event description: User clicked in the premium PP step2
 *
 * @param {b2BSubscriptionsAddPremiumPpStep2ClickParams} params - The parameters for this event
 * @property {GUID} selectedMsid - selected_msid
 * @property {GUID} subscriptionId - guid of the premium plan
 * @property {string} clickType - close,back,cancel,next
 * @property {number} cycle - selected cycle
 * @property {number} selectedFee - fee
 * @property {string} productGuid - premium type guid
 * @property {GUID} msid - msid
 * @return {LogObject<b2BSubscriptionsAddPremiumPpStep2ClickParams>} LogObject<b2BSubscriptionsAddPremiumPpStep2ClickParams>
 */
export function b2BSubscriptionsAddPremiumPpStep2Click(params) {
    return { evid: 872, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsAddPremiumPpStep3Click' event (evid: 874)
 *
 * Event description: User clicked  in the premium PP step3
 *
 * @param {b2BSubscriptionsAddPremiumPpStep3ClickParams} params - The parameters for this event
 * @property {GUID} subscriptionId - guid of the premium plan
 * @property {string} clickType - close,back,cancel,add_to_invoice
 * @property {number} subscriptionPricing - subscription cost
 * @property {number} lineItemTotal - total line item price
 * @property {number} selectedFee - fee
 * @property {string} productGuid - premium type guid
 * @property {GUID} msid - msid
 * @return {LogObject<b2BSubscriptionsAddPremiumPpStep3ClickParams>} LogObject<b2BSubscriptionsAddPremiumPpStep3ClickParams>
 */
export function b2BSubscriptionsAddPremiumPpStep3Click(params) {
    return { evid: 874, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsPickerError' event (evid: 875)
 *
 * Event description: user received an error after trying to assign a site / premium plan
 *
 * @param {b2BSubscriptionsPickerErrorParams} params - The parameters for this event
 * @property {string} errorType - premium , sites
 * @return {LogObject<b2BSubscriptionsPickerErrorParams>} LogObject<b2BSubscriptionsPickerErrorParams>
 */
export function b2BSubscriptionsPickerError(params) {
    return { evid: 875, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subSystemFailedToCreateFloatingLicense' event (evid: 8800)
 *
 * Event description: Sub system failed to create floating license.
 *
 * @param {subSystemFailedToCreateFloatingLicenseParams} params - The parameters for this event
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @property {string} reasons - reasons
 * @return {LogObject<subSystemFailedToCreateFloatingLicenseParams>} LogObject<subSystemFailedToCreateFloatingLicenseParams>
 */
export function subSystemFailedToCreateFloatingLicense(params) {
    return { evid: 8800, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createFloatingLicensesFailedSrc17Evid8801' event (evid: 8801)
 *
 * Event description: Sub System Successfully Created Floating License
 *
 * @param {createFloatingLicensesFailedSrc17Evid8801Params} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - owner (uuid)
 * @property {string} reasons - reasons
 * @return {LogObject<createFloatingLicensesFailedSrc17Evid8801Params>} LogObject<createFloatingLicensesFailedSrc17Evid8801Params>
 */
export function createFloatingLicensesFailedSrc17Evid8801(params) {
    return { evid: 8801, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createFloatingLicensesSucceeded' event (evid: 8802)
 *
 * Event description: Create Floating Licenses Failed
 *
 * @param {createFloatingLicensesSucceededParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @return {LogObject<createFloatingLicensesSucceededParams>} LogObject<createFloatingLicensesSucceededParams>
 */
export function createFloatingLicensesSucceeded(params) {
    return { evid: 8802, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subSystemSuccessfullyCreatedFloatingLicense' event (evid: 8803)
 *
 * Event description: sub system successfully created floating license
 *
 * @param {subSystemSuccessfullyCreatedFloatingLicenseParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} licensedProducts - licensed_products
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @return {LogObject<subSystemSuccessfullyCreatedFloatingLicenseParams>} LogObject<subSystemSuccessfullyCreatedFloatingLicenseParams>
 */
export function subSystemSuccessfullyCreatedFloatingLicense(params) {
    return { evid: 8803, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteFloatingLicensesSucceeded' event (evid: 8804)
 *
 * Event description: Delete floating licenses succeeded
 *
 * @param {deleteFloatingLicensesSucceededParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} licensedProducts - licensed_products
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @return {LogObject<deleteFloatingLicensesSucceededParams>} LogObject<deleteFloatingLicensesSucceededParams>
 */
export function deleteFloatingLicensesSucceeded(params) {
    return { evid: 8804, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteFloatingLicensesFailed' event (evid: 8805)
 *
 * Event description: Delete Floating Licenses Failed
 *
 * @param {deleteFloatingLicensesFailedParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @property {string} reasons - reasons
 * @return {LogObject<deleteFloatingLicensesFailedParams>} LogObject<deleteFloatingLicensesFailedParams>
 */
export function deleteFloatingLicensesFailed(params) {
    return { evid: 8805, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subSystemDeleteFloatingLicensesReplyFailed' event (evid: 8806)
 *
 * Event description: Sub System Delete Floating Licenses Reply Failed
 *
 * @param {subSystemDeleteFloatingLicensesReplyFailedParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @property {string} reasons - reasons
 * @return {LogObject<subSystemDeleteFloatingLicensesReplyFailedParams>} LogObject<subSystemDeleteFloatingLicensesReplyFailedParams>
 */
export function subSystemDeleteFloatingLicensesReplyFailed(params) {
    return { evid: 8806, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subSystemDeleteFloatingLicensesReplySucceeded' event (evid: 8807)
 *
 * Event description: Sub System Delete Floating Licenses Reply Succeeded
 *
 * @param {subSystemDeleteFloatingLicensesReplySucceededParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {GUID} licenseId - license_id
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @return {LogObject<subSystemDeleteFloatingLicensesReplySucceededParams>} LogObject<subSystemDeleteFloatingLicensesReplySucceededParams>
 */
export function subSystemDeleteFloatingLicensesReplySucceeded(params) {
    return { evid: 8807, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activateLicensesSucceeded' event (evid: 8808)
 *
 * Event description: Activate Licenses Succeeded
 *
 * @param {activateLicensesSucceededParams} params - The parameters for this event
 * @property {string} activatedLicenses - activated_licenses
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @return {LogObject<activateLicensesSucceededParams>} LogObject<activateLicensesSucceededParams>
 */
export function activateLicensesSucceeded(params) {
    return { evid: 8808, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activateLicensesFailed' event (evid: 8809)
 *
 * Event description: Activate Licenses Failed
 *
 * @param {activateLicensesFailedParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @property {string} reasons - reasons
 * @return {LogObject<activateLicensesFailedParams>} LogObject<activateLicensesFailedParams>
 */
export function activateLicensesFailed(params) {
    return { evid: 8809, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activateFloatingLicenseReplySucceeded' event (evid: 8810)
 *
 * Event description: Activate Floating License Reply Succeeded
 *
 * @param {activateFloatingLicenseReplySucceededParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @return {LogObject<activateFloatingLicenseReplySucceededParams>} LogObject<activateFloatingLicenseReplySucceededParams>
 */
export function activateFloatingLicenseReplySucceeded(params) {
    return { evid: 8810, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activateFloatingLicenseReplyFailed' event (evid: 8811)
 *
 * Event description: Activate Floating License Reply Failed
 *
 * @param {activateFloatingLicenseReplyFailedParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @property {string} reasons - reasons
 * @return {LogObject<activateFloatingLicenseReplyFailedParams>} LogObject<activateFloatingLicenseReplyFailedParams>
 */
export function activateFloatingLicenseReplyFailed(params) {
    return { evid: 8811, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activateFloatingLicenseReplyProcessingFailed' event (evid: 8812)
 *
 * Event description: Activate Floating License Reply Processing Failed
 *
 * @param {activateFloatingLicenseReplyProcessingFailedParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @property {string} reasons - reasons
 * @return {LogObject<activateFloatingLicenseReplyProcessingFailedParams>} LogObject<activateFloatingLicenseReplyProcessingFailedParams>
 */
export function activateFloatingLicenseReplyProcessingFailed(params) {
    return { evid: 8812, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deactivateLicensesSucceeded' event (evid: 8813)
 *
 * Event description: Deactivate Licenses Succeeded
 *
 * @param {deactivateLicensesSucceededParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} license - license
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @return {LogObject<deactivateLicensesSucceededParams>} LogObject<deactivateLicensesSucceededParams>
 */
export function deactivateLicensesSucceeded(params) {
    return { evid: 8813, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deactivateLicensesFailed' event (evid: 8814)
 *
 * Event description: Deactivate Licenses Failed
 *
 * @param {deactivateLicensesFailedParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} reason - reason
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @return {LogObject<deactivateLicensesFailedParams>} LogObject<deactivateLicensesFailedParams>
 */
export function deactivateLicensesFailed(params) {
    return { evid: 8814, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subSystemDeactivateFloatingLicenseReplyFailed' event (evid: 8815)
 *
 * Event description: Sub System Deactivate Floating License Reply Failed
 *
 * @param {subSystemDeactivateFloatingLicenseReplyFailedParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @property {string} reasons - reasons
 * @return {LogObject<subSystemDeactivateFloatingLicenseReplyFailedParams>} LogObject<subSystemDeactivateFloatingLicenseReplyFailedParams>
 */
export function subSystemDeactivateFloatingLicenseReplyFailed(params) {
    return { evid: 8815, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subSystemDeactivateFloatingLicenseReplySucceeded' event (evid: 8816)
 *
 * Event description: Sub System Deactivate Floating License Reply Succeeded
 *
 * @param {subSystemDeactivateFloatingLicenseReplySucceededParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} license - license
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @return {LogObject<subSystemDeactivateFloatingLicenseReplySucceededParams>} LogObject<subSystemDeactivateFloatingLicenseReplySucceededParams>
 */
export function subSystemDeactivateFloatingLicenseReplySucceeded(params) {
    return { evid: 8816, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'activateFloatingLicenseReplyEmpty' event (evid: 8817)
 *
 * Event description: Activate Floating License Reply Empty
 *
 * @param {activateFloatingLicenseReplyEmptyParams} params - The parameters for this event
 * @property {string} request - request
 * @property {string} licensesIds - licenses_ids
 * @property {string} externalReferenceIds - subscription
 * @property {string} bulkReferenceId - the same for all licenses for sub
 * @property {string} clientName - external client
 * @property {GUID} owner - uuid
 * @return {LogObject<activateFloatingLicenseReplyEmptyParams>} LogObject<activateFloatingLicenseReplyEmptyParams>
 */
export function activateFloatingLicenseReplyEmpty(params) {
    return { evid: 8817, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'debugEvent' event (evid: 888)
 *
 * Event description: for debug purposes
 *
 * @param {debugEventParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - string for whatever
 * @property {string} udger_ua_class - udger_ua_class
 * @property {string} location - location
 * @property {GUID} '4' - user guid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - user guid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - string for whatever
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<debugEventParams>} LogObject<debugEventParams>
 */
export function debugEvent(params) {
    return { evid: 888, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnTooltipeCommerece' event (evid: 89)
 *
 * Event description: A_ClickOnTooltipeCommerece.
 *
 * @param {aClickOnTooltipeCommereceParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnTooltipeCommereceParams>} LogObject<aClickOnTooltipeCommereceParams>
 */
export function aClickOnTooltipeCommerece(params) {
    return { evid: 89, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnLeftBanner' event (evid: 9)
 *
 * Event description: A_ClickOnLeftBanner.
 *
 * @param {aClickOnLeftBannerParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnLeftBannerParams>} LogObject<aClickOnLeftBannerParams>
 */
export function aClickOnLeftBanner(params) {
    return { evid: 9, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClickOnTooltipWidget' event (evid: 90)
 *
 * Event description: A_ClickOnTooltipWidget.
 *
 * @param {aClickOnTooltipWidgetParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnTooltipWidgetParams>} LogObject<aClickOnTooltipWidgetParams>
 */
export function aClickOnTooltipWidget(params) {
    return { evid: 90, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainCheckStatusTaskSuccess' event (evid: 9000)
 *
 * Event description: a long task, the domain is connected to Wix. From 6.03.2019 we started to check all domains every day.
 *
 * @param {rDomainCheckStatusTaskSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {string} checkType - check_type
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} aName - a_name
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} mgmtType - mgmt_type
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {string} wixNs - wix_ns
 * @property {number} '32' - domain_sku_id
 * @property {string} cName - c_name
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} nsRecords - ns_records
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {GUID} siteId - site_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} source - immediate / recurring
 * @return {LogObject<rDomainCheckStatusTaskSuccessParams>} LogObject<rDomainCheckStatusTaskSuccessParams>
 */
export function rDomainCheckStatusTaskSuccess(params) {
    return { evid: 9000, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainCheckStatusTaskFailed' event (evid: 9001)
 *
 * Event description: a long task, the domain is not connected to Wix. From 6.03.2019 we started to check all domains every day.
 *
 * @param {rDomainCheckStatusTaskFailedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} errorInfo - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {string} checkType - check_type
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} aName - a_name
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} mgmtType - mgmt_type
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} user_agent - user_agent
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {string} wixNs - wix_ns
 * @property {number} '32' - domain_sku_id
 * @property {string} cName - c_name
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} nsRecords - ns_records
 * @property {string} udger_device_class - udger_device_class
 * @property {string} invalidRecords - invalid_records
 * @property {string} status - status_text
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {GUID} siteId - site_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} source - immediate / recurring
 * @return {LogObject<rDomainCheckStatusTaskFailedParams>} LogObject<rDomainCheckStatusTaskFailedParams>
 */
export function rDomainCheckStatusTaskFailed(params) {
    return { evid: 9001, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainCheckStatusTaskCreateSslSuccess' event (evid: 9002)
 *
 * Event description: short task, ssl creation succeeded
 *
 * @param {rDomainCheckStatusTaskCreateSslSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainCheckStatusTaskCreateSslSuccessParams>} LogObject<rDomainCheckStatusTaskCreateSslSuccessParams>
 */
export function rDomainCheckStatusTaskCreateSslSuccess(params) {
    return { evid: 9002, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainCheckStatusTaskCreateSslFailed' event (evid: 9003)
 *
 * Event description: short task, ssl creation failed
 *
 * @param {rDomainCheckStatusTaskCreateSslFailedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainCheckStatusTaskCreateSslFailedParams>} LogObject<rDomainCheckStatusTaskCreateSslFailedParams>
 */
export function rDomainCheckStatusTaskCreateSslFailed(params) {
    return { evid: 9003, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rAmqCreateSslConsumerSuccess' event (evid: 9004)
 *
 * Event description: ssl creation from queue (inserted by long task) succeeded
 *
 * @param {rAmqCreateSslConsumerSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rAmqCreateSslConsumerSuccessParams>} LogObject<rAmqCreateSslConsumerSuccessParams>
 */
export function rAmqCreateSslConsumerSuccess(params) {
    return { evid: 9004, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rAmqCreateSslConsumerFailed' event (evid: 9005)
 *
 * Event description: ssl creation from queue (inserted by long task) failed
 *
 * @param {rAmqCreateSslConsumerFailedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rAmqCreateSslConsumerFailedParams>} LogObject<rAmqCreateSslConsumerFailedParams>
 */
export function rAmqCreateSslConsumerFailed(params) {
    return { evid: 9005, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rAmqCreateSslConsumerFailedLastAttempt' event (evid: 9006)
 *
 * Event description: ssl creation from queue (inserted by long task) failed, last attempt
 *
 * @param {rAmqCreateSslConsumerFailedLastAttemptParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rAmqCreateSslConsumerFailedLastAttemptParams>} LogObject<rAmqCreateSslConsumerFailedLastAttemptParams>
 */
export function rAmqCreateSslConsumerFailedLastAttempt(params) {
    return { evid: 9006, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainHasNoSslForSiteConnection' event (evid: 9007)
 *
 * Event description: ssl creation failed for domain that was already in Wix and was just connected to a site
 *
 * @param {rDomainHasNoSslForSiteConnectionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainHasNoSslForSiteConnectionParams>} LogObject<rDomainHasNoSslForSiteConnectionParams>
 */
export function rDomainHasNoSslForSiteConnection(params) {
    return { evid: 9007, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rAmqCreateSslConsumerFailedUnsafeSite' event (evid: 9008)
 *
 * Event description: ssl creation failed because the domain is considered unsafe by a third party API
 *
 * @param {rAmqCreateSslConsumerFailedUnsafeSiteParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rAmqCreateSslConsumerFailedUnsafeSiteParams>} LogObject<rAmqCreateSslConsumerFailedUnsafeSiteParams>
 */
export function rAmqCreateSslConsumerFailedUnsafeSite(params) {
    return { evid: 9008, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'renewCertificationFailed' event (evid: 9009)
 *
 * Event description: Every 2 months we renew the ssl  - fail
 *
 * @param {renewCertificationFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {DateTime} expiresAt - expiration date
 * @property {GUID} userGuid - uuid
 * @property {string} domainName - domain
 * @property {string} user_agent - user_agent
 * @return {LogObject<renewCertificationFailedParams>} LogObject<renewCertificationFailedParams>
 */
export function renewCertificationFailed(params) {
    return { evid: 9009, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aWixPpClickOnBuyNow' event (evid: 901)
 *
 * Event description: the click between PP and Purchase Page. current version "select"
 *
 * @param {aWixPpClickOnBuyNowParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aWixPpClickOnBuyNowParams>} LogObject<aWixPpClickOnBuyNowParams>
 */
export function aWixPpClickOnBuyNow(params) {
    return { evid: 901, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'renewCertificationLastAttemptFailed' event (evid: 9010)
 *
 * Event description: Every 2 months we renew the ssl  - fail, last attempt (after all 9009 attempts have failed)
 *
 * @param {renewCertificationLastAttemptFailedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {DateTime} expiresAt - expiration date
 * @property {GUID} userGuid - uuid
 * @property {string} domainName - domain
 * @property {string} user_agent - user_agent
 * @return {LogObject<renewCertificationLastAttemptFailedParams>} LogObject<renewCertificationLastAttemptFailedParams>
 */
export function renewCertificationLastAttemptFailed(params) {
    return { evid: 9010, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'renewCertificationFailedForResolvedDomain' event (evid: 9011)
 *
 * Event description: Every 2 months we renew the ssl  - fail
 *
 * @param {renewCertificationFailedForResolvedDomainParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {DateTime} expiresAt - expiration date
 * @property {GUID} userGuid - uuid
 * @property {string} domainName - domain
 * @property {string} user_agent - user_agent
 * @return {LogObject<renewCertificationFailedForResolvedDomainParams>} LogObject<renewCertificationFailedForResolvedDomainParams>
 */
export function renewCertificationFailedForResolvedDomain(params) {
    return { evid: 9011, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSslServiceCreateSslSuccess' event (evid: 9012)
 *
 * Event description: ssl creation succeeded - triggers
 *
 * @param {rSslServiceCreateSslSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSslServiceCreateSslSuccessParams>} LogObject<rSslServiceCreateSslSuccessParams>
 */
export function rSslServiceCreateSslSuccess(params) {
    return { evid: 9012, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rSslServiceCreateSslFailed' event (evid: 9013)
 *
 * Event description: ssl creation failed - triggers
 *
 * @param {rSslServiceCreateSslFailedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rSslServiceCreateSslFailedParams>} LogObject<rSslServiceCreateSslFailedParams>
 */
export function rSslServiceCreateSslFailed(params) {
    return { evid: 9013, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rDomainSlimCheckStatusForSsl' event (evid: 9014)
 *
 * Event description: R_DOMAIN_SLIM_CHECK_STATUS_FOR_SSL.
 *
 * @param {rDomainSlimCheckStatusForSslParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rDomainSlimCheckStatusForSslParams>} LogObject<rDomainSlimCheckStatusForSslParams>
 */
export function rDomainSlimCheckStatusForSsl(params) {
    return { evid: 9014, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'disableHttps' event (evid: 9015)
 *
 * Event description: Disable https.
 *
 * @param {disableHttpsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<disableHttpsParams>} LogObject<disableHttpsParams>
 */
export function disableHttps(params) {
    return { evid: 9015, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'enabelHttps' event (evid: 9016)
 *
 * Event description: Enable https.
 *
 * @param {enabelHttpsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<enabelHttpsParams>} LogObject<enabelHttpsParams>
 */
export function enabelHttps(params) {
    return { evid: 9016, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rWixPpUserNotLogin' event (evid: 903)
 *
 * Event description: R_Wix_PP_UserNotLogin.
 *
 * @param {rWixPpUserNotLoginParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rWixPpUserNotLoginParams>} LogObject<rWixPpUserNotLoginParams>
 */
export function rWixPpUserNotLogin(params) {
    return { evid: 903, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aContractSelected' event (evid: 91)
 *
 * Event description: click on "select" in PP 1st step or radio button in 2nd step. NOT available in OnePage
 *
 * @param {aContractSelectedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aContractSelectedParams>} LogObject<aContractSelectedParams>
 */
export function aContractSelected(params) {
    return { evid: 91, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aWixGoogleDomainConsentCallBackSuccess' event (evid: 915)
 *
 * Event description: A_WixGoogleDomainConsentCallBackSuccess.
 *
 * @param {aWixGoogleDomainConsentCallBackSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aWixGoogleDomainConsentCallBackSuccessParams>} LogObject<aWixGoogleDomainConsentCallBackSuccessParams>
 */
export function aWixGoogleDomainConsentCallBackSuccess(params) {
    return { evid: 915, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aWixGoogleDomainConsentCallBackError' event (evid: 916)
 *
 * Event description: A_WixGoogleDomainConsentCallBackError.
 *
 * @param {aWixGoogleDomainConsentCallBackErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aWixGoogleDomainConsentCallBackErrorParams>} LogObject<aWixGoogleDomainConsentCallBackErrorParams>
 */
export function aWixGoogleDomainConsentCallBackError(params) {
    return { evid: 916, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aWixGoogleDomainConsentCallBackException' event (evid: 917)
 *
 * Event description: A_WixGoogleDomainConsentCallBackException.
 *
 * @param {aWixGoogleDomainConsentCallBackExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aWixGoogleDomainConsentCallBackExceptionParams>} LogObject<aWixGoogleDomainConsentCallBackExceptionParams>
 */
export function aWixGoogleDomainConsentCallBackException(params) {
    return { evid: 917, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aWixGoogleDomainConsentActivationSuccess' event (evid: 918)
 *
 * Event description: A_WixGoogleDomainConsentActivationSuccess.
 *
 * @param {aWixGoogleDomainConsentActivationSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aWixGoogleDomainConsentActivationSuccessParams>} LogObject<aWixGoogleDomainConsentActivationSuccessParams>
 */
export function aWixGoogleDomainConsentActivationSuccess(params) {
    return { evid: 918, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aWixGoogleDomainConsentActivationError' event (evid: 919)
 *
 * Event description: A_WixGoogleDomainConsentActivationError.
 *
 * @param {aWixGoogleDomainConsentActivationErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aWixGoogleDomainConsentActivationErrorParams>} LogObject<aWixGoogleDomainConsentActivationErrorParams>
 */
export function aWixGoogleDomainConsentActivationError(params) {
    return { evid: 919, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aBuyNowWidgetPlan' event (evid: 92)
 *
 * Event description: A_BuyNowWidgetPlan.
 *
 * @param {aBuyNowWidgetPlanParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aBuyNowWidgetPlanParams>} LogObject<aBuyNowWidgetPlanParams>
 */
export function aBuyNowWidgetPlan(params) {
    return { evid: 92, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aWixGoogleDomainConsentActivationException' event (evid: 920)
 *
 * Event description: A_WixGoogleDomainConsentActivationException.
 *
 * @param {aWixGoogleDomainConsentActivationExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aWixGoogleDomainConsentActivationExceptionParams>} LogObject<aWixGoogleDomainConsentActivationExceptionParams>
 */
export function aWixGoogleDomainConsentActivationException(params) {
    return { evid: 920, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc17Evid9200' event (evid: 9200)
 *
 * Event description: Invoices in progress.
 *
 * @param {dummyNameSrc17Evid9200Params} params - The parameters for this event
 * @property {number} pendingSubscriptionsCounter - pending_subscriptions_counter
 * @property {number} paymentMethod - payment_method
 * @property {string} productTypeName - Premium Plan / Domain
 * @property {number} invoiceId - invoice_id
 * @property {string} newPurchase - true / false
 * @property {string} actionType - action_type
 * @property {string} productName - product name
 * @property {string} productGuid - premium product guid
 * @property {number} cycleId - cycle_id
 * @return {LogObject<dummyNameSrc17Evid9200Params>} LogObject<dummyNameSrc17Evid9200Params>
 */
export function dummyNameSrc17Evid9200(params) {
    return { evid: 9200, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aWixGoogleDomainsUnlinkSubscriptionSuccess' event (evid: 921)
 *
 * Event description: A_WixGoogleDomainsUnlinkSubscriptionSuccess.
 *
 * @param {aWixGoogleDomainsUnlinkSubscriptionSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aWixGoogleDomainsUnlinkSubscriptionSuccessParams>} LogObject<aWixGoogleDomainsUnlinkSubscriptionSuccessParams>
 */
export function aWixGoogleDomainsUnlinkSubscriptionSuccess(params) {
    return { evid: 921, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aWixGoogleDomainsUnlinkSubscriptionError' event (evid: 922)
 *
 * Event description: A_WixGoogleDomainsUnlinkSubscriptionError.
 *
 * @param {aWixGoogleDomainsUnlinkSubscriptionErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aWixGoogleDomainsUnlinkSubscriptionErrorParams>} LogObject<aWixGoogleDomainsUnlinkSubscriptionErrorParams>
 */
export function aWixGoogleDomainsUnlinkSubscriptionError(params) {
    return { evid: 922, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aWixGoogleDomainsUnlinkSubscriptionException' event (evid: 923)
 *
 * Event description: A_WixGoogleDomainsUnlinkSubscriptionException.
 *
 * @param {aWixGoogleDomainsUnlinkSubscriptionExceptionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aWixGoogleDomainsUnlinkSubscriptionExceptionParams>} LogObject<aWixGoogleDomainsUnlinkSubscriptionExceptionParams>
 */
export function aWixGoogleDomainsUnlinkSubscriptionException(params) {
    return { evid: 923, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aTooltipCoupons' event (evid: 93)
 *
 * Event description: A_TooltipCoupons.
 *
 * @param {aTooltipCouponsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTooltipCouponsParams>} LogObject<aTooltipCouponsParams>
 */
export function aTooltipCoupons(params) {
    return { evid: 93, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerSoftbank' event (evid: 930)
 *
 * Event description: V_WixSoftBankPackagePicker. last event  2018-12-24 , moved to 2233
 *
 * @param {packagePickerSoftbankParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<packagePickerSoftbankParams>} LogObject<packagePickerSoftbankParams>
 */
export function packagePickerSoftbank(params) {
    return { evid: 930, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageCheckSaveCc' event (evid: 94)
 *
 * Event description: A_CheckSaveCC
 *
 * @param {checkOutPageCheckSaveCcParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} initiatorname - initiatorname
 * @property {string} segment - segment
 * @property {string} trackabletenant - trackable_tenant
 * @return {LogObject<checkOutPageCheckSaveCcParams>} LogObject<checkOutPageCheckSaveCcParams>
 */
export function checkOutPageCheckSaveCc(params) {
    return { evid: 94, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPremiumpploaded' event (evid: 940)
 *
 * Event description: Plan PP page  is loaded (goes with 168.. events) A_PremiumPPLoaded
 *
 * @param {aPremiumpploadedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - Loading time
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} changePlanType - product is in current offering/ legacy / in offering but was updated
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} intent - intent
 * @property {string} flowType - 2nd upgrade/initial/change plan
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {boolean} didFinish - Was fully loaded
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} loadedComponents - list of components that were supposed to load, and indication if they were loaded {marketing cards : true , title :false}
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} products - products
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} currentProductGuid - current_product_guid
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} ppType - pp_type
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} currentProductId - product id for change plan / second upgrade flows
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} currency - Currency
 * @property {string} additionalInfo - Loading time
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} intentDomainName - if the user found a domain before the PP
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} offeringType - Seasonal/personal/default
 * @property {number} '29' - initiator
 * @property {string} initiatorName - who called the app (Cart/editor)
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {string} pricing - Pricing
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @property {string} cartFlow - cartFlow
 * @return {LogObject<aPremiumpploadedParams>} LogObject<aPremiumpploadedParams>
 */
export function aPremiumpploaded(params) {
    return { evid: 940, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPaymentPageReady' event (evid: 942)
 *
 * Event description: Client - A_PaymentPageReady
 *
 * @param {aPaymentPageReadyParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} products - products
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} vendorName - ab_test
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} currency - currency
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {GUID} skuId - sku_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {string} pricing - pricing
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aPaymentPageReadyParams>} LogObject<aPaymentPageReadyParams>
 */
export function aPaymentPageReady(params) {
    return { evid: 942, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'vPackagePickerPreload' event (evid: 943)
 *
 * Event description: V_PackagePickerPreload.
 *
 * @param {vPackagePickerPreloadParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vPackagePickerPreloadParams>} LogObject<vPackagePickerPreloadParams>
 */
export function vPackagePickerPreload(params) {
    return { evid: 943, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerStartLoad' event (evid: 944)
 *
 * Event description: Package picker started loading
 *
 * @param {packagePickerStartLoadParams} params - The parameters for this event
 * @property {string} eventAggregator - identifier of event
 * @property {string} packagePickerType - Example: sunrise,studio
 * @return {LogObject<packagePickerStartLoadParams>} LogObject<packagePickerStartLoadParams>
 */
export function packagePickerStartLoad(params) {
    return { evid: 944, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerComponentStartLoad' event (evid: 945)
 *
 * Event description: A package picker component (Grid/Marketing cards)started to load
 *
 * @param {packagePickerComponentStartLoadParams} params - The parameters for this event
 * @property {string} packagePickerType - sunrise/studio etc
 * @property {string} flowType - initial purchase/2nd upgrade/change plan
 * @property {string} componentName - example Grid/Marketing cards
 * @property {number} cycle - current_cycle_id
 * @property {number} productId - for sites that are already upgraded
 * @property {string} offeringType - default / seasonal / personal
 * @property {string} initiatorName - Source of loading (cart/Editor)
 * @property {string} pricing - a list of the products offered and their prices
 * @property {string} referraladditionalinfo - referral_additional_info
 * @property {string} eventAggregator - aggregator
 * @return {LogObject<packagePickerComponentStartLoadParams>} LogObject<packagePickerComponentStartLoadParams>
 */
export function packagePickerComponentStartLoad(params) {
    return { evid: 945, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerComponentFinishLoad' event (evid: 946)
 *
 * Event description: A package picker component (Grid/Marketing cards) successfully loaded
 *
 * @param {packagePickerComponentFinishLoadParams} params - The parameters for this event
 * @property {string} packagePickerType - sunrise/studio etc
 * @property {string} flowType - initial purchase/2nd upgrade/change plan
 * @property {string} componentName - example Grid/Marketing cards
 * @property {number} cycle - for sites that are already upgraded
 * @property {number} productId - for sites that are already upgraded
 * @property {string} offeringType - default / seasonal / personal
 * @property {string} initiatorName - Source of loading (cart/Editor)
 * @property {string} pricing - a list of the products offered and their prices
 * @property {string} referraladditionalinfo - Specific entry point to the PP
 * @property {string} eventAggregator - aggregator
 * @return {LogObject<packagePickerComponentFinishLoadParams>} LogObject<packagePickerComponentFinishLoadParams>
 */
export function packagePickerComponentFinishLoad(params) {
    return { evid: 946, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkOutPageUnCheckSaveCc' event (evid: 95)
 *
 * Event description: A_UnCheckSaveCC
 *
 * @param {checkOutPageUnCheckSaveCcParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - 0, 4
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - false, true
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - 3, 6
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - 3, 2
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator_name
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - 1, 4
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<checkOutPageUnCheckSaveCcParams>} LogObject<checkOutPageUnCheckSaveCcParams>
 */
export function checkOutPageUnCheckSaveCc(params) {
    return { evid: 95, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'enterpriseAccountCreated' event (evid: 951)
 *
 * Event description: account received enterprise capabilities
 *
 * @param {enterpriseAccountCreatedParams} params - The parameters for this event
 * @property {string} flowType - account created from flow (channel, enterprise etc)
 * @property {GUID} uuid - uuid
 * @property {GUID} accountId - enterprise account id
 * @property {string} discountCode - discount code for sale tag
 * @property {string} limits - limits per product and product type, json
 * @return {LogObject<enterpriseAccountCreatedParams>} LogObject<enterpriseAccountCreatedParams>
 */
export function enterpriseAccountCreated(params) {
    return { evid: 951, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'enterpriseAccountRemoved' event (evid: 952)
 *
 * Event description: account is no longer enterprise
 *
 * @param {enterpriseAccountRemovedParams} params - The parameters for this event
 * @property {GUID} accountId - enterprise account id
 * @property {GUID} uuid - uuid
 * @return {LogObject<enterpriseAccountRemovedParams>} LogObject<enterpriseAccountRemovedParams>
 */
export function enterpriseAccountRemoved(params) {
    return { evid: 952, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'spiHostCalledBeforeCallingImplementor' event (evid: 953)
 *
 * Event description: When an invoice is created, a call to the implementor is made, this events records the SPI Host Call, before Calling Implementor (part of custom charge flow where we ask the external app how much should we charge the user)
 *
 * @param {spiHostCalledBeforeCallingImplementorParams} params - The parameters for this event
 * @property {GUID} appInstanceId - The appInstanceId of the subscription
 * @property {string} appName - the ID of the third party app for example “reconvert” -
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscriptionId
 * @property {GUID} appDefId - app_def_id
 * @property {string} flavor - The call target - for info only or to charge
 * @property {GUID} eventAggregatorId - unique session that will be delivered through flow
 * @property {GUID} msid - Msid
 * @return {LogObject<spiHostCalledBeforeCallingImplementorParams>} LogObject<spiHostCalledBeforeCallingImplementorParams>
 */
export function spiHostCalledBeforeCallingImplementor(params) {
    return { evid: 953, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeSpiProviderResponse' event (evid: 954)
 *
 * Event description: SPI Provider Response in Custom Charge Flow.
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeSpiProviderResponseParams} params - The parameters for this event
 * @property {string} totalAmountCharge - Total amount of the invoice
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} chargeLineItems - List of charge line items [(charge_id:amount)]
 * @property {GUID} eventAggregatorId - unique session that will be delivered through flow
 * @return {LogObject<customChargeSpiProviderResponseParams>} LogObject<customChargeSpiProviderResponseParams>
 */
export function customChargeSpiProviderResponse(params) {
    return { evid: 954, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeCapValidationCheck' event (evid: 955)
 *
 * Event description: Custom Charge Cap Validation check - after SPI Provider Response
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeCapValidationCheckParams} params - The parameters for this event
 * @property {string} totalAmountCharge - total amount of the invoice
 * @property {string} chargeLimit - The maximal amount that the user can be charged with
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscriptionId
 * @property {GUID} eventAggregatorId - unique session that will be delivered through flow
 * @return {LogObject<customChargeCapValidationCheckParams>} LogObject<customChargeCapValidationCheckParams>
 */
export function customChargeCapValidationCheck(params) {
    return { evid: 955, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeInvoiceCreated' event (evid: 956)
 *
 * Event description: Custom Charge Invoice created - after Billing Recived from SPI Provider
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeInvoiceCreatedParams} params - The parameters for this event
 * @property {string} totalAmountCharge - total amount of the charge line items ( The  actual invoice Total amount might be different due to tax etc)
 * @property {GUID} appInstanceId - app_instance_id of the specific subscription
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscriptionId
 * @property {number} invoiceId - Billng invoice Id
 * @property {GUID} appDefId - app_def_id
 * @property {string} invoiceLineItems - A list of the invoice line items and their amount and maybe their purpose if exists
 * @property {GUID} msid - msid
 * @return {LogObject<customChargeInvoiceCreatedParams>} LogObject<customChargeInvoiceCreatedParams>
 */
export function customChargeInvoiceCreated(params) {
    return { evid: 956, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeInvoiceSentToApp' event (evid: 957)
 *
 * Event description: Custom Charge Invoice sent to App  - documents that the invoice was sent to the app.
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeInvoiceSentToAppParams} params - The parameters for this event
 * @property {string} totalAmountCharge - total amount of the charge line items ( The  actual invoice Total amount might be different due to tax etc)
 * @property {GUID} appInstanceId - app_instance_id of the specific subscription
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscriptionId
 * @property {number} invoiceId - Billng invoice Id
 * @property {GUID} appDefId - app_def_id
 * @property {string} invoiceLineItems - A list of the invoice line items and their amount and maybe their purpose if exists
 * @property {GUID} msid - msid
 * @return {LogObject<customChargeInvoiceSentToAppParams>} LogObject<customChargeInvoiceSentToAppParams>
 */
export function customChargeInvoiceSentToApp(params) {
    return { evid: 957, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeBeforeCallingSpiProviderToGetChargeLimit' event (evid: 958)
 *
 * Event description: Custom Charge Before calling SPI provider to get Charge Limit. Charge Limit is the the Total amount that the user is allowed to be charged with.
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeBeforeCallingSpiProviderToGetChargeLimitParams} params - The parameters for this event
 * @property {GUID} appInstanceId - app_instance_id of the specific subscription
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscriptionId - optional, during initial purchase flow, we don't have a subscription yet
 * @property {GUID} appDefId - app_def_id
 * @property {string} currency - currency
 * @property {GUID} msid - msid
 * @return {LogObject<customChargeBeforeCallingSpiProviderToGetChargeLimitParams>} LogObject<customChargeBeforeCallingSpiProviderToGetChargeLimitParams>
 */
export function customChargeBeforeCallingSpiProviderToGetChargeLimit(params) {
    return { evid: 958, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeSpiProviderResponseToChargeLimit' event (evid: 959)
 *
 * Event description: Custom Charge SPI provider  Response  to Charge Limit. Charge Limit is the the Total amount that the user is allowed to be charged with in this subscription.
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeSpiProviderResponseToChargeLimitParams} params - The parameters for this event
 * @property {string} chargeLimit - The charge Limit for the subscription
 * @property {GUID} appInstanceId - app_instance_id of the specific subscription
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscriptionId - optional, during initial purchase flow, we don't have a subscription yet
 * @property {GUID} appDefId - app_def_id
 * @property {string} currency - currency
 * @property {GUID} msid - msid
 * @return {LogObject<customChargeSpiProviderResponseToChargeLimitParams>} LogObject<customChargeSpiProviderResponseToChargeLimitParams>
 */
export function customChargeSpiProviderResponseToChargeLimit(params) {
    return { evid: 959, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aClicktou' event (evid: 96)
 *
 * Event description: A_ClickTOU.
 *
 * @param {aClicktouParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClicktouParams>} LogObject<aClicktouParams>
 */
export function aClicktou(params) {
    return { evid: 96, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeBeforeCallingSpiProviderToUpdateChargeLimit' event (evid: 960)
 *
 * Event description: Custom Charge Before calling SPI provider to update charge Limit - After the user updates the charge limit, we updated the SPI provider with the new charge limit.
 * Charge Limit is the the Total amount that the user is allowed to be charged within the subscription.
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeBeforeCallingSpiProviderToUpdateChargeLimitParams} params - The parameters for this event
 * @property {string} chargeLimit - Charge Limit is the the Total amount that the user is allowed to be charged within the subscription.
 * @property {GUID} appInstanceId - app_instance_id of the specific subscription
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscriptionId
 * @property {GUID} appDefId - app_def_id
 * @property {string} currency - currency
 * @property {GUID} msid - msid
 * @return {LogObject<customChargeBeforeCallingSpiProviderToUpdateChargeLimitParams>} LogObject<customChargeBeforeCallingSpiProviderToUpdateChargeLimitParams>
 */
export function customChargeBeforeCallingSpiProviderToUpdateChargeLimit(params) {
    return { evid: 960, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeAfterCallingSpiProviderToUpdateChargeLimit' event (evid: 961)
 *
 * Event description: Custom Charge After calling SPI provider to update charge Limit - After the user updates the charge limit, we updated the SPI provider with the new charge limit.  This events recored that the call got to the SPI provider.
 *
 * Charge Limit is the the Total amount that the user is allowed to be charged within the subscription.
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeAfterCallingSpiProviderToUpdateChargeLimitParams} params - The parameters for this event
 * @property {string} chargeLimit - Charge Limit is the the Total amount that the user is allowed to be charged within the subscription.
 * @property {GUID} appInstanceId - app_instance_id of the specific subscription
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscriptionId
 * @property {GUID} appDefId - app_def_id
 * @property {string} currency - currency
 * @property {GUID} msid - msid
 * @return {LogObject<customChargeAfterCallingSpiProviderToUpdateChargeLimitParams>} LogObject<customChargeAfterCallingSpiProviderToUpdateChargeLimitParams>
 */
export function customChargeAfterCallingSpiProviderToUpdateChargeLimit(params) {
    return { evid: 961, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeBeforeCallingSpiProviderToNotifyAboutChargeFailure' event (evid: 962)
 *
 * Event description: Custom Charge Before calling SPI provider to Notify about charge failure.
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeBeforeCallingSpiProviderToNotifyAboutChargeFailureParams} params - The parameters for this event
 * @property {string} failureReason - failure Reason of the charge
 * @property {GUID} appInstanceId - app_instance_id of the specific subscription
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscriptionId
 * @property {GUID} appDefId - app_def_id
 * @property {GUID} msid - msid
 * @return {LogObject<customChargeBeforeCallingSpiProviderToNotifyAboutChargeFailureParams>} LogObject<customChargeBeforeCallingSpiProviderToNotifyAboutChargeFailureParams>
 */
export function customChargeBeforeCallingSpiProviderToNotifyAboutChargeFailure(params) {
    return { evid: 962, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeAfterCallingSpiProviderToNotifyAboutChargeFailure' event (evid: 963)
 *
 * Event description: Custom Charge after calling SPI provider to Notify about charge failure.
 * the event records that the SPI provider got the notification.
 *
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeAfterCallingSpiProviderToNotifyAboutChargeFailureParams} params - The parameters for this event
 * @property {string} failureReason - failure Reason of the cahrge
 * @property {GUID} appInstanceId - app_instance_id of the specific subscription
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - subscriptionId
 * @property {GUID} appDefId - app_def_id
 * @property {GUID} msid - msid
 * @return {LogObject<customChargeAfterCallingSpiProviderToNotifyAboutChargeFailureParams>} LogObject<customChargeAfterCallingSpiProviderToNotifyAboutChargeFailureParams>
 */
export function customChargeAfterCallingSpiProviderToNotifyAboutChargeFailure(params) {
    return { evid: 963, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressFlowCheckoutPageClickBack' event (evid: 964)
 *
 * Event description: click back in Checkout page (Bundle Express checkout)
 *
 * @param {expressFlowCheckoutPageClickBackParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {string} externalSessionId - unique checkout guid
 * @property {GUID} uuid - uuid
 * @property {string} countryCode - .
 * @property {string} initiatorName - .
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowCheckoutPageClickBackParams>} LogObject<expressFlowCheckoutPageClickBackParams>
 */
export function expressFlowCheckoutPageClickBack(params) {
    return { evid: 964, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aPressUpSaleLink' event (evid: 97)
 *
 * Event description: A_PressUpSaleLink.
 *
 * @param {aPressUpSaleLinkParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aPressUpSaleLinkParams>} LogObject<aPressUpSaleLinkParams>
 */
export function aPressUpSaleLink(params) {
    return { evid: 97, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'rStartPremiumPurchaseDispatcherError' event (evid: 99)
 *
 * Event description: R_StartPremiumPurchaseDispatcherError.
 *
 * @param {rStartPremiumPurchaseDispatcherErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - 5e5983b4-d39a-4d05-94c6-e6562effc694, 1531e1cb-91b2-4092-a23a-019dc9bdbc04
 * @property {number} '12' - 1, 4
 * @property {string} city - city
 * @property {number} '8' - 3, 2
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - false, true
 * @property {number} '9' - 3, 6
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - default value of 373f5354-a2e6-4968-b2f2-b638ecc5d4eb since Dec 25, 2013
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - PHONE85221, Phone87221
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - 4, 5
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - ed_Settings dialog - favicon_upgrade_btn, ed_Settings dialog - url_upgrade_btn
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - 110, 90
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - 0, 4
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<rStartPremiumPurchaseDispatcherErrorParams>} LogObject<rStartPremiumPurchaseDispatcherErrorParams>
 */
export function rStartPremiumPurchaseDispatcherError(params) {
    return { evid: 99, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitCheckoutPlanReassignDomainFlow' event (evid: 997)
 *
 * Event description: triggered when user is on re-assign domain flow, and upgrade his site.
 *
 * @param {submitCheckoutPlanReassignDomainFlowParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral additional info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab test identifier
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab test identifier
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab test identifier
 * @return {LogObject<submitCheckoutPlanReassignDomainFlowParams>} LogObject<submitCheckoutPlanReassignDomainFlowParams>
 */
export function submitCheckoutPlanReassignDomainFlow(params) {
    return { evid: 997, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'packagePickerInvalidUpgradePath' event (evid: 998)
 *
 * Event description: All the plans in the PP are unavailable. for both second upgrade and initial purcahse
 *
 * @param {packagePickerInvalidUpgradePathParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {number} existingProductId - productId
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - wrong - don't use it
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - user_package_guid
 * @property {number} existingCycle - cycle_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {Url} referer - referral
 * @property {string} pageName - ab_test
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<packagePickerInvalidUpgradePathParams>} LogObject<packagePickerInvalidUpgradePathParams>
 */
export function packagePickerInvalidUpgradePath(params) {
    return { evid: 998, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountLevelPpToUpgradeResult' event (evid: 999)
 *
 * Event description: After clicking on "buy now" replacing events 902-912 (27.7.17)
 * Died with account level - now only for anon users
 *
 * @param {accountLevelPpToUpgradeResultParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} clickOnBuyNowResult - Success_UpgradePurchase, Fail_UserHasNoSites...
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - productId
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<accountLevelPpToUpgradeResultParams>} LogObject<accountLevelPpToUpgradeResultParams>
 */
export function accountLevelPpToUpgradeResult(params) {
    return { evid: 999, src: 17, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteRequestCreated' event (evid: 8500)
 *
 * Event description: When a request  is received from the button in MA (replacing 50:1)
 *
 * @param {premiumTransferSiteRequestCreatedParams} params - The parameters for this event
 * @property {string} transferSubscriptions - transfer_subscriptions
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {string} transferEmail - the email you transfer to - PII, removed
 * @property {boolean} isOffline - is_offline
 * @property {GUID} transferGuid - id from MyAccount
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {boolean} transferPremium - True/False
 * @property {string} disconnectSubscriptions - disconnect_subscriptions
 * @property {boolean} keepCopy - True/False check - keep copy
 * @property {string} wixPaymentsAccountIds - wix_payments_account_ids
 * @property {string} user_agent - user_agent
 * @property {string} newOwnerType - new_owner_type
 * @property {boolean} existingUser - if the email belong to a wix user
 * @property {boolean} isPremium - True/False transfer a subscription (premium/TPA)
 * @property {boolean} transferDomain - True/False
 * @property {boolean} keepAdmin - True/False check - keep me as admin
 * @return {LogObject<premiumTransferSiteRequestCreatedParams>} LogObject<premiumTransferSiteRequestCreatedParams>
 */
export function premiumTransferSiteRequestCreated(params) {
    return { evid: 8500, src: 50, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteSuccess' event (evid: 8503)
 *
 * Event description: transfer site success (replacing 50:2) - for all sites, premium or free.
 *
 * @param {premiumTransferSiteSuccessParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {string} disconnectedSubscriptionsIds - disconnected_subscriptions_ids
 * @property {boolean} isOffline - is_offline
 * @property {GUID} newSiteGuid - new site
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} newUserGuid - accepting user
 * @property {boolean} includePremiumPlan - True/False transfer a premium plan
 * @property {string} user_agent - user_agent
 * @property {string} rejectedWixPaymentsAccountIds - rejected_wix_payments_account_ids
 * @property {string} transferredSubscriptionsIds - transferred_subscriptions_ids
 * @property {boolean} isPremium - True/False transfer a subscription (premium/TPA)
 * @property {string} acceptedWixPaymentsAccountIds - accepted_wix_payments_account_ids
 * @return {LogObject<premiumTransferSiteSuccessParams>} LogObject<premiumTransferSiteSuccessParams>
 */
export function premiumTransferSiteSuccess(params) {
    return { evid: 8503, src: 50, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transferSiteErrors' event (evid: 8504)
 *
 * Event description: transfer site errors (replacing 50:3)
 *
 * @param {transferSiteErrorsParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {string} errn - error name
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} newUserGuid - accepting user
 * @property {string} user_agent - user_agent
 * @property {boolean} existingUser - if the email belong to a wix user
 * @property {number} errc - error code
 * @property {boolean} isPremium - True/False transfer a subscription (premium/TPA)
 * @return {LogObject<transferSiteErrorsParams>} LogObject<transferSiteErrorsParams>
 */
export function transferSiteErrors(params) {
    return { evid: 8504, src: 50, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteTargetUserClickConfirmTransfer' event (evid: 8505)
 *
 * Event description: target user click 'confirm transfer'  in the email (replacing 50:21) in case it's a new user, he will need to signup first
 *
 * @param {premiumTransferSiteTargetUserClickConfirmTransferParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} newUserGuid - accepting user
 * @property {string} user_agent - user_agent
 * @property {boolean} isPremium - True/False transfer a subscription (premium/TPA)
 * @return {LogObject<premiumTransferSiteTargetUserClickConfirmTransferParams>} LogObject<premiumTransferSiteTargetUserClickConfirmTransferParams>
 */
export function premiumTransferSiteTargetUserClickConfirmTransfer(params) {
    return { evid: 8505, src: 50, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSiteClickCancelBackOnTransferSiteActionWindow' event (evid: 47)
 *
 * Event description: when user click on quick action, and then click on cancel when the quick action window is opened
 *
 * @param {dashboardSiteClickCancelBackOnTransferSiteActionWindowParams} params - The parameters for this event
 * @property {string} name - name of quick action (transfer,etc.)
 * @property {string} stage_process - {transfer_details_summary, transfer_options_select}
 * @property {string} view_type - view_type
 * @property {string} origin - --
 * @property {string} platform - platform
 * @property {string} hosting - ma/editor
 * @property {GUID} msid - --
 * @return {LogObject<dashboardSiteClickCancelBackOnTransferSiteActionWindowParams>} LogObject<dashboardSiteClickCancelBackOnTransferSiteActionWindowParams>
 */
export function dashboardSiteClickCancelBackOnTransferSiteActionWindow(params) {
    return { evid: 47, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSiteClickNextOnTransferSiteActionFirstWindow' event (evid: 48)
 *
 * Event description: when user click on quick action, and then click next after chooses relevant transfer options
 *
 * @param {dashboardSiteClickNextOnTransferSiteActionFirstWindowParams} params - The parameters for this event
 * @property {string} name - name of quick action (transfer,etc.)
 * @property {string} stage_process - deprecated
 * @property {string} stepLabel - recipient-step, options-step, confirmation-step, success-step
 * @property {boolean} transferPremium - true if marked
 * @property {boolean} keepCopy - true if marked
 * @property {string} view_type - view_type
 * @property {string} origin - --
 * @property {boolean} transferDomain - true if marked
 * @property {string} platform - platform
 * @property {boolean} addAdmin - true if marked
 * @property {string} hosting - ma/editor
 * @property {boolean} isContributor - true if email is contact
 * @property {GUID} msid - --
 * @return {LogObject<dashboardSiteClickNextOnTransferSiteActionFirstWindowParams>} LogObject<dashboardSiteClickNextOnTransferSiteActionFirstWindowParams>
 */
export function dashboardSiteClickNextOnTransferSiteActionFirstWindow(params) {
    return { evid: 48, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindow' event (evid: 49)
 *
 * Event description: legal checkbox on/off
 *
 * @param {dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindowParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {boolean} check_box - true/false
 * @property {string} platform - platform
 * @property {string} hosting - ma/editor
 * @property {GUID} msid - site id
 * @return {LogObject<dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindowParams>} LogObject<dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindowParams>
 */
export function dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindow(params) {
    return { evid: 49, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transferSiteOpenTransferDialogClick' event (evid: 63)
 *
 * Event description: user clicks on transfer site and dialog is opened
 *
 * @param {transferSiteOpenTransferDialogClickParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} origin - quick-actions/roles-contributor/roles-owner
 * @property {string} platform - platform
 * @property {string} hosting - MA /Editor
 * @property {string} block_from_transfer_reason - Block from transferring a site
 * @property {GUID} msid - msid
 * @return {LogObject<transferSiteOpenTransferDialogClickParams>} LogObject<transferSiteOpenTransferDialogClickParams>
 */
export function transferSiteOpenTransferDialogClick(params) {
    return { evid: 63, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardSiteClickRadioButtonOnTransferSiteMiddleStepWindow' event (evid: 9020)
 *
 * Event description: user licked one of the radio buttons on the middle step window in transfer site flow, fired every time the user clicks on one
 *
 * @param {dashboardSiteClickRadioButtonOnTransferSiteMiddleStepWindowParams} params - The parameters for this event
 * @property {string} view_type - view_type
 * @property {string} choice - 'client', 'agency', 'other'
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<dashboardSiteClickRadioButtonOnTransferSiteMiddleStepWindowParams>} LogObject<dashboardSiteClickRadioButtonOnTransferSiteMiddleStepWindowParams>
 */
export function dashboardSiteClickRadioButtonOnTransferSiteMiddleStepWindow(params) {
    return { evid: 9020, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transferSiteSecondStepWindowViewClick' event (evid: 9031)
 *
 * Event description: user licked one of the radio buttons on the middle step window in transfer site flow, fired every time the user clicks on one
 *
 * @param {transferSiteSecondStepWindowViewClickParams} params - The parameters for this event
 * @property {string} clickType - keep role/create a copy/remove create a cope/remove keep role/remove transfer premium/transfer premium/transfer domain/remove transfer domain/null if view only
 * @property {string} view_type - view_type
 * @property {boolean} isPremium - is site premium
 * @property {string} platform - platform
 * @property {GUID} msid - msid
 * @return {LogObject<transferSiteSecondStepWindowViewClickParams>} LogObject<transferSiteSecondStepWindowViewClickParams>
 */
export function transferSiteSecondStepWindowViewClick(params) {
    return { evid: 9031, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serviceUpgradedInTheLastYearCopySrc70Evid736' event (evid: 736)
 *
 * Event description: --Premium Services--
 * will be sent for  - premium plans
 * -service that had a price increase: add
 * -service from the first list that didn't have a price increase in the last 6 months: remove
 *
 * @param {serviceUpgradedInTheLastYearCopySrc70Evid736Params} params - The parameters for this event
 * @property {GUID} serviceGuid - sbs service guid
 * @property {GUID} uuid - uuid
 * @property {DateTime} actionDate - action date
 * @property {string} action - add / remove
 * @return {LogObject<serviceUpgradedInTheLastYearCopySrc70Evid736Params>} LogObject<serviceUpgradedInTheLastYearCopySrc70Evid736Params>
 */
export function serviceUpgradedInTheLastYearCopySrc70Evid736(params) {
    return { evid: 736, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'requestForServicesTerminationByWixCopySrc74Evid1' event (evid: 1)
 *
 * Event description: This event will fire when a request for service termination is created by wix employees. Currently the limit for request is 15 services and we want to monitor it. Major part of the data is in anonymous
 *
 * @param {requestForServicesTerminationByWixCopySrc74Evid1Params} params - The parameters for this event
 * @property {boolean} isLimitExceeded - is_limit_exceeded
 * @property {string} source - email of employee who initiated the termination
 * @property {number} countServices - number of services to exclude
 * @property {GUID} uuid - Originator uuid (UUID of employee who initiated the termination)
 * @property {number} transactionSource - transaction_source
 * @property {string} user_agent - user_agent
 * @property {string} serviceGuids - list of services to terminate
 * @property {string} userId - uuid of the actual user we tried to terminate his services
 * @return {LogObject<requestForServicesTerminationByWixCopySrc74Evid1Params>} LogObject<requestForServicesTerminationByWixCopySrc74Evid1Params>
 */
export function requestForServicesTerminationByWixCopySrc74Evid1(params) {
    return { evid: 1, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeRouting' event (evid: 1001)
 *
 * Event description: where the transaction is routing to
 *
 * @param {chargeRoutingParams} params - The parameters for this event
 * @property {string} billingCountry - country from billing account
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {string} paymentGatewayNames - 1 or 2 gateways
 * @property {GUID} uuid - uuid
 * @property {string} paymentGatewayGuids - 1 or 2 gateways
 * @property {number} transactionSource - user,support...
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - 1=recurring ; 0=charge
 * @property {string} sessionId - 3ds session id
 * @property {number} billingAccountType - 0=credit card ; 10=SEPA..
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto...
 * @property {string} currency - currency
 * @property {string} billingState - state from billing account
 * @property {number} creditCardType - 0=visa ; 2=amex..
 * @property {string} paymentGatewayBeans - gateway Beans
 * @property {GUID} paymentSessionGuid - payment session
 * @property {string} activeExperiments - Petri and label
 * @return {LogObject<chargeRoutingParams>} LogObject<chargeRoutingParams>
 */
export function chargeRouting(params) {
    return { evid: 1001, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeFailure' event (evid: 1002)
 *
 * Event description: Failed transactions
 *
 * @param {chargeFailureParams} params - The parameters for this event
 * @property {string} billingCountry - country from billing account
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {GUID} uuid - uuid
 * @property {GUID} transactionGuid - transaction Guid
 * @property {string} paymentGatewayBean - gateway Bean
 * @property {number} transactionSource - user,support...
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - 0=charge ; 1=recurring
 * @property {string} errorCode - error code
 * @property {string} sessionId - 3ds session id
 * @property {number} billingAccountType - 0=credit card ; 10=SEPA..
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto...
 * @property {string} currency - currency
 * @property {string} message - error message
 * @property {GUID} paymentGatewayGuid - gateway_guid
 * @property {boolean} failover - 0=failover ; 1=initial
 * @property {string} billingState - state from billing account
 * @property {number} creditCardType - 0=visa ; 2=amex..
 * @property {GUID} paymentSessionGuid - payment session
 * @return {LogObject<chargeFailureParams>} LogObject<chargeFailureParams>
 */
export function chargeFailure(params) {
    return { evid: 1002, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeSuccess' event (evid: 1003)
 *
 * Event description: Successful transactions
 *
 * @param {chargeSuccessParams} params - The parameters for this event
 * @property {string} billingCountry - country from billing account
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {GUID} uuid - uuid
 * @property {GUID} transactionGuid - transaction Guid
 * @property {string} paymentGatewayBean - gateway Bean
 * @property {number} transactionSource - user,support...
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - 0=charge ; 1=recurring
 * @property {string} sessionId - 3ds session id
 * @property {number} billingAccountType - 0=credit card ; 10=SEPA..
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto...
 * @property {string} currency - currency
 * @property {string} message - message
 * @property {GUID} paymentGatewayGuid - gateway_guid
 * @property {boolean} failover - 0=failover ; 1=initial
 * @property {string} billingState - state from billing account
 * @property {number} creditCardType - 0=visa ; 2=amex..
 * @property {GUID} paymentSessionGuid - payment session
 * @return {LogObject<chargeSuccessParams>} LogObject<chargeSuccessParams>
 */
export function chargeSuccess(params) {
    return { evid: 1003, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargePending' event (evid: 1004)
 *
 * Event description: Pending transactions (SEPA)
 *
 * @param {chargePendingParams} params - The parameters for this event
 * @property {string} billingCountry - country from billing account
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {GUID} uuid - uuid
 * @property {GUID} transactionGuid - transaction Guid
 * @property {string} paymentGatewayBean - gateway Bean
 * @property {number} transactionSource - user,support...
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - 0=charge ; 1=recurring
 * @property {string} sessionId - 3ds session id
 * @property {number} billingAccountType - 10=SEPA
 * @property {number} paymentMethodSubType - NULL
 * @property {string} currency - currency
 * @property {string} message - message
 * @property {GUID} paymentGatewayGuid - gateway_guid
 * @property {boolean} failover - 0=failover ; 1=initial
 * @property {string} billingState - state from billing account
 * @property {number} creditCardType - 0=visa ; 2=amex..
 * @property {GUID} paymentSessionGuid - payment session
 * @return {LogObject<chargePendingParams>} LogObject<chargePendingParams>
 */
export function chargePending(params) {
    return { evid: 1004, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeException' event (evid: 1005)
 *
 * Event description: when there is an exception
 *
 * @param {chargeExceptionParams} params - The parameters for this event
 * @property {string} billingCountry - country from billing account
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {GUID} uuid - uuid
 * @property {GUID} transactionGuid - transaction Guid
 * @property {string} paymentGatewayBean - gateway Bean
 * @property {number} transactionSource - user,support...
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - 0=charge ; 1=recurring
 * @property {string} sessionId - 3ds session id
 * @property {number} billingAccountType - 0=credit card ; 10=SEPA..
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto...
 * @property {string} currency - currency
 * @property {string} message - message
 * @property {GUID} paymentGatewayGuid - gateway_guid
 * @property {boolean} failover - 0=failover ; 1=initial
 * @property {string} billingState - state from billing account
 * @property {number} creditCardType - 0=visa ; 2=amex..
 * @property {GUID} paymentSessionGuid - payment session
 * @return {LogObject<chargeExceptionParams>} LogObject<chargeExceptionParams>
 */
export function chargeException(params) {
    return { evid: 1005, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeNoGatewaysAvailable' event (evid: 1006)
 *
 * Event description: when there is no gateways available
 *
 * @param {chargeNoGatewaysAvailableParams} params - The parameters for this event
 * @property {string} billingCountry - country from billing account
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - user,support...
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - 0=charge ; 1=recurring
 * @property {number} billingAccountType - 0=credit card ; 10=SEPA..
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto...
 * @property {string} currency - currency
 * @property {string} billingState - state from billing account
 * @property {number} creditCardType - 0=visa ; 2=amex..
 * @property {GUID} paymentSessionGuid - payment session
 * @return {LogObject<chargeNoGatewaysAvailableParams>} LogObject<chargeNoGatewaysAvailableParams>
 */
export function chargeNoGatewaysAvailable(params) {
    return { evid: 1006, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeAttemptWithBlockedCreditCard' event (evid: 1007)
 *
 * Event description: The action was not able to happen because of a blocked card
 *
 * @param {chargeAttemptWithBlockedCreditCardParams} params - The parameters for this event
 * @property {string} billingCountry - country from billing account
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - user,support...
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - 0=charge ; 1=recurring
 * @property {number} billingAccountType - 0=credit card
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto...
 * @property {string} currency - currency
 * @property {string} billingState - state from billing account
 * @property {number} creditCardType - 0=visa ; 2=amex..
 * @property {GUID} paymentSessionGuid - payment session
 * @return {LogObject<chargeAttemptWithBlockedCreditCardParams>} LogObject<chargeAttemptWithBlockedCreditCardParams>
 */
export function chargeAttemptWithBlockedCreditCard(params) {
    return { evid: 1007, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'generateOrderPage' event (evid: 1008)
 *
 * Event description: SBS get a request to generate WIX purchase page
 *
 * @param {generateOrderPageParams} params - The parameters for this event
 * @property {string} countryISO2 - country code from premium
 * @property {string} remoteIp - Ip from premium
 * @property {string} parentDomain - hosting server domain
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} productIds - all the products in the page (sbs guids)
 * @property {string} templateName - iframe template name
 * @property {string} user_agent - user_agent
 * @property {string} productClassNames - all the products class  in the page (sbs guids)
 * @property {string} localeLanguage - locale language from premium
 * @property {string} currency - currency
 * @return {LogObject<generateOrderPageParams>} LogObject<generateOrderPageParams>
 */
export function generateOrderPage(params) {
    return { evid: 1008, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'generateChangePaymentPage' event (evid: 1009)
 *
 * Event description: SBS get a request to generate WIX update payment method page
 *
 * @param {generateChangePaymentPageParams} params - The parameters for this event
 * @property {string} countryISO2 - country code from premium
 * @property {string} billingAccountGuid - billingAccountGuid
 * @property {string} parentDomain - hosting server domain
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} templateName - iframe template name
 * @property {string} user_agent - user_agent
 * @property {string} serviceStatus - Service Status
 * @property {string} localeLanguage - locale language from premium
 * @property {string} serviceId - sbs service id
 * @property {string} lastInvoiceStatus - last_invoice_status
 * @return {LogObject<generateChangePaymentPageParams>} LogObject<generateChangePaymentPageParams>
 */
export function generateChangePaymentPage(params) {
    return { evid: 1009, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'generatePayNowPage' event (evid: 1010)
 *
 * Event description: SBS get a request to generate WIX payNow page (for an existing invoice)
 *
 * @param {generatePayNowPageParams} params - The parameters for this event
 * @property {string} countryISO2 - country code from premium
 * @property {string} remoteIp - IP from oremium
 * @property {string} parentDomain - hosting server domain
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} templateName - iframe template name
 * @property {number} invoiceId - invoiceId
 * @property {string} user_agent - user_agent
 * @property {string} serviceStatus - Service Status
 * @property {string} localeLanguage - locale language from premium
 * @property {string} currency - currency
 * @property {string} serviceId - sbs service id
 * @property {string} invoiceStatus - Invoice Status
 * @return {LogObject<generatePayNowPageParams>} LogObject<generatePayNowPageParams>
 */
export function generatePayNowPage(params) {
    return { evid: 1010, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'generateTransferPage' event (evid: 1011)
 *
 * Event description: will update later
 *
 * @param {generateTransferPageParams} params - The parameters for this event
 * @property {string} countryISO2 - country code from premium
 * @property {string} parentDomain - hosting server domain
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} templateName - iframe template name
 * @property {string} user_agent - user_agent
 * @property {boolean} savedPaymentMethodShown - True or false
 * @property {string} localeLanguage - locale language from premium
 * @property {string} sourceCustomerExternalId - source_customer_external_id
 * @property {string} transferServiceIds - transfer_service_ids
 * @property {string} destinationCustomerExternalId - destination_customer_external_id
 * @return {LogObject<generateTransferPageParams>} LogObject<generateTransferPageParams>
 */
export function generateTransferPage(params) {
    return { evid: 1011, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transferService' event (evid: 1012)
 *
 * Event description: A service is transferred to a different user and site - start
 *
 * @param {transferServiceParams} params - The parameters for this event
 * @property {string} sourceServiceIds - sourceServiceIds
 * @property {GUID} sourceCustomerGuid - sourceCustomerGuid
 * @property {GUID} billingAccountGuid - billingAccountGuid
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} transferParams - transferParams
 * @property {string} user_agent - user_agent
 * @property {string} destinationServiceIds - destinationServiceIds
 * @property {GUID} destinationCustomerGuid - destinationCustomerGuid
 * @return {LogObject<transferServiceParams>} LogObject<transferServiceParams>
 */
export function transferService(params) {
    return { evid: 1012, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commitServicesTransfer' event (evid: 1013)
 *
 * Event description: A service is transferred to a different user and site - succses
 *
 * @param {commitServicesTransferParams} params - The parameters for this event
 * @property {string} sourceServiceIds - sourceServiceIds
 * @property {GUID} sourceCustomerGuid - sourceCustomerGuid
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} user_agent - user_agent
 * @property {string} destinationServiceIds - destinationServiceIds
 * @property {GUID} destinationCustomerGuid - destinationCustomerGuid
 * @return {LogObject<commitServicesTransferParams>} LogObject<commitServicesTransferParams>
 */
export function commitServicesTransfer(params) {
    return { evid: 1013, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundTransactionSuccessEvent' event (evid: 1014)
 *
 * Event description: REFUND_TRANSACTION_SUCCESS_EVENT
 *
 * @param {refundTransactionSuccessEventParams} params - The parameters for this event
 * @property {GUID} originalTransactionGuid - originalTransactionGuid
 * @property {GUID} billingAccountGuid - billing_account_guid
 * @property {GUID} refundLineItemGuid - refund_line_item_guid
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {GUID} refundClaimGuid - refund_claim_guid
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} user_agent - user_agent
 * @property {number} billingAccountType - billingAccountType
 * @property {number} paymentMethodSubType - paymentMethodSubType
 * @property {string} currency - currency
 * @property {number} refundAmount - refundAmount
 * @property {GUID} refundTransactionGuid - refund_transaction_guid
 * @return {LogObject<refundTransactionSuccessEventParams>} LogObject<refundTransactionSuccessEventParams>
 */
export function refundTransactionSuccessEvent(params) {
    return { evid: 1014, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundTransactionPendingEvent' event (evid: 1015)
 *
 * Event description: REFUND_TRANSACTION_PENDING_EVENT
 *
 * @param {refundTransactionPendingEventParams} params - The parameters for this event
 * @property {GUID} originalTransactionGuid - originalTransactionGuid
 * @property {GUID} billingAccountGuid - billing_account_guid
 * @property {GUID} refundLineItemGuid - refund_line_item_guid
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {GUID} refundClaimGuid - refund_claim_guid
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} user_agent - user_agent
 * @property {number} billingAccountType - billingAccountType
 * @property {number} paymentMethodSubType - paymentMethodSubType
 * @property {string} currency - currency
 * @property {number} refundAmount - refundAmount
 * @property {GUID} refundTransactionGuid - refund_transaction_guid
 * @return {LogObject<refundTransactionPendingEventParams>} LogObject<refundTransactionPendingEventParams>
 */
export function refundTransactionPendingEvent(params) {
    return { evid: 1015, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundTransactionFailureEvent' event (evid: 1016)
 *
 * Event description: REFUND_TRANSACTION_FAILURE_EVENT
 *
 * @param {refundTransactionFailureEventParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing_account_guid
 * @property {GUID} refundLineItemGuid - refund_line_item_guid
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {GUID} refundClaimGuid - refund_claim_guid
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} user_agent - user_agent
 * @property {number} billingAccountType - billingAccountType
 * @property {number} paymentMethodSubType - paymentMethodSubType
 * @property {string} currency - currency
 * @property {number} refundAmount - refundAmount
 * @property {GUID} refundTransactionGuid - refund_transaction_guid
 * @return {LogObject<refundTransactionFailureEventParams>} LogObject<refundTransactionFailureEventParams>
 */
export function refundTransactionFailureEvent(params) {
    return { evid: 1016, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargebackTransactionEvent' event (evid: 1017)
 *
 * Event description: ChargebackTransactionEvent
 *
 * @param {chargebackTransactionEventParams} params - The parameters for this event
 * @property {string} chargebackId - chargebackId
 * @property {GUID} billingAccountGuid - billingAccountGuid
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {GUID} uuid - userGuid
 * @property {GUID} userGuid - userGuid
 * @property {string} paymentGatewayBean - paymentGatewayBean
 * @property {number} transactionSource - transaction_source
 * @property {string} reasonCode - reasonCode
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - recurring
 * @property {string} processorTransactionId - processorTransactionId
 * @property {string} currency - currency
 * @property {string} chargebackMessage - chargebackMessage
 * @property {GUID} paymentGatewayGuid - paymentGatewayGuid
 * @property {GUID} chargebackTransactionGuid - chargebackTransactionGuid
 * @property {GUID} chargeTransactionGuid - chargeTransactionGuid
 * @return {LogObject<chargebackTransactionEventParams>} LogObject<chargebackTransactionEventParams>
 */
export function chargebackTransactionEvent(params) {
    return { evid: 1017, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serviceCreated' event (evid: 1018)
 *
 * Event description: include: initial / switch up / switch down
 *
 * @param {serviceCreatedParams} params - The parameters for this event
 * @property {number} cycleUnitAmount - cycle_unit_amount
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {GUID} serviceGuid - serviceGuid
 * @property {GUID} uuid - uuid
 * @property {string} serviceName - serviceName
 * @property {string} productClassName - productClassName
 * @property {GUID} transactionGuid - transaction Guid
 * @property {number} transactionSource - transaction_source
 * @property {string} orderParams - order_params
 * @property {number} invoiceId - invoice_id
 * @property {string} user_agent - user_agent
 * @property {GUID} orderGuid - order_guid
 * @property {number} contractSwitchType - 0=NOT_APPLICABLE ; 1=ADDITIONAL_QUANTITY ; 2=CREDIT_UNUSED_PERIOD ; 3=REFUND_PRICE_DIFF ; 4=ADJUST_PERIOD_END ; 5=DOWNGRADE_GRACE_PERIOD
 * @property {number} billingAccountType - 0=credit card ; 10=SEPA..
 * @property {string} currency - currency
 * @property {string} cycleUnitType - cycle_unit_type
 * @property {string} productGuid - productGuid
 * @property {number} creditCardType - creditCardType
 * @return {LogObject<serviceCreatedParams>} LogObject<serviceCreatedParams>
 */
export function serviceCreated(params) {
    return { evid: 1018, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'resolveTaxRate' event (evid: 1019)
 *
 * Event description: tax calculation result
 *
 * @param {resolveTaxRateParams} params - The parameters for this event
 * @property {string} taxCode - tax code
 * @property {GUID} billingAccountGuid - billing_account_guid
 * @property {string} source - external/fallback/default
 * @property {string} taxPercent - tax_percent
 * @property {string} state - Sate
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} zipCode - zip_code
 * @property {string} orderParams - orderParams
 * @property {number} invoiceId - invoice_id
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - 0=charge ; 1=recurring
 * @property {string} taxServiceError - IN CASE external_response=error
 * @property {string} taxServiceTrackingId - correlating with tax_service
 * @property {string} taxServiceErrorMessage - tax_service_error_message
 * @return {LogObject<resolveTaxRateParams>} LogObject<resolveTaxRateParams>
 */
export function resolveTaxRate(params) {
    return { evid: 1019, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'taxCalculationProcess' event (evid: 1020)
 *
 * Event description: tax calculation result
 *
 * @param {taxCalculationProcessParams} params - The parameters for this event
 * @property {number} taxRateDefault - default_tax_rate from sbs db
 * @property {string} taxCode - tax code
 * @property {string} taxPercent - tax_percent
 * @property {string} state - State
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} zipCode - zip_code
 * @property {string} user_agent - user_agent
 * @property {string} taxPercentDefault - tax_percent_default
 * @return {LogObject<taxCalculationProcessParams>} LogObject<taxCalculationProcessParams>
 */
export function taxCalculationProcess(params) {
    return { evid: 1020, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingAccountCreated' event (evid: 1021)
 *
 * Event description: billing account created
 *
 * @param {billingAccountCreatedParams} params - The parameters for this event
 * @property {string} billingCountry - billing_country_code
 * @property {GUID} billingAccountGuid - billing_account_guid
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} taxType - 0 =regular; 1=EU_VAT.. .4=US_TAX
 * @property {boolean} isClone - true/false
 * @property {string} user_agent - user_agent
 * @property {string} customerId - customer_id
 * @property {number} billingAccountType - 0=credit card ; 10=SEPA..
 * @property {number} paymentMethodSubType - 0 =OXXO; 5=PAYU_CREDIT_CARD; 6=PAYU_DEBIT_CARD...
 * @property {GUID} originalBillingAccountGuid - if isClone is null (ba created without clone) then this field will be null
 * @property {number} creditCardType - 0 =VISA; 1= Mastercard...
 * @return {LogObject<billingAccountCreatedParams>} LogObject<billingAccountCreatedParams>
 */
export function billingAccountCreated(params) {
    return { evid: 1021, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'invoiceUpdateBillingAccountSuccess' event (evid: 1022)
 *
 * Event description: invoice update billing account success (server event for each invoice)
 *
 * @param {invoiceUpdateBillingAccountSuccessParams} params - The parameters for this event
 * @property {GUID} newBillingAccountGuid - new_billing_account_guid
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {number} invoiceId - invoice_id
 * @property {string} user_agent - user_agent
 * @property {GUID} originalBillingAccountGuid - if isClone is null (ba created without clone) then this field will be null
 * @return {LogObject<invoiceUpdateBillingAccountSuccessParams>} LogObject<invoiceUpdateBillingAccountSuccessParams>
 */
export function invoiceUpdateBillingAccountSuccess(params) {
    return { evid: 1022, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serviceUpdateBillingAccountSuccess' event (evid: 1023)
 *
 * Event description: service update billing account success (server event for each service)
 *
 * @param {serviceUpdateBillingAccountSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing_account_guid
 * @property {GUID} serviceGuid - serviceGuid
 * @property {GUID} newBillingAccountGuid - f16d0412-085d-4238-ba1c-e66076a4c6a9
 * @property {GUID} uuid - uuid
 * @property {number} transactionSource - transaction_source
 * @property {string} user_agent - user_agent
 * @property {GUID} originalBillingAccountGuid - if isClone is null (ba created without clone) then this field will be null
 * @return {LogObject<serviceUpdateBillingAccountSuccessParams>} LogObject<serviceUpdateBillingAccountSuccessParams>
 */
export function serviceUpdateBillingAccountSuccess(params) {
    return { evid: 1023, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'servicePendingChange' event (evid: 1024)
 *
 * Event description: Service pending change create/cancel
 *
 * @param {servicePendingChangeParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service guid
 * @property {GUID} uuid - uuid
 * @property {number} currentCycleId - current cycle Id
 * @property {number} transactionSource - transaction_source
 * @property {string} user_agent - user_agent
 * @property {string} actionType - NEXT_PAYMENT_CYCLE_CHANGE / NEXT_PRODUCT_CHANGE
 * @property {number} pendingCycleId - pending cycle Id
 * @property {string} action - create/cancel
 * @return {LogObject<servicePendingChangeParams>} LogObject<servicePendingChangeParams>
 */
export function servicePendingChange(params) {
    return { evid: 1024, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountUpdaterBillingAccountSent' event (evid: 1026)
 *
 * Event description: Account Updater - Billing account sent to processor (upload).
 * (In general, Account Updater is a process to update billing accounts with data from the payment gateways)
 *
 * @param {accountUpdaterBillingAccountSentParams} params - The parameters for this event
 * @property {string} billingCountry - country from billing account
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {GUID} uuid - uuid
 * @property {GUID} transactionGuid - transaction Guid
 * @property {string} ccLast4 - credit card last 4 digits
 * @property {string} paymentGatewayBean - gateway Bean
 * @property {number} transactionSource - user,support...
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {string} token_id - credit card token id
 * @property {number} billingAccountType - 0=credit card ; 10=SEPA..
 * @property {string} docId - document Id
 * @property {string} accountUpdaterProvider - the processor that provide the AU service
 * @property {string} currency - currency
 * @property {string} message - transaction notes from last transaction
 * @property {GUID} paymentGatewayGuid - gateway_guid
 * @property {boolean} isClosedBillingAccount - closed account update
 * @property {string} billingState - state from billing account
 * @property {number} creditCardType - 0=visa ; 2=amex..
 * @property {GUID} paymentSessionGuid - payment session
 * @property {DateTime} expiry_date - credit card expiry date
 * @return {LogObject<accountUpdaterBillingAccountSentParams>} LogObject<accountUpdaterBillingAccountSentParams>
 */
export function accountUpdaterBillingAccountSent(params) {
    return { evid: 1026, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountUpdaterBillingAccountReceived' event (evid: 1027)
 *
 * Event description: Account Updater - Billing account received from processor (download).
 * (In general, Account Updater is a process to update billing accounts with data from the payment gateways))
 *
 * @param {accountUpdaterBillingAccountReceivedParams} params - The parameters for this event
 * @property {string} new_ccLast4 - new credit card last 4 digits
 * @property {boolean} isLast4DigitsUpdated - bool field - if we update the last 4 digits on BA
 * @property {string} billingCountry - country from billing account
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {boolean} isChangedLast4Digits - bool field - if we got a new last 4 digits
 * @property {boolean} isCvvUpdated - bool field - if we update the cvv on BA
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {boolean} isExpiryDateUpdated - bool field - if we update the expiry date on BA
 * @property {boolean} isChangedTokenId - bool field - if we got a new token id
 * @property {GUID} uuid - uuid
 * @property {boolean} isChangedExpiryDate - bool field - if we got a new expiry date
 * @property {boolean} isChangedCvv - bool field - if we got a new cvv
 * @property {string} old_token_id - old credit card token id
 * @property {boolean} isBillingAccountUpdated - bool field - if we update the BA
 * @property {GUID} transactionGuid - transaction_guid
 * @property {string} paymentGatewayBean - payment_gateway_bean
 * @property {number} transactionSource - user,support...
 * @property {DateTime} new_expiry_date - new credit card expiry date
 * @property {string} new_token_id - new credit card token id
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {string} triggeredBy - upload or download
 * @property {DateTime} old_expiry_date - old credit card expiry date
 * @property {number} billingAccountType - 0=credit card ; 10=SEPA..
 * @property {string} docId - document Id
 * @property {string} accountUpdaterProvider - the processor that provide the AU service
 * @property {string} currency - currency
 * @property {string} message - transaction notes from last transaction
 * @property {GUID} paymentGatewayGuid - gateway_guid
 * @property {boolean} isClosedBillingAccount - closed account update
 * @property {string} billingState - state from billing account
 * @property {number} creditCardType - 0=visa ; 2=amex..
 * @property {boolean} isTokenIdUpdated - bool field - if we update the token id on BA
 * @property {GUID} paymentSessionGuid - payment session
 * @property {string} old_ccLast4 - old credit card last 4 digits
 * @return {LogObject<accountUpdaterBillingAccountReceivedParams>} LogObject<accountUpdaterBillingAccountReceivedParams>
 */
export function accountUpdaterBillingAccountReceived(params) {
    return { evid: 1027, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeBeforeCallingHost' event (evid: 1028)
 *
 * Event description: When an invoice is created, a call to the host is made the events represents Before sending .
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeBeforeCallingHostParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {GUID} subscriptionId - external id of the service
 * @property {number} transactionSource - transaction_source
 * @property {number} invoiceId - invoice_id
 * @property {string} user_agent - user_agent
 * @property {GUID} customerGuid - The SBS customer guid of the user
 * @property {string} currency - currency
 * @property {DateTime} periodStart - Period Start of the invoice
 * @property {GUID} eventAggregatorId - unique session that will be delivered through flow
 * @property {DateTime} periodEnd - Period End of the invoice
 * @property {GUID} serviceId - SBS service guid
 * @return {LogObject<customChargeBeforeCallingHostParams>} LogObject<customChargeBeforeCallingHostParams>
 */
export function customChargeBeforeCallingHost(params) {
    return { evid: 1028, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customChargeReceivedFromSpiAndStatus' event (evid: 1029)
 *
 * Event description: When an invoice is created, a call to the host is made the events represents Before sending
 * Custom charge is a new service which is used in order to charge the service for an amount which is Unknown at billing ( for example - metered billing by a 3rd party)
 *
 * @param {customChargeReceivedFromSpiAndStatusParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} subscriptionId - external id of the service
 * @property {number} transactionSource - transaction_source
 * @property {number} invoiceId - invoice_id
 * @property {string} user_agent - user_agent
 * @property {string} totalAmount - Total amount of the invoice
 * @property {string} status - Paid or not
 * @property {GUID} customerGuid - The sbs customer ID of the user
 * @property {GUID} eventAggregatorId - unique session that will be delivered through flow
 * @property {GUID} serviceId - SBS service ID
 * @return {LogObject<customChargeReceivedFromSpiAndStatusParams>} LogObject<customChargeReceivedFromSpiAndStatusParams>
 */
export function customChargeReceivedFromSpiAndStatus(params) {
    return { evid: 1029, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paymentReceived' event (evid: 1030)
 *
 * Event description: in sofort payment method the service creation and the payment are not in the same time. this event is an indication for the payment received or payment decline.
 *
 * @param {paymentReceivedParams} params - The parameters for this event
 * @property {number} cycleUnitAmount - cycle_unit_amount
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {GUID} serviceGuid - serviceGuid
 * @property {string} paymentStatus - delivered or decline. currently 1/0 only
 * @property {GUID} uuid - uuid
 * @property {string} serviceName - serviceName
 * @property {string} productClassName - productClassName
 * @property {GUID} transactionGuid - transaction Guid
 * @property {number} transactionSource - transaction_source
 * @property {string} orderParams - order_params
 * @property {number} invoiceId - invoice_id
 * @property {string} user_agent - user_agent
 * @property {GUID} orderGuid - order_guid
 * @property {number} contractSwitchType - 0=NOT_APPLICABLE ; 1=ADDITIONAL_QUANTITY ; 2=CREDIT_UNUSED_PERIOD ; 3=REFUND_PRICE_DIFF ; 4=ADJUST_PERIOD_END ; 5=DOWNGRADE_GRACE_PERIOD
 * @property {number} billingAccountType - 0=credit card ; 10=SEPA..
 * @property {number} paymentMethodSubType - sofort ind
 * @property {string} currency - currency
 * @property {string} cycleUnitType - cycle_unit_type
 * @property {string} productGuid - productGuid
 * @property {number} creditCardType - creditCardType
 * @return {LogObject<paymentReceivedParams>} LogObject<paymentReceivedParams>
 */
export function paymentReceived(params) {
    return { evid: 1030, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargebackReversalTransaction' event (evid: 1031)
 *
 * Event description: Chargeback Reversal transaction
 *
 * @param {chargebackReversalTransactionParams} params - The parameters for this event
 * @property {string} chargebackId - chargebackId
 * @property {GUID} billingAccountGuid - billingAccountGuid
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {GUID} uuid - userGuid
 * @property {GUID} userGuid - userGuid
 * @property {string} paymentGatewayBean - paymentGatewayBean
 * @property {number} transactionSource - transaction_source
 * @property {string} reasonCode - reasonCode
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - recurring
 * @property {string} processorTransactionId - processorTransactionId
 * @property {string} currency - currency
 * @property {string} chargebackMessage - chargebackMessage
 * @property {GUID} paymentGatewayGuid - paymentGatewayGuid
 * @property {number} addedDays - number of added days to the service
 * @property {GUID} chargebackTransactionGuid - chargebackTransactionGuid
 * @property {GUID} chargeTransactionGuid - chargeTransactionGuid
 * @return {LogObject<chargebackReversalTransactionParams>} LogObject<chargebackReversalTransactionParams>
 */
export function chargebackReversalTransaction(params) {
    return { evid: 1031, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'secondChargebackTransaction' event (evid: 1032)
 *
 * Event description: Second Chargeback transaction (can happen after chargeback reversal- 74:1031)
 *
 * @param {secondChargebackTransactionParams} params - The parameters for this event
 * @property {string} chargebackId - chargebackId
 * @property {GUID} billingAccountGuid - billingAccountGuid
 * @property {string} paymentGatewayName - paymentGatewayName
 * @property {GUID} uuid - userGuid
 * @property {GUID} userGuid - userGuid
 * @property {string} paymentGatewayBean - paymentGatewayBean
 * @property {number} transactionSource - transaction_source
 * @property {string} reasonCode - reasonCode
 * @property {number} invoiceId - billing invoice id
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - recurring
 * @property {string} processorTransactionId - processorTransactionId
 * @property {string} currency - currency
 * @property {string} chargebackMessage - chargebackMessage
 * @property {GUID} paymentGatewayGuid - paymentGatewayGuid
 * @property {number} addedDays - number of added days to the service
 * @property {GUID} chargebackTransactionGuid - chargebackTransactionGuid
 * @property {GUID} chargeTransactionGuid - chargeTransactionGuid
 * @return {LogObject<secondChargebackTransactionParams>} LogObject<secondChargebackTransactionParams>
 */
export function secondChargebackTransaction(params) {
    return { evid: 1032, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cashfreeCallsTax' event (evid: 1044)
 *
 * Event description: Cashfree calls in the correct projecct
 *
 * @param {cashfreeCallsTaxParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service id
 * @property {string} validResponse - valid Response
 * @property {string} taxIdString - tax id string
 * @return {LogObject<cashfreeCallsTaxParams>} LogObject<cashfreeCallsTaxParams>
 */
export function cashfreeCallsTax(params) {
    return { evid: 1044, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'requestForServicesTerminationByWix' event (evid: 1045)
 *
 * Event description: This event will fire when a request for service termination is created by wix employees. Currently the limit for request is 15 services and we want to monitor it. Major part of the data is in anonymous
 *
 * @param {requestForServicesTerminationByWixParams} params - The parameters for this event
 * @property {boolean} isLimitExceeded - is_limit_exceeded
 * @property {string} source - email of employee who initiated the termination
 * @property {number} countServices - number of services to exclude
 * @property {GUID} uuid - Originator uuid (UUID of employee who initiated the termination)
 * @property {number} transactionSource - transaction_source
 * @property {string} user_agent - user_agent
 * @property {string} serviceGuids - list of services to terminate
 * @property {string} userId - uuid of the actual user we tried to terminate his services
 * @return {LogObject<requestForServicesTerminationByWixParams>} LogObject<requestForServicesTerminationByWixParams>
 */
export function requestForServicesTerminationByWix(params) {
    return { evid: 1045, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'freeTrialMissingChargeAttempt' event (evid: 1046)
 *
 * Event description: A single recurring payment was triggered, and for some reason there was no charge attempt or the payment was not handled at all.
 *
 * @param {freeTrialMissingChargeAttemptParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - Billing account guid
 * @property {GUID} serviceGuid - Service guid
 * @property {GUID} uuid - uuid
 * @property {GUID} transactionGuid - transaction guid
 * @property {number} transactionSource - transaction_source
 * @property {string} user_agent - user_agent
 * @property {string} error_type - Error type
 * @property {boolean} isAuthorizedSuccess - Did the transaction succeed
 * @property {DateTime} transactionDate - transaction Date
 * @property {DateTime} freeTrialStartDate - Free trial start date
 * @property {DateTime} freeTrialEndDate - Free trial end date
 * @return {LogObject<freeTrialMissingChargeAttemptParams>} LogObject<freeTrialMissingChargeAttemptParams>
 */
export function freeTrialMissingChargeAttempt(params) {
    return { evid: 1046, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'freeTrialServiceCancellationFailure' event (evid: 1047)
 *
 * Event description: The free trial has ended, the charge attempt got declined, and for some reason we couldn't cancel the service.
 *
 * @param {freeTrialServiceCancellationFailureParams} params - The parameters for this event
 * @property {string} billingAccountGuid - Billing account guid
 * @property {GUID} serviceGuid - Service guid
 * @property {GUID} uuid - uuid
 * @property {GUID} transactionGuid - The declined transaction guid
 * @property {number} transactionSource - transaction_source
 * @property {string} user_agent - user_agent
 * @property {string} error_type - Backend error type
 * @property {number} transactionAmount - Transaction amount
 * @property {string} currency - Currency
 * @property {DateTime} transactionDate - Transaction Date
 * @property {DateTime} freeTrialStartDate - Free trial start date
 * @property {DateTime} freeTrialEndDate - Free trial end date
 * @return {LogObject<freeTrialServiceCancellationFailureParams>} LogObject<freeTrialServiceCancellationFailureParams>
 */
export function freeTrialServiceCancellationFailure(params) {
    return { evid: 1047, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeRoutingChosenPaymentGateway' event (evid: 1048)
 *
 * Event description: where the transaction is routing to
 *
 * @param {chargeRoutingChosenPaymentGatewayParams} params - The parameters for this event
 * @property {string} billingCountry - country from billing account
 * @property {GUID} billingAccountGuid - billing Account Guid
 * @property {string} threedsInitiationType - threeds initiation type
 * @property {string} paymentGatewayNames - 1 or 2 gateways
 * @property {string} externalSessionId - for charge transactions- the same session in the checkout
 * @property {GUID} uuid - uuid
 * @property {string} paymentGatewayGuids - 1 or 2 gateways
 * @property {GUID} transactionGuid - transaction_guid if created else null
 * @property {number} transactionSource - user,support...
 * @property {string} chosenGaymentGatewayName - chosen payment gateway name
 * @property {number} invoiceId - billing invoice id
 * @property {boolean} authorizeSuccess - is successful transaction
 * @property {string} user_agent - user_agent
 * @property {boolean} recurring - 1=recurring ; 0=charge
 * @property {number} billingAccountType - 0=credit card ; 10=SEPA..
 * @property {string} errorDescription - for cases that transaction was not created what is the error reason (user closed the window/fake CC etc)
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto...
 * @property {string} currency - currency
 * @property {boolean} failover - is failover
 * @property {string} chosenGaymentGatewayGuid - chosen payment gateway guid
 * @property {string} billingState - state from billing account
 * @property {number} creditCardType - 0=visa ; 2=amex..
 * @property {string} transactionNotes - transaction notes
 * @property {string} paymentGatewayBeans - gateway Beans
 * @property {GUID} paymentSessionGuid - payment session
 * @property {string} activeExperiments - Petri and label
 * @return {LogObject<chargeRoutingChosenPaymentGatewayParams>} LogObject<chargeRoutingChosenPaymentGatewayParams>
 */
export function chargeRoutingChosenPaymentGateway(params) {
    return { evid: 1048, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingExternalTransactionInsightRequestSrc74Evid1050' event (evid: 1050)
 *
 * Event description: Billing - External Transaction Insight request. An external API call (currently only Verifi) used to retrieve transaction insights. This data helps in disputing chargebacks or providing additional information to users regarding their transactions.
 *
 * @param {billingExternalTransactionInsightRequestSrc74Evid1050Params} params - The parameters for this event
 * @property {string} insightId - uniqe Id from Verify for the flow
 * @property {string} source - source
 * @property {number} ccBin - ccBin
 * @property {number} lastDigits - lastDigits
 * @property {string} currency - currency
 * @property {DateTime} transactionDate - transactionDate
 * @property {string} transactionCode - transactionCode
 * @property {string} invoice - invoice
 * @property {string} linkedInsightId - linkedInsightId
 * @property {string} transactionAmount - transactionAmount
 * @property {string} purchaseIdentifier - purchaseIdentifier
 * @property {string} transactionType - transactionType
 * @property {DateTime} cardExpirationDate - cardExpirationDate
 * @property {string} posEntryModeCode - posEntryModeCode
 * @property {string} transactionRequestId - transactionRequestId
 * @property {string} ipAddress - ipAddress
 * @return {LogObject<billingExternalTransactionInsightRequestSrc74Evid1050Params>} LogObject<billingExternalTransactionInsightRequestSrc74Evid1050Params>
 */
export function billingExternalTransactionInsightRequestSrc74Evid1050(params) {
    return { evid: 1050, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingExternalTransactionInsightResponseSrc74Evid1051' event (evid: 1051)
 *
 * Event description: Billing - External Transaction Insight response. An external API call (currently only Verifi) used to retrieve transaction insights. This data helps in disputing chargebacks or providing additional information to users regarding their transactions.
 *
 * @param {billingExternalTransactionInsightResponseSrc74Evid1051Params} params - The parameters for this event
 * @property {string} insightId - insightId
 * @property {string} source - source API
 * OI =Order insight
 * OID= Order Insight Didtial
 * CE= Compeling Evidence
 * @property {number} ccBin - ccBin
 * @property {number} lastDigits - lastDigits
 * @property {string} currency - currency
 * @property {DateTime} transactionDate - transactionDate
 * @property {string} transactionCode - transactionCode
 * @property {string} linkedInsightId - linkedInsightId
 * @property {string} transactionAmount - transactionAmount
 * @property {string} purchaseIdentifier - purchaseIdentifier
 * @property {string} transactionType - transactionType
 * @property {DateTime} cardExpirationDate - cardExpirationDate
 * @property {string} posEntryModeCode - posEntryModeCode
 * @property {string} transactionRequestId - transactionRequestId
 * @property {string} productDescription - productDescription
 * @property {number} quantity - quantity
 * @property {string} city - city
 * @property {string} region - region
 * @property {string} country - country
 * @property {string} merchantName - merchantName
 * @property {string} merchantUrl - merchantUrl
 * @property {number} invoiceId - invoice_id
 * @property {string} paymentType - paymentType
 * @property {string} token - token
 * @property {string} paymentDescriptor - paymentDescriptor
 * @property {string} paymentDescriptorContact - paymentDescriptorContact
 * @property {string} terminalId - terminalId
 * @property {string} acquirerBin - acquirerBin
 * @property {string} cardAcceptorId - cardAcceptorId
 * @property {string} mcsn - mcsn
 * @property {string} responseError - will be null in case of a valid response
 * @property {string} transactionId - transaction_guid
 * @return {LogObject<billingExternalTransactionInsightResponseSrc74Evid1051Params>} LogObject<billingExternalTransactionInsightResponseSrc74Evid1051Params>
 */
export function billingExternalTransactionInsightResponseSrc74Evid1051(params) {
    return { evid: 1051, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'billingExternalTransactionInsightNotificationSrc74Evid1052' event (evid: 1052)
 *
 * Event description: Billing - External Transaction Insight notifciation. An external API call (currently only Verifi) used to retrieve transaction insights. This data helps in disputing chargebacks or providing additional information to users regarding their transactions.
 *
 * @param {billingExternalTransactionInsightNotificationSrc74Evid1052Params} params - The parameters for this event
 * @property {string} caseId - caseId -changed to external since case_id was integer in system
 * @property {string} caseStatus - caseStatus
 * @property {string} caseEvent - caseEvent
 * @property {string} linkedCaseId - linkedCaseId
 * @property {string} caseType - caseType
 * @property {number} cardBin - card_bin
 * @property {number} cardLast4 - cardLast4
 * @property {DateTime} transactionDate - transactionDate
 * @property {string} reasonCode - reasonCode
 * @property {string} statusCode - statusCode
 * @property {string} fraudType - fraudType
 * @property {DateTime} fraudReportLastUpdatedDate - fraudReportLastUpdatedDate
 * @property {DateTime} dateFraudReportedToIssuer - dateFraudReportedToIssuer
 * @property {string} fraudDisputeEligibleId - fraudDisputeEligibleId
 * @property {string} linkedInsightId - linkedInsightId
 * @property {string} linkedRDRCaseId - linkedRDRCaseId
 * @property {string} source - source - API type
 * @property {DateTime} caseDate - caseDate
 * @property {string} token - token
 * @property {string} paymentType - paymentType
 * @property {string} currency - currency
 * @property {string} arn - arn
 * @property {string} authcode - authcode
 * @property {string} terminalId - terminalId
 * @property {string} acquirerBin - acquirerBin
 * @property {string} cardAcceptorId - cardAcceptorId
 * @property {string} paymentDescriptor - paymentDescriptor
 * @property {string} paymentDescriptorContact - paymentDescriptorContact
 * @property {string} mcsn - mcsn
 * @property {string} purchaseIdentifier - purchaseIdentifier
 * @property {string} transactionId - transactionId
 * @property {string} transactionType - transactionType
 * @property {DateTime} fraudReportDate - fraudReportDate
 * @property {string} amount - transactionAmount ( although it amount field and not transaction amount)
 * @return {LogObject<billingExternalTransactionInsightNotificationSrc74Evid1052Params>} LogObject<billingExternalTransactionInsightNotificationSrc74Evid1052Params>
 */
export function billingExternalTransactionInsightNotificationSrc74Evid1052(params) {
    return { evid: 1052, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'invoiceChargeAttemptExecuted' event (evid: 1100)
 *
 * Event description: Invoice Charge Attempt - Executed
 *
 * @param {invoiceChargeAttemptExecutedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {number} invoiceId - invoiceId
 * @property {string} user_agent - user_agent
 * @property {GUID} invoiceAttemptGuid - invoice_attempt_guid
 * @property {boolean} chargeSuccess - chargeSuccess
 * @return {LogObject<invoiceChargeAttemptExecutedParams>} LogObject<invoiceChargeAttemptExecutedParams>
 */
export function invoiceChargeAttemptExecuted(params) {
    return { evid: 1100, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'invoiceChargeAttemptException' event (evid: 1101)
 *
 * Event description: Invoice Charge Attempt - Exception
 *
 * @param {invoiceChargeAttemptExceptionParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {number} invoiceId - invoiceId
 * @property {string} user_agent - user_agent
 * @property {string} exceptionMessage - exception_message
 * @property {string} exceptionClassName - exception_class_name
 * @return {LogObject<invoiceChargeAttemptExceptionParams>} LogObject<invoiceChargeAttemptExceptionParams>
 */
export function invoiceChargeAttemptException(params) {
    return { evid: 1101, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'invoiceTooManyExecutedInLastDay' event (evid: 1102)
 *
 * Event description: Invoice Too Many Executed In Last Day
 *
 * @param {invoiceTooManyExecutedInLastDayParams} params - The parameters for this event
 * @property {number} count - count of charge attempts
 * @property {GUID} uuid - uuid
 * @property {number} invoiceId - invoiceId
 * @property {string} user_agent - user_agent
 * @return {LogObject<invoiceTooManyExecutedInLastDayParams>} LogObject<invoiceTooManyExecutedInLastDayParams>
 */
export function invoiceTooManyExecutedInLastDay(params) {
    return { evid: 1102, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'noNextRetryDateCalculated' event (evid: 1103)
 *
 * Event description: No Next RetryDate Calculated
 *
 * @param {noNextRetryDateCalculatedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {number} invoiceId - invoiceId
 * @property {string} user_agent - user_agent
 * @return {LogObject<noNextRetryDateCalculatedParams>} LogObject<noNextRetryDateCalculatedParams>
 */
export function noNextRetryDateCalculated(params) {
    return { evid: 1103, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scheduledServiceToNextCancellationBatch' event (evid: 1201)
 *
 * Event description: Scheduled Service To Next Cancellation Batch
 *
 * @param {scheduledServiceToNextCancellationBatchParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service guid
 * @property {GUID} serviceCancellation - service cancellation
 * @property {GUID} uuid - uuid
 * @property {DateTime} jobScheduledTime - job scheduled time
 * @return {LogObject<scheduledServiceToNextCancellationBatchParams>} LogObject<scheduledServiceToNextCancellationBatchParams>
 */
export function scheduledServiceToNextCancellationBatch(params) {
    return { evid: 1201, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'terminationServiceStarted' event (evid: 1202)
 *
 * Event description: Termination Service Started
 *
 * @param {terminationServiceStartedParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service guid
 * @property {GUID} serviceCancellation - service cancellation
 * @property {GUID} uuid - uuid
 * @return {LogObject<terminationServiceStartedParams>} LogObject<terminationServiceStartedParams>
 */
export function terminationServiceStarted(params) {
    return { evid: 1202, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serviceNotSuspended' event (evid: 1203)
 *
 * Event description: Service Not Suspended (we meant to move a service from status suspended to status cancelled, but the service is not in status suspended - it's either cancelled before or became active)
 *
 * @param {serviceNotSuspendedParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service guid
 * @property {GUID} serviceCancellation - service cancellation
 * @property {GUID} uuid - uuid
 * @return {LogObject<serviceNotSuspendedParams>} LogObject<serviceNotSuspendedParams>
 */
export function serviceNotSuspended(params) {
    return { evid: 1203, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeServiceSuccess' event (evid: 1204)
 *
 * Event description: Charge Service Success
 *
 * @param {chargeServiceSuccessParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service guid
 * @property {GUID} serviceCancellation - service cancellation
 * @property {GUID} uuid - uuid
 * @return {LogObject<chargeServiceSuccessParams>} LogObject<chargeServiceSuccessParams>
 */
export function chargeServiceSuccess(params) {
    return { evid: 1204, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chargeServiceExploded' event (evid: 1205)
 *
 * Event description: Charge Service Exploded
 *
 * @param {chargeServiceExplodedParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service guid
 * @property {GUID} serviceCancellation - service cancellation
 * @property {GUID} uuid - uuid
 * @property {string} exception - exception
 * @return {LogObject<chargeServiceExplodedParams>} LogObject<chargeServiceExplodedParams>
 */
export function chargeServiceExploded(params) {
    return { evid: 1205, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainValidEvent' event (evid: 1207)
 *
 * Event description: Domain Valid Event
 *
 * @param {domainValidEventParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service guid
 * @property {GUID} serviceCancellation - service cancellation
 * @property {GUID} uuid - uuid
 * @return {LogObject<domainValidEventParams>} LogObject<domainValidEventParams>
 */
export function domainValidEvent(params) {
    return { evid: 1207, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainNotValidEvent' event (evid: 1208)
 *
 * Event description: Domain Not Valid Event
 *
 * @param {domainNotValidEventParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service guid
 * @property {GUID} serviceCancellation - service cancellation
 * @property {GUID} uuid - uuid
 * @return {LogObject<domainNotValidEventParams>} LogObject<domainNotValidEventParams>
 */
export function domainNotValidEvent(params) {
    return { evid: 1208, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serviceCancelled' event (evid: 1209)
 *
 * Event description: Service Cancelled
 *
 * @param {serviceCancelledParams} params - The parameters for this event
 * @property {GUID} serviceGuid - service guid
 * @property {GUID} serviceCancellation - service cancellation
 * @property {GUID} uuid - uuid
 * @return {LogObject<serviceCancelledParams>} LogObject<serviceCancelledParams>
 */
export function serviceCancelled(params) {
    return { evid: 1209, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'receiveServiceForCancellation' event (evid: 1211)
 *
 * Event description: Receive Service For Cancellation
 *
 * @param {receiveServiceForCancellationParams} params - The parameters for this event
 * @property {DateTime} date_created - service was insert to cancellation job
 * @property {GUID} serviceGuid - service guid
 * @property {GUID} serviceCancellation - service cancellation
 * @property {number} serviceCancellationStatus - service cancellation status
 * @property {GUID} uuid - uuid
 * @property {string} jsonData - json data
 * @return {LogObject<receiveServiceForCancellationParams>} LogObject<receiveServiceForCancellationParams>
 */
export function receiveServiceForCancellation(params) {
    return { evid: 1211, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsFromClientInt' event (evid: 1300)
 *
 * Event description: after the user request to purchase (all types of PM and Geos) we start the 3ds process.
 *
 * @param {dsFromClientIntParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay/ If it’s not null its failover
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @property {string} trackableTenant - trackable tenant
 * @return {LogObject<dsFromClientIntParams>} LogObject<dsFromClientIntParams>
 */
export function dsFromClientInt(params) {
    return { evid: 1300, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsFromClientFingerprintSuccess' event (evid: 1301)
 *
 * Event description: we get a fingerprint from the client
 *
 * @param {dsFromClientFingerprintSuccessParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsFromClientFingerprintSuccessParams>} LogObject<dsFromClientFingerprintSuccessParams>
 */
export function dsFromClientFingerprintSuccess(params) {
    return { evid: 1301, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsFromClientFingerprintFailed' event (evid: 1302)
 *
 * Event description: we wasn't able to get a fingerprint from the client
 *
 * @param {dsFromClientFingerprintFailedParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {string} reason - reason
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsFromClientFingerprintFailedParams>} LogObject<dsFromClientFingerprintFailedParams>
 */
export function dsFromClientFingerprintFailed(params) {
    return { evid: 1302, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsFromClientChallengeSuccess' event (evid: 1303)
 *
 * Event description: we get a Challenge from the client
 *
 * @param {dsFromClientChallengeSuccessParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsFromClientChallengeSuccessParams>} LogObject<dsFromClientChallengeSuccessParams>
 */
export function dsFromClientChallengeSuccess(params) {
    return { evid: 1303, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsFromClientChallengeFailed' event (evid: 1304)
 *
 * Event description: we wasn't able to get a Challenge2 from the client
 *
 * @param {dsFromClientChallengeFailedParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {string} reason - reason
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsFromClientChallengeFailedParams>} LogObject<dsFromClientChallengeFailedParams>
 */
export function dsFromClientChallengeFailed(params) {
    return { evid: 1304, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsFromClientV1Fallback' event (evid: 1305)
 *
 * Event description: we get v1 verification from client
 *
 * @param {dsFromClientV1FallbackParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsFromClientV1FallbackParams>} LogObject<dsFromClientV1FallbackParams>
 */
export function dsFromClientV1Fallback(params) {
    return { evid: 1305, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsToClientInit' event (evid: 1306)
 *
 * Event description: Request to retry before we have another 1300
 *
 * @param {dsToClientInitParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay - the other one
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsToClientInitParams>} LogObject<dsToClientInitParams>
 */
export function dsToClientInit(params) {
    return { evid: 1306, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsToClientFingerprintSuccess' event (evid: 1307)
 *
 * Event description: provider want fingerprint from client
 *
 * @param {dsToClientFingerprintSuccessParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsToClientFingerprintSuccessParams>} LogObject<dsToClientFingerprintSuccessParams>
 */
export function dsToClientFingerprintSuccess(params) {
    return { evid: 1307, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsToClientChallenge' event (evid: 1308)
 *
 * Event description: provider want a Challenge from client
 *
 * @param {dsToClientChallengeParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsToClientChallengeParams>} LogObject<dsToClientChallengeParams>
 */
export function dsToClientChallenge(params) {
    return { evid: 1308, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsToClientV1Fallback' event (evid: 1309)
 *
 * Event description: when the bank does not support v2 , provider wants v1 verification from client
 *
 * @param {dsToClientV1FallbackParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsToClientV1FallbackParams>} LogObject<dsToClientV1FallbackParams>
 */
export function dsToClientV1Fallback(params) {
    return { evid: 1309, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsToClientAuthorized' event (evid: 1310)
 *
 * Event description: Authorized! Authorized! Authorized!
 *
 * @param {dsToClientAuthorizedParams} params - The parameters for this event
 * @property {boolean} success - 0,1
 * @property {string} provider - UNKNOWN
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @property {string} trackableTenant - trackable tenant
 * @return {LogObject<dsToClientAuthorizedParams>} LogObject<dsToClientAuthorizedParams>
 */
export function dsToClientAuthorized(params) {
    return { evid: 1310, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsFromClientChallenge1Failed' event (evid: 1311)
 *
 * Event description: 3DS > FromClient > Challenge1 Failed.
 *
 * @param {dsFromClientChallenge1FailedParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - vendor_id
 * @property {string} reason - reason
 * @property {number} invoiceId - invoice_id
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsFromClientChallenge1FailedParams>} LogObject<dsFromClientChallenge1FailedParams>
 */
export function dsFromClientChallenge1Failed(params) {
    return { evid: 1311, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsReDirectFromClientEventPayments' event (evid: 1312)
 *
 * Event description: 3DS > ReDirect > FromClient Event (Payments)
 *
 * @param {dsReDirectFromClientEventPaymentsParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsReDirectFromClientEventPaymentsParams>} LogObject<dsReDirectFromClientEventPaymentsParams>
 */
export function dsReDirectFromClientEventPayments(params) {
    return { evid: 1312, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsReDirectFromClientFailedEventPayments' event (evid: 1313)
 *
 * Event description: 3DS > ReDirect > FromClient Failed Event (Payments)
 *
 * @param {dsReDirectFromClientFailedEventPaymentsParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {string} reason - reason
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsReDirectFromClientFailedEventPaymentsParams>} LogObject<dsReDirectFromClientFailedEventPaymentsParams>
 */
export function dsReDirectFromClientFailedEventPayments(params) {
    return { evid: 1313, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dsReDirectToClientEventPayments' event (evid: 1314)
 *
 * Event description: 3DS > ReDirect > ToClient Event (Payments)
 *
 * @param {dsReDirectToClientEventPaymentsParams} params - The parameters for this event
 * @property {string} provider - adyen/worldpay
 * @property {GUID} paymentSourceId - billing_account_guid
 * @property {string} vendorId - wix / da
 * @property {number} invoiceId - invoiceId
 * @property {string} sessionId - sessionId
 * @return {LogObject<dsReDirectToClientEventPaymentsParams>} LogObject<dsReDirectToClientEventPaymentsParams>
 */
export function dsReDirectToClientEventPayments(params) {
    return { evid: 1314, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteToken' event (evid: 2)
 *
 * Event description: the token was successfully deleted
 *
 * @param {deleteTokenParams} params - The parameters for this event
 * @property {string} clientId - dead
 * @property {GUID} uuid - uuid
 * @property {string} additionalData - additionalData
 * @property {string} callerId - the id of caller
 * @return {LogObject<deleteTokenParams>} LogObject<deleteTokenParams>
 */
export function deleteToken(params) {
    return { evid: 2, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createBillingAccountRequest' event (evid: 2000)
 *
 * Event description: Create Billing Account Request
 *
 * @param {createBillingAccountRequestParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} partnerId - id of the partner, i.e. WeWork
 * @property {string} operation - the type of the operation, i.e. Create, Update, Delete
 * @property {string} additionalData - the data that we will add in the future
 * @return {LogObject<createBillingAccountRequestParams>} LogObject<createBillingAccountRequestParams>
 */
export function createBillingAccountRequest(params) {
    return { evid: 2000, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createBillingAccountResponse' event (evid: 2001)
 *
 * Event description: Create Billing Account Response
 *
 * @param {createBillingAccountResponseParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} partnerId - id of the partner, i.e. WeWork
 * @property {string} operation - the type of the operation, i.e. Create, Update, Delete
 * @property {string} additionalData - the data that we will add in the future
 * @return {LogObject<createBillingAccountResponseParams>} LogObject<createBillingAccountResponseParams>
 */
export function createBillingAccountResponse(params) {
    return { evid: 2001, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteTokenFailed' event (evid: 3)
 *
 * Event description: token was NOT deleted
 *
 * @param {deleteTokenFailedParams} params - The parameters for this event
 * @property {string} clientId - dead
 * @property {GUID} uuid - uuid
 * @property {string} additionalData - additionalData
 * @property {string} message - the error message or reason for NOT deleting
 * @property {string} callerId - the id of caller
 * @return {LogObject<deleteTokenFailedParams>} LogObject<deleteTokenFailedParams>
 */
export function deleteTokenFailed(params) {
    return { evid: 3, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'processFilesForProvider' event (evid: 5001)
 *
 * Event description: process files for provider
 *
 * @param {processFilesForProviderParams} params - The parameters for this event
 * @property {string} dataProviderName - data_provider_name
 * @return {LogObject<processFilesForProviderParams>} LogObject<processFilesForProviderParams>
 */
export function processFilesForProvider(params) {
    return { evid: 5001, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'processReferencesForProvider' event (evid: 5002)
 *
 * Event description: process references for provider
 *
 * @param {processReferencesForProviderParams} params - The parameters for this event
 * @property {string} dataProviderName - data_provider_name
 * @return {LogObject<processReferencesForProviderParams>} LogObject<processReferencesForProviderParams>
 */
export function processReferencesForProvider(params) {
    return { evid: 5002, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smokeDetectorRegistrationRequestReceived' event (evid: 6001)
 *
 * Event description: Smoke Detector: registration request received
 *
 * @param {smokeDetectorRegistrationRequestReceivedParams} params - The parameters for this event
 * @property {GUID} externalId - external id
 * @property {GUID} appId - app id
 * @return {LogObject<smokeDetectorRegistrationRequestReceivedParams>} LogObject<smokeDetectorRegistrationRequestReceivedParams>
 */
export function smokeDetectorRegistrationRequestReceived(params) {
    return { evid: 6001, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smokeDetectorAnalysisCallbackReceived' event (evid: 6002)
 *
 * Event description: Smoke Detector analysis callback received
 *
 * @param {smokeDetectorAnalysisCallbackReceivedParams} params - The parameters for this event
 * @property {GUID} externalId - external id
 * @property {string} result - result
 * @property {string} registrationId - registrationId
 * @property {string} providerId - providerId
 * @property {GUID} appId - app id
 * @return {LogObject<smokeDetectorAnalysisCallbackReceivedParams>} LogObject<smokeDetectorAnalysisCallbackReceivedParams>
 */
export function smokeDetectorAnalysisCallbackReceived(params) {
    return { evid: 6002, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smokeDetectorUnsubscribeRequestReceived' event (evid: 6003)
 *
 * Event description: Smoke Detector: unsubscribe request received
 *
 * @param {smokeDetectorUnsubscribeRequestReceivedParams} params - The parameters for this event
 * @property {GUID} externalId - external id
 * @property {string} registrationId - registrationId
 * @property {string} providerId - providerId
 * @property {GUID} appId - app id
 * @return {LogObject<smokeDetectorUnsubscribeRequestReceivedParams>} LogObject<smokeDetectorUnsubscribeRequestReceivedParams>
 */
export function smokeDetectorUnsubscribeRequestReceived(params) {
    return { evid: 6003, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createServiceSuccess' event (evid: 7103)
 *
 * Event description: the service was created in SBS - server (answers, DA)
 *
 * @param {createServiceSuccessParams} params - The parameters for this event
 * @property {string} vendorUserGuid - vendorUserGuid
 * @property {string} vendorGuid - vendorGuid
 * @property {GUID} serviceGuid - service_guid
 * @property {string} eventAggregator - eventAggregator
 * @property {number} invoiceId - invoiceId
 * @property {string} user_agent - user_agent
 * @property {string} productGuid - productGuid
 * @property {number} cycleId - 3,6...
 * @return {LogObject<createServiceSuccessParams>} LogObject<createServiceSuccessParams>
 */
export function createServiceSuccess(params) {
    return { evid: 7103, src: 74, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionStatusChanged' event (evid: 401)
 *
 * Event description: subscription status change event. Identifies subscription information, status and etc.
 *
 * @param {subscriptionStatusChangedParams} params - The parameters for this event
 * @property {DateTime} expirationDate - expiration date
 * @property {string} paymentStatus - payment status
 * @property {string} changeOperation - Operation name that changed subscription status. For example, cancel, activation
 * @property {GUID} appInstanceId - app_instance_id of subscription
 * @property {string} originAppId - app id from which came the subscription
 * @property {number} price - price * 100 to lose decimal places
 * @property {GUID} subscriptionId - subscription id
 * @property {string} paymentType - payment type
 * @property {number} billingCycles - duration of subscription/membership
 * @property {string} subscriptionStatus - subscription status
 * @property {number} interval - interval of period
 * @property {GUID} wixPayOrderId - wix pay /cashier transaction id. IT IS order_snapshot_id ????
 * @property {string} currency - currency name (three symbols)
 * @property {string} changeInitiator - Service or event that initiated status change of subscription
 * @property {GUID} subscriberId - Id of subscriber (site_member_id if logged in, later might have visitor_id or other id)
 * @property {string} subscriptionType - subscription type
 * @property {string} subscriberType - subscriber type Contact/Member
 * @property {DateTime} startDate - order start date
 * @property {string} periodUnit - period unit as a string
 * @return {LogObject<subscriptionStatusChangedParams>} LogObject<subscriptionStatusChangedParams>
 */
export function subscriptionStatusChanged(params) {
    return { evid: 401, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pricingPlansAutopiliotLoadStatusesServerless' event (evid: 402)
 *
 * Event description: When SAPI receives an event from WP that a new cycle is triggered (new payment) we want to save this event
 *
 * @param {pricingPlansAutopiliotLoadStatusesServerlessParams} params - The parameters for this event
 * @property {number} billingCycle - billing_cycle
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} originAppId - origin_app_id
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} wixPayOrderId - wix_pay_order_id
 * @property {string} transactionId - transaction_id
 * @return {LogObject<pricingPlansAutopiliotLoadStatusesServerlessParams>} LogObject<pricingPlansAutopiliotLoadStatusesServerlessParams>
 */
export function pricingPlansAutopiliotLoadStatusesServerless(params) {
    return { evid: 402, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bassSubscriptionStatusChanged' event (evid: 403)
 *
 * Event description: subscription status change event. Identifies subscription information, status and etc.
 *
 * General note: After moving to BASS, starting from 2022 Q3. For benefit status changed, there will be a separate event.
 *
 * @param {bassSubscriptionStatusChangedParams} params - The parameters for this event
 * @property {DateTime} expirationDate - expiration date
 * @property {string} paymentStatus - payment status
 * @property {string} changeOperation - Operation name that changed subscription status. For example, cancel, activation
 * @property {GUID} appInstanceId - app_instance_id of subscription
 * @property {GUID} originAppId - app id from which came the subscription
 * @property {number} price - price * 100 to lose decimal places
 * @property {GUID} subscriptionId - subscription id
 * @property {string} paymentType - payment type
 * @property {number} billingCycles - duration of subscription/membership
 * @property {string} subscriptionStatus - subscription status
 * @property {number} interval - interval of period
 * @property {GUID} wixPayOrderId - wix pay /cashier transaction id. IT IS order_snapshot_id ????
 * @property {string} currency - currency name (three symbols)
 * @property {string} changeInitiator - Service or event that initiated status change of subscription
 * @property {GUID} subscriberId - Id of subscriber (site_member_id if logged in, later might have visitor_id or other id)
 * @property {string} subscriptionType - subscription type
 * @property {string} subscriberType - subscriber type Contact/Member
 * @property {DateTime} startDate - order start date
 * @property {string} periodUnit - period unit as a string
 * @return {LogObject<bassSubscriptionStatusChangedParams>} LogObject<bassSubscriptionStatusChangedParams>
 */
export function bassSubscriptionStatusChanged(params) {
    return { evid: 403, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'benefitStatusChange' event (evid: 404)
 *
 * Event description: Benefit status change event. Identifies benefit information, status and etc.
 *
 * General note: After moving to BASS, starting from 2022 Q3. For benefit status changed, there will be a separate event.
 *
 * @param {benefitStatusChangeParams} params - The parameters for this event
 * @property {GUID} instanceId - Instance ID
 * @property {GUID} benefitId - Benefit ID
 * @property {GUID} appDefId - App Def ID
 * @property {GUID} pricingPlanId - Pricing Plan ID
 * @property {string} benefitType - Benefit Type
 * @property {GUID} id - Entry ID
 * @property {DateTime} updateDate - Update Date
 * @property {number} creditAmount - Credit Amount
 * @property {DateTime} creationDate - Creation Date
 * @property {number} discountRate - Discount Rate
 * @property {string} resourceIds - Resource Ids
 * @property {string} type - Behaviour Type
 * @property {number} discountAmount - Discount Amount
 * @return {LogObject<benefitStatusChangeParams>} LogObject<benefitStatusChangeParams>
 */
export function benefitStatusChange(params) {
    return { evid: 404, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'purchasedSubscriptionsLoaded' event (evid: 601)
 *
 * Event description: sent when contact purchased subscriptions page loads
 *
 * @param {purchasedSubscriptionsLoadedParams} params - The parameters for this event
 * @property {string} referralInfo - the place click came from
 * @property {GUID} appInstanceId - app instance id
 * @property {number} totalSubscriptions - number of subscriptions as appears to the user
 * @property {GUID} viewedMemberUuid - {APP ONLY} number of ACTIVE subscriptions as appears to the user
 * @property {string} origin - dashboard/editor
 * @property {number} activeSubscriptions - number of ACTIVE subscriptions as appears to the user
 * @return {LogObject<purchasedSubscriptionsLoadedParams>} LogObject<purchasedSubscriptionsLoadedParams>
 */
export function purchasedSubscriptionsLoaded(params) {
    return { evid: 601, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'singleSubscriptionPageLoaded' event (evid: 602)
 *
 * Event description: sent when an individual purchased subscription detail page is loaded
 *
 * @param {singleSubscriptionPageLoadedParams} params - The parameters for this event
 * @property {string} referralInfo - referral_info
 * @property {string} paymentStatus - payment status
 * @property {GUID} appInstanceId - app id
 * @property {GUID} subscriptionId - subscription id
 * @property {GUID} viewedMemberUuid - Member viewed
 * @property {string} origin - dashboard/editor
 * @return {LogObject<singleSubscriptionPageLoadedParams>} LogObject<singleSubscriptionPageLoadedParams>
 */
export function singleSubscriptionPageLoaded(params) {
    return { evid: 602, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionCancelClick' event (evid: 603)
 *
 * Event description: sent when a owner clicks on cancel subscription
 *
 * @param {subscriptionCancelClickParams} params - The parameters for this event
 * @property {string} referralInfo - referral_info
 * @property {string} paymentStatus - payment status
 * @property {GUID} appInstanceId - app id
 * @property {GUID} subscriptionId - subscription id
 * @property {string} origin - dashboard/editor
 * @return {LogObject<subscriptionCancelClickParams>} LogObject<subscriptionCancelClickParams>
 */
export function subscriptionCancelClick(params) {
    return { evid: 603, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionCancelled' event (evid: 604)
 *
 * Event description: sent when subscription cancellation is confirmed (auto renew off or cancel immediately)
 *
 * @param {subscriptionCancelledParams} params - The parameters for this event
 * @property {string} referralInfo - referral_info
 * @property {string} expirationTime - expiration time of a subscription (now/period end)
 * @property {string} paymentStatus - payment status
 * @property {GUID} appInstanceId - app id
 * @property {GUID} subscriptionId - subscription id
 * @property {string} cancelationType - cancel immediately/auto renew off
 * @property {string} origin - dashboard/editor
 * @return {LogObject<subscriptionCancelledParams>} LogObject<subscriptionCancelledParams>
 */
export function subscriptionCancelled(params) {
    return { evid: 604, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsActionItemClick' event (evid: 605)
 *
 * Event description: sent when action item is clicked in My Subscription page
 *
 * @param {mySubscriptionsActionItemClickParams} params - The parameters for this event
 * @property {GUID} sessionid - session in my subscriptions page level (same id for all actions in the page until refresh/cancel)
 * @property {GUID} planGuid - plan guid
 * @property {GUID} appInstanceId - app id
 * @property {GUID} subscriptionId - subscription id
 * @property {boolean} emptyState - indicates if action item was clicked in empty state (no purchased Subscriptions)
 * @property {string} action - name of the action {cancel, buy_new_plan, reactivate},
 * @return {LogObject<mySubscriptionsActionItemClickParams>} LogObject<mySubscriptionsActionItemClickParams>
 */
export function mySubscriptionsActionItemClick(params) {
    return { evid: 605, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsShowDetails' event (evid: 606)
 *
 * Event description: sent when Subscription drawer with details is expanded
 *
 * @param {mySubscriptionsShowDetailsParams} params - The parameters for this event
 * @property {string} sessionid - session
 * @property {GUID} planGuid - plan guid
 * @property {GUID} appInstanceId - app id
 * @property {GUID} subscriptionId - subscription id
 * @property {string} subscriptionStatus - status of the subscription at the time of action
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsShowDetailsParams>} LogObject<mySubscriptionsShowDetailsParams>
 */
export function mySubscriptionsShowDetails(params) {
    return { evid: 606, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsCancelSubscriptionConfirmed' event (evid: 607)
 *
 * Event description: sent when subscription cancellation is confirmed in Modal
 *
 * @param {mySubscriptionsCancelSubscriptionConfirmedParams} params - The parameters for this event
 * @property {GUID} sessionid - session in my subscriptions page level (same id for all actions in the page until refresh/cancel)
 * @property {GUID} appInstanceId - app id
 * @property {GUID} subscriptionId - subscription id
 * @property {GUID} originEntityId - plan_guid, product_id or invoice_id
 * @property {GUID} appId - vertical id (stores, paid plans, invoices)
 * @property {string} action - value of the cancel action {cancel} for initiate, {cancel-confirm} for confirmation in modal
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsCancelSubscriptionConfirmedParams>} LogObject<mySubscriptionsCancelSubscriptionConfirmedParams>
 */
export function mySubscriptionsCancelSubscriptionConfirmed(params) {
    return { evid: 607, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageSubscriptionClick' event (evid: 608)
 *
 * Event description: sent when a User clicks on a manage subscription CTA
 *
 * @param {manageSubscriptionClickParams} params - The parameters for this event
 * @property {string} referralInfo - referral_info
 * @property {string} paymentStatus - payment status
 * @property {GUID} subscriptionId - subscription id
 * @property {string} disabledActions - disabled actions and the reasons for it
 * @property {string} appinstanceid - app id
 * @property {string} origin - dashboard/editor
 * @return {LogObject<manageSubscriptionClickParams>} LogObject<manageSubscriptionClickParams>
 */
export function manageSubscriptionClick(params) {
    return { evid: 608, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionSuspendedOrReactivated' event (evid: 609)
 *
 * Event description: sent when a subscription is suspended or reactivated
 *
 * @param {subscriptionSuspendedOrReactivatedParams} params - The parameters for this event
 * @property {string} referralInfo - referral_info
 * @property {GUID} appInstanceId - app id
 * @property {GUID} subscriptionId - subscription id
 * @property {string} origin - dashboard/editor
 * @property {string} action - 'suspend', 'suspend-confirm', 'reactivate', 'reactivate-confirm'
 * @return {LogObject<subscriptionSuspendedOrReactivatedParams>} LogObject<subscriptionSuspendedOrReactivatedParams>
 */
export function subscriptionSuspendedOrReactivated(params) {
    return { evid: 609, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionListFilterApplied' event (evid: 610)
 *
 * Event description: sent when list of subscriptions is filtered
 *
 * @param {subscriptionListFilterAppliedParams} params - The parameters for this event
 * @property {string} referralInfo - referral_info
 * @property {GUID} appInstanceId - app id
 * @property {number} totalSubscriptions - number of subscriptions as appears to the user. From  widget (at OneApp) we can't have the number of subs since it is always up to 3 there
 * @property {string} filter - vertical/status
 * @property {string} origin - dashboard/editor
 * @return {LogObject<subscriptionListFilterAppliedParams>} LogObject<subscriptionListFilterAppliedParams>
 */
export function subscriptionListFilterApplied(params) {
    return { evid: 610, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionNumberOfSessionsChanged' event (evid: 612)
 *
 * Event description: sent when number of sessions is edited for a subscription
 *
 * @param {subscriptionNumberOfSessionsChangedParams} params - The parameters for this event
 * @property {number} originalSessions - number of sessions originally offered
 * @property {GUID} appInstanceId - app id
 * @property {GUID} subscriptionId - subscription ID
 * @property {number} newSessions - new number of sessions offered
 * @property {string} origin - dashboard/editor
 * @property {string} action - {intent/confirm}
 * @return {LogObject<subscriptionNumberOfSessionsChangedParams>} LogObject<subscriptionNumberOfSessionsChangedParams>
 */
export function subscriptionNumberOfSessionsChanged(params) {
    return { evid: 612, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionDurationChanged' event (evid: 614)
 *
 * Event description: sent when duration is changed for a subscription (e.g. duration extended)
 *
 * @param {subscriptionDurationChangedParams} params - The parameters for this event
 * @property {string} referralInfo - referral_info
 * @property {number} daysAdded - number of days added to duration
 * @property {GUID} appInstanceId - app id
 * @property {GUID} subscriptionId - subscription Id
 * @property {string} origin - dashboard/editor
 * @property {string} action - {intent/confirm}
 * @return {LogObject<subscriptionDurationChangedParams>} LogObject<subscriptionDurationChangedParams>
 */
export function subscriptionDurationChanged(params) {
    return { evid: 614, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionMarkedAsPaid' event (evid: 615)
 *
 * Event description: sent when subscription is marked as paid
 *
 * @param {subscriptionMarkedAsPaidParams} params - The parameters for this event
 * @property {string} referralInfo - referral_info
 * @property {GUID} appInstanceId - app id
 * @property {GUID} subscriptionId - subscription id
 * @property {string} origin - dashboard/editor
 * @property {string} action - {intent/confirm}
 * @return {LogObject<subscriptionMarkedAsPaidParams>} LogObject<subscriptionMarkedAsPaidParams>
 */
export function subscriptionMarkedAsPaid(params) {
    return { evid: 615, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySubscriptionsOpened' event (evid: 616)
 *
 * Event description: sent when My Subscriptions page is opened
 *
 * @param {mySubscriptionsOpenedParams} params - The parameters for this event
 * @property {string} referralInfo - page/widget/cta which referred to My Subscriptions. E.g. {login-menu, ma-menu}
 * @property {string} sessionid - session
 * @property {number} totalSubscriptions - number of subscriptions as appears to the user
 * @property {string} tabName - on app - indicate which tab is seen{active,expired}
 * @property {string} origin - Site - UoU view My Subscriptions page
 * my-subscriptions - UoU view My Subscriptions page from My Account tab in one of the client apps
 * home-widget - UoU view Pricing Plans Subscriptions (aka My Memberships) from Home tab on Fit app
 * Preview - user view My Subscriptions page from editor
 * @return {LogObject<mySubscriptionsOpenedParams>} LogObject<mySubscriptionsOpenedParams>
 */
export function mySubscriptionsOpened(params) {
    return { evid: 616, src: 92, endpoint: '', params };
}
/**
 * A function to create a log object for the 'subscriptionsMiscClick' event (evid: 617)
 *
 * Event description: Buttons/links/etc clicks at random places.
 *
 * @param {subscriptionsMiscClickParams} params - The parameters for this event
 * @property {string} referralInfo - identifier of a button, link
 * @return {LogObject<subscriptionsMiscClickParams>} LogObject<subscriptionsMiscClickParams>
 */
export function subscriptionsMiscClick(params) {
    return { evid: 617, src: 92, endpoint: '', params };
}
//# sourceMappingURL=index.js.map